export const italyMap = {
    "type": "FeatureCollection",
    "crs": {
        "type": "name",
        "properties": {
            "name": "urn:ogc:def:crs:OGC:1.3:CRS84"
        }
    },
    "features": [
        {
            "type": "Feature",
            "properties": {
                "id": 2,
                "name": "Piemonte",
                "length": 1236869.3688,
                "area": 25394103941.599998474121094
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            8.449759643243958,
                            46.461764029066018
                        ],
                        [
                            8.465821367240597,
                            46.443490032458605
                        ],
                        [
                            8.457665208041776,
                            46.422356552984859
                        ],
                        [
                            8.468529056493072,
                            46.411625987887
                        ],
                        [
                            8.46096823688862,
                            46.386535525119243
                        ],
                        [
                            8.468552427046593,
                            46.364872739468254
                        ],
                        [
                            8.464441479531411,
                            46.332985457609453
                        ],
                        [
                            8.42766199596111,
                            46.298401023182052
                        ],
                        [
                            8.45624634259717,
                            46.263513121220306
                        ],
                        [
                            8.44307670065991,
                            46.25021987650139
                        ],
                        [
                            8.46456721549491,
                            46.244400607265185
                        ],
                        [
                            8.468755417010748,
                            46.233485258935204
                        ],
                        [
                            8.532580809141049,
                            46.218059137810776
                        ],
                        [
                            8.540685635912636,
                            46.197671076052998
                        ],
                        [
                            8.563721735219101,
                            46.183937329024928
                        ],
                        [
                            8.573707539615997,
                            46.164381959544443
                        ],
                        [
                            8.602709908725608,
                            46.155252409291265
                        ],
                        [
                            8.594879554681254,
                            46.142237847890826
                        ],
                        [
                            8.611712583500925,
                            46.121821085321734
                        ],
                        [
                            8.647690399894604,
                            46.123166161004235
                        ],
                        [
                            8.658286432289875,
                            46.11256469826759
                        ],
                        [
                            8.714815168174969,
                            46.098042784920843
                        ],
                        [
                            8.70547561089125,
                            46.081933591683729
                        ],
                        [
                            8.72876348542867,
                            46.029232080258232
                        ],
                        [
                            8.720801679797146,
                            46.012292442905363
                        ],
                        [
                            8.570638294549438,
                            45.900033523600932
                        ],
                        [
                            8.595200838823246,
                            45.833614017553117
                        ],
                        [
                            8.587940655709218,
                            45.818928406351105
                        ],
                        [
                            8.55556368918875,
                            45.800043070842712
                        ],
                        [
                            8.555665067747467,
                            45.774990321411174
                        ],
                        [
                            8.593750059478582,
                            45.730411484601873
                        ],
                        [
                            8.642868136240999,
                            45.723155154250122
                        ],
                        [
                            8.653434188363747,
                            45.713970949231694
                        ],
                        [
                            8.64079933416374,
                            45.676808271850092
                        ],
                        [
                            8.681201068039778,
                            45.67640161926775
                        ],
                        [
                            8.6698344595014,
                            45.6614234983183
                        ],
                        [
                            8.68818485059643,
                            45.636992784265921
                        ],
                        [
                            8.678645155094383,
                            45.63362701681951
                        ],
                        [
                            8.665657511401397,
                            45.642878639870396
                        ],
                        [
                            8.658938959775012,
                            45.637746291960212
                        ],
                        [
                            8.663087664471769,
                            45.622034094563247
                        ],
                        [
                            8.682133034376658,
                            45.620342496581877
                        ],
                        [
                            8.703148012811708,
                            45.600057002872539
                        ],
                        [
                            8.693344864487951,
                            45.577780811774844
                        ],
                        [
                            8.705527903486168,
                            45.569153958814816
                        ],
                        [
                            8.719404290595444,
                            45.531054677415888
                        ],
                        [
                            8.713069318228827,
                            45.520131188750483
                        ],
                        [
                            8.72789239233721,
                            45.502399386397194
                        ],
                        [
                            8.760351528049503,
                            45.496846423958985
                        ],
                        [
                            8.773493485660149,
                            45.484703777886381
                        ],
                        [
                            8.787486732195465,
                            45.486232351549525
                        ],
                        [
                            8.789348159126556,
                            45.461981949552708
                        ],
                        [
                            8.810069734983314,
                            45.445978840231632
                        ],
                        [
                            8.808102252972594,
                            45.433334682230068
                        ],
                        [
                            8.826335279684793,
                            45.432589761407833
                        ],
                        [
                            8.824534883473396,
                            45.419497783741299
                        ],
                        [
                            8.842896239640593,
                            45.39383803551226
                        ],
                        [
                            8.811228426038676,
                            45.389107947930526
                        ],
                        [
                            8.801541724938639,
                            45.379181142657842
                        ],
                        [
                            8.765431540213068,
                            45.388939809489585
                        ],
                        [
                            8.76088603027222,
                            45.376483905898844
                        ],
                        [
                            8.719076291434163,
                            45.378079457103262
                        ],
                        [
                            8.720782640730087,
                            45.370428819118793
                        ],
                        [
                            8.760662000943377,
                            45.355696478093634
                        ],
                        [
                            8.76253762199895,
                            45.348619362957628
                        ],
                        [
                            8.743746985921257,
                            45.340302051934316
                        ],
                        [
                            8.742121871156666,
                            45.332059171317411
                        ],
                        [
                            8.724767732795486,
                            45.33570847606466
                        ],
                        [
                            8.716121236857196,
                            45.302881115206411
                        ],
                        [
                            8.690645650748433,
                            45.292526356354998
                        ],
                        [
                            8.666586870037579,
                            45.292206625761509
                        ],
                        [
                            8.655710315825942,
                            45.325680467149745
                        ],
                        [
                            8.631666430146669,
                            45.338381353774004
                        ],
                        [
                            8.628834604496015,
                            45.349856367321479
                        ],
                        [
                            8.611778279190185,
                            45.354426169566914
                        ],
                        [
                            8.578812410133938,
                            45.347234500230314
                        ],
                        [
                            8.551754025567549,
                            45.361317560846615
                        ],
                        [
                            8.526450586913601,
                            45.342546751119833
                        ],
                        [
                            8.53789912424944,
                            45.317247368348994
                        ],
                        [
                            8.513542734774807,
                            45.31327841729783
                        ],
                        [
                            8.498337440901357,
                            45.292226420759583
                        ],
                        [
                            8.511997390004188,
                            45.291020627787582
                        ],
                        [
                            8.514077166006119,
                            45.274320620697836
                        ],
                        [
                            8.535105940197047,
                            45.277801691031257
                        ],
                        [
                            8.533048339553215,
                            45.258143157547011
                        ],
                        [
                            8.543383226213553,
                            45.253279145824898
                        ],
                        [
                            8.536013910367718,
                            45.247587531711346
                        ],
                        [
                            8.522768349067029,
                            45.254626094771922
                        ],
                        [
                            8.52249487998581,
                            45.249239830979569
                        ],
                        [
                            8.556180406552638,
                            45.24139590088479
                        ],
                        [
                            8.529097367097775,
                            45.239514141395155
                        ],
                        [
                            8.5436510800152,
                            45.234001302764618
                        ],
                        [
                            8.523244907807063,
                            45.221603884443759
                        ],
                        [
                            8.548048573390151,
                            45.204124760798919
                        ],
                        [
                            8.524514874149002,
                            45.198333668101824
                        ],
                        [
                            8.546478399571745,
                            45.194862701189685
                        ],
                        [
                            8.556025547868915,
                            45.204855921408395
                        ],
                        [
                            8.577793757622679,
                            45.207915707306071
                        ],
                        [
                            8.581189728280808,
                            45.202226175350113
                        ],
                        [
                            8.545540456262662,
                            45.182943160696041
                        ],
                        [
                            8.542934596643001,
                            45.17284197789089
                        ],
                        [
                            8.553661633133419,
                            45.157858495849489
                        ],
                        [
                            8.580001295640058,
                            45.152699201527483
                        ],
                        [
                            8.590113089007977,
                            45.133021692405535
                        ],
                        [
                            8.61097860526505,
                            45.123630103403578
                        ],
                        [
                            8.609094658466478,
                            45.106889549769285
                        ],
                        [
                            8.64598763306855,
                            45.075332828152924
                        ],
                        [
                            8.63689697749294,
                            45.066527587361641
                        ],
                        [
                            8.646948880491621,
                            45.054685778445659
                        ],
                        [
                            8.634737772370888,
                            45.0409624159076
                        ],
                        [
                            8.652262677570661,
                            45.034922902995952
                        ],
                        [
                            8.659067916404403,
                            45.017974999026428
                        ],
                        [
                            8.67115988283641,
                            45.027174307479754
                        ],
                        [
                            8.700813649893421,
                            45.026517694825472
                        ],
                        [
                            8.710058846597931,
                            45.038291147419685
                        ],
                        [
                            8.726662443590367,
                            45.021858791405229
                        ],
                        [
                            8.750561624077399,
                            45.020707491502456
                        ],
                        [
                            8.747880438810025,
                            45.00914672400453
                        ],
                        [
                            8.771748242550405,
                            45.006780690381554
                        ],
                        [
                            8.7776985728106,
                            45.02373389341453
                        ],
                        [
                            8.79803975905717,
                            45.020972099378127
                        ],
                        [
                            8.795363821597871,
                            45.035280236149134
                        ],
                        [
                            8.823892213116244,
                            45.046589019377421
                        ],
                        [
                            8.842122189865915,
                            45.042630144527074
                        ],
                        [
                            8.842684359332324,
                            45.050586237216358
                        ],
                        [
                            8.870600692507056,
                            45.051989554189461
                        ],
                        [
                            8.884003899518731,
                            45.060870696332671
                        ],
                        [
                            8.885903798502056,
                            45.050160497088818
                        ],
                        [
                            8.898066845863671,
                            45.0506581112814
                        ],
                        [
                            8.909400772194147,
                            44.997556911293877
                        ],
                        [
                            8.925603638767249,
                            44.982157265410166
                        ],
                        [
                            8.960623864577906,
                            44.987284927949219
                        ],
                        [
                            8.97812410710883,
                            44.967206389872878
                        ],
                        [
                            8.969590179823387,
                            44.943491498785527
                        ],
                        [
                            8.988206277272811,
                            44.930852040188228
                        ],
                        [
                            8.999687728422886,
                            44.90931989558451
                        ],
                        [
                            9.030363531636947,
                            44.888499198241341
                        ],
                        [
                            9.055900386780968,
                            44.88884463259042
                        ],
                        [
                            9.07006665214463,
                            44.864684311773402
                        ],
                        [
                            9.04900376685764,
                            44.849859856782295
                        ],
                        [
                            9.072906450693662,
                            44.828034986361715
                        ],
                        [
                            9.07263970580197,
                            44.817088554973047
                        ],
                        [
                            9.095145105388802,
                            44.819025488716889
                        ],
                        [
                            9.108992319273979,
                            44.805437846207568
                        ],
                        [
                            9.160976792963073,
                            44.814738657117786
                        ],
                        [
                            9.155119539929942,
                            44.809408481114424
                        ],
                        [
                            9.173504920384635,
                            44.796148846864639
                        ],
                        [
                            9.171725561760345,
                            44.771683545794325
                        ],
                        [
                            9.21355042810754,
                            44.752348212239276
                        ],
                        [
                            9.199196124502999,
                            44.68410969658715
                        ],
                        [
                            9.204947056658705,
                            44.59853596803201
                        ],
                        [
                            9.1525549752887,
                            44.574221151564238
                        ],
                        [
                            9.135192176450762,
                            44.574477095811382
                        ],
                        [
                            9.110704092342472,
                            44.581971047235847
                        ],
                        [
                            9.103532246235668,
                            44.609385877722566
                        ],
                        [
                            9.0758534320262,
                            44.623699032105463
                        ],
                        [
                            9.04390887419695,
                            44.614425234128987
                        ],
                        [
                            9.038761778305613,
                            44.640867293778683
                        ],
                        [
                            9.014690729147695,
                            44.666070660802383
                        ],
                        [
                            8.972515226361828,
                            44.663349576164748
                        ],
                        [
                            8.9595230961814,
                            44.676021062865956
                        ],
                        [
                            8.931153200509177,
                            44.676150833782309
                        ],
                        [
                            8.908261169604605,
                            44.646823637102713
                        ],
                        [
                            8.882620669595713,
                            44.638747491843667
                        ],
                        [
                            8.909367671490539,
                            44.61332642433365
                        ],
                        [
                            8.917502842345034,
                            44.561055010020056
                        ],
                        [
                            8.891337065270273,
                            44.550630652310083
                        ],
                        [
                            8.868607351660383,
                            44.566244202961279
                        ],
                        [
                            8.862904672151549,
                            44.560610914514555
                        ],
                        [
                            8.826840437001126,
                            44.561799373648746
                        ],
                        [
                            8.828765318141764,
                            44.543069470109138
                        ],
                        [
                            8.799082524686458,
                            44.530132782849151
                        ],
                        [
                            8.788263228659261,
                            44.488031011400381
                        ],
                        [
                            8.766940865637515,
                            44.49195006712872
                        ],
                        [
                            8.773573773415983,
                            44.503927934054857
                        ],
                        [
                            8.767564327851812,
                            44.524964003882573
                        ],
                        [
                            8.760471729747952,
                            44.530242877086437
                        ],
                        [
                            8.749807716790562,
                            44.525664700037552
                        ],
                        [
                            8.756983941522027,
                            44.536690373249193
                        ],
                        [
                            8.74994719788358,
                            44.54894569686212
                        ],
                        [
                            8.738190051422515,
                            44.551773162265597
                        ],
                        [
                            8.732766809757516,
                            44.570431900286167
                        ],
                        [
                            8.714075403303083,
                            44.581450735945708
                        ],
                        [
                            8.690052394172007,
                            44.58196322990996
                        ],
                        [
                            8.681419810381051,
                            44.574882502104742
                        ],
                        [
                            8.623861366724805,
                            44.586380709787854
                        ],
                        [
                            8.597816084211281,
                            44.556559599618247
                        ],
                        [
                            8.612367110473199,
                            44.543295116148236
                        ],
                        [
                            8.586687823009116,
                            44.524191600381535
                        ],
                        [
                            8.573756531154505,
                            44.523324831573653
                        ],
                        [
                            8.576161587650041,
                            44.509226674810947
                        ],
                        [
                            8.559695508833897,
                            44.502817529227038
                        ],
                        [
                            8.534783188475327,
                            44.513350878326349
                        ],
                        [
                            8.478073497005395,
                            44.510648086072699
                        ],
                        [
                            8.470656745742328,
                            44.522479403253961
                        ],
                        [
                            8.449498663274376,
                            44.497388087823701
                        ],
                        [
                            8.418587247383373,
                            44.513277600972621
                        ],
                        [
                            8.403899935665102,
                            44.508978158105855
                        ],
                        [
                            8.392431653481605,
                            44.477049848982546
                        ],
                        [
                            8.359533746207068,
                            44.464995565260367
                        ],
                        [
                            8.349177104727548,
                            44.485553148453263
                        ],
                        [
                            8.321637656655968,
                            44.488021671150669
                        ],
                        [
                            8.304553650288751,
                            44.502647245959025
                        ],
                        [
                            8.271312514034395,
                            44.506797266884377
                        ],
                        [
                            8.252798704198712,
                            44.528758781078359
                        ],
                        [
                            8.224162875001021,
                            44.514174946555038
                        ],
                        [
                            8.216199561672173,
                            44.497303665184305
                        ],
                        [
                            8.223269862821637,
                            44.485612515344457
                        ],
                        [
                            8.197327503031945,
                            44.477555808877305
                        ],
                        [
                            8.195735346025188,
                            44.464265667227536
                        ],
                        [
                            8.210256841106915,
                            44.45551734869953
                        ],
                        [
                            8.221835821845087,
                            44.429556460006808
                        ],
                        [
                            8.203499640401795,
                            44.404893029179966
                        ],
                        [
                            8.149519212727359,
                            44.384792014658856
                        ],
                        [
                            8.14491633180746,
                            44.34578005973141
                        ],
                        [
                            8.134283899002265,
                            44.332099613560644
                        ],
                        [
                            8.106436349559059,
                            44.332372805377638
                        ],
                        [
                            8.101956768601978,
                            44.300931016911825
                        ],
                        [
                            8.076021686635544,
                            44.313958455321341
                        ],
                        [
                            8.059739801521912,
                            44.300703820966199
                        ],
                        [
                            8.063557444928797,
                            44.28827061450022
                        ],
                        [
                            8.076044901454203,
                            44.287526028056462
                        ],
                        [
                            8.090675155150578,
                            44.274744711030557
                        ],
                        [
                            8.063096625651406,
                            44.253074186185849
                        ],
                        [
                            8.081103436440813,
                            44.240044557174159
                        ],
                        [
                            8.065363252244008,
                            44.21693657553503
                        ],
                        [
                            8.095532169008774,
                            44.196938316337054
                        ],
                        [
                            8.097171271243024,
                            44.178708688965294
                        ],
                        [
                            8.068204843366134,
                            44.144975368367362
                        ],
                        [
                            8.042913932280239,
                            44.14283209260978
                        ],
                        [
                            8.028787915474988,
                            44.15409136430236
                        ],
                        [
                            8.011841249337021,
                            44.155899708197808
                        ],
                        [
                            7.979631840012021,
                            44.138456513854358
                        ],
                        [
                            8.011987510300708,
                            44.120941634759767
                        ],
                        [
                            8.002688624051746,
                            44.11662932532559
                        ],
                        [
                            8.015597263701569,
                            44.110701631470647
                        ],
                        [
                            8.006878354641753,
                            44.102589288377743
                        ],
                        [
                            7.9715313960425,
                            44.113095196826301
                        ],
                        [
                            7.942367898829818,
                            44.100116567650581
                        ],
                        [
                            7.925972212930311,
                            44.110296431697556
                        ],
                        [
                            7.883928438514931,
                            44.104671951966488
                        ],
                        [
                            7.866119591112493,
                            44.118155373765447
                        ],
                        [
                            7.816001517626884,
                            44.12307132231534
                        ],
                        [
                            7.762738814967058,
                            44.140882289450268
                        ],
                        [
                            7.72535509684697,
                            44.12551700037217
                        ],
                        [
                            7.719295830351368,
                            44.104480809112168
                        ],
                        [
                            7.73289202258997,
                            44.083645933355506
                        ],
                        [
                            7.759363730062775,
                            44.0842966264414
                        ],
                        [
                            7.737892287464152,
                            44.076372651471615
                        ],
                        [
                            7.727773343281686,
                            44.06027962736659
                        ],
                        [
                            7.714329718734954,
                            44.061558881234092
                        ],
                        [
                            7.716977648062104,
                            44.083315239230743
                        ],
                        [
                            7.666430618895698,
                            44.130660319392142
                        ],
                        [
                            7.68474157768625,
                            44.173921259007791
                        ],
                        [
                            7.644989114944603,
                            44.1781244868409
                        ],
                        [
                            7.632558619382968,
                            44.173596340596632
                        ],
                        [
                            7.617380258903405,
                            44.149838999009994
                        ],
                        [
                            7.565022886381185,
                            44.152344303378456
                        ],
                        [
                            7.534952533103113,
                            44.147438502589331
                        ],
                        [
                            7.521404843947856,
                            44.13779714258127
                        ],
                        [
                            7.503826735506846,
                            44.14366335995804
                        ],
                        [
                            7.459958940903927,
                            44.125857321864657
                        ],
                        [
                            7.428170591536031,
                            44.130412003665427
                        ],
                        [
                            7.423350300382451,
                            44.113320649830399
                        ],
                        [
                            7.392652163083044,
                            44.125560170862258
                        ],
                        [
                            7.356959275439838,
                            44.116391290472514
                        ],
                        [
                            7.341907680931953,
                            44.146055093549855
                        ],
                        [
                            7.27880484842492,
                            44.141277229554341
                        ],
                        [
                            7.248418256092834,
                            44.157966101588876
                        ],
                        [
                            7.243916197139237,
                            44.171478059391646
                        ],
                        [
                            7.218872441220398,
                            44.168564871695857
                        ],
                        [
                            7.188677675163113,
                            44.198913290274611
                        ],
                        [
                            7.163572566530156,
                            44.207851430911688
                        ],
                        [
                            7.144052532476015,
                            44.20018042232136
                        ],
                        [
                            7.076065798864101,
                            44.232096083271394
                        ],
                        [
                            7.034977893546555,
                            44.223969012515326
                        ],
                        [
                            7.007279312718062,
                            44.235985075915856
                        ],
                        [
                            6.996712746488851,
                            44.25070897975678
                        ],
                        [
                            6.99574769812982,
                            44.280140162761313
                        ],
                        [
                            6.970991686044294,
                            44.28450173049265
                        ],
                        [
                            6.958344814750064,
                            44.295484818168916
                        ],
                        [
                            6.960709098699573,
                            44.311200972797153
                        ],
                        [
                            6.926784968110222,
                            44.333187019935586
                        ],
                        [
                            6.922010690512326,
                            44.35172692845476
                        ],
                        [
                            6.887234051896883,
                            44.362027012356656
                        ],
                        [
                            6.89684233199415,
                            44.374736179243989
                        ],
                        [
                            6.892794329357342,
                            44.420233084644472
                        ],
                        [
                            6.948395113227434,
                            44.42983427060598
                        ],
                        [
                            6.913009834774908,
                            44.451042285688558
                        ],
                        [
                            6.906328018853698,
                            44.46782680934394
                        ],
                        [
                            6.876169369105454,
                            44.481493798525307
                        ],
                        [
                            6.85505451878618,
                            44.532206357467921
                        ],
                        [
                            6.878916799666747,
                            44.554321162912636
                        ],
                        [
                            6.913579343639856,
                            44.558659939855715
                        ],
                        [
                            6.912472148190263,
                            44.568524374398557
                        ],
                        [
                            6.932589522663472,
                            44.572887548305786
                        ],
                        [
                            6.937705536529821,
                            44.603115686226154
                        ],
                        [
                            6.952280539446822,
                            44.620514085058154
                        ],
                        [
                            6.967336115730401,
                            44.61928424712854
                        ],
                        [
                            6.94751985995355,
                            44.653584256793145
                        ],
                        [
                            6.962680529814636,
                            44.677738956550385
                        ],
                        [
                            6.988920875714281,
                            44.690231294723077
                        ],
                        [
                            7.029219930675975,
                            44.691609265498251
                        ],
                        [
                            7.07111764344814,
                            44.679865684492533
                        ],
                        [
                            7.075241738209577,
                            44.690206908174893
                        ],
                        [
                            7.065347370519875,
                            44.713834271929862
                        ],
                        [
                            7.03244588567215,
                            44.727880978277184
                        ],
                        [
                            7.019236385454565,
                            44.775958354483784
                        ],
                        [
                            7.000079312199373,
                            44.789046559546549
                        ],
                        [
                            7.023850176092823,
                            44.823330998059667
                        ],
                        [
                            7.00970445070571,
                            44.826393514309331
                        ],
                        [
                            7.006086472527628,
                            44.839968552769164
                        ],
                        [
                            6.931505426896353,
                            44.863438203454265
                        ],
                        [
                            6.911291712460391,
                            44.844565887939851
                        ],
                        [
                            6.86294255527043,
                            44.850719585359947
                        ],
                        [
                            6.784999307080931,
                            44.888698635197116
                        ],
                        [
                            6.772926056771132,
                            44.902605846758448
                        ],
                        [
                            6.750836319798368,
                            44.906169602282141
                        ],
                        [
                            6.759995404048146,
                            44.933796808010747
                        ],
                        [
                            6.746224550204267,
                            44.938584699824759
                        ],
                        [
                            6.765546135010458,
                            44.961613376556087
                        ],
                        [
                            6.737557659092616,
                            44.990759269324279
                        ],
                        [
                            6.751309430001212,
                            44.997557359462611
                        ],
                        [
                            6.745950104871713,
                            45.013862018495644
                        ],
                        [
                            6.724586984003508,
                            45.021980891574174
                        ],
                        [
                            6.673602940961081,
                            45.020043959548325
                        ],
                        [
                            6.662259023875235,
                            45.071383454461774
                        ],
                        [
                            6.646166549135764,
                            45.075022502728935
                        ],
                        [
                            6.626861190101762,
                            45.104949578338875
                        ],
                        [
                            6.634777140832312,
                            45.115789915746298
                        ],
                        [
                            6.673057721920783,
                            45.124534212184599
                        ],
                        [
                            6.680208215620048,
                            45.140414691037044
                        ],
                        [
                            6.712034927788348,
                            45.144765754348114
                        ],
                        [
                            6.740199537801883,
                            45.136973264898124
                        ],
                        [
                            6.769156831635222,
                            45.159839934015764
                        ],
                        [
                            6.813103255010461,
                            45.148529090250555
                        ],
                        [
                            6.848324282812639,
                            45.127306359320542
                        ],
                        [
                            6.893925636465585,
                            45.137275472454782
                        ],
                        [
                            6.884200821718562,
                            45.156053133530314
                        ],
                        [
                            6.893519535283034,
                            45.169007773274352
                        ],
                        [
                            6.947463449621131,
                            45.170482500371151
                        ],
                        [
                            6.943205433219268,
                            45.175899848983462
                        ],
                        [
                            6.967778094234726,
                            45.195648336418898
                        ],
                        [
                            6.965756385978611,
                            45.207719458522035
                        ],
                        [
                            6.989087493378809,
                            45.210176163314621
                        ],
                        [
                            7.003212893676703,
                            45.220041867992947
                        ],
                        [
                            7.026898722819864,
                            45.215624730450656
                        ],
                        [
                            7.047548744902731,
                            45.225881460788727
                        ],
                        [
                            7.066990722431667,
                            45.210293049011462
                        ],
                        [
                            7.083089815412393,
                            45.216347995884831
                        ],
                        [
                            7.110505577998797,
                            45.246077970893467
                        ],
                        [
                            7.124758168766019,
                            45.244332641944126
                        ],
                        [
                            7.137090869679706,
                            45.256074447945757
                        ],
                        [
                            7.136014305131943,
                            45.280396869561898
                        ],
                        [
                            7.109400581394551,
                            45.327702813185859
                        ],
                        [
                            7.134535784338705,
                            45.331698805244216
                        ],
                        [
                            7.13296892740167,
                            45.347335594600395
                        ],
                        [
                            7.15950810228815,
                            45.359459226484539
                        ],
                        [
                            7.163280761032042,
                            45.381789262977129
                        ],
                        [
                            7.185854256382575,
                            45.403231184899241
                        ],
                        [
                            7.114426596925721,
                            45.433461376429968
                        ],
                        [
                            7.100335111548263,
                            45.456180927444791
                        ],
                        [
                            7.121665153898981,
                            45.506238277800861
                        ],
                        [
                            7.134301294431465,
                            45.515455575118636
                        ],
                        [
                            7.143582198396061,
                            45.477831386667056
                        ],
                        [
                            7.16032991556076,
                            45.486588165368318
                        ],
                        [
                            7.222660360728304,
                            45.470476109724331
                        ],
                        [
                            7.263729819077905,
                            45.499026551397478
                        ],
                        [
                            7.269497269426174,
                            45.514677037110722
                        ],
                        [
                            7.322953189993643,
                            45.51445128722483
                        ],
                        [
                            7.359301548641461,
                            45.525867787021824
                        ],
                        [
                            7.377239191154153,
                            45.516897968491328
                        ],
                        [
                            7.447963067384353,
                            45.555567368848131
                        ],
                        [
                            7.463672634252639,
                            45.573989996972308
                        ],
                        [
                            7.489317395652002,
                            45.583108063668128
                        ],
                        [
                            7.531770564119439,
                            45.576789442774277
                        ],
                        [
                            7.566473467481736,
                            45.591622876313579
                        ],
                        [
                            7.599694546695638,
                            45.578092478356439
                        ],
                        [
                            7.60906592594101,
                            45.562876776936555
                        ],
                        [
                            7.63404505016135,
                            45.570787112248645
                        ],
                        [
                            7.676792728344826,
                            45.552093717402059
                        ],
                        [
                            7.718931867604292,
                            45.558889100640691
                        ],
                        [
                            7.732699290827419,
                            45.550330878204178
                        ],
                        [
                            7.795676873722118,
                            45.586386268679711
                        ],
                        [
                            7.848872756114966,
                            45.602263396348327
                        ],
                        [
                            7.900765614238751,
                            45.591719909072346
                        ],
                        [
                            7.897462798661749,
                            45.61252675031448
                        ],
                        [
                            7.915038962260335,
                            45.632738573803778
                        ],
                        [
                            7.936107627356887,
                            45.635694023910602
                        ],
                        [
                            7.939503997132318,
                            45.643697384342701
                        ],
                        [
                            7.904794645957827,
                            45.684728748397525
                        ],
                        [
                            7.936624507434184,
                            45.72434258595095
                        ],
                        [
                            7.929002603923792,
                            45.74244261909061
                        ],
                        [
                            7.884930463372465,
                            45.760196940806004
                        ],
                        [
                            7.862638945765856,
                            45.792163614030876
                        ],
                        [
                            7.862331670119563,
                            45.819902007408494
                        ],
                        [
                            7.874038337279308,
                            45.825983874709365
                        ],
                        [
                            7.863862191631595,
                            45.839582041833239
                        ],
                        [
                            7.875922919419427,
                            45.861581706490135
                        ],
                        [
                            7.861373381407874,
                            45.910409422328122
                        ],
                        [
                            7.876964868279924,
                            45.926428292364875
                        ],
                        [
                            7.868401321533629,
                            45.937638104476186
                        ],
                        [
                            7.878064227539786,
                            45.973402000194071
                        ],
                        [
                            7.908819610980228,
                            45.997316760472181
                        ],
                        [
                            7.988913559580843,
                            45.996487430673511
                        ],
                        [
                            8.001185748905138,
                            46.012039887479013
                        ],
                        [
                            8.012179378001063,
                            46.01191493582958
                        ],
                        [
                            8.012766645479836,
                            46.031968165557011
                        ],
                        [
                            8.034587518226045,
                            46.043341919740115
                        ],
                        [
                            8.022374048036276,
                            46.069698771771044
                        ],
                        [
                            8.033286518107461,
                            46.099375237642356
                        ],
                        [
                            8.108048833318112,
                            46.111586249679519
                        ],
                        [
                            8.114971348519298,
                            46.130313408646863
                        ],
                        [
                            8.150258407174258,
                            46.141300312261095
                        ],
                        [
                            8.150583881049567,
                            46.16391091398495
                        ],
                        [
                            8.165448069532012,
                            46.182263507537428
                        ],
                        [
                            8.139002732322989,
                            46.22607736073266
                        ],
                        [
                            8.115644521935492,
                            46.236968997633198
                        ],
                        [
                            8.11014042876071,
                            46.249301209853115
                        ],
                        [
                            8.0804278467433,
                            46.260765960858379
                        ],
                        [
                            8.137708926074337,
                            46.301612821590531
                        ],
                        [
                            8.161355545104579,
                            46.296208800765037
                        ],
                        [
                            8.203162568851218,
                            46.304265695119305
                        ],
                        [
                            8.223702317687096,
                            46.333638379384801
                        ],
                        [
                            8.261697358992633,
                            46.345184749778277
                        ],
                        [
                            8.263397636540292,
                            46.363663206897229
                        ],
                        [
                            8.312347495062253,
                            46.376837676761035
                        ],
                        [
                            8.316902513621281,
                            46.397240280355241
                        ],
                        [
                            8.289692438623613,
                            46.408585093452793
                        ],
                        [
                            8.300311646452501,
                            46.419351144628436
                        ],
                        [
                            8.336869699069949,
                            46.431547504598228
                        ],
                        [
                            8.364499411081219,
                            46.451143523926049
                        ],
                        [
                            8.449759643243958,
                            46.461764029066018
                        ]
                    ],
                    [
                        [
                            8.816692331101313,
                            45.021944263874609
                        ],
                        [
                            8.810012025454979,
                            45.019074488412727
                        ],
                        [
                            8.810741980876974,
                            45.017334618646558
                        ],
                        [
                            8.816258472711235,
                            45.018387836901944
                        ],
                        [
                            8.816692331101313,
                            45.021944263874609
                        ]
                    ],
                    [
                        [
                            8.704042681422781,
                            45.017526532172504
                        ],
                        [
                            8.706385937949047,
                            45.013562778038171
                        ],
                        [
                            8.705427661961116,
                            45.024483280561086
                        ],
                        [
                            8.704042681422781,
                            45.017526532172504
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1,
                "name": "Valle d'Aosta",
                "length": 311165.134877,
                "area": 3259040961.300000190734863
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            7.588571915813589,
                            45.970750850433724
                        ],
                        [
                            7.663708528320136,
                            45.975551456797859
                        ],
                        [
                            7.681261776020623,
                            45.957178536286193
                        ],
                        [
                            7.709884570384864,
                            45.948261876583921
                        ],
                        [
                            7.707296887412667,
                            45.93469596292833
                        ],
                        [
                            7.721292987179962,
                            45.923458853949228
                        ],
                        [
                            7.734554900886504,
                            45.92365151796912
                        ],
                        [
                            7.753688860766695,
                            45.939612619278201
                        ],
                        [
                            7.800086774092033,
                            45.91712213436854
                        ],
                        [
                            7.821402793661139,
                            45.926857481168462
                        ],
                        [
                            7.864048277623001,
                            45.916439357464732
                        ],
                        [
                            7.865609686596487,
                            45.879039823534477
                        ],
                        [
                            7.875922919419427,
                            45.861581706490135
                        ],
                        [
                            7.863862191631595,
                            45.839582041833239
                        ],
                        [
                            7.874038337279308,
                            45.825983874709365
                        ],
                        [
                            7.862331670119563,
                            45.819902007408494
                        ],
                        [
                            7.862638945765856,
                            45.792163614030876
                        ],
                        [
                            7.884930463372465,
                            45.760196940806004
                        ],
                        [
                            7.929002603923792,
                            45.74244261909061
                        ],
                        [
                            7.936624507434184,
                            45.72434258595095
                        ],
                        [
                            7.904794645957827,
                            45.684728748397525
                        ],
                        [
                            7.939503997132318,
                            45.643697384342701
                        ],
                        [
                            7.936107627356887,
                            45.635694023910602
                        ],
                        [
                            7.915038962260335,
                            45.632738573803778
                        ],
                        [
                            7.897462798661749,
                            45.61252675031448
                        ],
                        [
                            7.900765614238751,
                            45.591719909072346
                        ],
                        [
                            7.848872756114966,
                            45.602263396348327
                        ],
                        [
                            7.795676873722118,
                            45.586386268679711
                        ],
                        [
                            7.732699290827419,
                            45.550330878204178
                        ],
                        [
                            7.718931867604292,
                            45.558889100640691
                        ],
                        [
                            7.676792728344826,
                            45.552093717402059
                        ],
                        [
                            7.63404505016135,
                            45.570787112248645
                        ],
                        [
                            7.60906592594101,
                            45.562876776936555
                        ],
                        [
                            7.599694546695638,
                            45.578092478356439
                        ],
                        [
                            7.566473467481736,
                            45.591622876313579
                        ],
                        [
                            7.531770564119439,
                            45.576789442774277
                        ],
                        [
                            7.489317395652002,
                            45.583108063668128
                        ],
                        [
                            7.463672634252639,
                            45.573989996972308
                        ],
                        [
                            7.447963067384353,
                            45.555567368848131
                        ],
                        [
                            7.377239191154153,
                            45.516897968491328
                        ],
                        [
                            7.359301548641461,
                            45.525867787021824
                        ],
                        [
                            7.322953189993643,
                            45.51445128722483
                        ],
                        [
                            7.269497269426174,
                            45.514677037110722
                        ],
                        [
                            7.263729819077905,
                            45.499026551397478
                        ],
                        [
                            7.222660360728304,
                            45.470476109724331
                        ],
                        [
                            7.16032991556076,
                            45.486588165368318
                        ],
                        [
                            7.143208876990943,
                            45.478029965652794
                        ],
                        [
                            7.13752714612764,
                            45.516264336926056
                        ],
                        [
                            7.121665153898981,
                            45.506238277800861
                        ],
                        [
                            7.10432956530325,
                            45.466958749323126
                        ],
                        [
                            7.046461430144928,
                            45.473067292130743
                        ],
                        [
                            7.053190397619932,
                            45.494992076158546
                        ],
                        [
                            6.999687704314764,
                            45.504571674562854
                        ],
                        [
                            6.99503214947968,
                            45.576147793430565
                        ],
                        [
                            6.977857282892947,
                            45.588941455979239
                        ],
                        [
                            6.984187219595594,
                            45.625174437084311
                        ],
                        [
                            7.000802216329514,
                            45.640255123154205
                        ],
                        [
                            6.973667165768716,
                            45.646905614339126
                        ],
                        [
                            6.968566869179146,
                            45.654510803101367
                        ],
                        [
                            6.93200396183728,
                            45.647085813569305
                        ],
                        [
                            6.915208792856626,
                            45.652523026656596
                        ],
                        [
                            6.902801401963829,
                            45.680261752637406
                        ],
                        [
                            6.893524883816283,
                            45.675959589223666
                        ],
                        [
                            6.854058086805421,
                            45.686961950899473
                        ],
                        [
                            6.809186906645642,
                            45.724759743426532
                        ],
                        [
                            6.817277305611197,
                            45.739748097039538
                        ],
                        [
                            6.805544081421337,
                            45.748200044297043
                        ],
                        [
                            6.801326674374722,
                            45.781259949553139
                        ],
                        [
                            6.818645082837369,
                            45.836208642201989
                        ],
                        [
                            6.843108990603702,
                            45.842253723886202
                        ],
                        [
                            6.864898068300872,
                            45.833185367941539
                        ],
                        [
                            6.880178348432982,
                            45.849887280753414
                        ],
                        [
                            6.896627736074738,
                            45.842666819676197
                        ],
                        [
                            6.940650328128606,
                            45.847069334365933
                        ],
                        [
                            6.950740391408224,
                            45.858834684164819
                        ],
                        [
                            6.997676900411059,
                            45.872610070526733
                        ],
                        [
                            7.003797732237762,
                            45.899215033206687
                        ],
                        [
                            7.032920531041712,
                            45.921429677041978
                        ],
                        [
                            7.061813117229492,
                            45.912409940773514
                        ],
                        [
                            7.101645017298562,
                            45.859039203808237
                        ],
                        [
                            7.118271597415042,
                            45.859539330406093
                        ],
                        [
                            7.156481923380696,
                            45.879342713303224
                        ],
                        [
                            7.190261304240148,
                            45.858596410754167
                        ],
                        [
                            7.21641272442463,
                            45.888754723274438
                        ],
                        [
                            7.259707333693449,
                            45.890367557168126
                        ],
                        [
                            7.294204972384704,
                            45.921723770124785
                        ],
                        [
                            7.32419522020119,
                            45.910385918286508
                        ],
                        [
                            7.343855231849693,
                            45.915253901924189
                        ],
                        [
                            7.383732376818816,
                            45.896833881667668
                        ],
                        [
                            7.427157500987818,
                            45.915666070042882
                        ],
                        [
                            7.444278382977112,
                            45.931480362410433
                        ],
                        [
                            7.474167880298163,
                            45.935591634889974
                        ],
                        [
                            7.478126213573951,
                            45.952628317555167
                        ],
                        [
                            7.502336169173228,
                            45.960661612429845
                        ],
                        [
                            7.542321356087855,
                            45.957056533740499
                        ],
                        [
                            7.548550923585364,
                            45.985838174689974
                        ],
                        [
                            7.577623930617022,
                            45.986464793611404
                        ],
                        [
                            7.588571915813589,
                            45.970750850433724
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 3,
                "name": "Lombardia",
                "length": 1411265.07152,
                "area": 23862698613.599998474121094
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                10.249298490410025,
                                46.618381793283923
                            ],
                            [
                                10.25821747339227,
                                46.609856062648625
                            ],
                            [
                                10.242252626946684,
                                46.592522135787092
                            ],
                            [
                                10.244002735895386,
                                46.578400942155177
                            ],
                            [
                                10.253522165682842,
                                46.571826387267201
                            ],
                            [
                                10.269126231438737,
                                46.577800962830935
                            ],
                            [
                                10.283535240904992,
                                46.571223549289826
                            ],
                            [
                                10.295748746437715,
                                46.550400442337228
                            ],
                            [
                                10.325653540925584,
                                46.5517136565214
                            ],
                            [
                                10.338226069886142,
                                46.543013181487581
                            ],
                            [
                                10.35220686297458,
                                46.555574082133255
                            ],
                            [
                                10.397555433333002,
                                46.543941503337173
                            ],
                            [
                                10.419340034148448,
                                46.5510528719009
                            ],
                            [
                                10.453113980269414,
                                46.530556997955635
                            ],
                            [
                                10.457930228576279,
                                46.510576843742776
                            ],
                            [
                                10.476095771269907,
                                46.495588979971458
                            ],
                            [
                                10.551952845890247,
                                46.491440095474864
                            ],
                            [
                                10.577071167511567,
                                46.473353957602782
                            ],
                            [
                                10.60050465130735,
                                46.468667600242505
                            ],
                            [
                                10.62214673873185,
                                46.44809330733743
                            ],
                            [
                                10.616229332474012,
                                46.428770743912303
                            ],
                            [
                                10.630461785841963,
                                46.402550819153994
                            ],
                            [
                                10.607468942341887,
                                46.379378024069176
                            ],
                            [
                                10.567044179644201,
                                46.377927817266354
                            ],
                            [
                                10.543597538311833,
                                46.359288577031791
                            ],
                            [
                                10.519484812444137,
                                46.355750708467859
                            ],
                            [
                                10.515927589411321,
                                46.346351077552114
                            ],
                            [
                                10.565619956331895,
                                46.326346563494731
                            ],
                            [
                                10.564514147325863,
                                46.313622330348387
                            ],
                            [
                                10.579574648417779,
                                46.298825884931809
                            ],
                            [
                                10.559722739098397,
                                46.28305122147556
                            ],
                            [
                                10.575666168133491,
                                46.275682350072692
                            ],
                            [
                                10.585736101833259,
                                46.245338076676397
                            ],
                            [
                                10.568218110262931,
                                46.2337222316539
                            ],
                            [
                                10.570403050543593,
                                46.22320604650082
                            ],
                            [
                                10.541402977764898,
                                46.188613329069739
                            ],
                            [
                                10.5653949004117,
                                46.166838636730198
                            ],
                            [
                                10.549269638858442,
                                46.146427414429134
                            ],
                            [
                                10.549502020376913,
                                46.117394520690944
                            ],
                            [
                                10.517185447991416,
                                46.080077097142699
                            ],
                            [
                                10.480944146429707,
                                46.056296320049476
                            ],
                            [
                                10.484705980468149,
                                46.024616457629563
                            ],
                            [
                                10.458291460460691,
                                46.010425516848436
                            ],
                            [
                                10.45293350071473,
                                45.989621783798938
                            ],
                            [
                                10.453406014228268,
                                45.976552937988899
                            ],
                            [
                                10.488492714937497,
                                45.969345358097719
                            ],
                            [
                                10.484708667914118,
                                45.94511216759846
                            ],
                            [
                                10.50856811197233,
                                45.923566164860006
                            ],
                            [
                                10.507690522167566,
                                45.905342825570983
                            ],
                            [
                                10.495078626300023,
                                45.899816623420328
                            ],
                            [
                                10.490045394656224,
                                45.884607759326862
                            ],
                            [
                                10.502278799963721,
                                45.871145606818253
                            ],
                            [
                                10.502827592029346,
                                45.82973396177605
                            ],
                            [
                                10.54362777099775,
                                45.817647769138041
                            ],
                            [
                                10.526012570226763,
                                45.805697751911708
                            ],
                            [
                                10.535110895486286,
                                45.801704957933573
                            ],
                            [
                                10.532753201036126,
                                45.788060207169359
                            ],
                            [
                                10.56346893359818,
                                45.784111983980388
                            ],
                            [
                                10.600986025498639,
                                45.803002215410913
                            ],
                            [
                                10.635159571914139,
                                45.806667282576988
                            ],
                            [
                                10.641395692161126,
                                45.801868051394329
                            ],
                            [
                                10.654640138409389,
                                45.832627608196468
                            ],
                            [
                                10.675718800073318,
                                45.830461274230039
                            ],
                            [
                                10.699509735016019,
                                45.841663526308338
                            ],
                            [
                                10.711012998430975,
                                45.836062629237404
                            ],
                            [
                                10.735553305122236,
                                45.842722948627625
                            ],
                            [
                                10.75635315630757,
                                45.830025002724398
                            ],
                            [
                                10.774630942058383,
                                45.843076470558309
                            ],
                            [
                                10.791214674673052,
                                45.833457365555091
                            ],
                            [
                                10.825385178698999,
                                45.837744880372
                            ],
                            [
                                10.84014624222158,
                                45.832758414330257
                            ],
                            [
                                10.705606445180319,
                                45.676412438823256
                            ],
                            [
                                10.628467643005326,
                                45.60205659721322
                            ],
                            [
                                10.647615833428176,
                                45.451400745741459
                            ],
                            [
                                10.644135110695288,
                                45.444546093702961
                            ],
                            [
                                10.623645956920029,
                                45.443615986611491
                            ],
                            [
                                10.627251646781728,
                                45.438271941399691
                            ],
                            [
                                10.649454952911277,
                                45.440788774453807
                            ],
                            [
                                10.643865081351354,
                                45.417817231026163
                            ],
                            [
                                10.654626005158685,
                                45.415822549125046
                            ],
                            [
                                10.665232915223394,
                                45.427716378991782
                            ],
                            [
                                10.698138951264244,
                                45.422896321183764
                            ],
                            [
                                10.715793345824665,
                                45.41663758326132
                            ],
                            [
                                10.7193674515661,
                                45.405962333118573
                            ],
                            [
                                10.697738063699644,
                                45.380092226608056
                            ],
                            [
                                10.714626191451897,
                                45.367931143126654
                            ],
                            [
                                10.685544243480006,
                                45.353684462618773
                            ],
                            [
                                10.686762995518853,
                                45.342174743038683
                            ],
                            [
                                10.71497071311512,
                                45.334076397921123
                            ],
                            [
                                10.706382647437911,
                                45.316301301027181
                            ],
                            [
                                10.730482227636559,
                                45.315857597167437
                            ],
                            [
                                10.728347986238147,
                                45.291300497611964
                            ],
                            [
                                10.737415796311835,
                                45.287244803362157
                            ],
                            [
                                10.782815226528719,
                                45.315421513867463
                            ],
                            [
                                10.84001119612304,
                                45.272894469481052
                            ],
                            [
                                10.846608056590673,
                                45.256568799411319
                            ],
                            [
                                10.936790157101056,
                                45.232938364669749
                            ],
                            [
                                10.934982170586828,
                                45.214202308442893
                            ],
                            [
                                10.946957391431376,
                                45.205736785879331
                            ],
                            [
                                10.984110475769073,
                                45.19978471265334
                            ],
                            [
                                10.997118800701591,
                                45.186937677811684
                            ],
                            [
                                10.994517311093219,
                                45.15035558024951
                            ],
                            [
                                11.010244530199888,
                                45.148657461677423
                            ],
                            [
                                11.028389000035816,
                                45.159227131526727
                            ],
                            [
                                11.032281182757821,
                                45.149851587775061
                            ],
                            [
                                11.050146520464244,
                                45.149991231100437
                            ],
                            [
                                11.043847612359039,
                                45.134279270760054
                            ],
                            [
                                11.028395220042031,
                                45.126732418435836
                            ],
                            [
                                11.039710546630715,
                                45.113127293734053
                            ],
                            [
                                11.097572649651211,
                                45.095247078187292
                            ],
                            [
                                11.100565311768477,
                                45.112734889319988
                            ],
                            [
                                11.127404570781898,
                                45.103227155526973
                            ],
                            [
                                11.145875506866233,
                                45.126006790569846
                            ],
                            [
                                11.188192605863657,
                                45.109693539416895
                            ],
                            [
                                11.203434131287796,
                                45.111667282645861
                            ],
                            [
                                11.177508732575481,
                                45.097344958929355
                            ],
                            [
                                11.176816344601633,
                                45.088491465523688
                            ],
                            [
                                11.188368178316809,
                                45.084084783798509
                            ],
                            [
                                11.174645604827237,
                                45.074490123251167
                            ],
                            [
                                11.175279709033166,
                                45.060066227041872
                            ],
                            [
                                11.212191050032995,
                                45.057484490263946
                            ],
                            [
                                11.240440848190085,
                                45.04295374076284
                            ],
                            [
                                11.265902502636491,
                                45.056223881237393
                            ],
                            [
                                11.263053328552719,
                                45.032938755033548
                            ],
                            [
                                11.274036951891008,
                                45.018259046948003
                            ],
                            [
                                11.308740331455018,
                                45.012359338467895
                            ],
                            [
                                11.335812040238133,
                                44.990397653659961
                            ],
                            [
                                11.414792366563837,
                                44.967347557928335
                            ],
                            [
                                11.425487375659571,
                                44.960819451367421
                            ],
                            [
                                11.426742026009423,
                                44.950083518311182
                            ],
                            [
                                11.378192683300702,
                                44.957925877896791
                            ],
                            [
                                11.357155454134629,
                                44.950080507889638
                            ],
                            [
                                11.3264939342169,
                                44.962248532842743
                            ],
                            [
                                11.301583508531438,
                                44.962358967240206
                            ],
                            [
                                11.284352123384718,
                                44.956610839784837
                            ],
                            [
                                11.272256195152675,
                                44.938321479516269
                            ],
                            [
                                11.246208022622239,
                                44.951434890328166
                            ],
                            [
                                11.238015008511622,
                                44.9450611160851
                            ],
                            [
                                11.152436122357981,
                                44.933258032139278
                            ],
                            [
                                11.118027194515617,
                                44.954482741661039
                            ],
                            [
                                11.073474186740492,
                                44.96296567272374
                            ],
                            [
                                11.059540226739067,
                                44.948903237913456
                            ],
                            [
                                10.997473495537433,
                                44.955104568900978
                            ],
                            [
                                10.967152579054465,
                                44.934805373130068
                            ],
                            [
                                10.95059300979721,
                                44.933326640727294
                            ],
                            [
                                10.941372917784676,
                                44.921913875085053
                            ],
                            [
                                10.916687692447397,
                                44.924407375330773
                            ],
                            [
                                10.890308381975547,
                                44.91244973066307
                            ],
                            [
                                10.897999879756318,
                                44.921815941741222
                            ],
                            [
                                10.876633812485291,
                                44.917054501365534
                            ],
                            [
                                10.865397956645388,
                                44.929632609142807
                            ],
                            [
                                10.74375226535739,
                                44.949063325336006
                            ],
                            [
                                10.741680404747777,
                                44.980346524139655
                            ],
                            [
                                10.727396608935306,
                                44.992025601432836
                            ],
                            [
                                10.694740937171394,
                                44.961940099458602
                            ],
                            [
                                10.686679987062405,
                                44.986592632217942
                            ],
                            [
                                10.627882504179333,
                                44.924207274677052
                            ],
                            [
                                10.569838929287885,
                                44.908354803046599
                            ],
                            [
                                10.519849182283576,
                                44.912736575457878
                            ],
                            [
                                10.435667785639478,
                                44.943135400042024
                            ],
                            [
                                10.405673984689933,
                                44.984494280537895
                            ],
                            [
                                10.3585160154992,
                                44.965535482769525
                            ],
                            [
                                10.308900787110279,
                                44.987377475466438
                            ],
                            [
                                10.304687581734543,
                                44.999038093973056
                            ],
                            [
                                10.274466586787449,
                                44.997930107457201
                            ],
                            [
                                10.255857175910705,
                                45.017805324717095
                            ],
                            [
                                10.211067551075974,
                                45.034031821676287
                            ],
                            [
                                10.187295907570912,
                                45.028215751009675
                            ],
                            [
                                10.157721350076326,
                                45.044079036504598
                            ],
                            [
                                10.106167863721458,
                                45.022132070670025
                            ],
                            [
                                10.089100883250616,
                                45.02719161524827
                            ],
                            [
                                10.082307524720774,
                                45.046605572395116
                            ],
                            [
                                10.050223561372151,
                                45.041279032983056
                            ],
                            [
                                10.046946126287299,
                                45.059285688767446
                            ],
                            [
                                10.021649555665785,
                                45.075888988545387
                            ],
                            [
                                10.028531936020487,
                                45.096225128770875
                            ],
                            [
                                9.985465587862063,
                                45.133430762110173
                            ],
                            [
                                9.91848722038792,
                                45.099602709259308
                            ],
                            [
                                9.922605933633601,
                                45.135936273884383
                            ],
                            [
                                9.913690845299083,
                                45.139131529837186
                            ],
                            [
                                9.881033410886264,
                                45.127001876069023
                            ],
                            [
                                9.877825888854737,
                                45.113533062946495
                            ],
                            [
                                9.900628052952545,
                                45.09544213718199
                            ],
                            [
                                9.896772738252354,
                                45.080538623244976
                            ],
                            [
                                9.880650016763639,
                                45.074794959857201
                            ],
                            [
                                9.861519775557325,
                                45.093556452290798
                            ],
                            [
                                9.83835732581159,
                                45.095646208681814
                            ],
                            [
                                9.833759277238389,
                                45.061676679894532
                            ],
                            [
                                9.823758644751013,
                                45.052590595859776
                            ],
                            [
                                9.813262342652395,
                                45.078103282216738
                            ],
                            [
                                9.778962199870209,
                                45.089584056687343
                            ],
                            [
                                9.757535681826495,
                                45.112538507414861
                            ],
                            [
                                9.7450691304799,
                                45.110938708842284
                            ],
                            [
                                9.749593731111576,
                                45.077836809604861
                            ],
                            [
                                9.714994984710149,
                                45.058236817993638
                            ],
                            [
                                9.676892963032344,
                                45.077608240372037
                            ],
                            [
                                9.6349355118607,
                                45.083977901426906
                            ],
                            [
                                9.640916836906133,
                                45.116620668274237
                            ],
                            [
                                9.62935160478485,
                                45.132032823951661
                            ],
                            [
                                9.618965455829093,
                                45.133547854177152
                            ],
                            [
                                9.611964014493733,
                                45.11149549007218
                            ],
                            [
                                9.587446995679729,
                                45.099624985774128
                            ],
                            [
                                9.568583250961732,
                                45.107339286714492
                            ],
                            [
                                9.548661299715974,
                                45.132651515429174
                            ],
                            [
                                9.535756453499907,
                                45.122000822495664
                            ],
                            [
                                9.550999975034108,
                                45.090791440105903
                            ],
                            [
                                9.533417559674369,
                                45.078902623357493
                            ],
                            [
                                9.499286054767929,
                                45.103919664772931
                            ],
                            [
                                9.439006402295147,
                                45.093446262121226
                            ],
                            [
                                9.435601445181135,
                                45.08182908408962
                            ],
                            [
                                9.410760883118192,
                                45.082740709694988
                            ],
                            [
                                9.413736805665049,
                                45.074512696728
                            ],
                            [
                                9.370806018691669,
                                45.048142518170515
                            ],
                            [
                                9.375605526712967,
                                45.019917938580434
                            ],
                            [
                                9.365424425004363,
                                45.00267488328079
                            ],
                            [
                                9.345451163174735,
                                44.995125988005562
                            ],
                            [
                                9.321822110708263,
                                44.944100185427949
                            ],
                            [
                                9.305643011258558,
                                44.933963422730066
                            ],
                            [
                                9.28634581478472,
                                44.933950422993007
                            ],
                            [
                                9.292283150241529,
                                44.912379522567811
                            ],
                            [
                                9.277409518144502,
                                44.895608890912108
                            ],
                            [
                                9.292826208890196,
                                44.89031930768401
                            ],
                            [
                                9.290113390898167,
                                44.882206405663339
                            ],
                            [
                                9.341675176044308,
                                44.869811982696284
                            ],
                            [
                                9.348317311091384,
                                44.839769955373022
                            ],
                            [
                                9.363098231232234,
                                44.822403832364664
                            ],
                            [
                                9.354194310352804,
                                44.811863278056002
                            ],
                            [
                                9.321528075612212,
                                44.800032044344491
                            ],
                            [
                                9.316759741394808,
                                44.783949457522233
                            ],
                            [
                                9.286974935475561,
                                44.772496362125267
                            ],
                            [
                                9.286512738827948,
                                44.758679096822164
                            ],
                            [
                                9.332580786368414,
                                44.735040346381041
                            ],
                            [
                                9.308480638361692,
                                44.705634454900945
                            ],
                            [
                                9.324637465989227,
                                44.690015623709094
                            ],
                            [
                                9.298505872928311,
                                44.681021547450307
                            ],
                            [
                                9.283024605552095,
                                44.685976257497835
                            ],
                            [
                                9.25947576387515,
                                44.679946577266982
                            ],
                            [
                                9.23508364129305,
                                44.71635982270184
                            ],
                            [
                                9.237087747860702,
                                44.685117590633055
                            ],
                            [
                                9.200319859769191,
                                44.686404799144029
                            ],
                            [
                                9.21355042810754,
                                44.752348212239276
                            ],
                            [
                                9.171725561760345,
                                44.771683545794325
                            ],
                            [
                                9.173504920384635,
                                44.796148846864639
                            ],
                            [
                                9.155119539929942,
                                44.809408481114424
                            ],
                            [
                                9.160976792963073,
                                44.814738657117786
                            ],
                            [
                                9.108992319273979,
                                44.805437846207568
                            ],
                            [
                                9.095145105388802,
                                44.819025488716889
                            ],
                            [
                                9.07263970580197,
                                44.817088554973047
                            ],
                            [
                                9.072906450693662,
                                44.828034986361715
                            ],
                            [
                                9.04900376685764,
                                44.849859856782295
                            ],
                            [
                                9.07006665214463,
                                44.864684311773402
                            ],
                            [
                                9.055900386780968,
                                44.88884463259042
                            ],
                            [
                                9.030363531636947,
                                44.888499198241341
                            ],
                            [
                                8.999687728422886,
                                44.90931989558451
                            ],
                            [
                                8.988206277272811,
                                44.930852040188228
                            ],
                            [
                                8.969590179823387,
                                44.943491498785527
                            ],
                            [
                                8.97812410710883,
                                44.967206389872878
                            ],
                            [
                                8.960623864577906,
                                44.987284927949219
                            ],
                            [
                                8.925603638767249,
                                44.982157265410166
                            ],
                            [
                                8.909400772194147,
                                44.997556911293877
                            ],
                            [
                                8.898715556361104,
                                45.04983052292318
                            ],
                            [
                                8.881058574556018,
                                45.054080334606212
                            ],
                            [
                                8.887398998699648,
                                45.05979536244994
                            ],
                            [
                                8.842684359332324,
                                45.050586237216358
                            ],
                            [
                                8.842122189865915,
                                45.042630144527074
                            ],
                            [
                                8.823892213116244,
                                45.046589019377421
                            ],
                            [
                                8.79621254082906,
                                45.0358128484174
                            ],
                            [
                                8.798336966939804,
                                45.021122660703647
                            ],
                            [
                                8.7776985728106,
                                45.02373389341453
                            ],
                            [
                                8.771748242550405,
                                45.006780690381554
                            ],
                            [
                                8.747880438810025,
                                45.00914672400453
                            ],
                            [
                                8.750561624077399,
                                45.020707491502456
                            ],
                            [
                                8.726662443590367,
                                45.021858791405229
                            ],
                            [
                                8.710058846597931,
                                45.038291147419685
                            ],
                            [
                                8.700813649893421,
                                45.026517694825472
                            ],
                            [
                                8.67115988283641,
                                45.027174307479754
                            ],
                            [
                                8.659067916404403,
                                45.017974999026428
                            ],
                            [
                                8.652262677570661,
                                45.034922902995952
                            ],
                            [
                                8.634737772370888,
                                45.0409624159076
                            ],
                            [
                                8.646948880491621,
                                45.054685778445659
                            ],
                            [
                                8.63689697749294,
                                45.066527587361641
                            ],
                            [
                                8.64598763306855,
                                45.075332828152924
                            ],
                            [
                                8.609094658466478,
                                45.106889549769285
                            ],
                            [
                                8.61097860526505,
                                45.123630103403578
                            ],
                            [
                                8.590113089007977,
                                45.133021692405535
                            ],
                            [
                                8.580001295640058,
                                45.152699201527483
                            ],
                            [
                                8.553661633133419,
                                45.157858495849489
                            ],
                            [
                                8.542934596643001,
                                45.17284197789089
                            ],
                            [
                                8.545540456262662,
                                45.182943160696041
                            ],
                            [
                                8.581189728280808,
                                45.202226175350113
                            ],
                            [
                                8.577793757622679,
                                45.207915707306071
                            ],
                            [
                                8.556025547868915,
                                45.204855921408395
                            ],
                            [
                                8.546478399571745,
                                45.194862701189685
                            ],
                            [
                                8.524514874149002,
                                45.198333668101824
                            ],
                            [
                                8.548048573390151,
                                45.204124760798919
                            ],
                            [
                                8.523244907807063,
                                45.221603884443759
                            ],
                            [
                                8.5436510800152,
                                45.234001302764618
                            ],
                            [
                                8.529097367097775,
                                45.239514141395155
                            ],
                            [
                                8.556180406552638,
                                45.24139590088479
                            ],
                            [
                                8.52249487998581,
                                45.249239830979569
                            ],
                            [
                                8.522768349067029,
                                45.254626094771922
                            ],
                            [
                                8.536013910367718,
                                45.247587531711346
                            ],
                            [
                                8.543383226213553,
                                45.253279145824898
                            ],
                            [
                                8.533048339553215,
                                45.258143157547011
                            ],
                            [
                                8.535105940197047,
                                45.277801691031257
                            ],
                            [
                                8.514077166006119,
                                45.274320620697836
                            ],
                            [
                                8.511997390004188,
                                45.291020627787582
                            ],
                            [
                                8.498337440901357,
                                45.292226420759583
                            ],
                            [
                                8.513542734774807,
                                45.31327841729783
                            ],
                            [
                                8.53789912424944,
                                45.317247368348994
                            ],
                            [
                                8.526450586913601,
                                45.342546751119833
                            ],
                            [
                                8.551754025567549,
                                45.361317560846615
                            ],
                            [
                                8.578812410133938,
                                45.347234500230314
                            ],
                            [
                                8.611778279190185,
                                45.354426169566914
                            ],
                            [
                                8.628834604496015,
                                45.349856367321479
                            ],
                            [
                                8.631666430146669,
                                45.338381353774004
                            ],
                            [
                                8.655710315825942,
                                45.325680467149745
                            ],
                            [
                                8.666586870037579,
                                45.292206625761509
                            ],
                            [
                                8.690645650748433,
                                45.292526356354998
                            ],
                            [
                                8.716121236857196,
                                45.302881115206411
                            ],
                            [
                                8.724767732795486,
                                45.33570847606466
                            ],
                            [
                                8.742121871156666,
                                45.332059171317411
                            ],
                            [
                                8.743746985921257,
                                45.340302051934316
                            ],
                            [
                                8.76253762199895,
                                45.348619362957628
                            ],
                            [
                                8.760662000943377,
                                45.355696478093634
                            ],
                            [
                                8.720782640730087,
                                45.370428819118793
                            ],
                            [
                                8.719076291434163,
                                45.378079457103262
                            ],
                            [
                                8.76088603027222,
                                45.376483905898844
                            ],
                            [
                                8.765431540213068,
                                45.388939809489585
                            ],
                            [
                                8.801541724938639,
                                45.379181142657842
                            ],
                            [
                                8.811228426038676,
                                45.389107947930526
                            ],
                            [
                                8.842896239640593,
                                45.39383803551226
                            ],
                            [
                                8.824534883473396,
                                45.419497783741299
                            ],
                            [
                                8.826335279684793,
                                45.432589761407833
                            ],
                            [
                                8.808102252972594,
                                45.433334682230068
                            ],
                            [
                                8.810069734983314,
                                45.445978840231632
                            ],
                            [
                                8.789348159126556,
                                45.461981949552708
                            ],
                            [
                                8.787486732195465,
                                45.486232351549525
                            ],
                            [
                                8.773493485660149,
                                45.484703777886381
                            ],
                            [
                                8.760351528049503,
                                45.496846423958985
                            ],
                            [
                                8.72789239233721,
                                45.502399386397194
                            ],
                            [
                                8.713069318228827,
                                45.520131188750483
                            ],
                            [
                                8.719404290595444,
                                45.531054677415888
                            ],
                            [
                                8.705527903486168,
                                45.569153958814816
                            ],
                            [
                                8.693344864487951,
                                45.577780811774844
                            ],
                            [
                                8.703148012811708,
                                45.600057002872539
                            ],
                            [
                                8.682133034376658,
                                45.620342496581877
                            ],
                            [
                                8.663087664471769,
                                45.622034094563247
                            ],
                            [
                                8.658938959775012,
                                45.637746291960212
                            ],
                            [
                                8.665657511401397,
                                45.642878639870396
                            ],
                            [
                                8.678645155094383,
                                45.63362701681951
                            ],
                            [
                                8.68818485059643,
                                45.636992784265921
                            ],
                            [
                                8.6698344595014,
                                45.6614234983183
                            ],
                            [
                                8.681201068039778,
                                45.67640161926775
                            ],
                            [
                                8.64079933416374,
                                45.676808271850092
                            ],
                            [
                                8.653434188363747,
                                45.713970949231694
                            ],
                            [
                                8.642868136240999,
                                45.723155154250122
                            ],
                            [
                                8.593750059478582,
                                45.730411484601873
                            ],
                            [
                                8.555665067747467,
                                45.774990321411174
                            ],
                            [
                                8.55556368918875,
                                45.800043070842712
                            ],
                            [
                                8.587940655709218,
                                45.818928406351105
                            ],
                            [
                                8.595200838823246,
                                45.833614017553117
                            ],
                            [
                                8.570638294549438,
                                45.900033523600932
                            ],
                            [
                                8.72642984749876,
                                46.017967208857087
                            ],
                            [
                                8.705564909574321,
                                46.085128879066943
                            ],
                            [
                                8.742687489027357,
                                46.122145963799731
                            ],
                            [
                                8.760165018993847,
                                46.101699734270838
                            ],
                            [
                                8.783424600123716,
                                46.093943059020049
                            ],
                            [
                                8.806148713442525,
                                46.100913943773293
                            ],
                            [
                                8.852050531684581,
                                46.075521188259238
                            ],
                            [
                                8.854517041410267,
                                46.061628074862142
                            ],
                            [
                                8.844302509123199,
                                46.048537348921464
                            ],
                            [
                                8.834434630015132,
                                46.051349537457043
                            ],
                            [
                                8.819682402476648,
                                46.02527158342744
                            ],
                            [
                                8.805941363243267,
                                46.021608475094745
                            ],
                            [
                                8.785902255364899,
                                45.989017698015211
                            ],
                            [
                                8.831275496223123,
                                45.987983163262918
                            ],
                            [
                                8.868233483025206,
                                45.960387263067034
                            ],
                            [
                                8.89427462121218,
                                45.958465745266913
                            ],
                            [
                                8.893060902569053,
                                45.931337524141099
                            ],
                            [
                                8.924614432266864,
                                45.905851025165774
                            ],
                            [
                                8.934092525555418,
                                45.870057582430213
                            ],
                            [
                                8.94560018517863,
                                45.867196978134459
                            ],
                            [
                                8.91900166172452,
                                45.847708637592099
                            ],
                            [
                                8.912448580872413,
                                45.830278761691481
                            ],
                            [
                                8.949537460736883,
                                45.843477951678338
                            ],
                            [
                                8.969798413733741,
                                45.832315439207392
                            ],
                            [
                                8.997490442711275,
                                45.834740555048072
                            ],
                            [
                                8.993282195025767,
                                45.822634633440472
                            ],
                            [
                                9.034045494677065,
                                45.822832275038991
                            ],
                            [
                                9.054006886415442,
                                45.872898967700685
                            ],
                            [
                                9.088757568147448,
                                45.900715678053075
                            ],
                            [
                                9.043032240299445,
                                45.926735258838939
                            ],
                            [
                                9.019395186223191,
                                45.928577788090678
                            ],
                            [
                                9.014063878137101,
                                45.960156359956414
                            ],
                            [
                                8.988770879683681,
                                45.970583544851124
                            ],
                            [
                                9.028287081261134,
                                45.993661897042315
                            ],
                            [
                                9.008971484280659,
                                46.036983259838834
                            ],
                            [
                                9.022081560593959,
                                46.052380849796201
                            ],
                            [
                                9.077872431407663,
                                46.065316722990083
                            ],
                            [
                                9.089842449693837,
                                46.088487840315516
                            ],
                            [
                                9.071634925742634,
                                46.11951509387179
                            ],
                            [
                                9.120802174273726,
                                46.134611839147681
                            ],
                            [
                                9.159568676889867,
                                46.170519461696728
                            ],
                            [
                                9.18160429606762,
                                46.170648578557788
                            ],
                            [
                                9.221300732893583,
                                46.229870398596304
                            ],
                            [
                                9.247615382996472,
                                46.233627241494752
                            ],
                            [
                                9.251640598195104,
                                46.265487713884148
                            ],
                            [
                                9.284540191500268,
                                46.296945998426104
                            ],
                            [
                                9.28146406094617,
                                46.309355351628064
                            ],
                            [
                                9.300050098388331,
                                46.326587671404369
                            ],
                            [
                                9.291810383003975,
                                46.334960775312688
                            ],
                            [
                                9.295739219773347,
                                46.355681583207492
                            ],
                            [
                                9.281473293997786,
                                46.358876477742292
                            ],
                            [
                                9.276678010944689,
                                46.369417838196163
                            ],
                            [
                                9.280637471238823,
                                46.4123591131113
                            ],
                            [
                                9.248696467479167,
                                46.431849710949933
                            ],
                            [
                                9.246549506538065,
                                46.446433682998482
                            ],
                            [
                                9.277816916933912,
                                46.461598269592962
                            ],
                            [
                                9.281928883386801,
                                46.496420888278251
                            ],
                            [
                                9.309582537382594,
                                46.504471431756606
                            ],
                            [
                                9.364683790318603,
                                46.507728831551603
                            ],
                            [
                                9.375561423362713,
                                46.485226353843899
                            ],
                            [
                                9.410281956315639,
                                46.466545528653192
                            ],
                            [
                                9.433931531166513,
                                46.497862119679944
                            ],
                            [
                                9.459859681955056,
                                46.506620824951241
                            ],
                            [
                                9.459259910362972,
                                46.484925415832976
                            ],
                            [
                                9.449458468620499,
                                46.483371431945194
                            ],
                            [
                                9.461525291421662,
                                46.480209525807773
                            ],
                            [
                                9.463514197263914,
                                46.470400984810354
                            ],
                            [
                                9.453409447816574,
                                46.420529764256955
                            ],
                            [
                                9.468748670144009,
                                46.388694639478565
                            ],
                            [
                                9.461597065080991,
                                46.3762501765802
                            ],
                            [
                                9.496042374343924,
                                46.364037319765124
                            ],
                            [
                                9.518623644841995,
                                46.327231654461528
                            ],
                            [
                                9.549377300561259,
                                46.302343083967045
                            ],
                            [
                                9.559532845553216,
                                46.306343762479045
                            ],
                            [
                                9.582895846141973,
                                46.294477757184744
                            ],
                            [
                                9.635082448192293,
                                46.286216937595434
                            ],
                            [
                                9.675695806416453,
                                46.303088336217861
                            ],
                            [
                                9.703056968691625,
                                46.290710574761654
                            ],
                            [
                                9.714497738252748,
                                46.29306961037183
                            ],
                            [
                                9.724170820263909,
                                46.309734949391817
                            ],
                            [
                                9.723021754487304,
                                46.340445022274793
                            ],
                            [
                                9.737279071198431,
                                46.350658713136816
                            ],
                            [
                                9.777477404670741,
                                46.334962339354512
                            ],
                            [
                                9.838712696233157,
                                46.361488370016573
                            ],
                            [
                                9.869618324494416,
                                46.362485978546474
                            ],
                            [
                                9.906360613171175,
                                46.380884109591882
                            ],
                            [
                                9.925360924195409,
                                46.366008328842042
                            ],
                            [
                                9.952940799509076,
                                46.379355679653926
                            ],
                            [
                                9.96449056949278,
                                46.363412523423797
                            ],
                            [
                                9.996352296178877,
                                46.350935632660871
                            ],
                            [
                                9.980849431185259,
                                46.323597776452374
                            ],
                            [
                                9.994680033599652,
                                46.314046456430745
                            ],
                            [
                                9.995486468723147,
                                46.285455869965162
                            ],
                            [
                                10.055456291037283,
                                46.262922155974849
                            ],
                            [
                                10.060530429393898,
                                46.248142300567068
                            ],
                            [
                                10.047448021115374,
                                46.228741995057028
                            ],
                            [
                                10.070837209550481,
                                46.217140294159485
                            ],
                            [
                                10.090266424075541,
                                46.227981618312292
                            ],
                            [
                                10.123287569625049,
                                46.223773917954048
                            ],
                            [
                                10.145676235862279,
                                46.230382707624912
                            ],
                            [
                                10.176125616926383,
                                46.258882400750934
                            ],
                            [
                                10.153786836601144,
                                46.293102745687136
                            ],
                            [
                                10.117139480745406,
                                46.31374345172464
                            ],
                            [
                                10.104315895689323,
                                46.333541677581067
                            ],
                            [
                                10.108122382641973,
                                46.352170475097978
                            ],
                            [
                                10.129180200699421,
                                46.361234224739881
                            ],
                            [
                                10.127721865836159,
                                46.377619218359541
                            ],
                            [
                                10.16165785071545,
                                46.387498699788438
                            ],
                            [
                                10.166679394148009,
                                46.407777996370875
                            ],
                            [
                                10.130673258304766,
                                46.431867399162776
                            ],
                            [
                                10.079592777647543,
                                46.421106963043364
                            ],
                            [
                                10.040523250896886,
                                46.444130303572557
                            ],
                            [
                                10.053361324983612,
                                46.463146001223329
                            ],
                            [
                                10.043044816917339,
                                46.4794128503544
                            ],
                            [
                                10.053098016244686,
                                46.531464171190969
                            ],
                            [
                                10.043648950292607,
                                46.537845927108407
                            ],
                            [
                                10.083139073594706,
                                46.564058789500677
                            ],
                            [
                                10.079373906687232,
                                46.574866747563483
                            ],
                            [
                                10.101094862996563,
                                46.582777214664198
                            ],
                            [
                                10.102154317106171,
                                46.610773242618734
                            ],
                            [
                                10.130171648784678,
                                46.605599690847605
                            ],
                            [
                                10.190628319273166,
                                46.62608552462941
                            ],
                            [
                                10.213537218728543,
                                46.617583338238319
                            ],
                            [
                                10.239062671613123,
                                46.635187009180903
                            ],
                            [
                                10.249298490410025,
                                46.618381793283923
                            ]
                        ],
                        [
                            [
                                9.28967510825453,
                                44.701218539318688
                            ],
                            [
                                9.290948156751183,
                                44.70091326155729
                            ],
                            [
                                9.302574935794487,
                                44.703260165727563
                            ],
                            [
                                9.292823364969092,
                                44.705893291926856
                            ],
                            [
                                9.28967510825453,
                                44.701218539318688
                            ]
                        ],
                        [
                            [
                                9.298857985499389,
                                44.692651659418246
                            ],
                            [
                                9.304121761021587,
                                44.693698294547318
                            ],
                            [
                                9.304203015749426,
                                44.696555190132216
                            ],
                            [
                                9.298939783243323,
                                44.693722825794588
                            ],
                            [
                                9.298857985499389,
                                44.692651659418246
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.975185233994617,
                                45.961590088288453
                            ],
                            [
                                8.957879033064087,
                                45.964735130032274
                            ],
                            [
                                8.967274601867461,
                                45.984174389066808
                            ],
                            [
                                8.977537895567318,
                                45.983015833168224
                            ],
                            [
                                8.975185233994617,
                                45.961590088288453
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.813509095878716,
                                45.017231146059586
                            ],
                            [
                                8.810012025454979,
                                45.019074488412727
                            ],
                            [
                                8.816395979142087,
                                45.022292632804081
                            ],
                            [
                                8.81676480130654,
                                45.018811741787673
                            ],
                            [
                                8.813509095878716,
                                45.017231146059586
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.705427661961116,
                                45.024483280561086
                            ],
                            [
                                8.706385937949047,
                                45.013562778038171
                            ],
                            [
                                8.704042681422781,
                                45.017526532172504
                            ],
                            [
                                8.705427661961116,
                                45.024483280561086
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 4,
                "name": "Prov. autonoma di Trento",
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            11.145903173274379,
                            45.716945434378864
                        ],
                        [
                            11.145796014365338,
                            45.71537707673471
                        ],
                        [
                            11.145722825129427,
                            45.71490135865856
                        ],
                        [
                            11.144379647587945,
                            45.71310287691388
                        ],
                        [
                            11.14411391857595,
                            45.71290054666479
                        ],
                        [
                            11.14361746683454,
                            45.712599794812014
                        ],
                        [
                            11.142815449306962,
                            45.7123545509896
                        ],
                        [
                            11.142131557721113,
                            45.71210039357126
                        ],
                        [
                            11.141539280656051,
                            45.71164305571279
                        ],
                        [
                            11.139208557384903,
                            45.70983358174232
                        ],
                        [
                            11.13875014545429,
                            45.70944064636339
                        ],
                        [
                            11.138661966205582,
                            45.7093156345965
                        ],
                        [
                            11.136991570221676,
                            45.70410014383476
                        ],
                        [
                            11.136837145515768,
                            45.70357228834833
                        ],
                        [
                            11.136155250625812,
                            45.70101596447184
                        ],
                        [
                            11.13590188353036,
                            45.700030851486545
                        ],
                        [
                            11.135850113477865,
                            45.69958119638072
                        ],
                        [
                            11.135876578014582,
                            45.69935233972538
                        ],
                        [
                            11.135992566936983,
                            45.69908775973272
                        ],
                        [
                            11.138259314136521,
                            45.69708379504117
                        ],
                        [
                            11.138509794435107,
                            45.69684830004005
                        ],
                        [
                            11.135633666569209,
                            45.69543243743077
                        ],
                        [
                            11.133391720972062,
                            45.6938929514928
                        ],
                        [
                            11.128497944607304,
                            45.69159992218269
                        ],
                        [
                            11.123941014633555,
                            45.68962836318783
                        ],
                        [
                            11.123327304340295,
                            45.689374568460686
                        ],
                        [
                            11.122559725088498,
                            45.68909344300246
                        ],
                        [
                            11.12250070344068,
                            45.68921890741882
                        ],
                        [
                            11.122472306428445,
                            45.6895825868237
                        ],
                        [
                            11.122606727541847,
                            45.68968770315031
                        ],
                        [
                            11.12288858145607,
                            45.68981523999808
                        ],
                        [
                            11.122999984830134,
                            45.68993890901689
                        ],
                        [
                            11.123055324770135,
                            45.69016204139871
                        ],
                        [
                            11.123195314107926,
                            45.69096607104271
                        ],
                        [
                            11.123534319129961,
                            45.69293970093967
                        ],
                        [
                            11.123378669734995,
                            45.69382291360917
                        ],
                        [
                            11.12250093692519,
                            45.695188655299376
                        ],
                        [
                            11.121396313300117,
                            45.69554451278683
                        ],
                        [
                            11.12071731479263,
                            45.69566498465097
                        ],
                        [
                            11.114337635852875,
                            45.6967185921591
                        ],
                        [
                            11.114091688022457,
                            45.696749430166996
                        ],
                        [
                            11.113744001452877,
                            45.696721641832504
                        ],
                        [
                            11.113145459114756,
                            45.69652460585933
                        ],
                        [
                            11.10864309872582,
                            45.69495983218719
                        ],
                        [
                            11.107568720394735,
                            45.69566964344731
                        ],
                        [
                            11.107152661876164,
                            45.695722308944994
                        ],
                        [
                            11.103192624560677,
                            45.69596111664066
                        ],
                        [
                            11.10186673534186,
                            45.69595829367452
                        ],
                        [
                            11.101687431076897,
                            45.695922383700214
                        ],
                        [
                            11.10015830358117,
                            45.69501617096497
                        ],
                        [
                            11.092399049248423,
                            45.695151100203866
                        ],
                        [
                            11.073836424451082,
                            45.70305908912382
                        ],
                        [
                            11.072385996511146,
                            45.70383432254341
                        ],
                        [
                            11.070849692663339,
                            45.705915312236115
                        ],
                        [
                            11.065451989157879,
                            45.708485532759326
                        ],
                        [
                            11.064974337446532,
                            45.708834960680946
                        ],
                        [
                            11.059507019958142,
                            45.714189484193646
                        ],
                        [
                            11.059162667574453,
                            45.71458714968973
                        ],
                        [
                            11.058957332433842,
                            45.71496301615933
                        ],
                        [
                            11.05840723326559,
                            45.71597971476572
                        ],
                        [
                            11.058088033043447,
                            45.71674790050833
                        ],
                        [
                            11.05797920228491,
                            45.71724296239468
                        ],
                        [
                            11.057726653326144,
                            45.717598937342274
                        ],
                        [
                            11.057554484004445,
                            45.717738281955434
                        ],
                        [
                            11.056678082131171,
                            45.71839272301641
                        ],
                        [
                            11.056407529921374,
                            45.71847007593704
                        ],
                        [
                            11.056145344522767,
                            45.718421600320276
                        ],
                        [
                            11.055942237934396,
                            45.718333884012196
                        ],
                        [
                            11.052757954733313,
                            45.71656711750205
                        ],
                        [
                            11.052073815601164,
                            45.71593286588176
                        ],
                        [
                            11.041376980119484,
                            45.70631909587807
                        ],
                        [
                            11.027666028503166,
                            45.704722539818334
                        ],
                        [
                            11.027195686740003,
                            45.70468858981694
                        ],
                        [
                            11.026195519282245,
                            45.70471691445415
                        ],
                        [
                            11.025479850574273,
                            45.704814125809655
                        ],
                        [
                            11.022113365023916,
                            45.70553061458653
                        ],
                        [
                            11.017885406870619,
                            45.70636185199853
                        ],
                        [
                            11.017639646943179,
                            45.70632548017007
                        ],
                        [
                            11.017184138432492,
                            45.706162422498
                        ],
                        [
                            11.016465929291725,
                            45.70572738486686
                        ],
                        [
                            11.015209743623846,
                            45.710999990690986
                        ],
                        [
                            11.016639564882265,
                            45.71454907236334
                        ],
                        [
                            11.017189733078277,
                            45.71650102885985
                        ],
                        [
                            11.017359717269636,
                            45.71711458517391
                        ],
                        [
                            11.017526100015155,
                            45.717916306104314
                        ],
                        [
                            11.017565509497441,
                            45.71833865328514
                        ],
                        [
                            11.017377010780098,
                            45.718923026936054
                        ],
                        [
                            11.017150322913041,
                            45.71934739389643
                        ],
                        [
                            11.017022185479389,
                            45.71945974552738
                        ],
                        [
                            11.016575319178656,
                            45.71942388437057
                        ],
                        [
                            11.01146700611842,
                            45.7189454638574
                        ],
                        [
                            11.011579004402869,
                            45.717589113438514
                        ],
                        [
                            11.011704502879372,
                            45.716420828667765
                        ],
                        [
                            11.01185837793233,
                            45.71564029050806
                        ],
                        [
                            11.011903919221824,
                            45.71489254095335
                        ],
                        [
                            11.01176520655304,
                            45.714638178170944
                        ],
                        [
                            11.011441781500592,
                            45.71420767203801
                        ],
                        [
                            11.011081094202794,
                            45.71375965726459
                        ],
                        [
                            11.010569501826334,
                            45.71321163531021
                        ],
                        [
                            11.00755801376022,
                            45.71042220260715
                        ],
                        [
                            11.001521564417432,
                            45.70834708272049
                        ],
                        [
                            10.998977266646751,
                            45.707607799651555
                        ],
                        [
                            10.997716645643456,
                            45.70277367700097
                        ],
                        [
                            10.997799894850607,
                            45.70194901343147
                        ],
                        [
                            10.997895769051832,
                            45.70068270630938
                        ],
                        [
                            10.998011081133555,
                            45.6990797528101
                        ],
                        [
                            10.997631950385099,
                            45.69702745598036
                        ],
                        [
                            10.986335727158108,
                            45.688806859879946
                        ],
                        [
                            10.979142145261509,
                            45.68568490753932
                        ],
                        [
                            10.97538899142941,
                            45.68416675899883
                        ],
                        [
                            10.968319505533914,
                            45.68012109727075
                        ],
                        [
                            10.968431372136429,
                            45.68470014901184
                        ],
                        [
                            10.969383137630638,
                            45.687433158662586
                        ],
                        [
                            10.970087805604564,
                            45.6888564147495
                        ],
                        [
                            10.970362850210925,
                            45.689317228047514
                        ],
                        [
                            10.972541594658448,
                            45.692465401884114
                        ],
                        [
                            10.974158824580565,
                            45.69469119949347
                        ],
                        [
                            10.974799000443173,
                            45.69557233080665
                        ],
                        [
                            10.97492105996573,
                            45.69586296967066
                        ],
                        [
                            10.974938094664802,
                            45.695969302127246
                        ],
                        [
                            10.974956931196816,
                            45.69610535155439
                        ],
                        [
                            10.974830532561631,
                            45.69656504290447
                        ],
                        [
                            10.974776872180891,
                            45.69670845399081
                        ],
                        [
                            10.97250884174668,
                            45.70140320662977
                        ],
                        [
                            10.97219991876186,
                            45.70181749324268
                        ],
                        [
                            10.96592329280208,
                            45.693272040668745
                        ],
                        [
                            10.965660157696043,
                            45.692897648843655
                        ],
                        [
                            10.965335492026446,
                            45.692327082819354
                        ],
                        [
                            10.96514553419459,
                            45.69197487071324
                        ],
                        [
                            10.9619976776923,
                            45.68568284535466
                        ],
                        [
                            10.951326533789985,
                            45.68449853392986
                        ],
                        [
                            10.946122510504157,
                            45.67919212672896
                        ],
                        [
                            10.946144208658152,
                            45.6787099837225
                        ],
                        [
                            10.946044264334217,
                            45.678213152837166
                        ],
                        [
                            10.945534953286629,
                            45.675871305971334
                        ],
                        [
                            10.945431732253795,
                            45.67568807186758
                        ],
                        [
                            10.944497482875711,
                            45.674065234819274
                        ],
                        [
                            10.942989000661044,
                            45.67311653918732
                        ],
                        [
                            10.942900728198984,
                            45.67306257515287
                        ],
                        [
                            10.9419608028811,
                            45.67309366464777
                        ],
                        [
                            10.940308716638857,
                            45.673174114036925
                        ],
                        [
                            10.937459644557661,
                            45.67341569808066
                        ],
                        [
                            10.933896859003307,
                            45.6758129330053
                        ],
                        [
                            10.930368139115997,
                            45.677726515728736
                        ],
                        [
                            10.917966626698384,
                            45.683716436156026
                        ],
                        [
                            10.911997604922654,
                            45.68831466981815
                        ],
                        [
                            10.913557122511204,
                            45.692087496259084
                        ],
                        [
                            10.918781936923573,
                            45.70055358466717
                        ],
                        [
                            10.904597373472674,
                            45.70771887471444
                        ],
                        [
                            10.88957863180984,
                            45.71507464915417
                        ],
                        [
                            10.888894512796128,
                            45.71527420172034
                        ],
                        [
                            10.88554598154315,
                            45.716238319812845
                        ],
                        [
                            10.882974960266045,
                            45.716897836385954
                        ],
                        [
                            10.881471973451344,
                            45.71727737495567
                        ],
                        [
                            10.872507331914367,
                            45.715790148650306
                        ],
                        [
                            10.862031435034645,
                            45.71738091668759
                        ],
                        [
                            10.860181782543465,
                            45.717591041071906
                        ],
                        [
                            10.85825721153877,
                            45.71779342013462
                        ],
                        [
                            10.858026425034078,
                            45.717810146958435
                        ],
                        [
                            10.857295199877345,
                            45.717861989065455
                        ],
                        [
                            10.85549188511956,
                            45.71789167984612
                        ],
                        [
                            10.848191888378057,
                            45.71794334832535
                        ],
                        [
                            10.843832376572815,
                            45.71859281910569
                        ],
                        [
                            10.843270150530577,
                            45.72058783725562
                        ],
                        [
                            10.844402087740137,
                            45.72488383713164
                        ],
                        [
                            10.849930419282307,
                            45.73578189743016
                        ],
                        [
                            10.85502927105845,
                            45.74185482886451
                        ],
                        [
                            10.855258786735785,
                            45.74209001099414
                        ],
                        [
                            10.855692461062297,
                            45.74239235259197
                        ],
                        [
                            10.858261355394655,
                            45.743795423129434
                        ],
                        [
                            10.858598224969084,
                            45.743871321343725
                        ],
                        [
                            10.862627185115768,
                            45.74366131829689
                        ],
                        [
                            10.863729802996826,
                            45.74909336141512
                        ],
                        [
                            10.864868028346486,
                            45.7548938339593
                        ],
                        [
                            10.86509431547706,
                            45.759698403848425
                        ],
                        [
                            10.865244391890634,
                            45.76130129496436
                        ],
                        [
                            10.866936747172703,
                            45.764240131275585
                        ],
                        [
                            10.867228369987332,
                            45.76461185034341
                        ],
                        [
                            10.867609901773145,
                            45.765020698636455
                        ],
                        [
                            10.875766332082957,
                            45.77009849370424
                        ],
                        [
                            10.880856590037842,
                            45.77215254068325
                        ],
                        [
                            10.881535141602923,
                            45.77204185964871
                        ],
                        [
                            10.882284138553228,
                            45.77194468952044
                        ],
                        [
                            10.882723854160417,
                            45.7719406141128
                        ],
                        [
                            10.883007064070666,
                            45.7720233371669
                        ],
                        [
                            10.883789246727195,
                            45.7728121710416
                        ],
                        [
                            10.884108882238657,
                            45.77323389723905
                        ],
                        [
                            10.884444269475004,
                            45.77373173015653
                        ],
                        [
                            10.884976455254082,
                            45.77465488783661
                        ],
                        [
                            10.885393623936345,
                            45.77557092634005
                        ],
                        [
                            10.88477688054013,
                            45.77823760371778
                        ],
                        [
                            10.883824759362007,
                            45.77933952755902
                        ],
                        [
                            10.883413476799817,
                            45.779755960880586
                        ],
                        [
                            10.881912830061092,
                            45.78086493823665
                        ],
                        [
                            10.872797363143711,
                            45.78856184077164
                        ],
                        [
                            10.873006404471093,
                            45.79053869245901
                        ],
                        [
                            10.873190753202818,
                            45.79154071411964
                        ],
                        [
                            10.874116714218212,
                            45.79554595987088
                        ],
                        [
                            10.876688641891409,
                            45.80322853684651
                        ],
                        [
                            10.876760965139518,
                            45.803323704633335
                        ],
                        [
                            10.880003249048148,
                            45.80568727077835
                        ],
                        [
                            10.880896043797092,
                            45.806135926466105
                        ],
                        [
                            10.881072723336978,
                            45.80616650793801
                        ],
                        [
                            10.885487595511373,
                            45.80914584675381
                        ],
                        [
                            10.886696864143442,
                            45.81003576990126
                        ],
                        [
                            10.887569568471557,
                            45.81116426990057
                        ],
                        [
                            10.887586263061651,
                            45.81164843461527
                        ],
                        [
                            10.887260315045642,
                            45.81223884304671
                        ],
                        [
                            10.886653253408776,
                            45.81292420515437
                        ],
                        [
                            10.885821231673246,
                            45.81369374698032
                        ],
                        [
                            10.884736244218256,
                            45.81446838317079
                        ],
                        [
                            10.88251126042913,
                            45.81513667070256
                        ],
                        [
                            10.883346984442692,
                            45.81647244936156
                        ],
                        [
                            10.883404321299912,
                            45.81697155595142
                        ],
                        [
                            10.870061864161062,
                            45.82213515341273
                        ],
                        [
                            10.85896720699636,
                            45.82634541717405
                        ],
                        [
                            10.856107640292953,
                            45.82739189292961
                        ],
                        [
                            10.841273381423433,
                            45.83237656689296
                        ],
                        [
                            10.840150465662777,
                            45.83275599772702
                        ],
                        [
                            10.839917833684897,
                            45.83284159331681
                        ],
                        [
                            10.837332107849353,
                            45.833746918264595
                        ],
                        [
                            10.825785812556791,
                            45.837697165171484
                        ],
                        [
                            10.82538518465312,
                            45.83774488763416
                        ],
                        [
                            10.805327765999591,
                            45.83490798286263
                        ],
                        [
                            10.804004368752462,
                            45.83445636605094
                        ],
                        [
                            10.803582902300365,
                            45.834414940472755
                        ],
                        [
                            10.803300153702745,
                            45.83443734117066
                        ],
                        [
                            10.800902813009335,
                            45.834754177727646
                        ],
                        [
                            10.799365051141127,
                            45.83563403235756
                        ],
                        [
                            10.798776398242293,
                            45.83604498794947
                        ],
                        [
                            10.798350897269426,
                            45.8363410888556
                        ],
                        [
                            10.797613701778435,
                            45.83632772442072
                        ],
                        [
                            10.796887910637793,
                            45.8362880935229
                        ],
                        [
                            10.796273874307154,
                            45.83611452412451
                        ],
                        [
                            10.796023902389477,
                            45.83603109275465
                        ],
                        [
                            10.792922150169833,
                            45.83418585125167
                        ],
                        [
                            10.791684910073325,
                            45.83309894300889
                        ],
                        [
                            10.789062276502444,
                            45.83422324903404
                        ],
                        [
                            10.78227310361506,
                            45.83841457632538
                        ],
                        [
                            10.777397147329717,
                            45.84280041533816
                        ],
                        [
                            10.777204785325178,
                            45.843028193923416
                        ],
                        [
                            10.777097597906614,
                            45.843088121323206
                        ],
                        [
                            10.776943292124551,
                            45.84311172925223
                        ],
                        [
                            10.77463094991792,
                            45.843076476793264
                        ],
                        [
                            10.772634352390561,
                            45.84291459125805
                        ],
                        [
                            10.771198423837708,
                            45.842716282676136
                        ],
                        [
                            10.770552066750794,
                            45.84262688370326
                        ],
                        [
                            10.769623432802184,
                            45.84238434005167
                        ],
                        [
                            10.767872847544563,
                            45.8418982271268
                        ],
                        [
                            10.765423433722365,
                            45.84107696889198
                        ],
                        [
                            10.76479843441138,
                            45.840847856378474
                        ],
                        [
                            10.76419544039469,
                            45.84059621112347
                        ],
                        [
                            10.763064953895134,
                            45.83996098964581
                        ],
                        [
                            10.760008304451963,
                            45.83751233460389
                        ],
                        [
                            10.756350697267,
                            45.830026366102395
                        ],
                        [
                            10.754251061378634,
                            45.831556213498764
                        ],
                        [
                            10.752157345099747,
                            45.834224926788636
                        ],
                        [
                            10.7512960182563,
                            45.83656423409582
                        ],
                        [
                            10.74521787045594,
                            45.840437405490846
                        ],
                        [
                            10.745015216852947,
                            45.84049898086716
                        ],
                        [
                            10.743258835580605,
                            45.841003239956024
                        ],
                        [
                            10.741542972596818,
                            45.84130951182593
                        ],
                        [
                            10.737306174186854,
                            45.84167485415472
                        ],
                        [
                            10.737090715721884,
                            45.84197988409182
                        ],
                        [
                            10.73687422947903,
                            45.84217244915859
                        ],
                        [
                            10.736273456404938,
                            45.84248188997953
                        ],
                        [
                            10.735926628505185,
                            45.8426410794972
                        ],
                        [
                            10.735553312856444,
                            45.84272295466885
                        ],
                        [
                            10.735080693139938,
                            45.84272199585085
                        ],
                        [
                            10.733182121290556,
                            45.84270433790707
                        ],
                        [
                            10.731723029100237,
                            45.84264676166695
                        ],
                        [
                            10.726385823281781,
                            45.84237281741522
                        ],
                        [
                            10.722506114679693,
                            45.84118978774603
                        ],
                        [
                            10.722160881468831,
                            45.84084609845532
                        ],
                        [
                            10.721803978378688,
                            45.840384317365796
                        ],
                        [
                            10.721454798690688,
                            45.84002038338356
                        ],
                        [
                            10.720564954753943,
                            45.839326367906764
                        ],
                        [
                            10.71865003272584,
                            45.837889198719004
                        ],
                        [
                            10.717124539726806,
                            45.83678475719809
                        ],
                        [
                            10.711013004490631,
                            45.83606263655482
                        ],
                        [
                            10.710675304478796,
                            45.83607243131992
                        ],
                        [
                            10.709893030958526,
                            45.83611983132625
                        ],
                        [
                            10.70889212245953,
                            45.836234900625385
                        ],
                        [
                            10.706802133683468,
                            45.836499150535914
                        ],
                        [
                            10.706667877713455,
                            45.83820918035814
                        ],
                        [
                            10.706155240271126,
                            45.838538677482134
                        ],
                        [
                            10.701843840259546,
                            45.84103504733566
                        ],
                        [
                            10.701577904634213,
                            45.84114635405326
                        ],
                        [
                            10.700243707341597,
                            45.841575881702035
                        ],
                        [
                            10.699505508055807,
                            45.84166438789694
                        ],
                        [
                            10.696774810938589,
                            45.84086062572032
                        ],
                        [
                            10.695083763631354,
                            45.8394126997568
                        ],
                        [
                            10.692938934101273,
                            45.83778723979107
                        ],
                        [
                            10.692778854047134,
                            45.83768191316143
                        ],
                        [
                            10.690349419111332,
                            45.836252973742845
                        ],
                        [
                            10.682643972999324,
                            45.832597655125554
                        ],
                        [
                            10.675723848826141,
                            45.830460702696215
                        ],
                        [
                            10.67457146952226,
                            45.830843620243435
                        ],
                        [
                            10.673908881299676,
                            45.83106812539517
                        ],
                        [
                            10.673324681169483,
                            45.831270566196
                        ],
                        [
                            10.671941617536243,
                            45.83164615757303
                        ],
                        [
                            10.671252893140212,
                            45.83180158206851
                        ],
                        [
                            10.6698331785936,
                            45.832105849339534
                        ],
                        [
                            10.667714258761253,
                            45.832257864862676
                        ],
                        [
                            10.654640146273259,
                            45.83262761533502
                        ],
                        [
                            10.654039283279968,
                            45.82705225318723
                        ],
                        [
                            10.6547498514801,
                            45.82126555050585
                        ],
                        [
                            10.65103571778614,
                            45.81248622771095
                        ],
                        [
                            10.648391988330063,
                            45.80767464444587
                        ],
                        [
                            10.64532755374003,
                            45.804127150933425
                        ],
                        [
                            10.643828769445204,
                            45.80295985166088
                        ],
                        [
                            10.641409389169906,
                            45.80188520428966
                        ],
                        [
                            10.636728543499368,
                            45.80588451564527
                        ],
                        [
                            10.63514749436425,
                            45.80667174667686
                        ],
                        [
                            10.624758947753548,
                            45.806202437658925
                        ],
                        [
                            10.614563390160317,
                            45.8056414043231
                        ],
                        [
                            10.611710135493212,
                            45.80532121764391
                        ],
                        [
                            10.60098179327972,
                            45.80300330565249
                        ],
                        [
                            10.60062656717907,
                            45.8029063780474
                        ],
                        [
                            10.60048698638942,
                            45.802819453164325
                        ],
                        [
                            10.597677600054489,
                            45.799735233194845
                        ],
                        [
                            10.591020088842392,
                            45.798462523038296
                        ],
                        [
                            10.5903253222053,
                            45.798298176089354
                        ],
                        [
                            10.589707203563792,
                            45.79812301585156
                        ],
                        [
                            10.589082886845445,
                            45.797871155739024
                        ],
                        [
                            10.585660149757414,
                            45.79618202206277
                        ],
                        [
                            10.582181529206334,
                            45.79419766580597
                        ],
                        [
                            10.582133940009596,
                            45.79407554195979
                        ],
                        [
                            10.58201534671458,
                            45.79185396106176
                        ],
                        [
                            10.58110013244706,
                            45.78935644034439
                        ],
                        [
                            10.580738101845014,
                            45.78908452318966
                        ],
                        [
                            10.580449669603173,
                            45.78889361783092
                        ],
                        [
                            10.574487160527932,
                            45.786860180828576
                        ],
                        [
                            10.563473316357879,
                            45.784112642397886
                        ],
                        [
                            10.561430446103536,
                            45.78391909452678
                        ],
                        [
                            10.56107167511031,
                            45.783913546303765
                        ],
                        [
                            10.553673573139445,
                            45.78393331371894
                        ],
                        [
                            10.54542384582104,
                            45.784659201041514
                        ],
                        [
                            10.538416439789925,
                            45.78552247408451
                        ],
                        [
                            10.53779763045899,
                            45.785634420304866
                        ],
                        [
                            10.536028955016498,
                            45.78645974830261
                        ],
                        [
                            10.532753208860091,
                            45.78806021305941
                        ],
                        [
                            10.532697856058753,
                            45.788282343941574
                        ],
                        [
                            10.530881150947332,
                            45.79586164736195
                        ],
                        [
                            10.533854104952818,
                            45.80063738229304
                        ],
                        [
                            10.534088783071242,
                            45.8006697983217
                        ],
                        [
                            10.534219790047048,
                            45.80070600496156
                        ],
                        [
                            10.534401945221397,
                            45.80085140013743
                        ],
                        [
                            10.535055313936274,
                            45.80137304600693
                        ],
                        [
                            10.535157170479907,
                            45.80153657717925
                        ],
                        [
                            10.535110902896397,
                            45.80170496381396
                        ],
                        [
                            10.533792665639325,
                            45.80433240460251
                        ],
                        [
                            10.533668680922917,
                            45.8045248750181
                        ],
                        [
                            10.533499175513258,
                            45.80476036875827
                        ],
                        [
                            10.533329485024872,
                            45.80496511009564
                        ],
                        [
                            10.533193079289692,
                            45.80507567885722
                        ],
                        [
                            10.532929517244762,
                            45.80515994534383
                        ],
                        [
                            10.532474106415997,
                            45.805146831844006
                        ],
                        [
                            10.528151171338958,
                            45.8041426571056
                        ],
                        [
                            10.526051424323791,
                            45.80561385008084
                        ],
                        [
                            10.526012415029223,
                            45.80569781792737
                        ],
                        [
                            10.526351974488726,
                            45.80637962810567
                        ],
                        [
                            10.526581851257264,
                            45.806612374775554
                        ],
                        [
                            10.52970727407366,
                            45.80957445527955
                        ],
                        [
                            10.531059725315751,
                            45.80947751658605
                        ],
                        [
                            10.531752522240492,
                            45.80940493063823
                        ],
                        [
                            10.532460687144525,
                            45.80935068483585
                        ],
                        [
                            10.533190198888954,
                            45.80932710886028
                        ],
                        [
                            10.533906217809813,
                            45.809380643162804
                        ],
                        [
                            10.536160801230784,
                            45.81016961652581
                        ],
                        [
                            10.53706955006569,
                            45.8105557812844
                        ],
                        [
                            10.543118575109073,
                            45.81490604214241
                        ],
                        [
                            10.543213205807211,
                            45.8152191717563
                        ],
                        [
                            10.543348328847761,
                            45.8157220448447
                        ],
                        [
                            10.543512407277447,
                            45.81620431717922
                        ],
                        [
                            10.543800705469625,
                            45.81705562336156
                        ],
                        [
                            10.54377300958111,
                            45.817181416409795
                        ],
                        [
                            10.543627779013589,
                            45.81764777479293
                        ],
                        [
                            10.543266710425028,
                            45.818364034178295
                        ],
                        [
                            10.540373191729273,
                            45.82041387476926
                        ],
                        [
                            10.536767712998662,
                            45.822577448366694
                        ],
                        [
                            10.529105029537472,
                            45.826461062413394
                        ],
                        [
                            10.528878672724769,
                            45.82655346455094
                        ],
                        [
                            10.524285261049844,
                            45.827128556894245
                        ],
                        [
                            10.517634535196803,
                            45.82636283179998
                        ],
                        [
                            10.514452579757402,
                            45.82599137855519
                        ],
                        [
                            10.513946427960933,
                            45.82585671696466
                        ],
                        [
                            10.51380699513383,
                            45.82579031955904
                        ],
                        [
                            10.513676362018906,
                            45.82568820219156
                        ],
                        [
                            10.51106102157195,
                            45.824153089934555
                        ],
                        [
                            10.510913640704999,
                            45.82409755085998
                        ],
                        [
                            10.509041209242618,
                            45.82364866854594
                        ],
                        [
                            10.508837739217043,
                            45.8236078925948
                        ],
                        [
                            10.50857008057197,
                            45.82359388688057
                        ],
                        [
                            10.508333330592958,
                            45.82364541073714
                        ],
                        [
                            10.508197559112409,
                            45.823737571314055
                        ],
                        [
                            10.502827599631503,
                            45.829733967837974
                        ],
                        [
                            10.502487137156779,
                            45.830161767905594
                        ],
                        [
                            10.502360482195822,
                            45.830374603496004
                        ],
                        [
                            10.50225503505285,
                            45.83065324587957
                        ],
                        [
                            10.502155343055962,
                            45.83104556508911
                        ],
                        [
                            10.50210234743306,
                            45.83131990021391
                        ],
                        [
                            10.501976604085616,
                            45.83204585303076
                        ],
                        [
                            10.501959372011482,
                            45.83217284538617
                        ],
                        [
                            10.502069880200729,
                            45.83347119803404
                        ],
                        [
                            10.502140735813715,
                            45.83369953383864
                        ],
                        [
                            10.502592037303621,
                            45.835120320117674
                        ],
                        [
                            10.502966335181668,
                            45.83616064387813
                        ],
                        [
                            10.50301223879909,
                            45.83624440701671
                        ],
                        [
                            10.503070513568762,
                            45.83632803977046
                        ],
                        [
                            10.503504394236371,
                            45.83694909331924
                        ],
                        [
                            10.503557981171545,
                            45.83700888888341
                        ],
                        [
                            10.505906509520079,
                            45.843277255670245
                        ],
                        [
                            10.50470848164162,
                            45.849731319587576
                        ],
                        [
                            10.503089259163646,
                            45.85605746524435
                        ],
                        [
                            10.502732302034966,
                            45.85631592217212
                        ],
                        [
                            10.502661752960462,
                            45.85638365213927
                        ],
                        [
                            10.502590520197453,
                            45.856469761400795
                        ],
                        [
                            10.502533072832005,
                            45.856576669848124
                        ],
                        [
                            10.501548270039974,
                            45.85850071133456
                        ],
                        [
                            10.501525613698371,
                            45.85855311391546
                        ],
                        [
                            10.501519691466058,
                            45.85961738518728
                        ],
                        [
                            10.501718371951275,
                            45.867111936717386
                        ],
                        [
                            10.501747722115761,
                            45.867398828958784
                        ],
                        [
                            10.502280644260775,
                            45.87114621114356
                        ],
                        [
                            10.502311221986174,
                            45.871261904682314
                        ],
                        [
                            10.49532638832799,
                            45.87946768096491
                        ],
                        [
                            10.494818227097642,
                            45.87979825714699
                        ],
                        [
                            10.490990555237126,
                            45.882317512761375
                        ],
                        [
                            10.490306416720648,
                            45.88390176347571
                        ],
                        [
                            10.490043200911309,
                            45.884610829808985
                        ],
                        [
                            10.490046512823783,
                            45.88504954416322
                        ],
                        [
                            10.49011584053516,
                            45.88707745678862
                        ],
                        [
                            10.495078631998581,
                            45.89981662943447
                        ],
                        [
                            10.495410677154606,
                            45.89977170368135
                        ],
                        [
                            10.498961613666033,
                            45.89950369605198
                        ],
                        [
                            10.499758877265432,
                            45.899609969885674
                        ],
                        [
                            10.500407852391325,
                            45.899817990598685
                        ],
                        [
                            10.50107271395483,
                            45.900035407931135
                        ],
                        [
                            10.501952018509373,
                            45.900348834389085
                        ],
                        [
                            10.502406928989952,
                            45.90063783948192
                        ],
                        [
                            10.50594179758263,
                            45.90303032149488
                        ],
                        [
                            10.506095321558247,
                            45.90315213059757
                        ],
                        [
                            10.506164388202027,
                            45.90327575228329
                        ],
                        [
                            10.506175877806472,
                            45.90344377145764
                        ],
                        [
                            10.50769011572171,
                            45.90534424837469
                        ],
                        [
                            10.510063406436194,
                            45.91706894204324
                        ],
                        [
                            10.508644411235968,
                            45.92328312021783
                        ],
                        [
                            10.508568119923453,
                            45.92356617099044
                        ],
                        [
                            10.507361713535733,
                            45.924972901856925
                        ],
                        [
                            10.50412058318612,
                            45.92630841667242
                        ],
                        [
                            10.496421807632036,
                            45.9294694738727
                        ],
                        [
                            10.491235930116261,
                            45.933227964093014
                        ],
                        [
                            10.491435429586966,
                            45.94195295837994
                        ],
                        [
                            10.49104073421855,
                            45.94193785327578
                        ],
                        [
                            10.486150465271498,
                            45.94282900475407
                        ],
                        [
                            10.485999769124017,
                            45.9430475445557
                        ],
                        [
                            10.48570841088375,
                            45.94347849780738
                        ],
                        [
                            10.48512206991653,
                            45.944399676164636
                        ],
                        [
                            10.484706155456575,
                            45.945114747934895
                        ],
                        [
                            10.483218968739894,
                            45.950574005537774
                        ],
                        [
                            10.483026188136586,
                            45.95192801035643
                        ],
                        [
                            10.484179822071177,
                            45.95469537593358
                        ],
                        [
                            10.486790031833863,
                            45.95922918869833
                        ],
                        [
                            10.486965397422605,
                            45.95949620624488
                        ],
                        [
                            10.487397611957881,
                            45.959832501645614
                        ],
                        [
                            10.487926708630027,
                            45.96014556265478
                        ],
                        [
                            10.48846728890808,
                            45.96048934603323
                        ],
                        [
                            10.488660745527506,
                            45.96068470355194
                        ],
                        [
                            10.48980359549634,
                            45.96218312984278
                        ],
                        [
                            10.48987454893829,
                            45.96228877781051
                        ],
                        [
                            10.489934138456153,
                            45.962516476716736
                        ],
                        [
                            10.489900549332095,
                            45.962810728889075
                        ],
                        [
                            10.488494978722507,
                            45.96934583000729
                        ],
                        [
                            10.486604675164383,
                            45.97115833691757
                        ],
                        [
                            10.474450230542974,
                            45.972649904143694
                        ],
                        [
                            10.47302726697654,
                            45.97253499557317
                        ],
                        [
                            10.47112462832422,
                            45.97234333553166
                        ],
                        [
                            10.467523546657103,
                            45.97163780681494
                        ],
                        [
                            10.453407903185584,
                            45.97655254129284
                        ],
                        [
                            10.45301003692435,
                            45.977181621544005
                        ],
                        [
                            10.45273706104783,
                            45.97765760034861
                        ],
                        [
                            10.452488428334954,
                            45.97809716091294
                        ],
                        [
                            10.452131419215545,
                            45.97968597801814
                        ],
                        [
                            10.452270950140258,
                            45.9824101120369
                        ],
                        [
                            10.452934531888017,
                            45.98962212937544
                        ],
                        [
                            10.4529796207491,
                            45.98994042870879
                        ],
                        [
                            10.453094339163613,
                            45.99044408267863
                        ],
                        [
                            10.453148669284783,
                            45.990662414231494
                        ],
                        [
                            10.453231768419613,
                            45.990927192130115
                        ],
                        [
                            10.453284641253747,
                            45.991024803736245
                        ],
                        [
                            10.453728242537506,
                            45.99124663294021
                        ],
                        [
                            10.454263996982828,
                            45.991581723871185
                        ],
                        [
                            10.455128180864042,
                            45.992316863124785
                        ],
                        [
                            10.455444699042921,
                            45.99259196383615
                        ],
                        [
                            10.457192037364745,
                            45.9956801944857
                        ],
                        [
                            10.457840567612974,
                            45.99941926304049
                        ],
                        [
                            10.457857611397772,
                            45.99998963134279
                        ],
                        [
                            10.45749860990454,
                            46.00108893299624
                        ],
                        [
                            10.457073065186185,
                            46.00357209003096
                        ],
                        [
                            10.4570938192722,
                            46.00804788312252
                        ],
                        [
                            10.457158641152505,
                            46.00855450074016
                        ],
                        [
                            10.457305153452346,
                            46.00906494209533
                        ],
                        [
                            10.457574185738599,
                            46.00950765738561
                        ],
                        [
                            10.457951277269203,
                            46.01000328299052
                        ],
                        [
                            10.458292137401449,
                            46.010425173796285
                        ],
                        [
                            10.462493086204113,
                            46.01488891213042
                        ],
                        [
                            10.46298301788934,
                            46.015404385862055
                        ],
                        [
                            10.464699607777373,
                            46.017017561584154
                        ],
                        [
                            10.464879999802303,
                            46.01716700878788
                        ],
                        [
                            10.465051351307931,
                            46.01730516898617
                        ],
                        [
                            10.465387519760517,
                            46.01754739872111
                        ],
                        [
                            10.470374950332968,
                            46.02079750623279
                        ],
                        [
                            10.470815730708159,
                            46.021082656647636
                        ],
                        [
                            10.471532454616831,
                            46.02136221981032
                        ],
                        [
                            10.471859087157107,
                            46.02142467004594
                        ],
                        [
                            10.47212500643014,
                            46.02145993725871
                        ],
                        [
                            10.47612000396263,
                            46.02126272228074
                        ],
                        [
                            10.48077398661316,
                            46.02107270288358
                        ],
                        [
                            10.481499883452264,
                            46.021107081704486
                        ],
                        [
                            10.482041593290758,
                            46.021244190573434
                        ],
                        [
                            10.482662823615378,
                            46.02141937999022
                        ],
                        [
                            10.48304346127861,
                            46.021592448821345
                        ],
                        [
                            10.483292244084128,
                            46.021863720581514
                        ],
                        [
                            10.484568498876765,
                            46.024316466180515
                        ],
                        [
                            10.48470522756597,
                            46.02461648965381
                        ],
                        [
                            10.486107985517735,
                            46.02897246663739
                        ],
                        [
                            10.486212110978256,
                            46.029339939907565
                        ],
                        [
                            10.486224613266243,
                            46.02955094204172
                        ],
                        [
                            10.483513970552131,
                            46.043774750823786
                        ],
                        [
                            10.481369928636587,
                            46.049909693390056
                        ],
                        [
                            10.47972268377989,
                            46.05030970646557
                        ],
                        [
                            10.479058237636075,
                            46.05047473676739
                        ],
                        [
                            10.47843581058141,
                            46.0506947590508
                        ],
                        [
                            10.47785114216938,
                            46.0509678904152
                        ],
                        [
                            10.477552182812428,
                            46.05112585080708
                        ],
                        [
                            10.477336000419974,
                            46.051321059353874
                        ],
                        [
                            10.480947249943892,
                            46.05629472743614
                        ],
                        [
                            10.490919693294748,
                            46.06680868195972
                        ],
                        [
                            10.49486337921326,
                            46.069294478683204
                        ],
                        [
                            10.495124831080291,
                            46.069427582678024
                        ],
                        [
                            10.50130877455882,
                            46.07232168933772
                        ],
                        [
                            10.501749172462617,
                            46.07230717504149
                        ],
                        [
                            10.502259827862005,
                            46.072281301365564
                        ],
                        [
                            10.502943648054961,
                            46.07224178513985
                        ],
                        [
                            10.503675401507532,
                            46.072271622562205
                        ],
                        [
                            10.50488555423405,
                            46.072388776908795
                        ],
                        [
                            10.507741417597758,
                            46.0735683051825
                        ],
                        [
                            10.509192512097309,
                            46.07523164311531
                        ],
                        [
                            10.517182333882372,
                            46.080078850290796
                        ],
                        [
                            10.524728566040592,
                            46.08964318629969
                        ],
                        [
                            10.535310926189068,
                            46.097368468947124
                        ],
                        [
                            10.535743235733072,
                            46.09773114896743
                        ],
                        [
                            10.536196646219892,
                            46.098147132423925
                        ],
                        [
                            10.540746011918802,
                            46.10239302076903
                        ],
                        [
                            10.54140170180342,
                            46.10302459877557
                        ],
                        [
                            10.541578022803842,
                            46.10326927689945
                        ],
                        [
                            10.549498794956762,
                            46.11739421914409
                        ],
                        [
                            10.551117720432453,
                            46.1245056549367
                        ],
                        [
                            10.551163490274122,
                            46.12505011538467
                        ],
                        [
                            10.548103492402761,
                            46.13926316136261
                        ],
                        [
                            10.549269646520722,
                            46.14642742041988
                        ],
                        [
                            10.554321250590633,
                            46.148775848185366
                        ],
                        [
                            10.554923254772069,
                            46.15253954956147
                        ],
                        [
                            10.555394973473339,
                            46.1553957365828
                        ],
                        [
                            10.557197622890845,
                            46.159406813613856
                        ],
                        [
                            10.557294556839233,
                            46.159599600615216
                        ],
                        [
                            10.557471354912293,
                            46.15986934821994
                        ],
                        [
                            10.560725458070236,
                            46.16391239491276
                        ],
                        [
                            10.561068303757159,
                            46.164308220297876
                        ],
                        [
                            10.561272106038958,
                            46.164537464632744
                        ],
                        [
                            10.561672081171217,
                            46.164723191520764
                        ],
                        [
                            10.56234306199579,
                            46.16496095636053
                        ],
                        [
                            10.562992680407278,
                            46.16519614373908
                        ],
                        [
                            10.563594253268745,
                            46.16541796061335
                        ],
                        [
                            10.564146680849214,
                            46.165675380359716
                        ],
                        [
                            10.565071684443733,
                            46.166369104246606
                        ],
                        [
                            10.565364464251042,
                            46.16661658209324
                        ],
                        [
                            10.565390219749377,
                            46.166673461682805
                        ],
                        [
                            10.565394906415646,
                            46.16683864410039
                        ],
                        [
                            10.5653081069077,
                            46.16697038553425
                        ],
                        [
                            10.565243127153284,
                            46.16706426028109
                        ],
                        [
                            10.5647752214059,
                            46.16767363044022
                        ],
                        [
                            10.558020136191654,
                            46.17644159285289
                        ],
                        [
                            10.556907414429743,
                            46.177743909353765
                        ],
                        [
                            10.556140809733456,
                            46.17859722965704
                        ],
                        [
                            10.554552354901128,
                            46.18026990740619
                        ],
                        [
                            10.554126097614594,
                            46.180595714310904
                        ],
                        [
                            10.554060535091084,
                            46.180640431335185
                        ],
                        [
                            10.553498227477046,
                            46.18102175294698
                        ],
                        [
                            10.548671357265349,
                            46.18420037044512
                        ],
                        [
                            10.54636180225944,
                            46.18571896884534
                        ],
                        [
                            10.54373681657344,
                            46.187440400505274
                        ],
                        [
                            10.54139963951191,
                            46.188619472517104
                        ],
                        [
                            10.543365030952566,
                            46.19245021468609
                        ],
                        [
                            10.549249388523593,
                            46.20414658139485
                        ],
                        [
                            10.549356901916077,
                            46.20462647842283
                        ],
                        [
                            10.549717582021849,
                            46.20552603838391
                        ],
                        [
                            10.550803615443682,
                            46.20680277222447
                        ],
                        [
                            10.551548723556,
                            46.20750395362349
                        ],
                        [
                            10.552823033791103,
                            46.20856722767368
                        ],
                        [
                            10.554302625452818,
                            46.209617683306554
                        ],
                        [
                            10.55498659448413,
                            46.210008463650794
                        ],
                        [
                            10.558194782945009,
                            46.21170536330981
                        ],
                        [
                            10.568061270395823,
                            46.220184966306846
                        ],
                        [
                            10.570405089606343,
                            46.223208872593034
                        ],
                        [
                            10.57074825631066,
                            46.22422182529757
                        ],
                        [
                            10.571061573718794,
                            46.22552232089568
                        ],
                        [
                            10.571076246897778,
                            46.2257910529264
                        ],
                        [
                            10.5707687123669,
                            46.22673071325415
                        ],
                        [
                            10.570514510416412,
                            46.227193230782596
                        ],
                        [
                            10.56891131716188,
                            46.2300548930193
                        ],
                        [
                            10.5681749149407,
                            46.2312170779604
                        ],
                        [
                            10.567833701354349,
                            46.23177993899176
                        ],
                        [
                            10.567648815259378,
                            46.23227201919744
                        ],
                        [
                            10.5680189032073,
                            46.2332977099507
                        ],
                        [
                            10.568220763365368,
                            46.23372103125529
                        ],
                        [
                            10.570105187394688,
                            46.23546559165831
                        ],
                        [
                            10.570689361727755,
                            46.23589712571129
                        ],
                        [
                            10.572628259145278,
                            46.23672728429604
                        ],
                        [
                            10.573654291141475,
                            46.23710954308053
                        ],
                        [
                            10.574047746808827,
                            46.23712233447385
                        ],
                        [
                            10.57458889170376,
                            46.23699629827026
                        ],
                        [
                            10.575042599538081,
                            46.236913314017286
                        ],
                        [
                            10.575467758709786,
                            46.23697953471784
                        ],
                        [
                            10.576097551817956,
                            46.23713599797494
                        ],
                        [
                            10.577974360189945,
                            46.23797227069725
                        ],
                        [
                            10.579928614793923,
                            46.239120449683924
                        ],
                        [
                            10.580746929802702,
                            46.23962557266421
                        ],
                        [
                            10.58120036291976,
                            46.23999788691715
                        ],
                        [
                            10.581481253146018,
                            46.24029550807504
                        ],
                        [
                            10.58573095334106,
                            46.24533910458964
                        ],
                        [
                            10.585694798988335,
                            46.24793816445581
                        ],
                        [
                            10.582805271024844,
                            46.25549269812798
                        ],
                        [
                            10.578304052512435,
                            46.26630292271024
                        ],
                        [
                            10.576369775700428,
                            46.272116822499676
                        ],
                        [
                            10.576166660365603,
                            46.27414054260869
                        ],
                        [
                            10.576093115992684,
                            46.27460705494256
                        ],
                        [
                            10.575831613808118,
                            46.27528774172283
                        ],
                        [
                            10.575666174089603,
                            46.27568235635522
                        ],
                        [
                            10.575509541904877,
                            46.27586033770359
                        ],
                        [
                            10.575161312189964,
                            46.27610667129454
                        ],
                        [
                            10.574923990488811,
                            46.27626934849342
                        ],
                        [
                            10.574561954702844,
                            46.2764259851125
                        ],
                        [
                            10.57385379962545,
                            46.276534497825
                        ],
                        [
                            10.573018990397808,
                            46.27659990095688
                        ],
                        [
                            10.57230886014134,
                            46.27650203753971
                        ],
                        [
                            10.571624091449797,
                            46.27634048043979
                        ],
                        [
                            10.570976303961606,
                            46.27616003378806
                        ],
                        [
                            10.570531307092947,
                            46.27608488086563
                        ],
                        [
                            10.568824604091123,
                            46.277049639048826
                        ],
                        [
                            10.56034710693477,
                            46.282628548730635
                        ],
                        [
                            10.55972139666348,
                            46.28305150307559
                        ],
                        [
                            10.559907197362147,
                            46.28369734061029
                        ],
                        [
                            10.56001137490426,
                            46.28404266079062
                        ],
                        [
                            10.56334262980269,
                            46.28813111858348
                        ],
                        [
                            10.563682430142684,
                            46.28851867800527
                        ],
                        [
                            10.564024315883595,
                            46.28887644025258
                        ],
                        [
                            10.564299072544738,
                            46.289049426019965
                        ],
                        [
                            10.570927379081695,
                            46.293090649953065
                        ],
                        [
                            10.57759139400964,
                            46.29718732259592
                        ],
                        [
                            10.579572506115127,
                            46.29882844030935
                        ],
                        [
                            10.579201588329626,
                            46.300846376504836
                        ],
                        [
                            10.578884548139726,
                            46.301947318135845
                        ],
                        [
                            10.57603610158442,
                            46.30485147392145
                        ],
                        [
                            10.57190496869927,
                            46.307076324170836
                        ],
                        [
                            10.57138951287207,
                            46.30734443364317
                        ],
                        [
                            10.56643641679596,
                            46.31162764279563
                        ],
                        [
                            10.564859952082768,
                            46.31301450408677
                        ],
                        [
                            10.564510482309256,
                            46.3136242033985
                        ],
                        [
                            10.564111700478227,
                            46.31483024644854
                        ],
                        [
                            10.563666882523046,
                            46.32036667820145
                        ],
                        [
                            10.56365311703344,
                            46.32097372033448
                        ],
                        [
                            10.563926037395245,
                            46.3213998758182
                        ],
                        [
                            10.564459210499002,
                            46.32195741329506
                        ],
                        [
                            10.564910513361218,
                            46.32242393796295
                        ],
                        [
                            10.565154447721698,
                            46.32294238156182
                        ],
                        [
                            10.5654457496437,
                            46.323648569023035
                        ],
                        [
                            10.565620658695346,
                            46.32634336283813
                        ],
                        [
                            10.552340136507967,
                            46.33185962536444
                        ],
                        [
                            10.53684451431875,
                            46.33822041561987
                        ],
                        [
                            10.528382790154632,
                            46.34122091235195
                        ],
                        [
                            10.520040491311825,
                            46.34327802018377
                        ],
                        [
                            10.5157148159509,
                            46.34321786896404
                        ],
                        [
                            10.515733058999707,
                            46.34523417875402
                        ],
                        [
                            10.515799660796564,
                            46.34580348251922
                        ],
                        [
                            10.515934154219078,
                            46.34636263583535
                        ],
                        [
                            10.519241245559641,
                            46.35531339488167
                        ],
                        [
                            10.519472993635972,
                            46.35573940007033
                        ],
                        [
                            10.519496643524615,
                            46.35576202925889
                        ],
                        [
                            10.519872569450095,
                            46.35597555047464
                        ],
                        [
                            10.520395105321484,
                            46.35613400144341
                        ],
                        [
                            10.529049447612094,
                            46.35691920172261
                        ],
                        [
                            10.52968719307612,
                            46.356864535896335
                        ],
                        [
                            10.532825595264864,
                            46.35637840648255
                        ],
                        [
                            10.533045998896474,
                            46.3562569257318
                        ],
                        [
                            10.533511957032392,
                            46.355743426089646
                        ],
                        [
                            10.53379981966751,
                            46.35541114800338
                        ],
                        [
                            10.533979502951135,
                            46.35510481674872
                        ],
                        [
                            10.534056201681272,
                            46.35487681833747
                        ],
                        [
                            10.534176941851063,
                            46.354465609444745
                        ],
                        [
                            10.534254295684299,
                            46.35428535932487
                        ],
                        [
                            10.53433482536589,
                            46.354200377610255
                        ],
                        [
                            10.534540245996133,
                            46.35417091231591
                        ],
                        [
                            10.535939665491673,
                            46.35412163352368
                        ],
                        [
                            10.53659878065528,
                            46.35411185491672
                        ],
                        [
                            10.53770075697312,
                            46.354125478149996
                        ],
                        [
                            10.538758709399639,
                            46.35432228655305
                        ],
                        [
                            10.539181418274145,
                            46.35443413004238
                        ],
                        [
                            10.539237979867721,
                            46.35445165999174
                        ],
                        [
                            10.539414230099627,
                            46.35452151043745
                        ],
                        [
                            10.539890503160848,
                            46.3547118798452
                        ],
                        [
                            10.539986423659279,
                            46.354753524691915
                        ],
                        [
                            10.541016432908092,
                            46.35523388317044
                        ],
                        [
                            10.541118597174412,
                            46.355286678419304
                        ],
                        [
                            10.541260226241603,
                            46.35536760722729
                        ],
                        [
                            10.541527711336093,
                            46.35552346884219
                        ],
                        [
                            10.542808677560156,
                            46.356280370796405
                        ],
                        [
                            10.542940643774626,
                            46.35637063574292
                        ],
                        [
                            10.543201417702685,
                            46.35655754016215
                        ],
                        [
                            10.543250063882144,
                            46.35666937184286
                        ],
                        [
                            10.543934420978115,
                            46.35886586595272
                        ],
                        [
                            10.54360690955655,
                            46.359301525335475
                        ],
                        [
                            10.542319463181537,
                            46.36061037497895
                        ],
                        [
                            10.54663977780516,
                            46.366425612413956
                        ],
                        [
                            10.562388039764837,
                            46.375520029299686
                        ],
                        [
                            10.56241689617918,
                            46.37553585368246
                        ],
                        [
                            10.566690129886751,
                            46.37777194664465
                        ],
                        [
                            10.567043526296942,
                            46.37792846085762
                        ],
                        [
                            10.56737178926297,
                            46.37789393377975
                        ],
                        [
                            10.570017665275858,
                            46.37712469383178
                        ],
                        [
                            10.570212439328023,
                            46.37706521242131
                        ],
                        [
                            10.578584249110211,
                            46.37675967549993
                        ],
                        [
                            10.598055207982073,
                            46.37738581019146
                        ],
                        [
                            10.607379470468395,
                            46.37929736181832
                        ],
                        [
                            10.60746895009179,
                            46.37937802993572
                        ],
                        [
                            10.607718629878589,
                            46.37967934787159
                        ],
                        [
                            10.609114042350724,
                            46.38206682665926
                        ],
                        [
                            10.609156892543549,
                            46.38222583239933
                        ],
                        [
                            10.609133870059024,
                            46.3823917196146
                        ],
                        [
                            10.613500444437216,
                            46.38792231552696
                        ],
                        [
                            10.621151261346116,
                            46.394986454832036
                        ],
                        [
                            10.62639840752381,
                            46.39903147556599
                        ],
                        [
                            10.629392891930417,
                            46.40087809007826
                        ],
                        [
                            10.630461791644924,
                            46.402550825532785
                        ],
                        [
                            10.62870117255478,
                            46.40764253220962
                        ],
                        [
                            10.624450997270493,
                            46.409210464021506
                        ],
                        [
                            10.621066059818451,
                            46.41374942169827
                        ],
                        [
                            10.619058845987288,
                            46.418139569286176
                        ],
                        [
                            10.617528207998337,
                            46.42370471964041
                        ],
                        [
                            10.616445459618431,
                            46.42779149719094
                        ],
                        [
                            10.616343867003902,
                            46.42825633884426
                        ],
                        [
                            10.616242032922418,
                            46.428779851942224
                        ],
                        [
                            10.616222885415144,
                            46.429068115685126
                        ],
                        [
                            10.616223993258819,
                            46.42927058831797
                        ],
                        [
                            10.616244886914597,
                            46.4296949512868
                        ],
                        [
                            10.616462560566035,
                            46.42996794506304
                        ],
                        [
                            10.61686450459145,
                            46.43021024158076
                        ],
                        [
                            10.617137293636784,
                            46.43037100155562
                        ],
                        [
                            10.617304359540352,
                            46.430516306980344
                        ],
                        [
                            10.61959763004006,
                            46.434509198614585
                        ],
                        [
                            10.619688330648966,
                            46.43482930412766
                        ],
                        [
                            10.619720178193782,
                            46.435030475317795
                        ],
                        [
                            10.619710746254253,
                            46.435206095749756
                        ],
                        [
                            10.61969815162212,
                            46.43543194043757
                        ],
                        [
                            10.619677969959442,
                            46.435630272109286
                        ],
                        [
                            10.619643737094595,
                            46.43585504181746
                        ],
                        [
                            10.61952856570207,
                            46.43630666021156
                        ],
                        [
                            10.617990429187275,
                            46.43937499141182
                        ],
                        [
                            10.616854351623743,
                            46.44162769817197
                        ],
                        [
                            10.616624207777557,
                            46.44203204017791
                        ],
                        [
                            10.616593020046386,
                            46.44251754266265
                        ],
                        [
                            10.616566332106455,
                            46.44299075252641
                        ],
                        [
                            10.616621350839173,
                            46.44363680695277
                        ],
                        [
                            10.616760685051755,
                            46.44389578661157
                        ],
                        [
                            10.617302388393322,
                            46.44440407719978
                        ],
                        [
                            10.617325172179324,
                            46.444424832503756
                        ],
                        [
                            10.618501944241935,
                            46.44546057760336
                        ],
                        [
                            10.61937659819856,
                            46.44614455067144
                        ],
                        [
                            10.621560808138039,
                            46.44778441209274
                        ],
                        [
                            10.621787366597744,
                            46.44793991418868
                        ],
                        [
                            10.621836982320522,
                            46.447960643498355
                        ],
                        [
                            10.62746013413035,
                            46.446943807992426
                        ],
                        [
                            10.638824603331784,
                            46.44607841220805
                        ],
                        [
                            10.639085590503244,
                            46.4462308765942
                        ],
                        [
                            10.639352121833301,
                            46.446314398772586
                        ],
                        [
                            10.639451536661056,
                            46.44634318126791
                        ],
                        [
                            10.639544356730054,
                            46.44636991448308
                        ],
                        [
                            10.639639068059225,
                            46.446397191090824
                        ],
                        [
                            10.639978707966401,
                            46.44648744465367
                        ],
                        [
                            10.645227686809799,
                            46.44782778376929
                        ],
                        [
                            10.666076461478225,
                            46.45200328502327
                        ],
                        [
                            10.66793640570856,
                            46.45228279392153
                        ],
                        [
                            10.668327974276329,
                            46.452313079640305
                        ],
                        [
                            10.66856279745535,
                            46.45232765546206
                        ],
                        [
                            10.669200830946687,
                            46.45232734003022
                        ],
                        [
                            10.684643595663356,
                            46.45147086601842
                        ],
                        [
                            10.689284502226892,
                            46.45375133878669
                        ],
                        [
                            10.689861959286587,
                            46.454524883906785
                        ],
                        [
                            10.691690718041926,
                            46.45580595988004
                        ],
                        [
                            10.695673011908035,
                            46.4582016465523
                        ],
                        [
                            10.695936689140403,
                            46.45830572920219
                        ],
                        [
                            10.696277351492943,
                            46.458372670813155
                        ],
                        [
                            10.69878773857026,
                            46.45869538908738
                        ],
                        [
                            10.69910098537585,
                            46.45871773502405
                        ],
                        [
                            10.71664279946095,
                            46.461623626486805
                        ],
                        [
                            10.71670900873914,
                            46.46207261959293
                        ],
                        [
                            10.716914700042954,
                            46.46307525498429
                        ],
                        [
                            10.718060018287996,
                            46.46486025126298
                        ],
                        [
                            10.71900159387632,
                            46.466223060614475
                        ],
                        [
                            10.719214698458533,
                            46.466372853377685
                        ],
                        [
                            10.722393933974162,
                            46.46847594220249
                        ],
                        [
                            10.727081944114609,
                            46.47119469903674
                        ],
                        [
                            10.736128035467729,
                            46.47848293275564
                        ],
                        [
                            10.738756877872088,
                            46.48125990262565
                        ],
                        [
                            10.739091884379949,
                            46.481551805552236
                        ],
                        [
                            10.742829469567567,
                            46.483951815383186
                        ],
                        [
                            10.743333238352147,
                            46.484223130246065
                        ],
                        [
                            10.744730424047981,
                            46.484847659044064
                        ],
                        [
                            10.744905920879505,
                            46.48491912404639
                        ],
                        [
                            10.74523465455659,
                            46.48501310295506
                        ],
                        [
                            10.757995855095585,
                            46.486243408981245
                        ],
                        [
                            10.762426365138921,
                            46.486018364767325
                        ],
                        [
                            10.764977293405861,
                            46.485957197067485
                        ],
                        [
                            10.77004075456213,
                            46.47895295216609
                        ],
                        [
                            10.777974782726126,
                            46.472152969285034
                        ],
                        [
                            10.781390956389293,
                            46.46707701337524
                        ],
                        [
                            10.78545003282156,
                            46.46016488009561
                        ],
                        [
                            10.78966576310189,
                            46.4532951353998
                        ],
                        [
                            10.78973303108599,
                            46.45318581432098
                        ],
                        [
                            10.789900659523965,
                            46.45291346580179
                        ],
                        [
                            10.790174315100947,
                            46.452522191694776
                        ],
                        [
                            10.790460669720384,
                            46.4521217208933
                        ],
                        [
                            10.791357664147332,
                            46.45099615173288
                        ],
                        [
                            10.791687115964935,
                            46.450608541872185
                        ],
                        [
                            10.797070119658557,
                            46.44483618968581
                        ],
                        [
                            10.797579377985528,
                            46.44448619851307
                        ],
                        [
                            10.798371958357913,
                            46.44404173957368
                        ],
                        [
                            10.799100932702904,
                            46.44364327978473
                        ],
                        [
                            10.800380535227276,
                            46.44296614835808
                        ],
                        [
                            10.800625986159071,
                            46.44290829105957
                        ],
                        [
                            10.801261214038792,
                            46.44282628803539
                        ],
                        [
                            10.804749319582674,
                            46.442402284351104
                        ],
                        [
                            10.805385710621396,
                            46.44235623946931
                        ],
                        [
                            10.807759549094248,
                            46.442197336689645
                        ],
                        [
                            10.80915384987287,
                            46.44213467766401
                        ],
                        [
                            10.809428593049105,
                            46.44217532653796
                        ],
                        [
                            10.80989712835171,
                            46.44256390821349
                        ],
                        [
                            10.810471848162127,
                            46.443013794812785
                        ],
                        [
                            10.810776784494816,
                            46.44317995863385
                        ],
                        [
                            10.811343764496938,
                            46.443395972340795
                        ],
                        [
                            10.811813400332918,
                            46.443424528724435
                        ],
                        [
                            10.81623772177041,
                            46.44296734007344
                        ],
                        [
                            10.821060648722943,
                            46.442245303143416
                        ],
                        [
                            10.822239648224585,
                            46.44180086489893
                        ],
                        [
                            10.826438498702753,
                            46.44044689423967
                        ],
                        [
                            10.835067869112319,
                            46.43884174143596
                        ],
                        [
                            10.838526988027535,
                            46.43911915764618
                        ],
                        [
                            10.839062250118012,
                            46.43916455003071
                        ],
                        [
                            10.839977270368058,
                            46.439275826135706
                        ],
                        [
                            10.840671403953401,
                            46.4393996484778
                        ],
                        [
                            10.84094766981643,
                            46.43948520006537
                        ],
                        [
                            10.8573546914879,
                            46.436924876736164
                        ],
                        [
                            10.861324055865436,
                            46.43613133397988
                        ],
                        [
                            10.865619924574581,
                            46.43804127634798
                        ],
                        [
                            10.874757615951,
                            46.44560464330327
                        ],
                        [
                            10.880623819106578,
                            46.45038118300431
                        ],
                        [
                            10.880744430590799,
                            46.45045621451789
                        ],
                        [
                            10.880903077447428,
                            46.45052560004966
                        ],
                        [
                            10.882816524850192,
                            46.45098864013595
                        ],
                        [
                            10.88363257407096,
                            46.45115551270186
                        ],
                        [
                            10.884454521595922,
                            46.450809114043494
                        ],
                        [
                            10.884959221449835,
                            46.44993744007126
                        ],
                        [
                            10.88540160802596,
                            46.4492005312713
                        ],
                        [
                            10.885873750871673,
                            46.44854476050404
                        ],
                        [
                            10.886408767434283,
                            46.44782495029049
                        ],
                        [
                            10.887158760805342,
                            46.446921589863074
                        ],
                        [
                            10.887274014016606,
                            46.4468656863442
                        ],
                        [
                            10.891462869496754,
                            46.44492369698354
                        ],
                        [
                            10.891965259555647,
                            46.44472719503519
                        ],
                        [
                            10.892223011488484,
                            46.444650924019896
                        ],
                        [
                            10.89677645754138,
                            46.44417948066279
                        ],
                        [
                            10.897458960079861,
                            46.444125787737065
                        ],
                        [
                            10.897646377930815,
                            46.444111042964316
                        ],
                        [
                            10.911694331460223,
                            46.44374201010712
                        ],
                        [
                            10.911994540071294,
                            46.443763992276544
                        ],
                        [
                            10.912465787855377,
                            46.44383711291064
                        ],
                        [
                            10.913044293138537,
                            46.44399842771803
                        ],
                        [
                            10.914617577459994,
                            46.44468307536472
                        ],
                        [
                            10.915148150505846,
                            46.44496218256127
                        ],
                        [
                            10.919372508180219,
                            46.4473572915198
                        ],
                        [
                            10.92332835009451,
                            46.449337806955874
                        ],
                        [
                            10.928967529538875,
                            46.45212770432643
                        ],
                        [
                            10.93220833673365,
                            46.453557956381864
                        ],
                        [
                            10.930978285666521,
                            46.45707066266876
                        ],
                        [
                            10.930899660586004,
                            46.45852995400618
                        ],
                        [
                            10.930916319125322,
                            46.458617299029406
                        ],
                        [
                            10.931775016291553,
                            46.460450131452866
                        ],
                        [
                            10.935227000772311,
                            46.46488265111732
                        ],
                        [
                            10.937180535783412,
                            46.46708152106568
                        ],
                        [
                            10.937298959725064,
                            46.467115511252835
                        ],
                        [
                            10.93761009277377,
                            46.46707424210557
                        ],
                        [
                            10.9385653651065,
                            46.4668330532785
                        ],
                        [
                            10.939120298583479,
                            46.4666886474854
                        ],
                        [
                            10.944239928945743,
                            46.46651588275175
                        ],
                        [
                            10.95577297505576,
                            46.47015790706723
                        ],
                        [
                            10.956234381598833,
                            46.47031201084441
                        ],
                        [
                            10.956563712393107,
                            46.47044096485628
                        ],
                        [
                            10.956694051731784,
                            46.470518287684406
                        ],
                        [
                            10.956764447089865,
                            46.47056393259919
                        ],
                        [
                            10.957165936500132,
                            46.47086305767229
                        ],
                        [
                            10.957556030444122,
                            46.47120737125058
                        ],
                        [
                            10.958109774624132,
                            46.47175587228704
                        ],
                        [
                            10.959650979247506,
                            46.473322433007176
                        ],
                        [
                            10.960315911784534,
                            46.4740144002654
                        ],
                        [
                            10.962692742751377,
                            46.47749115995678
                        ],
                        [
                            10.962802859246192,
                            46.47771001175065
                        ],
                        [
                            10.962839554494652,
                            46.47781082365036
                        ],
                        [
                            10.963479620128995,
                            46.47980859627337
                        ],
                        [
                            10.9637363396338,
                            46.48187413139566
                        ],
                        [
                            10.963782526010165,
                            46.48207134200334
                        ],
                        [
                            10.974538915923466,
                            46.48388169815986
                        ],
                        [
                            10.9751079215353,
                            46.48397320031135
                        ],
                        [
                            10.97574821994617,
                            46.48402513552345
                        ],
                        [
                            10.97866601980004,
                            46.48394478083182
                        ],
                        [
                            10.988512298908145,
                            46.48355185509846
                        ],
                        [
                            10.995375281487151,
                            46.48061535014532
                        ],
                        [
                            11.005358559769554,
                            46.47704485943769
                        ],
                        [
                            11.005596768661977,
                            46.47693801234884
                        ],
                        [
                            11.005858811790745,
                            46.47680406739996
                        ],
                        [
                            11.005980257073565,
                            46.47668641616172
                        ],
                        [
                            11.008821478120886,
                            46.47240131061878
                        ],
                        [
                            11.011186327858928,
                            46.47019445359795
                        ],
                        [
                            11.01927036828851,
                            46.46576148340627
                        ],
                        [
                            11.020487344010565,
                            46.46554842907232
                        ],
                        [
                            11.022632721687929,
                            46.465231361017764
                        ],
                        [
                            11.029201242329986,
                            46.462027402720125
                        ],
                        [
                            11.03047154349248,
                            46.46084248358108
                        ],
                        [
                            11.030655768171771,
                            46.460641217418626
                        ],
                        [
                            11.031006616350268,
                            46.459897826017354
                        ],
                        [
                            11.0310768660091,
                            46.45962433017683
                        ],
                        [
                            11.031535828183952,
                            46.45799175024073
                        ],
                        [
                            11.033787526515457,
                            46.454439755449854
                        ],
                        [
                            11.033825616216125,
                            46.4543989319628
                        ],
                        [
                            11.033920496418741,
                            46.454297327054306
                        ],
                        [
                            11.041239306833052,
                            46.44723618463331
                        ],
                        [
                            11.041382369265168,
                            46.44713735263639
                        ],
                        [
                            11.04145951367626,
                            46.447084114869206
                        ],
                        [
                            11.042083319811223,
                            46.446659719217244
                        ],
                        [
                            11.042418954419281,
                            46.44654708524222
                        ],
                        [
                            11.046046695933088,
                            46.446412104818286
                        ],
                        [
                            11.0471747368792,
                            46.446382639796646
                        ],
                        [
                            11.047310220908455,
                            46.44640304281204
                        ],
                        [
                            11.047505522249113,
                            46.446458788947
                        ],
                        [
                            11.047582296769052,
                            46.446498020648264
                        ],
                        [
                            11.048991594130234,
                            46.44944903707157
                        ],
                        [
                            11.049799033001714,
                            46.44964195590291
                        ],
                        [
                            11.053979823272059,
                            46.4497240526784
                        ],
                        [
                            11.054095013531771,
                            46.44969148323876
                        ],
                        [
                            11.054187646973041,
                            46.44966131697308
                        ],
                        [
                            11.064557137720202,
                            46.4462766023331
                        ],
                        [
                            11.065045036856677,
                            46.44608324675299
                        ],
                        [
                            11.065249234353297,
                            46.44570861795785
                        ],
                        [
                            11.065423466930065,
                            46.44534043319699
                        ],
                        [
                            11.06552223281912,
                            46.44508333610529
                        ],
                        [
                            11.065661528637737,
                            46.444794717837205
                        ],
                        [
                            11.065831264573772,
                            46.4444767450501
                        ],
                        [
                            11.066165042085277,
                            46.44412753135983
                        ],
                        [
                            11.066593834970222,
                            46.44372005434535
                        ],
                        [
                            11.06706909430409,
                            46.443361998341416
                        ],
                        [
                            11.067551746542934,
                            46.44310921382958
                        ],
                        [
                            11.071730051620925,
                            46.44179428172556
                        ],
                        [
                            11.072672047208288,
                            46.44152145755573
                        ],
                        [
                            11.072821381416203,
                            46.4414941801541
                        ],
                        [
                            11.073108435255822,
                            46.44160382771295
                        ],
                        [
                            11.073182261198859,
                            46.44163205730613
                        ],
                        [
                            11.073289942258722,
                            46.44167656664787
                        ],
                        [
                            11.07485361015059,
                            46.44234692835682
                        ],
                        [
                            11.074952389412408,
                            46.44240553769257
                        ],
                        [
                            11.075023245808218,
                            46.44252568052941
                        ],
                        [
                            11.075142482723239,
                            46.44278973787883
                        ],
                        [
                            11.07539513470127,
                            46.44342492439749
                        ],
                        [
                            11.076120293892888,
                            46.445435541699304
                        ],
                        [
                            11.076274786025339,
                            46.44592011731176
                        ],
                        [
                            11.074690576270728,
                            46.45482334150326
                        ],
                        [
                            11.074620714623567,
                            46.45501056559917
                        ],
                        [
                            11.074560879315127,
                            46.455131594211004
                        ],
                        [
                            11.07046026854386,
                            46.46317250975176
                        ],
                        [
                            11.067964969065072,
                            46.4653307493594
                        ],
                        [
                            11.067075080520082,
                            46.467379279946876
                        ],
                        [
                            11.066464793682325,
                            46.46994265981212
                        ],
                        [
                            11.065987922575054,
                            46.47362167183464
                        ],
                        [
                            11.064238597751332,
                            46.479695750347055
                        ],
                        [
                            11.061963198956523,
                            46.48623532081836
                        ],
                        [
                            11.058139199763797,
                            46.48989683665119
                        ],
                        [
                            11.058071716486,
                            46.48996461982755
                        ],
                        [
                            11.058024324312203,
                            46.490012226314235
                        ],
                        [
                            11.056749306210971,
                            46.49135220018029
                        ],
                        [
                            11.0563353499324,
                            46.49185527758169
                        ],
                        [
                            11.056164716733793,
                            46.49210944072509
                        ],
                        [
                            11.055980861248479,
                            46.492423415949354
                        ],
                        [
                            11.055725850736458,
                            46.49285892099537
                        ],
                        [
                            11.055396425592049,
                            46.493435876644504
                        ],
                        [
                            11.049488058455863,
                            46.50436164808671
                        ],
                        [
                            11.049433152677775,
                            46.50452942994751
                        ],
                        [
                            11.049399511428232,
                            46.50467367043143
                        ],
                        [
                            11.049005955067274,
                            46.507041789795494
                        ],
                        [
                            11.034600957085248,
                            46.513778739181355
                        ],
                        [
                            11.034779169332161,
                            46.51408062319779
                        ],
                        [
                            11.044092702415059,
                            46.516815301009615
                        ],
                        [
                            11.044195906519468,
                            46.5168215017693
                        ],
                        [
                            11.044278722765329,
                            46.51682646318708
                        ],
                        [
                            11.04473020414537,
                            46.51684772150685
                        ],
                        [
                            11.050903179680978,
                            46.51660996988945
                        ],
                        [
                            11.053761768312356,
                            46.51640683565846
                        ],
                        [
                            11.064927155839708,
                            46.52259862931761
                        ],
                        [
                            11.066560440571621,
                            46.52406679654372
                        ],
                        [
                            11.066597249995043,
                            46.5240984217008
                        ],
                        [
                            11.066686206268953,
                            46.524174765788125
                        ],
                        [
                            11.080298897447369,
                            46.531077492628825
                        ],
                        [
                            11.080433956034314,
                            46.53111676293837
                        ],
                        [
                            11.080636647267314,
                            46.53117563337357
                        ],
                        [
                            11.080794463718922,
                            46.531197413783566
                        ],
                        [
                            11.081072872023197,
                            46.53123581869131
                        ],
                        [
                            11.082425766291676,
                            46.531374584949226
                        ],
                        [
                            11.08648364305617,
                            46.5209521535025
                        ],
                        [
                            11.086359907401294,
                            46.51548420331611
                        ],
                        [
                            11.088588587549669,
                            46.513091794985804
                        ],
                        [
                            11.088819386615622,
                            46.51282110507888
                        ],
                        [
                            11.088875000473504,
                            46.512683199640875
                        ],
                        [
                            11.08907296093433,
                            46.5118552898572
                        ],
                        [
                            11.089091505124744,
                            46.51146648536058
                        ],
                        [
                            11.088945894176481,
                            46.51067996653329
                        ],
                        [
                            11.088824381589651,
                            46.51037765788112
                        ],
                        [
                            11.0885335746144,
                            46.50984007715647
                        ],
                        [
                            11.08842440744213,
                            46.509457844392564
                        ],
                        [
                            11.088302099778906,
                            46.50894962685483
                        ],
                        [
                            11.088284597384744,
                            46.50880349741218
                        ],
                        [
                            11.088231936962806,
                            46.50836316788125
                        ],
                        [
                            11.088209556582632,
                            46.5078058515204
                        ],
                        [
                            11.08823693443944,
                            46.506735181153054
                        ],
                        [
                            11.0883366294255,
                            46.50433368376712
                        ],
                        [
                            11.088361076015484,
                            46.50392487516094
                        ],
                        [
                            11.088388447690283,
                            46.50373773801704
                        ],
                        [
                            11.088405355405076,
                            46.50362251453848
                        ],
                        [
                            11.088475849360352,
                            46.50314294937779
                        ],
                        [
                            11.08849113273517,
                            46.50304078913743
                        ],
                        [
                            11.08928041705073,
                            46.50203309513211
                        ],
                        [
                            11.089447396892556,
                            46.501847885667736
                        ],
                        [
                            11.103914053945164,
                            46.49635834874336
                        ],
                        [
                            11.108989648708002,
                            46.49716060666739
                        ],
                        [
                            11.109512917854364,
                            46.49738044524346
                        ],
                        [
                            11.109946745255282,
                            46.49748957590845
                        ],
                        [
                            11.11049875737403,
                            46.4975962443565
                        ],
                        [
                            11.110850035336084,
                            46.49761653489799
                        ],
                        [
                            11.111101586582024,
                            46.497598620018536
                        ],
                        [
                            11.111326179915721,
                            46.49750897125797
                        ],
                        [
                            11.122195613462335,
                            46.49082784182343
                        ],
                        [
                            11.122459328810782,
                            46.4906564665581
                        ],
                        [
                            11.125475406080291,
                            46.4867170144341
                        ],
                        [
                            11.1274607815603,
                            46.484002634576804
                        ],
                        [
                            11.129678620462217,
                            46.48162936049757
                        ],
                        [
                            11.15029350352775,
                            46.48560043184896
                        ],
                        [
                            11.150705500195448,
                            46.485682681998895
                        ],
                        [
                            11.151008149205536,
                            46.48575798095352
                        ],
                        [
                            11.153464247997626,
                            46.48637773284069
                        ],
                        [
                            11.15376145247963,
                            46.48645344385635
                        ],
                        [
                            11.154928700316175,
                            46.48675513518491
                        ],
                        [
                            11.155508500980693,
                            46.48691969680839
                        ],
                        [
                            11.160011185447814,
                            46.4886706756868
                        ],
                        [
                            11.160145364932825,
                            46.48872664163751
                        ],
                        [
                            11.160442723045294,
                            46.48891451789008
                        ],
                        [
                            11.160513550830363,
                            46.48902098108663
                        ],
                        [
                            11.160866495771533,
                            46.4895814958333
                        ],
                        [
                            11.16134759635026,
                            46.49058065718848
                        ],
                        [
                            11.172890086855181,
                            46.49735812780164
                        ],
                        [
                            11.175271193128813,
                            46.49774116823366
                        ],
                        [
                            11.17567901693588,
                            46.49783690402484
                        ],
                        [
                            11.176319265323366,
                            46.498000219626554
                        ],
                        [
                            11.178391650337415,
                            46.49869873507516
                        ],
                        [
                            11.178606245782781,
                            46.498771139648134
                        ],
                        [
                            11.178890277689678,
                            46.49898199687011
                        ],
                        [
                            11.179069253413461,
                            46.499120513105595
                        ],
                        [
                            11.179135387434647,
                            46.499187025343026
                        ],
                        [
                            11.179171648532934,
                            46.49922443161342
                        ],
                        [
                            11.179515597286118,
                            46.4996077008401
                        ],
                        [
                            11.18298565309394,
                            46.5036692199927
                        ],
                        [
                            11.187084975607835,
                            46.508728587849255
                        ],
                        [
                            11.18983831115406,
                            46.50687296091178
                        ],
                        [
                            11.198256781971411,
                            46.50225400471894
                        ],
                        [
                            11.208304419503278,
                            46.49584339002066
                        ],
                        [
                            11.208695405864681,
                            46.49557387604721
                        ],
                        [
                            11.208909755980608,
                            46.495386202433416
                        ],
                        [
                            11.209095080484653,
                            46.495216126986655
                        ],
                        [
                            11.209422071680574,
                            46.49490560598978
                        ],
                        [
                            11.209465177156144,
                            46.49486275058806
                        ],
                        [
                            11.209617804565458,
                            46.49469965560822
                        ],
                        [
                            11.210019644120658,
                            46.49415428179078
                        ],
                        [
                            11.210093585233823,
                            46.49404934720868
                        ],
                        [
                            11.21017568396675,
                            46.49391554607404
                        ],
                        [
                            11.21025561404601,
                            46.49378522116749
                        ],
                        [
                            11.210487007020557,
                            46.49314625674894
                        ],
                        [
                            11.213025321087333,
                            46.480272368354456
                        ],
                        [
                            11.213060304582447,
                            46.48001068703759
                        ],
                        [
                            11.212987606326614,
                            46.47974635353979
                        ],
                        [
                            11.21223996435644,
                            46.477388264820306
                        ],
                        [
                            11.215016538703264,
                            46.47717906276624
                        ],
                        [
                            11.216633317055377,
                            46.47508154400439
                        ],
                        [
                            11.216857667276388,
                            46.4747872014947
                        ],
                        [
                            11.217144525797185,
                            46.474304798634705
                        ],
                        [
                            11.217740739071948,
                            46.473110588660134
                        ],
                        [
                            11.21785529982017,
                            46.47285737329461
                        ],
                        [
                            11.21881807339333,
                            46.46914423701159
                        ],
                        [
                            11.220355842602778,
                            46.462679463917915
                        ],
                        [
                            11.220421332791918,
                            46.46204820616549
                        ],
                        [
                            11.220402934674853,
                            46.46023508484534
                        ],
                        [
                            11.2203202410186,
                            46.45988119641885
                        ],
                        [
                            11.220158144626948,
                            46.45948807663424
                        ],
                        [
                            11.220031205673655,
                            46.45918031881837
                        ],
                        [
                            11.219095953788795,
                            46.45719599816995
                        ],
                        [
                            11.218663641559536,
                            46.45669139625535
                        ],
                        [
                            11.218540865032114,
                            46.456551914510236
                        ],
                        [
                            11.218438821951867,
                            46.45644825960856
                        ],
                        [
                            11.218306837776689,
                            46.45632482141916
                        ],
                        [
                            11.21817964050857,
                            46.45623729902433
                        ],
                        [
                            11.217986751655427,
                            46.45617804103914
                        ],
                        [
                            11.217694118355796,
                            46.45610721423643
                        ],
                        [
                            11.21317521367349,
                            46.45538030530956
                        ],
                        [
                            11.21277157288864,
                            46.45533865983489
                        ],
                        [
                            11.2123704689787,
                            46.45535816534998
                        ],
                        [
                            11.212957197678113,
                            46.45054744379551
                        ],
                        [
                            11.215821576190661,
                            46.44893371857441
                        ],
                        [
                            11.216971010355234,
                            46.44369050993111
                        ],
                        [
                            11.217761102786492,
                            46.441882286531296
                        ],
                        [
                            11.216492522231217,
                            46.43766119629031
                        ],
                        [
                            11.212448742233049,
                            46.433008729415555
                        ],
                        [
                            11.211996628138564,
                            46.43292718208871
                        ],
                        [
                            11.21129301848836,
                            46.432732186241104
                        ],
                        [
                            11.21037922609874,
                            46.432313897240256
                        ],
                        [
                            11.210250117366861,
                            46.43224078206707
                        ],
                        [
                            11.210202125432339,
                            46.43220951523716
                        ],
                        [
                            11.208019029361608,
                            46.43063159740312
                        ],
                        [
                            11.207724442619575,
                            46.430412136261744
                        ],
                        [
                            11.207656140092393,
                            46.430360975543266
                        ],
                        [
                            11.207621244203281,
                            46.43033482769977
                        ],
                        [
                            11.207568875779195,
                            46.4302955433894
                        ],
                        [
                            11.205031444901696,
                            46.426818870995646
                        ],
                        [
                            11.205031588358326,
                            46.42669773191101
                        ],
                        [
                            11.205096817339657,
                            46.42648018578124
                        ],
                        [
                            11.205161041290893,
                            46.42633200665196
                        ],
                        [
                            11.205243915910419,
                            46.426208606467
                        ],
                        [
                            11.205366509641696,
                            46.426085195935165
                        ],
                        [
                            11.205485770532748,
                            46.42600516024775
                        ],
                        [
                            11.206966681594531,
                            46.425230379602716
                        ],
                        [
                            11.207321047329922,
                            46.42506308005109
                        ],
                        [
                            11.207470170279098,
                            46.424992688729645
                        ],
                        [
                            11.20871929726668,
                            46.42411958455737
                        ],
                        [
                            11.21092931671098,
                            46.4222887587268
                        ],
                        [
                            11.211008845338709,
                            46.42220874857465
                        ],
                        [
                            11.211758020070693,
                            46.42091959666261
                        ],
                        [
                            11.211843751602693,
                            46.42064944250334
                        ],
                        [
                            11.211834746388107,
                            46.420085280469365
                        ],
                        [
                            11.211806266223526,
                            46.419954501673175
                        ],
                        [
                            11.21175558543595,
                            46.41972186286766
                        ],
                        [
                            11.211666299910819,
                            46.41945672854777
                        ],
                        [
                            11.211608518007097,
                            46.419368260448586
                        ],
                        [
                            11.211441408122544,
                            46.41915500556647
                        ],
                        [
                            11.209101857493438,
                            46.41648494622899
                        ],
                        [
                            11.207847804789912,
                            46.41644617573846
                        ],
                        [
                            11.207632640484324,
                            46.41650559414484
                        ],
                        [
                            11.207532345180917,
                            46.416533331420105
                        ],
                        [
                            11.20721182465583,
                            46.416644104571226
                        ],
                        [
                            11.209135282194776,
                            46.41485530925261
                        ],
                        [
                            11.209394354626248,
                            46.41337881089663
                        ],
                        [
                            11.209425176141913,
                            46.41328218141867
                        ],
                        [
                            11.209467751805791,
                            46.41314875047938
                        ],
                        [
                            11.209538371232643,
                            46.41293062821746
                        ],
                        [
                            11.209564010464316,
                            46.41289115085497
                        ],
                        [
                            11.209632287982163,
                            46.4127866638725
                        ],
                        [
                            11.209832974400326,
                            46.412552086048876
                        ],
                        [
                            11.21185468558788,
                            46.41042874194966
                        ],
                        [
                            11.212522964021531,
                            46.40974081274263
                        ],
                        [
                            11.2129893138728,
                            46.409286286866546
                        ],
                        [
                            11.21314075265793,
                            46.409153130910546
                        ],
                        [
                            11.213783016879615,
                            46.408481627848985
                        ],
                        [
                            11.214125362921171,
                            46.40810329441294
                        ],
                        [
                            11.215231063116049,
                            46.40681287463596
                        ],
                        [
                            11.215078085795234,
                            46.40444007643036
                        ],
                        [
                            11.214187254298217,
                            46.398463136477574
                        ],
                        [
                            11.212378361324207,
                            46.393498680036764
                        ],
                        [
                            11.2123606050318,
                            46.39346239354743
                        ],
                        [
                            11.212312766372742,
                            46.393364942714115
                        ],
                        [
                            11.209980325756781,
                            46.3896210527191
                        ],
                        [
                            11.20836088021369,
                            46.388185377221035
                        ],
                        [
                            11.206812617479693,
                            46.38752678954136
                        ],
                        [
                            11.206526504869595,
                            46.38423664980746
                        ],
                        [
                            11.201725109782927,
                            46.37453891208731
                        ],
                        [
                            11.202834314163553,
                            46.36966653500484
                        ],
                        [
                            11.205636448599352,
                            46.36716907832983
                        ],
                        [
                            11.202935504893825,
                            46.3658395772182
                        ],
                        [
                            11.202115289988374,
                            46.36544588920196
                        ],
                        [
                            11.201850411573327,
                            46.365324991985915
                        ],
                        [
                            11.201619248838943,
                            46.365275441733495
                        ],
                        [
                            11.200768932924388,
                            46.3651028167076
                        ],
                        [
                            11.200370555048998,
                            46.36503447918415
                        ],
                        [
                            11.20018001541965,
                            46.365006158158074
                        ],
                        [
                            11.199477262621773,
                            46.36490717905967
                        ],
                        [
                            11.197864591089889,
                            46.36477170300826
                        ],
                        [
                            11.197698198564742,
                            46.36476590510456
                        ],
                        [
                            11.197586347458966,
                            46.36477147662119
                        ],
                        [
                            11.197549047797398,
                            46.364773886680524
                        ],
                        [
                            11.197417935530591,
                            46.36481628945847
                        ],
                        [
                            11.197087864051944,
                            46.36501613540746
                        ],
                        [
                            11.19684681711355,
                            46.36516477344244
                        ],
                        [
                            11.196528395090157,
                            46.3653688911877
                        ],
                        [
                            11.194655583292242,
                            46.36526986901567
                        ],
                        [
                            11.194324147751317,
                            46.36519072994955
                        ],
                        [
                            11.193756860612963,
                            46.36502576157168
                        ],
                        [
                            11.193706189048381,
                            46.365004075524105
                        ],
                        [
                            11.193588104283416,
                            46.36492552477192
                        ],
                        [
                            11.193166912125916,
                            46.36457843837744
                        ],
                        [
                            11.19305653912032,
                            46.36445905426314
                        ],
                        [
                            11.192982032847643,
                            46.36430298339305
                        ],
                        [
                            11.19262416649963,
                            46.36323457762333
                        ],
                        [
                            11.191564945796683,
                            46.359794164116146
                        ],
                        [
                            11.191555943777605,
                            46.35965033183534
                        ],
                        [
                            11.191853331420928,
                            46.359001529412716
                        ],
                        [
                            11.192877227811682,
                            46.35592085780534
                        ],
                        [
                            11.196268626337027,
                            46.353507313401934
                        ],
                        [
                            11.198966837838357,
                            46.349558463459445
                        ],
                        [
                            11.203562204232139,
                            46.34237104010292
                        ],
                        [
                            11.203574120337171,
                            46.342323823501786
                        ],
                        [
                            11.203612231428922,
                            46.34209796452822
                        ],
                        [
                            11.203554599393524,
                            46.34183804555164
                        ],
                        [
                            11.203458537718065,
                            46.341668921609354
                        ],
                        [
                            11.197341428748755,
                            46.331706636435314
                        ],
                        [
                            11.197143060291443,
                            46.33141794974038
                        ],
                        [
                            11.195479285860161,
                            46.32954166146022
                        ],
                        [
                            11.195124928926454,
                            46.32924271756833
                        ],
                        [
                            11.194860428448258,
                            46.32904529820318
                        ],
                        [
                            11.19460801434563,
                            46.32890614064112
                        ],
                        [
                            11.194503931745004,
                            46.32885801749072
                        ],
                        [
                            11.184138197310991,
                            46.315368107255544
                        ],
                        [
                            11.178619413697575,
                            46.30706708240606
                        ],
                        [
                            11.169642783790326,
                            46.299394561329706
                        ],
                        [
                            11.16287818198736,
                            46.29117069347117
                        ],
                        [
                            11.159249735895264,
                            46.28965079552079
                        ],
                        [
                            11.15887754282925,
                            46.28952940536094
                        ],
                        [
                            11.158649673145032,
                            46.289455123788656
                        ],
                        [
                            11.158436542751556,
                            46.28939232210887
                        ],
                        [
                            11.158062136503757,
                            46.28928621467344
                        ],
                        [
                            11.157709322908246,
                            46.289270383123615
                        ],
                        [
                            11.15238406464305,
                            46.28941579704768
                        ],
                        [
                            11.143671665425247,
                            46.28839154029066
                        ],
                        [
                            11.141310256141598,
                            46.28634778785507
                        ],
                        [
                            11.141079866322402,
                            46.28614238333535
                        ],
                        [
                            11.140891245564527,
                            46.285973199188625
                        ],
                        [
                            11.140612736833903,
                            46.28565387548092
                        ],
                        [
                            11.13908251873291,
                            46.28389647766995
                        ],
                        [
                            11.139001551883672,
                            46.28373094095936
                        ],
                        [
                            11.138953644715295,
                            46.28363290593361
                        ],
                        [
                            11.138810635416224,
                            46.28333005903521
                        ],
                        [
                            11.13885227024688,
                            46.28331578499072
                        ],
                        [
                            11.14581838739649,
                            46.28171460729052
                        ],
                        [
                            11.14966376139462,
                            46.279977831747836
                        ],
                        [
                            11.149775735283557,
                            46.27991576180173
                        ],
                        [
                            11.149969266732226,
                            46.27980221098641
                        ],
                        [
                            11.150189264950884,
                            46.279615501650014
                        ],
                        [
                            11.150668919731153,
                            46.27903764513056
                        ],
                        [
                            11.152773745589725,
                            46.27563028364947
                        ],
                        [
                            11.15581812016084,
                            46.271557846190966
                        ],
                        [
                            11.159833070003119,
                            46.268124987843954
                        ],
                        [
                            11.167137016413971,
                            46.26214515633165
                        ],
                        [
                            11.174624253581742,
                            46.25925503338531
                        ],
                        [
                            11.174896501942303,
                            46.25922344489617
                        ],
                        [
                            11.190950800491882,
                            46.25747497366273
                        ],
                        [
                            11.191535935673011,
                            46.25748293151905
                        ],
                        [
                            11.191637201475519,
                            46.25748431505095
                        ],
                        [
                            11.19294724804817,
                            46.25751317733875
                        ],
                        [
                            11.193514216080638,
                            46.25757880237195
                        ],
                        [
                            11.194157270384663,
                            46.25771945300194
                        ],
                        [
                            11.198283005002128,
                            46.258927191074484
                        ],
                        [
                            11.20161603895891,
                            46.256297982933184
                        ],
                        [
                            11.20237839202023,
                            46.25560463313254
                        ],
                        [
                            11.199532417959658,
                            46.25383155643739
                        ],
                        [
                            11.188240956728125,
                            46.252756814032004
                        ],
                        [
                            11.187966184787404,
                            46.25278007024177
                        ],
                        [
                            11.187319922613385,
                            46.25280144838375
                        ],
                        [
                            11.187083034535057,
                            46.2527969757731
                        ],
                        [
                            11.18641593364322,
                            46.25277810620638
                        ],
                        [
                            11.186132827759156,
                            46.25272065584391
                        ],
                        [
                            11.185898422947432,
                            46.25261714071161
                        ],
                        [
                            11.185557453728888,
                            46.25244365691053
                        ],
                        [
                            11.185352113227491,
                            46.25233084287721
                        ],
                        [
                            11.185066773284134,
                            46.25217404132201
                        ],
                        [
                            11.184546146125069,
                            46.251886983945056
                        ],
                        [
                            11.184271923035551,
                            46.25172067875539
                        ],
                        [
                            11.184107367483657,
                            46.25162087125881
                        ],
                        [
                            11.183588207519632,
                            46.25128878304016
                        ],
                        [
                            11.183517216654044,
                            46.25120660661521
                        ],
                        [
                            11.183450563253732,
                            46.25112943329812
                        ],
                        [
                            11.182707423399407,
                            46.2501805912818
                        ],
                        [
                            11.182513620702238,
                            46.24987378497916
                        ],
                        [
                            11.182417663097292,
                            46.249714866338685
                        ],
                        [
                            11.182288048944592,
                            46.249500093218785
                        ],
                        [
                            11.182161827835529,
                            46.24929017917908
                        ],
                        [
                            11.182055321543876,
                            46.24911302288884
                        ],
                        [
                            11.176171107231982,
                            46.23855553405894
                        ],
                        [
                            11.174591895908733,
                            46.23494815943821
                        ],
                        [
                            11.174638171751425,
                            46.23266729683924
                        ],
                        [
                            11.176059599237211,
                            46.231441035069004
                        ],
                        [
                            11.183654656017815,
                            46.22579782323266
                        ],
                        [
                            11.2016509380793,
                            46.222884043927095
                        ],
                        [
                            11.206429184384845,
                            46.219772403066244
                        ],
                        [
                            11.239472203308344,
                            46.22838180079026
                        ],
                        [
                            11.248945235682529,
                            46.23281736286569
                        ],
                        [
                            11.25886488978535,
                            46.24007836499205
                        ],
                        [
                            11.275163985253158,
                            46.25190075523937
                        ],
                        [
                            11.289315293165794,
                            46.26066780508499
                        ],
                        [
                            11.29012861471508,
                            46.26116950725568
                        ],
                        [
                            11.290212639050216,
                            46.26122133693355
                        ],
                        [
                            11.29080846570748,
                            46.26154689497258
                        ],
                        [
                            11.292089087278132,
                            46.26137271691093
                        ],
                        [
                            11.305616489355062,
                            46.25876708914908
                        ],
                        [
                            11.307783074046563,
                            46.262979001357465
                        ],
                        [
                            11.310136724923979,
                            46.26670739056941
                        ],
                        [
                            11.311637018025536,
                            46.26835295628346
                        ],
                        [
                            11.313833181917149,
                            46.270561334442455
                        ],
                        [
                            11.315767056857839,
                            46.27302053523727
                        ],
                        [
                            11.315851219478647,
                            46.27327252905804
                        ],
                        [
                            11.315776872474412,
                            46.27352856405282
                        ],
                        [
                            11.314105476319545,
                            46.27907915379715
                        ],
                        [
                            11.31393960636462,
                            46.27920673995784
                        ],
                        [
                            11.312815114353896,
                            46.28001090237403
                        ],
                        [
                            11.312384013196265,
                            46.28030014546432
                        ],
                        [
                            11.310880410523193,
                            46.281281055448005
                        ],
                        [
                            11.323231957274437,
                            46.29261844201834
                        ],
                        [
                            11.330973132354641,
                            46.29386363976065
                        ],
                        [
                            11.332315763931422,
                            46.29537848410411
                        ],
                        [
                            11.332207846678525,
                            46.295938261009226
                        ],
                        [
                            11.332142065023522,
                            46.29641400878915
                        ],
                        [
                            11.332130479215532,
                            46.29650908578491
                        ],
                        [
                            11.332140097427812,
                            46.29657436508843
                        ],
                        [
                            11.333469711381305,
                            46.29762047939699
                        ],
                        [
                            11.333547305104858,
                            46.29766442519329
                        ],
                        [
                            11.333699560627043,
                            46.29770297348434
                        ],
                        [
                            11.33378367320856,
                            46.29772425758709
                        ],
                        [
                            11.338070028432348,
                            46.298710647157684
                        ],
                        [
                            11.338250925889557,
                            46.29873282062242
                        ],
                        [
                            11.338791705076199,
                            46.298798760138794
                        ],
                        [
                            11.339363776581852,
                            46.29827806943878
                        ],
                        [
                            11.340338555718079,
                            46.29788177522349
                        ],
                        [
                            11.338719869998199,
                            46.29622878076086
                        ],
                        [
                            11.338634740243778,
                            46.29611983299098
                        ],
                        [
                            11.338610825634749,
                            46.29608874066419
                        ],
                        [
                            11.338517788739875,
                            46.2959677791397
                        ],
                        [
                            11.338239298294154,
                            46.29544490542075
                        ],
                        [
                            11.336597202559878,
                            46.291465496244356
                        ],
                        [
                            11.336320733416022,
                            46.28963041433841
                        ],
                        [
                            11.338522449882142,
                            46.286379395422934
                        ],
                        [
                            11.33896220425043,
                            46.28573138523176
                        ],
                        [
                            11.339231468610931,
                            46.28534786527948
                        ],
                        [
                            11.340479198808994,
                            46.28358729204429
                        ],
                        [
                            11.341551780201701,
                            46.28222229128115
                        ],
                        [
                            11.341925161298871,
                            46.28184562878015
                        ],
                        [
                            11.343706676596259,
                            46.28070208025737
                        ],
                        [
                            11.343959843646603,
                            46.2805478447475
                        ],
                        [
                            11.34444048547851,
                            46.28025502401625
                        ],
                        [
                            11.346064998991814,
                            46.27999668091851
                        ],
                        [
                            11.346575024122933,
                            46.2800852095869
                        ],
                        [
                            11.347386019302798,
                            46.280230554626286
                        ],
                        [
                            11.354314937072488,
                            46.277401358329456
                        ],
                        [
                            11.356146047926835,
                            46.27644688355789
                        ],
                        [
                            11.356203278953899,
                            46.27641384627437
                        ],
                        [
                            11.356292439025802,
                            46.27628620250613
                        ],
                        [
                            11.356428474128593,
                            46.27605388681095
                        ],
                        [
                            11.357163203319319,
                            46.2741464393377
                        ],
                        [
                            11.35724738587414,
                            46.27387721474401
                        ],
                        [
                            11.35728128655878,
                            46.271416030735274
                        ],
                        [
                            11.358780819600133,
                            46.265667625144474
                        ],
                        [
                            11.359537304176417,
                            46.26545400522812
                        ],
                        [
                            11.370232327350855,
                            46.2624531982796
                        ],
                        [
                            11.371840407135645,
                            46.263651602347004
                        ],
                        [
                            11.372089613385567,
                            46.26375433890748
                        ],
                        [
                            11.372380372433467,
                            46.26387367544301
                        ],
                        [
                            11.372801332437493,
                            46.2639464584267
                        ],
                        [
                            11.373545141970393,
                            46.26398639838677
                        ],
                        [
                            11.373617674157362,
                            46.263990292815215
                        ],
                        [
                            11.373678228816745,
                            46.263980125591516
                        ],
                        [
                            11.373909240675006,
                            46.26393489475504
                        ],
                        [
                            11.3742594444679,
                            46.263862572158075
                        ],
                        [
                            11.374761047893534,
                            46.263689605055006
                        ],
                        [
                            11.375014913526082,
                            46.26355832614866
                        ],
                        [
                            11.376190587634461,
                            46.26281557446439
                        ],
                        [
                            11.387249954683773,
                            46.26142232301328
                        ],
                        [
                            11.38772896022358,
                            46.2613667761257
                        ],
                        [
                            11.387818038520814,
                            46.26135644997028
                        ],
                        [
                            11.388419870037769,
                            46.261469874046
                        ],
                        [
                            11.39762389425282,
                            46.26483220764218
                        ],
                        [
                            11.397104309446165,
                            46.267201154187774
                        ],
                        [
                            11.396949394903928,
                            46.26779769117324
                        ],
                        [
                            11.396857915719773,
                            46.268148135236025
                        ],
                        [
                            11.396366230349209,
                            46.26961968648064
                        ],
                        [
                            11.394678160597586,
                            46.27376816724325
                        ],
                        [
                            11.39436100013843,
                            46.27423381987647
                        ],
                        [
                            11.393978989346584,
                            46.27470083923237
                        ],
                        [
                            11.393506212509132,
                            46.275169750390155
                        ],
                        [
                            11.390870605426002,
                            46.2775379702482
                        ],
                        [
                            11.38970798736839,
                            46.278561306941086
                        ],
                        [
                            11.389676110517458,
                            46.278583482349994
                        ],
                        [
                            11.389027637659272,
                            46.27903454886562
                        ],
                        [
                            11.386782247874235,
                            46.280102891674
                        ],
                        [
                            11.384781163173978,
                            46.28676439079255
                        ],
                        [
                            11.384647067085654,
                            46.28696519970063
                        ],
                        [
                            11.384132765772463,
                            46.287677945443676
                        ],
                        [
                            11.382765582572624,
                            46.28938048973893
                        ],
                        [
                            11.38149624796134,
                            46.290945977251134
                        ],
                        [
                            11.381284714933928,
                            46.29115738435147
                        ],
                        [
                            11.381019861015302,
                            46.29135829446925
                        ],
                        [
                            11.380869901625331,
                            46.29147203800265
                        ],
                        [
                            11.380258190061225,
                            46.29173678661162
                        ],
                        [
                            11.379943084695647,
                            46.29183478650474
                        ],
                        [
                            11.37966889711341,
                            46.29192005945587
                        ],
                        [
                            11.37909101236826,
                            46.2920670926421
                        ],
                        [
                            11.377893992062136,
                            46.292308014453404
                        ],
                        [
                            11.37723672012748,
                            46.292420690147964
                        ],
                        [
                            11.374812797211286,
                            46.29281309921116
                        ],
                        [
                            11.373600051129488,
                            46.29299130026524
                        ],
                        [
                            11.371781486244798,
                            46.29327205793084
                        ],
                        [
                            11.370623323958853,
                            46.29351209684857
                        ],
                        [
                            11.368875000932809,
                            46.29388425930879
                        ],
                        [
                            11.366327056005826,
                            46.294447162093306
                        ],
                        [
                            11.36468056101347,
                            46.29481184951123
                        ],
                        [
                            11.360745361119847,
                            46.29568762665992
                        ],
                        [
                            11.359549707076496,
                            46.295964325631125
                        ],
                        [
                            11.359499116178574,
                            46.295977171290104
                        ],
                        [
                            11.359180456724037,
                            46.29605818028175
                        ],
                        [
                            11.359096797960746,
                            46.296079481012555
                        ],
                        [
                            11.358932157216136,
                            46.296122495945674
                        ],
                        [
                            11.359074510105314,
                            46.29850317781277
                        ],
                        [
                            11.35914698462786,
                            46.299077560955155
                        ],
                        [
                            11.359157770116754,
                            46.299116421704724
                        ],
                        [
                            11.359533727051478,
                            46.29960449563462
                        ],
                        [
                            11.360218736710216,
                            46.30035157662416
                        ],
                        [
                            11.360746371260344,
                            46.300844687719334
                        ],
                        [
                            11.36107497336482,
                            46.3009368994265
                        ],
                        [
                            11.363583584597068,
                            46.30159604976327
                        ],
                        [
                            11.36368442366416,
                            46.30161652038909
                        ],
                        [
                            11.364146890400182,
                            46.30171040045194
                        ],
                        [
                            11.36824862502669,
                            46.301670475234715
                        ],
                        [
                            11.368702333027974,
                            46.30165206436764
                        ],
                        [
                            11.371514877855908,
                            46.30148990728377
                        ],
                        [
                            11.372264365785277,
                            46.30144317530276
                        ],
                        [
                            11.37634328217821,
                            46.301074393247156
                        ],
                        [
                            11.376919792656668,
                            46.30099543012949
                        ],
                        [
                            11.377502060538095,
                            46.30094731854356
                        ],
                        [
                            11.378139323424385,
                            46.30097005762252
                        ],
                        [
                            11.378979656871012,
                            46.30109243008306
                        ],
                        [
                            11.379707486407987,
                            46.30119841518119
                        ],
                        [
                            11.381503447538579,
                            46.301566325245716
                        ],
                        [
                            11.384890734028497,
                            46.302440379783405
                        ],
                        [
                            11.38534201800717,
                            46.30266497079906
                        ],
                        [
                            11.38600101665392,
                            46.3030419367708
                        ],
                        [
                            11.386953726700561,
                            46.30359433104297
                        ],
                        [
                            11.395783177338956,
                            46.30996709639866
                        ],
                        [
                            11.397291726953735,
                            46.314916101145904
                        ],
                        [
                            11.397677009290662,
                            46.31559095503815
                        ],
                        [
                            11.397751554848556,
                            46.31571475023037
                        ],
                        [
                            11.40425138703762,
                            46.32497403020492
                        ],
                        [
                            11.410115152993596,
                            46.32445651858726
                        ],
                        [
                            11.41222834829898,
                            46.32435792836703
                        ],
                        [
                            11.420498383889537,
                            46.32541608085091
                        ],
                        [
                            11.421037282342384,
                            46.325557669507404
                        ],
                        [
                            11.454471643923158,
                            46.334726578876385
                        ],
                        [
                            11.454779862657098,
                            46.33493596402116
                        ],
                        [
                            11.456141437851622,
                            46.336904740604226
                        ],
                        [
                            11.458709088013489,
                            46.340845572510396
                        ],
                        [
                            11.45918906865433,
                            46.34227526335644
                        ],
                        [
                            11.459274594002906,
                            46.344181450590945
                        ],
                        [
                            11.45932500652204,
                            46.345305694174805
                        ],
                        [
                            11.459321804813388,
                            46.3453344664464
                        ],
                        [
                            11.459243576088628,
                            46.346075016851294
                        ],
                        [
                            11.459233919833842,
                            46.34617135014662
                        ],
                        [
                            11.461157692510202,
                            46.34912409820558
                        ],
                        [
                            11.461417252496933,
                            46.34938108270599
                        ],
                        [
                            11.461852752466717,
                            46.34976406453794
                        ],
                        [
                            11.462068062657934,
                            46.34995337264709
                        ],
                        [
                            11.462550052602941,
                            46.350266990299126
                        ],
                        [
                            11.46380496410285,
                            46.35100495076427
                        ],
                        [
                            11.464079114946085,
                            46.35114736282281
                        ],
                        [
                            11.46453693091305,
                            46.351385179035816
                        ],
                        [
                            11.464989329112484,
                            46.35161841938099
                        ],
                        [
                            11.468156404219155,
                            46.35181106369483
                        ],
                        [
                            11.469210213422883,
                            46.351833304811976
                        ],
                        [
                            11.470288783150611,
                            46.35182799056091
                        ],
                        [
                            11.471379314385345,
                            46.351798812588484
                        ],
                        [
                            11.47261105409731,
                            46.35173277159942
                        ],
                        [
                            11.473828800868075,
                            46.352219422152736
                        ],
                        [
                            11.475974614829259,
                            46.35310896084759
                        ],
                        [
                            11.476465236001754,
                            46.35332333179301
                        ],
                        [
                            11.476931100647375,
                            46.35356524042927
                        ],
                        [
                            11.476983964568863,
                            46.35361341469323
                        ],
                        [
                            11.47743269229411,
                            46.35402237682737
                        ],
                        [
                            11.479155884990027,
                            46.35562302385266
                        ],
                        [
                            11.479555663865176,
                            46.356127356742455
                        ],
                        [
                            11.47822769068409,
                            46.362402231892936
                        ],
                        [
                            11.477984674129555,
                            46.36288796344053
                        ],
                        [
                            11.477685948350224,
                            46.36325302834831
                        ],
                        [
                            11.47689681459508,
                            46.3639314013008
                        ],
                        [
                            11.496841429923576,
                            46.36063805585592
                        ],
                        [
                            11.498979181996857,
                            46.360670713939086
                        ],
                        [
                            11.501209524257348,
                            46.36060760385744
                        ],
                        [
                            11.501298484808292,
                            46.36059204042596
                        ],
                        [
                            11.501619988313495,
                            46.36053563718624
                        ],
                        [
                            11.512003988489413,
                            46.35864550262752
                        ],
                        [
                            11.525991054838817,
                            46.35593839942373
                        ],
                        [
                            11.52604540732147,
                            46.354157080602754
                        ],
                        [
                            11.535259011320369,
                            46.35276138806968
                        ],
                        [
                            11.53926979769506,
                            46.351045043755946
                        ],
                        [
                            11.53993961691309,
                            46.35063415577577
                        ],
                        [
                            11.542260674302232,
                            46.34912435305697
                        ],
                        [
                            11.542832886553212,
                            46.34856277876511
                        ],
                        [
                            11.543205692014809,
                            46.34819447904153
                        ],
                        [
                            11.545566486472532,
                            46.34557687588909
                        ],
                        [
                            11.557246492130922,
                            46.35094542406965
                        ],
                        [
                            11.556745081656526,
                            46.35286042731924
                        ],
                        [
                            11.556681864394257,
                            46.358441100614876
                        ],
                        [
                            11.556700938139077,
                            46.35857387044304
                        ],
                        [
                            11.559053555627672,
                            46.36854061104499
                        ],
                        [
                            11.562391905921032,
                            46.378972160855376
                        ],
                        [
                            11.563165343009763,
                            46.38022808730693
                        ],
                        [
                            11.563355711572436,
                            46.38049173174648
                        ],
                        [
                            11.563433577560177,
                            46.38059700346004
                        ],
                        [
                            11.56351004106535,
                            46.38070034004287
                        ],
                        [
                            11.563667883080495,
                            46.38085408351287
                        ],
                        [
                            11.564207895862813,
                            46.381283357051494
                        ],
                        [
                            11.564323251304648,
                            46.38135230111245
                        ],
                        [
                            11.564560845029751,
                            46.381455878795606
                        ],
                        [
                            11.564832113924902,
                            46.38157279807457
                        ],
                        [
                            11.57216843861578,
                            46.38140705628417
                        ],
                        [
                            11.57619695827896,
                            46.38147596134586
                        ],
                        [
                            11.576637943676845,
                            46.38150626105163
                        ],
                        [
                            11.576830594093446,
                            46.3815211515475
                        ],
                        [
                            11.577170626909615,
                            46.38159098346413
                        ],
                        [
                            11.577518101551185,
                            46.38169692891285
                        ],
                        [
                            11.583004975266059,
                            46.382717304814754
                        ],
                        [
                            11.588647929643008,
                            46.38351663117678
                        ],
                        [
                            11.589328158584793,
                            46.38360022178718
                        ],
                        [
                            11.590670940440422,
                            46.38366878876264
                        ],
                        [
                            11.591556899363786,
                            46.38370269586369
                        ],
                        [
                            11.592128510305667,
                            46.383689730991854
                        ],
                        [
                            11.592575134540246,
                            46.383643130087115
                        ],
                        [
                            11.59302307740054,
                            46.38387971857323
                        ],
                        [
                            11.594516587235903,
                            46.38464463497835
                        ],
                        [
                            11.59458423833361,
                            46.38468109689833
                        ],
                        [
                            11.599322397225087,
                            46.38732717170966
                        ],
                        [
                            11.599818457799127,
                            46.387773342975656
                        ],
                        [
                            11.599940223946973,
                            46.3878918212999
                        ],
                        [
                            11.600208732879565,
                            46.38815311544104
                        ],
                        [
                            11.600972722242547,
                            46.38893790522726
                        ],
                        [
                            11.601329220040144,
                            46.38931704665565
                        ],
                        [
                            11.601723527874963,
                            46.38978688940057
                        ],
                        [
                            11.602651109940265,
                            46.40048866084377
                        ],
                        [
                            11.60798372384103,
                            46.41019268243469
                        ],
                        [
                            11.619359830085568,
                            46.42521512447995
                        ],
                        [
                            11.618319308668775,
                            46.43801799353306
                        ],
                        [
                            11.618049758590145,
                            46.44088844878906
                        ],
                        [
                            11.617767246072168,
                            46.44409506327523
                        ],
                        [
                            11.622117778074761,
                            46.45655227413361
                        ],
                        [
                            11.626085413072753,
                            46.461036163914635
                        ],
                        [
                            11.627487606869845,
                            46.46256382313528
                        ],
                        [
                            11.627520572394939,
                            46.462608680435814
                        ],
                        [
                            11.627786763194035,
                            46.46297111781629
                        ],
                        [
                            11.628031939905174,
                            46.463345286061056
                        ],
                        [
                            11.628222682642637,
                            46.46363716849905
                        ],
                        [
                            11.628304436400072,
                            46.46377335884879
                        ],
                        [
                            11.628305075328567,
                            46.463955413184976
                        ],
                        [
                            11.627990203586938,
                            46.46706865151946
                        ],
                        [
                            11.62784628477581,
                            46.46779179510543
                        ],
                        [
                            11.627214090572778,
                            46.46840713604226
                        ],
                        [
                            11.62698162451559,
                            46.46862966289101
                        ],
                        [
                            11.626857389748677,
                            46.46874854185227
                        ],
                        [
                            11.626495057070501,
                            46.46902255735258
                        ],
                        [
                            11.626133157297186,
                            46.46940894840919
                        ],
                        [
                            11.625754995809215,
                            46.46981408912853
                        ],
                        [
                            11.624977717129216,
                            46.47078618063791
                        ],
                        [
                            11.624828982204672,
                            46.47099700137652
                        ],
                        [
                            11.624761688265473,
                            46.471092949453
                        ],
                        [
                            11.625359152360872,
                            46.47141789758825
                        ],
                        [
                            11.625820742687083,
                            46.47164939609816
                        ],
                        [
                            11.626341999120262,
                            46.47189204533946
                        ],
                        [
                            11.635247657326586,
                            46.47449585657408
                        ],
                        [
                            11.636462930190314,
                            46.474770969300195
                        ],
                        [
                            11.64273488448889,
                            46.47594015941115
                        ],
                        [
                            11.643132410623776,
                            46.4749356973816
                        ],
                        [
                            11.644577712775892,
                            46.47282061092331
                        ],
                        [
                            11.644857739929403,
                            46.47378651163448
                        ],
                        [
                            11.647244349772052,
                            46.48137865331656
                        ],
                        [
                            11.647468345113484,
                            46.48183524975996
                        ],
                        [
                            11.647832415315829,
                            46.48205555033568
                        ],
                        [
                            11.648065135808395,
                            46.482166401078416
                        ],
                        [
                            11.648310498105664,
                            46.48228321348236
                        ],
                        [
                            11.648967422458776,
                            46.482495531146995
                        ],
                        [
                            11.650061364804117,
                            46.482870751396455
                        ],
                        [
                            11.650133183838657,
                            46.4829414422686
                        ],
                        [
                            11.65026006941203,
                            46.48306648929379
                        ],
                        [
                            11.650062069616135,
                            46.483752174836546
                        ],
                        [
                            11.648815015958986,
                            46.48496318650867
                        ],
                        [
                            11.648044198326344,
                            46.48565348090348
                        ],
                        [
                            11.647916817880429,
                            46.48576742526251
                        ],
                        [
                            11.647029158903011,
                            46.4862297171863
                        ],
                        [
                            11.645188762687154,
                            46.48715441913044
                        ],
                        [
                            11.64464195009366,
                            46.48740259967029
                        ],
                        [
                            11.643626617727639,
                            46.48760814825727
                        ],
                        [
                            11.642424112948277,
                            46.49191256997213
                        ],
                        [
                            11.64228991078306,
                            46.49229483484811
                        ],
                        [
                            11.641949478174489,
                            46.49264004780001
                        ],
                        [
                            11.633941693949074,
                            46.496541727539444
                        ],
                        [
                            11.632807729886936,
                            46.499288427556834
                        ],
                        [
                            11.63667328888191,
                            46.50057502389126
                        ],
                        [
                            11.645019738047296,
                            46.498571595332514
                        ],
                        [
                            11.645211565813272,
                            46.498537081579116
                        ],
                        [
                            11.645545131523404,
                            46.49847712260158
                        ],
                        [
                            11.652721967676372,
                            46.49767795805109
                        ],
                        [
                            11.653536960178512,
                            46.4976424409105
                        ],
                        [
                            11.666093555018744,
                            46.49740494735665
                        ],
                        [
                            11.666855684598172,
                            46.497522096705964
                        ],
                        [
                            11.667402977050331,
                            46.497731846062045
                        ],
                        [
                            11.667906960137381,
                            46.49796556644851
                        ],
                        [
                            11.668137930933682,
                            46.49815817453543
                        ],
                        [
                            11.669821622515908,
                            46.499127116800274
                        ],
                        [
                            11.674794769306581,
                            46.50040322406864
                        ],
                        [
                            11.675395086052811,
                            46.500525739251366
                        ],
                        [
                            11.677482663988854,
                            46.50095078629224
                        ],
                        [
                            11.689880560964443,
                            46.50332761773668
                        ],
                        [
                            11.695090987813263,
                            46.50365534825794
                        ],
                        [
                            11.706386750361366,
                            46.510443705964384
                        ],
                        [
                            11.707013341656783,
                            46.51074187640536
                        ],
                        [
                            11.714809420376355,
                            46.513507280468566
                        ],
                        [
                            11.715831629694499,
                            46.5138472237901
                        ],
                        [
                            11.719719841221306,
                            46.51024350367036
                        ],
                        [
                            11.733484193285284,
                            46.509194846450356
                        ],
                        [
                            11.743592720137915,
                            46.504953487805295
                        ],
                        [
                            11.753570748447276,
                            46.506385509159585
                        ],
                        [
                            11.762909636424927,
                            46.5075512535696
                        ],
                        [
                            11.774640249404351,
                            46.509194731081884
                        ],
                        [
                            11.785041159376666,
                            46.511300125578785
                        ],
                        [
                            11.790427262789175,
                            46.514006888773835
                        ],
                        [
                            11.793619459575153,
                            46.521312114103374
                        ],
                        [
                            11.80076273356002,
                            46.52766527444111
                        ],
                        [
                            11.801936103718536,
                            46.52853543181447
                        ],
                        [
                            11.802737601754854,
                            46.529063405642376
                        ],
                        [
                            11.803234164292835,
                            46.52939045268341
                        ],
                        [
                            11.805204980872674,
                            46.53043156449011
                        ],
                        [
                            11.806172368671648,
                            46.53091332865983
                        ],
                        [
                            11.807240792697971,
                            46.53143141328744
                        ],
                        [
                            11.808190853278147,
                            46.53187528703205
                        ],
                        [
                            11.811184716862723,
                            46.53276429012237
                        ],
                        [
                            11.811565143645272,
                            46.532644950182906
                        ],
                        [
                            11.811615482113911,
                            46.5326075568354
                        ],
                        [
                            11.811864207432405,
                            46.53242212076314
                        ],
                        [
                            11.814722669259048,
                            46.52901971435149
                        ],
                        [
                            11.817968742238119,
                            46.52785774173851
                        ],
                        [
                            11.81829367044717,
                            46.52773750824141
                        ],
                        [
                            11.81862360478141,
                            46.52750878848329
                        ],
                        [
                            11.818759966392136,
                            46.527404670643364
                        ],
                        [
                            11.819050759756156,
                            46.52718263175961
                        ],
                        [
                            11.821215677867327,
                            46.525409353074245
                        ],
                        [
                            11.822434983734823,
                            46.524363975528956
                        ],
                        [
                            11.824304886862258,
                            46.522757197272576
                        ],
                        [
                            11.825489045433265,
                            46.52178516237192
                        ],
                        [
                            11.825530560685994,
                            46.51958888127534
                        ],
                        [
                            11.825521666261613,
                            46.519367952656616
                        ],
                        [
                            11.825507011056187,
                            46.519005266460596
                        ],
                        [
                            11.82544012881546,
                            46.51845167972274
                        ],
                        [
                            11.825350582260208,
                            46.518093098431244
                        ],
                        [
                            11.825258920250482,
                            46.517726107457634
                        ],
                        [
                            11.825116381757509,
                            46.517232466401474
                        ],
                        [
                            11.825077004729355,
                            46.517107331264356
                        ],
                        [
                            11.824974004370787,
                            46.51678001100173
                        ],
                        [
                            11.824894591150782,
                            46.51649759324758
                        ],
                        [
                            11.82477105544921,
                            46.516058217913105
                        ],
                        [
                            11.824720541630555,
                            46.5138509132164
                        ],
                        [
                            11.824870727792065,
                            46.5133829941454
                        ],
                        [
                            11.825047916525076,
                            46.51310160591283
                        ],
                        [
                            11.825134875249478,
                            46.512963546847224
                        ],
                        [
                            11.826765502160672,
                            46.51088424560099
                        ],
                        [
                            11.828312400847022,
                            46.50891394674888
                        ],
                        [
                            11.824080629405485,
                            46.50407690217731
                        ],
                        [
                            11.815453512431441,
                            46.50031750754023
                        ],
                        [
                            11.815207771759296,
                            46.49971543764184
                        ],
                        [
                            11.81389776955522,
                            46.495823398572156
                        ],
                        [
                            11.81039286334579,
                            46.48486541378194
                        ],
                        [
                            11.810417431804854,
                            46.48471680880561
                        ],
                        [
                            11.810566472149464,
                            46.48424580477662
                        ],
                        [
                            11.813157540083425,
                            46.478140392353126
                        ],
                        [
                            11.813409140310641,
                            46.4779352832783
                        ],
                        [
                            11.815442890578707,
                            46.47716139515739
                        ],
                        [
                            11.816224801213764,
                            46.476867016454925
                        ],
                        [
                            11.816286984244135,
                            46.47684656673167
                        ],
                        [
                            11.81637558045666,
                            46.47682396574715
                        ],
                        [
                            11.816789146008249,
                            46.47672714433649
                        ],
                        [
                            11.817310800295315,
                            46.47661425841747
                        ],
                        [
                            11.818071623256534,
                            46.4765373829667
                        ],
                        [
                            11.822984360750297,
                            46.47605997105005
                        ],
                        [
                            11.830444677864339,
                            46.47609495196658
                        ],
                        [
                            11.834393501882676,
                            46.47630971658652
                        ],
                        [
                            11.851521324266592,
                            46.47500161154802
                        ],
                        [
                            11.874215856205987,
                            46.472875317405354
                        ],
                        [
                            11.874268743229978,
                            46.47286792024989
                        ],
                        [
                            11.87431796117138,
                            46.47285472384146
                        ],
                        [
                            11.875245320204714,
                            46.47256063289789
                        ],
                        [
                            11.876419615760945,
                            46.47209987687931
                        ],
                        [
                            11.877158098954162,
                            46.471783302186104
                        ],
                        [
                            11.877732752211143,
                            46.47136476321652
                        ],
                        [
                            11.878565543984175,
                            46.47074420778958
                        ],
                        [
                            11.878648412463484,
                            46.470289340586945
                        ],
                        [
                            11.881190624308719,
                            46.46770903143773
                        ],
                        [
                            11.882677822208494,
                            46.46632180145368
                        ],
                        [
                            11.883780399323282,
                            46.46584432211739
                        ],
                        [
                            11.886825697263921,
                            46.464566820169104
                        ],
                        [
                            11.887362778824242,
                            46.46314323574458
                        ],
                        [
                            11.888159326290134,
                            46.45776803520707
                        ],
                        [
                            11.889062093763718,
                            46.44363749939769
                        ],
                        [
                            11.889108263464895,
                            46.44274165095211
                        ],
                        [
                            11.888793266283196,
                            46.44199597363581
                        ],
                        [
                            11.873896803860934,
                            46.434394248624905
                        ],
                        [
                            11.873001214920995,
                            46.43394876650996
                        ],
                        [
                            11.871753748679131,
                            46.433449111229145
                        ],
                        [
                            11.870882290093654,
                            46.433214503935986
                        ],
                        [
                            11.869949243668447,
                            46.433161652579074
                        ],
                        [
                            11.8631978503514,
                            46.4331157794321
                        ],
                        [
                            11.862337947762201,
                            46.43328964302735
                        ],
                        [
                            11.86160699025444,
                            46.433488796456544
                        ],
                        [
                            11.861246623662016,
                            46.43371174699363
                        ],
                        [
                            11.860625518350465,
                            46.43391273721476
                        ],
                        [
                            11.859746095180482,
                            46.43411830689403
                        ],
                        [
                            11.857761980038033,
                            46.434195329638754
                        ],
                        [
                            11.850518726101752,
                            46.43430929543938
                        ],
                        [
                            11.85029772976261,
                            46.43418898499867
                        ],
                        [
                            11.850290562983933,
                            46.43416055660333
                        ],
                        [
                            11.848171362022162,
                            46.42904449305516
                        ],
                        [
                            11.840528051809677,
                            46.418960299638975
                        ],
                        [
                            11.840148404977528,
                            46.41842132482769
                        ],
                        [
                            11.839495099275654,
                            46.41748312934299
                        ],
                        [
                            11.838851237888749,
                            46.416441140672
                        ],
                        [
                            11.838223192825657,
                            46.415233029830695
                        ],
                        [
                            11.83819944578487,
                            46.41506188368369
                        ],
                        [
                            11.838400339448985,
                            46.414707051526584
                        ],
                        [
                            11.838535051482056,
                            46.41455627803682
                        ],
                        [
                            11.839935394291972,
                            46.41329518656038
                        ],
                        [
                            11.840314043497106,
                            46.41297851853521
                        ],
                        [
                            11.843689152066432,
                            46.4099187758077
                        ],
                        [
                            11.842418675404799,
                            46.40864009842939
                        ],
                        [
                            11.841975179248504,
                            46.40814227962309
                        ],
                        [
                            11.841354182492033,
                            46.40740231233593
                        ],
                        [
                            11.840202371952817,
                            46.405883409563806
                        ],
                        [
                            11.83740593178165,
                            46.4018758917071
                        ],
                        [
                            11.835931395344971,
                            46.39820729270236
                        ],
                        [
                            11.834860498502541,
                            46.39524751247869
                        ],
                        [
                            11.83204004342198,
                            46.38718700101569
                        ],
                        [
                            11.832029393109408,
                            46.38697338922727
                        ],
                        [
                            11.831809528546755,
                            46.3796125410703
                        ],
                        [
                            11.832862412117436,
                            46.376587140031845
                        ],
                        [
                            11.834409442548258,
                            46.37147377946811
                        ],
                        [
                            11.83531338668305,
                            46.36812210069333
                        ],
                        [
                            11.83539427852995,
                            46.366222242204245
                        ],
                        [
                            11.834975531297298,
                            46.366157519912484
                        ],
                        [
                            11.833559974656174,
                            46.36613608153866
                        ],
                        [
                            11.833225997804314,
                            46.36615813645102
                        ],
                        [
                            11.832505005403412,
                            46.366355400985746
                        ],
                        [
                            11.830891901155237,
                            46.3669324722558
                        ],
                        [
                            11.825183253297185,
                            46.37125368107826
                        ],
                        [
                            11.820173201663271,
                            46.376621056755255
                        ],
                        [
                            11.819124307114608,
                            46.376389420721516
                        ],
                        [
                            11.818692248328011,
                            46.37628622721165
                        ],
                        [
                            11.818344613317695,
                            46.376201922188635
                        ],
                        [
                            11.818265031398003,
                            46.37618185151538
                        ],
                        [
                            11.817773689818532,
                            46.376038771285685
                        ],
                        [
                            11.817084504196348,
                            46.37567854739873
                        ],
                        [
                            11.816881173788808,
                            46.37551193233266
                        ],
                        [
                            11.816428134283154,
                            46.37511980262299
                        ],
                        [
                            11.816121753048586,
                            46.37482931748945
                        ],
                        [
                            11.815934749352918,
                            46.37460557508544
                        ],
                        [
                            11.815424573684712,
                            46.373785646629265
                        ],
                        [
                            11.815161581475932,
                            46.37329698129569
                        ],
                        [
                            11.814916018617938,
                            46.3728006659471
                        ],
                        [
                            11.8147224759138,
                            46.37178240051214
                        ],
                        [
                            11.81479998915663,
                            46.37157673671898
                        ],
                        [
                            11.814945169655022,
                            46.371240992753904
                        ],
                        [
                            11.815089859534957,
                            46.37102650057901
                        ],
                        [
                            11.815516574727562,
                            46.37021344015125
                        ],
                        [
                            11.816025964916653,
                            46.36921291964386
                        ],
                        [
                            11.815782601209413,
                            46.36875905279319
                        ],
                        [
                            11.815385868187317,
                            46.36842598687917
                        ],
                        [
                            11.815089207053353,
                            46.3682138604778
                        ],
                        [
                            11.814800334032203,
                            46.36805295549789
                        ],
                        [
                            11.814455890471354,
                            46.36786823852166
                        ],
                        [
                            11.814177134122202,
                            46.367749913267374
                        ],
                        [
                            11.81366968510147,
                            46.367549545566
                        ],
                        [
                            11.804010741008504,
                            46.36497985351164
                        ],
                        [
                            11.802090150916673,
                            46.364914828787775
                        ],
                        [
                            11.801719361534603,
                            46.36491379759803
                        ],
                        [
                            11.800326924785683,
                            46.36494844179804
                        ],
                        [
                            11.799945345641467,
                            46.36497204740377
                        ],
                        [
                            11.79970026122537,
                            46.365027040335164
                        ],
                        [
                            11.799396875963275,
                            46.3651943147094
                        ],
                        [
                            11.798816462427268,
                            46.36557569543382
                        ],
                        [
                            11.798511911262109,
                            46.365780915016835
                        ],
                        [
                            11.798186536031489,
                            46.36610685130845
                        ],
                        [
                            11.79796327517204,
                            46.36632094648791
                        ],
                        [
                            11.79773289340462,
                            46.366528610279445
                        ],
                        [
                            11.797293886117002,
                            46.36677247167007
                        ],
                        [
                            11.795878448570864,
                            46.367443468986465
                        ],
                        [
                            11.795070617088266,
                            46.367736007223655
                        ],
                        [
                            11.794711292343072,
                            46.36781818172536
                        ],
                        [
                            11.794474546447697,
                            46.3678405188728
                        ],
                        [
                            11.7942781107701,
                            46.3678509596485
                        ],
                        [
                            11.793589853861512,
                            46.367857811775885
                        ],
                        [
                            11.792522067321096,
                            46.3678472877777
                        ],
                        [
                            11.79217334838544,
                            46.36781760261594
                        ],
                        [
                            11.791810035679935,
                            46.36772723137362
                        ],
                        [
                            11.783727374516916,
                            46.364685144468105
                        ],
                        [
                            11.783326157479282,
                            46.36452327335258
                        ],
                        [
                            11.782871738253744,
                            46.36431778164584
                        ],
                        [
                            11.780248867190343,
                            46.36293155050368
                        ],
                        [
                            11.779586178594188,
                            46.362543113762015
                        ],
                        [
                            11.776878309236656,
                            46.36040943415259
                        ],
                        [
                            11.77437855346641,
                            46.35824165814715
                        ],
                        [
                            11.779497695685036,
                            46.351636160308885
                        ],
                        [
                            11.791368181022053,
                            46.347068294325865
                        ],
                        [
                            11.798238249888595,
                            46.344677187309685
                        ],
                        [
                            11.799982832459174,
                            46.344229435477565
                        ],
                        [
                            11.800251661203653,
                            46.34415072890251
                        ],
                        [
                            11.800418176457548,
                            46.3441017696696
                        ],
                        [
                            11.802117082831854,
                            46.34302453031865
                        ],
                        [
                            11.802343384849546,
                            46.34286653676426
                        ],
                        [
                            11.801914883619904,
                            46.33804391969471
                        ],
                        [
                            11.80281198186763,
                            46.33322478714854
                        ],
                        [
                            11.803126889005528,
                            46.33310804013919
                        ],
                        [
                            11.803704735946448,
                            46.33289687134353
                        ],
                        [
                            11.815574522550072,
                            46.329742902558394
                        ],
                        [
                            11.820355406626998,
                            46.32847295485072
                        ],
                        [
                            11.82412163187401,
                            46.32768690012107
                        ],
                        [
                            11.827671348650734,
                            46.32698708494384
                        ],
                        [
                            11.828480901652876,
                            46.32681403999002
                        ],
                        [
                            11.830022159999684,
                            46.32646987008912
                        ],
                        [
                            11.83019824570811,
                            46.32635749725076
                        ],
                        [
                            11.831294026445304,
                            46.32555521026428
                        ],
                        [
                            11.831850611592182,
                            46.325146525942124
                        ],
                        [
                            11.83187932350745,
                            46.324947801657096
                        ],
                        [
                            11.831657134377492,
                            46.31661906244563
                        ],
                        [
                            11.831372877009553,
                            46.313377013049205
                        ],
                        [
                            11.83166193719813,
                            46.31293783001127
                        ],
                        [
                            11.834378295359329,
                            46.31020639209171
                        ],
                        [
                            11.836780423194908,
                            46.30818470449228
                        ],
                        [
                            11.841446215206377,
                            46.30634052359568
                        ],
                        [
                            11.836767942022295,
                            46.30266784055571
                        ],
                        [
                            11.833527663675724,
                            46.29912409465591
                        ],
                        [
                            11.830083341120554,
                            46.29421226722699
                        ],
                        [
                            11.82626082738997,
                            46.28497039753362
                        ],
                        [
                            11.826849762905653,
                            46.28400854613014
                        ],
                        [
                            11.837637585087782,
                            46.27072231098723
                        ],
                        [
                            11.838022091296349,
                            46.270348070821896
                        ],
                        [
                            11.838830228181422,
                            46.26999348693934
                        ],
                        [
                            11.839691090098977,
                            46.26993307878389
                        ],
                        [
                            11.840272371273084,
                            46.2699504971135
                        ],
                        [
                            11.857265880833888,
                            46.27062207728966
                        ],
                        [
                            11.862903896327236,
                            46.271325084923845
                        ],
                        [
                            11.86482760699882,
                            46.27243708942637
                        ],
                        [
                            11.865793055466899,
                            46.27314309359312
                        ],
                        [
                            11.866850915508488,
                            46.27382186915096
                        ],
                        [
                            11.867947223778494,
                            46.274506204872104
                        ],
                        [
                            11.869222399308853,
                            46.27499681070546
                        ],
                        [
                            11.879461250552676,
                            46.278069087876794
                        ],
                        [
                            11.880166815490293,
                            46.2782791217734
                        ],
                        [
                            11.88225208274326,
                            46.27874543947604
                        ],
                        [
                            11.883001221206667,
                            46.27884253821797
                        ],
                        [
                            11.883578841977391,
                            46.27890013043521
                        ],
                        [
                            11.884155967272129,
                            46.2789049808809
                        ],
                        [
                            11.88491748963929,
                            46.27888958778242
                        ],
                        [
                            11.885194688347571,
                            46.27882468866034
                        ],
                        [
                            11.885247948001286,
                            46.2788087575004
                        ],
                        [
                            11.886543523148188,
                            46.27704324531065
                        ],
                        [
                            11.887702789347502,
                            46.27490701919536
                        ],
                        [
                            11.888038135091646,
                            46.274241928855425
                        ],
                        [
                            11.888291631216955,
                            46.27363858948913
                        ],
                        [
                            11.888359029518519,
                            46.272512053734
                        ],
                        [
                            11.887885631914322,
                            46.268499622883354
                        ],
                        [
                            11.887595161251797,
                            46.26605459837596
                        ],
                        [
                            11.887483454627274,
                            46.265179154731534
                        ],
                        [
                            11.887347265898395,
                            46.26441450921854
                        ],
                        [
                            11.887199433593821,
                            46.264076126980044
                        ],
                        [
                            11.886802462126266,
                            46.26381631037615
                        ],
                        [
                            11.886372811877333,
                            46.26354263118195
                        ],
                        [
                            11.885996470101393,
                            46.26328672233858
                        ],
                        [
                            11.885637293753394,
                            46.26294019083091
                        ],
                        [
                            11.885308353270174,
                            46.26247565232248
                        ],
                        [
                            11.885035756158569,
                            46.26193495041686
                        ],
                        [
                            11.884913871425828,
                            46.261623243232236
                        ],
                        [
                            11.884860294846694,
                            46.26148504826668
                        ],
                        [
                            11.884942229086962,
                            46.26073422759689
                        ],
                        [
                            11.885231834875935,
                            46.260094084687694
                        ],
                        [
                            11.885467891716761,
                            46.25958311220518
                        ],
                        [
                            11.885687761110118,
                            46.2591659842202
                        ],
                        [
                            11.886261583179007,
                            46.258190421219425
                        ],
                        [
                            11.889510956522024,
                            46.254832659798964
                        ],
                        [
                            11.891228348200256,
                            46.25316491903792
                        ],
                        [
                            11.891986526191706,
                            46.252628543548376
                        ],
                        [
                            11.894314172852614,
                            46.25105310555528
                        ],
                        [
                            11.894747390415239,
                            46.250936257231416
                        ],
                        [
                            11.897441070886313,
                            46.25187710576536
                        ],
                        [
                            11.898016329296485,
                            46.25221470786838
                        ],
                        [
                            11.900309979103767,
                            46.25370269611706
                        ],
                        [
                            11.913260778500867,
                            46.25217187244438
                        ],
                        [
                            11.91364229223753,
                            46.25192802534193
                        ],
                        [
                            11.915893098358932,
                            46.25050925050454
                        ],
                        [
                            11.920837286354868,
                            46.24811266635692
                        ],
                        [
                            11.921335038211014,
                            46.2478989022382
                        ],
                        [
                            11.921616452673522,
                            46.24782874784067
                        ],
                        [
                            11.922225398365082,
                            46.24782128116559
                        ],
                        [
                            11.922839806229135,
                            46.24788662284538
                        ],
                        [
                            11.924550090311985,
                            46.248104933460674
                        ],
                        [
                            11.927916906230202,
                            46.248599550323355
                        ],
                        [
                            11.929099454439871,
                            46.24883288870454
                        ],
                        [
                            11.926194588307544,
                            46.24469653581297
                        ],
                        [
                            11.925734473143354,
                            46.244081849934055
                        ],
                        [
                            11.925280913768487,
                            46.243495536541545
                        ],
                        [
                            11.924814917214022,
                            46.242952481856435
                        ],
                        [
                            11.923765507011385,
                            46.241953043063795
                        ],
                        [
                            11.923341181146158,
                            46.241583000825386
                        ],
                        [
                            11.9181310338618,
                            46.23837626265964
                        ],
                        [
                            11.91238029116159,
                            46.22903728780411
                        ],
                        [
                            11.909569454531896,
                            46.22442756516879
                        ],
                        [
                            11.915654309321615,
                            46.220986408038726
                        ],
                        [
                            11.917200601378955,
                            46.221250789323186
                        ],
                        [
                            11.9185790049444,
                            46.22111318197658
                        ],
                        [
                            11.919401196854446,
                            46.22082819368253
                        ],
                        [
                            11.9242392123757,
                            46.21716935778446
                        ],
                        [
                            11.924551385672473,
                            46.216841499024405
                        ],
                        [
                            11.925645537994523,
                            46.21567789899671
                        ],
                        [
                            11.926033073143294,
                            46.21508837864359
                        ],
                        [
                            11.926158130913805,
                            46.214864455107005
                        ],
                        [
                            11.92636604211543,
                            46.2144136980247
                        ],
                        [
                            11.926943918095464,
                            46.2120234778224
                        ],
                        [
                            11.927766575391313,
                            46.20904666468708
                        ],
                        [
                            11.93017066855634,
                            46.206468049764815
                        ],
                        [
                            11.934152939117594,
                            46.202233670181414
                        ],
                        [
                            11.939358754295387,
                            46.19882041658043
                        ],
                        [
                            11.939554654903997,
                            46.19877337605558
                        ],
                        [
                            11.953995760365668,
                            46.19938567533056
                        ],
                        [
                            11.962261167975813,
                            46.19982637253777
                        ],
                        [
                            11.962358972767296,
                            46.19979893242896
                        ],
                        [
                            11.962496904509418,
                            46.19975926563701
                        ],
                        [
                            11.96259931253371,
                            46.19966061170484
                        ],
                        [
                            11.962678629355665,
                            46.1905395151762
                        ],
                        [
                            11.962653875546277,
                            46.18995163219425
                        ],
                        [
                            11.962644592667992,
                            46.18980282144154
                        ],
                        [
                            11.962331732049671,
                            46.18801105689617
                        ],
                        [
                            11.962269324687743,
                            46.187859812157015
                        ],
                        [
                            11.961072126474317,
                            46.18644041893303
                        ],
                        [
                            11.958588997618508,
                            46.184321265508345
                        ],
                        [
                            11.958384389361742,
                            46.18425652039466
                        ],
                        [
                            11.958042393528732,
                            46.18419859488041
                        ],
                        [
                            11.95735722897569,
                            46.184121114340314
                        ],
                        [
                            11.952762388277392,
                            46.18325064138962
                        ],
                        [
                            11.95231497077062,
                            46.18311530122943
                        ],
                        [
                            11.95000951378982,
                            46.18209360324787
                        ],
                        [
                            11.949634647613824,
                            46.181768298065315
                        ],
                        [
                            11.949471293782107,
                            46.18162501925826
                        ],
                        [
                            11.949796388672713,
                            46.18035550783265
                        ],
                        [
                            11.950475046340715,
                            46.17810593172041
                        ],
                        [
                            11.95077760620255,
                            46.17713514019346
                        ],
                        [
                            11.951124021898478,
                            46.17612259152669
                        ],
                        [
                            11.951414204062718,
                            46.175237877739505
                        ],
                        [
                            11.95172038592928,
                            46.17417707241597
                        ],
                        [
                            11.952128631179917,
                            46.17270075132138
                        ],
                        [
                            11.952076417199098,
                            46.172591367105376
                        ],
                        [
                            11.950903220928646,
                            46.170268497906704
                        ],
                        [
                            11.949476618518046,
                            46.17034289535744
                        ],
                        [
                            11.948347534412555,
                            46.170551392676416
                        ],
                        [
                            11.941968415804228,
                            46.17244394122747
                        ],
                        [
                            11.9400396526302,
                            46.17301975477139
                        ],
                        [
                            11.937255103458412,
                            46.17388092572977
                        ],
                        [
                            11.936620596049393,
                            46.174436100949656
                        ],
                        [
                            11.935890635183709,
                            46.174913485441806
                        ],
                        [
                            11.935621138165892,
                            46.17507041537703
                        ],
                        [
                            11.930909220832751,
                            46.17556429757734
                        ],
                        [
                            11.928626243220469,
                            46.17580118935435
                        ],
                        [
                            11.929556793045675,
                            46.17081516953639
                        ],
                        [
                            11.929332232739815,
                            46.16986680823486
                        ],
                        [
                            11.929072094178421,
                            46.16892838903753
                        ],
                        [
                            11.92877596153163,
                            46.16790918424748
                        ],
                        [
                            11.928332679427594,
                            46.16657104834252
                        ],
                        [
                            11.927240870562489,
                            46.165783933790586
                        ],
                        [
                            11.923977323589817,
                            46.163535885744864
                        ],
                        [
                            11.921855795776262,
                            46.1622926166989
                        ],
                        [
                            11.918323084184653,
                            46.155271493385214
                        ],
                        [
                            11.919106665237912,
                            46.15341109689577
                        ],
                        [
                            11.919246748974322,
                            46.153078515419026
                        ],
                        [
                            11.919706411098502,
                            46.151989618142395
                        ],
                        [
                            11.919825190052244,
                            46.15171217611773
                        ],
                        [
                            11.9205838201829,
                            46.15087453122327
                        ],
                        [
                            11.921510204927651,
                            46.149798699728365
                        ],
                        [
                            11.921767061193092,
                            46.14934098305263
                        ],
                        [
                            11.912846589413592,
                            46.143344528141704
                        ],
                        [
                            11.90518488366172,
                            46.13943199661885
                        ],
                        [
                            11.901242557043428,
                            46.13662852171503
                        ],
                        [
                            11.905583299353973,
                            46.13449950113313
                        ],
                        [
                            11.904743563843635,
                            46.13299584401001
                        ],
                        [
                            11.893414937041365,
                            46.12114690460889
                        ],
                        [
                            11.89176518096676,
                            46.12047548310594
                        ],
                        [
                            11.887569284714179,
                            46.11869537853073
                        ],
                        [
                            11.87951735175194,
                            46.11772859234094
                        ],
                        [
                            11.87881765656085,
                            46.11783281482851
                        ],
                        [
                            11.878382335456887,
                            46.11787067052551
                        ],
                        [
                            11.878017864493327,
                            46.117882844468156
                        ],
                        [
                            11.876320883122784,
                            46.11773363019542
                        ],
                        [
                            11.875804370211913,
                            46.117670051770126
                        ],
                        [
                            11.850186199351674,
                            46.11300896421566
                        ],
                        [
                            11.841532808979201,
                            46.1111893557917
                        ],
                        [
                            11.827009293727203,
                            46.107407512356154
                        ],
                        [
                            11.822550583193356,
                            46.10789094844265
                        ],
                        [
                            11.821083615157722,
                            46.10795442407124
                        ],
                        [
                            11.819681895478155,
                            46.10796307925595
                        ],
                        [
                            11.818956210368876,
                            46.10778846179076
                        ],
                        [
                            11.81778675952809,
                            46.107214935392065
                        ],
                        [
                            11.816871413963375,
                            46.10657625474232
                        ],
                        [
                            11.816457929293591,
                            46.10619135036234
                        ],
                        [
                            11.81636048332023,
                            46.106085459129844
                        ],
                        [
                            11.81608551854719,
                            46.105786534123496
                        ],
                        [
                            11.815448618474766,
                            46.10490716170415
                        ],
                        [
                            11.815129432817383,
                            46.10441502063974
                        ],
                        [
                            11.814955128879872,
                            46.10391130642493
                        ],
                        [
                            11.814846306732965,
                            46.103441394527174
                        ],
                        [
                            11.814690888367874,
                            46.102923708124074
                        ],
                        [
                            11.813941830826197,
                            46.10232278449721
                        ],
                        [
                            11.813669793680628,
                            46.102265664206406
                        ],
                        [
                            11.80996089274216,
                            46.10203245958513
                        ],
                        [
                            11.808215076510757,
                            46.10238317747818
                        ],
                        [
                            11.793989508045817,
                            46.10312198865821
                        ],
                        [
                            11.783563194793572,
                            46.10272603169636
                        ],
                        [
                            11.781718054606555,
                            46.102697052281684
                        ],
                        [
                            11.780098655565814,
                            46.102699343811274
                        ],
                        [
                            11.77981003389034,
                            46.10273793733585
                        ],
                        [
                            11.777704778702802,
                            46.10305512488146
                        ],
                        [
                            11.777158324433369,
                            46.10317662713326
                        ],
                        [
                            11.775487679362564,
                            46.10412123825562
                        ],
                        [
                            11.775052262042403,
                            46.104379721939544
                        ],
                        [
                            11.77352705604765,
                            46.10627503999213
                        ],
                        [
                            11.77322199930352,
                            46.10669177983037
                        ],
                        [
                            11.773256040510308,
                            46.10608451536859
                        ],
                        [
                            11.773248677044158,
                            46.106049976244805
                        ],
                        [
                            11.773191987480478,
                            46.10582414849792
                        ],
                        [
                            11.771820683221014,
                            46.10350830620854
                        ],
                        [
                            11.765432838525891,
                            46.09867686513289
                        ],
                        [
                            11.763762825521345,
                            46.09788024179909
                        ],
                        [
                            11.758691750025989,
                            46.095601201298564
                        ],
                        [
                            11.751621205953564,
                            46.10425773998714
                        ],
                        [
                            11.750770106397596,
                            46.10513700467113
                        ],
                        [
                            11.745783537284106,
                            46.104335936150804
                        ],
                        [
                            11.719756480226543,
                            46.1031630496534
                        ],
                        [
                            11.718315415029956,
                            46.10331903946411
                        ],
                        [
                            11.718022512249686,
                            46.10332868662776
                        ],
                        [
                            11.71692526501463,
                            46.1030228070488
                        ],
                        [
                            11.716789161492587,
                            46.102936683256246
                        ],
                        [
                            11.711467740130391,
                            46.09912024868104
                        ],
                        [
                            11.710282977298979,
                            46.09791997506268
                        ],
                        [
                            11.70679937227577,
                            46.09434010320242
                        ],
                        [
                            11.705621620343782,
                            46.093065487690055
                        ],
                        [
                            11.704530406011706,
                            46.09185062316823
                        ],
                        [
                            11.703456061758256,
                            46.09049420720788
                        ],
                        [
                            11.69539157989013,
                            46.094319895491665
                        ],
                        [
                            11.695097409897517,
                            46.0944568348773
                        ],
                        [
                            11.691851929865335,
                            46.09502390948795
                        ],
                        [
                            11.691681946788387,
                            46.09504155483802
                        ],
                        [
                            11.689095758226163,
                            46.09490340447745
                        ],
                        [
                            11.688782709849445,
                            46.09487406625475
                        ],
                        [
                            11.688595256211286,
                            46.09485604400715
                        ],
                        [
                            11.688159169554895,
                            46.094789269536776
                        ],
                        [
                            11.68806844446066,
                            46.09475381204622
                        ],
                        [
                            11.687852438978409,
                            46.0946684621592
                        ],
                        [
                            11.68562855603386,
                            46.093736646186336
                        ],
                        [
                            11.685289243013397,
                            46.093568916625756
                        ],
                        [
                            11.683885245483754,
                            46.09226998591565
                        ],
                        [
                            11.683199674627334,
                            46.09147536886984
                        ],
                        [
                            11.682437577586782,
                            46.09024161519928
                        ],
                        [
                            11.682346410473619,
                            46.0899870276195
                        ],
                        [
                            11.68199505810982,
                            46.086932510493725
                        ],
                        [
                            11.682912268661667,
                            46.07903990178384
                        ],
                        [
                            11.683497477701422,
                            46.07628150998273
                        ],
                        [
                            11.686389386142306,
                            46.06625887187939
                        ],
                        [
                            11.686497637686783,
                            46.0660025592578
                        ],
                        [
                            11.687586638236954,
                            46.06443312508899
                        ],
                        [
                            11.6876908165002,
                            46.06428811852747
                        ],
                        [
                            11.689913839277903,
                            46.062813119468544
                        ],
                        [
                            11.690088904707705,
                            46.062698713727265
                        ],
                        [
                            11.69235016350142,
                            46.06227531484747
                        ],
                        [
                            11.703888365947442,
                            46.055127821791835
                        ],
                        [
                            11.704183424634431,
                            46.05479859428956
                        ],
                        [
                            11.704333830209862,
                            46.05455780922204
                        ],
                        [
                            11.706441012288913,
                            46.045993265895866
                        ],
                        [
                            11.706265405168283,
                            46.04573514876438
                        ],
                        [
                            11.706075922540059,
                            46.04555990128453
                        ],
                        [
                            11.70592729752822,
                            46.04551118029428
                        ],
                        [
                            11.705467952017017,
                            46.04536348832575
                        ],
                        [
                            11.704267763539837,
                            46.04501762301568
                        ],
                        [
                            11.703788945772938,
                            46.044889080552714
                        ],
                        [
                            11.703499038767502,
                            46.04483355004722
                        ],
                        [
                            11.701613772120368,
                            46.044603917743146
                        ],
                        [
                            11.701175738554468,
                            46.044551193846914
                        ],
                        [
                            11.70095549455905,
                            46.04452688048137
                        ],
                        [
                            11.700873964495132,
                            46.04451843980798
                        ],
                        [
                            11.70064898038318,
                            46.04450967222305
                        ],
                        [
                            11.687312077805348,
                            46.04413988443701
                        ],
                        [
                            11.684540592251752,
                            46.044142663528355
                        ],
                        [
                            11.683597104840672,
                            46.04416054728877
                        ],
                        [
                            11.683339923301268,
                            46.04424235622225
                        ],
                        [
                            11.682859247551105,
                            46.0444795828902
                        ],
                        [
                            11.679871151223773,
                            46.0458839756394
                        ],
                        [
                            11.679744242361673,
                            46.045929483066146
                        ],
                        [
                            11.679546727865207,
                            46.04597213213503
                        ],
                        [
                            11.678832176902139,
                            46.04604528281618
                        ],
                        [
                            11.666902007585072,
                            46.03806196289282
                        ],
                        [
                            11.666753884327013,
                            46.03794694715774
                        ],
                        [
                            11.666686493512904,
                            46.03779006369258
                        ],
                        [
                            11.666249485028741,
                            46.03631781775014
                        ],
                        [
                            11.66623587865424,
                            46.03606869642922
                        ],
                        [
                            11.666608820963313,
                            46.03534576891612
                        ],
                        [
                            11.672275582466362,
                            46.030127085638014
                        ],
                        [
                            11.672577549781051,
                            46.02985125361412
                        ],
                        [
                            11.673037648579179,
                            46.02948869171192
                        ],
                        [
                            11.67344802832514,
                            46.02928604145568
                        ],
                        [
                            11.675854366188112,
                            46.02863105946829
                        ],
                        [
                            11.676138549529128,
                            46.02856614429571
                        ],
                        [
                            11.679871866163872,
                            46.02820405535287
                        ],
                        [
                            11.680145490112434,
                            46.02818422095605
                        ],
                        [
                            11.680626396182898,
                            46.028259905154876
                        ],
                        [
                            11.681096967497165,
                            46.02838646395692
                        ],
                        [
                            11.681282954527042,
                            46.02841738566529
                        ],
                        [
                            11.681602965136738,
                            46.02846988870692
                        ],
                        [
                            11.681865905867284,
                            46.028415792553446
                        ],
                        [
                            11.681930636840871,
                            46.02794488445343
                        ],
                        [
                            11.681915961276326,
                            46.02744482563865
                        ],
                        [
                            11.681885320891396,
                            46.026946747391
                        ],
                        [
                            11.681869361285953,
                            46.02669111139196
                        ],
                        [
                            11.681191072962983,
                            46.02607955865665
                        ],
                        [
                            11.680765118199046,
                            46.02570725421492
                        ],
                        [
                            11.680591197369802,
                            46.025566464689696
                        ],
                        [
                            11.672414243882292,
                            46.01977300084946
                        ],
                        [
                            11.672085950827883,
                            46.01954238362304
                        ],
                        [
                            11.669971296266908,
                            46.01815208679046
                        ],
                        [
                            11.669798321862212,
                            46.01804480765167
                        ],
                        [
                            11.669175083931322,
                            46.017709081248704
                        ],
                        [
                            11.668662076567522,
                            46.017601846879884
                        ],
                        [
                            11.6666502878016,
                            46.01709889117608
                        ],
                        [
                            11.668736928072722,
                            46.01559361156541
                        ],
                        [
                            11.672578642359014,
                            46.0127501532789
                        ],
                        [
                            11.675104089399401,
                            46.00919727605239
                        ],
                        [
                            11.67747146592862,
                            46.004783014572965
                        ],
                        [
                            11.67853804948268,
                            46.002863692265684
                        ],
                        [
                            11.681179874513246,
                            45.999681713327995
                        ],
                        [
                            11.681673470730495,
                            45.99911235122911
                        ],
                        [
                            11.685295635327325,
                            45.99511987107274
                        ],
                        [
                            11.685666552964147,
                            45.994820259527955
                        ],
                        [
                            11.68585031773561,
                            45.9947203443377
                        ],
                        [
                            11.686059332055455,
                            45.99460815930002
                        ],
                        [
                            11.690004516380622,
                            45.988807204602985
                        ],
                        [
                            11.684283873872776,
                            45.98407845173848
                        ],
                        [
                            11.682315404038208,
                            45.97589095610307
                        ],
                        [
                            11.683800037161738,
                            45.974216240455284
                        ],
                        [
                            11.68557236125918,
                            45.97150143275582
                        ],
                        [
                            11.685768347550088,
                            45.97108699868484
                        ],
                        [
                            11.685964227791635,
                            45.97033900650063
                        ],
                        [
                            11.685804477707393,
                            45.969285853548115
                        ],
                        [
                            11.684525348971583,
                            45.969198809177335
                        ],
                        [
                            11.68330646213238,
                            45.96905024262797
                        ],
                        [
                            11.682666005986471,
                            45.96891847939714
                        ],
                        [
                            11.681745687147275,
                            45.968571063419326
                        ],
                        [
                            11.679522521064648,
                            45.96770517980082
                        ],
                        [
                            11.677718816717501,
                            45.966703416368645
                        ],
                        [
                            11.676084948517655,
                            45.96574264560622
                        ],
                        [
                            11.674413311197227,
                            45.9648007301354
                        ],
                        [
                            11.67323008583034,
                            45.96435139784159
                        ],
                        [
                            11.667952328879231,
                            45.963835774103885
                        ],
                        [
                            11.655912854976588,
                            45.96469244864219
                        ],
                        [
                            11.637261550798911,
                            45.96167743813644
                        ],
                        [
                            11.627608365097283,
                            45.9606413642517
                        ],
                        [
                            11.63067913719972,
                            45.9693791416923
                        ],
                        [
                            11.620924131941445,
                            45.971555872047496
                        ],
                        [
                            11.619295339655233,
                            45.97157622321902
                        ],
                        [
                            11.61865360771157,
                            45.97158330690772
                        ],
                        [
                            11.609090075303964,
                            45.969417032444056
                        ],
                        [
                            11.597868153626653,
                            45.97206702402405
                        ],
                        [
                            11.59424479295379,
                            45.97132132892282
                        ],
                        [
                            11.591744964804537,
                            45.969478949439605
                        ],
                        [
                            11.587592031352598,
                            45.96899707914805
                        ],
                        [
                            11.586665096552698,
                            45.97291085092642
                        ],
                        [
                            11.584185795675056,
                            45.98339353818238
                        ],
                        [
                            11.584162096333362,
                            45.983493736196785
                        ],
                        [
                            11.58198925632965,
                            45.99257048464229
                        ],
                        [
                            11.579826645459555,
                            46.0007650182571
                        ],
                        [
                            11.577230068511549,
                            46.00652028630877
                        ],
                        [
                            11.57216762331225,
                            46.00702199495786
                        ],
                        [
                            11.569429645698454,
                            46.00588014814684
                        ],
                        [
                            11.568190903658596,
                            46.005810856083116
                        ],
                        [
                            11.567002166521442,
                            46.00574449949175
                        ],
                        [
                            11.566799312016995,
                            46.0058027077837
                        ],
                        [
                            11.562763765112793,
                            46.00735482867723
                        ],
                        [
                            11.56012416897811,
                            46.00866092219557
                        ],
                        [
                            11.552411602569942,
                            46.01176790473326
                        ],
                        [
                            11.54452213881391,
                            46.01175754079664
                        ],
                        [
                            11.538910644294186,
                            46.013303872095015
                        ],
                        [
                            11.537929576517904,
                            46.01289128770336
                        ],
                        [
                            11.533165523276221,
                            46.01181797396216
                        ],
                        [
                            11.517208932438336,
                            46.00918257570748
                        ],
                        [
                            11.512737308062995,
                            46.010271101442044
                        ],
                        [
                            11.511346620192331,
                            46.0106527090905
                        ],
                        [
                            11.510704090596755,
                            46.01199865328767
                        ],
                        [
                            11.491200756328809,
                            46.00854961686034
                        ],
                        [
                            11.48968052354254,
                            46.00782433497098
                        ],
                        [
                            11.489050375322071,
                            46.00729469233324
                        ],
                        [
                            11.488622299485229,
                            46.006901486213664
                        ],
                        [
                            11.48847914317955,
                            46.00675746576722
                        ],
                        [
                            11.485239321927484,
                            46.0034211434454
                        ],
                        [
                            11.483758956554393,
                            46.001122446738265
                        ],
                        [
                            11.483483117951806,
                            46.00067321810444
                        ],
                        [
                            11.468045493123125,
                            45.99755597822359
                        ],
                        [
                            11.464133187303158,
                            45.99405358830944
                        ],
                        [
                            11.462025239560594,
                            45.9913144894745
                        ],
                        [
                            11.454399869715381,
                            45.984807080658996
                        ],
                        [
                            11.453820785267608,
                            45.984382826249714
                        ],
                        [
                            11.446781740879837,
                            45.98089345205155
                        ],
                        [
                            11.42241365918911,
                            45.980176757329765
                        ],
                        [
                            11.400149737755818,
                            45.98010182034814
                        ],
                        [
                            11.39415145299054,
                            45.980556831020166
                        ],
                        [
                            11.393771350219303,
                            45.9805962053956
                        ],
                        [
                            11.393459447091962,
                            45.980700855819585
                        ],
                        [
                            11.39274821953832,
                            45.98095526863707
                        ],
                        [
                            11.378189726638064,
                            45.98424654896923
                        ],
                        [
                            11.377920391625441,
                            45.984270945252156
                        ],
                        [
                            11.377460062485447,
                            45.98427407154474
                        ],
                        [
                            11.377126829007931,
                            45.98421548887832
                        ],
                        [
                            11.374356467004196,
                            45.98366993472101
                        ],
                        [
                            11.37401236874133,
                            45.98359494465361
                        ],
                        [
                            11.373739917420465,
                            45.98350283682327
                        ],
                        [
                            11.373375933468164,
                            45.98321409357417
                        ],
                        [
                            11.373290438216157,
                            45.98274281323698
                        ],
                        [
                            11.373249942285117,
                            45.9823733319081
                        ],
                        [
                            11.37261695167727,
                            45.9760497093603
                        ],
                        [
                            11.372396425666416,
                            45.973169322543285
                        ],
                        [
                            11.376109416489989,
                            45.96091052548217
                        ],
                        [
                            11.378087254732721,
                            45.956365359345796
                        ],
                        [
                            11.378295443709671,
                            45.95596952983253
                        ],
                        [
                            11.379557923833138,
                            45.954682351370145
                        ],
                        [
                            11.38330744488032,
                            45.95103069262212
                        ],
                        [
                            11.38235879940469,
                            45.947861144562076
                        ],
                        [
                            11.380749169633178,
                            45.942673602852956
                        ],
                        [
                            11.370450479598734,
                            45.942158426522745
                        ],
                        [
                            11.36975298879626,
                            45.942145985501284
                        ],
                        [
                            11.367853588838447,
                            45.94214933263077
                        ],
                        [
                            11.367177181916686,
                            45.94215488025561
                        ],
                        [
                            11.366200017270684,
                            45.94221593196026
                        ],
                        [
                            11.365212991778053,
                            45.942299556982746
                        ],
                        [
                            11.36426759351154,
                            45.9424344410189
                        ],
                        [
                            11.363441510607169,
                            45.94259209071784
                        ],
                        [
                            11.361567558504936,
                            45.94297735070042
                        ],
                        [
                            11.358295873073077,
                            45.94366347389116
                        ],
                        [
                            11.360141347563069,
                            45.938088684977764
                        ],
                        [
                            11.360644021748184,
                            45.93505791759219
                        ],
                        [
                            11.360666900659586,
                            45.93476877105178
                        ],
                        [
                            11.360652934946419,
                            45.934567912319025
                        ],
                        [
                            11.360592478854999,
                            45.934437906597914
                        ],
                        [
                            11.357835156853048,
                            45.929076931217736
                        ],
                        [
                            11.35805694804277,
                            45.925294623631295
                        ],
                        [
                            11.353590799110327,
                            45.92399340344695
                        ],
                        [
                            11.352943121941431,
                            45.92378202770225
                        ],
                        [
                            11.347999430201428,
                            45.922046444389615
                        ],
                        [
                            11.345477830534781,
                            45.921118521657775
                        ],
                        [
                            11.345034545646689,
                            45.92094421398896
                        ],
                        [
                            11.345931526911626,
                            45.919435113227216
                        ],
                        [
                            11.34628275487176,
                            45.918882669961036
                        ],
                        [
                            11.346514513997155,
                            45.91856622504831
                        ],
                        [
                            11.346871252282915,
                            45.9181013551684
                        ],
                        [
                            11.347961076172371,
                            45.91671943151885
                        ],
                        [
                            11.348544108396332,
                            45.9160363404891
                        ],
                        [
                            11.34897390783644,
                            45.91557307569884
                        ],
                        [
                            11.34946487712639,
                            45.915068453673925
                        ],
                        [
                            11.350084799564245,
                            45.91450148884646
                        ],
                        [
                            11.350688239035083,
                            45.91396828578626
                        ],
                        [
                            11.350223049787921,
                            45.91090027966436
                        ],
                        [
                            11.35020283017926,
                            45.91078330117565
                        ],
                        [
                            11.349315339041599,
                            45.9095312103929
                        ],
                        [
                            11.346817159203164,
                            45.90917800927488
                        ],
                        [
                            11.346107969002004,
                            45.909090130531425
                        ],
                        [
                            11.345540812153727,
                            45.90910251931905
                        ],
                        [
                            11.339684250487313,
                            45.9113349422065
                        ],
                        [
                            11.324349210629334,
                            45.917415884948575
                        ],
                        [
                            11.32416670844196,
                            45.91751763361765
                        ],
                        [
                            11.31822829067248,
                            45.92128024859461
                        ],
                        [
                            11.315810104281239,
                            45.923451361897044
                        ],
                        [
                            11.313753417011823,
                            45.926192147336614
                        ],
                        [
                            11.312394390750022,
                            45.92801729550067
                        ],
                        [
                            11.313023732113756,
                            45.92982345961168
                        ],
                        [
                            11.304599203626983,
                            45.926833398262715
                        ],
                        [
                            11.30182173645408,
                            45.92468895601252
                        ],
                        [
                            11.303429437582398,
                            45.91945321036198
                        ],
                        [
                            11.303775774474307,
                            45.91823656827466
                        ],
                        [
                            11.302888121773686,
                            45.91802215927909
                        ],
                        [
                            11.30079588435016,
                            45.91790414411126
                        ],
                        [
                            11.300670362166995,
                            45.91789937392788
                        ],
                        [
                            11.28370558301554,
                            45.91747127656764
                        ],
                        [
                            11.28170113968189,
                            45.91858569566573
                        ],
                        [
                            11.275295966831116,
                            45.9196913883395
                        ],
                        [
                            11.274464490542906,
                            45.91964610607066
                        ],
                        [
                            11.27383655543549,
                            45.91957778428436
                        ],
                        [
                            11.271741373055738,
                            45.91934954238666
                        ],
                        [
                            11.271040867760512,
                            45.919253219028775
                        ],
                        [
                            11.27081204947846,
                            45.91911543876925
                        ],
                        [
                            11.27070344935092,
                            45.91883089252984
                        ],
                        [
                            11.270640032070016,
                            45.9186250509696
                        ],
                        [
                            11.270657848561635,
                            45.918344876071636
                        ],
                        [
                            11.270770849559268,
                            45.9178701373027
                        ],
                        [
                            11.270880083603021,
                            45.91742172740311
                        ],
                        [
                            11.271101322912182,
                            45.916973540295345
                        ],
                        [
                            11.26993900410605,
                            45.91660809949839
                        ],
                        [
                            11.258322548418718,
                            45.92067793970188
                        ],
                        [
                            11.26123632673242,
                            45.91824822566542
                        ],
                        [
                            11.26043879440777,
                            45.90920568177624
                        ],
                        [
                            11.256965272880471,
                            45.90290660729949
                        ],
                        [
                            11.25637499465109,
                            45.90272526412592
                        ],
                        [
                            11.2557393143882,
                            45.902476573000804
                        ],
                        [
                            11.254544033915636,
                            45.901950499832864
                        ],
                        [
                            11.25170932600508,
                            45.90062480424727
                        ],
                        [
                            11.249712724368475,
                            45.89965590692147
                        ],
                        [
                            11.248972436264552,
                            45.899251284055566
                        ],
                        [
                            11.24889394857626,
                            45.899175941797324
                        ],
                        [
                            11.24936619127723,
                            45.89847132829097
                        ],
                        [
                            11.251121146946593,
                            45.896123218504954
                        ],
                        [
                            11.253447085532956,
                            45.8929797008515
                        ],
                        [
                            11.25408109853594,
                            45.89208106618548
                        ],
                        [
                            11.25463475540481,
                            45.89123704911016
                        ],
                        [
                            11.254706215320553,
                            45.89074524562066
                        ],
                        [
                            11.254763622260143,
                            45.89023548760485
                        ],
                        [
                            11.254794966764985,
                            45.889726027124276
                        ],
                        [
                            11.254852364320671,
                            45.88863345041442
                        ],
                        [
                            11.255080823598847,
                            45.884006557369766
                        ],
                        [
                            11.254394636368724,
                            45.884010710499226
                        ],
                        [
                            11.25375644388668,
                            45.8840592140385
                        ],
                        [
                            11.253062030032796,
                            45.88413112420261
                        ],
                        [
                            11.251697733074128,
                            45.88431091020172
                        ],
                        [
                            11.250447834177109,
                            45.88449404501302
                        ],
                        [
                            11.249740930593616,
                            45.88482222579391
                        ],
                        [
                            11.247922733671619,
                            45.88570964403822
                        ],
                        [
                            11.246818396632206,
                            45.886261566385556
                        ],
                        [
                            11.246440871258372,
                            45.886438540069605
                        ],
                        [
                            11.234939710443651,
                            45.87973324224274
                        ],
                        [
                            11.234849659961792,
                            45.87965695442312
                        ],
                        [
                            11.234849675544666,
                            45.878207755204684
                        ],
                        [
                            11.234966242520695,
                            45.878119416387136
                        ],
                        [
                            11.240353856755611,
                            45.87566855862377
                        ],
                        [
                            11.240651145678687,
                            45.87555064499986
                        ],
                        [
                            11.240865241096019,
                            45.87558818649449
                        ],
                        [
                            11.241482186218235,
                            45.87578983451387
                        ],
                        [
                            11.244363899651463,
                            45.87694609164404
                        ],
                        [
                            11.239323863122348,
                            45.855981907902645
                        ],
                        [
                            11.228164241249036,
                            45.84974666364874
                        ],
                        [
                            11.226640469204163,
                            45.84900232072415
                        ],
                        [
                            11.223817338483869,
                            45.84894032340322
                        ],
                        [
                            11.222721620302575,
                            45.84891664471032
                        ],
                        [
                            11.22186066905394,
                            45.848959863730876
                        ],
                        [
                            11.220860651950872,
                            45.848102720031044
                        ],
                        [
                            11.220523725013162,
                            45.84773853457515
                        ],
                        [
                            11.220176097894118,
                            45.84717892330743
                        ],
                        [
                            11.219698749278225,
                            45.846406444436134
                        ],
                        [
                            11.219159100693672,
                            45.84548951800413
                        ],
                        [
                            11.218453825517345,
                            45.84396175849062
                        ],
                        [
                            11.218281718437243,
                            45.84145698174846
                        ],
                        [
                            11.218387446383336,
                            45.83568279851673
                        ],
                        [
                            11.218430161077002,
                            45.835247443818034
                        ],
                        [
                            11.219039861933075,
                            45.83289795849789
                        ],
                        [
                            11.219069707677114,
                            45.83271623665823
                        ],
                        [
                            11.214866071252866,
                            45.83069053557055
                        ],
                        [
                            11.212841948327885,
                            45.83004590360615
                        ],
                        [
                            11.20806104231564,
                            45.82855441534617
                        ],
                        [
                            11.203131559813803,
                            45.827093039037386
                        ],
                        [
                            11.198665101729683,
                            45.824188757322005
                        ],
                        [
                            11.19762114723414,
                            45.82129226721367
                        ],
                        [
                            11.192209264781335,
                            45.81730269051593
                        ],
                        [
                            11.191820837119138,
                            45.81719775431259
                        ],
                        [
                            11.19158623085847,
                            45.817060932033286
                        ],
                        [
                            11.191088308892208,
                            45.816746349366326
                        ],
                        [
                            11.189141945680491,
                            45.81403867442151
                        ],
                        [
                            11.188821250220084,
                            45.81357254547428
                        ],
                        [
                            11.18867303358788,
                            45.81310856304754
                        ],
                        [
                            11.188499049848373,
                            45.811862931732016
                        ],
                        [
                            11.189451901245835,
                            45.804888946330955
                        ],
                        [
                            11.18960231667539,
                            45.80435428997435
                        ],
                        [
                            11.193061250211434,
                            45.79494518931123
                        ],
                        [
                            11.193306785384484,
                            45.7943253977868
                        ],
                        [
                            11.193510406954614,
                            45.793851439526705
                        ],
                        [
                            11.193723685146319,
                            45.79347934336759
                        ],
                        [
                            11.194888445860634,
                            45.79167560625137
                        ],
                        [
                            11.195428619412535,
                            45.79085905607832
                        ],
                        [
                            11.19586138225138,
                            45.79024374474331
                        ],
                        [
                            11.202787783381316,
                            45.783372968886525
                        ],
                        [
                            11.190071434804786,
                            45.78161507682951
                        ],
                        [
                            11.179384030144245,
                            45.78771775001247
                        ],
                        [
                            11.178383568624032,
                            45.78811450331545
                        ],
                        [
                            11.178131318612895,
                            45.788142286499706
                        ],
                        [
                            11.177029013087523,
                            45.78820547522606
                        ],
                        [
                            11.176793854880739,
                            45.7881728192605
                        ],
                        [
                            11.175936071174199,
                            45.78796800221012
                        ],
                        [
                            11.175672909063032,
                            45.787890702216444
                        ],
                        [
                            11.173966048944274,
                            45.78708141408818
                        ],
                        [
                            11.173808728044419,
                            45.78693805483219
                        ],
                        [
                            11.173664461823584,
                            45.786796265960625
                        ],
                        [
                            11.173549247308893,
                            45.78667054767068
                        ],
                        [
                            11.173567324026385,
                            45.78652094970533
                        ],
                        [
                            11.175180110938863,
                            45.78283064446092
                        ],
                        [
                            11.176848763685665,
                            45.78066057494597
                        ],
                        [
                            11.178323555265203,
                            45.77714479092833
                        ],
                        [
                            11.179060766131911,
                            45.77521862870349
                        ],
                        [
                            11.179779380427032,
                            45.77285512708824
                        ],
                        [
                            11.180585784496836,
                            45.76579621090154
                        ],
                        [
                            11.18059888957442,
                            45.76568113822799
                        ],
                        [
                            11.180655942864053,
                            45.762907469824036
                        ],
                        [
                            11.180450000063448,
                            45.76236210951637
                        ],
                        [
                            11.180240582014035,
                            45.76185286009307
                        ],
                        [
                            11.179356006766131,
                            45.76059967038163
                        ],
                        [
                            11.17773995666346,
                            45.75673341277078
                        ],
                        [
                            11.175061353188298,
                            45.74908968370076
                        ],
                        [
                            11.175102542815058,
                            45.74876016910581
                        ],
                        [
                            11.176108890911497,
                            45.74721026305882
                        ],
                        [
                            11.177059275542897,
                            45.74504972275931
                        ],
                        [
                            11.177130155991469,
                            45.74472100663944
                        ],
                        [
                            11.178430362538931,
                            45.738066416693464
                        ],
                        [
                            11.17465215832131,
                            45.733106869646974
                        ],
                        [
                            11.17453479647589,
                            45.732960511804755
                        ],
                        [
                            11.174164048896957,
                            45.73252568933576
                        ],
                        [
                            11.173760739817306,
                            45.73216455856498
                        ],
                        [
                            11.172901172651914,
                            45.731762344334356
                        ],
                        [
                            11.153187861504831,
                            45.718315881257595
                        ],
                        [
                            11.15229495918461,
                            45.71807567519593
                        ],
                        [
                            11.149499252056673,
                            45.71739633906641
                        ],
                        [
                            11.145903173274379,
                            45.716945434378864
                        ]
                    ]
                ]

            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 5,
                "name": "Prov. autonoma di Bolzano",
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            11.47689681459508,
                            46.3639314013008
                        ],
                        [
                            11.477685948350224,
                            46.36325302834831
                        ],
                        [
                            11.477984674129555,
                            46.36288796344053
                        ],
                        [
                            11.47822769068409,
                            46.362402231892936
                        ],
                        [
                            11.479555663865176,
                            46.356127356742455
                        ],
                        [
                            11.479155884990027,
                            46.35562302385266
                        ],
                        [
                            11.47743269229411,
                            46.35402237682737
                        ],
                        [
                            11.476983964568863,
                            46.35361341469323
                        ],
                        [
                            11.476931100647375,
                            46.35356524042927
                        ],
                        [
                            11.476465236001754,
                            46.35332333179301
                        ],
                        [
                            11.475974614829259,
                            46.35310896084759
                        ],
                        [
                            11.473828800868075,
                            46.352219422152736
                        ],
                        [
                            11.47261105409731,
                            46.35173277159942
                        ],
                        [
                            11.471379314385345,
                            46.351798812588484
                        ],
                        [
                            11.470288783150611,
                            46.35182799056091
                        ],
                        [
                            11.469210213422883,
                            46.351833304811976
                        ],
                        [
                            11.468156404219155,
                            46.35181106369483
                        ],
                        [
                            11.464989329112484,
                            46.35161841938099
                        ],
                        [
                            11.46453693091305,
                            46.351385179035816
                        ],
                        [
                            11.464079114946085,
                            46.35114736282281
                        ],
                        [
                            11.46380496410285,
                            46.35100495076427
                        ],
                        [
                            11.462550052602941,
                            46.350266990299126
                        ],
                        [
                            11.462068062657934,
                            46.34995337264709
                        ],
                        [
                            11.461852752466717,
                            46.34976406453794
                        ],
                        [
                            11.461417252496933,
                            46.34938108270599
                        ],
                        [
                            11.461157692510202,
                            46.34912409820558
                        ],
                        [
                            11.459233919833842,
                            46.34617135014662
                        ],
                        [
                            11.459243576088628,
                            46.346075016851294
                        ],
                        [
                            11.459321804813388,
                            46.3453344664464
                        ],
                        [
                            11.45932500652204,
                            46.345305694174805
                        ],
                        [
                            11.459274594002906,
                            46.344181450590945
                        ],
                        [
                            11.45918906865433,
                            46.34227526335644
                        ],
                        [
                            11.458709088013489,
                            46.340845572510396
                        ],
                        [
                            11.456141437851622,
                            46.336904740604226
                        ],
                        [
                            11.454779862657098,
                            46.33493596402116
                        ],
                        [
                            11.454471643923158,
                            46.334726578876385
                        ],
                        [
                            11.421037282342384,
                            46.325557669507404
                        ],
                        [
                            11.420498383889537,
                            46.32541608085091
                        ],
                        [
                            11.41222834829898,
                            46.32435792836703
                        ],
                        [
                            11.410115152993596,
                            46.32445651858726
                        ],
                        [
                            11.40425138703762,
                            46.32497403020492
                        ],
                        [
                            11.397751554848556,
                            46.31571475023037
                        ],
                        [
                            11.397677009290662,
                            46.31559095503815
                        ],
                        [
                            11.397291726953735,
                            46.314916101145904
                        ],
                        [
                            11.395783177338956,
                            46.30996709639866
                        ],
                        [
                            11.386953726700561,
                            46.30359433104297
                        ],
                        [
                            11.38600101665392,
                            46.3030419367708
                        ],
                        [
                            11.38534201800717,
                            46.30266497079906
                        ],
                        [
                            11.384890734028497,
                            46.302440379783405
                        ],
                        [
                            11.381503447538579,
                            46.301566325245716
                        ],
                        [
                            11.379707486407987,
                            46.30119841518119
                        ],
                        [
                            11.378979656871012,
                            46.30109243008306
                        ],
                        [
                            11.378139323424385,
                            46.30097005762252
                        ],
                        [
                            11.377502060538095,
                            46.30094731854356
                        ],
                        [
                            11.376919792656668,
                            46.30099543012949
                        ],
                        [
                            11.37634328217821,
                            46.301074393247156
                        ],
                        [
                            11.372264365785277,
                            46.30144317530276
                        ],
                        [
                            11.371514877855908,
                            46.30148990728377
                        ],
                        [
                            11.368702333027974,
                            46.30165206436764
                        ],
                        [
                            11.36824862502669,
                            46.301670475234715
                        ],
                        [
                            11.364146890400182,
                            46.30171040045194
                        ],
                        [
                            11.36368442366416,
                            46.30161652038909
                        ],
                        [
                            11.363583584597068,
                            46.30159604976327
                        ],
                        [
                            11.36107497336482,
                            46.3009368994265
                        ],
                        [
                            11.360746371260344,
                            46.300844687719334
                        ],
                        [
                            11.360218736710216,
                            46.30035157662416
                        ],
                        [
                            11.359533727051478,
                            46.29960449563462
                        ],
                        [
                            11.359157770116754,
                            46.299116421704724
                        ],
                        [
                            11.35914698462786,
                            46.299077560955155
                        ],
                        [
                            11.359074510105314,
                            46.29850317781277
                        ],
                        [
                            11.358932157216136,
                            46.296122495945674
                        ],
                        [
                            11.359096797960746,
                            46.296079481012555
                        ],
                        [
                            11.359180456724037,
                            46.29605818028175
                        ],
                        [
                            11.359499116178574,
                            46.295977171290104
                        ],
                        [
                            11.359549707076496,
                            46.295964325631125
                        ],
                        [
                            11.360745361119847,
                            46.29568762665992
                        ],
                        [
                            11.36468056101347,
                            46.29481184951123
                        ],
                        [
                            11.366327056005826,
                            46.294447162093306
                        ],
                        [
                            11.368875000932809,
                            46.29388425930879
                        ],
                        [
                            11.370623323958853,
                            46.29351209684857
                        ],
                        [
                            11.371781486244798,
                            46.29327205793084
                        ],
                        [
                            11.373600051129488,
                            46.29299130026524
                        ],
                        [
                            11.374812797211286,
                            46.29281309921116
                        ],
                        [
                            11.37723672012748,
                            46.292420690147964
                        ],
                        [
                            11.377893992062136,
                            46.292308014453404
                        ],
                        [
                            11.37909101236826,
                            46.2920670926421
                        ],
                        [
                            11.37966889711341,
                            46.29192005945587
                        ],
                        [
                            11.379943084695647,
                            46.29183478650474
                        ],
                        [
                            11.380258190061225,
                            46.29173678661162
                        ],
                        [
                            11.380869901625331,
                            46.29147203800265
                        ],
                        [
                            11.381019861015302,
                            46.29135829446925
                        ],
                        [
                            11.381284714933928,
                            46.29115738435147
                        ],
                        [
                            11.38149624796134,
                            46.290945977251134
                        ],
                        [
                            11.382765582572624,
                            46.28938048973893
                        ],
                        [
                            11.384132765772463,
                            46.287677945443676
                        ],
                        [
                            11.384647067085654,
                            46.28696519970063
                        ],
                        [
                            11.384781163173978,
                            46.28676439079255
                        ],
                        [
                            11.386782247874235,
                            46.280102891674
                        ],
                        [
                            11.389027637659272,
                            46.27903454886562
                        ],
                        [
                            11.389676110517458,
                            46.278583482349994
                        ],
                        [
                            11.38970798736839,
                            46.278561306941086
                        ],
                        [
                            11.390870605426002,
                            46.2775379702482
                        ],
                        [
                            11.393506212509132,
                            46.275169750390155
                        ],
                        [
                            11.393978989346584,
                            46.27470083923237
                        ],
                        [
                            11.39436100013843,
                            46.27423381987647
                        ],
                        [
                            11.394678160597586,
                            46.27376816724325
                        ],
                        [
                            11.396366230349209,
                            46.26961968648064
                        ],
                        [
                            11.396857915719773,
                            46.268148135236025
                        ],
                        [
                            11.396949394903928,
                            46.26779769117324
                        ],
                        [
                            11.397104309446165,
                            46.267201154187774
                        ],
                        [
                            11.39762389425282,
                            46.26483220764218
                        ],
                        [
                            11.388419870037769,
                            46.261469874046
                        ],
                        [
                            11.387818038520814,
                            46.26135644997028
                        ],
                        [
                            11.38772896022358,
                            46.2613667761257
                        ],
                        [
                            11.387249954683773,
                            46.26142232301328
                        ],
                        [
                            11.376190587634461,
                            46.26281557446439
                        ],
                        [
                            11.375014913526082,
                            46.26355832614866
                        ],
                        [
                            11.374761047893534,
                            46.263689605055006
                        ],
                        [
                            11.3742594444679,
                            46.263862572158075
                        ],
                        [
                            11.373909240675006,
                            46.26393489475504
                        ],
                        [
                            11.373678228816745,
                            46.263980125591516
                        ],
                        [
                            11.373617674157362,
                            46.263990292815215
                        ],
                        [
                            11.373545141970393,
                            46.26398639838677
                        ],
                        [
                            11.372801332437493,
                            46.2639464584267
                        ],
                        [
                            11.372380372433467,
                            46.26387367544301
                        ],
                        [
                            11.372089613385567,
                            46.26375433890748
                        ],
                        [
                            11.371840407135645,
                            46.263651602347004
                        ],
                        [
                            11.370232327350855,
                            46.2624531982796
                        ],
                        [
                            11.359537304176417,
                            46.26545400522812
                        ],
                        [
                            11.358780819600133,
                            46.265667625144474
                        ],
                        [
                            11.35728128655878,
                            46.271416030735274
                        ],
                        [
                            11.35724738587414,
                            46.27387721474401
                        ],
                        [
                            11.357163203319319,
                            46.2741464393377
                        ],
                        [
                            11.356428474128593,
                            46.27605388681095
                        ],
                        [
                            11.356292439025802,
                            46.27628620250613
                        ],
                        [
                            11.356203278953899,
                            46.27641384627437
                        ],
                        [
                            11.356146047926835,
                            46.27644688355789
                        ],
                        [
                            11.354314937072488,
                            46.277401358329456
                        ],
                        [
                            11.347386019302798,
                            46.280230554626286
                        ],
                        [
                            11.346575024122933,
                            46.2800852095869
                        ],
                        [
                            11.346064998991814,
                            46.27999668091851
                        ],
                        [
                            11.34444048547851,
                            46.28025502401625
                        ],
                        [
                            11.343959843646603,
                            46.2805478447475
                        ],
                        [
                            11.343706676596259,
                            46.28070208025737
                        ],
                        [
                            11.341925161298871,
                            46.28184562878015
                        ],
                        [
                            11.341551780201701,
                            46.28222229128115
                        ],
                        [
                            11.340479198808994,
                            46.28358729204429
                        ],
                        [
                            11.339231468610931,
                            46.28534786527948
                        ],
                        [
                            11.33896220425043,
                            46.28573138523176
                        ],
                        [
                            11.338522449882142,
                            46.286379395422934
                        ],
                        [
                            11.336320733416022,
                            46.28963041433841
                        ],
                        [
                            11.336597202559878,
                            46.291465496244356
                        ],
                        [
                            11.338239298294154,
                            46.29544490542075
                        ],
                        [
                            11.338517788739875,
                            46.2959677791397
                        ],
                        [
                            11.338610825634749,
                            46.29608874066419
                        ],
                        [
                            11.338634740243778,
                            46.29611983299098
                        ],
                        [
                            11.338719869998199,
                            46.29622878076086
                        ],
                        [
                            11.340338555718079,
                            46.29788177522349
                        ],
                        [
                            11.339363776581852,
                            46.29827806943878
                        ],
                        [
                            11.338791705076199,
                            46.298798760138794
                        ],
                        [
                            11.338250925889557,
                            46.29873282062242
                        ],
                        [
                            11.338070028432348,
                            46.298710647157684
                        ],
                        [
                            11.33378367320856,
                            46.29772425758709
                        ],
                        [
                            11.333699560627043,
                            46.29770297348434
                        ],
                        [
                            11.333547305104858,
                            46.29766442519329
                        ],
                        [
                            11.333469711381305,
                            46.29762047939699
                        ],
                        [
                            11.332140097427812,
                            46.29657436508843
                        ],
                        [
                            11.332130479215532,
                            46.29650908578491
                        ],
                        [
                            11.332142065023522,
                            46.29641400878915
                        ],
                        [
                            11.332207846678525,
                            46.295938261009226
                        ],
                        [
                            11.332315763931422,
                            46.29537848410411
                        ],
                        [
                            11.330973132354641,
                            46.29386363976065
                        ],
                        [
                            11.323231957274437,
                            46.29261844201834
                        ],
                        [
                            11.310880410523193,
                            46.281281055448005
                        ],
                        [
                            11.312384013196265,
                            46.28030014546432
                        ],
                        [
                            11.312815114353896,
                            46.28001090237403
                        ],
                        [
                            11.31393960636462,
                            46.27920673995784
                        ],
                        [
                            11.314105476319545,
                            46.27907915379715
                        ],
                        [
                            11.315776872474412,
                            46.27352856405282
                        ],
                        [
                            11.315851219478647,
                            46.27327252905804
                        ],
                        [
                            11.315767056857839,
                            46.27302053523727
                        ],
                        [
                            11.313833181917149,
                            46.270561334442455
                        ],
                        [
                            11.311637018025536,
                            46.26835295628346
                        ],
                        [
                            11.310136724923979,
                            46.26670739056941
                        ],
                        [
                            11.307783074046563,
                            46.262979001357465
                        ],
                        [
                            11.305616489355062,
                            46.25876708914908
                        ],
                        [
                            11.292089087278132,
                            46.26137271691093
                        ],
                        [
                            11.29080846570748,
                            46.26154689497258
                        ],
                        [
                            11.290212639050216,
                            46.26122133693355
                        ],
                        [
                            11.29012861471508,
                            46.26116950725568
                        ],
                        [
                            11.289315293165794,
                            46.26066780508499
                        ],
                        [
                            11.275163985253158,
                            46.25190075523937
                        ],
                        [
                            11.25886488978535,
                            46.24007836499205
                        ],
                        [
                            11.248945235682529,
                            46.23281736286569
                        ],
                        [
                            11.239472203308344,
                            46.22838180079026
                        ],
                        [
                            11.206429184384845,
                            46.219772403066244
                        ],
                        [
                            11.2016509380793,
                            46.222884043927095
                        ],
                        [
                            11.183654656017815,
                            46.22579782323266
                        ],
                        [
                            11.176059599237211,
                            46.231441035069004
                        ],
                        [
                            11.174638171751425,
                            46.23266729683924
                        ],
                        [
                            11.174591895908733,
                            46.23494815943821
                        ],
                        [
                            11.176171107231982,
                            46.23855553405894
                        ],
                        [
                            11.182055321543876,
                            46.24911302288884
                        ],
                        [
                            11.182161827835529,
                            46.24929017917908
                        ],
                        [
                            11.182288048944592,
                            46.249500093218785
                        ],
                        [
                            11.182417663097292,
                            46.249714866338685
                        ],
                        [
                            11.182513620702238,
                            46.24987378497916
                        ],
                        [
                            11.182707423399407,
                            46.2501805912818
                        ],
                        [
                            11.183450563253732,
                            46.25112943329812
                        ],
                        [
                            11.183517216654044,
                            46.25120660661521
                        ],
                        [
                            11.183588207519632,
                            46.25128878304016
                        ],
                        [
                            11.184107367483657,
                            46.25162087125881
                        ],
                        [
                            11.184271923035551,
                            46.25172067875539
                        ],
                        [
                            11.184546146125069,
                            46.251886983945056
                        ],
                        [
                            11.185066773284134,
                            46.25217404132201
                        ],
                        [
                            11.185352113227491,
                            46.25233084287721
                        ],
                        [
                            11.185557453728888,
                            46.25244365691053
                        ],
                        [
                            11.185898422947432,
                            46.25261714071161
                        ],
                        [
                            11.186132827759156,
                            46.25272065584391
                        ],
                        [
                            11.18641593364322,
                            46.25277810620638
                        ],
                        [
                            11.187083034535057,
                            46.2527969757731
                        ],
                        [
                            11.187319922613385,
                            46.25280144838375
                        ],
                        [
                            11.187966184787404,
                            46.25278007024177
                        ],
                        [
                            11.188240956728125,
                            46.252756814032004
                        ],
                        [
                            11.199532417959658,
                            46.25383155643739
                        ],
                        [
                            11.20237839202023,
                            46.25560463313254
                        ],
                        [
                            11.20161603895891,
                            46.256297982933184
                        ],
                        [
                            11.198283005002128,
                            46.258927191074484
                        ],
                        [
                            11.194157270384663,
                            46.25771945300194
                        ],
                        [
                            11.193514216080638,
                            46.25757880237195
                        ],
                        [
                            11.19294724804817,
                            46.25751317733875
                        ],
                        [
                            11.191637201475519,
                            46.25748431505095
                        ],
                        [
                            11.191535935673011,
                            46.25748293151905
                        ],
                        [
                            11.190950800491882,
                            46.25747497366273
                        ],
                        [
                            11.174896501942303,
                            46.25922344489617
                        ],
                        [
                            11.174624253581742,
                            46.25925503338531
                        ],
                        [
                            11.167137016413971,
                            46.26214515633165
                        ],
                        [
                            11.159833070003119,
                            46.268124987843954
                        ],
                        [
                            11.15581812016084,
                            46.271557846190966
                        ],
                        [
                            11.152773745589725,
                            46.27563028364947
                        ],
                        [
                            11.150668919731153,
                            46.27903764513056
                        ],
                        [
                            11.150189264950884,
                            46.279615501650014
                        ],
                        [
                            11.149969266732226,
                            46.27980221098641
                        ],
                        [
                            11.149775735283557,
                            46.27991576180173
                        ],
                        [
                            11.14966376139462,
                            46.279977831747836
                        ],
                        [
                            11.14581838739649,
                            46.28171460729052
                        ],
                        [
                            11.13885227024688,
                            46.28331578499072
                        ],
                        [
                            11.138810635416224,
                            46.28333005903521
                        ],
                        [
                            11.138953644715295,
                            46.28363290593361
                        ],
                        [
                            11.139001551883672,
                            46.28373094095936
                        ],
                        [
                            11.13908251873291,
                            46.28389647766995
                        ],
                        [
                            11.140612736833903,
                            46.28565387548092
                        ],
                        [
                            11.140891245564527,
                            46.285973199188625
                        ],
                        [
                            11.141079866322402,
                            46.28614238333535
                        ],
                        [
                            11.141310256141598,
                            46.28634778785507
                        ],
                        [
                            11.143671665425247,
                            46.28839154029066
                        ],
                        [
                            11.15238406464305,
                            46.28941579704768
                        ],
                        [
                            11.157709322908246,
                            46.289270383123615
                        ],
                        [
                            11.158062136503757,
                            46.28928621467344
                        ],
                        [
                            11.158436542751556,
                            46.28939232210887
                        ],
                        [
                            11.158649673145032,
                            46.289455123788656
                        ],
                        [
                            11.15887754282925,
                            46.28952940536094
                        ],
                        [
                            11.159249735895264,
                            46.28965079552079
                        ],
                        [
                            11.16287818198736,
                            46.29117069347117
                        ],
                        [
                            11.169642783790326,
                            46.299394561329706
                        ],
                        [
                            11.178619413697575,
                            46.30706708240606
                        ],
                        [
                            11.184138197310991,
                            46.315368107255544
                        ],
                        [
                            11.194503931745004,
                            46.32885801749072
                        ],
                        [
                            11.19460801434563,
                            46.32890614064112
                        ],
                        [
                            11.194860428448258,
                            46.32904529820318
                        ],
                        [
                            11.195124928926454,
                            46.32924271756833
                        ],
                        [
                            11.195479285860161,
                            46.32954166146022
                        ],
                        [
                            11.197143060291443,
                            46.33141794974038
                        ],
                        [
                            11.197341428748755,
                            46.331706636435314
                        ],
                        [
                            11.203458537718065,
                            46.341668921609354
                        ],
                        [
                            11.203554599393524,
                            46.34183804555164
                        ],
                        [
                            11.203612231428922,
                            46.34209796452822
                        ],
                        [
                            11.203574120337171,
                            46.342323823501786
                        ],
                        [
                            11.203562204232139,
                            46.34237104010292
                        ],
                        [
                            11.198966837838357,
                            46.349558463459445
                        ],
                        [
                            11.196268626337027,
                            46.353507313401934
                        ],
                        [
                            11.192877227811682,
                            46.35592085780534
                        ],
                        [
                            11.191853331420928,
                            46.359001529412716
                        ],
                        [
                            11.191555943777605,
                            46.35965033183534
                        ],
                        [
                            11.191564945796683,
                            46.359794164116146
                        ],
                        [
                            11.19262416649963,
                            46.36323457762333
                        ],
                        [
                            11.192982032847643,
                            46.36430298339305
                        ],
                        [
                            11.19305653912032,
                            46.36445905426314
                        ],
                        [
                            11.193166912125916,
                            46.36457843837744
                        ],
                        [
                            11.193588104283416,
                            46.36492552477192
                        ],
                        [
                            11.193706189048381,
                            46.365004075524105
                        ],
                        [
                            11.193756860612963,
                            46.36502576157168
                        ],
                        [
                            11.194324147751317,
                            46.36519072994955
                        ],
                        [
                            11.194655583292242,
                            46.36526986901567
                        ],
                        [
                            11.196528395090157,
                            46.3653688911877
                        ],
                        [
                            11.19684681711355,
                            46.36516477344244
                        ],
                        [
                            11.197087864051944,
                            46.36501613540746
                        ],
                        [
                            11.197417935530591,
                            46.36481628945847
                        ],
                        [
                            11.197549047797398,
                            46.364773886680524
                        ],
                        [
                            11.197586347458966,
                            46.36477147662119
                        ],
                        [
                            11.197698198564742,
                            46.36476590510456
                        ],
                        [
                            11.197864591089889,
                            46.36477170300826
                        ],
                        [
                            11.199477262621773,
                            46.36490717905967
                        ],
                        [
                            11.20018001541965,
                            46.365006158158074
                        ],
                        [
                            11.200370555048998,
                            46.36503447918415
                        ],
                        [
                            11.200768932924388,
                            46.3651028167076
                        ],
                        [
                            11.201619248838943,
                            46.365275441733495
                        ],
                        [
                            11.201850411573327,
                            46.365324991985915
                        ],
                        [
                            11.202115289988374,
                            46.36544588920196
                        ],
                        [
                            11.202935504893825,
                            46.3658395772182
                        ],
                        [
                            11.205636448599352,
                            46.36716907832983
                        ],
                        [
                            11.202834314163553,
                            46.36966653500484
                        ],
                        [
                            11.201725109782927,
                            46.37453891208731
                        ],
                        [
                            11.206526504869595,
                            46.38423664980746
                        ],
                        [
                            11.206812617479693,
                            46.38752678954136
                        ],
                        [
                            11.20836088021369,
                            46.388185377221035
                        ],
                        [
                            11.209980325756781,
                            46.3896210527191
                        ],
                        [
                            11.212312766372742,
                            46.393364942714115
                        ],
                        [
                            11.2123606050318,
                            46.39346239354743
                        ],
                        [
                            11.212378361324207,
                            46.393498680036764
                        ],
                        [
                            11.214187254298217,
                            46.398463136477574
                        ],
                        [
                            11.215078085795234,
                            46.40444007643036
                        ],
                        [
                            11.215231063116049,
                            46.40681287463596
                        ],
                        [
                            11.214125362921171,
                            46.40810329441294
                        ],
                        [
                            11.213783016879615,
                            46.408481627848985
                        ],
                        [
                            11.21314075265793,
                            46.409153130910546
                        ],
                        [
                            11.2129893138728,
                            46.409286286866546
                        ],
                        [
                            11.212522964021531,
                            46.40974081274263
                        ],
                        [
                            11.21185468558788,
                            46.41042874194966
                        ],
                        [
                            11.209832974400326,
                            46.412552086048876
                        ],
                        [
                            11.209632287982163,
                            46.4127866638725
                        ],
                        [
                            11.209564010464316,
                            46.41289115085497
                        ],
                        [
                            11.209538371232643,
                            46.41293062821746
                        ],
                        [
                            11.209467751805791,
                            46.41314875047938
                        ],
                        [
                            11.209425176141913,
                            46.41328218141867
                        ],
                        [
                            11.209394354626248,
                            46.41337881089663
                        ],
                        [
                            11.209135282194776,
                            46.41485530925261
                        ],
                        [
                            11.20721182465583,
                            46.416644104571226
                        ],
                        [
                            11.207532345180917,
                            46.416533331420105
                        ],
                        [
                            11.207632640484324,
                            46.41650559414484
                        ],
                        [
                            11.207847804789912,
                            46.41644617573846
                        ],
                        [
                            11.209101857493438,
                            46.41648494622899
                        ],
                        [
                            11.211441408122544,
                            46.41915500556647
                        ],
                        [
                            11.211608518007097,
                            46.419368260448586
                        ],
                        [
                            11.211666299910819,
                            46.41945672854777
                        ],
                        [
                            11.21175558543595,
                            46.41972186286766
                        ],
                        [
                            11.211806266223526,
                            46.419954501673175
                        ],
                        [
                            11.211834746388107,
                            46.420085280469365
                        ],
                        [
                            11.211843751602693,
                            46.42064944250334
                        ],
                        [
                            11.211758020070693,
                            46.42091959666261
                        ],
                        [
                            11.211008845338709,
                            46.42220874857465
                        ],
                        [
                            11.21092931671098,
                            46.4222887587268
                        ],
                        [
                            11.20871929726668,
                            46.42411958455737
                        ],
                        [
                            11.207470170279098,
                            46.424992688729645
                        ],
                        [
                            11.207321047329922,
                            46.42506308005109
                        ],
                        [
                            11.206966681594531,
                            46.425230379602716
                        ],
                        [
                            11.205485770532748,
                            46.42600516024775
                        ],
                        [
                            11.205366509641696,
                            46.426085195935165
                        ],
                        [
                            11.205243915910419,
                            46.426208606467
                        ],
                        [
                            11.205161041290893,
                            46.42633200665196
                        ],
                        [
                            11.205096817339657,
                            46.42648018578124
                        ],
                        [
                            11.205031588358326,
                            46.42669773191101
                        ],
                        [
                            11.205031444901696,
                            46.426818870995646
                        ],
                        [
                            11.207568875779195,
                            46.4302955433894
                        ],
                        [
                            11.207621244203281,
                            46.43033482769977
                        ],
                        [
                            11.207656140092393,
                            46.430360975543266
                        ],
                        [
                            11.207724442619575,
                            46.430412136261744
                        ],
                        [
                            11.208019029361608,
                            46.43063159740312
                        ],
                        [
                            11.210202125432339,
                            46.43220951523716
                        ],
                        [
                            11.210250117366861,
                            46.43224078206707
                        ],
                        [
                            11.21037922609874,
                            46.432313897240256
                        ],
                        [
                            11.21129301848836,
                            46.432732186241104
                        ],
                        [
                            11.211996628138564,
                            46.43292718208871
                        ],
                        [
                            11.212448742233049,
                            46.433008729415555
                        ],
                        [
                            11.216492522231217,
                            46.43766119629031
                        ],
                        [
                            11.217761102786492,
                            46.441882286531296
                        ],
                        [
                            11.216971010355234,
                            46.44369050993111
                        ],
                        [
                            11.215821576190661,
                            46.44893371857441
                        ],
                        [
                            11.212957197678113,
                            46.45054744379551
                        ],
                        [
                            11.2123704689787,
                            46.45535816534998
                        ],
                        [
                            11.21277157288864,
                            46.45533865983489
                        ],
                        [
                            11.21317521367349,
                            46.45538030530956
                        ],
                        [
                            11.217694118355796,
                            46.45610721423643
                        ],
                        [
                            11.217986751655427,
                            46.45617804103914
                        ],
                        [
                            11.21817964050857,
                            46.45623729902433
                        ],
                        [
                            11.218306837776689,
                            46.45632482141916
                        ],
                        [
                            11.218438821951867,
                            46.45644825960856
                        ],
                        [
                            11.218540865032114,
                            46.456551914510236
                        ],
                        [
                            11.218663641559536,
                            46.45669139625535
                        ],
                        [
                            11.219095953788795,
                            46.45719599816995
                        ],
                        [
                            11.220031205673655,
                            46.45918031881837
                        ],
                        [
                            11.220158144626948,
                            46.45948807663424
                        ],
                        [
                            11.2203202410186,
                            46.45988119641885
                        ],
                        [
                            11.220402934674853,
                            46.46023508484534
                        ],
                        [
                            11.220421332791918,
                            46.46204820616549
                        ],
                        [
                            11.220355842602778,
                            46.462679463917915
                        ],
                        [
                            11.21881807339333,
                            46.46914423701159
                        ],
                        [
                            11.21785529982017,
                            46.47285737329461
                        ],
                        [
                            11.217740739071948,
                            46.473110588660134
                        ],
                        [
                            11.217144525797185,
                            46.474304798634705
                        ],
                        [
                            11.216857667276388,
                            46.4747872014947
                        ],
                        [
                            11.216633317055377,
                            46.47508154400439
                        ],
                        [
                            11.215016538703264,
                            46.47717906276624
                        ],
                        [
                            11.21223996435644,
                            46.477388264820306
                        ],
                        [
                            11.212987606326614,
                            46.47974635353979
                        ],
                        [
                            11.213060304582447,
                            46.48001068703759
                        ],
                        [
                            11.213025321087333,
                            46.480272368354456
                        ],
                        [
                            11.210487007020557,
                            46.49314625674894
                        ],
                        [
                            11.21025561404601,
                            46.49378522116749
                        ],
                        [
                            11.21017568396675,
                            46.49391554607404
                        ],
                        [
                            11.210093585233823,
                            46.49404934720868
                        ],
                        [
                            11.210019644120658,
                            46.49415428179078
                        ],
                        [
                            11.209617804565458,
                            46.49469965560822
                        ],
                        [
                            11.209465177156144,
                            46.49486275058806
                        ],
                        [
                            11.209422071680574,
                            46.49490560598978
                        ],
                        [
                            11.209095080484653,
                            46.495216126986655
                        ],
                        [
                            11.208909755980608,
                            46.495386202433416
                        ],
                        [
                            11.208695405864681,
                            46.49557387604721
                        ],
                        [
                            11.208304419503278,
                            46.49584339002066
                        ],
                        [
                            11.198256781971411,
                            46.50225400471894
                        ],
                        [
                            11.18983831115406,
                            46.50687296091178
                        ],
                        [
                            11.187084975607835,
                            46.508728587849255
                        ],
                        [
                            11.18298565309394,
                            46.5036692199927
                        ],
                        [
                            11.179515597286118,
                            46.4996077008401
                        ],
                        [
                            11.179171648532934,
                            46.49922443161342
                        ],
                        [
                            11.179135387434647,
                            46.499187025343026
                        ],
                        [
                            11.179069253413461,
                            46.499120513105595
                        ],
                        [
                            11.178890277689678,
                            46.49898199687011
                        ],
                        [
                            11.178606245782781,
                            46.498771139648134
                        ],
                        [
                            11.178391650337415,
                            46.49869873507516
                        ],
                        [
                            11.176319265323366,
                            46.498000219626554
                        ],
                        [
                            11.17567901693588,
                            46.49783690402484
                        ],
                        [
                            11.175271193128813,
                            46.49774116823366
                        ],
                        [
                            11.172890086855181,
                            46.49735812780164
                        ],
                        [
                            11.16134759635026,
                            46.49058065718848
                        ],
                        [
                            11.160866495771533,
                            46.4895814958333
                        ],
                        [
                            11.160513550830363,
                            46.48902098108663
                        ],
                        [
                            11.160442723045294,
                            46.48891451789008
                        ],
                        [
                            11.160145364932825,
                            46.48872664163751
                        ],
                        [
                            11.160011185447814,
                            46.4886706756868
                        ],
                        [
                            11.155508500980693,
                            46.48691969680839
                        ],
                        [
                            11.154928700316175,
                            46.48675513518491
                        ],
                        [
                            11.15376145247963,
                            46.48645344385635
                        ],
                        [
                            11.153464247997626,
                            46.48637773284069
                        ],
                        [
                            11.151008149205536,
                            46.48575798095352
                        ],
                        [
                            11.150705500195448,
                            46.485682681998895
                        ],
                        [
                            11.15029350352775,
                            46.48560043184896
                        ],
                        [
                            11.129678620462217,
                            46.48162936049757
                        ],
                        [
                            11.1274607815603,
                            46.484002634576804
                        ],
                        [
                            11.125475406080291,
                            46.4867170144341
                        ],
                        [
                            11.122459328810782,
                            46.4906564665581
                        ],
                        [
                            11.122195613462335,
                            46.49082784182343
                        ],
                        [
                            11.111326179915721,
                            46.49750897125797
                        ],
                        [
                            11.111101586582024,
                            46.497598620018536
                        ],
                        [
                            11.110850035336084,
                            46.49761653489799
                        ],
                        [
                            11.11049875737403,
                            46.4975962443565
                        ],
                        [
                            11.109946745255282,
                            46.49748957590845
                        ],
                        [
                            11.109512917854364,
                            46.49738044524346
                        ],
                        [
                            11.108989648708002,
                            46.49716060666739
                        ],
                        [
                            11.103914053945164,
                            46.49635834874336
                        ],
                        [
                            11.089447396892556,
                            46.501847885667736
                        ],
                        [
                            11.08928041705073,
                            46.50203309513211
                        ],
                        [
                            11.08849113273517,
                            46.50304078913743
                        ],
                        [
                            11.088475849360352,
                            46.50314294937779
                        ],
                        [
                            11.088405355405076,
                            46.50362251453848
                        ],
                        [
                            11.088388447690283,
                            46.50373773801704
                        ],
                        [
                            11.088361076015484,
                            46.50392487516094
                        ],
                        [
                            11.0883366294255,
                            46.50433368376712
                        ],
                        [
                            11.08823693443944,
                            46.506735181153054
                        ],
                        [
                            11.088209556582632,
                            46.5078058515204
                        ],
                        [
                            11.088231936962806,
                            46.50836316788125
                        ],
                        [
                            11.088284597384744,
                            46.50880349741218
                        ],
                        [
                            11.088302099778906,
                            46.50894962685483
                        ],
                        [
                            11.08842440744213,
                            46.509457844392564
                        ],
                        [
                            11.0885335746144,
                            46.50984007715647
                        ],
                        [
                            11.088824381589651,
                            46.51037765788112
                        ],
                        [
                            11.088945894176481,
                            46.51067996653329
                        ],
                        [
                            11.089091505124744,
                            46.51146648536058
                        ],
                        [
                            11.08907296093433,
                            46.5118552898572
                        ],
                        [
                            11.088875000473504,
                            46.512683199640875
                        ],
                        [
                            11.088819386615622,
                            46.51282110507888
                        ],
                        [
                            11.088588587549669,
                            46.513091794985804
                        ],
                        [
                            11.086359907401294,
                            46.51548420331611
                        ],
                        [
                            11.08648364305617,
                            46.5209521535025
                        ],
                        [
                            11.082425766291676,
                            46.531374584949226
                        ],
                        [
                            11.081072872023197,
                            46.53123581869131
                        ],
                        [
                            11.080794463718922,
                            46.531197413783566
                        ],
                        [
                            11.080636647267314,
                            46.53117563337357
                        ],
                        [
                            11.080433956034314,
                            46.53111676293837
                        ],
                        [
                            11.080298897447369,
                            46.531077492628825
                        ],
                        [
                            11.066686206268953,
                            46.524174765788125
                        ],
                        [
                            11.066597249995043,
                            46.5240984217008
                        ],
                        [
                            11.066560440571621,
                            46.52406679654372
                        ],
                        [
                            11.064927155839708,
                            46.52259862931761
                        ],
                        [
                            11.053761768312356,
                            46.51640683565846
                        ],
                        [
                            11.050903179680978,
                            46.51660996988945
                        ],
                        [
                            11.04473020414537,
                            46.51684772150685
                        ],
                        [
                            11.044278722765329,
                            46.51682646318708
                        ],
                        [
                            11.044195906519468,
                            46.5168215017693
                        ],
                        [
                            11.044092702415059,
                            46.516815301009615
                        ],
                        [
                            11.034779169332161,
                            46.51408062319779
                        ],
                        [
                            11.034600957085248,
                            46.513778739181355
                        ],
                        [
                            11.049005955067274,
                            46.507041789795494
                        ],
                        [
                            11.049399511428232,
                            46.50467367043143
                        ],
                        [
                            11.049433152677775,
                            46.50452942994751
                        ],
                        [
                            11.049488058455863,
                            46.50436164808671
                        ],
                        [
                            11.055396425592049,
                            46.493435876644504
                        ],
                        [
                            11.055725850736458,
                            46.49285892099537
                        ],
                        [
                            11.055980861248479,
                            46.492423415949354
                        ],
                        [
                            11.056164716733793,
                            46.49210944072509
                        ],
                        [
                            11.0563353499324,
                            46.49185527758169
                        ],
                        [
                            11.056749306210971,
                            46.49135220018029
                        ],
                        [
                            11.058024324312203,
                            46.490012226314235
                        ],
                        [
                            11.058071716486,
                            46.48996461982755
                        ],
                        [
                            11.058139199763797,
                            46.48989683665119
                        ],
                        [
                            11.061963198956523,
                            46.48623532081836
                        ],
                        [
                            11.064238597751332,
                            46.479695750347055
                        ],
                        [
                            11.065987922575054,
                            46.47362167183464
                        ],
                        [
                            11.066464793682325,
                            46.46994265981212
                        ],
                        [
                            11.067075080520082,
                            46.467379279946876
                        ],
                        [
                            11.067964969065072,
                            46.4653307493594
                        ],
                        [
                            11.07046026854386,
                            46.46317250975176
                        ],
                        [
                            11.074560879315127,
                            46.455131594211004
                        ],
                        [
                            11.074620714623567,
                            46.45501056559917
                        ],
                        [
                            11.074690576270728,
                            46.45482334150326
                        ],
                        [
                            11.076274786025339,
                            46.44592011731176
                        ],
                        [
                            11.076120293892888,
                            46.445435541699304
                        ],
                        [
                            11.07539513470127,
                            46.44342492439749
                        ],
                        [
                            11.075142482723239,
                            46.44278973787883
                        ],
                        [
                            11.075023245808218,
                            46.44252568052941
                        ],
                        [
                            11.074952389412408,
                            46.44240553769257
                        ],
                        [
                            11.07485361015059,
                            46.44234692835682
                        ],
                        [
                            11.073289942258722,
                            46.44167656664787
                        ],
                        [
                            11.073182261198859,
                            46.44163205730613
                        ],
                        [
                            11.073108435255822,
                            46.44160382771295
                        ],
                        [
                            11.072821381416203,
                            46.4414941801541
                        ],
                        [
                            11.072672047208288,
                            46.44152145755573
                        ],
                        [
                            11.071730051620925,
                            46.44179428172556
                        ],
                        [
                            11.067551746542934,
                            46.44310921382958
                        ],
                        [
                            11.06706909430409,
                            46.443361998341416
                        ],
                        [
                            11.066593834970222,
                            46.44372005434535
                        ],
                        [
                            11.066165042085277,
                            46.44412753135983
                        ],
                        [
                            11.065831264573772,
                            46.4444767450501
                        ],
                        [
                            11.065661528637737,
                            46.444794717837205
                        ],
                        [
                            11.06552223281912,
                            46.44508333610529
                        ],
                        [
                            11.065423466930065,
                            46.44534043319699
                        ],
                        [
                            11.065249234353297,
                            46.44570861795785
                        ],
                        [
                            11.065045036856677,
                            46.44608324675299
                        ],
                        [
                            11.064557137720202,
                            46.4462766023331
                        ],
                        [
                            11.054187646973041,
                            46.44966131697308
                        ],
                        [
                            11.054095013531771,
                            46.44969148323876
                        ],
                        [
                            11.053979823272059,
                            46.4497240526784
                        ],
                        [
                            11.049799033001714,
                            46.44964195590291
                        ],
                        [
                            11.048991594130234,
                            46.44944903707157
                        ],
                        [
                            11.047582296769052,
                            46.446498020648264
                        ],
                        [
                            11.047505522249113,
                            46.446458788947
                        ],
                        [
                            11.047310220908455,
                            46.44640304281204
                        ],
                        [
                            11.0471747368792,
                            46.446382639796646
                        ],
                        [
                            11.046046695933088,
                            46.446412104818286
                        ],
                        [
                            11.042418954419281,
                            46.44654708524222
                        ],
                        [
                            11.042083319811223,
                            46.446659719217244
                        ],
                        [
                            11.04145951367626,
                            46.447084114869206
                        ],
                        [
                            11.041382369265168,
                            46.44713735263639
                        ],
                        [
                            11.041239306833052,
                            46.44723618463331
                        ],
                        [
                            11.033920496418741,
                            46.454297327054306
                        ],
                        [
                            11.033825616216125,
                            46.4543989319628
                        ],
                        [
                            11.033787526515457,
                            46.454439755449854
                        ],
                        [
                            11.031535828183952,
                            46.45799175024073
                        ],
                        [
                            11.0310768660091,
                            46.45962433017683
                        ],
                        [
                            11.031006616350268,
                            46.459897826017354
                        ],
                        [
                            11.030655768171771,
                            46.460641217418626
                        ],
                        [
                            11.03047154349248,
                            46.46084248358108
                        ],
                        [
                            11.029201242329986,
                            46.462027402720125
                        ],
                        [
                            11.022632721687929,
                            46.465231361017764
                        ],
                        [
                            11.020487344010565,
                            46.46554842907232
                        ],
                        [
                            11.01927036828851,
                            46.46576148340627
                        ],
                        [
                            11.011186327858928,
                            46.47019445359795
                        ],
                        [
                            11.008821478120886,
                            46.47240131061878
                        ],
                        [
                            11.005980257073565,
                            46.47668641616172
                        ],
                        [
                            11.005858811790745,
                            46.47680406739996
                        ],
                        [
                            11.005596768661977,
                            46.47693801234884
                        ],
                        [
                            11.005358559769554,
                            46.47704485943769
                        ],
                        [
                            10.995375281487151,
                            46.48061535014532
                        ],
                        [
                            10.988512298908145,
                            46.48355185509846
                        ],
                        [
                            10.97866601980004,
                            46.48394478083182
                        ],
                        [
                            10.97574821994617,
                            46.48402513552345
                        ],
                        [
                            10.9751079215353,
                            46.48397320031135
                        ],
                        [
                            10.974538915923466,
                            46.48388169815986
                        ],
                        [
                            10.963782526010165,
                            46.48207134200334
                        ],
                        [
                            10.9637363396338,
                            46.48187413139566
                        ],
                        [
                            10.963479620128995,
                            46.47980859627337
                        ],
                        [
                            10.962839554494652,
                            46.47781082365036
                        ],
                        [
                            10.962802859246192,
                            46.47771001175065
                        ],
                        [
                            10.962692742751377,
                            46.47749115995678
                        ],
                        [
                            10.960315911784534,
                            46.4740144002654
                        ],
                        [
                            10.959650979247506,
                            46.473322433007176
                        ],
                        [
                            10.958109774624132,
                            46.47175587228704
                        ],
                        [
                            10.957556030444122,
                            46.47120737125058
                        ],
                        [
                            10.957165936500132,
                            46.47086305767229
                        ],
                        [
                            10.956764447089865,
                            46.47056393259919
                        ],
                        [
                            10.956694051731784,
                            46.470518287684406
                        ],
                        [
                            10.956563712393107,
                            46.47044096485628
                        ],
                        [
                            10.956234381598833,
                            46.47031201084441
                        ],
                        [
                            10.95577297505576,
                            46.47015790706723
                        ],
                        [
                            10.944239928945743,
                            46.46651588275175
                        ],
                        [
                            10.939120298583479,
                            46.4666886474854
                        ],
                        [
                            10.9385653651065,
                            46.4668330532785
                        ],
                        [
                            10.93761009277377,
                            46.46707424210557
                        ],
                        [
                            10.937298959725064,
                            46.467115511252835
                        ],
                        [
                            10.937180535783412,
                            46.46708152106568
                        ],
                        [
                            10.935227000772311,
                            46.46488265111732
                        ],
                        [
                            10.931775016291553,
                            46.460450131452866
                        ],
                        [
                            10.930916319125322,
                            46.458617299029406
                        ],
                        [
                            10.930899660586004,
                            46.45852995400618
                        ],
                        [
                            10.930978285666521,
                            46.45707066266876
                        ],
                        [
                            10.93220833673365,
                            46.453557956381864
                        ],
                        [
                            10.928967529538875,
                            46.45212770432643
                        ],
                        [
                            10.92332835009451,
                            46.449337806955874
                        ],
                        [
                            10.919372508180219,
                            46.4473572915198
                        ],
                        [
                            10.915148150505846,
                            46.44496218256127
                        ],
                        [
                            10.914617577459994,
                            46.44468307536472
                        ],
                        [
                            10.913044293138537,
                            46.44399842771803
                        ],
                        [
                            10.912465787855377,
                            46.44383711291064
                        ],
                        [
                            10.911994540071294,
                            46.443763992276544
                        ],
                        [
                            10.911694331460223,
                            46.44374201010712
                        ],
                        [
                            10.897646377930815,
                            46.444111042964316
                        ],
                        [
                            10.897458960079861,
                            46.444125787737065
                        ],
                        [
                            10.89677645754138,
                            46.44417948066279
                        ],
                        [
                            10.892223011488484,
                            46.444650924019896
                        ],
                        [
                            10.891965259555647,
                            46.44472719503519
                        ],
                        [
                            10.891462869496754,
                            46.44492369698354
                        ],
                        [
                            10.887274014016606,
                            46.4468656863442
                        ],
                        [
                            10.887158760805342,
                            46.446921589863074
                        ],
                        [
                            10.886408767434283,
                            46.44782495029049
                        ],
                        [
                            10.885873750871673,
                            46.44854476050404
                        ],
                        [
                            10.88540160802596,
                            46.4492005312713
                        ],
                        [
                            10.884959221449835,
                            46.44993744007126
                        ],
                        [
                            10.884454521595922,
                            46.450809114043494
                        ],
                        [
                            10.88363257407096,
                            46.45115551270186
                        ],
                        [
                            10.882816524850192,
                            46.45098864013595
                        ],
                        [
                            10.880903077447428,
                            46.45052560004966
                        ],
                        [
                            10.880744430590799,
                            46.45045621451789
                        ],
                        [
                            10.880623819106578,
                            46.45038118300431
                        ],
                        [
                            10.874757615951,
                            46.44560464330327
                        ],
                        [
                            10.865619924574581,
                            46.43804127634798
                        ],
                        [
                            10.861324055865436,
                            46.43613133397988
                        ],
                        [
                            10.8573546914879,
                            46.436924876736164
                        ],
                        [
                            10.84094766981643,
                            46.43948520006537
                        ],
                        [
                            10.840671403953401,
                            46.4393996484778
                        ],
                        [
                            10.839977270368058,
                            46.439275826135706
                        ],
                        [
                            10.839062250118012,
                            46.43916455003071
                        ],
                        [
                            10.838526988027535,
                            46.43911915764618
                        ],
                        [
                            10.835067869112319,
                            46.43884174143596
                        ],
                        [
                            10.826438498702753,
                            46.44044689423967
                        ],
                        [
                            10.822239648224585,
                            46.44180086489893
                        ],
                        [
                            10.821060648722943,
                            46.442245303143416
                        ],
                        [
                            10.81623772177041,
                            46.44296734007344
                        ],
                        [
                            10.811813400332918,
                            46.443424528724435
                        ],
                        [
                            10.811343764496938,
                            46.443395972340795
                        ],
                        [
                            10.810776784494816,
                            46.44317995863385
                        ],
                        [
                            10.810471848162127,
                            46.443013794812785
                        ],
                        [
                            10.80989712835171,
                            46.44256390821349
                        ],
                        [
                            10.809428593049105,
                            46.44217532653796
                        ],
                        [
                            10.80915384987287,
                            46.44213467766401
                        ],
                        [
                            10.807759549094248,
                            46.442197336689645
                        ],
                        [
                            10.805385710621396,
                            46.44235623946931
                        ],
                        [
                            10.804749319582674,
                            46.442402284351104
                        ],
                        [
                            10.801261214038792,
                            46.44282628803539
                        ],
                        [
                            10.800625986159071,
                            46.44290829105957
                        ],
                        [
                            10.800380535227276,
                            46.44296614835808
                        ],
                        [
                            10.799100932702904,
                            46.44364327978473
                        ],
                        [
                            10.798371958357913,
                            46.44404173957368
                        ],
                        [
                            10.797579377985528,
                            46.44448619851307
                        ],
                        [
                            10.797070119658557,
                            46.44483618968581
                        ],
                        [
                            10.791687115964935,
                            46.450608541872185
                        ],
                        [
                            10.791357664147332,
                            46.45099615173288
                        ],
                        [
                            10.790460669720384,
                            46.4521217208933
                        ],
                        [
                            10.790174315100947,
                            46.452522191694776
                        ],
                        [
                            10.789900659523965,
                            46.45291346580179
                        ],
                        [
                            10.78973303108599,
                            46.45318581432098
                        ],
                        [
                            10.78966576310189,
                            46.4532951353998
                        ],
                        [
                            10.78545003282156,
                            46.46016488009561
                        ],
                        [
                            10.781390956389293,
                            46.46707701337524
                        ],
                        [
                            10.777974782726126,
                            46.472152969285034
                        ],
                        [
                            10.77004075456213,
                            46.47895295216609
                        ],
                        [
                            10.764977293405861,
                            46.485957197067485
                        ],
                        [
                            10.762426365138921,
                            46.486018364767325
                        ],
                        [
                            10.757995855095585,
                            46.486243408981245
                        ],
                        [
                            10.74523465455659,
                            46.48501310295506
                        ],
                        [
                            10.744905920879505,
                            46.48491912404639
                        ],
                        [
                            10.744730424047981,
                            46.484847659044064
                        ],
                        [
                            10.743333238352147,
                            46.484223130246065
                        ],
                        [
                            10.742829469567567,
                            46.483951815383186
                        ],
                        [
                            10.739091884379949,
                            46.481551805552236
                        ],
                        [
                            10.738756877872088,
                            46.48125990262565
                        ],
                        [
                            10.736128035467729,
                            46.47848293275564
                        ],
                        [
                            10.727081944114609,
                            46.47119469903674
                        ],
                        [
                            10.722393933974162,
                            46.46847594220249
                        ],
                        [
                            10.719214698458533,
                            46.466372853377685
                        ],
                        [
                            10.71900159387632,
                            46.466223060614475
                        ],
                        [
                            10.718060018287996,
                            46.46486025126298
                        ],
                        [
                            10.716914700042954,
                            46.46307525498429
                        ],
                        [
                            10.71670900873914,
                            46.46207261959293
                        ],
                        [
                            10.71664279946095,
                            46.461623626486805
                        ],
                        [
                            10.69910098537585,
                            46.45871773502405
                        ],
                        [
                            10.69878773857026,
                            46.45869538908738
                        ],
                        [
                            10.696277351492943,
                            46.458372670813155
                        ],
                        [
                            10.695936689140403,
                            46.45830572920219
                        ],
                        [
                            10.695673011908035,
                            46.4582016465523
                        ],
                        [
                            10.691690718041926,
                            46.45580595988004
                        ],
                        [
                            10.689861959286587,
                            46.454524883906785
                        ],
                        [
                            10.689284502226892,
                            46.45375133878669
                        ],
                        [
                            10.684643595663356,
                            46.45147086601842
                        ],
                        [
                            10.669200830946687,
                            46.45232734003022
                        ],
                        [
                            10.66856279745535,
                            46.45232765546206
                        ],
                        [
                            10.668327974276329,
                            46.452313079640305
                        ],
                        [
                            10.66793640570856,
                            46.45228279392153
                        ],
                        [
                            10.666076461478225,
                            46.45200328502327
                        ],
                        [
                            10.645227686809799,
                            46.44782778376929
                        ],
                        [
                            10.639978707966401,
                            46.44648744465367
                        ],
                        [
                            10.639639068059225,
                            46.446397191090824
                        ],
                        [
                            10.639544356730054,
                            46.44636991448308
                        ],
                        [
                            10.639451536661056,
                            46.44634318126791
                        ],
                        [
                            10.639352121833301,
                            46.446314398772586
                        ],
                        [
                            10.639085590503244,
                            46.4462308765942
                        ],
                        [
                            10.638824603331784,
                            46.44607841220805
                        ],
                        [
                            10.62746013413035,
                            46.446943807992426
                        ],
                        [
                            10.621836982320522,
                            46.447960643498355
                        ],
                        [
                            10.600492368602497,
                            46.468664278553454
                        ],
                        [
                            10.59412114883768,
                            46.470199603075194
                        ],
                        [
                            10.583261031358122,
                            46.47180665686406
                        ],
                        [
                            10.581798557798473,
                            46.47214607371867
                        ],
                        [
                            10.577082354413601,
                            46.4733651198642
                        ],
                        [
                            10.560759816572117,
                            46.482291672514975
                        ],
                        [
                            10.560494610652162,
                            46.482441836685524
                        ],
                        [
                            10.560270690324229,
                            46.4825843847159
                        ],
                        [
                            10.560029232387917,
                            46.48275418070725
                        ],
                        [
                            10.559590400515209,
                            46.48312690006337
                        ],
                        [
                            10.559076257938678,
                            46.483599650746946
                        ],
                        [
                            10.558480210216691,
                            46.48417025275086
                        ],
                        [
                            10.557933567868497,
                            46.48476043061555
                        ],
                        [
                            10.55730385787091,
                            46.485450742374304
                        ],
                        [
                            10.55714595320885,
                            46.485695879493655
                        ],
                        [
                            10.556331998067183,
                            46.486964675337944
                        ],
                        [
                            10.555576209146457,
                            46.488147165502205
                        ],
                        [
                            10.555013065302303,
                            46.48903230115726
                        ],
                        [
                            10.55449803480104,
                            46.48993477392663
                        ],
                        [
                            10.551960791889437,
                            46.49145665988791
                        ],
                        [
                            10.549726403288647,
                            46.492022219651545
                        ],
                        [
                            10.548799974585238,
                            46.49225076538835
                        ],
                        [
                            10.547335159284874,
                            46.49247758469895
                        ],
                        [
                            10.546888301517138,
                            46.49254369001721
                        ],
                        [
                            10.546558234456407,
                            46.492543937147175
                        ],
                        [
                            10.544276127069862,
                            46.492363183790744
                        ],
                        [
                            10.531112341145374,
                            46.49346767179379
                        ],
                        [
                            10.511205874221657,
                            46.495467159786934
                        ],
                        [
                            10.503932050087768,
                            46.49626295773122
                        ],
                        [
                            10.499679159373393,
                            46.4967573693354
                        ],
                        [
                            10.493287283969327,
                            46.49811240627325
                        ],
                        [
                            10.484530696550374,
                            46.493600815227836
                        ],
                        [
                            10.476121560102177,
                            46.495526211049004
                        ],
                        [
                            10.47612322986765,
                            46.49598389687068
                        ],
                        [
                            10.476094617626059,
                            46.49685273294897
                        ],
                        [
                            10.475860459576412,
                            46.49727424889328
                        ],
                        [
                            10.475036362807213,
                            46.49856057759575
                        ],
                        [
                            10.47487887698914,
                            46.498760609579996
                        ],
                        [
                            10.474738083673515,
                            46.49893116532838
                        ],
                        [
                            10.474587744224726,
                            46.49907934472241
                        ],
                        [
                            10.473551070780378,
                            46.500066926499144
                        ],
                        [
                            10.472978144602756,
                            46.50059853486175
                        ],
                        [
                            10.472829353494376,
                            46.50068370121645
                        ],
                        [
                            10.472345355985487,
                            46.50081574319406
                        ],
                        [
                            10.471710017139845,
                            46.50104010229457
                        ],
                        [
                            10.470730808763452,
                            46.50163992501825
                        ],
                        [
                            10.470001592695965,
                            46.502101532342145
                        ],
                        [
                            10.469263901113884,
                            46.50258124865781
                        ],
                        [
                            10.45921910838835,
                            46.509540597938006
                        ],
                        [
                            10.45815062111469,
                            46.510406946117726
                        ],
                        [
                            10.45794042607491,
                            46.51058961253598
                        ],
                        [
                            10.457741784538674,
                            46.51100613033371
                        ],
                        [
                            10.457470379864358,
                            46.51171831029334
                        ],
                        [
                            10.457225455884547,
                            46.51236941322841
                        ],
                        [
                            10.457120084688032,
                            46.51269474266215
                        ],
                        [
                            10.453348915463883,
                            46.52627144038439
                        ],
                        [
                            10.453295242436061,
                            46.52647010692367
                        ],
                        [
                            10.453074599364395,
                            46.52740556976871
                        ],
                        [
                            10.453012598495077,
                            46.52801485604911
                        ],
                        [
                            10.45313748628042,
                            46.5305510063765
                        ],
                        [
                            10.453182094252588,
                            46.53204986042153
                        ],
                        [
                            10.45372563447513,
                            46.533023914012276
                        ],
                        [
                            10.453957902005584,
                            46.53338994624477
                        ],
                        [
                            10.459090221822152,
                            46.53935433972819
                        ],
                        [
                            10.461606074175048,
                            46.541099641986044
                        ],
                        [
                            10.464710420987522,
                            46.541199421171264
                        ],
                        [
                            10.466046708711689,
                            46.541420788242604
                        ],
                        [
                            10.470494101420302,
                            46.542232156609465
                        ],
                        [
                            10.47170423039293,
                            46.542639573171925
                        ],
                        [
                            10.472175871102248,
                            46.543078984433706
                        ],
                        [
                            10.472419003559716,
                            46.54332784447271
                        ],
                        [
                            10.472572698632712,
                            46.54355535469141
                        ],
                        [
                            10.477224901342696,
                            46.55644131666768
                        ],
                        [
                            10.477334277596587,
                            46.556745891079665
                        ],
                        [
                            10.477456028794682,
                            46.5577162757228
                        ],
                        [
                            10.476994842337815,
                            46.55841970213629
                        ],
                        [
                            10.476314780615628,
                            46.559350942526954
                        ],
                        [
                            10.475968971762107,
                            46.55967939198223
                        ],
                        [
                            10.475426656400675,
                            46.56024886358187
                        ],
                        [
                            10.474926641232342,
                            46.56084478859897
                        ],
                        [
                            10.474502102481377,
                            46.561367739607256
                        ],
                        [
                            10.474458922044892,
                            46.561489791091965
                        ],
                        [
                            10.47423049907218,
                            46.56259968638268
                        ],
                        [
                            10.474219403056765,
                            46.563153305602896
                        ],
                        [
                            10.474226119900662,
                            46.56361219834717
                        ],
                        [
                            10.474297885970408,
                            46.56421424634916
                        ],
                        [
                            10.474979061222307,
                            46.56659935716961
                        ],
                        [
                            10.47504190570711,
                            46.56675154002604
                        ],
                        [
                            10.479285688137695,
                            46.57309994025883
                        ],
                        [
                            10.480503039216803,
                            46.57443412688027
                        ],
                        [
                            10.48367912828201,
                            46.57987371694384
                        ],
                        [
                            10.485575441316104,
                            46.58553683273347
                        ],
                        [
                            10.48572358596087,
                            46.59048017139704
                        ],
                        [
                            10.484845627660965,
                            46.59534683541662
                        ],
                        [
                            10.484263475914407,
                            46.60414695220543
                        ],
                        [
                            10.484284566943135,
                            46.60447066156255
                        ],
                        [
                            10.484314731897197,
                            46.60470875829148
                        ],
                        [
                            10.484393493408788,
                            46.604932724121774
                        ],
                        [
                            10.48448141276148,
                            46.60513407395569
                        ],
                        [
                            10.484652357636564,
                            46.605356843176004
                        ],
                        [
                            10.486904137630653,
                            46.60819394681225
                        ],
                        [
                            10.487197046707298,
                            46.608518621426924
                        ],
                        [
                            10.48847936496238,
                            46.609356897786796
                        ],
                        [
                            10.489456333315974,
                            46.609893152583396
                        ],
                        [
                            10.490620951593037,
                            46.61078243401571
                        ],
                        [
                            10.490882247126882,
                            46.61099501585897
                        ],
                        [
                            10.491102833325762,
                            46.61118113185937
                        ],
                        [
                            10.491249825765497,
                            46.61133220783806
                        ],
                        [
                            10.491499451641795,
                            46.61183292763086
                        ],
                        [
                            10.491939271446332,
                            46.612898135683075
                        ],
                        [
                            10.492096960342955,
                            46.61340905182692
                        ],
                        [
                            10.492134434438865,
                            46.613674049477765
                        ],
                        [
                            10.492294059113243,
                            46.61511639248696
                        ],
                        [
                            10.490598524763083,
                            46.61502150641714
                        ],
                        [
                            10.48965369955184,
                            46.61500681639623
                        ],
                        [
                            10.48916424288808,
                            46.615017689434175
                        ],
                        [
                            10.48870030114792,
                            46.6150957248486
                        ],
                        [
                            10.487920706831938,
                            46.615272360006266
                        ],
                        [
                            10.48720523625727,
                            46.61561464668419
                        ],
                        [
                            10.48497530276162,
                            46.617052045574034
                        ],
                        [
                            10.484367438236179,
                            46.61750991036712
                        ],
                        [
                            10.484051512357773,
                            46.617747997575705
                        ],
                        [
                            10.483067572643838,
                            46.618723708300216
                        ],
                        [
                            10.480668911261967,
                            46.620658181085965
                        ],
                        [
                            10.462590453997942,
                            46.63324969711073
                        ],
                        [
                            10.462481496255533,
                            46.633324982445465
                        ],
                        [
                            10.456129436475925,
                            46.63681682637349
                        ],
                        [
                            10.455713066478284,
                            46.63703361311515
                        ],
                        [
                            10.455422935410672,
                            46.63717679713523
                        ],
                        [
                            10.453109902684641,
                            46.63822764425694
                        ],
                        [
                            10.452045189034228,
                            46.638691140083104
                        ],
                        [
                            10.445953812902335,
                            46.64110366641241
                        ],
                        [
                            10.426332645034941,
                            46.63814169064514
                        ],
                        [
                            10.410754576344385,
                            46.6351400570656
                        ],
                        [
                            10.41024730237539,
                            46.63506981719753
                        ],
                        [
                            10.409607430677493,
                            46.634987708072515
                        ],
                        [
                            10.409133980627251,
                            46.634962043923565
                        ],
                        [
                            10.406566949957758,
                            46.63528612053996
                        ],
                        [
                            10.406244158120856,
                            46.63537108366471
                        ],
                        [
                            10.404972806297065,
                            46.63571968764235
                        ],
                        [
                            10.40404673739983,
                            46.63600104174317
                        ],
                        [
                            10.402643684261758,
                            46.636499726835844
                        ],
                        [
                            10.402396913403502,
                            46.63661974574768
                        ],
                        [
                            10.401870239182669,
                            46.636905185442245
                        ],
                        [
                            10.401607715014299,
                            46.63704789441145
                        ],
                        [
                            10.40110668518482,
                            46.63737801287891
                        ],
                        [
                            10.400589209090056,
                            46.6377353289482
                        ],
                        [
                            10.399976735569858,
                            46.63846278509103
                        ],
                        [
                            10.400289010136584,
                            46.638823442081055
                        ],
                        [
                            10.400432894985265,
                            46.63898817115137
                        ],
                        [
                            10.400835910574992,
                            46.6392892181652
                        ],
                        [
                            10.401712599194699,
                            46.64022342209804
                        ],
                        [
                            10.40172442891054,
                            46.64096573532328
                        ],
                        [
                            10.401727666788064,
                            46.64118618204402
                        ],
                        [
                            10.40170478949358,
                            46.64137545057475
                        ],
                        [
                            10.401667455352277,
                            46.64160539569893
                        ],
                        [
                            10.400494154295151,
                            46.644652586707195
                        ],
                        [
                            10.400046251572695,
                            46.64577850219592
                        ],
                        [
                            10.399934483858528,
                            46.64600485688586
                        ],
                        [
                            10.399716897240753,
                            46.646434994437776
                        ],
                        [
                            10.399505156241023,
                            46.6468065625548
                        ],
                        [
                            10.395755797166155,
                            46.65297650171101
                        ],
                        [
                            10.394139163610175,
                            46.65475110794427
                        ],
                        [
                            10.392621490671704,
                            46.66095671223342
                        ],
                        [
                            10.392508909388752,
                            46.66506632477453
                        ],
                        [
                            10.392253176300649,
                            46.671270044627164
                        ],
                        [
                            10.389955211116286,
                            46.67495625191825
                        ],
                        [
                            10.386105190810296,
                            46.68018212682632
                        ],
                        [
                            10.387417994112502,
                            46.68728024197745
                        ],
                        [
                            10.399369402286458,
                            46.69972032826003
                        ],
                        [
                            10.403227521943283,
                            46.7053426827079
                        ],
                        [
                            10.405133034577654,
                            46.70488732516947
                        ],
                        [
                            10.408874778442934,
                            46.70515178712496
                        ],
                        [
                            10.409256019968055,
                            46.705223586537656
                        ],
                        [
                            10.410253111822986,
                            46.70558477400563
                        ],
                        [
                            10.410883789917799,
                            46.70581548203881
                        ],
                        [
                            10.41153187750719,
                            46.706086469044926
                        ],
                        [
                            10.41280168949573,
                            46.70677724565944
                        ],
                        [
                            10.413415018700787,
                            46.70712514597516
                        ],
                        [
                            10.414875523739163,
                            46.70819601739287
                        ],
                        [
                            10.415049542053156,
                            46.708346854756854
                        ],
                        [
                            10.415248669353076,
                            46.70855137666378
                        ],
                        [
                            10.415562765223957,
                            46.70902445731424
                        ],
                        [
                            10.417540585434509,
                            46.71429609808671
                        ],
                        [
                            10.418273791549003,
                            46.71781026084223
                        ],
                        [
                            10.416958124595691,
                            46.71944194941672
                        ],
                        [
                            10.411177776871867,
                            46.723585599610445
                        ],
                        [
                            10.40104666113877,
                            46.73208849609808
                        ],
                        [
                            10.400512943619473,
                            46.7329589674747
                        ],
                        [
                            10.400686981823418,
                            46.73336180572638
                        ],
                        [
                            10.40097655601425,
                            46.7339297196181
                        ],
                        [
                            10.401067909077714,
                            46.73407708927022
                        ],
                        [
                            10.401573877073579,
                            46.734250879272935
                        ],
                        [
                            10.401913490644832,
                            46.73435021013521
                        ],
                        [
                            10.405485893620167,
                            46.735669781366546
                        ],
                        [
                            10.4093397342139,
                            46.73757973024655
                        ],
                        [
                            10.427411140973529,
                            46.74769143079976
                        ],
                        [
                            10.429070838817246,
                            46.748660637927074
                        ],
                        [
                            10.431246590088424,
                            46.74998783961248
                        ],
                        [
                            10.433817478705214,
                            46.75158452742382
                        ],
                        [
                            10.434334551121658,
                            46.751920019264126
                        ],
                        [
                            10.43477786548404,
                            46.75218894144405
                        ],
                        [
                            10.43531836901042,
                            46.7523891469447
                        ],
                        [
                            10.438968351827805,
                            46.75258178350311
                        ],
                        [
                            10.439268696911599,
                            46.75258250557525
                        ],
                        [
                            10.439583295779151,
                            46.75256504887541
                        ],
                        [
                            10.439874738553886,
                            46.752538883386386
                        ],
                        [
                            10.440098513830177,
                            46.75249107052991
                        ],
                        [
                            10.440572441419247,
                            46.75237261309824
                        ],
                        [
                            10.440888633412001,
                            46.75229213746998
                        ],
                        [
                            10.441318455356535,
                            46.75211573673467
                        ],
                        [
                            10.44139985787065,
                            46.75203821612944
                        ],
                        [
                            10.441996904561986,
                            46.75266964541211
                        ],
                        [
                            10.442105023595486,
                            46.75285726859737
                        ],
                        [
                            10.442668279781872,
                            46.75412357160193
                        ],
                        [
                            10.442851650096792,
                            46.75461622128365
                        ],
                        [
                            10.442916060711385,
                            46.75479089492695
                        ],
                        [
                            10.443412908930359,
                            46.756602489302566
                        ],
                        [
                            10.443478649390771,
                            46.75701112900049
                        ],
                        [
                            10.443651287307029,
                            46.75829585164461
                        ],
                        [
                            10.443946951918186,
                            46.76078492852936
                        ],
                        [
                            10.44389674422187,
                            46.761968969925526
                        ],
                        [
                            10.443878899381556,
                            46.76218967824241
                        ],
                        [
                            10.44197073231375,
                            46.771042048916854
                        ],
                        [
                            10.441911707089593,
                            46.77122277868667
                        ],
                        [
                            10.441611912291856,
                            46.77182950812822
                        ],
                        [
                            10.441378632523811,
                            46.77225991349551
                        ],
                        [
                            10.440695314943767,
                            46.77349692094595
                        ],
                        [
                            10.440535083613455,
                            46.77375091758034
                        ],
                        [
                            10.429596648193698,
                            46.784592738501985
                        ],
                        [
                            10.42943966564581,
                            46.7847251891132
                        ],
                        [
                            10.428398131701647,
                            46.78528264944456
                        ],
                        [
                            10.427906840047802,
                            46.78546876746899
                        ],
                        [
                            10.427590685743619,
                            46.78555820526888
                        ],
                        [
                            10.42467327116607,
                            46.788789302240765
                        ],
                        [
                            10.427725300155887,
                            46.793930333590225
                        ],
                        [
                            10.429751778802196,
                            46.7965103137802
                        ],
                        [
                            10.429859557150829,
                            46.796621457823555
                        ],
                        [
                            10.43010103083127,
                            46.79673993025547
                        ],
                        [
                            10.430416413241208,
                            46.796834980188294
                        ],
                        [
                            10.431381491812175,
                            46.79709288929749
                        ],
                        [
                            10.43191171029524,
                            46.797073006181925
                        ],
                        [
                            10.432429572440657,
                            46.79705277672334
                        ],
                        [
                            10.43394423704542,
                            46.79703380650955
                        ],
                        [
                            10.439159526203905,
                            46.79758028265705
                        ],
                        [
                            10.439610359546938,
                            46.79765560515495
                        ],
                        [
                            10.44093120293182,
                            46.79810694116245
                        ],
                        [
                            10.441836650875619,
                            46.79846000607205
                        ],
                        [
                            10.448274566047061,
                            46.80137095497578
                        ],
                        [
                            10.448423625088916,
                            46.80155355398161
                        ],
                        [
                            10.44862292016164,
                            46.80180750908564
                        ],
                        [
                            10.450966315644596,
                            46.804914055436306
                        ],
                        [
                            10.453569666763011,
                            46.80887217737762
                        ],
                        [
                            10.457768435549783,
                            46.815829166127266
                        ],
                        [
                            10.457958064706007,
                            46.81614622319127
                        ],
                        [
                            10.457997123121954,
                            46.816348208352004
                        ],
                        [
                            10.458863690408487,
                            46.823698525185165
                        ],
                        [
                            10.457628887398128,
                            46.828852809081795
                        ],
                        [
                            10.464799846001963,
                            46.84014523114369
                        ],
                        [
                            10.46856354196188,
                            46.847084865385916
                        ],
                        [
                            10.469578432448655,
                            46.85483812668329
                        ],
                        [
                            10.46980132529551,
                            46.854983750830726
                        ],
                        [
                            10.471330120385621,
                            46.855783031243455
                        ],
                        [
                            10.471919991806404,
                            46.856036421612835
                        ],
                        [
                            10.47808738750855,
                            46.85860718989418
                        ],
                        [
                            10.478354282226332,
                            46.85871173275414
                        ],
                        [
                            10.47893777940955,
                            46.85887967797155
                        ],
                        [
                            10.479294532812313,
                            46.858852569334985
                        ],
                        [
                            10.47987074137139,
                            46.85875512736943
                        ],
                        [
                            10.480096678376224,
                            46.85871171023735
                        ],
                        [
                            10.480906410155622,
                            46.85839976295314
                        ],
                        [
                            10.481583418641018,
                            46.85806253063275
                        ],
                        [
                            10.481791877386074,
                            46.85792034453382
                        ],
                        [
                            10.482001591168562,
                            46.85776464302859
                        ],
                        [
                            10.48224416886982,
                            46.857581518863235
                        ],
                        [
                            10.482402899439574,
                            46.857390480181955
                        ],
                        [
                            10.488904330082299,
                            46.852712003880654
                        ],
                        [
                            10.496466528046684,
                            46.84860423216856
                        ],
                        [
                            10.498942076413352,
                            46.84750543183289
                        ],
                        [
                            10.516575157520352,
                            46.84670616822498
                        ],
                        [
                            10.527051596538014,
                            46.84667034509704
                        ],
                        [
                            10.527650986952436,
                            46.8468198299222
                        ],
                        [
                            10.529506516740723,
                            46.847209010435996
                        ],
                        [
                            10.536150288698504,
                            46.84845640388178
                        ],
                        [
                            10.537506314003092,
                            46.848631676056925
                        ],
                        [
                            10.538939247019098,
                            46.848801399285946
                        ],
                        [
                            10.550722648396805,
                            46.84989772432367
                        ],
                        [
                            10.551023394950821,
                            46.84989364872302
                        ],
                        [
                            10.55263029219845,
                            46.8497818662742
                        ],
                        [
                            10.553483193238227,
                            46.84936532732371
                        ],
                        [
                            10.555310639199678,
                            46.84843158752517
                        ],
                        [
                            10.556310075512792,
                            46.84687463692
                        ],
                        [
                            10.556209774604357,
                            46.84663752168084
                        ],
                        [
                            10.555705162182532,
                            46.84588394961397
                        ],
                        [
                            10.555000494355776,
                            46.84504309977291
                        ],
                        [
                            10.55483513190019,
                            46.844851865191046
                        ],
                        [
                            10.550837139750113,
                            46.840689984576755
                        ],
                        [
                            10.55020687685954,
                            46.84003708189681
                        ],
                        [
                            10.550718005046088,
                            46.83917073191633
                        ],
                        [
                            10.56284044569331,
                            46.8406886750797
                        ],
                        [
                            10.56448128705028,
                            46.840909234219865
                        ],
                        [
                            10.568343291349425,
                            46.84174279409112
                        ],
                        [
                            10.570506481926634,
                            46.84244656309252
                        ],
                        [
                            10.591368870458265,
                            46.85227346935424
                        ],
                        [
                            10.591487900188392,
                            46.852528291799
                        ],
                        [
                            10.591615303323822,
                            46.85273350106627
                        ],
                        [
                            10.592083460752843,
                            46.85348292236188
                        ],
                        [
                            10.595012691741571,
                            46.85660535420049
                        ],
                        [
                            10.595179632002964,
                            46.856760511790505
                        ],
                        [
                            10.595683338522122,
                            46.857018967290166
                        ],
                        [
                            10.596101340851346,
                            46.857179623675435
                        ],
                        [
                            10.596427047940537,
                            46.85729656999847
                        ],
                        [
                            10.623744397018129,
                            46.86403060689386
                        ],
                        [
                            10.629633327600812,
                            46.8646083401929
                        ],
                        [
                            10.64056446727578,
                            46.86525309083534
                        ],
                        [
                            10.643889317104192,
                            46.865425859824
                        ],
                        [
                            10.655875321072774,
                            46.86894723134094
                        ],
                        [
                            10.658680276730678,
                            46.87124190362821
                        ],
                        [
                            10.662674727139192,
                            46.874014187948134
                        ],
                        [
                            10.663011521498015,
                            46.8742432737744
                        ],
                        [
                            10.663968692379395,
                            46.87477381288721
                        ],
                        [
                            10.667933552062147,
                            46.87588599191404
                        ],
                        [
                            10.668023808294404,
                            46.87578118651557
                        ],
                        [
                            10.669370598892217,
                            46.873718729256815
                        ],
                        [
                            10.670969260887377,
                            46.87129261404068
                        ],
                        [
                            10.67123925498013,
                            46.87090170543755
                        ],
                        [
                            10.671446110003957,
                            46.87069620220594
                        ],
                        [
                            10.672298719304663,
                            46.87036877325486
                        ],
                        [
                            10.672778706099264,
                            46.870190775167444
                        ],
                        [
                            10.673161499919868,
                            46.870131183154136
                        ],
                        [
                            10.673826938765515,
                            46.870035960823316
                        ],
                        [
                            10.677074335741109,
                            46.870447376880676
                        ],
                        [
                            10.67794036801069,
                            46.87055167234364
                        ],
                        [
                            10.678282886491072,
                            46.870542150277245
                        ],
                        [
                            10.678731090917195,
                            46.87045008401328
                        ],
                        [
                            10.679355499842973,
                            46.87030143426755
                        ],
                        [
                            10.688255901391997,
                            46.86761920432925
                        ],
                        [
                            10.692462813299555,
                            46.86526676587567
                        ],
                        [
                            10.696940799079306,
                            46.86268067060952
                        ],
                        [
                            10.696951958868427,
                            46.86228004017694
                        ],
                        [
                            10.696957134722055,
                            46.862027984900635
                        ],
                        [
                            10.696474428123134,
                            46.859798832711164
                        ],
                        [
                            10.696372167933582,
                            46.85959786757545
                        ],
                        [
                            10.694104007190388,
                            46.856544732680554
                        ],
                        [
                            10.693046590372777,
                            46.853032681929434
                        ],
                        [
                            10.6933267059645,
                            46.85276306057248
                        ],
                        [
                            10.693778088223516,
                            46.85236041376498
                        ],
                        [
                            10.702366282971179,
                            46.8485792844937
                        ],
                        [
                            10.71030504267052,
                            46.846791548304076
                        ],
                        [
                            10.716003318852175,
                            46.84378148413435
                        ],
                        [
                            10.715981625361064,
                            46.84315186174126
                        ],
                        [
                            10.716021858155436,
                            46.84284528337086
                        ],
                        [
                            10.722117926158507,
                            46.83791660146627
                        ],
                        [
                            10.722507480586795,
                            46.83774425080121
                        ],
                        [
                            10.723320563737357,
                            46.83738553850736
                        ],
                        [
                            10.736492600287404,
                            46.83412215693048
                        ],
                        [
                            10.736924400800536,
                            46.834016610469554
                        ],
                        [
                            10.739316116594699,
                            46.83369230567994
                        ],
                        [
                            10.74150688775133,
                            46.83346550076882
                        ],
                        [
                            10.742196523450215,
                            46.83340100743264
                        ],
                        [
                            10.743937440673559,
                            46.83332949140872
                        ],
                        [
                            10.744318636316123,
                            46.83333268056221
                        ],
                        [
                            10.744786143520813,
                            46.8333435526201
                        ],
                        [
                            10.745434303008754,
                            46.83336516360129
                        ],
                        [
                            10.746483773227945,
                            46.83340314754429
                        ],
                        [
                            10.748499113011372,
                            46.83340386823902
                        ],
                        [
                            10.750945993462224,
                            46.83331695740318
                        ],
                        [
                            10.752976541856372,
                            46.83302938824583
                        ],
                        [
                            10.75325315361954,
                            46.83296665592694
                        ],
                        [
                            10.753977611989257,
                            46.832789066806086
                        ],
                        [
                            10.754634006067864,
                            46.832585518006034
                        ],
                        [
                            10.755149831165703,
                            46.83234362657624
                        ],
                        [
                            10.755683169391729,
                            46.832060966377654
                        ],
                        [
                            10.763203143203857,
                            46.823486004225025
                        ],
                        [
                            10.76336248174783,
                            46.82327206600658
                        ],
                        [
                            10.763469267548999,
                            46.823054436024066
                        ],
                        [
                            10.763769129510946,
                            46.82240186494236
                        ],
                        [
                            10.76358581360609,
                            46.82205821787856
                        ],
                        [
                            10.762845378904995,
                            46.821165196613755
                        ],
                        [
                            10.758715590889215,
                            46.81787200721649
                        ],
                        [
                            10.745812559952723,
                            46.80437714907322
                        ],
                        [
                            10.744615467752645,
                            46.80365746337408
                        ],
                        [
                            10.743075454550484,
                            46.80284399785264
                        ],
                        [
                            10.739338284069975,
                            46.80092551627125
                        ],
                        [
                            10.738932682048192,
                            46.800742696056155
                        ],
                        [
                            10.736519641349005,
                            46.79974892109276
                        ],
                        [
                            10.73399035403751,
                            46.798779355261686
                        ],
                        [
                            10.733433578846451,
                            46.798580806816304
                        ],
                        [
                            10.726063251342557,
                            46.79774279877051
                        ],
                        [
                            10.730494129755014,
                            46.78790709660774
                        ],
                        [
                            10.741165655348935,
                            46.78678676860573
                        ],
                        [
                            10.7551267661579,
                            46.78521005752894
                        ],
                        [
                            10.756022970634273,
                            46.7851468090635
                        ],
                        [
                            10.756901535121782,
                            46.78524581384504
                        ],
                        [
                            10.757589921700792,
                            46.785338734057746
                        ],
                        [
                            10.758676553223165,
                            46.785515522194174
                        ],
                        [
                            10.75906631445358,
                            46.78559052484233
                        ],
                        [
                            10.778483097685411,
                            46.790347993064195
                        ],
                        [
                            10.778920892416263,
                            46.790561670643584
                        ],
                        [
                            10.78192711405931,
                            46.793214695595125
                        ],
                        [
                            10.782257931491085,
                            46.793511021481244
                        ],
                        [
                            10.782456085896532,
                            46.79373291863392
                        ],
                        [
                            10.78878439384028,
                            46.79470057937926
                        ],
                        [
                            10.793623967264939,
                            46.791232059586044
                        ],
                        [
                            10.794327441264556,
                            46.79177449046333
                        ],
                        [
                            10.79463497925406,
                            46.79173816845523
                        ],
                        [
                            10.795516016945452,
                            46.791463365284116
                        ],
                        [
                            10.796005514409769,
                            46.791185701733355
                        ],
                        [
                            10.796737500135324,
                            46.79056675221099
                        ],
                        [
                            10.797686184203762,
                            46.7897419085374
                        ],
                        [
                            10.798102268222289,
                            46.78937539654474
                        ],
                        [
                            10.799399186465733,
                            46.78818959012496
                        ],
                        [
                            10.801028628706726,
                            46.78673755214962
                        ],
                        [
                            10.801419893522878,
                            46.78638941725385
                        ],
                        [
                            10.812371116075113,
                            46.776749127091996
                        ],
                        [
                            10.813742096663848,
                            46.77554398249033
                        ],
                        [
                            10.814115077222038,
                            46.775412078519814
                        ],
                        [
                            10.818331129692039,
                            46.774773690339146
                        ],
                        [
                            10.821500606833954,
                            46.77444429199731
                        ],
                        [
                            10.824222344452238,
                            46.774166943442545
                        ],
                        [
                            10.827062835233123,
                            46.774279106619545
                        ],
                        [
                            10.827443850662691,
                            46.774385513909706
                        ],
                        [
                            10.8279397919093,
                            46.77459807569858
                        ],
                        [
                            10.828261935017673,
                            46.774754918437914
                        ],
                        [
                            10.829516301528443,
                            46.775580808634054
                        ],
                        [
                            10.829746029307623,
                            46.775788620718686
                        ],
                        [
                            10.82985244637446,
                            46.7760299015796
                        ],
                        [
                            10.83011234829662,
                            46.7766692004253
                        ],
                        [
                            10.830421406732755,
                            46.77735720977492
                        ],
                        [
                            10.831235584640456,
                            46.77913055725102
                        ],
                        [
                            10.831660956237409,
                            46.77991569462147
                        ],
                        [
                            10.831833162634926,
                            46.780164920543214
                        ],
                        [
                            10.83206939579885,
                            46.780467117309584
                        ],
                        [
                            10.832426970092149,
                            46.78060537941418
                        ],
                        [
                            10.83587658911968,
                            46.781764995194536
                        ],
                        [
                            10.836198953504784,
                            46.7818543156399
                        ],
                        [
                            10.836504694295316,
                            46.781912404148336
                        ],
                        [
                            10.836786464101108,
                            46.78193937790877
                        ],
                        [
                            10.840704950975478,
                            46.78169191556494
                        ],
                        [
                            10.84086426589321,
                            46.78158585843307
                        ],
                        [
                            10.841514815838691,
                            46.780085992519744
                        ],
                        [
                            10.85059862979537,
                            46.77503475334609
                        ],
                        [
                            10.851455661269654,
                            46.77462491462518
                        ],
                        [
                            10.851963280460097,
                            46.77438721403995
                        ],
                        [
                            10.85295408310737,
                            46.77408319143727
                        ],
                        [
                            10.85368386247743,
                            46.77394987687993
                        ],
                        [
                            10.85574351329677,
                            46.77373199968457
                        ],
                        [
                            10.857221122766248,
                            46.77358653103149
                        ],
                        [
                            10.860841013960885,
                            46.77319923137125
                        ],
                        [
                            10.866452348083246,
                            46.77259036119956
                        ],
                        [
                            10.866850226920272,
                            46.77254337219794
                        ],
                        [
                            10.867158657425653,
                            46.7723718489656
                        ],
                        [
                            10.86735932537302,
                            46.77216158916595
                        ],
                        [
                            10.867444692021802,
                            46.77200270605462
                        ],
                        [
                            10.867679308352109,
                            46.770572469915386
                        ],
                        [
                            10.867843508461274,
                            46.76961585292342
                        ],
                        [
                            10.868051147604836,
                            46.76861352648259
                        ],
                        [
                            10.868258747179917,
                            46.76763370228898
                        ],
                        [
                            10.868455336744555,
                            46.76676204862427
                        ],
                        [
                            10.868685539674697,
                            46.76593934229073
                        ],
                        [
                            10.868818744161754,
                            46.76583817284387
                        ],
                        [
                            10.868960115911138,
                            46.765736869818525
                        ],
                        [
                            10.882208080088317,
                            46.76319332993614
                        ],
                        [
                            10.883195554351142,
                            46.76310958485589
                        ],
                        [
                            10.883918883073543,
                            46.76307967721013
                        ],
                        [
                            10.884655431835588,
                            46.76307654460261
                        ],
                        [
                            10.885360511834033,
                            46.76310992447556
                        ],
                        [
                            10.886156768032098,
                            46.763222789941324
                        ],
                        [
                            10.886859611186829,
                            46.76333269262462
                        ],
                        [
                            10.887579920452293,
                            46.76347380173037
                        ],
                        [
                            10.889600610044859,
                            46.7639354123285
                        ],
                        [
                            10.905857320386344,
                            46.768183458176985
                        ],
                        [
                            10.906229245211772,
                            46.76830775262887
                        ],
                        [
                            10.906725388402968,
                            46.76856496624243
                        ],
                        [
                            10.910913228169955,
                            46.771154421808276
                        ],
                        [
                            10.913876642884498,
                            46.773071259219705
                        ],
                        [
                            10.91495041822976,
                            46.77375524480628
                        ],
                        [
                            10.915710479950196,
                            46.774133996263146
                        ],
                        [
                            10.916256333735195,
                            46.77435883898157
                        ],
                        [
                            10.916571398047902,
                            46.77447055392651
                        ],
                        [
                            10.917100469205504,
                            46.77461467982959
                        ],
                        [
                            10.917506189159196,
                            46.77472037335018
                        ],
                        [
                            10.918019804162444,
                            46.77477475889497
                        ],
                        [
                            10.923195699946637,
                            46.77491735299394
                        ],
                        [
                            10.92356045483264,
                            46.77490672111746
                        ],
                        [
                            10.923950085153516,
                            46.77488217061457
                        ],
                        [
                            10.92416650136995,
                            46.774775038475234
                        ],
                        [
                            10.92431750545553,
                            46.774601508660716
                        ],
                        [
                            10.924585089096766,
                            46.77411553907302
                        ],
                        [
                            10.924846761110809,
                            46.77364766623337
                        ],
                        [
                            10.925288454104782,
                            46.77336125172924
                        ],
                        [
                            10.925579469034444,
                            46.77325736117857
                        ],
                        [
                            10.928525544834725,
                            46.772951252948396
                        ],
                        [
                            10.939094959612007,
                            46.77396951950177
                        ],
                        [
                            10.93984893450237,
                            46.77406023119354
                        ],
                        [
                            10.941142557977432,
                            46.77422277689422
                        ],
                        [
                            10.94245919148519,
                            46.774524409420735
                        ],
                        [
                            10.943062089027581,
                            46.77478415356071
                        ],
                        [
                            10.943600850841781,
                            46.775013487
                        ],
                        [
                            10.943972906206744,
                            46.77513765747408
                        ],
                        [
                            10.95055198873588,
                            46.77491318331736
                        ],
                        [
                            10.950998728726681,
                            46.77488306718734
                        ],
                        [
                            10.952593708133259,
                            46.77477486048813
                        ],
                        [
                            10.973782883706315,
                            46.772152392581525
                        ],
                        [
                            10.976550316679145,
                            46.770709699419974
                        ],
                        [
                            10.982915270671345,
                            46.76890765824034
                        ],
                        [
                            10.993426002234626,
                            46.767087093013956
                        ],
                        [
                            10.995649796149923,
                            46.7670798194238
                        ],
                        [
                            10.995873134944928,
                            46.76709842188082
                        ],
                        [
                            10.996957466793779,
                            46.767245988405996
                        ],
                        [
                            10.997693455159654,
                            46.76735913132261
                        ],
                        [
                            10.998389356837968,
                            46.76747296975472
                        ],
                        [
                            11.00015119204937,
                            46.76783365489531
                        ],
                        [
                            11.00299551333507,
                            46.76842285327645
                        ],
                        [
                            11.004442462106416,
                            46.76878898509258
                        ],
                        [
                            11.005887801634458,
                            46.769177625485
                        ],
                        [
                            11.00643294125256,
                            46.76935255573004
                        ],
                        [
                            11.00709282653328,
                            46.76959746510538
                        ],
                        [
                            11.007933628119892,
                            46.769974186476794
                        ],
                        [
                            11.008568368002605,
                            46.77024652706495
                        ],
                        [
                            11.012331353367752,
                            46.771647307469635
                        ],
                        [
                            11.013024032705955,
                            46.77189160577886
                        ],
                        [
                            11.013628121950777,
                            46.772065461744894
                        ],
                        [
                            11.014120253800808,
                            46.77182731313999
                        ],
                        [
                            11.01509343962893,
                            46.7710767210369
                        ],
                        [
                            11.021671831787362,
                            46.76591196023026
                        ],
                        [
                            11.021949777180533,
                            46.76557406846662
                        ],
                        [
                            11.02213537031252,
                            46.765174811248244
                        ],
                        [
                            11.025602479196829,
                            46.773091493440226
                        ],
                        [
                            11.028741005282075,
                            46.77960097850664
                        ],
                        [
                            11.035201780825547,
                            46.79037104734991
                        ],
                        [
                            11.039798522774964,
                            46.805084235259294
                        ],
                        [
                            11.040349554143695,
                            46.80527239696417
                        ],
                        [
                            11.060358190870648,
                            46.812585815139286
                        ],
                        [
                            11.064131244448873,
                            46.81471366195307
                        ],
                        [
                            11.071767604586118,
                            46.81796841225024
                        ],
                        [
                            11.0799580409642,
                            46.82043863322588
                        ],
                        [
                            11.081073078273711,
                            46.82075368504109
                        ],
                        [
                            11.081674925590027,
                            46.820933871271336
                        ],
                        [
                            11.082700704661857,
                            46.82127068000888
                        ],
                        [
                            11.08345273060579,
                            46.82221992558068
                        ],
                        [
                            11.083538350277792,
                            46.82286632344014
                        ],
                        [
                            11.081402449194583,
                            46.82775587633133
                        ],
                        [
                            11.078039125120025,
                            46.83372511545759
                        ],
                        [
                            11.077825238767673,
                            46.83398098216567
                        ],
                        [
                            11.077015504777696,
                            46.83489562227905
                        ],
                        [
                            11.076139014026511,
                            46.83563148262731
                        ],
                        [
                            11.075752644080154,
                            46.835899475320545
                        ],
                        [
                            11.071685653719772,
                            46.85084015124614
                        ],
                        [
                            11.071439677737038,
                            46.85179853802967
                        ],
                        [
                            11.071423958622391,
                            46.85286074742258
                        ],
                        [
                            11.072046258531644,
                            46.8565257169973
                        ],
                        [
                            11.072361284618143,
                            46.85727595752488
                        ],
                        [
                            11.072603754918372,
                            46.85771703335767
                        ],
                        [
                            11.073159490831417,
                            46.85788245317481
                        ],
                        [
                            11.073436349290867,
                            46.857832439751874
                        ],
                        [
                            11.07472050822429,
                            46.85766517252026
                        ],
                        [
                            11.077000473526924,
                            46.85837975383818
                        ],
                        [
                            11.077599879843374,
                            46.85857135747381
                        ],
                        [
                            11.07800997858091,
                            46.85897788027996
                        ],
                        [
                            11.078548209202234,
                            46.85975104887116
                        ],
                        [
                            11.080564784116211,
                            46.86315214943899
                        ],
                        [
                            11.08122073571464,
                            46.864274138600116
                        ],
                        [
                            11.081709754880453,
                            46.86542615905828
                        ],
                        [
                            11.0816455701841,
                            46.86597178688255
                        ],
                        [
                            11.081291145957946,
                            46.86654069205088
                        ],
                        [
                            11.081303268499921,
                            46.86698144080995
                        ],
                        [
                            11.08198457555366,
                            46.86841793850552
                        ],
                        [
                            11.086914658691486,
                            46.87549160282984
                        ],
                        [
                            11.089557105722253,
                            46.878926120370195
                        ],
                        [
                            11.091115951832723,
                            46.88058051927968
                        ],
                        [
                            11.091534575975814,
                            46.88094633818348
                        ],
                        [
                            11.091902308221405,
                            46.88114210300678
                        ],
                        [
                            11.092253129459,
                            46.8812616787822
                        ],
                        [
                            11.094408335033155,
                            46.88234266649912
                        ],
                        [
                            11.095411453143864,
                            46.88294975566827
                        ],
                        [
                            11.097002294415462,
                            46.88430201031914
                        ],
                        [
                            11.100474720982538,
                            46.88824752033183
                        ],
                        [
                            11.10139920038105,
                            46.889566945643686
                        ],
                        [
                            11.101546106138908,
                            46.88985971016322
                        ],
                        [
                            11.0991584332681,
                            46.90087071315042
                        ],
                        [
                            11.098902343027278,
                            46.901352373327136
                        ],
                        [
                            11.097244235820748,
                            46.90397007227852
                        ],
                        [
                            11.095679211408896,
                            46.90569511349521
                        ],
                        [
                            11.094982288256757,
                            46.907480735653174
                        ],
                        [
                            11.09497648867494,
                            46.908047797027976
                        ],
                        [
                            11.09533016286084,
                            46.91015165521233
                        ],
                        [
                            11.095399371165758,
                            46.91053735786839
                        ],
                        [
                            11.09590135481178,
                            46.91223353035344
                        ],
                        [
                            11.097569539659693,
                            46.91396682386745
                        ],
                        [
                            11.098029500123081,
                            46.9141428785263
                        ],
                        [
                            11.102402331447285,
                            46.915138038462366
                        ],
                        [
                            11.105090695739058,
                            46.915561079868844
                        ],
                        [
                            11.107809754966807,
                            46.91596999112505
                        ],
                        [
                            11.108719542686094,
                            46.91606122164849
                        ],
                        [
                            11.108969221184172,
                            46.91623210774249
                        ],
                        [
                            11.109711226034362,
                            46.917401835575355
                        ],
                        [
                            11.110483727995682,
                            46.91884547719622
                        ],
                        [
                            11.110824991931189,
                            46.91955012628678
                        ],
                        [
                            11.110955768823786,
                            46.92014166551989
                        ],
                        [
                            11.110638877257683,
                            46.92304528023489
                        ],
                        [
                            11.10997555223487,
                            46.924947358930446
                        ],
                        [
                            11.109766654496292,
                            46.925648655783434
                        ],
                        [
                            11.109752788786743,
                            46.92608987542562
                        ],
                        [
                            11.109878281739789,
                            46.92683900107592
                        ],
                        [
                            11.111460109003382,
                            46.92852418801427
                        ],
                        [
                            11.112208316431676,
                            46.92913582996415
                        ],
                        [
                            11.115012732548065,
                            46.93100537834624
                        ],
                        [
                            11.116107860708397,
                            46.931084125715245
                        ],
                        [
                            11.116740972582456,
                            46.931085916050286
                        ],
                        [
                            11.118130042769304,
                            46.9308937280258
                        ],
                        [
                            11.118743134722076,
                            46.93078338590078
                        ],
                        [
                            11.119639083513158,
                            46.93060030809136
                        ],
                        [
                            11.127432487899238,
                            46.9289798113965
                        ],
                        [
                            11.131419219852729,
                            46.9283116760591
                        ],
                        [
                            11.138604257087867,
                            46.92747118372281
                        ],
                        [
                            11.139551429332078,
                            46.927628964493096
                        ],
                        [
                            11.155666903618547,
                            46.93443146500282
                        ],
                        [
                            11.156320303701886,
                            46.93485562075948
                        ],
                        [
                            11.163751749224538,
                            46.93970995007475
                        ],
                        [
                            11.16475178282213,
                            46.940397482690166
                        ],
                        [
                            11.165194829815764,
                            46.940713074558964
                        ],
                        [
                            11.166268514683473,
                            46.941678176433214
                        ],
                        [
                            11.167920723868859,
                            46.94405419524523
                        ],
                        [
                            11.168335226082904,
                            46.94465829263445
                        ],
                        [
                            11.164680517402383,
                            46.94734626848769
                        ],
                        [
                            11.163025940674505,
                            46.949352890858826
                        ],
                        [
                            11.162725791316849,
                            46.95015949865467
                        ],
                        [
                            11.16389726485784,
                            46.960490997348565
                        ],
                        [
                            11.16452521123373,
                            46.96556819512707
                        ],
                        [
                            11.164907715217304,
                            46.9654979646076
                        ],
                        [
                            11.166004332273511,
                            46.9650857490021
                        ],
                        [
                            11.166893314875937,
                            46.96478094567558
                        ],
                        [
                            11.171699055262534,
                            46.96336696518729
                        ],
                        [
                            11.174135804453574,
                            46.96275824487137
                        ],
                        [
                            11.174885041571528,
                            46.962595521390625
                        ],
                        [
                            11.176127107267867,
                            46.9625314143288
                        ],
                        [
                            11.176686331901838,
                            46.96268726685683
                        ],
                        [
                            11.177408486652292,
                            46.96305149864543
                        ],
                        [
                            11.182691216208585,
                            46.96571813859545
                        ],
                        [
                            11.18312736576311,
                            46.966038291708685
                        ],
                        [
                            11.184777569731077,
                            46.96746017979576
                        ],
                        [
                            11.185442789332125,
                            46.968117922684414
                        ],
                        [
                            11.187301011789673,
                            46.96954030142649
                        ],
                        [
                            11.187804815746302,
                            46.969805147209556
                        ],
                        [
                            11.188908731929839,
                            46.97015750831145
                        ],
                        [
                            11.195181891815738,
                            46.97010935088228
                        ],
                        [
                            11.202460039021824,
                            46.96836315097332
                        ],
                        [
                            11.202920320434332,
                            46.968106813340164
                        ],
                        [
                            11.203121725489037,
                            46.96790945134659
                        ],
                        [
                            11.203484813916615,
                            46.9674075025742
                        ],
                        [
                            11.204115923649306,
                            46.96627044154701
                        ],
                        [
                            11.204692567528152,
                            46.96496794045808
                        ],
                        [
                            11.204815148783794,
                            46.96409265254283
                        ],
                        [
                            11.205371762403654,
                            46.96326299335273
                        ],
                        [
                            11.206159018041854,
                            46.96274836231067
                        ],
                        [
                            11.206869301651981,
                            46.96259967883102
                        ],
                        [
                            11.207459061362163,
                            46.962876279737905
                        ],
                        [
                            11.211867495288466,
                            46.9649464870937
                        ],
                        [
                            11.213438535620055,
                            46.96576654326682
                        ],
                        [
                            11.215865967884932,
                            46.96702896172055
                        ],
                        [
                            11.220125118099954,
                            46.96902974628421
                        ],
                        [
                            11.224477620155671,
                            46.96948968372335
                        ],
                        [
                            11.225417603544612,
                            46.96958839996408
                        ],
                        [
                            11.240442630489252,
                            46.969785704382375
                        ],
                        [
                            11.241393713200228,
                            46.969618595193026
                        ],
                        [
                            11.244283605334436,
                            46.97156429694796
                        ],
                        [
                            11.247147783562534,
                            46.97308746368704
                        ],
                        [
                            11.247728311508798,
                            46.97339103904746
                        ],
                        [
                            11.248326357965627,
                            46.97368076569478
                        ],
                        [
                            11.262180672909855,
                            46.9800672100951
                        ],
                        [
                            11.262770713265747,
                            46.980339022794006
                        ],
                        [
                            11.263831711510463,
                            46.98047552686416
                        ],
                        [
                            11.284188337213175,
                            46.98291931137436
                        ],
                        [
                            11.300292641619553,
                            46.9835056831727
                        ],
                        [
                            11.31026851950614,
                            46.985676046346256
                        ],
                        [
                            11.310962468742737,
                            46.986539464323
                        ],
                        [
                            11.311431803841174,
                            46.9870924424646
                        ],
                        [
                            11.312342002244177,
                            46.98793798625356
                        ],
                        [
                            11.313309833004121,
                            46.98882285463063
                        ],
                        [
                            11.314021619219028,
                            46.98931692276182
                        ],
                        [
                            11.316243671840573,
                            46.990806349810626
                        ],
                        [
                            11.317055619615964,
                            46.99133436900641
                        ],
                        [
                            11.317809209982375,
                            46.99180506989215
                        ],
                        [
                            11.318196533758158,
                            46.99201770655912
                        ],
                        [
                            11.318811669877999,
                            46.99227072375192
                        ],
                        [
                            11.31930589376345,
                            46.99242719683525
                        ],
                        [
                            11.319781715111613,
                            46.992386055718335
                        ],
                        [
                            11.320064750486107,
                            46.99233532199828
                        ],
                        [
                            11.320388951120682,
                            46.99224775674263
                        ],
                        [
                            11.3209862195694,
                            46.99206915900485
                        ],
                        [
                            11.332158699516102,
                            46.988453802930955
                        ],
                        [
                            11.335218072278328,
                            46.98658706173041
                        ],
                        [
                            11.342214686415327,
                            46.98759149209811
                        ],
                        [
                            11.347247121362185,
                            46.9904356543377
                        ],
                        [
                            11.35740285805148,
                            46.99049238792759
                        ],
                        [
                            11.357728688286743,
                            46.99048117616193
                        ],
                        [
                            11.358286501771762,
                            46.990361692319404
                        ],
                        [
                            11.363985192075525,
                            46.98754433132373
                        ],
                        [
                            11.364449983807678,
                            46.98727374956803
                        ],
                        [
                            11.375592833611945,
                            46.979740048714845
                        ],
                        [
                            11.376116486319782,
                            46.97926121438682
                        ],
                        [
                            11.38047104902917,
                            46.97486904285785
                        ],
                        [
                            11.380552943143687,
                            46.97469635114159
                        ],
                        [
                            11.380634714021387,
                            46.97446516897049
                        ],
                        [
                            11.380739141480642,
                            46.97400402973134
                        ],
                        [
                            11.380767840632299,
                            46.973539968863996
                        ],
                        [
                            11.38076751169065,
                            46.97331049272022
                        ],
                        [
                            11.38076518661444,
                            46.9730360614297
                        ],
                        [
                            11.400908519190617,
                            46.96524476417305
                        ],
                        [
                            11.40676600245289,
                            46.9659091626285
                        ],
                        [
                            11.41426799503622,
                            46.96683555616965
                        ],
                        [
                            11.424023889799654,
                            46.96912213620665
                        ],
                        [
                            11.428680684885117,
                            46.97087276398183
                        ],
                        [
                            11.439086775762869,
                            46.97483163586441
                        ],
                        [
                            11.439378810672107,
                            46.97496489928287
                        ],
                        [
                            11.441184380084412,
                            46.97597932124012
                        ],
                        [
                            11.442090680655232,
                            46.97649994464387
                        ],
                        [
                            11.4422766110058,
                            46.97672095880546
                        ],
                        [
                            11.442515272133013,
                            46.97721532934897
                        ],
                        [
                            11.44261766986777,
                            46.977442626404475
                        ],
                        [
                            11.44273621065436,
                            46.978403027997274
                        ],
                        [
                            11.442852104230147,
                            46.97925099034017
                        ],
                        [
                            11.442959200373632,
                            46.979887657295166
                        ],
                        [
                            11.44300187620355,
                            46.980102732516336
                        ],
                        [
                            11.443053782069397,
                            46.98032210764534
                        ],
                        [
                            11.443164408312121,
                            46.98053122976224
                        ],
                        [
                            11.444498057733641,
                            46.98299556592314
                        ],
                        [
                            11.44474333954602,
                            46.983327803598534
                        ],
                        [
                            11.445363023604692,
                            46.984156000857574
                        ],
                        [
                            11.445700269310104,
                            46.98457626296952
                        ],
                        [
                            11.45229337304002,
                            46.99148614882726
                        ],
                        [
                            11.452896405898723,
                            46.99210767592275
                        ],
                        [
                            11.453674565243196,
                            46.99249596552059
                        ],
                        [
                            11.454569315167504,
                            46.99273775883411
                        ],
                        [
                            11.454911165203432,
                            46.99278892005829
                        ],
                        [
                            11.455178267175105,
                            46.99282368793754
                        ],
                        [
                            11.45551231367299,
                            46.992848017657415
                        ],
                        [
                            11.455837311836248,
                            46.992836544109046
                        ],
                        [
                            11.456546431999527,
                            46.99277632684346
                        ],
                        [
                            11.457723425630956,
                            46.99262956630266
                        ],
                        [
                            11.458039985510089,
                            46.99255977017801
                        ],
                        [
                            11.461689989899803,
                            46.99285028599278
                        ],
                        [
                            11.469092942410242,
                            46.99485964331439
                        ],
                        [
                            11.469854177591154,
                            46.995180691312974
                        ],
                        [
                            11.469840280431594,
                            46.99580644481176
                        ],
                        [
                            11.469690773312301,
                            46.99621914153165
                        ],
                        [
                            11.46935124742971,
                            46.99687891970387
                        ],
                        [
                            11.469126989676171,
                            46.99725723025138
                        ],
                        [
                            11.469061612832508,
                            46.997533120714095
                        ],
                        [
                            11.46883190419648,
                            46.99864949508426
                        ],
                        [
                            11.468791432307253,
                            46.99909133403931
                        ],
                        [
                            11.46889298001895,
                            46.999368122872575
                        ],
                        [
                            11.469559015938106,
                            47.00115361813539
                        ],
                        [
                            11.469699597549566,
                            47.00145656007683
                        ],
                        [
                            11.469812430976276,
                            47.001692607458395
                        ],
                        [
                            11.47037782429559,
                            47.00282781857077
                        ],
                        [
                            11.470478097003998,
                            47.002969643381185
                        ],
                        [
                            11.470666311360832,
                            47.003235560276764
                        ],
                        [
                            11.470848962130253,
                            47.003452099734766
                        ],
                        [
                            11.477145852714878,
                            47.00979098857728
                        ],
                        [
                            11.477677214081035,
                            47.010256449546084
                        ],
                        [
                            11.478324545599497,
                            47.01059790577466
                        ],
                        [
                            11.478715449824014,
                            47.01072892953213
                        ],
                        [
                            11.479041640534039,
                            47.01082985612225
                        ],
                        [
                            11.47931586991069,
                            47.01090940916409
                        ],
                        [
                            11.479532145280736,
                            47.0109452205439
                        ],
                        [
                            11.479858518248927,
                            47.01099664274638
                        ],
                        [
                            11.4802010907211,
                            47.01100721956322
                        ],
                        [
                            11.481694990697882,
                            47.01100183051706
                        ],
                        [
                            11.48201208383203,
                            47.010994954859456
                        ],
                        [
                            11.482321147356656,
                            47.01095675302933
                        ],
                        [
                            11.483733894336261,
                            47.01092160257969
                        ],
                        [
                            11.488469252563922,
                            47.01071974086704
                        ],
                        [
                            11.490214619113441,
                            47.010605281704954
                        ],
                        [
                            11.492144721497274,
                            47.010378781121915
                        ],
                        [
                            11.498740860614983,
                            47.00955999888152
                        ],
                        [
                            11.512598761831123,
                            47.00466691918783
                        ],
                        [
                            11.531955184194713,
                            46.99198316299118
                        ],
                        [
                            11.532430908124987,
                            46.991630661679686
                        ],
                        [
                            11.532720826708056,
                            46.99139926006321
                        ],
                        [
                            11.533484571436516,
                            46.99053191431852
                        ],
                        [
                            11.538076938508825,
                            46.98410808654417
                        ],
                        [
                            11.54358923763373,
                            46.986528016567064
                        ],
                        [
                            11.5502571508432,
                            46.98936740485072
                        ],
                        [
                            11.551488544882114,
                            46.989834919234085
                        ],
                        [
                            11.553628923783288,
                            46.9902641444418
                        ],
                        [
                            11.554621873432524,
                            46.99045346685188
                        ],
                        [
                            11.556496558832157,
                            46.99074007864676
                        ],
                        [
                            11.55674658117764,
                            46.99072549336176
                        ],
                        [
                            11.56211132324557,
                            46.99104197271865
                        ],
                        [
                            11.570699357341642,
                            46.993108213458264
                        ],
                        [
                            11.571297013991659,
                            46.993297271278635
                        ],
                        [
                            11.577087713293498,
                            46.995574342794534
                        ],
                        [
                            11.58080642750445,
                            46.99711942445964
                        ],
                        [
                            11.581051004346529,
                            46.99738389017387
                        ],
                        [
                            11.581045716023732,
                            46.99764949162133
                        ],
                        [
                            11.581004600625688,
                            46.99795639840447
                        ],
                        [
                            11.580917313751863,
                            46.99851632775097
                        ],
                        [
                            11.580831040024309,
                            46.99899524228988
                        ],
                        [
                            11.58063528965476,
                            46.99994909012203
                        ],
                        [
                            11.580499136370262,
                            47.000433628826464
                        ],
                        [
                            11.580522417988357,
                            47.00112155545284
                        ],
                        [
                            11.580790890106865,
                            47.001488974872245
                        ],
                        [
                            11.581968849338653,
                            47.00204736242995
                        ],
                        [
                            11.588852378439372,
                            47.00465465371283
                        ],
                        [
                            11.60945599832144,
                            47.01078773311393
                        ],
                        [
                            11.615670817818193,
                            47.012045252438185
                        ],
                        [
                            11.627210453739467,
                            47.01257735093896
                        ],
                        [
                            11.627511664133538,
                            47.01249844105403
                        ],
                        [
                            11.627686167922082,
                            47.0124179384014
                        ],
                        [
                            11.627836796322397,
                            47.01220299453992
                        ],
                        [
                            11.62806822211416,
                            47.011774709020756
                        ],
                        [
                            11.62815843127705,
                            47.011367664220586
                        ],
                        [
                            11.628242315475582,
                            47.011032760705405
                        ],
                        [
                            11.62834082950328,
                            47.010711019296735
                        ],
                        [
                            11.630561132727443,
                            47.00734822316583
                        ],
                        [
                            11.63067616542896,
                            47.00717908883048
                        ],
                        [
                            11.635805135458789,
                            47.00269635454031
                        ],
                        [
                            11.636780786035205,
                            47.00232289927219
                        ],
                        [
                            11.637130919385054,
                            47.00222033875373
                        ],
                        [
                            11.646791892749016,
                            46.9993649583044
                        ],
                        [
                            11.656041327186685,
                            46.996122335816665
                        ],
                        [
                            11.664104053923312,
                            46.99262761051312
                        ],
                        [
                            11.667642864079749,
                            46.992725154732966
                        ],
                        [
                            11.682651066202869,
                            46.99379619130201
                        ],
                        [
                            11.711231915465198,
                            46.993023559218415
                        ],
                        [
                            11.711482366141837,
                            46.99285563423755
                        ],
                        [
                            11.71694538070487,
                            46.98753335671673
                        ],
                        [
                            11.717097952218113,
                            46.987300247178666
                        ],
                        [
                            11.720573072421566,
                            46.981939481019914
                        ],
                        [
                            11.72724236585172,
                            46.972938716253005
                        ],
                        [
                            11.727669554307987,
                            46.97253255506031
                        ],
                        [
                            11.727964806090394,
                            46.97232752878183
                        ],
                        [
                            11.728332655292569,
                            46.97219276304091
                        ],
                        [
                            11.72909773751859,
                            46.972048524639426
                        ],
                        [
                            11.747168164872113,
                            46.96890272279262
                        ],
                        [
                            11.751448109148434,
                            46.97122074680964
                        ],
                        [
                            11.752277932190461,
                            46.97150677093161
                        ],
                        [
                            11.75634966553688,
                            46.97219620741175
                        ],
                        [
                            11.766780742982226,
                            46.97757813105665
                        ],
                        [
                            11.76837414323249,
                            46.980185441333205
                        ],
                        [
                            11.769156975602824,
                            46.98108444786509
                        ],
                        [
                            11.77198735678635,
                            46.98432322690408
                        ],
                        [
                            11.772938154150388,
                            46.98514614016732
                        ],
                        [
                            11.78178266658257,
                            46.9920590539057
                        ],
                        [
                            11.782749078793383,
                            46.99211654985946
                        ],
                        [
                            11.784386876995804,
                            46.991964211242205
                        ],
                        [
                            11.785339990465578,
                            46.99167102904807
                        ],
                        [
                            11.78585947956076,
                            46.99149639067983
                        ],
                        [
                            11.78926777598706,
                            46.990189421898144
                        ],
                        [
                            11.796826024891926,
                            46.990958863789466
                        ],
                        [
                            11.803029221014869,
                            46.991324537596405
                        ],
                        [
                            11.803664062180436,
                            46.99131348317254
                        ],
                        [
                            11.804816914693067,
                            46.99113223461988
                        ],
                        [
                            11.80737344754997,
                            46.99067805660803
                        ],
                        [
                            11.808963998718422,
                            46.99017554413171
                        ],
                        [
                            11.809491115450456,
                            46.989928616357496
                        ],
                        [
                            11.809742519929971,
                            46.989769451024685
                        ],
                        [
                            11.814732569254359,
                            46.98970079767374
                        ],
                        [
                            11.81529096021936,
                            46.98976805523902
                        ],
                        [
                            11.815683156775806,
                            46.989816899463584
                        ],
                        [
                            11.835568480182985,
                            46.992741128500356
                        ],
                        [
                            11.83592625793533,
                            46.992822256499444
                        ],
                        [
                            11.836210497951654,
                            46.99289620496199
                        ],
                        [
                            11.848238768903641,
                            47.000085011970164
                        ],
                        [
                            11.85976668039165,
                            47.00789703200301
                        ],
                        [
                            11.860040023082709,
                            47.008088187619734
                        ],
                        [
                            11.860554268911214,
                            47.00841731614543
                        ],
                        [
                            11.878161941538004,
                            47.015283366174174
                        ],
                        [
                            11.893624348459836,
                            47.01850218054588
                        ],
                        [
                            11.915327526073641,
                            47.0325484877238
                        ],
                        [
                            11.915766812124634,
                            47.03274428187928
                        ],
                        [
                            11.916798098201609,
                            47.03314547434335
                        ],
                        [
                            11.917373038171503,
                            47.03332430766019
                        ],
                        [
                            11.932077003670274,
                            47.03760571506329
                        ],
                        [
                            11.932326348385994,
                            47.037666821863915
                        ],
                        [
                            11.932783567700652,
                            47.03776759793373
                        ],
                        [
                            11.933083613130114,
                            47.03777790612905
                        ],
                        [
                            11.933725760312392,
                            47.03777044146919
                        ],
                        [
                            11.934493702240998,
                            47.03770125196208
                        ],
                        [
                            11.938206342491302,
                            47.037259494107325
                        ],
                        [
                            11.938906813809695,
                            47.03716051083318
                        ],
                        [
                            11.939751385709297,
                            47.037003822071334
                        ],
                        [
                            11.941212573824904,
                            47.036525293416204
                        ],
                        [
                            11.942658117844106,
                            47.03600215147889
                        ],
                        [
                            11.968401567134626,
                            47.04060641835675
                        ],
                        [
                            11.968749281803237,
                            47.040867384586015
                        ],
                        [
                            11.969082530950615,
                            47.041223218597274
                        ],
                        [
                            11.96925290353714,
                            47.04141678673917
                        ],
                        [
                            11.9713819406297,
                            47.04443036275187
                        ],
                        [
                            11.972240289139608,
                            47.04569050139387
                        ],
                        [
                            11.972751278365118,
                            47.046208200074055
                        ],
                        [
                            11.973074188286684,
                            47.04651029554249
                        ],
                        [
                            11.973585046758291,
                            47.04695149685013
                        ],
                        [
                            11.976122877394598,
                            47.048725921878464
                        ],
                        [
                            11.976461290135608,
                            47.048951106633076
                        ],
                        [
                            11.977952344269674,
                            47.049614274251574
                        ],
                        [
                            11.978281084476984,
                            47.049754208787604
                        ],
                        [
                            11.978875275242126,
                            47.04982873676557
                        ],
                        [
                            11.979903674415672,
                            47.04988295494969
                        ],
                        [
                            11.996820351408958,
                            47.04956713505225
                        ],
                        [
                            11.997095692931905,
                            47.04954642394275
                        ],
                        [
                            12.00854246963982,
                            47.048022081322024
                        ],
                        [
                            12.01252212941636,
                            47.047395395476535
                        ],
                        [
                            12.015476053382091,
                            47.04677761146251
                        ],
                        [
                            12.016876736514696,
                            47.046736187970126
                        ],
                        [
                            12.0175378614978,
                            47.04672775394126
                        ],
                        [
                            12.020061028533314,
                            47.04676017826602
                        ],
                        [
                            12.021149169326138,
                            47.046983441030584
                        ],
                        [
                            12.021469956328719,
                            47.04708296537746
                        ],
                        [
                            12.030347853267262,
                            47.050038526508125
                        ],
                        [
                            12.030634162963187,
                            47.05013893831206
                        ],
                        [
                            12.030821282326635,
                            47.05031847414813
                        ],
                        [
                            12.031461506225286,
                            47.0509854797115
                        ],
                        [
                            12.03170055991747,
                            47.051253632096525
                        ],
                        [
                            12.03191571033374,
                            47.05192740004342
                        ],
                        [
                            12.032032607426158,
                            47.05239227851351
                        ],
                        [
                            12.032146900017558,
                            47.05308671768994
                        ],
                        [
                            12.032251359679954,
                            47.05370941890055
                        ],
                        [
                            12.032515389641219,
                            47.05435938948032
                        ],
                        [
                            12.033496067007064,
                            47.055759823739926
                        ],
                        [
                            12.034090711941614,
                            47.056608015131346
                        ],
                        [
                            12.034423501661465,
                            47.05700416992323
                        ],
                        [
                            12.034867038638552,
                            47.05750988281987
                        ],
                        [
                            12.035318118731556,
                            47.057916397724895
                        ],
                        [
                            12.04304046524154,
                            47.061261608832226
                        ],
                        [
                            12.044369710744375,
                            47.06136124186828
                        ],
                        [
                            12.050038414335999,
                            47.061561259775395
                        ],
                        [
                            12.05270975358871,
                            47.061062541319544
                        ],
                        [
                            12.059520096378215,
                            47.05868924452806
                        ],
                        [
                            12.070045995453702,
                            47.05992823242904
                        ],
                        [
                            12.081207197567489,
                            47.068006824200424
                        ],
                        [
                            12.08144256197523,
                            47.06824797456507
                        ],
                        [
                            12.081836843629265,
                            47.06864683682699
                        ],
                        [
                            12.082104485137503,
                            47.06890511564565
                        ],
                        [
                            12.082330935434396,
                            47.06910600525927
                        ],
                        [
                            12.082573527275867,
                            47.0693154591524
                        ],
                        [
                            12.092982732979197,
                            47.07628371684572
                        ],
                        [
                            12.093669084705134,
                            47.07664764432128
                        ],
                        [
                            12.097130885438258,
                            47.077534949032696
                        ],
                        [
                            12.097566392636782,
                            47.077590655304654
                        ],
                        [
                            12.098535784304639,
                            47.0776949036125
                        ],
                        [
                            12.099238382941243,
                            47.07777037104848
                        ],
                        [
                            12.101778221256044,
                            47.078021033059045
                        ],
                        [
                            12.102112998492077,
                            47.07804345690924
                        ],
                        [
                            12.102780823021767,
                            47.07801634827437
                        ],
                        [
                            12.103282337068455,
                            47.077989248381996
                        ],
                        [
                            12.121547556459333,
                            47.07459904340009
                        ],
                        [
                            12.122014731003452,
                            47.0748022878115
                        ],
                        [
                            12.124341844896312,
                            47.07573772225571
                        ],
                        [
                            12.128793493872529,
                            47.0775194932318
                        ],
                        [
                            12.136260278023013,
                            47.08042893322458
                        ],
                        [
                            12.136519840449605,
                            47.080516314266816
                        ],
                        [
                            12.137272673894062,
                            47.08059017010575
                        ],
                        [
                            12.144169760380006,
                            47.080256858902835
                        ],
                        [
                            12.148987386065256,
                            47.07973739035468
                        ],
                        [
                            12.153377251629337,
                            47.08017446782389
                        ],
                        [
                            12.1610124685281,
                            47.08158821686156
                        ],
                        [
                            12.163088356144534,
                            47.08240830910537
                        ],
                        [
                            12.17476327006922,
                            47.08706175265422
                        ],
                        [
                            12.179100223703465,
                            47.08956922130088
                        ],
                        [
                            12.17988249166792,
                            47.09025845417587
                        ],
                        [
                            12.18543370649783,
                            47.09158898185108
                        ],
                        [
                            12.185761111327636,
                            47.09166536212827
                        ],
                        [
                            12.18668072282199,
                            47.09178374646217
                        ],
                        [
                            12.190536610897942,
                            47.09060983899929
                        ],
                        [
                            12.192062326493582,
                            47.090135303946454
                        ],
                        [
                            12.193471437039381,
                            47.08950200681124
                        ],
                        [
                            12.19478921886965,
                            47.08891174325323
                        ],
                        [
                            12.19510479058563,
                            47.08879043700485
                        ],
                        [
                            12.195355607386649,
                            47.08872943410709
                        ],
                        [
                            12.201533874354954,
                            47.08727428014594
                        ],
                        [
                            12.205112734620146,
                            47.08653061184659
                        ],
                        [
                            12.20667909757918,
                            47.0862707322926
                        ],
                        [
                            12.211268691555004,
                            47.08619150750617
                        ],
                        [
                            12.214055691440649,
                            47.086099753552915
                        ],
                        [
                            12.21489098932735,
                            47.08603578895123
                        ],
                        [
                            12.215217979399524,
                            47.08595460173912
                        ],
                        [
                            12.224650792509003,
                            47.08300274721895
                        ],
                        [
                            12.225591385120214,
                            47.08270624241812
                        ],
                        [
                            12.22589094689475,
                            47.082594301613305
                        ],
                        [
                            12.22612257032817,
                            47.082461776511465
                        ],
                        [
                            12.22668456505227,
                            47.08197794549883
                        ],
                        [
                            12.226883590418261,
                            47.08179684089411
                        ],
                        [
                            12.227581431179575,
                            47.08090419002912
                        ],
                        [
                            12.227966458305723,
                            47.08029934922997
                        ],
                        [
                            12.228097022673245,
                            47.080034676178535
                        ],
                        [
                            12.228338737147357,
                            47.07941588072839
                        ],
                        [
                            12.228541734041265,
                            47.078960168537016
                        ],
                        [
                            12.228878216401837,
                            47.0783971936591
                        ],
                        [
                            12.229793758358364,
                            47.077048402992105
                        ],
                        [
                            12.230041828315283,
                            47.076807409415586
                        ],
                        [
                            12.230438198449603,
                            47.07643173113508
                        ],
                        [
                            12.231891448280603,
                            47.075139736131824
                        ],
                        [
                            12.2377597897253,
                            47.07029849054561
                        ],
                        [
                            12.23799189136167,
                            47.07010742669179
                        ],
                        [
                            12.238633264618743,
                            47.06993177865141
                        ],
                        [
                            12.239066651657309,
                            47.069897010699115
                        ],
                        [
                            12.23954990356553,
                            47.06989682971423
                        ],
                        [
                            12.239757868303576,
                            47.06975594572723
                        ],
                        [
                            12.240121249937687,
                            47.069340669509415
                        ],
                        [
                            12.240201033552703,
                            47.06913591619752
                        ],
                        [
                            12.240272615059673,
                            47.06889089833722
                        ],
                        [
                            12.24029433905121,
                            47.068611291943746
                        ],
                        [
                            12.24019264358791,
                            47.06793919658145
                        ],
                        [
                            12.23992101445932,
                            47.0675869025039
                        ],
                        [
                            12.239607208250124,
                            47.067231301322124
                        ],
                        [
                            12.238997354014687,
                            47.06665008998599
                        ],
                        [
                            12.237829413391049,
                            47.065634688268624
                        ],
                        [
                            12.226370816734496,
                            47.060923080748566
                        ],
                        [
                            12.225790825485385,
                            47.060696443752455
                        ],
                        [
                            12.22144910079852,
                            47.05963532091939
                        ],
                        [
                            12.218298438925904,
                            47.05894101940303
                        ],
                        [
                            12.218006494529837,
                            47.058904234755595
                        ],
                        [
                            12.216738668262762,
                            47.05850340363714
                        ],
                        [
                            12.215651123837226,
                            47.05458761977867
                        ],
                        [
                            12.215631553917856,
                            47.05439917554941
                        ],
                        [
                            12.215630331759149,
                            47.05421471816072
                        ],
                        [
                            12.21565495066352,
                            47.05355704917143
                        ],
                        [
                            12.215716068821738,
                            47.05315034633783
                        ],
                        [
                            12.216798014957813,
                            47.049713550825885
                        ],
                        [
                            12.216434352343267,
                            47.045502922328225
                        ],
                        [
                            12.216398629353742,
                            47.045305935164954
                        ],
                        [
                            12.216321576384411,
                            47.0450921069338
                        ],
                        [
                            12.211339576603255,
                            47.03649786383038
                        ],
                        [
                            12.211169245726467,
                            47.036237154678574
                        ],
                        [
                            12.208224647141861,
                            47.03202691708141
                        ],
                        [
                            12.206977813847175,
                            47.03048242774307
                        ],
                        [
                            12.204790459886226,
                            47.0278888156892
                        ],
                        [
                            12.200219073395894,
                            47.027143816264726
                        ],
                        [
                            12.199953268178483,
                            47.027155751376334
                        ],
                        [
                            12.199309426658752,
                            47.0271737578229
                        ],
                        [
                            12.195134162673542,
                            47.026957458813015
                        ],
                        [
                            12.183265359914614,
                            47.025042907793235
                        ],
                        [
                            12.1788969690391,
                            47.02432740756594
                        ],
                        [
                            12.173583895697233,
                            47.023394957163056
                        ],
                        [
                            12.173349699404804,
                            47.02332945615802
                        ],
                        [
                            12.17298282531439,
                            47.02321813632456
                        ],
                        [
                            12.172380456719976,
                            47.023005350464715
                        ],
                        [
                            12.169920639924056,
                            47.021984575266416
                        ],
                        [
                            12.1481506967679,
                            47.024367654475085
                        ],
                        [
                            12.146932607447507,
                            47.02424367199944
                        ],
                        [
                            12.145761694252215,
                            47.02369089661075
                        ],
                        [
                            12.142882849046936,
                            47.02223557911784
                        ],
                        [
                            12.127146327471742,
                            47.01353665219284
                        ],
                        [
                            12.126551871120297,
                            47.01311641749182
                        ],
                        [
                            12.126100046844979,
                            47.012786777983024
                        ],
                        [
                            12.125590693912555,
                            47.01237320974108
                        ],
                        [
                            12.125188736379402,
                            47.012024203961424
                        ],
                        [
                            12.124911337828976,
                            47.01176629107438
                        ],
                        [
                            12.120988263371181,
                            47.00665357758659
                        ],
                        [
                            12.123815278093833,
                            47.003737021122745
                        ],
                        [
                            12.124824235714973,
                            47.00261150520297
                        ],
                        [
                            12.136698765529038,
                            46.98300468611996
                        ],
                        [
                            12.137426242487331,
                            46.979497349344726
                        ],
                        [
                            12.135893893136197,
                            46.96960368138051
                        ],
                        [
                            12.131524775170526,
                            46.9641165484173
                        ],
                        [
                            12.131048696812133,
                            46.963913588096254
                        ],
                        [
                            12.131508216695197,
                            46.9629470382391
                        ],
                        [
                            12.131642616496055,
                            46.96277236473403
                        ],
                        [
                            12.132326779174962,
                            46.96195265645978
                        ],
                        [
                            12.137798551445364,
                            46.95688433229307
                        ],
                        [
                            12.138074315619164,
                            46.95668327451471
                        ],
                        [
                            12.144795873487476,
                            46.95446923052848
                        ],
                        [
                            12.149423729177018,
                            46.95317643308262
                        ],
                        [
                            12.152442067451165,
                            46.95244080469259
                        ],
                        [
                            12.158212284836319,
                            46.9506616724192
                        ],
                        [
                            12.158987726187009,
                            46.94997877719285
                        ],
                        [
                            12.160462984403638,
                            46.94840356475207
                        ],
                        [
                            12.164956419746925,
                            46.94285695947177
                        ],
                        [
                            12.165673668535497,
                            46.941914634178985
                        ],
                        [
                            12.16820533358177,
                            46.93788913589081
                        ],
                        [
                            12.168255324740237,
                            46.937289267357144
                        ],
                        [
                            12.167880518751087,
                            46.93447371913608
                        ],
                        [
                            12.167738501647873,
                            46.933820667162706
                        ],
                        [
                            12.167605721928403,
                            46.93335185749329
                        ],
                        [
                            12.167405256715885,
                            46.93283542234739
                        ],
                        [
                            12.166872273514482,
                            46.93261168570036
                        ],
                        [
                            12.166421463500132,
                            46.93243067333167
                        ],
                        [
                            12.165812526322231,
                            46.932200035579285
                        ],
                        [
                            12.164979446864571,
                            46.9318720987631
                        ],
                        [
                            12.164137636754917,
                            46.93153539943136
                        ],
                        [
                            12.161777124475973,
                            46.92992221871671
                        ],
                        [
                            12.161410933221147,
                            46.9296578493314
                        ],
                        [
                            12.155734887970574,
                            46.92213328705573
                        ],
                        [
                            12.154818074976255,
                            46.920642115295834
                        ],
                        [
                            12.146985221539639,
                            46.91571002828829
                        ],
                        [
                            12.144133320862394,
                            46.91401100663754
                        ],
                        [
                            12.14451062855383,
                            46.914104131344544
                        ],
                        [
                            12.144909895674358,
                            46.91402565577356
                        ],
                        [
                            12.15890593541787,
                            46.90944153849592
                        ],
                        [
                            12.159258729396702,
                            46.9092157965367
                        ],
                        [
                            12.15983346064733,
                            46.90863293386223
                        ],
                        [
                            12.161372718937157,
                            46.90700642954868
                        ],
                        [
                            12.165801896661655,
                            46.9085173774892
                        ],
                        [
                            12.170735048925428,
                            46.909217699588
                        ],
                        [
                            12.180420311903406,
                            46.9080532919427
                        ],
                        [
                            12.190163939062987,
                            46.906233948867225
                        ],
                        [
                            12.193589043690315,
                            46.903420409860544
                        ],
                        [
                            12.19867795381089,
                            46.89737879996818
                        ],
                        [
                            12.199317739647455,
                            46.89629892283916
                        ],
                        [
                            12.19944671037426,
                            46.89601181872897
                        ],
                        [
                            12.199425889876933,
                            46.895841404111124
                        ],
                        [
                            12.197883495240367,
                            46.891875115795074
                        ],
                        [
                            12.200089896065533,
                            46.88838895749224
                        ],
                        [
                            12.204620658954928,
                            46.883505663199266
                        ],
                        [
                            12.209067336255925,
                            46.87913753560865
                        ],
                        [
                            12.209455899224183,
                            46.878775635349456
                        ],
                        [
                            12.215033121002348,
                            46.874191038754375
                        ],
                        [
                            12.21623032279695,
                            46.873869377856614
                        ],
                        [
                            12.216578891175125,
                            46.87385507217891
                        ],
                        [
                            12.217936575351846,
                            46.873816876299706
                        ],
                        [
                            12.218587220186189,
                            46.873888564300245
                        ],
                        [
                            12.219588320506057,
                            46.87673134201248
                        ],
                        [
                            12.219807669496175,
                            46.87717515932538
                        ],
                        [
                            12.219909031748521,
                            46.877374803517974
                        ],
                        [
                            12.221075665744516,
                            46.87899342489371
                        ],
                        [
                            12.221637985701935,
                            46.87965707459812
                        ],
                        [
                            12.221946515637782,
                            46.87990487886265
                        ],
                        [
                            12.22280942308163,
                            46.879547568160774
                        ],
                        [
                            12.223316545069402,
                            46.87929027857356
                        ],
                        [
                            12.223579813955048,
                            46.87913885957391
                        ],
                        [
                            12.22456029389064,
                            46.8788547193111
                        ],
                        [
                            12.225126543752753,
                            46.878721753568904
                        ],
                        [
                            12.225441592283392,
                            46.87868136842678
                        ],
                        [
                            12.22574187989327,
                            46.87865489860888
                        ],
                        [
                            12.227864587591146,
                            46.87892349585995
                        ],
                        [
                            12.231995280171311,
                            46.88049880202069
                        ],
                        [
                            12.232220378580612,
                            46.88066793857637
                        ],
                        [
                            12.232396071808322,
                            46.880833970343815
                        ],
                        [
                            12.23568036432441,
                            46.88404404100624
                        ],
                        [
                            12.235830411982588,
                            46.88420629408116
                        ],
                        [
                            12.235948242090489,
                            46.88439195562067
                        ],
                        [
                            12.236091691850504,
                            46.88464889289861
                        ],
                        [
                            12.236209237144832,
                            46.88487056534709
                        ],
                        [
                            12.236303504410293,
                            46.88519639236357
                        ],
                        [
                            12.23634757877477,
                            46.885465141457516
                        ],
                        [
                            12.236372823450155,
                            46.885720922698496
                        ],
                        [
                            12.236258878170888,
                            46.88591314391674
                        ],
                        [
                            12.235964071787134,
                            46.886780974819935
                        ],
                        [
                            12.236011653617147,
                            46.887612115299646
                        ],
                        [
                            12.236201428650048,
                            46.888515731726784
                        ],
                        [
                            12.23649339174137,
                            46.88881346585768
                        ],
                        [
                            12.236695365561227,
                            46.888938247762376
                        ],
                        [
                            12.236960946559844,
                            46.889056728964036
                        ],
                        [
                            12.24218651008429,
                            46.89108216378589
                        ],
                        [
                            12.24297358879164,
                            46.890636852293355
                        ],
                        [
                            12.243188536010944,
                            46.890486758566205
                        ],
                        [
                            12.245383509965,
                            46.888858509914485
                        ],
                        [
                            12.246749623670565,
                            46.88908972986056
                        ],
                        [
                            12.247382213719806,
                            46.889103266819305
                        ],
                        [
                            12.247838986881922,
                            46.88908579600389
                        ],
                        [
                            12.26649343517445,
                            46.88714148389743
                        ],
                        [
                            12.274019671848928,
                            46.884397282133186
                        ],
                        [
                            12.277673361522574,
                            46.87992316684314
                        ],
                        [
                            12.27781307188531,
                            46.879698662660395
                        ],
                        [
                            12.27793446119818,
                            46.87925418925512
                        ],
                        [
                            12.278095103909553,
                            46.87861958958958
                        ],
                        [
                            12.277419247154494,
                            46.87718097902881
                        ],
                        [
                            12.277050968098175,
                            46.87691253539899
                        ],
                        [
                            12.27641295127055,
                            46.876174827630194
                        ],
                        [
                            12.275295815156388,
                            46.87478934399781
                        ],
                        [
                            12.275313974610567,
                            46.8739293347103
                        ],
                        [
                            12.275352667113077,
                            46.873487229694774
                        ],
                        [
                            12.275409406992004,
                            46.873247107614894
                        ],
                        [
                            12.275556737624193,
                            46.87286489188129
                        ],
                        [
                            12.275803714106207,
                            46.87266431702435
                        ],
                        [
                            12.280902651670411,
                            46.869228665464156
                        ],
                        [
                            12.283657132710461,
                            46.86807860987182
                        ],
                        [
                            12.284911113917165,
                            46.86793009627071
                        ],
                        [
                            12.28528527273096,
                            46.86794634515067
                        ],
                        [
                            12.285601856535704,
                            46.867973249756886
                        ],
                        [
                            12.286175788315484,
                            46.867956758358204
                        ],
                        [
                            12.28684055926133,
                            46.8678701517654
                        ],
                        [
                            12.291762143463048,
                            46.86526709980608
                        ],
                        [
                            12.291985574530788,
                            46.865112168692725
                        ],
                        [
                            12.290912104047987,
                            46.86086360121425
                        ],
                        [
                            12.289217341670462,
                            46.856844397858076
                        ],
                        [
                            12.29109190430693,
                            46.851790994438105
                        ],
                        [
                            12.292114673297695,
                            46.849772565073366
                        ],
                        [
                            12.296106605273305,
                            46.8434655970278
                        ],
                        [
                            12.299346531746172,
                            46.84310665336898
                        ],
                        [
                            12.302163132664926,
                            46.84286334447339
                        ],
                        [
                            12.302695320371589,
                            46.84285247362931
                        ],
                        [
                            12.303286682482497,
                            46.84280389181928
                        ],
                        [
                            12.303859474756031,
                            46.842733341802806
                        ],
                        [
                            12.30452329769897,
                            46.842543159438335
                        ],
                        [
                            12.305641108299062,
                            46.842096851772965
                        ],
                        [
                            12.306601250444546,
                            46.84165959097494
                        ],
                        [
                            12.306848369932531,
                            46.84125194657853
                        ],
                        [
                            12.306921255409975,
                            46.84094383968969
                        ],
                        [
                            12.306903673440624,
                            46.84076434701512
                        ],
                        [
                            12.306176436202904,
                            46.83394090697565
                        ],
                        [
                            12.301205009924319,
                            46.82975106883888
                        ],
                        [
                            12.297907631783703,
                            46.827150734428145
                        ],
                        [
                            12.294623293593423,
                            46.82497293009122
                        ],
                        [
                            12.291623384418495,
                            46.82284533977695
                        ],
                        [
                            12.282430622956197,
                            46.81499165133236
                        ],
                        [
                            12.282777105223353,
                            46.814788203150265
                        ],
                        [
                            12.283050815805879,
                            46.81466784516541
                        ],
                        [
                            12.283323428549446,
                            46.81458351527659
                        ],
                        [
                            12.283572042190267,
                            46.814441376773445
                        ],
                        [
                            12.283819021863353,
                            46.81428578377578
                        ],
                        [
                            12.284732680987162,
                            46.81344054018124
                        ],
                        [
                            12.289205687298507,
                            46.80918995474841
                        ],
                        [
                            12.29255967546634,
                            46.802496424487174
                        ],
                        [
                            12.292397015869522,
                            46.801979107757326
                        ],
                        [
                            12.292234685202478,
                            46.8015877822303
                        ],
                        [
                            12.284888460815417,
                            46.7935460957744
                        ],
                        [
                            12.28054745771805,
                            46.79137573989111
                        ],
                        [
                            12.280976411033807,
                            46.78974343030014
                        ],
                        [
                            12.281259122531809,
                            46.78881731584249
                        ],
                        [
                            12.283534483040508,
                            46.783266487459095
                        ],
                        [
                            12.283685939985174,
                            46.78306413614175
                        ],
                        [
                            12.283843125406671,
                            46.78290212284974
                        ],
                        [
                            12.284077702434862,
                            46.78277388271699
                        ],
                        [
                            12.28436133042845,
                            46.782671236623194
                        ],
                        [
                            12.284670838808672,
                            46.78256334445137
                        ],
                        [
                            12.28491905359781,
                            46.78249771267483
                        ],
                        [
                            12.28521957771303,
                            46.782430575431086
                        ],
                        [
                            12.285701586918595,
                            46.782412224509
                        ],
                        [
                            12.301835608706941,
                            46.78223989170482
                        ],
                        [
                            12.30592874029226,
                            46.7827156056227
                        ],
                        [
                            12.30639989501348,
                            46.78321498012782
                        ],
                        [
                            12.30674455494503,
                            46.78360101293373
                        ],
                        [
                            12.307248715622848,
                            46.784130931161606
                        ],
                        [
                            12.307578806106777,
                            46.78430588134166
                        ],
                        [
                            12.307802046451577,
                            46.78442092285299
                        ],
                        [
                            12.308290228504942,
                            46.7846632978823
                        ],
                        [
                            12.30866336671443,
                            46.78481899917115
                        ],
                        [
                            12.308971277856482,
                            46.78483258850333
                        ],
                        [
                            12.309594958664858,
                            46.784774035099396
                        ],
                        [
                            12.310160314391391,
                            46.78469916518227
                        ],
                        [
                            12.310543113586384,
                            46.78463858079466
                        ],
                        [
                            12.323978727779396,
                            46.78204821940975
                        ],
                        [
                            12.324319512438889,
                            46.781970811061775
                        ],
                        [
                            12.324761094199774,
                            46.78186796933012
                        ],
                        [
                            12.325260652970952,
                            46.78172293935532
                        ],
                        [
                            12.326118957518307,
                            46.78147296899994
                        ],
                        [
                            12.326768041796493,
                            46.78126958171826
                        ],
                        [
                            12.329008838738886,
                            46.78026834997809
                        ],
                        [
                            12.329282745620782,
                            46.78008937273392
                        ],
                        [
                            12.329783175088782,
                            46.779759796525184
                        ],
                        [
                            12.331845285274474,
                            46.77915521226676
                        ],
                        [
                            12.336357325779973,
                            46.77909562041385
                        ],
                        [
                            12.35116980752465,
                            46.77706935919713
                        ],
                        [
                            12.351609856790885,
                            46.77691695775739
                        ],
                        [
                            12.357406561812843,
                            46.774663348531185
                        ],
                        [
                            12.358142543942416,
                            46.77407022593511
                        ],
                        [
                            12.358490631398066,
                            46.77367749906836
                        ],
                        [
                            12.358925923820903,
                            46.77297620377788
                        ],
                        [
                            12.358922723244836,
                            46.771990792796295
                        ],
                        [
                            12.358911706704534,
                            46.7717481145669
                        ],
                        [
                            12.358834158160189,
                            46.77129138855049
                        ],
                        [
                            12.359254020874813,
                            46.76725152197687
                        ],
                        [
                            12.359596247338569,
                            46.764595446579435
                        ],
                        [
                            12.359745928535734,
                            46.76417254294022
                        ],
                        [
                            12.361873497078705,
                            46.760081836339936
                        ],
                        [
                            12.364436480689614,
                            46.75608302216781
                        ],
                        [
                            12.366121501125647,
                            46.75279788387843
                        ],
                        [
                            12.367193887751283,
                            46.74822125548141
                        ],
                        [
                            12.368439735454068,
                            46.74250549189045
                        ],
                        [
                            12.368520956123414,
                            46.74224659541193
                        ],
                        [
                            12.369079091701781,
                            46.74052912789659
                        ],
                        [
                            12.369124077517798,
                            46.74041080057302
                        ],
                        [
                            12.37791833062784,
                            46.72193052488212
                        ],
                        [
                            12.37869139976276,
                            46.721003161894146
                        ],
                        [
                            12.379037678258072,
                            46.720628422001596
                        ],
                        [
                            12.38369124637367,
                            46.71655769703334
                        ],
                        [
                            12.390341378278729,
                            46.71349409236035
                        ],
                        [
                            12.40085585986385,
                            46.70757463533714
                        ],
                        [
                            12.413868107602237,
                            46.70065260025562
                        ],
                        [
                            12.414822170292187,
                            46.70022359069068
                        ],
                        [
                            12.415916303249674,
                            46.69978588859824
                        ],
                        [
                            12.417185403110755,
                            46.699477945764905
                        ],
                        [
                            12.417782195961555,
                            46.69934759989687
                        ],
                        [
                            12.419979547213364,
                            46.69907036634732
                        ],
                        [
                            12.421331683791893,
                            46.69910639859582
                        ],
                        [
                            12.430423511324534,
                            46.69441478681149
                        ],
                        [
                            12.438533384056157,
                            46.690143499302906
                        ],
                        [
                            12.44290355407753,
                            46.68812639131431
                        ],
                        [
                            12.443219550854762,
                            46.68819787530614
                        ],
                        [
                            12.444478135297654,
                            46.6891184690031
                        ],
                        [
                            12.445233163000664,
                            46.68973022669249
                        ],
                        [
                            12.446086523331847,
                            46.68994750471046
                        ],
                        [
                            12.447313911908596,
                            46.68991498794365
                        ],
                        [
                            12.451219361737486,
                            46.68972962044015
                        ],
                        [
                            12.473560662214368,
                            46.686879227438645
                        ],
                        [
                            12.474539630332366,
                            46.68661996427846
                        ],
                        [
                            12.475526805143986,
                            46.68600493422091
                        ],
                        [
                            12.475841052575849,
                            46.68566686728094
                        ],
                        [
                            12.476437396160485,
                            46.68483420926421
                        ],
                        [
                            12.477481339787815,
                            46.68288990410655
                        ],
                        [
                            12.477704031274008,
                            46.68045306735587
                        ],
                        [
                            12.4775943539877,
                            46.67982126382043
                        ],
                        [
                            12.477181343550118,
                            46.67964245692218
                        ],
                        [
                            12.476486038057281,
                            46.67935310459239
                        ],
                        [
                            12.47518364497669,
                            46.678875207420475
                        ],
                        [
                            12.472322323436789,
                            46.67794516010045
                        ],
                        [
                            12.458766238820555,
                            46.67417302594648
                        ],
                        [
                            12.44632356446411,
                            46.67104892462191
                        ],
                        [
                            12.437516050975606,
                            46.668924625546296
                        ],
                        [
                            12.436570511202229,
                            46.66885856142842
                        ],
                        [
                            12.435915605314129,
                            46.66878825043437
                        ],
                        [
                            12.435327298399105,
                            46.668621430580174
                        ],
                        [
                            12.4342417683823,
                            46.66828054827685
                        ],
                        [
                            12.433001568754358,
                            46.66727828560545
                        ],
                        [
                            12.427420566556066,
                            46.661582158272054
                        ],
                        [
                            12.417668816473716,
                            46.652909989959596
                        ],
                        [
                            12.412559682807665,
                            46.64872906346283
                        ],
                        [
                            12.405747757523754,
                            46.64319913204356
                        ],
                        [
                            12.405458639166223,
                            46.64309290487594
                        ],
                        [
                            12.392354679423248,
                            46.64174070643046
                        ],
                        [
                            12.391079077424461,
                            46.641612061953
                        ],
                        [
                            12.38850981812631,
                            46.64237228348188
                        ],
                        [
                            12.38647962259453,
                            46.64297697003999
                        ],
                        [
                            12.385087649147534,
                            46.64339846381978
                        ],
                        [
                            12.383029795130355,
                            46.64371140443458
                        ],
                        [
                            12.38159510454637,
                            46.64359292700473
                        ],
                        [
                            12.37977356030763,
                            46.64290739566008
                        ],
                        [
                            12.379262958014355,
                            46.64161378865896
                        ],
                        [
                            12.379012823122821,
                            46.640955171275344
                        ],
                        [
                            12.378179600026215,
                            46.63854074581617
                        ],
                        [
                            12.378036768165387,
                            46.63784745255385
                        ],
                        [
                            12.378395266855529,
                            46.636685611721795
                        ],
                        [
                            12.38285382280689,
                            46.63207816124916
                        ],
                        [
                            12.389835616293787,
                            46.627512012444086
                        ],
                        [
                            12.389929642741471,
                            46.627392540635164
                        ],
                        [
                            12.389904564694037,
                            46.62721327888337
                        ],
                        [
                            12.389236505863126,
                            46.62518554318079
                        ],
                        [
                            12.388788448581005,
                            46.62446981213464
                        ],
                        [
                            12.387751595432789,
                            46.62397403915032
                        ],
                        [
                            12.385163313207313,
                            46.62278170863068
                        ],
                        [
                            12.370574342437955,
                            46.61987835122483
                        ],
                        [
                            12.366655497225626,
                            46.61950785686179
                        ],
                        [
                            12.362273208197202,
                            46.61945687114809
                        ],
                        [
                            12.360103329521953,
                            46.61948468991269
                        ],
                        [
                            12.34673929305785,
                            46.6241744475243
                        ],
                        [
                            12.344563903831164,
                            46.62639368304732
                        ],
                        [
                            12.343554526809147,
                            46.627503245373404
                        ],
                        [
                            12.34313810926562,
                            46.628190113334654
                        ],
                        [
                            12.341561027693013,
                            46.63006810754144
                        ],
                        [
                            12.339704826308855,
                            46.63137789446692
                        ],
                        [
                            12.331641150049935,
                            46.629223703678505
                        ],
                        [
                            12.32058125766423,
                            46.62926170619055
                        ],
                        [
                            12.319865086905484,
                            46.62931470532285
                        ],
                        [
                            12.31913793545994,
                            46.62937338658047
                        ],
                        [
                            12.317830536965845,
                            46.629548980430194
                        ],
                        [
                            12.316366242091242,
                            46.62983898664082
                        ],
                        [
                            12.316089665459275,
                            46.6299191639684
                        ],
                        [
                            12.316021241664195,
                            46.62993899941435
                        ],
                        [
                            12.315434745568828,
                            46.62507702296163
                        ],
                        [
                            12.313785412943048,
                            46.62333470900091
                        ],
                        [
                            12.308380666202172,
                            46.62048523665067
                        ],
                        [
                            12.307920904117214,
                            46.62025553985333
                        ],
                        [
                            12.307438054435824,
                            46.620022009279026
                        ],
                        [
                            12.306537312793587,
                            46.6196025646428
                        ],
                        [
                            12.305503741987899,
                            46.61917345460119
                        ],
                        [
                            12.301321229701548,
                            46.61880834173455
                        ],
                        [
                            12.292700454946841,
                            46.618098525458635
                        ],
                        [
                            12.285725287316382,
                            46.617867271405416
                        ],
                        [
                            12.285038011281674,
                            46.617882526855894
                        ],
                        [
                            12.284392037816799,
                            46.61790559498411
                        ],
                        [
                            12.28383651498152,
                            46.61792605870006
                        ],
                        [
                            12.271422789240823,
                            46.620651068593666
                        ],
                        [
                            12.270074199742735,
                            46.62103010364806
                        ],
                        [
                            12.270032385825766,
                            46.621068498710144
                        ],
                        [
                            12.269229547144564,
                            46.62232116994893
                        ],
                        [
                            12.268577018776895,
                            46.62335188789638
                        ],
                        [
                            12.267951128755513,
                            46.624386439303244
                        ],
                        [
                            12.26729930696376,
                            46.62571009225626
                        ],
                        [
                            12.266822440418522,
                            46.62635723737865
                        ],
                        [
                            12.266743779943402,
                            46.626463983215174
                        ],
                        [
                            12.264171529551488,
                            46.62778849276371
                        ],
                        [
                            12.26121993611789,
                            46.629124883929414
                        ],
                        [
                            12.244654968657384,
                            46.62409619216984
                        ],
                        [
                            12.241838869165,
                            46.616319015468235
                        ],
                        [
                            12.240297879570045,
                            46.615885709705026
                        ],
                        [
                            12.238406467303463,
                            46.61548931634689
                        ],
                        [
                            12.232181737654196,
                            46.614045509605425
                        ],
                        [
                            12.224748390579025,
                            46.612257470038216
                        ],
                        [
                            12.22109109854852,
                            46.61137059693706
                        ],
                        [
                            12.217855936122756,
                            46.610552721992754
                        ],
                        [
                            12.214258729780727,
                            46.609573935995456
                        ],
                        [
                            12.212420133732321,
                            46.60895962326367
                        ],
                        [
                            12.2108918568245,
                            46.6078505576942
                        ],
                        [
                            12.21037446707036,
                            46.60638907404602
                        ],
                        [
                            12.210112490572957,
                            46.60527141979428
                        ],
                        [
                            12.209474010003266,
                            46.60463234564402
                        ],
                        [
                            12.203791331342732,
                            46.599283725543835
                        ],
                        [
                            12.195676433461259,
                            46.59518187187919
                        ],
                        [
                            12.194979064002021,
                            46.59486836594076
                        ],
                        [
                            12.19367119145926,
                            46.594607918283074
                        ],
                        [
                            12.192239785884183,
                            46.594563862915216
                        ],
                        [
                            12.192003208619168,
                            46.59517564676066
                        ],
                        [
                            12.191922752014769,
                            46.595384771801555
                        ],
                        [
                            12.191848320292396,
                            46.595586120668884
                        ],
                        [
                            12.1917700247951,
                            46.59580404409928
                        ],
                        [
                            12.19168188379738,
                            46.59653344306302
                        ],
                        [
                            12.191664830291884,
                            46.59667999206254
                        ],
                        [
                            12.193342114081355,
                            46.60255520698595
                        ],
                        [
                            12.193794523781502,
                            46.60358657698258
                        ],
                        [
                            12.19445995882491,
                            46.604908993707504
                        ],
                        [
                            12.194691720593934,
                            46.61094404651564
                        ],
                        [
                            12.194264058122458,
                            46.6193326136138
                        ],
                        [
                            12.185145139877203,
                            46.62064011981206
                        ],
                        [
                            12.183438346666339,
                            46.620714671879
                        ],
                        [
                            12.183286959624478,
                            46.62075038888882
                        ],
                        [
                            12.182202214716156,
                            46.62101909964218
                        ],
                        [
                            12.181684448572975,
                            46.621628158804896
                        ],
                        [
                            12.180367960441302,
                            46.62320433647734
                        ],
                        [
                            12.179891281278277,
                            46.623837537891085
                        ],
                        [
                            12.179669592971424,
                            46.6241411265967
                        ],
                        [
                            12.179551213274166,
                            46.62431315345846
                        ],
                        [
                            12.178809042919415,
                            46.62542808392606
                        ],
                        [
                            12.177478671756244,
                            46.627301388772054
                        ],
                        [
                            12.177237757344171,
                            46.62762553502282
                        ],
                        [
                            12.17678572055672,
                            46.628221997760996
                        ],
                        [
                            12.176617313892288,
                            46.62843430145155
                        ],
                        [
                            12.17595422718082,
                            46.629214398596275
                        ],
                        [
                            12.175673479969221,
                            46.62954369650445
                        ],
                        [
                            12.175618800466806,
                            46.629605883788706
                        ],
                        [
                            12.172664705696194,
                            46.63296141823577
                        ],
                        [
                            12.172613982148427,
                            46.63301567491913
                        ],
                        [
                            12.171328327772855,
                            46.63410142888356
                        ],
                        [
                            12.161997895300633,
                            46.63676294874107
                        ],
                        [
                            12.161086827613525,
                            46.63682414874817
                        ],
                        [
                            12.156550562249315,
                            46.63566251044855
                        ],
                        [
                            12.148078673889632,
                            46.6342312495702
                        ],
                        [
                            12.145125922294092,
                            46.63407019792023
                        ],
                        [
                            12.140318516058795,
                            46.63762164444515
                        ],
                        [
                            12.127087896284916,
                            46.64474340251589
                        ],
                        [
                            12.125346486058566,
                            46.64559203338427
                        ],
                        [
                            12.112812911759049,
                            46.65194605542885
                        ],
                        [
                            12.111413000907307,
                            46.65274282500396
                        ],
                        [
                            12.111000790451365,
                            46.65298350134713
                        ],
                        [
                            12.109985320122833,
                            46.653811734252145
                        ],
                        [
                            12.109308909580472,
                            46.65488542476543
                        ],
                        [
                            12.109155563310571,
                            46.65562497673398
                        ],
                        [
                            12.10913332750367,
                            46.65574614459826
                        ],
                        [
                            12.10908611198136,
                            46.6561406974075
                        ],
                        [
                            12.108942240453795,
                            46.65650430344396
                        ],
                        [
                            12.108928809488692,
                            46.65653218373129
                        ],
                        [
                            12.108779661147329,
                            46.65672563748128
                        ],
                        [
                            12.108468941365572,
                            46.65712446708584
                        ],
                        [
                            12.108359398783675,
                            46.657259886331396
                        ],
                        [
                            12.108327789728113,
                            46.657294794903045
                        ],
                        [
                            12.107558694690445,
                            46.65808282622618
                        ],
                        [
                            12.107458567893701,
                            46.65817574322002
                        ],
                        [
                            12.106037543526627,
                            46.6589253650753
                        ],
                        [
                            12.099924988585835,
                            46.661296293574374
                        ],
                        [
                            12.091278761107207,
                            46.66463544006442
                        ],
                        [
                            12.082063582147313,
                            46.66747176884215
                        ],
                        [
                            12.080912680274357,
                            46.66832629140047
                        ],
                        [
                            12.079892829866779,
                            46.66912536904411
                        ],
                        [
                            12.07960254309208,
                            46.669523486162895
                        ],
                        [
                            12.07933899626846,
                            46.66990454983728
                        ],
                        [
                            12.079315621458484,
                            46.66994669575399
                        ],
                        [
                            12.079198100243756,
                            46.67024067139446
                        ],
                        [
                            12.079166382232863,
                            46.670320648650765
                        ],
                        [
                            12.079079029949153,
                            46.670561560020516
                        ],
                        [
                            12.07902265598064,
                            46.67072620674932
                        ],
                        [
                            12.078475259147723,
                            46.67150509543406
                        ],
                        [
                            12.077794030600353,
                            46.672343287739636
                        ],
                        [
                            12.076545132137703,
                            46.67383490289139
                        ],
                        [
                            12.075506756411919,
                            46.67442984217029
                        ],
                        [
                            12.074730577896593,
                            46.674576721294095
                        ],
                        [
                            12.070251749282763,
                            46.674913100920904
                        ],
                        [
                            12.068269659362674,
                            46.67507128575588
                        ],
                        [
                            12.068907390257742,
                            46.66641723621075
                        ],
                        [
                            12.066461783253375,
                            46.65323490485232
                        ],
                        [
                            12.066554026352957,
                            46.65272976784811
                        ],
                        [
                            12.069463037939412,
                            46.64888332191543
                        ],
                        [
                            12.074224775676965,
                            46.64262239730637
                        ],
                        [
                            12.074181497823353,
                            46.642606395421815
                        ],
                        [
                            12.073317158025954,
                            46.64228680396711
                        ],
                        [
                            12.071370464701385,
                            46.64160112876882
                        ],
                        [
                            12.069754909632556,
                            46.64076252705867
                        ],
                        [
                            12.069232484968193,
                            46.640074556469344
                        ],
                        [
                            12.068603474452466,
                            46.63842644356031
                        ],
                        [
                            12.067504160619864,
                            46.634468950899155
                        ],
                        [
                            12.065823187669654,
                            46.627845045122825
                        ],
                        [
                            12.065504445521968,
                            46.62613459225221
                        ],
                        [
                            12.065173854291242,
                            46.624676454494164
                        ],
                        [
                            12.06479009613956,
                            46.62320174368202
                        ],
                        [
                            12.064064708845445,
                            46.6216911876348
                        ],
                        [
                            12.062725650436892,
                            46.62064707585459
                        ],
                        [
                            12.061118605284813,
                            46.620177123520165
                        ],
                        [
                            12.05888315042235,
                            46.619912970939566
                        ],
                        [
                            12.057656533169341,
                            46.61970278911
                        ],
                        [
                            12.054137978343606,
                            46.618455857672544
                        ],
                        [
                            12.053015645150866,
                            46.61800884200522
                        ],
                        [
                            12.045450211447864,
                            46.60795064778961
                        ],
                        [
                            12.048729548323328,
                            46.601698202489466
                        ],
                        [
                            12.04931340946602,
                            46.60070162503477
                        ],
                        [
                            12.049414922345246,
                            46.60030101347778
                        ],
                        [
                            12.049623374333876,
                            46.599478349207786
                        ],
                        [
                            12.049772255788401,
                            46.59375935360763
                        ],
                        [
                            12.049367561693083,
                            46.59213214291824
                        ],
                        [
                            12.047080267362102,
                            46.585569111284585
                        ],
                        [
                            12.046693499834117,
                            46.58472441823468
                        ],
                        [
                            12.046318603301513,
                            46.5841494081474
                        ],
                        [
                            12.044885243048657,
                            46.58273859524016
                        ],
                        [
                            12.043769160948811,
                            46.58192231853662
                        ],
                        [
                            12.042517294114488,
                            46.581244645544494
                        ],
                        [
                            12.040893990208437,
                            46.58045984215814
                        ],
                        [
                            12.038869226305122,
                            46.57973069290806
                        ],
                        [
                            12.036713657346676,
                            46.57876198016185
                        ],
                        [
                            12.035140617047537,
                            46.57770575793995
                        ],
                        [
                            12.034175653291683,
                            46.57678637403352
                        ],
                        [
                            12.033220235996662,
                            46.575569726510885
                        ],
                        [
                            12.028678435578174,
                            46.56807612466441
                        ],
                        [
                            12.02158150323311,
                            46.55965991246981
                        ],
                        [
                            12.013961736623731,
                            46.55091278152477
                        ],
                        [
                            12.013755996394146,
                            46.55076746639502
                        ],
                        [
                            12.012768409165089,
                            46.54965949515469
                        ],
                        [
                            12.006906491634563,
                            46.54273081198924
                        ],
                        [
                            12.005519387282785,
                            46.540760282301875
                        ],
                        [
                            12.003083586893252,
                            46.53763800101309
                        ],
                        [
                            12.001744242482026,
                            46.53592745321021
                        ],
                        [
                            12.000900147839378,
                            46.53510263605825
                        ],
                        [
                            12.000434724612038,
                            46.53464782929263
                        ],
                        [
                            11.99959427946926,
                            46.53383288330432
                        ],
                        [
                            11.99910169997083,
                            46.53341380702263
                        ],
                        [
                            11.998418896176528,
                            46.532855717993584
                        ],
                        [
                            11.988929485341481,
                            46.54433638605305
                        ],
                        [
                            11.987560571717049,
                            46.54529918726085
                        ],
                        [
                            11.985731591183754,
                            46.54524798208486
                        ],
                        [
                            11.966147470771404,
                            46.54467792156675
                        ],
                        [
                            11.964176805234182,
                            46.54418004454313
                        ],
                        [
                            11.952024883725027,
                            46.540543543231564
                        ],
                        [
                            11.951268518763728,
                            46.54018507447113
                        ],
                        [
                            11.950061226109783,
                            46.53956823990905
                        ],
                        [
                            11.94953427420316,
                            46.53923083823155
                        ],
                        [
                            11.94907171365001,
                            46.53839676767018
                        ],
                        [
                            11.948710801542088,
                            46.53727207410558
                        ],
                        [
                            11.948566693358528,
                            46.53679262753331
                        ],
                        [
                            11.948270181462084,
                            46.53587943170461
                        ],
                        [
                            11.94718405430854,
                            46.533162425723056
                        ],
                        [
                            11.946011637618577,
                            46.53029463080196
                        ],
                        [
                            11.945546835003274,
                            46.529505477778656
                        ],
                        [
                            11.945494693106053,
                            46.52941694989017
                        ],
                        [
                            11.940464329491688,
                            46.528268475551144
                        ],
                        [
                            11.933885244054293,
                            46.52789755324585
                        ],
                        [
                            11.929356113061054,
                            46.52854473486035
                        ],
                        [
                            11.927575982257464,
                            46.52890534999233
                        ],
                        [
                            11.925839743161065,
                            46.52959781463223
                        ],
                        [
                            11.9237875499814,
                            46.53047834010313
                        ],
                        [
                            11.922180955566212,
                            46.53115843191135
                        ],
                        [
                            11.917674982559316,
                            46.532488561741644
                        ],
                        [
                            11.914669718865118,
                            46.53291158854426
                        ],
                        [
                            11.914504037018025,
                            46.53293846873143
                        ],
                        [
                            11.913104735101323,
                            46.53310914572398
                        ],
                        [
                            11.91188394834672,
                            46.53296025446592
                        ],
                        [
                            11.907960375990347,
                            46.53177314481175
                        ],
                        [
                            11.90089747972364,
                            46.5294236167301
                        ],
                        [
                            11.898747341671069,
                            46.52822716432412
                        ],
                        [
                            11.884972555357244,
                            46.52272567381487
                        ],
                        [
                            11.879872411997757,
                            46.52244029902663
                        ],
                        [
                            11.876914426199088,
                            46.52222679378669
                        ],
                        [
                            11.8756660232609,
                            46.522042209523065
                        ],
                        [
                            11.853195330631788,
                            46.51820436361261
                        ],
                        [
                            11.851350817996217,
                            46.51783639374748
                        ],
                        [
                            11.848020650690485,
                            46.51673142237946
                        ],
                        [
                            11.844375666419388,
                            46.51533718571833
                        ],
                        [
                            11.828312400847022,
                            46.50891394674888
                        ],
                        [
                            11.826765502160672,
                            46.51088424560099
                        ],
                        [
                            11.825134875249478,
                            46.512963546847224
                        ],
                        [
                            11.825047916525076,
                            46.51310160591283
                        ],
                        [
                            11.824870727792065,
                            46.5133829941454
                        ],
                        [
                            11.824720541630555,
                            46.5138509132164
                        ],
                        [
                            11.82477105544921,
                            46.516058217913105
                        ],
                        [
                            11.824894591150782,
                            46.51649759324758
                        ],
                        [
                            11.824974004370787,
                            46.51678001100173
                        ],
                        [
                            11.825077004729355,
                            46.517107331264356
                        ],
                        [
                            11.825116381757509,
                            46.517232466401474
                        ],
                        [
                            11.825258920250482,
                            46.517726107457634
                        ],
                        [
                            11.825350582260208,
                            46.518093098431244
                        ],
                        [
                            11.82544012881546,
                            46.51845167972274
                        ],
                        [
                            11.825507011056187,
                            46.519005266460596
                        ],
                        [
                            11.825521666261613,
                            46.519367952656616
                        ],
                        [
                            11.825530560685994,
                            46.51958888127534
                        ],
                        [
                            11.825489045433265,
                            46.52178516237192
                        ],
                        [
                            11.824304886862258,
                            46.522757197272576
                        ],
                        [
                            11.822434983734823,
                            46.524363975528956
                        ],
                        [
                            11.821215677867327,
                            46.525409353074245
                        ],
                        [
                            11.819050759756156,
                            46.52718263175961
                        ],
                        [
                            11.818759966392136,
                            46.527404670643364
                        ],
                        [
                            11.81862360478141,
                            46.52750878848329
                        ],
                        [
                            11.81829367044717,
                            46.52773750824141
                        ],
                        [
                            11.817968742238119,
                            46.52785774173851
                        ],
                        [
                            11.814722669259048,
                            46.52901971435149
                        ],
                        [
                            11.811864207432405,
                            46.53242212076314
                        ],
                        [
                            11.811615482113911,
                            46.5326075568354
                        ],
                        [
                            11.811565143645272,
                            46.532644950182906
                        ],
                        [
                            11.811184716862723,
                            46.53276429012237
                        ],
                        [
                            11.808190853278147,
                            46.53187528703205
                        ],
                        [
                            11.807240792697971,
                            46.53143141328744
                        ],
                        [
                            11.806172368671648,
                            46.53091332865983
                        ],
                        [
                            11.805204980872674,
                            46.53043156449011
                        ],
                        [
                            11.803234164292835,
                            46.52939045268341
                        ],
                        [
                            11.802737601754854,
                            46.529063405642376
                        ],
                        [
                            11.801936103718536,
                            46.52853543181447
                        ],
                        [
                            11.80076273356002,
                            46.52766527444111
                        ],
                        [
                            11.793619459575153,
                            46.521312114103374
                        ],
                        [
                            11.790427262789175,
                            46.514006888773835
                        ],
                        [
                            11.785041159376666,
                            46.511300125578785
                        ],
                        [
                            11.774640249404351,
                            46.509194731081884
                        ],
                        [
                            11.762909636424927,
                            46.5075512535696
                        ],
                        [
                            11.753570748447276,
                            46.506385509159585
                        ],
                        [
                            11.743592720137915,
                            46.504953487805295
                        ],
                        [
                            11.733484193285284,
                            46.509194846450356
                        ],
                        [
                            11.719719841221306,
                            46.51024350367036
                        ],
                        [
                            11.715831629694499,
                            46.5138472237901
                        ],
                        [
                            11.714809420376355,
                            46.513507280468566
                        ],
                        [
                            11.707013341656783,
                            46.51074187640536
                        ],
                        [
                            11.706386750361366,
                            46.510443705964384
                        ],
                        [
                            11.695090987813263,
                            46.50365534825794
                        ],
                        [
                            11.689880560964443,
                            46.50332761773668
                        ],
                        [
                            11.677482663988854,
                            46.50095078629224
                        ],
                        [
                            11.675395086052811,
                            46.500525739251366
                        ],
                        [
                            11.674794769306581,
                            46.50040322406864
                        ],
                        [
                            11.669821622515908,
                            46.499127116800274
                        ],
                        [
                            11.668137930933682,
                            46.49815817453543
                        ],
                        [
                            11.667906960137381,
                            46.49796556644851
                        ],
                        [
                            11.667402977050331,
                            46.497731846062045
                        ],
                        [
                            11.666855684598172,
                            46.497522096705964
                        ],
                        [
                            11.666093555018744,
                            46.49740494735665
                        ],
                        [
                            11.653536960178512,
                            46.4976424409105
                        ],
                        [
                            11.652721967676372,
                            46.49767795805109
                        ],
                        [
                            11.645545131523404,
                            46.49847712260158
                        ],
                        [
                            11.645211565813272,
                            46.498537081579116
                        ],
                        [
                            11.645019738047296,
                            46.498571595332514
                        ],
                        [
                            11.63667328888191,
                            46.50057502389126
                        ],
                        [
                            11.632807729886936,
                            46.499288427556834
                        ],
                        [
                            11.633941693949074,
                            46.496541727539444
                        ],
                        [
                            11.641949478174489,
                            46.49264004780001
                        ],
                        [
                            11.64228991078306,
                            46.49229483484811
                        ],
                        [
                            11.642424112948277,
                            46.49191256997213
                        ],
                        [
                            11.643626617727639,
                            46.48760814825727
                        ],
                        [
                            11.64464195009366,
                            46.48740259967029
                        ],
                        [
                            11.645188762687154,
                            46.48715441913044
                        ],
                        [
                            11.647029158903011,
                            46.4862297171863
                        ],
                        [
                            11.647916817880429,
                            46.48576742526251
                        ],
                        [
                            11.648044198326344,
                            46.48565348090348
                        ],
                        [
                            11.648815015958986,
                            46.48496318650867
                        ],
                        [
                            11.650062069616135,
                            46.483752174836546
                        ],
                        [
                            11.65026006941203,
                            46.48306648929379
                        ],
                        [
                            11.650133183838657,
                            46.4829414422686
                        ],
                        [
                            11.650061364804117,
                            46.482870751396455
                        ],
                        [
                            11.648967422458776,
                            46.482495531146995
                        ],
                        [
                            11.648310498105664,
                            46.48228321348236
                        ],
                        [
                            11.648065135808395,
                            46.482166401078416
                        ],
                        [
                            11.647832415315829,
                            46.48205555033568
                        ],
                        [
                            11.647468345113484,
                            46.48183524975996
                        ],
                        [
                            11.647244349772052,
                            46.48137865331656
                        ],
                        [
                            11.644857739929403,
                            46.47378651163448
                        ],
                        [
                            11.644577712775892,
                            46.47282061092331
                        ],
                        [
                            11.643132410623776,
                            46.4749356973816
                        ],
                        [
                            11.64273488448889,
                            46.47594015941115
                        ],
                        [
                            11.636462930190314,
                            46.474770969300195
                        ],
                        [
                            11.635247657326586,
                            46.47449585657408
                        ],
                        [
                            11.626341999120262,
                            46.47189204533946
                        ],
                        [
                            11.625820742687083,
                            46.47164939609816
                        ],
                        [
                            11.625359152360872,
                            46.47141789758825
                        ],
                        [
                            11.624761688265473,
                            46.471092949453
                        ],
                        [
                            11.624828982204672,
                            46.47099700137652
                        ],
                        [
                            11.624977717129216,
                            46.47078618063791
                        ],
                        [
                            11.625754995809215,
                            46.46981408912853
                        ],
                        [
                            11.626133157297186,
                            46.46940894840919
                        ],
                        [
                            11.626495057070501,
                            46.46902255735258
                        ],
                        [
                            11.626857389748677,
                            46.46874854185227
                        ],
                        [
                            11.62698162451559,
                            46.46862966289101
                        ],
                        [
                            11.627214090572778,
                            46.46840713604226
                        ],
                        [
                            11.62784628477581,
                            46.46779179510543
                        ],
                        [
                            11.627990203586938,
                            46.46706865151946
                        ],
                        [
                            11.628305075328567,
                            46.463955413184976
                        ],
                        [
                            11.628304436400072,
                            46.46377335884879
                        ],
                        [
                            11.628222682642637,
                            46.46363716849905
                        ],
                        [
                            11.628031939905174,
                            46.463345286061056
                        ],
                        [
                            11.627786763194035,
                            46.46297111781629
                        ],
                        [
                            11.627520572394939,
                            46.462608680435814
                        ],
                        [
                            11.627487606869845,
                            46.46256382313528
                        ],
                        [
                            11.626085413072753,
                            46.461036163914635
                        ],
                        [
                            11.622117778074761,
                            46.45655227413361
                        ],
                        [
                            11.617767246072168,
                            46.44409506327523
                        ],
                        [
                            11.618049758590145,
                            46.44088844878906
                        ],
                        [
                            11.618319308668775,
                            46.43801799353306
                        ],
                        [
                            11.619359830085568,
                            46.42521512447995
                        ],
                        [
                            11.60798372384103,
                            46.41019268243469
                        ],
                        [
                            11.602651109940265,
                            46.40048866084377
                        ],
                        [
                            11.601723527874963,
                            46.38978688940057
                        ],
                        [
                            11.601329220040144,
                            46.38931704665565
                        ],
                        [
                            11.600972722242547,
                            46.38893790522726
                        ],
                        [
                            11.600208732879565,
                            46.38815311544104
                        ],
                        [
                            11.599940223946973,
                            46.3878918212999
                        ],
                        [
                            11.599818457799127,
                            46.387773342975656
                        ],
                        [
                            11.599322397225087,
                            46.38732717170966
                        ],
                        [
                            11.59458423833361,
                            46.38468109689833
                        ],
                        [
                            11.594516587235903,
                            46.38464463497835
                        ],
                        [
                            11.59302307740054,
                            46.38387971857323
                        ],
                        [
                            11.592575134540246,
                            46.383643130087115
                        ],
                        [
                            11.592128510305667,
                            46.383689730991854
                        ],
                        [
                            11.591556899363786,
                            46.38370269586369
                        ],
                        [
                            11.590670940440422,
                            46.38366878876264
                        ],
                        [
                            11.589328158584793,
                            46.38360022178718
                        ],
                        [
                            11.588647929643008,
                            46.38351663117678
                        ],
                        [
                            11.583004975266059,
                            46.382717304814754
                        ],
                        [
                            11.577518101551185,
                            46.38169692891285
                        ],
                        [
                            11.577170626909615,
                            46.38159098346413
                        ],
                        [
                            11.576830594093446,
                            46.3815211515475
                        ],
                        [
                            11.576637943676845,
                            46.38150626105163
                        ],
                        [
                            11.57619695827896,
                            46.38147596134586
                        ],
                        [
                            11.57216843861578,
                            46.38140705628417
                        ],
                        [
                            11.564832113924902,
                            46.38157279807457
                        ],
                        [
                            11.564560845029751,
                            46.381455878795606
                        ],
                        [
                            11.564323251304648,
                            46.38135230111245
                        ],
                        [
                            11.564207895862813,
                            46.381283357051494
                        ],
                        [
                            11.563667883080495,
                            46.38085408351287
                        ],
                        [
                            11.56351004106535,
                            46.38070034004287
                        ],
                        [
                            11.563433577560177,
                            46.38059700346004
                        ],
                        [
                            11.563355711572436,
                            46.38049173174648
                        ],
                        [
                            11.563165343009763,
                            46.38022808730693
                        ],
                        [
                            11.562391905921032,
                            46.378972160855376
                        ],
                        [
                            11.559053555627672,
                            46.36854061104499
                        ],
                        [
                            11.556700938139077,
                            46.35857387044304
                        ],
                        [
                            11.556681864394257,
                            46.358441100614876
                        ],
                        [
                            11.556745081656526,
                            46.35286042731924
                        ],
                        [
                            11.557246492130922,
                            46.35094542406965
                        ],
                        [
                            11.545566486472532,
                            46.34557687588909
                        ],
                        [
                            11.543205692014809,
                            46.34819447904153
                        ],
                        [
                            11.542832886553212,
                            46.34856277876511
                        ],
                        [
                            11.542260674302232,
                            46.34912435305697
                        ],
                        [
                            11.53993961691309,
                            46.35063415577577
                        ],
                        [
                            11.53926979769506,
                            46.351045043755946
                        ],
                        [
                            11.535259011320369,
                            46.35276138806968
                        ],
                        [
                            11.52604540732147,
                            46.354157080602754
                        ],
                        [
                            11.525991054838817,
                            46.35593839942373
                        ],
                        [
                            11.512003988489413,
                            46.35864550262752
                        ],
                        [
                            11.501619988313495,
                            46.36053563718624
                        ],
                        [
                            11.501298484808292,
                            46.36059204042596
                        ],
                        [
                            11.501209524257348,
                            46.36060760385744
                        ],
                        [
                            11.498979181996857,
                            46.360670713939086
                        ],
                        [
                            11.496841429923576,
                            46.36063805585592
                        ],
                        [
                            11.47689681459508,
                            46.3639314013008
                        ]
                    ]
                ]
            },
        },
        {
            "type": "Feature",
            "properties": {
                "id": 6,
                "name": "Veneto",
                "length": 1057855.9676,
                "area": 18405499479.400001525878906
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            12.505905320166946,
                            46.678391366799666
                        ],
                        [
                            12.527211826716695,
                            46.674099650245417
                        ],
                        [
                            12.564575110128642,
                            46.651105722741711
                        ],
                        [
                            12.624404625225898,
                            46.66089701282452
                        ],
                        [
                            12.641144168707754,
                            46.652053057974449
                        ],
                        [
                            12.677559938316103,
                            46.65675049729316
                        ],
                        [
                            12.714558284461566,
                            46.648308402173711
                        ],
                        [
                            12.731981341894748,
                            46.633812910420055
                        ],
                        [
                            12.728864199647788,
                            46.61047773274715
                        ],
                        [
                            12.742413042706968,
                            46.576332695810294
                        ],
                        [
                            12.732693605610404,
                            46.55748204819205
                        ],
                        [
                            12.749648984544995,
                            46.543981956592553
                        ],
                        [
                            12.69871477928616,
                            46.540890209132669
                        ],
                        [
                            12.630585565123585,
                            46.512166808697259
                        ],
                        [
                            12.630021094654534,
                            46.500706645883625
                        ],
                        [
                            12.656887425671194,
                            46.481159938151087
                        ],
                        [
                            12.658815953757014,
                            46.465954894400937
                        ],
                        [
                            12.620751490831493,
                            46.47536728227454
                        ],
                        [
                            12.606068803956516,
                            46.464126681230582
                        ],
                        [
                            12.569953963285116,
                            46.475485612225604
                        ],
                        [
                            12.541715252038586,
                            46.4589083494281
                        ],
                        [
                            12.530842125363632,
                            46.464933227300499
                        ],
                        [
                            12.527943451025299,
                            46.453092739260072
                        ],
                        [
                            12.492478117113086,
                            46.424260699908494
                        ],
                        [
                            12.498683596030375,
                            46.412210450413603
                        ],
                        [
                            12.46934916501125,
                            46.390077270948737
                        ],
                        [
                            12.455047615516465,
                            46.391668305885155
                        ],
                        [
                            12.462942613986126,
                            46.36926268484666
                        ],
                        [
                            12.428665956270384,
                            46.35159607742149
                        ],
                        [
                            12.417374428148989,
                            46.35485427779831
                        ],
                        [
                            12.421213663716003,
                            46.342578309333753
                        ],
                        [
                            12.411789347117967,
                            46.331474612160541
                        ],
                        [
                            12.378117313976793,
                            46.331624646009274
                        ],
                        [
                            12.354654614357033,
                            46.31968212306446
                        ],
                        [
                            12.350831853591957,
                            46.293839186835328
                        ],
                        [
                            12.322750016066523,
                            46.273123172850234
                        ],
                        [
                            12.323977478264093,
                            46.254931679545592
                        ],
                        [
                            12.338327121125165,
                            46.238951167759907
                        ],
                        [
                            12.376423449490368,
                            46.222941938505372
                        ],
                        [
                            12.401678662187338,
                            46.228994256776886
                        ],
                        [
                            12.406271359415962,
                            46.207274475678879
                        ],
                        [
                            12.446453981498884,
                            46.207766272413799
                        ],
                        [
                            12.442479233503958,
                            46.197122163074717
                        ],
                        [
                            12.456918896955674,
                            46.170649263657353
                        ],
                        [
                            12.495813402103774,
                            46.152552706291182
                        ],
                        [
                            12.497196132548922,
                            46.129752054014553
                        ],
                        [
                            12.48442520927671,
                            46.10447245412854
                        ],
                        [
                            12.437487003730181,
                            46.084833677059201
                        ],
                        [
                            12.398987184355539,
                            46.041424006617056
                        ],
                        [
                            12.428188233239919,
                            45.995762789256204
                        ],
                        [
                            12.425840463716311,
                            45.947352264706041
                        ],
                        [
                            12.454253936650501,
                            45.947112526200712
                        ],
                        [
                            12.474697208085232,
                            45.928470035512994
                        ],
                        [
                            12.506000688371268,
                            45.922710752422773
                        ],
                        [
                            12.523268049301654,
                            45.903126176725102
                        ],
                        [
                            12.507000684075571,
                            45.897848259585388
                        ],
                        [
                            12.532258428485733,
                            45.881927852327195
                        ],
                        [
                            12.5370886010764,
                            45.868654807998112
                        ],
                        [
                            12.529860580743476,
                            45.863608512690455
                        ],
                        [
                            12.549614564133256,
                            45.860696159050285
                        ],
                        [
                            12.559299508180118,
                            45.82592495752489
                        ],
                        [
                            12.56529939098445,
                            45.83181336781535
                        ],
                        [
                            12.593845430809228,
                            45.815179233839771
                        ],
                        [
                            12.594367735745564,
                            45.830877868333296
                        ],
                        [
                            12.605686152403219,
                            45.838244809266591
                        ],
                        [
                            12.647620085898204,
                            45.816470648218711
                        ],
                        [
                            12.650284211370542,
                            45.80366692187804
                        ],
                        [
                            12.669041929388568,
                            45.790886809028109
                        ],
                        [
                            12.729994671190207,
                            45.837277941318042
                        ],
                        [
                            12.742856103908531,
                            45.826643632677907
                        ],
                        [
                            12.779822186232575,
                            45.854441778009324
                        ],
                        [
                            12.804303291585789,
                            45.844622636963081
                        ],
                        [
                            12.798597789715222,
                            45.832388662548212
                        ],
                        [
                            12.808586464728315,
                            45.820174160188316
                        ],
                        [
                            12.836867886521228,
                            45.847462709336099
                        ],
                        [
                            12.861182563893381,
                            45.850790016835717
                        ],
                        [
                            12.874983445859796,
                            45.850344629141482
                        ],
                        [
                            12.869672304482869,
                            45.833780676002547
                        ],
                        [
                            12.890058559756556,
                            45.820474408703923
                        ],
                        [
                            12.920512745281524,
                            45.831340559610545
                        ],
                        [
                            12.929495345506663,
                            45.817351033737147
                        ],
                        [
                            12.952065132983012,
                            45.822205863164704
                        ],
                        [
                            12.951372141712314,
                            45.843003414694728
                        ],
                        [
                            12.961429481548766,
                            45.846871668506282
                        ],
                        [
                            12.967183360850489,
                            45.836014355856001
                        ],
                        [
                            12.979045763491587,
                            45.83404198066232
                        ],
                        [
                            12.974188864022874,
                            45.823364410872898
                        ],
                        [
                            12.982074648170645,
                            45.827295120460562
                        ],
                        [
                            12.98131697710004,
                            45.81867143894285
                        ],
                        [
                            12.993241729247433,
                            45.815014205291469
                        ],
                        [
                            12.98838305392886,
                            45.808739333207299
                        ],
                        [
                            12.978744379038652,
                            45.814566643587725
                        ],
                        [
                            12.973903597449853,
                            45.806638810548314
                        ],
                        [
                            12.982359223138371,
                            45.795583006614194
                        ],
                        [
                            12.991334870477363,
                            45.799994945072044
                        ],
                        [
                            12.981230643224102,
                            45.786891232152158
                        ],
                        [
                            13.007591392916948,
                            45.765629914207238
                        ],
                        [
                            13.001190886204173,
                            45.749287827281826
                        ],
                        [
                            13.016064475561112,
                            45.73592034242413
                        ],
                        [
                            13.008307257108784,
                            45.724892119315513
                        ],
                        [
                            13.029035852049187,
                            45.736309011311732
                        ],
                        [
                            13.036844275257977,
                            45.699384224720632
                        ],
                        [
                            13.053249828363793,
                            45.694517782569235
                        ],
                        [
                            13.043597321246889,
                            45.685485548943532
                        ],
                        [
                            13.066767970954174,
                            45.672343421166275
                        ],
                        [
                            13.063373863461161,
                            45.656770573266243
                        ],
                        [
                            13.083132090957577,
                            45.658054211867821
                        ],
                        [
                            13.102230402373198,
                            45.641494985504714
                        ],
                        [
                            13.074797687095074,
                            45.632304651037032
                        ],
                        [
                            12.908362874938396,
                            45.614435612229798
                        ],
                        [
                            12.885817062073073,
                            45.59732027531728
                        ],
                        [
                            12.736517023498692,
                            45.531733622783662
                        ],
                        [
                            12.468096318359596,
                            45.445042701234499
                        ],
                        [
                            12.426900468397799,
                            45.417969127171851
                        ],
                        [
                            12.39957028195359,
                            45.429795519618928
                        ],
                        [
                            12.360135230742594,
                            45.39608779695569
                        ],
                        [
                            12.330680723591795,
                            45.353546426303751
                        ],
                        [
                            12.32895397785872,
                            45.337529135204583
                        ],
                        [
                            12.342757866288011,
                            45.333772493954491
                        ],
                        [
                            12.326210424762044,
                            45.332311782765466
                        ],
                        [
                            12.318995347757797,
                            45.320230389655904
                        ],
                        [
                            12.295898551826596,
                            45.244463366895033
                        ],
                        [
                            12.297837337370572,
                            45.234816074190171
                        ],
                        [
                            12.31427054616216,
                            45.233750261912071
                        ],
                        [
                            12.29945536046959,
                            45.221620234090359
                        ],
                        [
                            12.306253253065988,
                            45.194384789277962
                        ],
                        [
                            12.334681631184131,
                            45.163756229652506
                        ],
                        [
                            12.326413460389357,
                            45.131932467354858
                        ],
                        [
                            12.337233920283124,
                            45.089522094179301
                        ],
                        [
                            12.355797124475371,
                            45.076577601472863
                        ],
                        [
                            12.357293258129516,
                            45.064876282544269
                        ],
                        [
                            12.366360575755539,
                            45.067273590459934
                        ],
                        [
                            12.410211391064323,
                            45.042480914704967
                        ],
                        [
                            12.444145237235148,
                            45.013209165750105
                        ],
                        [
                            12.547017720887963,
                            44.974980789666965
                        ],
                        [
                            12.551827626556458,
                            44.965133836100605
                        ],
                        [
                            12.509845865164598,
                            44.930680143673065
                        ],
                        [
                            12.467046631433943,
                            44.847289681427995
                        ],
                        [
                            12.415451126071993,
                            44.820039807666625
                        ],
                        [
                            12.423543902630572,
                            44.813014173025209
                        ],
                        [
                            12.409462225619551,
                            44.797581084441973
                        ],
                        [
                            12.40280337008676,
                            44.805546437258556
                        ],
                        [
                            12.394310611002693,
                            44.794440182287303
                        ],
                        [
                            12.355192211706743,
                            44.815081103978343
                        ],
                        [
                            12.338428891972722,
                            44.851310940114509
                        ],
                        [
                            12.29410868968381,
                            44.860359085310201
                        ],
                        [
                            12.281872193693468,
                            44.910015547511975
                        ],
                        [
                            12.294737308010859,
                            44.927414524446867
                        ],
                        [
                            12.280868802586424,
                            44.94176719423605
                        ],
                        [
                            12.25618313864492,
                            44.942528483320885
                        ],
                        [
                            12.224971800403782,
                            44.922980712138155
                        ],
                        [
                            12.187670098417779,
                            44.926432584086278
                        ],
                        [
                            12.170675924498692,
                            44.942047376522005
                        ],
                        [
                            12.142424353332963,
                            44.927903853060521
                        ],
                        [
                            12.113134074949556,
                            44.96036655770402
                        ],
                        [
                            12.047486837982266,
                            44.976963502139043
                        ],
                        [
                            11.962678862058372,
                            44.986827707399328
                        ],
                        [
                            11.924583079782906,
                            44.974676771902551
                        ],
                        [
                            11.804719113566664,
                            44.976961249241931
                        ],
                        [
                            11.78382650099477,
                            44.96418606358948
                        ],
                        [
                            11.745630994571938,
                            44.957333807707123
                        ],
                        [
                            11.744846851539274,
                            44.934973916233005
                        ],
                        [
                            11.734072542990354,
                            44.927135323889651
                        ],
                        [
                            11.671277897074821,
                            44.914756788181272
                        ],
                        [
                            11.619590283477384,
                            44.888064653545477
                        ],
                        [
                            11.593535824961503,
                            44.89089216530342
                        ],
                        [
                            11.584686691034387,
                            44.913183617955312
                        ],
                        [
                            11.534130495930661,
                            44.936245905167596
                        ],
                        [
                            11.427494796411237,
                            44.929562616078833
                        ],
                        [
                            11.425487375659571,
                            44.960819451367421
                        ],
                        [
                            11.414792366563837,
                            44.967347557928335
                        ],
                        [
                            11.335812040238133,
                            44.990397653659961
                        ],
                        [
                            11.308740331455018,
                            45.012359338467895
                        ],
                        [
                            11.274036951891008,
                            45.018259046948003
                        ],
                        [
                            11.263053328552719,
                            45.032938755033548
                        ],
                        [
                            11.265902502636491,
                            45.056223881237393
                        ],
                        [
                            11.240440848190085,
                            45.04295374076284
                        ],
                        [
                            11.212191050032995,
                            45.057484490263946
                        ],
                        [
                            11.175279709033166,
                            45.060066227041872
                        ],
                        [
                            11.174645604827237,
                            45.074490123251167
                        ],
                        [
                            11.188368178316809,
                            45.084084783798509
                        ],
                        [
                            11.176816344601633,
                            45.088491465523688
                        ],
                        [
                            11.177508732575481,
                            45.097344958929355
                        ],
                        [
                            11.203434131287796,
                            45.111667282645861
                        ],
                        [
                            11.188192605863657,
                            45.109693539416895
                        ],
                        [
                            11.146437299312151,
                            45.126068239300693
                        ],
                        [
                            11.127404570781898,
                            45.103227155526973
                        ],
                        [
                            11.1021437902158,
                            45.113137909962354
                        ],
                        [
                            11.097572649651211,
                            45.095247078187292
                        ],
                        [
                            11.07294247521954,
                            45.098748580311948
                        ],
                        [
                            11.028696810451704,
                            45.123045372757673
                        ],
                        [
                            11.049459107900784,
                            45.150687695360965
                        ],
                        [
                            11.032281182757821,
                            45.149851587775061
                        ],
                        [
                            11.028389000035816,
                            45.159227131526727
                        ],
                        [
                            11.010244530199888,
                            45.148657461677423
                        ],
                        [
                            10.994517311093219,
                            45.15035558024951
                        ],
                        [
                            10.997118800701591,
                            45.186937677811684
                        ],
                        [
                            10.984110475769073,
                            45.19978471265334
                        ],
                        [
                            10.946957391431376,
                            45.205736785879331
                        ],
                        [
                            10.934982170586828,
                            45.214202308442893
                        ],
                        [
                            10.936790157101056,
                            45.232938364669749
                        ],
                        [
                            10.846608056590673,
                            45.256568799411319
                        ],
                        [
                            10.84001119612304,
                            45.272894469481052
                        ],
                        [
                            10.782815226528719,
                            45.315421513867463
                        ],
                        [
                            10.737415796311835,
                            45.287244803362157
                        ],
                        [
                            10.728347986238147,
                            45.291300497611964
                        ],
                        [
                            10.73115084243237,
                            45.315190355264349
                        ],
                        [
                            10.706382647437911,
                            45.316301301027181
                        ],
                        [
                            10.71497071311512,
                            45.334076397921123
                        ],
                        [
                            10.686762995518853,
                            45.342174743038683
                        ],
                        [
                            10.685544243480006,
                            45.353684462618773
                        ],
                        [
                            10.714626191451897,
                            45.367931143126654
                        ],
                        [
                            10.697738063699644,
                            45.380092226608056
                        ],
                        [
                            10.717629646922612,
                            45.396690173346137
                        ],
                        [
                            10.715793345824665,
                            45.41663758326132
                        ],
                        [
                            10.665232915223394,
                            45.427716378991782
                        ],
                        [
                            10.654626005158685,
                            45.415822549125046
                        ],
                        [
                            10.643865081351354,
                            45.417817231026163
                        ],
                        [
                            10.649454952911277,
                            45.440788774453807
                        ],
                        [
                            10.627251646781728,
                            45.438271941399691
                        ],
                        [
                            10.623645956920029,
                            45.443615986611491
                        ],
                        [
                            10.644135110695288,
                            45.444546093702961
                        ],
                        [
                            10.647615833428176,
                            45.451400745741459
                        ],
                        [
                            10.631043051196562,
                            45.609508655929254
                        ],
                        [
                            10.705606445180319,
                            45.676412438823256
                        ],
                        [
                            10.84014624222158,
                            45.832758414330257
                        ],
                        [
                            10.887588557725291,
                            45.811649054791161
                        ],
                        [
                            10.872798224121361,
                            45.788561559592743
                        ],
                        [
                            10.884976785043802,
                            45.774654675749794
                        ],
                        [
                            10.866936105613918,
                            45.764240589893028
                        ],
                        [
                            10.843834140217835,
                            45.718596099246618
                        ],
                        [
                            10.889578625964141,
                            45.715074643292475
                        ],
                        [
                            10.918781929187972,
                            45.700553578889632
                        ],
                        [
                            10.911995242079984,
                            45.68831428756927
                        ],
                        [
                            10.937460322157722,
                            45.673414512960839
                        ],
                        [
                            10.962000351461027,
                            45.685680123472601
                        ],
                        [
                            10.972199948915469,
                            45.701819184594939
                        ],
                        [
                            10.968320331070061,
                            45.680092740704566
                        ],
                        [
                            10.986331798617972,
                            45.688806056608144
                        ],
                        [
                            11.016575313127069,
                            45.719423878170041
                        ],
                        [
                            11.016463240849161,
                            45.705730388082202
                        ],
                        [
                            11.041376974177293,
                            45.706319090238971
                        ],
                        [
                            11.056407521843221,
                            45.718470070233003
                        ],
                        [
                            11.073836418170844,
                            45.703059083093748
                        ],
                        [
                            11.09239987503191,
                            45.695152401926009
                        ],
                        [
                            11.12139630531653,
                            45.695544506661577
                        ],
                        [
                            11.122562384705638,
                            45.689091100274638
                        ],
                        [
                            11.138509770081802,
                            45.696846810993435
                        ],
                        [
                            11.145906312488707,
                            45.716942519929169
                        ],
                        [
                            11.178430356511337,
                            45.738066410972365
                        ],
                        [
                            11.173551072311781,
                            45.786672544527697
                        ],
                        [
                            11.202787775413185,
                            45.783372963274466
                        ],
                        [
                            11.188821196576432,
                            45.81357329709266
                        ],
                        [
                            11.219067647167812,
                            45.832714099853554
                        ],
                        [
                            11.221865127230689,
                            45.848960022942414
                        ],
                        [
                            11.239323857480192,
                            45.855981902224059
                        ],
                        [
                            11.244363893445266,
                            45.876946085517389
                        ],
                        [
                            11.234849651987581,
                            45.879656948138297
                        ],
                        [
                            11.255080815618005,
                            45.884006551639892
                        ],
                        [
                            11.248893174351391,
                            45.899178004411404
                        ],
                        [
                            11.259863147883456,
                            45.904252628520446
                        ],
                        [
                            11.258322541929095,
                            45.920677933447251
                        ],
                        [
                            11.302890912186765,
                            45.918023482594428
                        ],
                        [
                            11.313027283587274,
                            45.92982554972108
                        ],
                        [
                            11.324349318304119,
                            45.917413983263693
                        ],
                        [
                            11.349318459349213,
                            45.909531740608259
                        ],
                        [
                            11.34503428500493,
                            45.920946434670014
                        ],
                        [
                            11.358056941736733,
                            45.925294617730593
                        ],
                        [
                            11.358317795138133,
                            45.943661979589173
                        ],
                        [
                            11.380749254690031,
                            45.94267330392357
                        ],
                        [
                            11.373739910877111,
                            45.983502830554499
                        ],
                        [
                            11.446781725348776,
                            45.980894956257508
                        ],
                        [
                            11.491200750321779,
                            46.008549611218619
                        ],
                        [
                            11.538911746491083,
                            46.013305983160279
                        ],
                        [
                            11.577230062427603,
                            46.006520280703228
                        ],
                        [
                            11.587592025383618,
                            45.968997073098556
                        ],
                        [
                            11.620924275961395,
                            45.971558216301602
                        ],
                        [
                            11.630683011573561,
                            45.969380701435377
                        ],
                        [
                            11.627608358678581,
                            45.960641358415444
                        ],
                        [
                            11.685805336188007,
                            45.969287209820415
                        ],
                        [
                            11.690004510232118,
                            45.988807198856684
                        ],
                        [
                            11.666665843798743,
                            46.017079529968072
                        ],
                        [
                            11.681869781428412,
                            46.028417567759725
                        ],
                        [
                            11.666249479245691,
                            46.036317811691696
                        ],
                        [
                            11.678832171160371,
                            46.046045277070398
                        ],
                        [
                            11.706445388274298,
                            46.045992150936982
                        ],
                        [
                            11.68649626295767,
                            46.06600244718225
                        ],
                        [
                            11.685289236565637,
                            46.093568910442521
                        ],
                        [
                            11.703457372333707,
                            46.09049131298061
                        ],
                        [
                            11.716925258694534,
                            46.103022801155753
                        ],
                        [
                            11.750770099574503,
                            46.105136998482109
                        ],
                        [
                            11.758691744027871,
                            46.09560119568556
                        ],
                        [
                            11.773222809478797,
                            46.106688830323769
                        ],
                        [
                            11.805459484350834,
                            46.103835446957987
                        ],
                        [
                            11.885296803795693,
                            46.117743846817191
                        ],
                        [
                            11.921767928412233,
                            46.149338029596052
                        ],
                        [
                            11.928626236356696,
                            46.175801183484275
                        ],
                        [
                            11.950906427728992,
                            46.170269074894335
                        ],
                        [
                            11.949471287031066,
                            46.181625013416692
                        ],
                        [
                            11.962331725081533,
                            46.188011050757552
                        ],
                        [
                            11.962498360573498,
                            46.199760889432781
                        ],
                        [
                            11.939358747474976,
                            46.198820411844892
                        ],
                        [
                            11.909567731094056,
                            46.224427954959815
                        ],
                        [
                            11.929099717168208,
                            46.248834974823708
                        ],
                        [
                            11.891986291878919,
                            46.252628409667437
                        ],
                        [
                            11.885227320634632,
                            46.278817929075849
                        ],
                        [
                            11.838022084588166,
                            46.270348064938453
                        ],
                        [
                            11.826260837778158,
                            46.284972646568072
                        ],
                        [
                            11.841446208900853,
                            46.306340517202884
                        ],
                        [
                            11.831850604614869,
                            46.325146519945022
                        ],
                        [
                            11.802811975542811,
                            46.333224780778927
                        ],
                        [
                            11.802343378631614,
                            46.342866531013151
                        ],
                        [
                            11.774389419115598,
                            46.358230352233313
                        ],
                        [
                            11.792173341753665,
                            46.367817597858696
                        ],
                        [
                            11.814177127977844,
                            46.367749906832259
                        ],
                        [
                            11.820172770274327,
                            46.376618979932829
                        ],
                        [
                            11.83539427168953,
                            46.36622223588698
                        ],
                        [
                            11.832039144191823,
                            46.387188373854187
                        ],
                        [
                            11.850294718824369,
                            46.434172267703225
                        ],
                        [
                            11.870882283189603,
                            46.433214497855317
                        ],
                        [
                            11.889109050141876,
                            46.442740791652774
                        ],
                        [
                            11.877158797062556,
                            46.471784030913803
                        ],
                        [
                            11.813408258511163,
                            46.477934079845866
                        ],
                        [
                            11.815453506033432,
                            46.500317501170336
                        ],
                        [
                            11.848019520161669,
                            46.51671748192193
                        ],
                        [
                            11.911876943043584,
                            46.532947997454315
                        ],
                        [
                            11.945498316034115,
                            46.529406795897479
                        ],
                        [
                            11.949535290163556,
                            46.539214625171859
                        ],
                        [
                            11.966142324484414,
                            46.544667751211499
                        ],
                        [
                            11.987566334508456,
                            46.545285781039929
                        ],
                        [
                            11.998414081265796,
                            46.532846912367582
                        ],
                        [
                            12.046691849000249,
                            46.584711426806784
                        ],
                        [
                            12.045443945590286,
                            46.607939585965127
                        ],
                        [
                            12.074215674363291,
                            46.642612468249553
                        ],
                        [
                            12.068267532253467,
                            46.67506148283293
                        ],
                        [
                            12.145123272670235,
                            46.634065558118216
                        ],
                        [
                            12.17133395901509,
                            46.634087174721387
                        ],
                        [
                            12.194264280416178,
                            46.619321683052043
                        ],
                        [
                            12.19224575964477,
                            46.594542458217028
                        ],
                        [
                            12.261219522444806,
                            46.629118198717819
                        ],
                        [
                            12.283799533927651,
                            46.618012618862586
                        ],
                        [
                            12.33962818118729,
                            46.631487874927771
                        ],
                        [
                            12.360018743168498,
                            46.619576491482029
                        ],
                        [
                            12.385068674895871,
                            46.622900865041629
                        ],
                        [
                            12.379776869599365,
                            46.642900749177478
                        ],
                        [
                            12.405460452878101,
                            46.643090185719878
                        ],
                        [
                            12.43413605520025,
                            46.668368030993385
                        ],
                        [
                            12.47749963004882,
                            46.679853777134333
                        ],
                        [
                            12.505905320166946,
                            46.678391366799666
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 7,
                "name": "Friuli Venezia Giulia",
                "length": 667489.73706,
                "area": 7864293935.039999961853027
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                13.530387197820579,
                                45.787929005659677
                            ],
                            [
                                13.539810836357855,
                                45.7822366182248
                            ],
                            [
                                13.52076698418441,
                                45.756982269132692
                            ],
                            [
                                13.552838726182111,
                                45.724120087594365
                            ],
                            [
                                13.530563468690891,
                                45.723346674734671
                            ],
                            [
                                13.485633725028555,
                                45.704433438089488
                            ],
                            [
                                13.461080209568058,
                                45.711209087101246
                            ],
                            [
                                13.468464919142381,
                                45.703579354263539
                            ],
                            [
                                13.460221935700904,
                                45.694145435916475
                            ],
                            [
                                13.42427030190861,
                                45.677236475599152
                            ],
                            [
                                13.38940534247339,
                                45.675251415988093
                            ],
                            [
                                13.359416811744653,
                                45.692478399653979
                            ],
                            [
                                13.344046661697496,
                                45.68905937282689
                            ],
                            [
                                13.245795531204044,
                                45.71950290798793
                            ],
                            [
                                13.14882088839777,
                                45.698837441164969
                            ],
                            [
                                13.148127537671328,
                                45.689375306578299
                            ],
                            [
                                13.109309863873104,
                                45.662882738673851
                            ],
                            [
                                13.100791132622383,
                                45.643392363093668
                            ],
                            [
                                13.081143849749225,
                                45.658822981760501
                            ],
                            [
                                13.063373863461161,
                                45.656770573266243
                            ],
                            [
                                13.066767970954174,
                                45.672343421166275
                            ],
                            [
                                13.043597321246889,
                                45.685485548943532
                            ],
                            [
                                13.053249828363793,
                                45.694517782569235
                            ],
                            [
                                13.036844275257977,
                                45.699384224720632
                            ],
                            [
                                13.029035852049187,
                                45.736309011311732
                            ],
                            [
                                13.008307257108784,
                                45.724892119315513
                            ],
                            [
                                13.016064475561112,
                                45.73592034242413
                            ],
                            [
                                13.001190886204173,
                                45.749287827281826
                            ],
                            [
                                13.007591392916948,
                                45.765629914207238
                            ],
                            [
                                12.981230643224102,
                                45.786891232152158
                            ],
                            [
                                12.991334870477363,
                                45.799994945072044
                            ],
                            [
                                12.982359223138371,
                                45.795583006614194
                            ],
                            [
                                12.973903597449853,
                                45.806638810548314
                            ],
                            [
                                12.978744379038652,
                                45.814566643587725
                            ],
                            [
                                12.98838305392886,
                                45.808739333207299
                            ],
                            [
                                12.993241729247433,
                                45.815014205291469
                            ],
                            [
                                12.98131697710004,
                                45.81867143894285
                            ],
                            [
                                12.982074648170645,
                                45.827295120460562
                            ],
                            [
                                12.974188864022874,
                                45.823364410872898
                            ],
                            [
                                12.979045763491587,
                                45.83404198066232
                            ],
                            [
                                12.967183360850489,
                                45.836014355856001
                            ],
                            [
                                12.961429481548766,
                                45.846871668506282
                            ],
                            [
                                12.951372141712314,
                                45.843003414694728
                            ],
                            [
                                12.952065132983012,
                                45.822205863164704
                            ],
                            [
                                12.929495345506663,
                                45.817351033737147
                            ],
                            [
                                12.920512745281524,
                                45.831340559610545
                            ],
                            [
                                12.890058559756556,
                                45.820474408703923
                            ],
                            [
                                12.869672304482869,
                                45.833780676002547
                            ],
                            [
                                12.874983445859796,
                                45.850344629141482
                            ],
                            [
                                12.861182563893381,
                                45.850790016835717
                            ],
                            [
                                12.836867886521228,
                                45.847462709336099
                            ],
                            [
                                12.808586464728315,
                                45.820174160188316
                            ],
                            [
                                12.798597789715222,
                                45.832388662548212
                            ],
                            [
                                12.804303291585789,
                                45.844622636963081
                            ],
                            [
                                12.779822186232575,
                                45.854441778009324
                            ],
                            [
                                12.742856103908531,
                                45.826643632677907
                            ],
                            [
                                12.729994671190207,
                                45.837277941318042
                            ],
                            [
                                12.669041929388568,
                                45.790886809028109
                            ],
                            [
                                12.650284211370542,
                                45.80366692187804
                            ],
                            [
                                12.647620085898204,
                                45.816470648218711
                            ],
                            [
                                12.605686152403219,
                                45.838244809266591
                            ],
                            [
                                12.594367735745564,
                                45.830877868333296
                            ],
                            [
                                12.593845430809228,
                                45.815179233839771
                            ],
                            [
                                12.56529939098445,
                                45.83181336781535
                            ],
                            [
                                12.559299508180118,
                                45.82592495752489
                            ],
                            [
                                12.549614564133256,
                                45.860696159050285
                            ],
                            [
                                12.529860580743476,
                                45.863608512690455
                            ],
                            [
                                12.5370886010764,
                                45.868654807998112
                            ],
                            [
                                12.532258428485733,
                                45.881927852327195
                            ],
                            [
                                12.507000684075571,
                                45.897848259585388
                            ],
                            [
                                12.523268049301654,
                                45.903126176725102
                            ],
                            [
                                12.506000688371268,
                                45.922710752422773
                            ],
                            [
                                12.474697208085232,
                                45.928470035512994
                            ],
                            [
                                12.454253936650501,
                                45.947112526200712
                            ],
                            [
                                12.426141661477571,
                                45.947005723539128
                            ],
                            [
                                12.428188233239919,
                                45.995762789256204
                            ],
                            [
                                12.398987184355539,
                                46.041424006617056
                            ],
                            [
                                12.437487003730181,
                                46.084833677059201
                            ],
                            [
                                12.48442520927671,
                                46.10447245412854
                            ],
                            [
                                12.497196132548922,
                                46.129752054014553
                            ],
                            [
                                12.495813402103774,
                                46.152552706291182
                            ],
                            [
                                12.456918896955674,
                                46.170649263657353
                            ],
                            [
                                12.442479233503958,
                                46.197122163074717
                            ],
                            [
                                12.446453981498884,
                                46.207766272413799
                            ],
                            [
                                12.406271359415962,
                                46.207274475678879
                            ],
                            [
                                12.401678662187338,
                                46.228994256776886
                            ],
                            [
                                12.376423449490368,
                                46.222941938505372
                            ],
                            [
                                12.338327121125165,
                                46.238951167759907
                            ],
                            [
                                12.323977478264093,
                                46.254931679545592
                            ],
                            [
                                12.322750016066523,
                                46.273123172850234
                            ],
                            [
                                12.350831853591957,
                                46.293839186835328
                            ],
                            [
                                12.354654614357033,
                                46.31968212306446
                            ],
                            [
                                12.378117313976793,
                                46.331624646009274
                            ],
                            [
                                12.411789347117967,
                                46.331474612160541
                            ],
                            [
                                12.421213663716003,
                                46.342578309333753
                            ],
                            [
                                12.417374428148989,
                                46.35485427779831
                            ],
                            [
                                12.428665956270384,
                                46.35159607742149
                            ],
                            [
                                12.462942613986126,
                                46.36926268484666
                            ],
                            [
                                12.455047615516465,
                                46.391668305885155
                            ],
                            [
                                12.46934916501125,
                                46.390077270948737
                            ],
                            [
                                12.498683596030375,
                                46.412210450413603
                            ],
                            [
                                12.492478117113086,
                                46.424260699908494
                            ],
                            [
                                12.527943451025299,
                                46.453092739260072
                            ],
                            [
                                12.530842125363632,
                                46.464933227300499
                            ],
                            [
                                12.541715252038586,
                                46.4589083494281
                            ],
                            [
                                12.569953963285116,
                                46.475485612225604
                            ],
                            [
                                12.606068803956516,
                                46.464126681230582
                            ],
                            [
                                12.620751490831493,
                                46.47536728227454
                            ],
                            [
                                12.662362595880504,
                                46.467967586157208
                            ],
                            [
                                12.654062686685091,
                                46.484386998095609
                            ],
                            [
                                12.630021094654534,
                                46.500706645883625
                            ],
                            [
                                12.630585565123585,
                                46.512166808697259
                            ],
                            [
                                12.69871477928616,
                                46.540890209132669
                            ],
                            [
                                12.749648984544995,
                                46.543981956592553
                            ],
                            [
                                12.732693605610404,
                                46.55748204819205
                            ],
                            [
                                12.742413042706968,
                                46.576332695810294
                            ],
                            [
                                12.727437587402008,
                                46.630378988758302
                            ],
                            [
                                12.750685319507776,
                                46.645085731047224
                            ],
                            [
                                12.782765929559528,
                                46.645427604023922
                            ],
                            [
                                12.819039228652072,
                                46.628249595075914
                            ],
                            [
                                12.830898679306312,
                                46.630606649564967
                            ],
                            [
                                12.833654238366469,
                                46.610654769235815
                            ],
                            [
                                12.851989489215738,
                                46.605078726255691
                            ],
                            [
                                12.928698551414916,
                                46.610336472553549
                            ],
                            [
                                12.948944497405053,
                                46.60261792450369
                            ],
                            [
                                13.021430492531886,
                                46.602131980878418
                            ],
                            [
                                13.047424352110918,
                                46.595336429865888
                            ],
                            [
                                13.083549623467599,
                                46.601831521509219
                            ],
                            [
                                13.168416156566648,
                                46.588833260721799
                            ],
                            [
                                13.193382404904971,
                                46.572640558728935
                            ],
                            [
                                13.218005528040392,
                                46.570293572898493
                            ],
                            [
                                13.232525208045546,
                                46.553591004083195
                            ],
                            [
                                13.26956379393051,
                                46.561275810660348
                            ],
                            [
                                13.320184829971852,
                                46.552886648688578
                            ],
                            [
                                13.344443115228314,
                                46.56986426889079
                            ],
                            [
                                13.370813165894736,
                                46.567314196667461
                            ],
                            [
                                13.372750471327201,
                                46.579359599805073
                            ],
                            [
                                13.408755743158546,
                                46.570999315252791
                            ],
                            [
                                13.407934924260431,
                                46.561620628544439
                            ],
                            [
                                13.425433348528648,
                                46.557910412599618
                            ],
                            [
                                13.474879195785432,
                                46.557486137457701
                            ],
                            [
                                13.504100249521519,
                                46.566075956466307
                            ],
                            [
                                13.51816917307014,
                                46.547297642199396
                            ],
                            [
                                13.561003274925463,
                                46.551822868784186
                            ],
                            [
                                13.569900814414536,
                                46.538883643228836
                            ],
                            [
                                13.597045843560503,
                                46.545755019885092
                            ],
                            [
                                13.676779585701546,
                                46.523253628207968
                            ],
                            [
                                13.713851958942984,
                                46.523083137326452
                            ],
                            [
                                13.716777231435939,
                                46.507345389366137
                            ],
                            [
                                13.702539732613316,
                                46.498774339605951
                            ],
                            [
                                13.709564676624252,
                                46.481076535059778
                            ],
                            [
                                13.695465877483576,
                                46.468632921869983
                            ],
                            [
                                13.688771634237588,
                                46.439866109354774
                            ],
                            [
                                13.648379235085914,
                                46.446064159488124
                            ],
                            [
                                13.597543324894124,
                                46.439252964167281
                            ],
                            [
                                13.578699989942926,
                                46.426481965189211
                            ],
                            [
                                13.565438470542604,
                                46.39820993161279
                            ],
                            [
                                13.470107971158479,
                                46.361137286819869
                            ],
                            [
                                13.438988459131339,
                                46.360209756643357
                            ],
                            [
                                13.447371482268863,
                                46.336377236120647
                            ],
                            [
                                13.439015317557491,
                                46.322278456468879
                            ],
                            [
                                13.418141757358896,
                                46.318173974320089
                            ],
                            [
                                13.402797084148503,
                                46.29999542157536
                            ],
                            [
                                13.375547461339359,
                                46.298217702606287
                            ],
                            [
                                13.398584927154387,
                                46.253406552590391
                            ],
                            [
                                13.422483030760372,
                                46.234390682435496
                            ],
                            [
                                13.409052478154514,
                                46.21491009021593
                            ],
                            [
                                13.423452389913159,
                                46.206336660705034
                            ],
                            [
                                13.446298741041293,
                                46.212842911010483
                            ],
                            [
                                13.448279255336171,
                                46.225232210142579
                            ],
                            [
                                13.484385695831657,
                                46.224552363639354
                            ],
                            [
                                13.553270569716149,
                                46.208632756706635
                            ],
                            [
                                13.566947540644231,
                                46.185668652907381
                            ],
                            [
                                13.588712714954738,
                                46.190880007093419
                            ],
                            [
                                13.614534728903298,
                                46.184410631495602
                            ],
                            [
                                13.632584101275761,
                                46.190744988882415
                            ],
                            [
                                13.663203305408548,
                                46.180118075396571
                            ],
                            [
                                13.643894532471288,
                                46.137078842935352
                            ],
                            [
                                13.573963623519045,
                                46.090676888728339
                            ],
                            [
                                13.496495425818066,
                                46.058616399447544
                            ],
                            [
                                13.497149661844118,
                                46.04833822798787
                            ],
                            [
                                13.510016058433198,
                                46.046245995127499
                            ],
                            [
                                13.50755461166464,
                                46.033480540689474
                            ],
                            [
                                13.494292806559033,
                                46.014547714177709
                            ],
                            [
                                13.47619026580775,
                                46.006253852998086
                            ],
                            [
                                13.501685412560583,
                                45.980470646607834
                            ],
                            [
                                13.540980043634756,
                                45.964866317346093
                            ],
                            [
                                13.568246360832044,
                                45.968075456527146
                            ],
                            [
                                13.589911295945877,
                                45.9896682810651
                            ],
                            [
                                13.642660589409752,
                                45.983194331355499
                            ],
                            [
                                13.637545524708758,
                                45.935389345866248
                            ],
                            [
                                13.609231231790158,
                                45.899249290976314
                            ],
                            [
                                13.590326954983047,
                                45.888319132521005
                            ],
                            [
                                13.592884309860626,
                                45.874813124470869
                            ],
                            [
                                13.572733344750759,
                                45.847552270538799
                            ],
                            [
                                13.596363126023544,
                                45.820052583348229
                            ],
                            [
                                13.596288996289431,
                                45.807939681065157
                            ],
                            [
                                13.627271816390282,
                                45.797473485754765
                            ],
                            [
                                13.66940043999109,
                                45.799639944130682
                            ],
                            [
                                13.734673234930668,
                                45.760163236855881
                            ],
                            [
                                13.796296430773987,
                                45.742703022818787
                            ],
                            [
                                13.83370972323274,
                                45.70724080448533
                            ],
                            [
                                13.835496199889095,
                                45.68613290331016
                            ],
                            [
                                13.918066021374493,
                                45.63114280563704
                            ],
                            [
                                13.868753364122723,
                                45.609257497882126
                            ],
                            [
                                13.865621770557798,
                                45.596689986302053
                            ],
                            [
                                13.842244582375125,
                                45.583125587899985
                            ],
                            [
                                13.78698916796632,
                                45.582894461168586
                            ],
                            [
                                13.747156566587318,
                                45.59807188683321
                            ],
                            [
                                13.722935885959428,
                                45.594707867606466
                            ],
                            [
                                13.719291788479998,
                                45.605521150787617
                            ],
                            [
                                13.73174454334611,
                                45.608871032711612
                            ],
                            [
                                13.786921122333329,
                                45.600151778258287
                            ],
                            [
                                13.813894821120178,
                                45.614640435029912
                            ],
                            [
                                13.77398362636141,
                                45.612726868998529
                            ],
                            [
                                13.775706126524467,
                                45.635562303588877
                            ],
                            [
                                13.756847330984682,
                                45.627889883966496
                            ],
                            [
                                13.744239173334787,
                                45.639129597838512
                            ],
                            [
                                13.752365530379254,
                                45.650068639624962
                            ],
                            [
                                13.757372878979513,
                                45.64930628135167
                            ],
                            [
                                13.759023730778248,
                                45.645699988121201
                            ],
                            [
                                13.76910446818542,
                                45.652992289088459
                            ],
                            [
                                13.75333892263791,
                                45.680657061740142
                            ],
                            [
                                13.711606412709605,
                                45.703940666568869
                            ],
                            [
                                13.713661245734102,
                                45.707882786347774
                            ],
                            [
                                13.712081247617915,
                                45.71026974705601
                            ],
                            [
                                13.632010133719149,
                                45.768215278542613
                            ],
                            [
                                13.556470614477677,
                                45.783568885301676
                            ],
                            [
                                13.541761391164941,
                                45.800385270030603
                            ],
                            [
                                13.533451520380806,
                                45.804726084273135
                            ],
                            [
                                13.548147750436454,
                                45.790242672185926
                            ],
                            [
                                13.530387197820579,
                                45.787929005659677
                            ]
                        ],
                        [
                            [
                                13.757064703338585,
                                45.646216306612693
                            ],
                            [
                                13.757561455203305,
                                45.64665643301521
                            ],
                            [
                                13.757744013248201,
                                45.646910455220649
                            ],
                            [
                                13.75751231517398,
                                45.646715786175086
                            ],
                            [
                                13.757064703338585,
                                45.646216306612693
                            ]
                        ],
                        [
                            [
                                13.688897103241541,
                                45.727463806785366
                            ],
                            [
                                13.688650695490058,
                                45.7276049160997
                            ],
                            [
                                13.688604865973387,
                                45.72755508847181
                            ],
                            [
                                13.688943104248043,
                                45.727398029340534
                            ],
                            [
                                13.688897103241541,
                                45.727463806785366
                            ]
                        ],
                        [
                            [
                                13.722600041774589,
                                45.700401356599563
                            ],
                            [
                                13.72244302315829,
                                45.700482543747633
                            ],
                            [
                                13.722338061058847,
                                45.700512220626912
                            ],
                            [
                                13.722533764819808,
                                45.700367313319603
                            ],
                            [
                                13.722600041774589,
                                45.700401356599563
                            ]
                        ],
                        [
                            [
                                13.719764930723791,
                                45.700881476313604
                            ],
                            [
                                13.719829492836974,
                                45.700817769267019
                            ],
                            [
                                13.719927485101636,
                                45.700782837485718
                            ],
                            [
                                13.719910186623096,
                                45.700858367063269
                            ],
                            [
                                13.719764930723791,
                                45.700881476313604
                            ]
                        ],
                        [
                            [
                                13.691498350785274,
                                45.725372783732688
                            ],
                            [
                                13.691434397481638,
                                45.725307921733062
                            ],
                            [
                                13.691598814690989,
                                45.725398693295247
                            ],
                            [
                                13.691498350785274,
                                45.725372783732688
                            ]
                        ],
                        [
                            [
                                13.53623636807807,
                                45.784336515139728
                            ],
                            [
                                13.536141511893044,
                                45.784309281869994
                            ],
                            [
                                13.536169313133772,
                                45.784261332560632
                            ],
                            [
                                13.536241159610039,
                                45.78427524375158
                            ],
                            [
                                13.53623636807807,
                                45.784336515139728
                            ]
                        ],
                        [
                            [
                                13.7227627854188,
                                45.700284971087129
                            ],
                            [
                                13.722823160314801,
                                45.700230743367982
                            ],
                            [
                                13.72293515261906,
                                45.700200003322955
                            ],
                            [
                                13.722891911925124,
                                45.700253405060238
                            ],
                            [
                                13.7227627854188,
                                45.700284971087129
                            ]
                        ],
                        [
                            [
                                13.722631992044009,
                                45.700354910131971
                            ],
                            [
                                13.722679255979294,
                                45.700296615116393
                            ],
                            [
                                13.7227627854188,
                                45.700284971087129
                            ],
                            [
                                13.722724352118469,
                                45.700338424721828
                            ],
                            [
                                13.722631992044009,
                                45.700354910131971
                            ]
                        ],
                        [
                            [
                                13.530363408720275,
                                45.788054542710341
                            ],
                            [
                                13.530321604368146,
                                45.787999848729875
                            ],
                            [
                                13.530387197820579,
                                45.787929005659677
                            ],
                            [
                                13.530363408720275,
                                45.788054542710341
                            ]
                        ],
                        [
                            [
                                13.531095607408265,
                                45.787388514753594
                            ],
                            [
                                13.531133434813842,
                                45.787334831337958
                            ],
                            [
                                13.531210549535668,
                                45.787345390368294
                            ],
                            [
                                13.531095607408265,
                                45.787388514753594
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                13.762442734793852,
                                45.655136153135118
                            ],
                            [
                                13.758033655917018,
                                45.662971928879365
                            ],
                            [
                                13.756995340903229,
                                45.664147522395318
                            ],
                            [
                                13.758211714407322,
                                45.663118440073248
                            ],
                            [
                                13.762442734793852,
                                45.655136153135118
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                13.737253189618567,
                                45.624097750808318
                            ],
                            [
                                13.735580206162282,
                                45.631450151220577
                            ],
                            [
                                13.738847095012391,
                                45.617225671311921
                            ],
                            [
                                13.737253189618567,
                                45.624097750808318
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                13.738218416653186,
                                45.643022949285893
                            ],
                            [
                                13.739292645545428,
                                45.638614909046517
                            ],
                            [
                                13.738114298649844,
                                45.643010400483334
                            ],
                            [
                                13.738218416653186,
                                45.643022949285893
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                13.736870137410156,
                                45.637240268504144
                            ],
                            [
                                13.737907673383891,
                                45.632797369815222
                            ],
                            [
                                13.737810251548288,
                                45.632784528914534
                            ],
                            [
                                13.736769898730316,
                                45.637229839156589
                            ],
                            [
                                13.736870137410156,
                                45.637240268504144
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                13.773937629813457,
                                45.612864593252979
                            ],
                            [
                                13.77398362636141,
                                45.612726868998529
                            ],
                            [
                                13.774085527638727,
                                45.612622123359564
                            ],
                            [
                                13.773700128033418,
                                45.612499178522491
                            ],
                            [
                                13.773937629813457,
                                45.612864593252979
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                13.751729123025392,
                                45.649659801563182
                            ],
                            [
                                13.752365530379254,
                                45.650068639624962
                            ],
                            [
                                13.751094108271694,
                                45.648495338684512
                            ],
                            [
                                13.751402467176908,
                                45.64909562646298
                            ],
                            [
                                13.751729123025392,
                                45.649659801563182
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                13.787022032134782,
                                45.612066394323705
                            ],
                            [
                                13.787081438461597,
                                45.611955858696433
                            ],
                            [
                                13.786536301962819,
                                45.611793204112402
                            ],
                            [
                                13.786499609163174,
                                45.611941431991028
                            ],
                            [
                                13.787022032134782,
                                45.612066394323705
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                13.711843770690882,
                                45.706619526736361
                            ],
                            [
                                13.711748285960709,
                                45.706567557199023
                            ],
                            [
                                13.711814534165791,
                                45.707194971416094
                            ],
                            [
                                13.711896999089705,
                                45.707191440258775
                            ],
                            [
                                13.711843770690882,
                                45.706619526736361
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                13.706257445776805,
                                45.71385477078897
                            ],
                            [
                                13.706405291051512,
                                45.713757829089346
                            ],
                            [
                                13.706638280148962,
                                45.713779941422516
                            ],
                            [
                                13.706377782834119,
                                45.713706844382166
                            ],
                            [
                                13.706257445776805,
                                45.71385477078897
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                13.78705778139966,
                                45.612006552712067
                            ],
                            [
                                13.787466325561097,
                                45.612176520506452
                            ],
                            [
                                13.787925030953673,
                                45.612261654257473
                            ],
                            [
                                13.78705778139966,
                                45.612006552712067
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                13.787925030953673,
                                45.612261654257473
                            ],
                            [
                                13.787895903763815,
                                45.612314523485892
                            ],
                            [
                                13.788222020657349,
                                45.612363203903094
                            ],
                            [
                                13.787963596485923,
                                45.61221846577395
                            ],
                            [
                                13.787925030953673,
                                45.612261654257473
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                13.786114906027661,
                                45.61173575579884
                            ],
                            [
                                13.786020998632454,
                                45.611641253620263
                            ],
                            [
                                13.785936654603187,
                                45.611692518165306
                            ],
                            [
                                13.786046394987491,
                                45.611803004840056
                            ],
                            [
                                13.786114906027661,
                                45.61173575579884
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                13.775252384287949,
                                45.610710161917822
                            ],
                            [
                                13.775359899237166,
                                45.610691654361496
                            ],
                            [
                                13.775307793407059,
                                45.610609039171997
                            ],
                            [
                                13.775230658472873,
                                45.610645485869405
                            ],
                            [
                                13.775252384287949,
                                45.610710161917822
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                13.711592550102562,
                                45.703995454690812
                            ],
                            [
                                13.711606412709605,
                                45.703940666568869
                            ],
                            [
                                13.711475226774759,
                                45.704057522935315
                            ],
                            [
                                13.711546577749631,
                                45.704043336335808
                            ],
                            [
                                13.711592550102562,
                                45.703995454690812
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                13.773223356607518,
                                45.612422976741286
                            ],
                            [
                                13.773292642247673,
                                45.612372069681427
                            ],
                            [
                                13.773203661322741,
                                45.612365887309196
                            ],
                            [
                                13.773223356607518,
                                45.612422976741286
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                13.77306169612406,
                                45.612587025934324
                            ],
                            [
                                13.773150415293365,
                                45.612618998063148
                            ],
                            [
                                13.773133087843126,
                                45.612563841109051
                            ],
                            [
                                13.77306169612406,
                                45.612587025934324
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                13.773498443034081,
                                45.61250422678998
                            ],
                            [
                                13.773561865130633,
                                45.612478276243017
                            ],
                            [
                                13.773517813178412,
                                45.61242969989808
                            ],
                            [
                                13.773498443034081,
                                45.61250422678998
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                13.786189004837434,
                                45.612878290922673
                            ],
                            [
                                13.786271581188512,
                                45.612874783542161
                            ],
                            [
                                13.786233177556566,
                                45.61283005262225
                            ],
                            [
                                13.786189004837434,
                                45.612878290922673
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 8,
                "name": "Liguria",
                "length": 834224.468035,
                "area": 5415464956.439999580383301
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                7.760725422734668,
                                43.807508980260067
                            ],
                            [
                                7.739080120234052,
                                43.795556735891395
                            ],
                            [
                                7.699996767175392,
                                43.798650471102491
                            ],
                            [
                                7.672445506039718,
                                43.77655608457345
                            ],
                            [
                                7.575391305389138,
                                43.792861174697933
                            ],
                            [
                                7.55574155163626,
                                43.779782049060763
                            ],
                            [
                                7.529601075808464,
                                43.784254361201072
                            ],
                            [
                                7.495687206707824,
                                43.860892623626015
                            ],
                            [
                                7.515170420664228,
                                43.883831846487986
                            ],
                            [
                                7.562643515753958,
                                43.900658746366069
                            ],
                            [
                                7.56882060353434,
                                43.946397286641719
                            ],
                            [
                                7.655572659668228,
                                43.976910254358714
                            ],
                            [
                                7.670344898544017,
                                43.998227552726341
                            ],
                            [
                                7.663025146361308,
                                44.028766947594697
                            ],
                            [
                                7.70068972376359,
                                44.040721271176885
                            ],
                            [
                                7.711655420026326,
                                44.06039608954103
                            ],
                            [
                                7.727773343281686,
                                44.06027962736659
                            ],
                            [
                                7.737892287464152,
                                44.076372651471615
                            ],
                            [
                                7.759088398846891,
                                44.083883995852375
                            ],
                            [
                                7.733673140603969,
                                44.08331247859315
                            ],
                            [
                                7.721884025626208,
                                44.09795546176742
                            ],
                            [
                                7.727927536368206,
                                44.127319297348158
                            ],
                            [
                                7.775143113128112,
                                44.139971605208757
                            ],
                            [
                                7.816001517626884,
                                44.12307132231534
                            ],
                            [
                                7.866119591112493,
                                44.118155373765447
                            ],
                            [
                                7.883928438514931,
                                44.104671951966488
                            ],
                            [
                                7.925972212930311,
                                44.110296431697556
                            ],
                            [
                                7.942367898829818,
                                44.100116567650581
                            ],
                            [
                                7.9715313960425,
                                44.113095196826301
                            ],
                            [
                                8.004633806458511,
                                44.102326662469132
                            ],
                            [
                                8.015597263701569,
                                44.110701631470647
                            ],
                            [
                                8.002688624051746,
                                44.11662932532559
                            ],
                            [
                                8.012887668666849,
                                44.119657458397811
                            ],
                            [
                                7.978931534283835,
                                44.133542027631776
                            ],
                            [
                                7.985407504409785,
                                44.142766458562967
                            ],
                            [
                                8.011841249337021,
                                44.155899708197808
                            ],
                            [
                                8.044503973666446,
                                44.142546794238328
                            ],
                            [
                                8.07118771177525,
                                44.146926337189115
                            ],
                            [
                                8.097197055793563,
                                44.178965481744051
                            ],
                            [
                                8.095532169008774,
                                44.196938316337054
                            ],
                            [
                                8.065466164098547,
                                44.216563786876385
                            ],
                            [
                                8.081103436440813,
                                44.240044557174159
                            ],
                            [
                                8.063096625651406,
                                44.253074186185849
                            ],
                            [
                                8.081262121415385,
                                44.262031186377492
                            ],
                            [
                                8.090687174667154,
                                44.274683766551171
                            ],
                            [
                                8.076044901454203,
                                44.287526028056462
                            ],
                            [
                                8.063557444928797,
                                44.28827061450022
                            ],
                            [
                                8.059739801521912,
                                44.300703820966199
                            ],
                            [
                                8.076021686635544,
                                44.313958455321341
                            ],
                            [
                                8.101956768601978,
                                44.300931016911825
                            ],
                            [
                                8.106436349559059,
                                44.332372805377638
                            ],
                            [
                                8.134283899002265,
                                44.332099613560644
                            ],
                            [
                                8.14491633180746,
                                44.34578005973141
                            ],
                            [
                                8.149519212727359,
                                44.384792014658856
                            ],
                            [
                                8.186505576588281,
                                44.39530232006426
                            ],
                            [
                                8.20804681650869,
                                44.410344317848875
                            ],
                            [
                                8.221357632255462,
                                44.432911213913542
                            ],
                            [
                                8.207079118413281,
                                44.448076922147543
                            ],
                            [
                                8.210256841106915,
                                44.45551734869953
                            ],
                            [
                                8.195735346025188,
                                44.464265667227536
                            ],
                            [
                                8.197327503031945,
                                44.477555808877305
                            ],
                            [
                                8.22331544894613,
                                44.485669357539123
                            ],
                            [
                                8.216199561672173,
                                44.497303665184305
                            ],
                            [
                                8.225770617494531,
                                44.515392200467922
                            ],
                            [
                                8.252798704198712,
                                44.528758781078359
                            ],
                            [
                                8.271312514034395,
                                44.506797266884377
                            ],
                            [
                                8.304553650288751,
                                44.502647245959025
                            ],
                            [
                                8.321637656655968,
                                44.488021671150669
                            ],
                            [
                                8.349177104727548,
                                44.485553148453263
                            ],
                            [
                                8.359533746207068,
                                44.464995565260367
                            ],
                            [
                                8.392431653481605,
                                44.477049848982546
                            ],
                            [
                                8.403899935665102,
                                44.508978158105855
                            ],
                            [
                                8.418587247383373,
                                44.513277600972621
                            ],
                            [
                                8.449498663274376,
                                44.497388087823701
                            ],
                            [
                                8.470656745742328,
                                44.522479403253961
                            ],
                            [
                                8.478073497005395,
                                44.510648086072699
                            ],
                            [
                                8.534783188475327,
                                44.513350878326349
                            ],
                            [
                                8.559695508833897,
                                44.502817529227038
                            ],
                            [
                                8.576161587650041,
                                44.509226674810947
                            ],
                            [
                                8.573756531154505,
                                44.523324831573653
                            ],
                            [
                                8.586687823009116,
                                44.524191600381535
                            ],
                            [
                                8.612367110473199,
                                44.543295116148236
                            ],
                            [
                                8.597816084211281,
                                44.556559599618247
                            ],
                            [
                                8.623861366724805,
                                44.586380709787854
                            ],
                            [
                                8.681419810381051,
                                44.574882502104742
                            ],
                            [
                                8.690052394172007,
                                44.58196322990996
                            ],
                            [
                                8.72099802851489,
                                44.579865408329518
                            ],
                            [
                                8.756983941522027,
                                44.536690373249193
                            ],
                            [
                                8.749807716790562,
                                44.525664700037552
                            ],
                            [
                                8.760471729747952,
                                44.530242877086437
                            ],
                            [
                                8.767564327851812,
                                44.524964003882573
                            ],
                            [
                                8.773573773415983,
                                44.503927934054857
                            ],
                            [
                                8.766940865637515,
                                44.49195006712872
                            ],
                            [
                                8.788263228659261,
                                44.488031011400381
                            ],
                            [
                                8.799082524686458,
                                44.530132782849151
                            ],
                            [
                                8.828765318141764,
                                44.543069470109138
                            ],
                            [
                                8.826840437001126,
                                44.561799373648746
                            ],
                            [
                                8.862904672151549,
                                44.560610914514555
                            ],
                            [
                                8.868607351660383,
                                44.566244202961279
                            ],
                            [
                                8.891337065270273,
                                44.550630652310083
                            ],
                            [
                                8.917502842345034,
                                44.561055010020056
                            ],
                            [
                                8.909367671490539,
                                44.61332642433365
                            ],
                            [
                                8.882620669595713,
                                44.638747491843667
                            ],
                            [
                                8.908261169604605,
                                44.646823637102713
                            ],
                            [
                                8.931153200509177,
                                44.676150833782309
                            ],
                            [
                                8.9595230961814,
                                44.676021062865956
                            ],
                            [
                                8.972515226361828,
                                44.663349576164748
                            ],
                            [
                                9.014690729147695,
                                44.666070660802383
                            ],
                            [
                                9.038761778305613,
                                44.640867293778683
                            ],
                            [
                                9.04390887419695,
                                44.614425234128987
                            ],
                            [
                                9.0758534320262,
                                44.623699032105463
                            ],
                            [
                                9.103532246235668,
                                44.609385877722566
                            ],
                            [
                                9.110704092342472,
                                44.581971047235847
                            ],
                            [
                                9.13767170122153,
                                44.573933981098129
                            ],
                            [
                                9.198954886539298,
                                44.592775954924427
                            ],
                            [
                                9.204490813194788,
                                44.614957300336449
                            ],
                            [
                                9.244809677268019,
                                44.619721324074128
                            ],
                            [
                                9.256538921835649,
                                44.610594080699101
                            ],
                            [
                                9.246245264295371,
                                44.599269114606145
                            ],
                            [
                                9.280230825295089,
                                44.59617044968828
                            ],
                            [
                                9.287507771370743,
                                44.607603518162662
                            ],
                            [
                                9.300410235998367,
                                44.60777737134751
                            ],
                            [
                                9.342224184871272,
                                44.577780428541303
                            ],
                            [
                                9.361050715545893,
                                44.58496949716401
                            ],
                            [
                                9.381080338417561,
                                44.576749636002809
                            ],
                            [
                                9.405628916603032,
                                44.600806804790949
                            ],
                            [
                                9.421306229742347,
                                44.592604297970233
                            ],
                            [
                                9.423076555450013,
                                44.574612229879087
                            ],
                            [
                                9.484141573338508,
                                44.562421834774604
                            ],
                            [
                                9.504607671002939,
                                44.529959995715302
                            ],
                            [
                                9.496803423358797,
                                44.482730395911339
                            ],
                            [
                                9.468873092711787,
                                44.481880674281925
                            ],
                            [
                                9.45819850896333,
                                44.442204078918195
                            ],
                            [
                                9.445831810151832,
                                44.438417853374744
                            ],
                            [
                                9.438393696565388,
                                44.418541547090776
                            ],
                            [
                                9.472564794547921,
                                44.42428409058104
                            ],
                            [
                                9.479034341822834,
                                44.409258513875187
                            ],
                            [
                                9.493902282974265,
                                44.423896718007541
                            ],
                            [
                                9.545243715306578,
                                44.426084911612669
                            ],
                            [
                                9.559177521198757,
                                44.438135246091399
                            ],
                            [
                                9.583577426376007,
                                44.427236893334182
                            ],
                            [
                                9.600031790442143,
                                44.43691061311258
                            ],
                            [
                                9.636038292120919,
                                44.41390279216801
                            ],
                            [
                                9.655028193427775,
                                44.411877872090116
                            ],
                            [
                                9.674979436279502,
                                44.364713014739692
                            ],
                            [
                                9.70630125356511,
                                44.366189148350514
                            ],
                            [
                                9.729455177968477,
                                44.328330589000394
                            ],
                            [
                                9.753105861627896,
                                44.322730340910823
                            ],
                            [
                                9.765416139464445,
                                44.304327562139342
                            ],
                            [
                                9.805714966817984,
                                44.282803438731605
                            ],
                            [
                                9.814784140314043,
                                44.286214250629008
                            ],
                            [
                                9.85265694113891,
                                44.270205118512855
                            ],
                            [
                                9.85702737418063,
                                44.234029815769674
                            ],
                            [
                                9.875356726370953,
                                44.223942455084973
                            ],
                            [
                                9.857550406506581,
                                44.193507565157333
                            ],
                            [
                                9.86493896915754,
                                44.18071628085189
                            ],
                            [
                                9.89120876954739,
                                44.207812424133529
                            ],
                            [
                                9.908508538259698,
                                44.209773858191987
                            ],
                            [
                                9.914508935720125,
                                44.199602010990979
                            ],
                            [
                                9.933974533197619,
                                44.196606007482849
                            ],
                            [
                                9.892953057984908,
                                44.166501534147031
                            ],
                            [
                                9.974028983798201,
                                44.166928368961734
                            ],
                            [
                                9.976347892366881,
                                44.139547981038703
                            ],
                            [
                                9.995353691670665,
                                44.117893338523608
                            ],
                            [
                                9.983451599897865,
                                44.098878076797526
                            ],
                            [
                                9.993322031521918,
                                44.09267570979474
                            ],
                            [
                                10.021952310687071,
                                44.119621181660087
                            ],
                            [
                                10.047384559169734,
                                44.115123312106647
                            ],
                            [
                                10.071019406394623,
                                44.093665563597234
                            ],
                            [
                                10.01876816670061,
                                44.044466488865929
                            ],
                            [
                                9.994114124978616,
                                44.050869234001347
                            ],
                            [
                                9.977587484624395,
                                44.035486740883499
                            ],
                            [
                                9.925293727553857,
                                44.060114169938174
                            ],
                            [
                                9.906784856875451,
                                44.081416931254715
                            ],
                            [
                                9.881169608295032,
                                44.080980396754441
                            ],
                            [
                                9.858402574327146,
                                44.095024390532629
                            ],
                            [
                                9.851887906847095,
                                44.110050052274673
                            ],
                            [
                                9.845825233478779,
                                44.104639139252562
                            ],
                            [
                                9.840004340364326,
                                44.109606859509263
                            ],
                            [
                                9.839654762029943,
                                44.104056682119491
                            ],
                            [
                                9.835890664604323,
                                44.110199735394474
                            ],
                            [
                                9.821485685312116,
                                44.095399354430988
                            ],
                            [
                                9.810943517248724,
                                44.101808462914782
                            ],
                            [
                                9.839183106889175,
                                44.065732450177876
                            ],
                            [
                                9.845437583264284,
                                44.069287960613124
                            ],
                            [
                                9.851941472563425,
                                44.061697047269696
                            ],
                            [
                                9.832217795663185,
                                44.048009371467892
                            ],
                            [
                                9.739127296910461,
                                44.093400455719099
                            ],
                            [
                                9.725644238634473,
                                44.112493883433046
                            ],
                            [
                                9.675410367510811,
                                44.139499837888792
                            ],
                            [
                                9.648530859765241,
                                44.14534561298295
                            ],
                            [
                                9.635487435183357,
                                44.133531313622271
                            ],
                            [
                                9.607556012772719,
                                44.157536107581663
                            ],
                            [
                                9.607140359952874,
                                44.170813482739199
                            ],
                            [
                                9.568984304029195,
                                44.182207562864761
                            ],
                            [
                                9.552140859675838,
                                44.204948817992651
                            ],
                            [
                                9.511287004399701,
                                44.216660686449778
                            ],
                            [
                                9.488156968791376,
                                44.239104112306443
                            ],
                            [
                                9.472401406195852,
                                44.23344553634039
                            ],
                            [
                                9.445173661020892,
                                44.238799171074099
                            ],
                            [
                                9.420354068741474,
                                44.259186048113804
                            ],
                            [
                                9.403142885784534,
                                44.255277751585751
                            ],
                            [
                                9.394891367480032,
                                44.269369289793808
                            ],
                            [
                                9.384610862189019,
                                44.267930123899347
                            ],
                            [
                                9.393878932401918,
                                44.275834690367809
                            ],
                            [
                                9.376938530897764,
                                44.290514947530113
                            ],
                            [
                                9.333157255653674,
                                44.311339830201291
                            ],
                            [
                                9.322161791953617,
                                44.31062750230528
                            ],
                            [
                                9.317727063477875,
                                44.311631372924822
                            ],
                            [
                                9.323964132543402,
                                44.312613180615052
                            ],
                            [
                                9.234231644106567,
                                44.348386064588347
                            ],
                            [
                                9.229752981996963,
                                44.34808793728736
                            ],
                            [
                                9.22515645515511,
                                44.341159235996699
                            ],
                            [
                                9.225785919103071,
                                44.33520032242761
                            ],
                            [
                                9.213736701483619,
                                44.333602980470204
                            ],
                            [
                                9.209003100459705,
                                44.31061713475583
                            ],
                            [
                                9.217547134666196,
                                44.29850458520071
                            ],
                            [
                                9.152255664934401,
                                44.317127092847628
                            ],
                            [
                                9.155090295028829,
                                44.347714052418986
                            ],
                            [
                                9.140383867375542,
                                44.361241892370174
                            ],
                            [
                                9.058364387668115,
                                44.380663952384765
                            ],
                            [
                                8.953509863703442,
                                44.391623903403371
                            ],
                            [
                                8.927418075436311,
                                44.401001767761777
                            ],
                            [
                                8.924010853240034,
                                44.414160827736552
                            ],
                            [
                                8.912167778247046,
                                44.41230576343311
                            ],
                            [
                                8.91647402827288,
                                44.398580516748915
                            ],
                            [
                                8.821850558845794,
                                44.4149208054951
                            ],
                            [
                                8.850591731728073,
                                44.41930297713278
                            ],
                            [
                                8.835771370131525,
                                44.423940753851113
                            ],
                            [
                                8.785080477474427,
                                44.425559619928933
                            ],
                            [
                                8.796284800762805,
                                44.417261798602162
                            ],
                            [
                                8.743551704408846,
                                44.426952776121347
                            ],
                            [
                                8.692926879862165,
                                44.408346802176894
                            ],
                            [
                                8.679749715594953,
                                44.393275935745407
                            ],
                            [
                                8.640202087952707,
                                44.386518627414894
                            ],
                            [
                                8.624349992848261,
                                44.371859367240909
                            ],
                            [
                                8.572219810690749,
                                44.35756067256753
                            ],
                            [
                                8.563039823560857,
                                44.346279079620281
                            ],
                            [
                                8.496039268952552,
                                44.320707210279267
                            ],
                            [
                                8.489368307635825,
                                44.311422570527583
                            ],
                            [
                                8.500337699785081,
                                44.316623010205753
                            ],
                            [
                                8.496877284745116,
                                44.310141462604854
                            ],
                            [
                                8.486246093527575,
                                44.30371105345607
                            ],
                            [
                                8.466546502632614,
                                44.297075604152248
                            ],
                            [
                                8.462463351820402,
                                44.295327893829196
                            ],
                            [
                                8.459269709403143,
                                44.293656275039623
                            ],
                            [
                                8.458724315718095,
                                44.293329585200958
                            ],
                            [
                                8.441263515576148,
                                44.275977798913253
                            ],
                            [
                                8.442363152826555,
                                44.265206581491107
                            ],
                            [
                                8.456329581738457,
                                44.258401232278878
                            ],
                            [
                                8.442816533530152,
                                44.237429944470051
                            ],
                            [
                                8.416132120531822,
                                44.221907059006845
                            ],
                            [
                                8.4222499169786,
                                44.192570058507904
                            ],
                            [
                                8.294675842408763,
                                44.153447313898688
                            ],
                            [
                                8.269068017245104,
                                44.139320145402387
                            ],
                            [
                                8.231434884960743,
                                44.091635137354899
                            ],
                            [
                                8.226053358242215,
                                44.044009593929552
                            ],
                            [
                                8.163118970627872,
                                43.992595563975613
                            ],
                            [
                                8.15989559893638,
                                43.97355666455919
                            ],
                            [
                                8.173492173757317,
                                43.954596628945261
                            ],
                            [
                                8.140295282656526,
                                43.946571540479297
                            ],
                            [
                                8.128289337906363,
                                43.926906969272608
                            ],
                            [
                                8.091724239871215,
                                43.915615357853952
                            ],
                            [
                                8.073017861551604,
                                43.89137051854393
                            ],
                            [
                                8.029707203303809,
                                43.884196377082674
                            ],
                            [
                                8.015014864990031,
                                43.872013756034605
                            ],
                            [
                                7.968739228504319,
                                43.859925577830325
                            ],
                            [
                                7.965612924967699,
                                43.852092319917659
                            ],
                            [
                                7.907827071980186,
                                43.837259122659326
                            ],
                            [
                                7.871747974215427,
                                43.835972208901332
                            ],
                            [
                                7.833044076265478,
                                43.816432772774185
                            ],
                            [
                                7.804634440937634,
                                43.823220477290995
                            ],
                            [
                                7.783225915313047,
                                43.818875353572395
                            ],
                            [
                                7.785303047493692,
                                43.81486382147223
                            ],
                            [
                                7.768917096528561,
                                43.813097067750526
                            ],
                            [
                                7.760725422734668,
                                43.807508980260067
                            ]
                        ],
                        [
                            [
                                9.773880193523588,
                                44.077353820083026
                            ],
                            [
                                9.774031555870122,
                                44.077528358802546
                            ],
                            [
                                9.773671243344571,
                                44.077611829025884
                            ],
                            [
                                9.773486661364172,
                                44.077403752414284
                            ],
                            [
                                9.773880193523588,
                                44.077353820083026
                            ]
                        ],
                        [
                            [
                                9.567172908608963,
                                44.192276442909076
                            ],
                            [
                                9.566830979551046,
                                44.192259571115791
                            ],
                            [
                                9.567130407882201,
                                44.192085337568081
                            ],
                            [
                                9.567172908608963,
                                44.192276442909076
                            ]
                        ],
                        [
                            [
                                9.863795788307932,
                                44.094668624877357
                            ],
                            [
                                9.863634374274168,
                                44.094629330593811
                            ],
                            [
                                9.86365855951826,
                                44.094467089156552
                            ],
                            [
                                9.863854774174792,
                                44.094521694092506
                            ],
                            [
                                9.863795788307932,
                                44.094668624877357
                            ]
                        ],
                        [
                            [
                                9.848446445112895,
                                44.109693026132909
                            ],
                            [
                                9.848496419628802,
                                44.109501336254354
                            ],
                            [
                                9.848529663361306,
                                44.109996267165855
                            ],
                            [
                                9.848446445112895,
                                44.109693026132909
                            ]
                        ],
                        [
                            [
                                8.192659864333034,
                                44.017265856315696
                            ],
                            [
                                8.1931260143076,
                                44.017219630761296
                            ],
                            [
                                8.193129471609975,
                                44.017309688973043
                            ],
                            [
                                8.192659864333034,
                                44.017265856315696
                            ]
                        ],
                        [
                            [
                                9.849240366774039,
                                44.10917844428981
                            ],
                            [
                                9.849305205905791,
                                44.109234232479601
                            ],
                            [
                                9.849365239770218,
                                44.109936038355336
                            ],
                            [
                                9.849240366774039,
                                44.10917844428981
                            ]
                        ],
                        [
                            [
                                9.84945571416621,
                                44.109545975811201
                            ],
                            [
                                9.849477802320141,
                                44.109397373454122
                            ],
                            [
                                9.84954465444312,
                                44.109921199425877
                            ],
                            [
                                9.84945571416621,
                                44.109545975811201
                            ]
                        ],
                        [
                            [
                                9.85003238980406,
                                44.109432842653874
                            ],
                            [
                                9.850037317657025,
                                44.109312067220557
                            ],
                            [
                                9.850166817423444,
                                44.109302100327575
                            ],
                            [
                                9.85018593295724,
                                44.109437006574545
                            ],
                            [
                                9.85003238980406,
                                44.109432842653874
                            ]
                        ],
                        [
                            [
                                9.848813082413843,
                                44.109663292864084
                            ],
                            [
                                9.848894453613122,
                                44.109635715450899
                            ],
                            [
                                9.848876063378649,
                                44.109971185625319
                            ],
                            [
                                9.848813082413843,
                                44.109663292864084
                            ]
                        ],
                        [
                            [
                                9.849772261889909,
                                44.109590607680701
                            ],
                            [
                                9.849759015592095,
                                44.109465232649001
                            ],
                            [
                                9.849856522931775,
                                44.109448460846082
                            ],
                            [
                                9.849867957818711,
                                44.109592427514592
                            ],
                            [
                                9.849772261889909,
                                44.109590607680701
                            ]
                        ],
                        [
                            [
                                9.848288428810445,
                                44.109784231928522
                            ],
                            [
                                9.84836183369913,
                                44.1097836868353
                            ],
                            [
                                9.848343968740361,
                                44.110008900328005
                            ],
                            [
                                9.848288428810445,
                                44.109784231928522
                            ]
                        ],
                        [
                            [
                                9.848730341590631,
                                44.109467695638195
                            ],
                            [
                                9.848764746671488,
                                44.109560114809327
                            ],
                            [
                                9.848686221539698,
                                44.109566700655563
                            ],
                            [
                                9.848659341083494,
                                44.109452859088208
                            ],
                            [
                                9.848730341590631,
                                44.109467695638195
                            ]
                        ],
                        [
                            [
                                9.841585399750528,
                                44.058370535183059
                            ],
                            [
                                9.841774477065972,
                                44.058332566236118
                            ],
                            [
                                9.841775210482453,
                                44.058384329883069
                            ],
                            [
                                9.841585399750528,
                                44.058370535183059
                            ]
                        ],
                        [
                            [
                                9.320400659396595,
                                44.314465458139864
                            ],
                            [
                                9.320472366553155,
                                44.314393233473524
                            ],
                            [
                                9.320557148320843,
                                44.314425853605925
                            ],
                            [
                                9.320400659396595,
                                44.314465458139864
                            ]
                        ],
                        [
                            [
                                9.837342558049718,
                                44.053144899084671
                            ],
                            [
                                9.837463826972503,
                                44.053113061288641
                            ],
                            [
                                9.837469332622375,
                                44.053171542520595
                            ],
                            [
                                9.837342558049718,
                                44.053144899084671
                            ]
                        ],
                        [
                            [
                                7.819584962036529,
                                43.820085066571764
                            ],
                            [
                                7.819676173630802,
                                43.820031424184499
                            ],
                            [
                                7.819585230125081,
                                43.820150345739378
                            ],
                            [
                                7.819584962036529,
                                43.820085066571764
                            ]
                        ],
                        [
                            [
                                9.64392492163409,
                                44.143940442016394
                            ],
                            [
                                9.643902261519667,
                                44.143832812315765
                            ],
                            [
                                9.643960689809459,
                                44.143888190235415
                            ],
                            [
                                9.64392492163409,
                                44.143940442016394
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.847149001323499,
                                44.033465026163967
                            ],
                            [
                                9.833139695788024,
                                44.046988652164643
                            ],
                            [
                                9.855295863552639,
                                44.051515663990976
                            ],
                            [
                                9.852081897776998,
                                44.048288354031477
                            ],
                            [
                                9.847149001323499,
                                44.033465026163967
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.85369832885884,
                                44.025682391898471
                            ],
                            [
                                9.848659766661855,
                                44.026082315502414
                            ],
                            [
                                9.847463299073276,
                                44.029138834204744
                            ],
                            [
                                9.853340716634664,
                                44.027609531970036
                            ],
                            [
                                9.85369832885884,
                                44.025682391898471
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.800456990409714,
                                44.416454709206846
                            ],
                            [
                                8.795119402012897,
                                44.41197627806099
                            ],
                            [
                                8.76973589491058,
                                44.415789580350427
                            ],
                            [
                                8.795039017547698,
                                44.412156234593034
                            ],
                            [
                                8.805652947208907,
                                44.420779419373368
                            ],
                            [
                                8.810375627535031,
                                44.422320619542162
                            ],
                            [
                                8.800456990409714,
                                44.416454709206846
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.229243511611282,
                                44.025156750915848
                            ],
                            [
                                8.22549877982881,
                                44.023462426993881
                            ],
                            [
                                8.224083657101675,
                                44.026129077008413
                            ],
                            [
                                8.225602378840369,
                                44.027005955219593
                            ],
                            [
                                8.229243511611282,
                                44.025156750915848
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.91152231890324,
                                44.397444714780285
                            ],
                            [
                                8.877863361627984,
                                44.403591948318741
                            ],
                            [
                                8.877035111712082,
                                44.404089094595371
                            ],
                            [
                                8.913010954262743,
                                44.397179104902897
                            ],
                            [
                                8.91152231890324,
                                44.397444714780285
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.863651788184091,
                                44.404495143721803
                            ],
                            [
                                8.870127512156959,
                                44.403251121039837
                            ],
                            [
                                8.868504907616083,
                                44.403405553203626
                            ],
                            [
                                8.816919185303203,
                                44.413495069163844
                            ],
                            [
                                8.863651788184091,
                                44.404495143721803
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.444884531040511,
                                44.233582203725994
                            ],
                            [
                                8.44376758256784,
                                44.233846862124395
                            ],
                            [
                                8.444186861783754,
                                44.235199361433658
                            ],
                            [
                                8.446040575784885,
                                44.234488121467798
                            ],
                            [
                                8.444884531040511,
                                44.233582203725994
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.851315034728305,
                                44.023395314243572
                            ],
                            [
                                9.850395746355384,
                                44.023569848194846
                            ],
                            [
                                9.851209609234335,
                                44.024638564194852
                            ],
                            [
                                9.85148130336828,
                                44.024332676068269
                            ],
                            [
                                9.851315034728305,
                                44.023395314243572
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.839611051857798,
                                44.104002983919699
                            ],
                            [
                                9.839835372468229,
                                44.10412738045013
                            ],
                            [
                                9.840221149336447,
                                44.103852195674634
                            ],
                            [
                                9.839985785885279,
                                44.103664858389287
                            ],
                            [
                                9.839611051857798,
                                44.104002983919699
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.233970723347928,
                                44.34784530074603
                            ],
                            [
                                9.234057069323997,
                                44.348262070066134
                            ],
                            [
                                9.234378218743649,
                                44.347780319758378
                            ],
                            [
                                9.233970723347928,
                                44.34784530074603
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.60175422899721,
                                44.172238595692143
                            ],
                            [
                                9.602562805417154,
                                44.171642376329281
                            ],
                            [
                                9.602662898724502,
                                44.171491045518962
                            ],
                            [
                                9.602080082585264,
                                44.171838489288618
                            ],
                            [
                                9.60175422899721,
                                44.172238595692143
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.833012492757391,
                                44.421695379059742
                            ],
                            [
                                8.833207871802948,
                                44.421195707274748
                            ],
                            [
                                8.833393623500095,
                                44.420513038793914
                            ],
                            [
                                8.83331402936024,
                                44.42055457760069
                            ],
                            [
                                8.833012492757391,
                                44.421695379059742
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.45937674430562,
                                44.293688292051129
                            ],
                            [
                                8.461079977263431,
                                44.292566468427772
                            ],
                            [
                                8.463123151097822,
                                44.291185131348918
                            ],
                            [
                                8.460813961787499,
                                44.292700257553385
                            ],
                            [
                                8.45937674430562,
                                44.293688292051129
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.827137915862961,
                                44.097975774640048
                            ],
                            [
                                9.830449225614728,
                                44.096068313376918
                            ],
                            [
                                9.831735876283805,
                                44.095280171480312
                            ],
                            [
                                9.827137915862961,
                                44.097975774640048
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.33622840625905,
                                44.306810226916497
                            ],
                            [
                                9.337369763601306,
                                44.308118478799024
                            ],
                            [
                                9.33631444618487,
                                44.306782964775017
                            ],
                            [
                                9.33622840625905,
                                44.306810226916497
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                7.763776772726534,
                                43.808679305599057
                            ],
                            [
                                7.763863888275855,
                                43.808599777896035
                            ],
                            [
                                7.762907206449086,
                                43.808719414991508
                            ],
                            [
                                7.763001311497772,
                                43.808753071973726
                            ],
                            [
                                7.763776772726534,
                                43.808679305599057
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.336727077726719,
                                44.306589311073488
                            ],
                            [
                                9.337854366099803,
                                44.307902663794337
                            ],
                            [
                                9.336800637735159,
                                44.306572213672688
                            ],
                            [
                                9.336727077726719,
                                44.306589311073488
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                7.788849807465414,
                                43.818095510986268
                            ],
                            [
                                7.788758432594683,
                                43.818002255147732
                            ],
                            [
                                7.788678813431485,
                                43.819018822396444
                            ],
                            [
                                7.788849807465414,
                                43.818095510986268
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                7.760725422734668,
                                43.807508980260067
                            ],
                            [
                                7.761143583656921,
                                43.807653633847536
                            ],
                            [
                                7.761245319622845,
                                43.807618722166488
                            ],
                            [
                                7.761099279608866,
                                43.807466327742738
                            ],
                            [
                                7.760725422734668,
                                43.807508980260067
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                7.78991673626786,
                                43.818217109093077
                            ],
                            [
                                7.789825314077063,
                                43.818126104516956
                            ],
                            [
                                7.789769924241654,
                                43.819021380002333
                            ],
                            [
                                7.78991673626786,
                                43.818217109093077
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                7.787398020349298,
                                43.819018743468206
                            ],
                            [
                                7.787584699678598,
                                43.817935785812196
                            ],
                            [
                                7.787497766735121,
                                43.817930361584409
                            ],
                            [
                                7.787398020349298,
                                43.819018743468206
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.830999059255291,
                                44.421935949888493
                            ],
                            [
                                8.831174288990695,
                                44.421530199319108
                            ],
                            [
                                8.831269380045459,
                                44.420980247916994
                            ],
                            [
                                8.831082029633842,
                                44.42150532779894
                            ],
                            [
                                8.830999059255291,
                                44.421935949888493
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.835114751970663,
                                44.421964825193768
                            ],
                            [
                                8.83544068587482,
                                44.420917569695845
                            ],
                            [
                                8.835218784615638,
                                44.421403337395077
                            ],
                            [
                                8.835114751970663,
                                44.421964825193768
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                7.790873026480932,
                                43.818429813885359
                            ],
                            [
                                7.790778494477095,
                                43.818338777167412
                            ],
                            [
                                7.790755452135155,
                                43.819018308090364
                            ],
                            [
                                7.790873026480932,
                                43.818429813885359
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                7.793900468206589,
                                43.819686303284527
                            ],
                            [
                                7.794038201873648,
                                43.819021487705065
                            ],
                            [
                                7.793941897164782,
                                43.819018220382851
                            ],
                            [
                                7.793900468206589,
                                43.819686303284527
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                7.791700964537102,
                                43.818533109851963
                            ],
                            [
                                7.791609539132654,
                                43.818442106671597
                            ],
                            [
                                7.791579270102263,
                                43.819018019489448
                            ],
                            [
                                7.791700964537102,
                                43.818533109851963
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                7.792432646958376,
                                43.818630880833254
                            ],
                            [
                                7.79233500420728,
                                43.818539812530254
                            ],
                            [
                                7.792319170492645,
                                43.819016838073757
                            ],
                            [
                                7.792432646958376,
                                43.818630880833254
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.828112901409462,
                                44.102182724679885
                            ],
                            [
                                9.828689940384537,
                                44.102599442117722
                            ],
                            [
                                9.828170992548184,
                                44.102133643725459
                            ],
                            [
                                9.828112901409462,
                                44.102182724679885
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.010651791810595,
                                44.384818921652581
                            ],
                            [
                                9.01070704640224,
                                44.384907684399877
                            ],
                            [
                                9.010831057101099,
                                44.384773012863143
                            ],
                            [
                                9.010500627799081,
                                44.384753867687522
                            ],
                            [
                                9.010651791810595,
                                44.384818921652581
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                7.792953528665413,
                                43.818699409674579
                            ],
                            [
                                7.79286210108784,
                                43.818608407474272
                            ],
                            [
                                7.792866280330447,
                                43.81901811721476
                            ],
                            [
                                7.792953528665413,
                                43.818699409674579
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                7.768254523454398,
                                43.812439976956249
                            ],
                            [
                                7.768313886090115,
                                43.812500828708536
                            ],
                            [
                                7.768651531417259,
                                43.812633332296066
                            ],
                            [
                                7.768603276496252,
                                43.812561345863813
                            ],
                            [
                                7.768254523454398,
                                43.812439976956249
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.829212988467395,
                                44.421774769732167
                            ],
                            [
                                8.829278500091103,
                                44.421407742726778
                            ],
                            [
                                8.829125568260411,
                                44.421824581860164
                            ],
                            [
                                8.829212988467395,
                                44.421774769732167
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                7.793530175254771,
                                43.818777528568376
                            ],
                            [
                                7.793438746674432,
                                43.818686526819242
                            ],
                            [
                                7.793450687020446,
                                43.819019787553437
                            ],
                            [
                                7.793530175254771,
                                43.818777528568376
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.686310906302335,
                                44.399610739687091
                            ],
                            [
                                8.686856998668425,
                                44.399639246552297
                            ],
                            [
                                8.686967305881613,
                                44.399558523671217
                            ],
                            [
                                8.686879525881963,
                                44.39953577605614
                            ],
                            [
                                8.686310906302335,
                                44.399610739687091
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.606365129287534,
                                44.170843484321175
                            ],
                            [
                                9.606589458474508,
                                44.17091472284325
                            ],
                            [
                                9.606500830913504,
                                44.17081125290548
                            ],
                            [
                                9.606365129287534,
                                44.170843484321175
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.936119470728855,
                                44.39573672092294
                            ],
                            [
                                8.936219086888004,
                                44.395697164211171
                            ],
                            [
                                8.936318655205811,
                                44.39563676046987
                            ],
                            [
                                8.93601813349072,
                                44.395742350380615
                            ],
                            [
                                8.936119470728855,
                                44.39573672092294
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.463084434496164,
                                44.2911354330436
                            ],
                            [
                                8.463123151097822,
                                44.291185131348918
                            ],
                            [
                                8.463175968155467,
                                44.291234895908509
                            ],
                            [
                                8.463237561838833,
                                44.291181167548451
                            ],
                            [
                                8.463084434496164,
                                44.2911354330436
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.831269380045459,
                                44.420980247916994
                            ],
                            [
                                8.83135828190197,
                                44.420976350471022
                            ],
                            [
                                8.831349329188219,
                                44.420922545682991
                            ],
                            [
                                8.831272071254892,
                                44.420912393490205
                            ],
                            [
                                8.831269380045459,
                                44.420980247916994
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.829237033461954,
                                44.421347128993247
                            ],
                            [
                                8.829278500091103,
                                44.421407742726778
                            ],
                            [
                                8.829320669626776,
                                44.421340344373824
                            ],
                            [
                                8.829237033461954,
                                44.421347128993247
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.8353954503733,
                                44.420865215507838
                            ],
                            [
                                8.83544068587482,
                                44.420917569695845
                            ],
                            [
                                8.835490929373288,
                                44.420860356525282
                            ],
                            [
                                8.8353954503733,
                                44.420865215507838
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 9,
                "name": "Emilia Romagna",
                "length": 1164723.05925,
                "area": 22451465521.900001525878906
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                12.28068194336644,
                                44.540295008697036
                            ],
                            [
                                12.292122047712203,
                                44.454274536059231
                            ],
                            [
                                12.357195604646961,
                                44.270553774870692
                            ],
                            [
                                12.392335227763338,
                                44.213069431742348
                            ],
                            [
                                12.536109689727102,
                                44.090533255935959
                            ],
                            [
                                12.561254271906737,
                                44.076251675007441
                            ],
                            [
                                12.577304189476314,
                                44.076750851777753
                            ],
                            [
                                12.632285997439183,
                                44.025083043771602
                            ],
                            [
                                12.688202019730303,
                                43.987123855588074
                            ],
                            [
                                12.755640586110705,
                                43.96195470390267
                            ],
                            [
                                12.727907574526379,
                                43.92418244508972
                            ],
                            [
                                12.734831048529248,
                                43.896024741662451
                            ],
                            [
                                12.722653226609948,
                                43.880566365046818
                            ],
                            [
                                12.73399251318051,
                                43.870258974555298
                            ],
                            [
                                12.723632258061533,
                                43.861236748791107
                            ],
                            [
                                12.682462323346757,
                                43.852860143200928
                            ],
                            [
                                12.681317055891967,
                                43.8280706626458
                            ],
                            [
                                12.673436750457082,
                                43.823883849413072
                            ],
                            [
                                12.644317762382752,
                                43.826882839041907
                            ],
                            [
                                12.628804255363107,
                                43.820949050134601
                            ],
                            [
                                12.611227563163681,
                                43.83078258160554
                            ],
                            [
                                12.618902495535307,
                                43.842627452245694
                            ],
                            [
                                12.60100073484467,
                                43.850534463877729
                            ],
                            [
                                12.602561418054508,
                                43.863434819968816
                            ],
                            [
                                12.589359658284847,
                                43.865251480784622
                            ],
                            [
                                12.589492255999758,
                                43.885644957056734
                            ],
                            [
                                12.565896339685716,
                                43.882243292924628
                            ],
                            [
                                12.562452364223283,
                                43.869816512906631
                            ],
                            [
                                12.541692218711836,
                                43.864027762553519
                            ],
                            [
                                12.530301575955587,
                                43.876788976838405
                            ],
                            [
                                12.542519379537199,
                                43.888544113624498
                            ],
                            [
                                12.535864653371823,
                                43.897222241369555
                            ],
                            [
                                12.52096062323467,
                                43.898340230049236
                            ],
                            [
                                12.49279228580685,
                                43.915933199399724
                            ],
                            [
                                12.515665502401021,
                                43.941532886163706
                            ],
                            [
                                12.506750588686167,
                                43.958201417537353
                            ],
                            [
                                12.514354394186574,
                                43.990841455352381
                            ],
                            [
                                12.469884627684813,
                                43.977718998943118
                            ],
                            [
                                12.436867351488631,
                                43.95662263516347
                            ],
                            [
                                12.40459485875008,
                                43.955697053696646
                            ],
                            [
                                12.415249491961923,
                                43.930735462508039
                            ],
                            [
                                12.408325435032873,
                                43.902979071644332
                            ],
                            [
                                12.432136253709425,
                                43.87256944120054
                            ],
                            [
                                12.400608552785606,
                                43.872774849032538
                            ],
                            [
                                12.392472732228919,
                                43.896550766610041
                            ],
                            [
                                12.386230545445327,
                                43.881984726605054
                            ],
                            [
                                12.347371686878502,
                                43.867020005228206
                            ],
                            [
                                12.335439202835426,
                                43.824118628716526
                            ],
                            [
                                12.315886826029873,
                                43.805637695629002
                            ],
                            [
                                12.284740484417588,
                                43.794682132066001
                            ],
                            [
                                12.283780910700651,
                                43.764917213250918
                            ],
                            [
                                12.255634569475518,
                                43.760366411270752
                            ],
                            [
                                12.245910236315341,
                                43.751194448771201
                            ],
                            [
                                12.228992268006891,
                                43.759554205698798
                            ],
                            [
                                12.209096375717278,
                                43.75715985498644
                            ],
                            [
                                12.19463264350763,
                                43.731924310210736
                            ],
                            [
                                12.163669509418025,
                                43.762362003336783
                            ],
                            [
                                12.125208690705092,
                                43.749290628149275
                            ],
                            [
                                12.107445566563809,
                                43.753771364744892
                            ],
                            [
                                12.07706506518217,
                                43.740657068593293
                            ],
                            [
                                12.05124747965602,
                                43.75738167633822
                            ],
                            [
                                12.006392005353048,
                                43.766521337353176
                            ],
                            [
                                11.986509681043225,
                                43.76193221121931
                            ],
                            [
                                11.952658917491874,
                                43.776575516649146
                            ],
                            [
                                11.947821086597724,
                                43.790637560706976
                            ],
                            [
                                11.918787740799681,
                                43.793688203003818
                            ],
                            [
                                11.90974390467378,
                                43.812717797999092
                            ],
                            [
                                11.896425537430206,
                                43.807780494142008
                            ],
                            [
                                11.8674113735263,
                                43.816912779624126
                            ],
                            [
                                11.841674370785908,
                                43.808021343383089
                            ],
                            [
                                11.785729205990595,
                                43.847024790102211
                            ],
                            [
                                11.732476119595093,
                                43.863166833396654
                            ],
                            [
                                11.710167844578811,
                                43.877449395173123
                            ],
                            [
                                11.717031646001049,
                                43.92181760236722
                            ],
                            [
                                11.684205196052211,
                                43.935126389898478
                            ],
                            [
                                11.690885032848302,
                                43.956855821185215
                            ],
                            [
                                11.653997334826627,
                                43.975257274277723
                            ],
                            [
                                11.645549045148224,
                                43.989849311363919
                            ],
                            [
                                11.663947074726973,
                                44.005550577314494
                            ],
                            [
                                11.656522310283449,
                                44.017481589608025
                            ],
                            [
                                11.681888758808116,
                                44.021204040016428
                            ],
                            [
                                11.694909015133506,
                                44.035339839252167
                            ],
                            [
                                11.700695239048725,
                                44.05555894807128
                            ],
                            [
                                11.748876924580607,
                                44.104141409379061
                            ],
                            [
                                11.752638796554203,
                                44.121390404844412
                            ],
                            [
                                11.744182814129863,
                                44.126068437480832
                            ],
                            [
                                11.678811143475496,
                                44.12291259312191
                            ],
                            [
                                11.652553842570256,
                                44.101157859347012
                            ],
                            [
                                11.616166466765087,
                                44.118490900767931
                            ],
                            [
                                11.584579053323734,
                                44.112209051460439
                            ],
                            [
                                11.587828469314815,
                                44.123701252122579
                            ],
                            [
                                11.616705918123539,
                                44.143380659109056
                            ],
                            [
                                11.615361168982201,
                                44.158254276958573
                            ],
                            [
                                11.573240627273954,
                                44.160645891523458
                            ],
                            [
                                11.565172898511745,
                                44.167242024966264
                            ],
                            [
                                11.552976587691671,
                                44.165741833681963
                            ],
                            [
                                11.544415740104943,
                                44.152527615368037
                            ],
                            [
                                11.503371264847154,
                                44.162297226246245
                            ],
                            [
                                11.487347911997821,
                                44.179433368725007
                            ],
                            [
                                11.447626996863677,
                                44.199485288014884
                            ],
                            [
                                11.450929110488733,
                                44.220119379619632
                            ],
                            [
                                11.421973803332131,
                                44.239896093096426
                            ],
                            [
                                11.380545119406575,
                                44.200000758414809
                            ],
                            [
                                11.342809746806592,
                                44.205818441492951
                            ],
                            [
                                11.324409757740217,
                                44.194639289008762
                            ],
                            [
                                11.316784693908152,
                                44.177297075496753
                            ],
                            [
                                11.295802797205535,
                                44.172395650134369
                            ],
                            [
                                11.280713647736968,
                                44.155339213588761
                            ],
                            [
                                11.239291312660198,
                                44.158916236951718
                            ],
                            [
                                11.195730593562176,
                                44.151414550381105
                            ],
                            [
                                11.195854688281878,
                                44.143544289211441
                            ],
                            [
                                11.218360290612788,
                                44.129403325868481
                            ],
                            [
                                11.260226116233412,
                                44.115841906968988
                            ],
                            [
                                11.263664288551116,
                                44.104261447046476
                            ],
                            [
                                11.248036187818446,
                                44.097572284457605
                            ],
                            [
                                11.209804445315205,
                                44.098865471693088
                            ],
                            [
                                11.15920237932904,
                                44.112422012491876
                            ],
                            [
                                11.127656382773898,
                                44.109678587561632
                            ],
                            [
                                11.089428913864008,
                                44.089951844164887
                            ],
                            [
                                11.049427120838986,
                                44.090246064438496
                            ],
                            [
                                11.001999154492456,
                                44.110914512152846
                            ],
                            [
                                11.014929185005531,
                                44.125214219589907
                            ],
                            [
                                11.014309063231414,
                                44.1374873199399
                            ],
                            [
                                11.00639125277079,
                                44.138833116851494
                            ],
                            [
                                10.970312039729079,
                                44.11592728782103
                            ],
                            [
                                10.955289858324276,
                                44.089374224275105
                            ],
                            [
                                10.910063366002383,
                                44.062540421061776
                            ],
                            [
                                10.899209553644321,
                                44.065935560888178
                            ],
                            [
                                10.90280223870433,
                                44.086087832203567
                            ],
                            [
                                10.878707272404331,
                                44.098619516684877
                            ],
                            [
                                10.848666114908836,
                                44.098055304994922
                            ],
                            [
                                10.830885681818625,
                                44.116582046602154
                            ],
                            [
                                10.819149060473972,
                                44.112448101288287
                            ],
                            [
                                10.77325905339813,
                                44.13466023149843
                            ],
                            [
                                10.754259880433812,
                                44.154148206321054
                            ],
                            [
                                10.661619420180202,
                                44.154015435329761
                            ],
                            [
                                10.643980722444455,
                                44.160092321600416
                            ],
                            [
                                10.623752776730962,
                                44.141205118593319
                            ],
                            [
                                10.62405584356628,
                                44.12036609318956
                            ],
                            [
                                10.59310375787225,
                                44.1154151340372
                            ],
                            [
                                10.577509033110269,
                                44.131900243427737
                            ],
                            [
                                10.525121660618026,
                                44.15623593734496
                            ],
                            [
                                10.52293872671291,
                                44.174838423343473
                            ],
                            [
                                10.485214937079133,
                                44.204496080927818
                            ],
                            [
                                10.492992224763672,
                                44.216584757882764
                            ],
                            [
                                10.484611615346331,
                                44.222825054290048
                            ],
                            [
                                10.464936679862314,
                                44.231136795457893
                            ],
                            [
                                10.430263419766188,
                                44.227434887355358
                            ],
                            [
                                10.371588780747794,
                                44.269379205051791
                            ],
                            [
                                10.342755166599387,
                                44.26963180547164
                            ],
                            [
                                10.307116001312187,
                                44.284323905154281
                            ],
                            [
                                10.253856656009726,
                                44.268580682075509
                            ],
                            [
                                10.226263430370096,
                                44.299967405332588
                            ],
                            [
                                10.189606714893856,
                                44.314309595750473
                            ],
                            [
                                10.146281029750803,
                                44.352132554507655
                            ],
                            [
                                10.09827284723468,
                                44.346293307623874
                            ],
                            [
                                10.010043151955326,
                                44.38915983298385
                            ],
                            [
                                9.989284713151555,
                                44.404331162224857
                            ],
                            [
                                10.004317491778801,
                                44.437330060745964
                            ],
                            [
                                9.996329739635286,
                                44.446888877697155
                            ],
                            [
                                9.976154162859237,
                                44.447918364393985
                            ],
                            [
                                9.970137055185571,
                                44.46459760202886
                            ],
                            [
                                9.899950485011392,
                                44.472707484664575
                            ],
                            [
                                9.819936681069365,
                                44.466422898023325
                            ],
                            [
                                9.816731668390659,
                                44.452050560094328
                            ],
                            [
                                9.75646496612894,
                                44.406173524119069
                            ],
                            [
                                9.760475158100739,
                                44.390049897624209
                            ],
                            [
                                9.743848213469473,
                                44.389484186528783
                            ],
                            [
                                9.742741332398108,
                                44.380389539286554
                            ],
                            [
                                9.716899231507504,
                                44.383174486643078
                            ],
                            [
                                9.674979436279502,
                                44.364713014739692
                            ],
                            [
                                9.655289524165635,
                                44.411660303749798
                            ],
                            [
                                9.636038292120919,
                                44.41390279216801
                            ],
                            [
                                9.601487816035803,
                                44.436758906250468
                            ],
                            [
                                9.583577426376007,
                                44.427236893334182
                            ],
                            [
                                9.559177521198757,
                                44.438135246091399
                            ],
                            [
                                9.545243715306578,
                                44.426084911612669
                            ],
                            [
                                9.493902282974265,
                                44.423896718007541
                            ],
                            [
                                9.479034341822834,
                                44.409258513875187
                            ],
                            [
                                9.472564794547921,
                                44.42428409058104
                            ],
                            [
                                9.442777862413948,
                                44.41658658335713
                            ],
                            [
                                9.439164053081955,
                                44.429071822110735
                            ],
                            [
                                9.45819850896333,
                                44.442204078918195
                            ],
                            [
                                9.468873092711787,
                                44.481880674281925
                            ],
                            [
                                9.496803423358797,
                                44.482730395911339
                            ],
                            [
                                9.504607671002939,
                                44.529959995715302
                            ],
                            [
                                9.488180531687929,
                                44.545569856471865
                            ],
                            [
                                9.491609196479025,
                                44.558167738892521
                            ],
                            [
                                9.423076555450013,
                                44.574612229879087
                            ],
                            [
                                9.421306229742347,
                                44.592604297970233
                            ],
                            [
                                9.405628916603032,
                                44.600806804790949
                            ],
                            [
                                9.381080338417561,
                                44.576749636002809
                            ],
                            [
                                9.361050715545893,
                                44.58496949716401
                            ],
                            [
                                9.343003443640802,
                                44.577697073567954
                            ],
                            [
                                9.300410235998367,
                                44.60777737134751
                            ],
                            [
                                9.288087951034843,
                                44.60786312709299
                            ],
                            [
                                9.284157303772938,
                                44.59785320876432
                            ],
                            [
                                9.272230468336877,
                                44.595915219826722
                            ],
                            [
                                9.245642309010368,
                                44.599711537770169
                            ],
                            [
                                9.256538921835649,
                                44.610594080699101
                            ],
                            [
                                9.245502620698675,
                                44.619647809760423
                            ],
                            [
                                9.202973221019381,
                                44.613494114064359
                            ],
                            [
                                9.199196124502999,
                                44.68410969658715
                            ],
                            [
                                9.237087747860702,
                                44.685117590633055
                            ],
                            [
                                9.23508364129305,
                                44.71635982270184
                            ],
                            [
                                9.25947576387515,
                                44.679946577266982
                            ],
                            [
                                9.283024605552095,
                                44.685976257497835
                            ],
                            [
                                9.298505872928311,
                                44.681021547450307
                            ],
                            [
                                9.325110584058617,
                                44.690743471523845
                            ],
                            [
                                9.308480638361692,
                                44.705634454900945
                            ],
                            [
                                9.332580786368414,
                                44.735040346381041
                            ],
                            [
                                9.286512738827948,
                                44.758679096822164
                            ],
                            [
                                9.286974935475561,
                                44.772496362125267
                            ],
                            [
                                9.316759741394808,
                                44.783949457522233
                            ],
                            [
                                9.321528075612212,
                                44.800032044344491
                            ],
                            [
                                9.354194310352804,
                                44.811863278056002
                            ],
                            [
                                9.363098231232234,
                                44.822403832364664
                            ],
                            [
                                9.348317311091384,
                                44.839769955373022
                            ],
                            [
                                9.341675176044308,
                                44.869811982696284
                            ],
                            [
                                9.290113390898167,
                                44.882206405663339
                            ],
                            [
                                9.292826208890196,
                                44.89031930768401
                            ],
                            [
                                9.277409518144502,
                                44.895608890912108
                            ],
                            [
                                9.292283150241529,
                                44.912379522567811
                            ],
                            [
                                9.28634581478472,
                                44.933950422993007
                            ],
                            [
                                9.305643011258558,
                                44.933963422730066
                            ],
                            [
                                9.321822110708263,
                                44.944100185427949
                            ],
                            [
                                9.345451163174735,
                                44.995125988005562
                            ],
                            [
                                9.365424425004363,
                                45.00267488328079
                            ],
                            [
                                9.375605526712967,
                                45.019917938580434
                            ],
                            [
                                9.370806018691669,
                                45.048142518170515
                            ],
                            [
                                9.413736805665049,
                                45.074512696728
                            ],
                            [
                                9.410760883118192,
                                45.082740709694988
                            ],
                            [
                                9.435601445181135,
                                45.08182908408962
                            ],
                            [
                                9.439006402295147,
                                45.093446262121226
                            ],
                            [
                                9.499286054767929,
                                45.103919664772931
                            ],
                            [
                                9.532026194721558,
                                45.078432019889135
                            ],
                            [
                                9.551330386884162,
                                45.092113091289661
                            ],
                            [
                                9.53721563750323,
                                45.126053702986617
                            ],
                            [
                                9.552995407816546,
                                45.130644247254892
                            ],
                            [
                                9.568583250961732,
                                45.107339286714492
                            ],
                            [
                                9.587446995679729,
                                45.099624985774128
                            ],
                            [
                                9.609058308536838,
                                45.108423454146241
                            ],
                            [
                                9.622403841530147,
                                45.133979248431679
                            ],
                            [
                                9.639564144325099,
                                45.121858224000157
                            ],
                            [
                                9.631381655539407,
                                45.088948548822778
                            ],
                            [
                                9.638989010004687,
                                45.081713863408069
                            ],
                            [
                                9.664774376080643,
                                45.081062583598154
                            ],
                            [
                                9.720247628252464,
                                45.058815929204847
                            ],
                            [
                                9.750371873947161,
                                45.079046934554704
                            ],
                            [
                                9.744837109613783,
                                45.109715988522858
                            ],
                            [
                                9.753669082158376,
                                45.113357742797398
                            ],
                            [
                                9.778962199870209,
                                45.089584056687343
                            ],
                            [
                                9.813262342652395,
                                45.078103282216738
                            ],
                            [
                                9.823758644751013,
                                45.052590595859776
                            ],
                            [
                                9.833759277238389,
                                45.061676679894532
                            ],
                            [
                                9.83835732581159,
                                45.095646208681814
                            ],
                            [
                                9.861519775557325,
                                45.093556452290798
                            ],
                            [
                                9.880650016763639,
                                45.074794959857201
                            ],
                            [
                                9.896772738252354,
                                45.080538623244976
                            ],
                            [
                                9.900628052952545,
                                45.09544213718199
                            ],
                            [
                                9.875421001492592,
                                45.121707045424614
                            ],
                            [
                                9.914733493467695,
                                45.139114176795331
                            ],
                            [
                                9.927199713816481,
                                45.127464519049127
                            ],
                            [
                                9.917407310064561,
                                45.099629392383399
                            ],
                            [
                                9.978336349983927,
                                45.133735113493927
                            ],
                            [
                                9.991107435253841,
                                45.130960493801005
                            ],
                            [
                                10.028531936020487,
                                45.096225128770875
                            ],
                            [
                                10.021649555665785,
                                45.075888988545387
                            ],
                            [
                                10.046946126287299,
                                45.059285688767446
                            ],
                            [
                                10.050223561372151,
                                45.041279032983056
                            ],
                            [
                                10.082307524720774,
                                45.046605572395116
                            ],
                            [
                                10.092881828843538,
                                45.023761806624698
                            ],
                            [
                                10.106167863721458,
                                45.022132070670025
                            ],
                            [
                                10.161003389612484,
                                45.044378782169993
                            ],
                            [
                                10.187295907570912,
                                45.028215751009675
                            ],
                            [
                                10.211067551075974,
                                45.034031821676287
                            ],
                            [
                                10.255857175910705,
                                45.017805324717095
                            ],
                            [
                                10.274466586787449,
                                44.997930107457201
                            ],
                            [
                                10.304687581734543,
                                44.999038093973056
                            ],
                            [
                                10.308900787110279,
                                44.987377475466438
                            ],
                            [
                                10.355284572416755,
                                44.966159012212174
                            ],
                            [
                                10.407991774933437,
                                44.983835586117507
                            ],
                            [
                                10.437757377495817,
                                44.942046872729463
                            ],
                            [
                                10.519849182283576,
                                44.912736575457878
                            ],
                            [
                                10.566067343180533,
                                44.908478609006707
                            ],
                            [
                                10.627882504179333,
                                44.924207274677052
                            ],
                            [
                                10.686679987062405,
                                44.986592632217942
                            ],
                            [
                                10.694740937171394,
                                44.961940099458602
                            ],
                            [
                                10.727396608935306,
                                44.992025601432836
                            ],
                            [
                                10.741680404747777,
                                44.980346524139655
                            ],
                            [
                                10.74375226535739,
                                44.949063325336006
                            ],
                            [
                                10.865397956645388,
                                44.929632609142807
                            ],
                            [
                                10.876633812485291,
                                44.917054501365534
                            ],
                            [
                                10.897999879756318,
                                44.921815941741222
                            ],
                            [
                                10.890308381975547,
                                44.91244973066307
                            ],
                            [
                                10.916687692447397,
                                44.924407375330773
                            ],
                            [
                                10.941372917784676,
                                44.921913875085053
                            ],
                            [
                                10.95059300979721,
                                44.933326640727294
                            ],
                            [
                                10.967152579054465,
                                44.934805373130068
                            ],
                            [
                                10.997473495537433,
                                44.955104568900978
                            ],
                            [
                                11.059540226739067,
                                44.948903237913456
                            ],
                            [
                                11.073474186740492,
                                44.96296567272374
                            ],
                            [
                                11.118027194515617,
                                44.954482741661039
                            ],
                            [
                                11.152436122357981,
                                44.933258032139278
                            ],
                            [
                                11.238015008511622,
                                44.9450611160851
                            ],
                            [
                                11.246208022622239,
                                44.951434890328166
                            ],
                            [
                                11.272256195152675,
                                44.938321479516269
                            ],
                            [
                                11.284352123384718,
                                44.956610839784837
                            ],
                            [
                                11.3264939342169,
                                44.962248532842743
                            ],
                            [
                                11.357155454134629,
                                44.950080507889638
                            ],
                            [
                                11.378192683300702,
                                44.957925877896791
                            ],
                            [
                                11.426314615002214,
                                44.952107713856556
                            ],
                            [
                                11.429373417643189,
                                44.929045541316881
                            ],
                            [
                                11.46960179864152,
                                44.936373064199309
                            ],
                            [
                                11.534130495930661,
                                44.936245905167596
                            ],
                            [
                                11.584686691034387,
                                44.913183617955312
                            ],
                            [
                                11.593535824961503,
                                44.89089216530342
                            ],
                            [
                                11.617372890010662,
                                44.888034513609412
                            ],
                            [
                                11.671277897074821,
                                44.914756788181272
                            ],
                            [
                                11.734072542990354,
                                44.927135323889651
                            ],
                            [
                                11.744846851539274,
                                44.934973916233005
                            ],
                            [
                                11.745630994571938,
                                44.957333807707123
                            ],
                            [
                                11.78382650099477,
                                44.96418606358948
                            ],
                            [
                                11.806467999742578,
                                44.977161305108304
                            ],
                            [
                                11.924583079782906,
                                44.974676771902551
                            ],
                            [
                                11.962678862058372,
                                44.986827707399328
                            ],
                            [
                                12.047486837982266,
                                44.976963502139043
                            ],
                            [
                                12.113134074949556,
                                44.96036655770402
                            ],
                            [
                                12.142424353332963,
                                44.927903853060521
                            ],
                            [
                                12.170675924498692,
                                44.942047376522005
                            ],
                            [
                                12.187670098417779,
                                44.926432584086278
                            ],
                            [
                                12.224971800403782,
                                44.922980712138155
                            ],
                            [
                                12.25618313864492,
                                44.942528483320885
                            ],
                            [
                                12.276164307713216,
                                44.943288696890768
                            ],
                            [
                                12.294737308010859,
                                44.927414524446867
                            ],
                            [
                                12.281872193693468,
                                44.910015547511975
                            ],
                            [
                                12.29410868968381,
                                44.860359085310201
                            ],
                            [
                                12.340533745419508,
                                44.850070066190469
                            ],
                            [
                                12.355192211706743,
                                44.815081103978343
                            ],
                            [
                                12.398107693349916,
                                44.792777476375768
                            ],
                            [
                                12.384001069007967,
                                44.78481590779375
                            ],
                            [
                                12.308545435223664,
                                44.801081551138381
                            ],
                            [
                                12.327380415047879,
                                44.802541191715875
                            ],
                            [
                                12.33974792814676,
                                44.81745709609315
                            ],
                            [
                                12.308601314681228,
                                44.842309579680141
                            ],
                            [
                                12.287534943129888,
                                44.842225684144523
                            ],
                            [
                                12.258928438675728,
                                44.815625755652185
                            ],
                            [
                                12.281113838676379,
                                44.823685783435145
                            ],
                            [
                                12.286070542427369,
                                44.817216315346606
                            ],
                            [
                                12.248307321824209,
                                44.762765010526742
                            ],
                            [
                                12.240177819296477,
                                44.69176335623964
                            ],
                            [
                                12.276746961971496,
                                44.614333215420523
                            ],
                            [
                                12.28068194336644,
                                44.540295008697036
                            ]
                        ],
                        [
                            [
                                12.224223624984241,
                                43.809852701380599
                            ],
                            [
                                12.217275215204966,
                                43.802751303584607
                            ],
                            [
                                12.170924395833181,
                                43.807743558867706
                            ],
                            [
                                12.186139619963409,
                                43.774130075310616
                            ],
                            [
                                12.199347755356278,
                                43.770375528127317
                            ],
                            [
                                12.212909855275019,
                                43.782054088128824
                            ],
                            [
                                12.237350089493326,
                                43.786991032535703
                            ],
                            [
                                12.23800377425386,
                                43.800398416015824
                            ],
                            [
                                12.224223624984241,
                                43.809852701380599
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.290948156751183,
                                44.70091326155729
                            ],
                            [
                                9.291299261764419,
                                44.70558942715008
                            ],
                            [
                                9.302574935794487,
                                44.703260165727563
                            ],
                            [
                                9.292202716861489,
                                44.70114428030422
                            ],
                            [
                                9.290948156751183,
                                44.70091326155729
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.300224284454561,
                                44.692467352934976
                            ],
                            [
                                9.298939783243323,
                                44.693722825794588
                            ],
                            [
                                9.304203015749426,
                                44.696555190132216
                            ],
                            [
                                9.304121761021587,
                                44.693698294547318
                            ],
                            [
                                9.300224284454561,
                                44.692467352934976
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.480802704698529,
                                44.189491283913227
                            ],
                            [
                                10.480644487566794,
                                44.19016856291482
                            ],
                            [
                                10.481801595666333,
                                44.190405642817971
                            ],
                            [
                                10.481686645020631,
                                44.189812929296956
                            ],
                            [
                                10.480802704698529,
                                44.189491283913227
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.280786554563871,
                                44.540252495525202
                            ],
                            [
                                12.28109496270269,
                                44.540309750269124
                            ],
                            [
                                12.281570039792264,
                                44.540309697882847
                            ],
                            [
                                12.281292103681734,
                                44.540258221647171
                            ],
                            [
                                12.280786554563871,
                                44.540252495525202
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.281570039792264,
                                44.540309697882847
                            ],
                            [
                                12.281964117837589,
                                44.540355609764006
                            ],
                            [
                                12.282028264398404,
                                44.540325791483653
                            ],
                            [
                                12.281827817481288,
                                44.540287930563316
                            ],
                            [
                                12.281570039792264,
                                44.540309697882847
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.343950795870855,
                                44.318228571515988
                            ],
                            [
                                12.344037811514715,
                                44.318187432679345
                            ],
                            [
                                12.344029823773662,
                                44.318125859726628
                            ],
                            [
                                12.343817641282946,
                                44.318259633726264
                            ],
                            [
                                12.343950795870855,
                                44.318228571515988
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 10,
                "name": "Toscana",
                "length": 1316658.00191,
                "area": 22984426772.0
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                10.166200439747133,
                                43.957296398522622
                            ],
                            [
                                10.081490109223219,
                                44.018380399161622
                            ],
                            [
                                10.01876816670061,
                                44.044466488865929
                            ],
                            [
                                10.070910485453286,
                                44.09308137418941
                            ],
                            [
                                10.058151982882865,
                                44.10805109291131
                            ],
                            [
                                10.018226983239536,
                                44.119337085021186
                            ],
                            [
                                9.993322031521918,
                                44.09267570979474
                            ],
                            [
                                9.983451599897865,
                                44.098878076797526
                            ],
                            [
                                9.995353691670665,
                                44.117893338523608
                            ],
                            [
                                9.976347892366881,
                                44.139547981038703
                            ],
                            [
                                9.974028983798201,
                                44.166928368961734
                            ],
                            [
                                9.892953057984908,
                                44.166501534147031
                            ],
                            [
                                9.933974533197619,
                                44.196606007482849
                            ],
                            [
                                9.914508935720125,
                                44.199602010990979
                            ],
                            [
                                9.907851058904271,
                                44.210040174695344
                            ],
                            [
                                9.89120876954739,
                                44.207812424133529
                            ],
                            [
                                9.86493896915754,
                                44.18071628085189
                            ],
                            [
                                9.857550406506581,
                                44.193507565157333
                            ],
                            [
                                9.875356726370953,
                                44.223942455084973
                            ],
                            [
                                9.85702737418063,
                                44.234029815769674
                            ],
                            [
                                9.85265694113891,
                                44.270205118512855
                            ],
                            [
                                9.814784140314043,
                                44.286214250629008
                            ],
                            [
                                9.805714966817984,
                                44.282803438731605
                            ],
                            [
                                9.765416139464445,
                                44.304327562139342
                            ],
                            [
                                9.753105861627896,
                                44.322730340910823
                            ],
                            [
                                9.729455177968477,
                                44.328330589000394
                            ],
                            [
                                9.711149295211829,
                                44.363575249426809
                            ],
                            [
                                9.686700441475084,
                                44.36593956038044
                            ],
                            [
                                9.716899231507504,
                                44.383174486643078
                            ],
                            [
                                9.742741332398108,
                                44.380389539286554
                            ],
                            [
                                9.743848213469473,
                                44.389484186528783
                            ],
                            [
                                9.760475158100739,
                                44.390049897624209
                            ],
                            [
                                9.75646496612894,
                                44.406173524119069
                            ],
                            [
                                9.816731668390659,
                                44.452050560094328
                            ],
                            [
                                9.819936681069365,
                                44.466422898023325
                            ],
                            [
                                9.899950485011392,
                                44.472707484664575
                            ],
                            [
                                9.970712715627027,
                                44.464439663241812
                            ],
                            [
                                9.976154162859237,
                                44.447918364393985
                            ],
                            [
                                9.996329739635286,
                                44.446888877697155
                            ],
                            [
                                10.004317491778801,
                                44.437330060745964
                            ],
                            [
                                9.989284713151555,
                                44.404331162224857
                            ],
                            [
                                10.010043151955326,
                                44.38915983298385
                            ],
                            [
                                10.09827284723468,
                                44.346293307623874
                            ],
                            [
                                10.146281029750803,
                                44.352132554507655
                            ],
                            [
                                10.189606714893856,
                                44.314309595750473
                            ],
                            [
                                10.226263430370096,
                                44.299967405332588
                            ],
                            [
                                10.253856656009726,
                                44.268580682075509
                            ],
                            [
                                10.307116001312187,
                                44.284323905154281
                            ],
                            [
                                10.342755166599387,
                                44.26963180547164
                            ],
                            [
                                10.371588780747794,
                                44.269379205051791
                            ],
                            [
                                10.430263419766188,
                                44.227434887355358
                            ],
                            [
                                10.464936679862314,
                                44.231136795457893
                            ],
                            [
                                10.484611615346331,
                                44.222825054290048
                            ],
                            [
                                10.492992224763672,
                                44.216584757882764
                            ],
                            [
                                10.485214937079133,
                                44.204496080927818
                            ],
                            [
                                10.52293872671291,
                                44.174838423343473
                            ],
                            [
                                10.525121660618026,
                                44.15623593734496
                            ],
                            [
                                10.577509033110269,
                                44.131900243427737
                            ],
                            [
                                10.592534195138253,
                                44.115612142869111
                            ],
                            [
                                10.62405584356628,
                                44.12036609318956
                            ],
                            [
                                10.623752776730962,
                                44.141205118593319
                            ],
                            [
                                10.64120970487035,
                                44.159835075959435
                            ],
                            [
                                10.661619420180202,
                                44.154015435329761
                            ],
                            [
                                10.743933567412402,
                                44.156237676670266
                            ],
                            [
                                10.804110286980864,
                                44.118619699637783
                            ],
                            [
                                10.819149060473972,
                                44.112448101288287
                            ],
                            [
                                10.830885681818625,
                                44.116582046602154
                            ],
                            [
                                10.848666114908836,
                                44.098055304994922
                            ],
                            [
                                10.878707272404331,
                                44.098619516684877
                            ],
                            [
                                10.90280223870433,
                                44.086087832203567
                            ],
                            [
                                10.904729802582096,
                                44.063250719154226
                            ],
                            [
                                10.918250412722779,
                                44.063010921774598
                            ],
                            [
                                10.927549114579797,
                                44.075989966491179
                            ],
                            [
                                10.955289858324276,
                                44.089374224275105
                            ],
                            [
                                10.970312039729079,
                                44.11592728782103
                            ],
                            [
                                11.00639125277079,
                                44.138833116851494
                            ],
                            [
                                11.014309063231414,
                                44.1374873199399
                            ],
                            [
                                11.014929185005531,
                                44.125214219589907
                            ],
                            [
                                11.001999154492456,
                                44.110914512152846
                            ],
                            [
                                11.049427120838986,
                                44.090246064438496
                            ],
                            [
                                11.089428913864008,
                                44.089951844164887
                            ],
                            [
                                11.127656382773898,
                                44.109678587561632
                            ],
                            [
                                11.15920237932904,
                                44.112422012491876
                            ],
                            [
                                11.209804445315205,
                                44.098865471693088
                            ],
                            [
                                11.248036187818446,
                                44.097572284457605
                            ],
                            [
                                11.263664288551116,
                                44.104261447046476
                            ],
                            [
                                11.260226116233412,
                                44.115841906968988
                            ],
                            [
                                11.218360290612788,
                                44.129403325868481
                            ],
                            [
                                11.195854688281878,
                                44.143544289211441
                            ],
                            [
                                11.195730593562176,
                                44.151414550381105
                            ],
                            [
                                11.239291312660198,
                                44.158916236951718
                            ],
                            [
                                11.280713647736968,
                                44.155339213588761
                            ],
                            [
                                11.295802797205535,
                                44.172395650134369
                            ],
                            [
                                11.316784693908152,
                                44.177297075496753
                            ],
                            [
                                11.324409757740217,
                                44.194639289008762
                            ],
                            [
                                11.342809746806592,
                                44.205818441492951
                            ],
                            [
                                11.380545119406575,
                                44.200000758414809
                            ],
                            [
                                11.421973803332131,
                                44.239896093096426
                            ],
                            [
                                11.450929110488733,
                                44.220119379619632
                            ],
                            [
                                11.447626996863677,
                                44.199485288014884
                            ],
                            [
                                11.487347911997821,
                                44.179433368725007
                            ],
                            [
                                11.503371264847154,
                                44.162297226246245
                            ],
                            [
                                11.544415740104943,
                                44.152527615368037
                            ],
                            [
                                11.552976587691671,
                                44.165741833681963
                            ],
                            [
                                11.565172898511745,
                                44.167242024966264
                            ],
                            [
                                11.573240627273954,
                                44.160645891523458
                            ],
                            [
                                11.615361168982201,
                                44.158254276958573
                            ],
                            [
                                11.616705918123539,
                                44.143380659109056
                            ],
                            [
                                11.587828469314815,
                                44.123701252122579
                            ],
                            [
                                11.584579053323734,
                                44.112209051460439
                            ],
                            [
                                11.616166466765087,
                                44.118490900767931
                            ],
                            [
                                11.652553842570256,
                                44.101157859347012
                            ],
                            [
                                11.678811143475496,
                                44.12291259312191
                            ],
                            [
                                11.744182814129863,
                                44.126068437480832
                            ],
                            [
                                11.752638796554203,
                                44.121390404844412
                            ],
                            [
                                11.748876924580607,
                                44.104141409379061
                            ],
                            [
                                11.700695239048725,
                                44.05555894807128
                            ],
                            [
                                11.694909015133506,
                                44.035339839252167
                            ],
                            [
                                11.681888758808116,
                                44.021204040016428
                            ],
                            [
                                11.656522310283449,
                                44.017481589608025
                            ],
                            [
                                11.663947074726973,
                                44.005550577314494
                            ],
                            [
                                11.645549045148224,
                                43.989849311363919
                            ],
                            [
                                11.653997334826627,
                                43.975257274277723
                            ],
                            [
                                11.690885032848302,
                                43.956855821185215
                            ],
                            [
                                11.684205196052211,
                                43.935126389898478
                            ],
                            [
                                11.717031646001049,
                                43.92181760236722
                            ],
                            [
                                11.710167844578811,
                                43.877449395173123
                            ],
                            [
                                11.732025667206512,
                                43.863384682090832
                            ],
                            [
                                11.785729205990595,
                                43.847024790102211
                            ],
                            [
                                11.841674370785908,
                                43.808021343383089
                            ],
                            [
                                11.8674113735263,
                                43.816912779624126
                            ],
                            [
                                11.896425537430206,
                                43.807780494142008
                            ],
                            [
                                11.90974390467378,
                                43.812717797999092
                            ],
                            [
                                11.918787740799681,
                                43.793688203003818
                            ],
                            [
                                11.947821086597724,
                                43.790637560706976
                            ],
                            [
                                11.953380466504436,
                                43.776088692571115
                            ],
                            [
                                11.986509681043225,
                                43.76193221121931
                            ],
                            [
                                12.006392005353048,
                                43.766521337353176
                            ],
                            [
                                12.053002571328019,
                                43.756965627086089
                            ],
                            [
                                12.070542913077514,
                                43.740730603173517
                            ],
                            [
                                12.107445566563809,
                                43.753771364744892
                            ],
                            [
                                12.141887999823735,
                                43.752573732719824
                            ],
                            [
                                12.163669509418025,
                                43.762362003336783
                            ],
                            [
                                12.19463264350763,
                                43.731924310210736
                            ],
                            [
                                12.209096375717278,
                                43.75715985498644
                            ],
                            [
                                12.228992268006891,
                                43.759554205698798
                            ],
                            [
                                12.245910236315341,
                                43.751194448771201
                            ],
                            [
                                12.255634569475518,
                                43.760366411270752
                            ],
                            [
                                12.283780910700651,
                                43.764917213250918
                            ],
                            [
                                12.327074383755507,
                                43.751009828979882
                            ],
                            [
                                12.368486877518313,
                                43.714854197405892
                            ],
                            [
                                12.369479848949338,
                                43.706555475023293
                            ],
                            [
                                12.357324778507424,
                                43.702024819716506
                            ],
                            [
                                12.345107923956858,
                                43.709977603719295
                            ],
                            [
                                12.330488887671194,
                                43.707965117497707
                            ],
                            [
                                12.330831931836206,
                                43.673621340951073
                            ],
                            [
                                12.315718919501776,
                                43.677919100254172
                            ],
                            [
                                12.321368300284158,
                                43.693398012555939
                            ],
                            [
                                12.30831884433684,
                                43.730176823869762
                            ],
                            [
                                12.297210780827168,
                                43.685950258412099
                            ],
                            [
                                12.273479370331037,
                                43.675964231170802
                            ],
                            [
                                12.245070686471612,
                                43.68147632908677
                            ],
                            [
                                12.249481461515092,
                                43.668933885129327
                            ],
                            [
                                12.232649989589405,
                                43.655601479778838
                            ],
                            [
                                12.186277947941008,
                                43.642507593502359
                            ],
                            [
                                12.21381207600567,
                                43.610872757962596
                            ],
                            [
                                12.162662176773573,
                                43.561366644835154
                            ],
                            [
                                12.153237643349323,
                                43.528712785721488
                            ],
                            [
                                12.142098753684131,
                                43.535767851691709
                            ],
                            [
                                12.10272768512055,
                                43.529932856382793
                            ],
                            [
                                12.090892289105229,
                                43.511229937936662
                            ],
                            [
                                12.095094808585102,
                                43.499164722591487
                            ],
                            [
                                12.14482251113866,
                                43.479596351603519
                            ],
                            [
                                12.143244277432039,
                                43.470292551275797
                            ],
                            [
                                12.104025510288784,
                                43.460449486837263
                            ],
                            [
                                12.08136093631648,
                                43.434046204133189
                            ],
                            [
                                12.05687865006162,
                                43.438254561692453
                            ],
                            [
                                12.02521045029072,
                                43.415573884620457
                            ],
                            [
                                12.03293599733845,
                                43.400224909929371
                            ],
                            [
                                12.077306099695651,
                                43.402144459232858
                            ],
                            [
                                12.076994472577955,
                                43.365833024732027
                            ],
                            [
                                12.102570269585049,
                                43.3724507396078
                            ],
                            [
                                12.124881595234504,
                                43.357926455572482
                            ],
                            [
                                12.135447254690764,
                                43.341728754695716
                            ],
                            [
                                12.12583496951104,
                                43.306781907179243
                            ],
                            [
                                12.132523230103809,
                                43.29306969818164
                            ],
                            [
                                12.177042433351001,
                                43.281781858355465
                            ],
                            [
                                12.193820229174301,
                                43.313073952200448
                            ],
                            [
                                12.223888168943731,
                                43.295796334339535
                            ],
                            [
                                12.148583099876161,
                                43.254617117027607
                            ],
                            [
                                12.121054934820602,
                                43.254953503410157
                            ],
                            [
                                12.092365093273102,
                                43.235908076832501
                            ],
                            [
                                12.04891334638546,
                                43.253098926319787
                            ],
                            [
                                12.033962219742188,
                                43.24670229279144
                            ],
                            [
                                12.039652851202002,
                                43.228993555993426
                            ],
                            [
                                12.024072283456022,
                                43.188160034977663
                            ],
                            [
                                11.987477160346939,
                                43.180518521000884
                            ],
                            [
                                11.9249819219116,
                                43.149253380848307
                            ],
                            [
                                11.912351762695559,
                                43.128402400535236
                            ],
                            [
                                11.930931745319677,
                                43.092395762874531
                            ],
                            [
                                11.923639985793953,
                                43.074665411302291
                            ],
                            [
                                11.940070322627665,
                                43.053282559810036
                            ],
                            [
                                11.956587915405999,
                                43.068676841407175
                            ],
                            [
                                11.973120207416111,
                                43.063638052435586
                            ],
                            [
                                11.982401600577248,
                                43.050948179434457
                            ],
                            [
                                11.949514926064873,
                                42.976528036628814
                            ],
                            [
                                11.952082688263133,
                                42.949699769977649
                            ],
                            [
                                11.932720525452618,
                                42.908499174893322
                            ],
                            [
                                11.958812275190994,
                                42.891646485404657
                            ],
                            [
                                11.958655309705305,
                                42.871057729765475
                            ],
                            [
                                11.929018720161871,
                                42.869290187775711
                            ],
                            [
                                11.913217357031854,
                                42.850554933190168
                            ],
                            [
                                11.891887296945505,
                                42.842879619450912
                            ],
                            [
                                11.894593438747902,
                                42.8342862770049
                            ],
                            [
                                11.850593080832631,
                                42.83868318201403
                            ],
                            [
                                11.814572124869532,
                                42.823352508082095
                            ],
                            [
                                11.806848334222646,
                                42.794853987397119
                            ],
                            [
                                11.775874033440003,
                                42.820673628838222
                            ],
                            [
                                11.753347917643099,
                                42.802236417538751
                            ],
                            [
                                11.746017668716586,
                                42.78575944079337
                            ],
                            [
                                11.764393467500289,
                                42.777914508554616
                            ],
                            [
                                11.779418825851096,
                                42.758017432159136
                            ],
                            [
                                11.818658353630047,
                                42.745771938909023
                            ],
                            [
                                11.801555696177132,
                                42.7071915763348
                            ],
                            [
                                11.781143062761007,
                                42.705325718987268
                            ],
                            [
                                11.784511639450644,
                                42.671321100412719
                            ],
                            [
                                11.800890111911675,
                                42.668420426564005
                            ],
                            [
                                11.809282467302566,
                                42.652951882119247
                            ],
                            [
                                11.804776027697709,
                                42.64399917177041
                            ],
                            [
                                11.780886172951316,
                                42.634682910170618
                            ],
                            [
                                11.749754250636975,
                                42.639649909069263
                            ],
                            [
                                11.751830312301424,
                                42.625595428256183
                            ],
                            [
                                11.735971733607233,
                                42.606662595353718
                            ],
                            [
                                11.711111250303039,
                                42.610905449607863
                            ],
                            [
                                11.680049976582174,
                                42.595313331208757
                            ],
                            [
                                11.681458599787534,
                                42.581325123609815
                            ],
                            [
                                11.657167895867008,
                                42.577161624655325
                            ],
                            [
                                11.643368700721002,
                                42.566346518438721
                            ],
                            [
                                11.626107332592746,
                                42.56942940912225
                            ],
                            [
                                11.616191552563274,
                                42.559874827336785
                            ],
                            [
                                11.598715528009487,
                                42.569658131805475
                            ],
                            [
                                11.578557197220636,
                                42.566210972922889
                            ],
                            [
                                11.584350637919982,
                                42.542754614626659
                            ],
                            [
                                11.568825221818246,
                                42.533826579195107
                            ],
                            [
                                11.561235650327296,
                                42.517292341513205
                            ],
                            [
                                11.616316817688364,
                                42.488390728656029
                            ],
                            [
                                11.617707438481915,
                                42.436039468220486
                            ],
                            [
                                11.54423707092544,
                                42.442155666485235
                            ],
                            [
                                11.516575084969478,
                                42.433556009078053
                            ],
                            [
                                11.488888400706507,
                                42.439370356010123
                            ],
                            [
                                11.482090598777599,
                                42.419891140983694
                            ],
                            [
                                11.449780199918559,
                                42.394039290728109
                            ],
                            [
                                11.449851985149687,
                                42.377540181377384
                            ],
                            [
                                11.361871322402996,
                                42.399068528666874
                            ],
                            [
                                11.282866965638297,
                                42.406786702053118
                            ],
                            [
                                11.272947429085768,
                                42.418618747022961
                            ],
                            [
                                11.242479833029039,
                                42.418329839629578
                            ],
                            [
                                11.2100511674395,
                                42.408743396256831
                            ],
                            [
                                11.205054046300829,
                                42.39297225265971
                            ],
                            [
                                11.213248550977966,
                                42.388482692902279
                            ],
                            [
                                11.192340647549722,
                                42.379897251382879
                            ],
                            [
                                11.189956719788087,
                                42.363643073165427
                            ],
                            [
                                11.165707843077467,
                                42.368003242663676
                            ],
                            [
                                11.153163020027391,
                                42.361071314531138
                            ],
                            [
                                11.142191172506093,
                                42.377477687529037
                            ],
                            [
                                11.098068258377101,
                                42.393252006308479
                            ],
                            [
                                11.089727823716123,
                                42.425814828776026
                            ],
                            [
                                11.104905775523161,
                                42.44757310385711
                            ],
                            [
                                11.123305277874826,
                                42.434502300900057
                            ],
                            [
                                11.132114803138254,
                                42.439037240901648
                            ],
                            [
                                11.160095906746054,
                                42.434348161029831
                            ],
                            [
                                11.173990074604351,
                                42.446003897491543
                            ],
                            [
                                11.192209619184917,
                                42.500674338978456
                            ],
                            [
                                11.177947047946072,
                                42.539747554677348
                            ],
                            [
                                11.15668470097803,
                                42.562797882599561
                            ],
                            [
                                11.128755540494533,
                                42.554132864366196
                            ],
                            [
                                11.102170494475644,
                                42.601576788369215
                            ],
                            [
                                11.082301424260088,
                                42.613457341377782
                            ],
                            [
                                11.085326040199535,
                                42.62681992037993
                            ],
                            [
                                11.009977667001554,
                                42.659182958368262
                            ],
                            [
                                10.982677720971244,
                                42.713098294782888
                            ],
                            [
                                10.954067406987836,
                                42.735451606208329
                            ],
                            [
                                10.871569567403718,
                                42.763761277762796
                            ],
                            [
                                10.784595651486805,
                                42.775658950327106
                            ],
                            [
                                10.734440309317952,
                                42.801330941492743
                            ],
                            [
                                10.759440038053285,
                                42.809454654625263
                            ],
                            [
                                10.773100729864144,
                                42.832006176486267
                            ],
                            [
                                10.769426795035455,
                                42.869494241803672
                            ],
                            [
                                10.786632131776955,
                                42.888227253239549
                            ],
                            [
                                10.77276636012334,
                                42.909908184206138
                            ],
                            [
                                10.71229050596844,
                                42.940009153474385
                            ],
                            [
                                10.660570718106387,
                                42.951811233793741
                            ],
                            [
                                10.561914799911339,
                                42.951151655298695
                            ],
                            [
                                10.546579393901469,
                                42.946013293465825
                            ],
                            [
                                10.54515184203769,
                                42.92164961321911
                            ],
                            [
                                10.535939816388558,
                                42.920004147696638
                            ],
                            [
                                10.499061031199927,
                                42.935954537245422
                            ],
                            [
                                10.483003142514544,
                                42.988391910299491
                            ],
                            [
                                10.494266216235529,
                                42.994080510086128
                            ],
                            [
                                10.507137028054055,
                                42.990674489947253
                            ],
                            [
                                10.516062146704583,
                                42.999084138243575
                            ],
                            [
                                10.510757514941865,
                                43.012152702516914
                            ],
                            [
                                10.522120783379961,
                                43.02074573844282
                            ],
                            [
                                10.537668917255209,
                                43.093421910741966
                            ],
                            [
                                10.528791748565755,
                                43.231769723333784
                            ],
                            [
                                10.50151596511019,
                                43.290842079116167
                            ],
                            [
                                10.459839218234697,
                                43.321345937863988
                            ],
                            [
                                10.448940717751459,
                                43.354179207168677
                            ],
                            [
                                10.446364602805225,
                                43.355337357279794
                            ],
                            [
                                10.444306123259427,
                                43.353481479943852
                            ],
                            [
                                10.427491353436222,
                                43.355244503326198
                            ],
                            [
                                10.444312482976935,
                                43.354399837166923
                            ],
                            [
                                10.424991216332646,
                                43.398378196340204
                            ],
                            [
                                10.404104050095814,
                                43.401729556707586
                            ],
                            [
                                10.38120616937543,
                                43.450095447569268
                            ],
                            [
                                10.330446315786425,
                                43.473835402177194
                            ],
                            [
                                10.318925038600543,
                                43.51031160354465
                            ],
                            [
                                10.295578797824669,
                                43.541365850123164
                            ],
                            [
                                10.304192706792708,
                                43.548945675912151
                            ],
                            [
                                10.294121918829331,
                                43.552409342577576
                            ],
                            [
                                10.316353171890478,
                                43.573601499090401
                            ],
                            [
                                10.319925085100667,
                                43.58432907002036
                            ],
                            [
                                10.31125997496116,
                                43.571454016283319
                            ],
                            [
                                10.303593101822967,
                                43.578232836462085
                            ],
                            [
                                10.305103622250176,
                                43.566518820388943
                            ],
                            [
                                10.296644361067344,
                                43.562283308653683
                            ],
                            [
                                10.300662679471175,
                                43.575237920665735
                            ],
                            [
                                10.272559426120342,
                                43.671896151002059
                            ],
                            [
                                10.282767274698358,
                                43.690915185053925
                            ],
                            [
                                10.259316975595832,
                                43.815657056416121
                            ],
                            [
                                10.2368657270823,
                                43.874889332537116
                            ],
                            [
                                10.166200439747133,
                                43.957296398522622
                            ]
                        ],
                        [
                            [
                                10.481801595666333,
                                44.190405642817971
                            ],
                            [
                                10.480644487566794,
                                44.19016856291482
                            ],
                            [
                                10.480414938528,
                                44.189496310703781
                            ],
                            [
                                10.481686645020631,
                                44.189812929296956
                            ],
                            [
                                10.481801595666333,
                                44.190405642817971
                            ]
                        ],
                        [
                            [
                                10.543013704094028,
                                42.931709907982722
                            ],
                            [
                                10.54359706743074,
                                42.931760573152701
                            ],
                            [
                                10.543610667167325,
                                42.931814419026189
                            ],
                            [
                                10.543315978690121,
                                42.931791378616403
                            ],
                            [
                                10.543013704094028,
                                42.931709907982722
                            ]
                        ],
                        [
                            [
                                11.135662452955373,
                                42.557502794919472
                            ],
                            [
                                11.136245084180109,
                                42.55748742686395
                            ],
                            [
                                11.136262143175705,
                                42.557541139713415
                            ],
                            [
                                11.136130975715931,
                                42.557534580958382
                            ],
                            [
                                11.135662452955373,
                                42.557502794919472
                            ]
                        ],
                        [
                            [
                                11.136008447806832,
                                42.557915083282474
                            ],
                            [
                                11.136591082709533,
                                42.55789971338416
                            ],
                            [
                                11.136611185410176,
                                42.557953369397794
                            ],
                            [
                                11.136480017064258,
                                42.557946811063019
                            ],
                            [
                                11.136008447806832,
                                42.557915083282474
                            ]
                        ],
                        [
                            [
                                11.135948549813484,
                                42.557096729744018
                            ],
                            [
                                11.135807485963973,
                                42.557067842240748
                            ],
                            [
                                11.136105200049835,
                                42.557091556989405
                            ],
                            [
                                11.135948549813484,
                                42.557096729744018
                            ]
                        ],
                        [
                            [
                                11.135365427745651,
                                42.557499327819393
                            ],
                            [
                                11.135501607095696,
                                42.557474275905562
                            ],
                            [
                                11.135662452955373,
                                42.557502794919472
                            ],
                            [
                                11.135365427745651,
                                42.557499327819393
                            ]
                        ],
                        [
                            [
                                11.13571294229815,
                                42.557911588750081
                            ],
                            [
                                11.135850644023575,
                                42.557886508032141
                            ],
                            [
                                11.136008447806832,
                                42.557915083282474
                            ],
                            [
                                11.13571294229815,
                                42.557911588750081
                            ]
                        ],
                        [
                            [
                                11.207558097793386,
                                42.391366112007326
                            ],
                            [
                                11.207631993335418,
                                42.391329792607927
                            ],
                            [
                                11.207622781057101,
                                42.391391881920917
                            ],
                            [
                                11.207558097793386,
                                42.391366112007326
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.417692324966152,
                                42.867364998332263
                            ],
                            [
                                10.443878993629069,
                                42.846794389572494
                            ],
                            [
                                10.428616501924182,
                                42.816310122155322
                            ],
                            [
                                10.434516411488403,
                                42.776528287012077
                            ],
                            [
                                10.385710714720485,
                                42.759348655111246
                            ],
                            [
                                10.401618956677023,
                                42.757448545354762
                            ],
                            [
                                10.411015069239122,
                                42.743791585982954
                            ],
                            [
                                10.432765259095575,
                                42.734894517533988
                            ],
                            [
                                10.434878442750044,
                                42.718197145116974
                            ],
                            [
                                10.422040120446006,
                                42.707643304505261
                            ],
                            [
                                10.411159452850624,
                                42.716353148294949
                            ],
                            [
                                10.382723296775216,
                                42.714982283001653
                            ],
                            [
                                10.358152242283468,
                                42.758334825993906
                            ],
                            [
                                10.344611124778137,
                                42.763949536532898
                            ],
                            [
                                10.318177000659336,
                                42.759974929497076
                            ],
                            [
                                10.325762161215771,
                                42.744024671801853
                            ],
                            [
                                10.319510996792898,
                                42.736019180850597
                            ],
                            [
                                10.309835959337242,
                                42.759235414984225
                            ],
                            [
                                10.29317723734081,
                                42.755178805021892
                            ],
                            [
                                10.283022840802289,
                                42.734907427515367
                            ],
                            [
                                10.24103608231103,
                                42.749733533435055
                            ],
                            [
                                10.23678935289826,
                                42.726037109797694
                            ],
                            [
                                10.188139560743908,
                                42.736248633158105
                            ],
                            [
                                10.156898834161645,
                                42.728817202226196
                            ],
                            [
                                10.1401326789157,
                                42.73291166085572
                            ],
                            [
                                10.105555731852018,
                                42.762607898320894
                            ],
                            [
                                10.105268145149564,
                                42.789905547038998
                            ],
                            [
                                10.139917424626017,
                                42.809305221181972
                            ],
                            [
                                10.170470031149208,
                                42.806088288854617
                            ],
                            [
                                10.185973266135022,
                                42.812259383308536
                            ],
                            [
                                10.206042195474069,
                                42.807096900969064
                            ],
                            [
                                10.219829056919824,
                                42.79295680634587
                            ],
                            [
                                10.244617283849339,
                                42.788241475214107
                            ],
                            [
                                10.247571574103302,
                                42.798972757923394
                            ],
                            [
                                10.269405613478106,
                                42.803455969644887
                            ],
                            [
                                10.275318130293391,
                                42.81846486929966
                            ],
                            [
                                10.260315661492374,
                                42.827224145314659
                            ],
                            [
                                10.2631450611331,
                                42.830090359579899
                            ],
                            [
                                10.295397258459397,
                                42.818741476315296
                            ],
                            [
                                10.332964406344251,
                                42.81738047007957
                            ],
                            [
                                10.315034320157647,
                                42.809550749980247
                            ],
                            [
                                10.317373223363735,
                                42.804643078207768
                            ],
                            [
                                10.341045620531972,
                                42.796522520775028
                            ],
                            [
                                10.357425327606505,
                                42.799330456100023
                            ],
                            [
                                10.359430533332896,
                                42.817046753238792
                            ],
                            [
                                10.379690099683678,
                                42.826406076683774
                            ],
                            [
                                10.407346445824711,
                                42.870536358757356
                            ],
                            [
                                10.417692324966152,
                                42.867364998332263
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.88609786075326,
                                42.389802153942618
                            ],
                            [
                                10.906410266357396,
                                42.381381351693236
                            ],
                            [
                                10.927746094157357,
                                42.355871991747044
                            ],
                            [
                                10.920387218751168,
                                42.351756160864539
                            ],
                            [
                                10.931388914376873,
                                42.331398818518792
                            ],
                            [
                                10.921130756461272,
                                42.319562243471921
                            ],
                            [
                                10.899674783833809,
                                42.330400111506428
                            ],
                            [
                                10.882422056699435,
                                42.351859150575812
                            ],
                            [
                                10.866572944216662,
                                42.354358492769386
                            ],
                            [
                                10.867776565033957,
                                42.36896168636946
                            ],
                            [
                                10.881587336232537,
                                42.367623599139748
                            ],
                            [
                                10.88609786075326,
                                42.389802153942618
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.835137033477752,
                                43.050038819993304
                            ],
                            [
                                9.847599814866713,
                                43.045145340581357
                            ],
                            [
                                9.841513649459388,
                                43.026534371855377
                            ],
                            [
                                9.810080824460142,
                                43.002285787092625
                            ],
                            [
                                9.791282836335592,
                                43.0231601674624
                            ],
                            [
                                9.800136657643694,
                                43.053769279555979
                            ],
                            [
                                9.825565677352879,
                                43.07289730769034
                            ],
                            [
                                9.836809941252779,
                                43.065161516583437
                            ],
                            [
                                9.835137033477752,
                                43.050038819993304
                            ]
                        ],
                        [
                            [
                                9.797354396545984,
                                43.031413802059767
                            ],
                            [
                                9.797862046743093,
                                43.031811545047837
                            ],
                            [
                                9.796172365589035,
                                43.032318019725942
                            ],
                            [
                                9.795993883414964,
                                43.031567351693361
                            ],
                            [
                                9.797354396545984,
                                43.031413802059767
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.233458741742982,
                                43.80652444625531
                            ],
                            [
                                12.237350089493326,
                                43.786991032535703
                            ],
                            [
                                12.212909855275019,
                                43.782054088128824
                            ],
                            [
                                12.199347755356278,
                                43.770375528127317
                            ],
                            [
                                12.185565245963094,
                                43.774515232901194
                            ],
                            [
                                12.171145745327838,
                                43.80794027365139
                            ],
                            [
                                12.233458741742982,
                                43.80652444625531
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.315178263492609,
                                42.350862030995629
                            ],
                            [
                                10.329579949736805,
                                42.341748624284591
                            ],
                            [
                                10.332657173359088,
                                42.324065956821244
                            ],
                            [
                                10.316442367751746,
                                42.313977599767931
                            ],
                            [
                                10.297505392133127,
                                42.315670434760932
                            ],
                            [
                                10.289101798231828,
                                42.326347125937666
                            ],
                            [
                                10.293972078478955,
                                42.346942662686644
                            ],
                            [
                                10.315178263492609,
                                42.350862030995629
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.093257121122258,
                                42.5921841606201
                            ],
                            [
                                10.100982414960036,
                                42.576318983391857
                            ],
                            [
                                10.087678635470068,
                                42.567859265779212
                            ],
                            [
                                10.046838271971335,
                                42.577954450854143
                            ],
                            [
                                10.054065495354356,
                                42.589786757984719
                            ],
                            [
                                10.074186800573072,
                                42.591178080630492
                            ],
                            [
                                10.07948415121693,
                                42.61934027700984
                            ],
                            [
                                10.089039812148162,
                                42.614740336912043
                            ],
                            [
                                10.093257121122258,
                                42.5921841606201
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                11.113768492657956,
                                42.260656975444157
                            ],
                            [
                                11.117385890315875,
                                42.251830031444733
                            ],
                            [
                                11.105465894219979,
                                42.25397676578384
                            ],
                            [
                                11.102686466638744,
                                42.245938491272092
                            ],
                            [
                                11.112306110013334,
                                42.240367294765733
                            ],
                            [
                                11.104295927834503,
                                42.238751747550928
                            ],
                            [
                                11.091892518729113,
                                42.254997474431811
                            ],
                            [
                                11.113768492657956,
                                42.260656975444157
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.90143051829995,
                                43.439561276134604
                            ],
                            [
                                9.90894944085108,
                                43.433351840504152
                            ],
                            [
                                9.900236374463542,
                                43.420310539200756
                            ],
                            [
                                9.888505036365201,
                                43.425499219979727
                            ],
                            [
                                9.90143051829995,
                                43.439561276134604
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.884270617876398,
                                42.575488453792659
                            ],
                            [
                                10.880848613749507,
                                42.576018776492084
                            ],
                            [
                                10.878316009309687,
                                42.578779913592037
                            ],
                            [
                                10.882855895361955,
                                42.577930683650713
                            ],
                            [
                                10.884270617876398,
                                42.575488453792659
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.548209857788548,
                                42.856335947753031
                            ],
                            [
                                10.545824259808885,
                                42.857854012280704
                            ],
                            [
                                10.549613104098004,
                                42.860567314503768
                            ],
                            [
                                10.549751460294068,
                                42.859736982692567
                            ],
                            [
                                10.548209857788548,
                                42.856335947753031
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                11.212780152349158,
                                42.378955057945994
                            ],
                            [
                                11.209395414603009,
                                42.380974533255781
                            ],
                            [
                                11.209301889258468,
                                42.382723378032054
                            ],
                            [
                                11.211678912889113,
                                42.382443384863933
                            ],
                            [
                                11.212780152349158,
                                42.378955057945994
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.474003290086667,
                                42.863673082405803
                            ],
                            [
                                10.472496809859308,
                                42.86621387221566
                            ],
                            [
                                10.476608553795995,
                                42.866665185618096
                            ],
                            [
                                10.476221681041757,
                                42.865328430437067
                            ],
                            [
                                10.474003290086667,
                                42.863673082405803
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.895298828741193,
                                42.562772478790365
                            ],
                            [
                                10.894242905823232,
                                42.563504666742475
                            ],
                            [
                                10.894137637844802,
                                42.565286059246063
                            ],
                            [
                                10.895226911011644,
                                42.564646761116407
                            ],
                            [
                                10.895298828741193,
                                42.562772478790365
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.713926250294609,
                                42.797558386746246
                            ],
                            [
                                10.712460096941946,
                                42.796715845903009
                            ],
                            [
                                10.711658595346819,
                                42.798690926970622
                            ],
                            [
                                10.712230664807507,
                                42.798151075961044
                            ],
                            [
                                10.713926250294609,
                                42.797558386746246
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.373488075933196,
                                42.716509497587417
                            ],
                            [
                                10.372211632454119,
                                42.716497784237468
                            ],
                            [
                                10.37203378943385,
                                42.71757154023733
                            ],
                            [
                                10.373408774876921,
                                42.717897257526317
                            ],
                            [
                                10.373488075933196,
                                42.716509497587417
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.106950911710387,
                                42.583085415076241
                            ],
                            [
                                10.105614242753603,
                                42.58347430325346
                            ],
                            [
                                10.105385868475565,
                                42.584343289065792
                            ],
                            [
                                10.106751625494903,
                                42.584564247064854
                            ],
                            [
                                10.106950911710387,
                                42.583085415076241
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.375272746770325,
                                42.718244102543672
                            ],
                            [
                                10.374906746104687,
                                42.717708182422953
                            ],
                            [
                                10.373015495185196,
                                42.718892551110208
                            ],
                            [
                                10.374155750683448,
                                42.719094999932402
                            ],
                            [
                                10.375272746770325,
                                42.718244102543672
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                11.082377819745387,
                                42.41813196904976
                            ],
                            [
                                11.081990018279956,
                                42.417706757350842
                            ],
                            [
                                11.080364720345914,
                                42.417898374319734
                            ],
                            [
                                11.082147525887985,
                                42.418793547358625
                            ],
                            [
                                11.082377819745387,
                                42.41813196904976
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                11.130600585532022,
                                42.376838254296111
                            ],
                            [
                                11.129551617961702,
                                42.377695256067106
                            ],
                            [
                                11.131102442110949,
                                42.378389111222738
                            ],
                            [
                                11.131184574602342,
                                42.37812417535936
                            ],
                            [
                                11.130600585532022,
                                42.376838254296111
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.424147452304178,
                                42.870715779862024
                            ],
                            [
                                10.422917744811768,
                                42.870478932251316
                            ],
                            [
                                10.422499921505956,
                                42.870943380804384
                            ],
                            [
                                10.423814625007122,
                                42.871415557157974
                            ],
                            [
                                10.424147452304178,
                                42.870715779862024
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.319975376240402,
                                42.734083330208243
                            ],
                            [
                                10.318976861478882,
                                42.734161249368746
                            ],
                            [
                                10.319298310059429,
                                42.734918489390935
                            ],
                            [
                                10.319979748024661,
                                42.73450540056799
                            ],
                            [
                                10.319975376240402,
                                42.734083330208243
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.929303464277663,
                                42.355580123147647
                            ],
                            [
                                10.92851339712966,
                                42.355850077961037
                            ],
                            [
                                10.928687537549047,
                                42.356482039143913
                            ],
                            [
                                10.929418666980432,
                                42.355972176793621
                            ],
                            [
                                10.929303464277663,
                                42.355580123147647
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.064277573726038,
                                42.358018300663062
                            ],
                            [
                                10.063769184448844,
                                42.358563372034617
                            ],
                            [
                                10.064086749830537,
                                42.35876305724473
                            ],
                            [
                                10.064707823663937,
                                42.358329511544163
                            ],
                            [
                                10.064277573726038,
                                42.358018300663062
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.330496915021969,
                                42.828091481479611
                            ],
                            [
                                10.330516999995934,
                                42.828600036174088
                            ],
                            [
                                10.3311364880048,
                                42.828962043911709
                            ],
                            [
                                10.331319242839795,
                                42.828356577200118
                            ],
                            [
                                10.330496915021969,
                                42.828091481479611
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.900764126959462,
                                42.556108059138595
                            ],
                            [
                                10.900029275527617,
                                42.556201309179187
                            ],
                            [
                                10.90073893068374,
                                42.556785455876181
                            ],
                            [
                                10.900949751527213,
                                42.556353723661985
                            ],
                            [
                                10.900764126959462,
                                42.556108059138595
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.475512031529206,
                                42.867913010101127
                            ],
                            [
                                10.47497268768986,
                                42.867883941099365
                            ],
                            [
                                10.474962146063774,
                                42.868469401791494
                            ],
                            [
                                10.475585877200654,
                                42.868443353050225
                            ],
                            [
                                10.475512031529206,
                                42.867913010101127
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.080088937902131,
                                42.621703017374742
                            ],
                            [
                                10.079407359801161,
                                42.621776982805471
                            ],
                            [
                                10.079799651581158,
                                42.622250575965452
                            ],
                            [
                                10.080156928443698,
                                42.622285480934941
                            ],
                            [
                                10.080088937902131,
                                42.621703017374742
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.219363348983428,
                                43.547872281031367
                            ],
                            [
                                10.218929087605121,
                                43.547822889876102
                            ],
                            [
                                10.218953078368816,
                                43.548398892988722
                            ],
                            [
                                10.219616141374589,
                                43.548130704314296
                            ],
                            [
                                10.219363348983428,
                                43.547872281031367
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.424170744982726,
                                43.355958094687693
                            ],
                            [
                                10.42625055592398,
                                43.355322825643569
                            ],
                            [
                                10.423935724887032,
                                43.355934008697666
                            ],
                            [
                                10.423050605175785,
                                43.356341216252204
                            ],
                            [
                                10.424170744982726,
                                43.355958094687693
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.882747968163043,
                                42.349762250987617
                            ],
                            [
                                10.882794244050677,
                                42.349482317733312
                            ],
                            [
                                10.882666660141675,
                                42.349173720781074
                            ],
                            [
                                10.882201903329193,
                                42.349771219514224
                            ],
                            [
                                10.882747968163043,
                                42.349762250987617
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.361062199380376,
                                42.713442980325553
                            ],
                            [
                                10.36067388684253,
                                42.713555657996231
                            ],
                            [
                                10.361183096128283,
                                42.713945837997784
                            ],
                            [
                                10.361376466040653,
                                42.713853486770297
                            ],
                            [
                                10.361062199380376,
                                42.713442980325553
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.413310944682074,
                                42.709721267346374
                            ],
                            [
                                10.413303615170127,
                                42.709667326298238
                            ],
                            [
                                10.412779304288716,
                                42.709700811630491
                            ],
                            [
                                10.412932330265686,
                                42.709987091685818
                            ],
                            [
                                10.413310944682074,
                                42.709721267346374
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.165576921045369,
                                43.956960630763355
                            ],
                            [
                                10.166200439747133,
                                43.957296398522622
                            ],
                            [
                                10.163538617185099,
                                43.955657901939688
                            ],
                            [
                                10.163486712320976,
                                43.955712451159783
                            ],
                            [
                                10.165576921045369,
                                43.956960630763355
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.406192847287981,
                                42.713275915882051
                            ],
                            [
                                10.406113081194508,
                                42.713529042276889
                            ],
                            [
                                10.406480347306944,
                                42.713569558335521
                            ],
                            [
                                10.406449830840099,
                                42.713299775708983
                            ],
                            [
                                10.406192847287981,
                                42.713275915882051
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.361140771891113,
                                42.713126862283318
                            ],
                            [
                                10.360932637658562,
                                42.713102320175366
                            ],
                            [
                                10.361305779594963,
                                42.713413069270985
                            ],
                            [
                                10.361388877504629,
                                42.713304018286024
                            ],
                            [
                                10.361140771891113,
                                42.713126862283318
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.0413016836668,
                                44.034151738493023
                            ],
                            [
                                10.041334559178537,
                                44.034069283428835
                            ],
                            [
                                10.040252969969101,
                                44.03457432026471
                            ],
                            [
                                10.040368154698777,
                                44.034559766390394
                            ],
                            [
                                10.0413016836668,
                                44.034151738493023
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.373356950556142,
                                42.716101331179914
                            ],
                            [
                                10.373197737325988,
                                42.716080727336504
                            ],
                            [
                                10.373332682696388,
                                42.716385287705137
                            ],
                            [
                                10.37343348096031,
                                42.716249000031773
                            ],
                            [
                                10.373356950556142,
                                42.716101331179914
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                11.206246827972244,
                                42.394768374807924
                            ],
                            [
                                11.206289656896537,
                                42.394907133147164
                            ],
                            [
                                11.206312794810998,
                                42.394614013654916
                            ],
                            [
                                11.206246827972244,
                                42.394768374807924
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                10.041334559178537,
                                44.034069283428835
                            ],
                            [
                                10.041456750209239,
                                44.034098555839556
                            ],
                            [
                                10.041443365770615,
                                44.03404690869035
                            ],
                            [
                                10.041334559178537,
                                44.034069283428835
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                11.210925241804052,
                                42.402233686172877
                            ],
                            [
                                11.210934158104592,
                                42.402314562196011
                            ],
                            [
                                11.210990760406267,
                                42.40219640058929
                            ],
                            [
                                11.210925241804052,
                                42.402233686172877
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 11,
                "name": "Umbria",
                "length": 620315.16993,
                "area": 8464007915.760000228881836
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                12.361635614657468,
                                43.601309881727659
                            ],
                            [
                                12.370292604903188,
                                43.579401453109213
                            ],
                            [
                                12.344027895869155,
                                43.552859290353588
                            ],
                            [
                                12.319793963579624,
                                43.553166185780363
                            ],
                            [
                                12.312759341204018,
                                43.54420017850596
                            ],
                            [
                                12.332914348134178,
                                43.523693842263782
                            ],
                            [
                                12.350124060143074,
                                43.521825823669573
                            ],
                            [
                                12.366736508310003,
                                43.534085925276798
                            ],
                            [
                                12.394824442605122,
                                43.508839598580614
                            ],
                            [
                                12.417935625904889,
                                43.534893993726342
                            ],
                            [
                                12.437366508282242,
                                43.538553595924135
                            ],
                            [
                                12.459217038066779,
                                43.516464737424904
                            ],
                            [
                                12.48053430282123,
                                43.527453813553741
                            ],
                            [
                                12.499814722690513,
                                43.521458044761637
                            ],
                            [
                                12.564259676938063,
                                43.459799776406371
                            ],
                            [
                                12.619584767961348,
                                43.427029658252188
                            ],
                            [
                                12.619417256069024,
                                43.416586150007696
                            ],
                            [
                                12.637312662592805,
                                43.431499254212206
                            ],
                            [
                                12.663176584514284,
                                43.436830816655089
                            ],
                            [
                                12.70885781715219,
                                43.42468290428716
                            ],
                            [
                                12.715265426488685,
                                43.446085495211193
                            ],
                            [
                                12.73197796547122,
                                43.461842417495554
                            ],
                            [
                                12.771199893686164,
                                43.457339604086982
                            ],
                            [
                                12.776441796959363,
                                43.450517467665961
                            ],
                            [
                                12.766311850113407,
                                43.445396085328824
                            ],
                            [
                                12.765562623468254,
                                43.427121681130131
                            ],
                            [
                                12.779661714051795,
                                43.414204365650065
                            ],
                            [
                                12.774427481297185,
                                43.401966490001818
                            ],
                            [
                                12.746809414152871,
                                43.390452937143095
                            ],
                            [
                                12.749045073184222,
                                43.37881330750325
                            ],
                            [
                                12.798736573238832,
                                43.325042033408451
                            ],
                            [
                                12.80098749389613,
                                43.294783428849804
                            ],
                            [
                                12.788980991571449,
                                43.283225889899725
                            ],
                            [
                                12.824762438317853,
                                43.266570014593697
                            ],
                            [
                                12.836600038711458,
                                43.217535240769095
                            ],
                            [
                                12.865389184972233,
                                43.206059220548333
                            ],
                            [
                                12.862490466692206,
                                43.16596603028902
                            ],
                            [
                                12.829645311603391,
                                43.145508515630915
                            ],
                            [
                                12.843003096636178,
                                43.122344210634544
                            ],
                            [
                                12.881307806714489,
                                43.121211414298941
                            ],
                            [
                                12.885026266785925,
                                43.099643280539183
                            ],
                            [
                                12.89732769498371,
                                43.09348461862502
                            ],
                            [
                                12.890058752791361,
                                43.058114554217092
                            ],
                            [
                                12.906708973946374,
                                43.035393376340309
                            ],
                            [
                                12.887959858369317,
                                43.00980103707316
                            ],
                            [
                                12.908227860496886,
                                42.985313315475111
                            ],
                            [
                                12.895822071457832,
                                42.964592015182163
                            ],
                            [
                                12.948052364590573,
                                42.941470221614537
                            ],
                            [
                                12.949336812234506,
                                42.929957570358162
                            ],
                            [
                                12.976700493169663,
                                42.926092719377607
                            ],
                            [
                                12.968394068186363,
                                42.900680753014214
                            ],
                            [
                                12.976156940701804,
                                42.869802169788457
                            ],
                            [
                                12.990068306587762,
                                42.870871972821142
                            ],
                            [
                                13.002508804541861,
                                42.895574519382428
                            ],
                            [
                                12.992036293501778,
                                42.900812344613563
                            ],
                            [
                                13.000817187488495,
                                42.908392240034864
                            ],
                            [
                                13.024960105221405,
                                42.902566535956268
                            ],
                            [
                                13.05441911894853,
                                42.920195760802649
                            ],
                            [
                                13.072642357356784,
                                42.903654770272077
                            ],
                            [
                                13.112245514545348,
                                42.889329540978807
                            ],
                            [
                                13.160863422352916,
                                42.831898045643179
                            ],
                            [
                                13.212247797696371,
                                42.841715871389738
                            ],
                            [
                                13.231282528923678,
                                42.854328786883983
                            ],
                            [
                                13.235270642596621,
                                42.867686209930234
                            ],
                            [
                                13.264166900043746,
                                42.809790445113045
                            ],
                            [
                                13.240522933281051,
                                42.762231331583699
                            ],
                            [
                                13.23431297128476,
                                42.773146155598681
                            ],
                            [
                                13.194268767198352,
                                42.760885587835162
                            ],
                            [
                                13.190533193005363,
                                42.709929574442199
                            ],
                            [
                                13.17333512227002,
                                42.68731388129342
                            ],
                            [
                                13.174129779055413,
                                42.66612151637964
                            ],
                            [
                                13.154092828390262,
                                42.650691369284516
                            ],
                            [
                                13.144776415768577,
                                42.646081926936532
                            ],
                            [
                                13.129951315362636,
                                42.659655544250533
                            ],
                            [
                                13.118188103242867,
                                42.65765328095975
                            ],
                            [
                                13.109040322873064,
                                42.641888311131936
                            ],
                            [
                                13.061955459944324,
                                42.623100396813555
                            ],
                            [
                                13.035730935957272,
                                42.627999388720376
                            ],
                            [
                                13.024284670154191,
                                42.639036117865878
                            ],
                            [
                                13.011219560762886,
                                42.617106907776481
                            ],
                            [
                                12.95250181427137,
                                42.618925877418306
                            ],
                            [
                                12.937451508687282,
                                42.615357197902924
                            ],
                            [
                                12.930122739119607,
                                42.602882283343085
                            ],
                            [
                                12.889623212889736,
                                42.613513499476333
                            ],
                            [
                                12.880089878945922,
                                42.602361782493055
                            ],
                            [
                                12.892727851230447,
                                42.56350034000338
                            ],
                            [
                                12.847829090186307,
                                42.552803894143494
                            ],
                            [
                                12.818034248555151,
                                42.532936611116781
                            ],
                            [
                                12.773202311559992,
                                42.531279907444109
                            ],
                            [
                                12.773542707222923,
                                42.513093982393848
                            ],
                            [
                                12.7275869004851,
                                42.509139134590669
                            ],
                            [
                                12.711135495661619,
                                42.500794340007417
                            ],
                            [
                                12.741563894025839,
                                42.470533938096779
                            ],
                            [
                                12.724694179168647,
                                42.460409752594458
                            ],
                            [
                                12.702787055529145,
                                42.460898554604761
                            ],
                            [
                                12.674647224803945,
                                42.442419325507387
                            ],
                            [
                                12.649495273755013,
                                42.443309523514465
                            ],
                            [
                                12.641086004783993,
                                42.467803236963725
                            ],
                            [
                                12.614806033435563,
                                42.465106511983414
                            ],
                            [
                                12.614891056327354,
                                42.414481748501885
                            ],
                            [
                                12.606069650995668,
                                42.403528456744532
                            ],
                            [
                                12.567070060160077,
                                42.383345412719073
                            ],
                            [
                                12.548938491212168,
                                42.382328577805872
                            ],
                            [
                                12.528736436500205,
                                42.364448868077815
                            ],
                            [
                                12.517136842074411,
                                42.37039748086579
                            ],
                            [
                                12.51169050097146,
                                42.403111136461682
                            ],
                            [
                                12.491577821408189,
                                42.397423136697235
                            ],
                            [
                                12.480322706548012,
                                42.404051230534286
                            ],
                            [
                                12.466255466388704,
                                42.394889776725968
                            ],
                            [
                                12.444689036889201,
                                42.398817728095082
                            ],
                            [
                                12.458261305427035,
                                42.403904772405312
                            ],
                            [
                                12.463602461576958,
                                42.429086322423736
                            ],
                            [
                                12.450142589951433,
                                42.422996016386037
                            ],
                            [
                                12.41365029980447,
                                42.425598086827598
                            ],
                            [
                                12.41367695974148,
                                42.455167909252509
                            ],
                            [
                                12.4303823582294,
                                42.458022728550581
                            ],
                            [
                                12.427515045507375,
                                42.465348161597774
                            ],
                            [
                                12.412440959745547,
                                42.467563343007285
                            ],
                            [
                                12.412852641686037,
                                42.478779590615588
                            ],
                            [
                                12.427825139748014,
                                42.486940453016565
                            ],
                            [
                                12.421390021470728,
                                42.49252661010803
                            ],
                            [
                                12.391845015060444,
                                42.498758960269953
                            ],
                            [
                                12.374173930377827,
                                42.481128246107211
                            ],
                            [
                                12.35122554427617,
                                42.473653266194596
                            ],
                            [
                                12.325365836892521,
                                42.494757447858127
                            ],
                            [
                                12.314150578555152,
                                42.487883587724923
                            ],
                            [
                                12.290578319735541,
                                42.491517020379476
                            ],
                            [
                                12.307352102766055,
                                42.497300789189268
                            ],
                            [
                                12.290346904943814,
                                42.510608690955848
                            ],
                            [
                                12.274765067399018,
                                42.509205061440632
                            ],
                            [
                                12.275504157038155,
                                42.515995819117535
                            ],
                            [
                                12.290267255176355,
                                42.519043684404963
                            ],
                            [
                                12.266757016848423,
                                42.533466846040859
                            ],
                            [
                                12.27855380916882,
                                42.541557754986414
                            ],
                            [
                                12.275043301144569,
                                42.559914787126012
                            ],
                            [
                                12.238657036955599,
                                42.572178648851903
                            ],
                            [
                                12.240562485832434,
                                42.596994989970248
                            ],
                            [
                                12.247556151566233,
                                42.596693212452557
                            ],
                            [
                                12.229135020165948,
                                42.611094317852661
                            ],
                            [
                                12.242916597694483,
                                42.629065044323752
                            ],
                            [
                                12.225652342333651,
                                42.635548670849651
                            ],
                            [
                                12.226918681203289,
                                42.643478559115181
                            ],
                            [
                                12.204335475772659,
                                42.660460593400224
                            ],
                            [
                                12.161011591727092,
                                42.676909984298675
                            ],
                            [
                                12.14703448921297,
                                42.659335907785788
                            ],
                            [
                                12.132326868747652,
                                42.661666369001793
                            ],
                            [
                                12.124062227949914,
                                42.649286047699576
                            ],
                            [
                                12.106664028708586,
                                42.664642577741212
                            ],
                            [
                                12.094508638082869,
                                42.65548715768147
                            ],
                            [
                                12.07371538005432,
                                42.656670300856533
                            ],
                            [
                                12.029999157958482,
                                42.643241219605642
                            ],
                            [
                                12.029791778585029,
                                42.650415810378284
                            ],
                            [
                                12.007081791291345,
                                42.662451987028014
                            ],
                            [
                                11.94132981871584,
                                42.683300882392814
                            ],
                            [
                                11.948764191659855,
                                42.696010528910712
                            ],
                            [
                                11.926202544537192,
                                42.703860791983836
                            ],
                            [
                                11.930100543082951,
                                42.712945668454942
                            ],
                            [
                                11.968726053402328,
                                42.734578422581777
                            ],
                            [
                                11.981870640478567,
                                42.753582691981826
                            ],
                            [
                                11.979481830764213,
                                42.76458530747216
                            ],
                            [
                                11.92742513184325,
                                42.780916903100632
                            ],
                            [
                                11.891887296945505,
                                42.842879619450912
                            ],
                            [
                                11.913217357031854,
                                42.850554933190168
                            ],
                            [
                                11.929018720161871,
                                42.869290187775711
                            ],
                            [
                                11.958655309705305,
                                42.871057729765475
                            ],
                            [
                                11.958812275190994,
                                42.891646485404657
                            ],
                            [
                                11.932720525452618,
                                42.908499174893322
                            ],
                            [
                                11.952082688263133,
                                42.949699769977649
                            ],
                            [
                                11.949514926064873,
                                42.976528036628814
                            ],
                            [
                                11.982413458496275,
                                43.049966421296219
                            ],
                            [
                                11.973690212334571,
                                43.063236054392156
                            ],
                            [
                                11.956587915405999,
                                43.068676841407175
                            ],
                            [
                                11.940070322627665,
                                43.053282559810036
                            ],
                            [
                                11.923639985793953,
                                43.074665411302291
                            ],
                            [
                                11.930931745319677,
                                43.092395762874531
                            ],
                            [
                                11.912351762695559,
                                43.128402400535236
                            ],
                            [
                                11.9249819219116,
                                43.149253380848307
                            ],
                            [
                                11.987477160346939,
                                43.180518521000884
                            ],
                            [
                                12.024072283456022,
                                43.188160034977663
                            ],
                            [
                                12.039652851202002,
                                43.228993555993426
                            ],
                            [
                                12.033962219742188,
                                43.24670229279144
                            ],
                            [
                                12.04891334638546,
                                43.253098926319787
                            ],
                            [
                                12.092365093273102,
                                43.235908076832501
                            ],
                            [
                                12.121054934820602,
                                43.254953503410157
                            ],
                            [
                                12.148583099876161,
                                43.254617117027607
                            ],
                            [
                                12.223888168943731,
                                43.295796334339535
                            ],
                            [
                                12.193820229174301,
                                43.313073952200448
                            ],
                            [
                                12.177042433351001,
                                43.281781858355465
                            ],
                            [
                                12.132523230103809,
                                43.29306969818164
                            ],
                            [
                                12.12583496951104,
                                43.306781907179243
                            ],
                            [
                                12.135447254690764,
                                43.341728754695716
                            ],
                            [
                                12.124881595234504,
                                43.357926455572482
                            ],
                            [
                                12.102570269585049,
                                43.3724507396078
                            ],
                            [
                                12.076994472577955,
                                43.365833024732027
                            ],
                            [
                                12.077306099695651,
                                43.402144459232858
                            ],
                            [
                                12.03293599733845,
                                43.400224909929371
                            ],
                            [
                                12.02521045029072,
                                43.415573884620457
                            ],
                            [
                                12.05687865006162,
                                43.438254561692453
                            ],
                            [
                                12.08136093631648,
                                43.434046204133189
                            ],
                            [
                                12.104025510288784,
                                43.460449486837263
                            ],
                            [
                                12.143244277432039,
                                43.470292551275797
                            ],
                            [
                                12.140673131154381,
                                43.482466158529313
                            ],
                            [
                                12.092498815306271,
                                43.501067210651534
                            ],
                            [
                                12.095394878695727,
                                43.522609992616225
                            ],
                            [
                                12.10272768512055,
                                43.529932856382793
                            ],
                            [
                                12.142098753684131,
                                43.535767851691709
                            ],
                            [
                                12.153237643349323,
                                43.528712785721488
                            ],
                            [
                                12.162662176773573,
                                43.561366644835154
                            ],
                            [
                                12.203184608954356,
                                43.60617942104831
                            ],
                            [
                                12.21381207600567,
                                43.610872757962596
                            ],
                            [
                                12.22546790728321,
                                43.593317163218963
                            ],
                            [
                                12.2621840485668,
                                43.588909254058507
                            ],
                            [
                                12.287791635817536,
                                43.594626907323267
                            ],
                            [
                                12.297430669477682,
                                43.585813819579009
                            ],
                            [
                                12.313466281085528,
                                43.602204297359272
                            ],
                            [
                                12.354731664997948,
                                43.617285655460719
                            ],
                            [
                                12.371275517456603,
                                43.61115763740095
                            ],
                            [
                                12.361635614657468,
                                43.601309881727659
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.431212756767868,
                                43.591363861848748
                            ],
                            [
                                12.425073683280292,
                                43.59172510937303
                            ],
                            [
                                12.407804691950105,
                                43.602136047963455
                            ],
                            [
                                12.425311096882178,
                                43.609087520289293
                            ],
                            [
                                12.431212756767868,
                                43.591363861848748
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 12,
                "name": "Marche",
                "length": 629209.047201,
                "area": 9401177971.950000762939453
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                13.500036435496954,
                                43.623843727154359
                            ],
                            [
                                13.494146352008419,
                                43.625504376134636
                            ],
                            [
                                13.502610835840953,
                                43.631467990464344
                            ],
                            [
                                13.530778561475788,
                                43.620042440153789
                            ],
                            [
                                13.565577315517729,
                                43.589111671094138
                            ],
                            [
                                13.575852077127955,
                                43.568828855855479
                            ],
                            [
                                13.627536685203946,
                                43.547583028036556
                            ],
                            [
                                13.623719828781445,
                                43.501455043211443
                            ],
                            [
                                13.810368542940671,
                                43.163599286783658
                            ],
                            [
                                13.813660471075828,
                                43.168938661559018
                            ],
                            [
                                13.844697441532437,
                                43.096726957089587
                            ],
                            [
                                13.880066576961264,
                                42.966560294025378
                            ],
                            [
                                13.916726815434378,
                                42.894582893139173
                            ],
                            [
                                13.876852722538111,
                                42.894714849096133
                            ],
                            [
                                13.874872141756429,
                                42.888859818064788
                            ],
                            [
                                13.81931597997955,
                                42.878907331688978
                            ],
                            [
                                13.777964718765846,
                                42.860445481771023
                            ],
                            [
                                13.722478311414351,
                                42.855353554637809
                            ],
                            [
                                13.706602169718991,
                                42.849312057740306
                            ],
                            [
                                13.699303303375498,
                                42.822615594365509
                            ],
                            [
                                13.663599828555302,
                                42.807127373191335
                            ],
                            [
                                13.635516359759826,
                                42.80330238088154
                            ],
                            [
                                13.624398863148985,
                                42.816541728357372
                            ],
                            [
                                13.572247604869501,
                                42.800373199410785
                            ],
                            [
                                13.534499894745869,
                                42.816649938083188
                            ],
                            [
                                13.529733382633669,
                                42.79598926458074
                            ],
                            [
                                13.50420649207895,
                                42.774740124730982
                            ],
                            [
                                13.504615489128234,
                                42.747599508204857
                            ],
                            [
                                13.493443722009962,
                                42.736615385060709
                            ],
                            [
                                13.447987373116666,
                                42.73221715063795
                            ],
                            [
                                13.437565871696265,
                                42.69919746869931
                            ],
                            [
                                13.427396929779411,
                                42.706425287723974
                            ],
                            [
                                13.389981287881113,
                                42.687156064446306
                            ],
                            [
                                13.34115888901775,
                                42.70176360243358
                            ],
                            [
                                13.286276598026136,
                                42.740406405724336
                            ],
                            [
                                13.26449887700783,
                                42.740185490331477
                            ],
                            [
                                13.254152452718859,
                                42.721452132804636
                            ],
                            [
                                13.187596110430604,
                                42.733673147122126
                            ],
                            [
                                13.199254542731198,
                                42.748655871480864
                            ],
                            [
                                13.195119322019803,
                                42.761916788795908
                            ],
                            [
                                13.23431297128476,
                                42.773146155598681
                            ],
                            [
                                13.241337925867754,
                                42.76280882901893
                            ],
                            [
                                13.264011111221668,
                                42.808251892530123
                            ],
                            [
                                13.235270642596621,
                                42.867686209930234
                            ],
                            [
                                13.231282528923678,
                                42.854328786883983
                            ],
                            [
                                13.212247797696371,
                                42.841715871389738
                            ],
                            [
                                13.160863422352916,
                                42.831898045643179
                            ],
                            [
                                13.112245514545348,
                                42.889329540978807
                            ],
                            [
                                13.072642357356784,
                                42.903654770272077
                            ],
                            [
                                13.05441911894853,
                                42.920195760802649
                            ],
                            [
                                13.024960105221405,
                                42.902566535956268
                            ],
                            [
                                13.000817187488495,
                                42.908392240034864
                            ],
                            [
                                12.992036293501778,
                                42.900812344613563
                            ],
                            [
                                13.002508804541861,
                                42.895574519382428
                            ],
                            [
                                12.990068306587762,
                                42.870871972821142
                            ],
                            [
                                12.976156940701804,
                                42.869802169788457
                            ],
                            [
                                12.968394068186363,
                                42.900680753014214
                            ],
                            [
                                12.976700493169663,
                                42.926092719377607
                            ],
                            [
                                12.949336812234506,
                                42.929957570358162
                            ],
                            [
                                12.948052364590573,
                                42.941470221614537
                            ],
                            [
                                12.895822071457832,
                                42.964592015182163
                            ],
                            [
                                12.908227860496886,
                                42.985313315475111
                            ],
                            [
                                12.887959858369317,
                                43.00980103707316
                            ],
                            [
                                12.906708973946374,
                                43.035393376340309
                            ],
                            [
                                12.890058752791361,
                                43.058114554217092
                            ],
                            [
                                12.89732769498371,
                                43.09348461862502
                            ],
                            [
                                12.885026266785925,
                                43.099643280539183
                            ],
                            [
                                12.881307806714489,
                                43.121211414298941
                            ],
                            [
                                12.843003096636178,
                                43.122344210634544
                            ],
                            [
                                12.829645311603391,
                                43.145508515630915
                            ],
                            [
                                12.862490466692206,
                                43.16596603028902
                            ],
                            [
                                12.865389184972233,
                                43.206059220548333
                            ],
                            [
                                12.836600038711458,
                                43.217535240769095
                            ],
                            [
                                12.824762438317853,
                                43.266570014593697
                            ],
                            [
                                12.788980991571449,
                                43.283225889899725
                            ],
                            [
                                12.80098749389613,
                                43.294783428849804
                            ],
                            [
                                12.798736573238832,
                                43.325042033408451
                            ],
                            [
                                12.749045073184222,
                                43.37881330750325
                            ],
                            [
                                12.746809414152871,
                                43.390452937143095
                            ],
                            [
                                12.774427481297185,
                                43.401966490001818
                            ],
                            [
                                12.779661714051795,
                                43.414204365650065
                            ],
                            [
                                12.765562623468254,
                                43.427121681130131
                            ],
                            [
                                12.766311850113407,
                                43.445396085328824
                            ],
                            [
                                12.776441796959363,
                                43.450517467665961
                            ],
                            [
                                12.771199893686164,
                                43.457339604086982
                            ],
                            [
                                12.73197796547122,
                                43.461842417495554
                            ],
                            [
                                12.715265426488685,
                                43.446085495211193
                            ],
                            [
                                12.70885781715219,
                                43.42468290428716
                            ],
                            [
                                12.663176584514284,
                                43.436830816655089
                            ],
                            [
                                12.637312662592805,
                                43.431499254212206
                            ],
                            [
                                12.619417256069024,
                                43.416586150007696
                            ],
                            [
                                12.619584767961348,
                                43.427029658252188
                            ],
                            [
                                12.564259676938063,
                                43.459799776406371
                            ],
                            [
                                12.499814722690513,
                                43.521458044761637
                            ],
                            [
                                12.48053430282123,
                                43.527453813553741
                            ],
                            [
                                12.459217038066779,
                                43.516464737424904
                            ],
                            [
                                12.437366508282242,
                                43.538553595924135
                            ],
                            [
                                12.417935625904889,
                                43.534893993726342
                            ],
                            [
                                12.394824442605122,
                                43.508839598580614
                            ],
                            [
                                12.366736508310003,
                                43.534085925276798
                            ],
                            [
                                12.350124060143074,
                                43.521825823669573
                            ],
                            [
                                12.331795901380891,
                                43.524500674536533
                            ],
                            [
                                12.314534594355047,
                                43.548172618637146
                            ],
                            [
                                12.344027895869155,
                                43.552859290353588
                            ],
                            [
                                12.370292604903188,
                                43.579401453109213
                            ],
                            [
                                12.361309623447982,
                                43.596539051866053
                            ],
                            [
                                12.371275517456603,
                                43.61115763740095
                            ],
                            [
                                12.354731664997948,
                                43.617285655460719
                            ],
                            [
                                12.313466281085528,
                                43.602204297359272
                            ],
                            [
                                12.299539904737694,
                                43.585873318083394
                            ],
                            [
                                12.287791635817536,
                                43.594626907323267
                            ],
                            [
                                12.2621840485668,
                                43.588909254058507
                            ],
                            [
                                12.22546790728321,
                                43.593317163218963
                            ],
                            [
                                12.209909844298533,
                                43.621025567972445
                            ],
                            [
                                12.185453630656609,
                                43.641103562556445
                            ],
                            [
                                12.203692072936715,
                                43.651743961030853
                            ],
                            [
                                12.232649989589405,
                                43.655601479778838
                            ],
                            [
                                12.249481461515092,
                                43.668933885129327
                            ],
                            [
                                12.245070686471612,
                                43.68147632908677
                            ],
                            [
                                12.273479370331037,
                                43.675964231170802
                            ],
                            [
                                12.297210780827168,
                                43.685950258412099
                            ],
                            [
                                12.30831884433684,
                                43.730176823869762
                            ],
                            [
                                12.321368300284158,
                                43.693398012555939
                            ],
                            [
                                12.315718919501776,
                                43.677919100254172
                            ],
                            [
                                12.33602546082221,
                                43.677647589103742
                            ],
                            [
                                12.330488887671194,
                                43.707965117497707
                            ],
                            [
                                12.345107923956858,
                                43.709977603719295
                            ],
                            [
                                12.357324778507424,
                                43.702024819716506
                            ],
                            [
                                12.370101983027499,
                                43.707275373699744
                            ],
                            [
                                12.327074383755507,
                                43.751009828979882
                            ],
                            [
                                12.283410999083623,
                                43.763275772537241
                            ],
                            [
                                12.282772217378659,
                                43.789695868382722
                            ],
                            [
                                12.335439202835426,
                                43.824118628716526
                            ],
                            [
                                12.347371686878502,
                                43.867020005228206
                            ],
                            [
                                12.386230545445327,
                                43.881984726605054
                            ],
                            [
                                12.392472732228919,
                                43.896550766610041
                            ],
                            [
                                12.400608552785606,
                                43.872774849032538
                            ],
                            [
                                12.430168796348116,
                                43.871683270315657
                            ],
                            [
                                12.418688574600564,
                                43.900657175899632
                            ],
                            [
                                12.443693916978356,
                                43.904978628324841
                            ],
                            [
                                12.45500486594405,
                                43.893927776975865
                            ],
                            [
                                12.487404304029475,
                                43.896469308532971
                            ],
                            [
                                12.493945291909712,
                                43.915564800879942
                            ],
                            [
                                12.52096062323467,
                                43.898340230049236
                            ],
                            [
                                12.535864653371823,
                                43.897222241369555
                            ],
                            [
                                12.542519379537199,
                                43.888544113624498
                            ],
                            [
                                12.530301575955587,
                                43.876788976838405
                            ],
                            [
                                12.541692218711836,
                                43.864027762553519
                            ],
                            [
                                12.562452364223283,
                                43.869816512906631
                            ],
                            [
                                12.565896339685716,
                                43.882243292924628
                            ],
                            [
                                12.589492255999758,
                                43.885644957056734
                            ],
                            [
                                12.589359658284847,
                                43.865251480784622
                            ],
                            [
                                12.602561418054508,
                                43.863434819968816
                            ],
                            [
                                12.60100073484467,
                                43.850534463877729
                            ],
                            [
                                12.618902495535307,
                                43.842627452245694
                            ],
                            [
                                12.610015536549541,
                                43.833899186473168
                            ],
                            [
                                12.623274686752993,
                                43.821151720082341
                            ],
                            [
                                12.644464185849023,
                                43.826892235964017
                            ],
                            [
                                12.672564276556754,
                                43.823571691890621
                            ],
                            [
                                12.681317055891967,
                                43.8280706626458
                            ],
                            [
                                12.682462323346757,
                                43.852860143200928
                            ],
                            [
                                12.723632258061533,
                                43.861236748791107
                            ],
                            [
                                12.73399251318051,
                                43.870258974555298
                            ],
                            [
                                12.722653226609948,
                                43.880566365046818
                            ],
                            [
                                12.734831048529248,
                                43.896024741662451
                            ],
                            [
                                12.727907574526379,
                                43.92418244508972
                            ],
                            [
                                12.756210914954345,
                                43.968635117640183
                            ],
                            [
                                12.797592693223086,
                                43.965174401783713
                            ],
                            [
                                12.892604094896827,
                                43.923202040430986
                            ],
                            [
                                12.907332209751875,
                                43.923002444219662
                            ],
                            [
                                12.986315889878039,
                                43.865335270126494
                            ],
                            [
                                13.022041497281846,
                                43.849821059791843
                            ],
                            [
                                13.219789190755542,
                                43.717697563066238
                            ],
                            [
                                13.307963179944631,
                                43.668418429019319
                            ],
                            [
                                13.454020543367321,
                                43.610515253424531
                            ],
                            [
                                13.481977913982828,
                                43.606672283518961
                            ],
                            [
                                13.497715337825301,
                                43.622680921106074
                            ],
                            [
                                13.503926850116608,
                                43.61513917910802
                            ],
                            [
                                13.508180122818995,
                                43.618698296544331
                            ],
                            [
                                13.500036435496954,
                                43.623843727154359
                            ]
                        ],
                        [
                            [
                                12.425073683280292,
                                43.59172510937303
                            ],
                            [
                                12.434816495173445,
                                43.599487634408852
                            ],
                            [
                                12.421112206778837,
                                43.609339448745565
                            ],
                            [
                                12.407804691950105,
                                43.602136047963455
                            ],
                            [
                                12.425073683280292,
                                43.59172510937303
                            ]
                        ],
                        [
                            [
                                13.526942085101629,
                                43.621551898951125
                            ],
                            [
                                13.526776920994815,
                                43.621621471685124
                            ],
                            [
                                13.526704708689707,
                                43.621598454421679
                            ],
                            [
                                13.526944297796234,
                                43.621498920419022
                            ],
                            [
                                13.526942085101629,
                                43.621551898951125
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                13.729297924450522,
                                43.313153299598746
                            ],
                            [
                                13.73055755877796,
                                43.313398180529092
                            ],
                            [
                                13.730589543262706,
                                43.313333835694955
                            ],
                            [
                                13.729297924450522,
                                43.313153299598746
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                13.49995629809542,
                                43.623771901190004
                            ],
                            [
                                13.500036435496954,
                                43.623843727154359
                            ],
                            [
                                13.500045211199685,
                                43.623759391282952
                            ],
                            [
                                13.49995629809542,
                                43.623771901190004
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 13,
                "name": "Lazio",
                "length": 1055355.14651,
                "area": 17227617801.299999237060547
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                12.622405227476035,
                                41.444589199642557
                            ],
                            [
                                12.552777782638829,
                                41.53404234396843
                            ],
                            [
                                12.437108463894456,
                                41.640773940553188
                            ],
                            [
                                12.352154348263369,
                                41.696842176580823
                            ],
                            [
                                12.234434288960985,
                                41.739713587140336
                            ],
                            [
                                12.256207594503737,
                                41.746160859183696
                            ],
                            [
                                12.2252433284349,
                                41.74477570648655
                            ],
                            [
                                12.224221060911042,
                                41.781894615778114
                            ],
                            [
                                12.203510225407774,
                                41.829742942621621
                            ],
                            [
                                12.140979434626956,
                                41.916056833524493
                            ],
                            [
                                12.049786148549551,
                                41.956510698785621
                            ],
                            [
                                12.02397778627944,
                                41.983840764420009
                            ],
                            [
                                11.979202099586075,
                                41.996665439952594
                            ],
                            [
                                11.963893184382188,
                                42.014262217056576
                            ],
                            [
                                11.915734120648562,
                                42.039369811875218
                            ],
                            [
                                11.833040235411126,
                                42.030908367458167
                            ],
                            [
                                11.806765435406742,
                                42.080410694175683
                            ],
                            [
                                11.786708949978484,
                                42.088901350544617
                            ],
                            [
                                11.780203671493815,
                                42.093066182366641
                            ],
                            [
                                11.777377479659322,
                                42.095230014104381
                            ],
                            [
                                11.772284278210538,
                                42.099896785451925
                            ],
                            [
                                11.788795679912861,
                                42.089527862313012
                            ],
                            [
                                11.746381242849605,
                                42.137949982118265
                            ],
                            [
                                11.733766963813034,
                                42.158058103805011
                            ],
                            [
                                11.739465431542049,
                                42.171090054074121
                            ],
                            [
                                11.663733456517017,
                                42.269204168771815
                            ],
                            [
                                11.632474374892217,
                                42.29553203418164
                            ],
                            [
                                11.556419459151526,
                                42.338389870941135
                            ],
                            [
                                11.451130057596142,
                                42.377247037263018
                            ],
                            [
                                11.449780199918559,
                                42.394039290728109
                            ],
                            [
                                11.482090598777599,
                                42.419891140983694
                            ],
                            [
                                11.488888400706507,
                                42.439370356010123
                            ],
                            [
                                11.516575084969478,
                                42.433556009078053
                            ],
                            [
                                11.54423707092544,
                                42.442155666485235
                            ],
                            [
                                11.617707438481915,
                                42.436039468220486
                            ],
                            [
                                11.616316817688364,
                                42.488390728656029
                            ],
                            [
                                11.561235650327296,
                                42.517292341513205
                            ],
                            [
                                11.568825221818246,
                                42.533826579195107
                            ],
                            [
                                11.584350637919982,
                                42.542754614626659
                            ],
                            [
                                11.580720206465104,
                                42.567919704906515
                            ],
                            [
                                11.600781021525631,
                                42.56922177642025
                            ],
                            [
                                11.616191552563274,
                                42.559874827336785
                            ],
                            [
                                11.626107332592746,
                                42.56942940912225
                            ],
                            [
                                11.643368700721002,
                                42.566346518438721
                            ],
                            [
                                11.657167895867008,
                                42.577161624655325
                            ],
                            [
                                11.681458599787534,
                                42.581325123609815
                            ],
                            [
                                11.680049976582174,
                                42.595313331208757
                            ],
                            [
                                11.711111250303039,
                                42.610905449607863
                            ],
                            [
                                11.735971733607233,
                                42.606662595353718
                            ],
                            [
                                11.751830312301424,
                                42.625595428256183
                            ],
                            [
                                11.749754250636975,
                                42.639649909069263
                            ],
                            [
                                11.780886172951316,
                                42.634682910170618
                            ],
                            [
                                11.804776027697709,
                                42.64399917177041
                            ],
                            [
                                11.808941750117572,
                                42.658666944438849
                            ],
                            [
                                11.800890111911675,
                                42.668420426564005
                            ],
                            [
                                11.784511639450644,
                                42.671321100412719
                            ],
                            [
                                11.781143062761007,
                                42.705325718987268
                            ],
                            [
                                11.801555696177132,
                                42.7071915763348
                            ],
                            [
                                11.818658353630047,
                                42.745771938909023
                            ],
                            [
                                11.779418825851096,
                                42.758017432159136
                            ],
                            [
                                11.764393467500289,
                                42.777914508554616
                            ],
                            [
                                11.746017668716586,
                                42.78575944079337
                            ],
                            [
                                11.768500914082988,
                                42.819958577713358
                            ],
                            [
                                11.78639487827391,
                                42.81628934315453
                            ],
                            [
                                11.806848334222646,
                                42.794853987397119
                            ],
                            [
                                11.813697566299261,
                                42.822671671279188
                            ],
                            [
                                11.850593080832631,
                                42.83868318201403
                            ],
                            [
                                11.901828359451496,
                                42.83157050635603
                            ],
                            [
                                11.92742513184325,
                                42.780916903100632
                            ],
                            [
                                11.979481830764213,
                                42.76458530747216
                            ],
                            [
                                11.981944244866591,
                                42.754845905773905
                            ],
                            [
                                11.968726053402328,
                                42.734578422581777
                            ],
                            [
                                11.947390771710264,
                                42.726206500597932
                            ],
                            [
                                11.926202544537192,
                                42.703860791983836
                            ],
                            [
                                11.948764191659855,
                                42.696010528910712
                            ],
                            [
                                11.94132981871584,
                                42.683300882392814
                            ],
                            [
                                12.007081791291345,
                                42.662451987028014
                            ],
                            [
                                12.029791778585029,
                                42.650415810378284
                            ],
                            [
                                12.029999157958482,
                                42.643241219605642
                            ],
                            [
                                12.07371538005432,
                                42.656670300856533
                            ],
                            [
                                12.094508638082869,
                                42.65548715768147
                            ],
                            [
                                12.106664028708586,
                                42.664642577741212
                            ],
                            [
                                12.124062227949914,
                                42.649286047699576
                            ],
                            [
                                12.132326868747652,
                                42.661666369001793
                            ],
                            [
                                12.14703448921297,
                                42.659335907785788
                            ],
                            [
                                12.161011591727092,
                                42.676909984298675
                            ],
                            [
                                12.204335475772659,
                                42.660460593400224
                            ],
                            [
                                12.226918681203289,
                                42.643478559115181
                            ],
                            [
                                12.225652342333651,
                                42.635548670849651
                            ],
                            [
                                12.242916597694483,
                                42.629065044323752
                            ],
                            [
                                12.229135020165948,
                                42.611094317852661
                            ],
                            [
                                12.247556151566233,
                                42.596693212452557
                            ],
                            [
                                12.240562485832434,
                                42.596994989970248
                            ],
                            [
                                12.238657036955599,
                                42.572178648851903
                            ],
                            [
                                12.275043301144569,
                                42.559914787126012
                            ],
                            [
                                12.27855380916882,
                                42.541557754986414
                            ],
                            [
                                12.266757016848423,
                                42.533466846040859
                            ],
                            [
                                12.290267255176355,
                                42.519043684404963
                            ],
                            [
                                12.275504157038155,
                                42.515995819117535
                            ],
                            [
                                12.274765067399018,
                                42.509205061440632
                            ],
                            [
                                12.290346904943814,
                                42.510608690955848
                            ],
                            [
                                12.307352102766055,
                                42.497300789189268
                            ],
                            [
                                12.290578319735541,
                                42.491517020379476
                            ],
                            [
                                12.314150578555152,
                                42.487883587724923
                            ],
                            [
                                12.325365836892521,
                                42.494757447858127
                            ],
                            [
                                12.35122554427617,
                                42.473653266194596
                            ],
                            [
                                12.374173930377827,
                                42.481128246107211
                            ],
                            [
                                12.391845015060444,
                                42.498758960269953
                            ],
                            [
                                12.421390021470728,
                                42.49252661010803
                            ],
                            [
                                12.427825139748014,
                                42.486940453016565
                            ],
                            [
                                12.412852641686037,
                                42.478779590615588
                            ],
                            [
                                12.412440959745547,
                                42.467563343007285
                            ],
                            [
                                12.427515045507375,
                                42.465348161597774
                            ],
                            [
                                12.4303823582294,
                                42.458022728550581
                            ],
                            [
                                12.41367695974148,
                                42.455167909252509
                            ],
                            [
                                12.41365029980447,
                                42.425598086827598
                            ],
                            [
                                12.450142589951433,
                                42.422996016386037
                            ],
                            [
                                12.463602461576958,
                                42.429086322423736
                            ],
                            [
                                12.458261305427035,
                                42.403904772405312
                            ],
                            [
                                12.444689036889201,
                                42.398817728095082
                            ],
                            [
                                12.466255466388704,
                                42.394889776725968
                            ],
                            [
                                12.480322706548012,
                                42.404051230534286
                            ],
                            [
                                12.491577821408189,
                                42.397423136697235
                            ],
                            [
                                12.51169050097146,
                                42.403111136461682
                            ],
                            [
                                12.517136842074411,
                                42.37039748086579
                            ],
                            [
                                12.528736436500205,
                                42.364448868077815
                            ],
                            [
                                12.548938491212168,
                                42.382328577805872
                            ],
                            [
                                12.567070060160077,
                                42.383345412719073
                            ],
                            [
                                12.606069650995668,
                                42.403528456744532
                            ],
                            [
                                12.614891056327354,
                                42.414481748501885
                            ],
                            [
                                12.614806033435563,
                                42.465106511983414
                            ],
                            [
                                12.641086004783993,
                                42.467803236963725
                            ],
                            [
                                12.649495273755013,
                                42.443309523514465
                            ],
                            [
                                12.674647224803945,
                                42.442419325507387
                            ],
                            [
                                12.702787055529145,
                                42.460898554604761
                            ],
                            [
                                12.724694179168647,
                                42.460409752594458
                            ],
                            [
                                12.741563894025839,
                                42.470533938096779
                            ],
                            [
                                12.711135495661619,
                                42.500794340007417
                            ],
                            [
                                12.7275869004851,
                                42.509139134590669
                            ],
                            [
                                12.773542707222923,
                                42.513093982393848
                            ],
                            [
                                12.773202311559992,
                                42.531279907444109
                            ],
                            [
                                12.818034248555151,
                                42.532936611116781
                            ],
                            [
                                12.847829090186307,
                                42.552803894143494
                            ],
                            [
                                12.892727851230447,
                                42.56350034000338
                            ],
                            [
                                12.880524106370261,
                                42.609347588747205
                            ],
                            [
                                12.896336554364753,
                                42.616442091074383
                            ],
                            [
                                12.930122739119607,
                                42.602882283343085
                            ],
                            [
                                12.937451508687282,
                                42.615357197902924
                            ],
                            [
                                12.95250181427137,
                                42.618925877418306
                            ],
                            [
                                13.004317773803855,
                                42.61523736085578
                            ],
                            [
                                13.024284670154191,
                                42.639036117865878
                            ],
                            [
                                13.035730935957272,
                                42.627999388720376
                            ],
                            [
                                13.063303295890748,
                                42.623309126728408
                            ],
                            [
                                13.105119934352006,
                                42.639661138192778
                            ],
                            [
                                13.116837825494745,
                                42.657098661747284
                            ],
                            [
                                13.129074963678097,
                                42.659570146721748
                            ],
                            [
                                13.145516786761721,
                                42.646176643264013
                            ],
                            [
                                13.174129779055413,
                                42.66612151637964
                            ],
                            [
                                13.17333512227002,
                                42.68731388129342
                            ],
                            [
                                13.190712784400743,
                                42.710444926913269
                            ],
                            [
                                13.189209844865642,
                                42.733589662255916
                            ],
                            [
                                13.254152452718859,
                                42.721452132804636
                            ],
                            [
                                13.26449887700783,
                                42.740185490331477
                            ],
                            [
                                13.280042777319588,
                                42.740968595938071
                            ],
                            [
                                13.313262579775056,
                                42.725985290538965
                            ],
                            [
                                13.357757377923434,
                                42.694094069309664
                            ],
                            [
                                13.349682737927941,
                                42.668716734599101
                            ],
                            [
                                13.369918595005752,
                                42.648968148501126
                            ],
                            [
                                13.408283301291229,
                                42.642863522592272
                            ],
                            [
                                13.390351594339815,
                                42.608491609910295
                            ],
                            [
                                13.394013451958379,
                                42.591258603934051
                            ],
                            [
                                13.381779339088018,
                                42.58101445260467
                            ],
                            [
                                13.342825213995619,
                                42.574901460934207
                            ],
                            [
                                13.323091001950019,
                                42.579750244113995
                            ],
                            [
                                13.293284080917177,
                                42.569537653054716
                            ],
                            [
                                13.283619592040955,
                                42.582523003737087
                            ],
                            [
                                13.253804319595316,
                                42.581965695139218
                            ],
                            [
                                13.245935611881956,
                                42.572705298201342
                            ],
                            [
                                13.226788576140038,
                                42.582836764318749
                            ],
                            [
                                13.191364186797788,
                                42.587515304268621
                            ],
                            [
                                13.192271648898595,
                                42.577966702558619
                            ],
                            [
                                13.174274564719029,
                                42.567514433985394
                            ],
                            [
                                13.176812761445543,
                                42.547321101428437
                            ],
                            [
                                13.155803549623077,
                                42.540048295735637
                            ],
                            [
                                13.160542275544122,
                                42.522014930500823
                            ],
                            [
                                13.177772391476511,
                                42.512635398483944
                            ],
                            [
                                13.171404408008826,
                                42.485122843862726
                            ],
                            [
                                13.178421306111971,
                                42.479340010387304
                            ],
                            [
                                13.116170638833314,
                                42.443908153982207
                            ],
                            [
                                13.155165212768273,
                                42.414214911123949
                            ],
                            [
                                13.189201951994566,
                                42.400220117942609
                            ],
                            [
                                13.194158137142809,
                                42.389193545912491
                            ],
                            [
                                13.15334899638421,
                                42.356994098511329
                            ],
                            [
                                13.226462976043926,
                                42.31933055998249
                            ],
                            [
                                13.23461514583305,
                                42.277865645091055
                            ],
                            [
                                13.271242872839318,
                                42.25416338037067
                            ],
                            [
                                13.276660706788325,
                                42.241666453662113
                            ],
                            [
                                13.335622893319321,
                                42.222401478131864
                            ],
                            [
                                13.341069214022919,
                                42.217394715467854
                            ],
                            [
                                13.331890240372479,
                                42.208180424913309
                            ],
                            [
                                13.341473874852523,
                                42.198413012295909
                            ],
                            [
                                13.3798894133772,
                                42.180447482888617
                            ],
                            [
                                13.342366050985049,
                                42.176810705741779
                            ],
                            [
                                13.353959186401763,
                                42.166718453663407
                            ],
                            [
                                13.327270071666927,
                                42.163858539886327
                            ],
                            [
                                13.328753724276817,
                                42.154920229970514
                            ],
                            [
                                13.317483830193781,
                                42.153652979494574
                            ],
                            [
                                13.305290674482569,
                                42.138256326456791
                            ],
                            [
                                13.265001573921893,
                                42.136788063978784
                            ],
                            [
                                13.248778851570274,
                                42.127428251667148
                            ],
                            [
                                13.192711203022855,
                                42.158257547920478
                            ],
                            [
                                13.169710583034661,
                                42.150706975557604
                            ],
                            [
                                13.123417991026676,
                                42.17699405152878
                            ],
                            [
                                13.087058574016083,
                                42.177868298454882
                            ],
                            [
                                13.093482748460948,
                                42.160649626704924
                            ],
                            [
                                13.084839299011126,
                                42.142198256662319
                            ],
                            [
                                13.059821988176592,
                                42.12295452081792
                            ],
                            [
                                13.03077842134889,
                                42.122101418202632
                            ],
                            [
                                13.018487896923602,
                                42.07493818837407
                            ],
                            [
                                13.026621707390849,
                                42.050027638020175
                            ],
                            [
                                13.064832967309851,
                                42.01243513160486
                            ],
                            [
                                13.101024800057168,
                                42.007989661761059
                            ],
                            [
                                13.09661247847426,
                                42.021946351269555
                            ],
                            [
                                13.104972334622522,
                                42.025996173064669
                            ],
                            [
                                13.199082167563075,
                                41.986496254697819
                            ],
                            [
                                13.230563459906277,
                                41.98213889675678
                            ],
                            [
                                13.287218329393944,
                                41.949892448120671
                            ],
                            [
                                13.31030039471363,
                                41.951619720640402
                            ],
                            [
                                13.345495086072876,
                                41.922175805117448
                            ],
                            [
                                13.364374027801448,
                                41.924753827764278
                            ],
                            [
                                13.383996004322618,
                                41.904187344529717
                            ],
                            [
                                13.359835248988645,
                                41.869376925399301
                            ],
                            [
                                13.367279391384745,
                                41.863326524266149
                            ],
                            [
                                13.366831845477931,
                                41.833070825278845
                            ],
                            [
                                13.380518808288294,
                                41.817085879591026
                            ],
                            [
                                13.391514395271962,
                                41.819785071442411
                            ],
                            [
                                13.396303381693816,
                                41.834034801645565
                            ],
                            [
                                13.416902281353995,
                                41.834665593241738
                            ],
                            [
                                13.451558727739299,
                                41.822820525183573
                            ],
                            [
                                13.469706410294792,
                                41.80662928050203
                            ],
                            [
                                13.505081716576495,
                                41.801598021997052
                            ],
                            [
                                13.520435634984652,
                                41.772967874810213
                            ],
                            [
                                13.571815490711186,
                                41.754297630255884
                            ],
                            [
                                13.631268411565124,
                                41.782645330973104
                            ],
                            [
                                13.647731986049113,
                                41.811006578984035
                            ],
                            [
                                13.662887610321011,
                                41.81126886628266
                            ],
                            [
                                13.705550205497582,
                                41.787466697225199
                            ],
                            [
                                13.729562459142684,
                                41.79890021263374
                            ],
                            [
                                13.749457215702499,
                                41.760585646049925
                            ],
                            [
                                13.76591219856058,
                                41.7487024090847
                            ],
                            [
                                13.790157915095662,
                                41.742972522810625
                            ],
                            [
                                13.811618302192269,
                                41.754261316561987
                            ],
                            [
                                13.823484599731326,
                                41.740883287579074
                            ],
                            [
                                13.856449336020717,
                                41.731238381589023
                            ],
                            [
                                13.880585010312716,
                                41.728297095488479
                            ],
                            [
                                13.891707682230216,
                                41.735148637189752
                            ],
                            [
                                13.904455075864531,
                                41.718191288033594
                            ],
                            [
                                13.919307212552571,
                                41.717863707423632
                            ],
                            [
                                13.932468558187605,
                                41.693327074789927
                            ],
                            [
                                13.988294014206573,
                                41.653832027437389
                            ],
                            [
                                14.010990417087932,
                                41.607538593519735
                            ],
                            [
                                13.998947765602072,
                                41.574477953281011
                            ],
                            [
                                14.026012493140737,
                                41.555325133923681
                            ],
                            [
                                14.020702036428212,
                                41.542363524591266
                            ],
                            [
                                14.005257068002045,
                                41.538753155703979
                            ],
                            [
                                14.027500409693411,
                                41.523208791858792
                            ],
                            [
                                13.994726106924254,
                                41.512922903368725
                            ],
                            [
                                13.972906886805166,
                                41.494036408165329
                            ],
                            [
                                13.992776628934616,
                                41.482081463058385
                            ],
                            [
                                13.977904751137292,
                                41.462486710550444
                            ],
                            [
                                13.961234867431738,
                                41.463943862882978
                            ],
                            [
                                13.910859213106965,
                                41.428685360732395
                            ],
                            [
                                13.875139867062758,
                                41.426416370026928
                            ],
                            [
                                13.861231937044392,
                                41.417633709669438
                            ],
                            [
                                13.88631835771281,
                                41.38444426176266
                            ],
                            [
                                13.873857503279959,
                                41.375304309543516
                            ],
                            [
                                13.870811702157097,
                                41.357089044098373
                            ],
                            [
                                13.873679891043986,
                                41.335624624806862
                            ],
                            [
                                13.894814804093558,
                                41.311636548749597
                            ],
                            [
                                13.886687927127193,
                                41.293615639712243
                            ],
                            [
                                13.828429541214378,
                                41.281034477472936
                            ],
                            [
                                13.840121860004805,
                                41.262540209744252
                            ],
                            [
                                13.833525239128072,
                                41.252202790654636
                            ],
                            [
                                13.816865153340357,
                                41.243683754715001
                            ],
                            [
                                13.771971216977365,
                                41.242103814719464
                            ],
                            [
                                13.762112591802691,
                                41.222596721145614
                            ],
                            [
                                13.706852688555049,
                                41.25393134971371
                            ],
                            [
                                13.681952050348237,
                                41.244126134693921
                            ],
                            [
                                13.65340571654402,
                                41.257217960221269
                            ],
                            [
                                13.621035881936471,
                                41.260720924610062
                            ],
                            [
                                13.574000589820054,
                                41.240364535264455
                            ],
                            [
                                13.571578058650601,
                                41.216166735198492
                            ],
                            [
                                13.59125383459538,
                                41.209148693724124
                            ],
                            [
                                13.575590524043214,
                                41.203920489144302
                            ],
                            [
                                13.557818282873971,
                                41.211263809919082
                            ],
                            [
                                13.549371596262429,
                                41.206746532723884
                            ],
                            [
                                13.523553314804749,
                                41.22304728188017
                            ],
                            [
                                13.4701575958739,
                                41.23745285509127
                            ],
                            [
                                13.379348438906163,
                                41.27973096664148
                            ],
                            [
                                13.291613719520363,
                                41.297520183921279
                            ],
                            [
                                13.268607276237166,
                                41.29572149143749
                            ],
                            [
                                13.251526661255193,
                                41.283202035340423
                            ],
                            [
                                13.207467529322594,
                                41.283332481863219
                            ],
                            [
                                13.160478944521435,
                                41.271235310217229
                            ],
                            [
                                13.105394777697231,
                                41.241218603726516
                            ],
                            [
                                13.094520918783839,
                                41.22443295300797
                            ],
                            [
                                13.045546949952136,
                                41.226785703184213
                            ],
                            [
                                12.989591568695005,
                                41.325262033163391
                            ],
                            [
                                12.950100463320872,
                                41.362340997065878
                            ],
                            [
                                12.903295728349855,
                                41.390837542257898
                            ],
                            [
                                12.840839429983703,
                                41.414335636416233
                            ],
                            [
                                12.780789087162704,
                                41.417786034797217
                            ],
                            [
                                12.765493520091473,
                                41.41013448746321
                            ],
                            [
                                12.672967098701022,
                                41.455798280596589
                            ],
                            [
                                12.622405227476035,
                                41.444589199642557
                            ]
                        ],
                        [
                            [
                                12.65044920776125,
                                41.747801677696494
                            ],
                            [
                                12.648408385130434,
                                41.746587888349978
                            ],
                            [
                                12.654901813774442,
                                41.734670366156926
                            ],
                            [
                                12.66039377854135,
                                41.735348811381463
                            ],
                            [
                                12.65044920776125,
                                41.747801677696494
                            ]
                        ],
                        [
                            [
                                12.457703539463038,
                                41.905948846468284
                            ],
                            [
                                12.450444389112327,
                                41.906518096668243
                            ],
                            [
                                12.44569032808363,
                                41.901989711873107
                            ],
                            [
                                12.456481260088587,
                                41.900450750355276
                            ],
                            [
                                12.457703539463038,
                                41.905948846468284
                            ]
                        ],
                        [
                            [
                                12.661699018889635,
                                41.45450489146922
                            ],
                            [
                                12.663292235243494,
                                41.454585325316501
                            ],
                            [
                                12.663290219100855,
                                41.454641362944429
                            ],
                            [
                                12.661699018889635,
                                41.45450489146922
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.967390369071669,
                                40.921282205567692
                            ],
                            [
                                12.959037338267491,
                                40.896454178869483
                            ],
                            [
                                12.967256190556611,
                                40.89353727609366
                            ],
                            [
                                12.954336527863763,
                                40.879816441062054
                            ],
                            [
                                12.947885569826965,
                                40.887025854415576
                            ],
                            [
                                12.954139275485064,
                                40.894929496153352
                            ],
                            [
                                12.942342269817892,
                                40.900791192286647
                            ],
                            [
                                12.949086371898465,
                                40.91745841589367
                            ],
                            [
                                12.982097838837539,
                                40.935835583468744
                            ],
                            [
                                12.994969186688074,
                                40.933989333222719
                            ],
                            [
                                12.967390369071669,
                                40.921282205567692
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                13.427481454312847,
                                40.789842416157882
                            ],
                            [
                                13.414154075510524,
                                40.784870259740245
                            ],
                            [
                                13.407600299445409,
                                40.785535483882164
                            ],
                            [
                                13.431040297904644,
                                40.803860636670372
                            ],
                            [
                                13.427481454312847,
                                40.789842416157882
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.86028179948654,
                                40.929741050428895
                            ],
                            [
                                12.851246506723964,
                                40.925707552747703
                            ],
                            [
                                12.856542058236865,
                                40.941154593038306
                            ],
                            [
                                12.854202119676692,
                                40.94961241404765
                            ],
                            [
                                12.86028179948654,
                                40.929741050428895
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                13.058741376512648,
                                40.965248300503482
                            ],
                            [
                                13.050788536311487,
                                40.965429415546701
                            ],
                            [
                                13.048089708082069,
                                40.970598712894983
                            ],
                            [
                                13.061566984647323,
                                40.973451259333345
                            ],
                            [
                                13.058741376512648,
                                40.965248300503482
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                13.455262125887632,
                                40.787186216607438
                            ],
                            [
                                13.450906535696994,
                                40.788232571651989
                            ],
                            [
                                13.452457583404495,
                                40.792278653291724
                            ],
                            [
                                13.458983646844057,
                                40.789883076669184
                            ],
                            [
                                13.455262125887632,
                                40.787186216607438
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                13.000290347934309,
                                40.932723951032955
                            ],
                            [
                                12.99766215789481,
                                40.935705890424209
                            ],
                            [
                                13.003540834860862,
                                40.937509745952177
                            ],
                            [
                                13.003534453204157,
                                40.935146119121633
                            ],
                            [
                                13.000290347934309,
                                40.932723951032955
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.848003525217734,
                                40.924095949029343
                            ],
                            [
                                12.849470476433275,
                                40.923200416171518
                            ],
                            [
                                12.84739490714823,
                                40.922598888683694
                            ],
                            [
                                12.847768069553458,
                                40.925215986057239
                            ],
                            [
                                12.848003525217734,
                                40.924095949029343
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.848697793386169,
                                40.919876240128026
                            ],
                            [
                                12.847699366848486,
                                40.921670160112292
                            ],
                            [
                                12.848884256101261,
                                40.922396017280484
                            ],
                            [
                                12.84982428696649,
                                40.921500074659939
                            ],
                            [
                                12.848697793386169,
                                40.919876240128026
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.850116376672908,
                                40.943846122421867
                            ],
                            [
                                12.85079642196718,
                                40.94365678310222
                            ],
                            [
                                12.850483075959939,
                                40.942519077845709
                            ],
                            [
                                12.849764546825302,
                                40.942723220896767
                            ],
                            [
                                12.850116376672908,
                                40.943846122421867
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.852734855110443,
                                40.942425726980282
                            ],
                            [
                                12.851831090824586,
                                40.942469486064617
                            ],
                            [
                                12.85284362602531,
                                40.943606291648244
                            ],
                            [
                                12.853437244867013,
                                40.943194695275338
                            ],
                            [
                                12.852734855110443,
                                40.942425726980282
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.965648063612097,
                                40.883997598287664
                            ],
                            [
                                12.964524658518055,
                                40.884446022515
                            ],
                            [
                                12.964864506650347,
                                40.885379879636822
                            ],
                            [
                                12.965476733055571,
                                40.885039111516726
                            ],
                            [
                                12.965648063612097,
                                40.883997598287664
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.846675793018283,
                                40.921204554562735
                            ],
                            [
                                12.846558494740535,
                                40.921982932244603
                            ],
                            [
                                12.847639735914459,
                                40.922099901920234
                            ],
                            [
                                12.847608200497834,
                                40.921722726255439
                            ],
                            [
                                12.846675793018283,
                                40.921204554562735
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.851120303266176,
                                40.920371585121664
                            ],
                            [
                                12.850799278616256,
                                40.920465619765956
                            ],
                            [
                                12.850616804590084,
                                40.921347497577088
                            ],
                            [
                                12.851116133157749,
                                40.921155183080288
                            ],
                            [
                                12.851120303266176,
                                40.920371585121664
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                13.104284306526083,
                                40.838783503162219
                            ],
                            [
                                13.103659115791688,
                                40.838859818767062
                            ],
                            [
                                13.103461165739626,
                                40.839326123113587
                            ],
                            [
                                13.104057707891062,
                                40.839205812356639
                            ],
                            [
                                13.104284306526083,
                                40.838783503162219
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.622332990309868,
                                41.444447402836602
                            ],
                            [
                                12.622405227476035,
                                41.444589199642557
                            ],
                            [
                                12.622317271957245,
                                41.444312815706446
                            ],
                            [
                                12.622332990309868,
                                41.444447402836602
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.634517648727396,
                                41.4469915131723
                            ],
                            [
                                12.634588619260658,
                                41.446802416389453
                            ],
                            [
                                12.634576134953363,
                                41.446589167551465
                            ],
                            [
                                12.634517648727396,
                                41.4469915131723
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 14,
                "name": "Abruzzo",
                "length": 614513.705789,
                "area": 10829102919.5
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            13.920265186431294,
                            42.890047291768866
                        ],
                        [
                            13.944062026871537,
                            42.804141746755214
                        ],
                        [
                            13.973292139913616,
                            42.750904522084632
                        ],
                        [
                            13.97465366834636,
                            42.752612028828636
                        ],
                        [
                            13.979009984869238,
                            42.754074244523657
                        ],
                        [
                            13.995827516687967,
                            42.708337611514288
                        ],
                        [
                            14.110169865376367,
                            42.562546431915536
                        ],
                        [
                            14.185687502123475,
                            42.494197634466694
                        ],
                        [
                            14.255896939273155,
                            42.443689010652683
                        ],
                        [
                            14.409916357892541,
                            42.358090004366048
                        ],
                        [
                            14.425954521479207,
                            42.325914020525701
                        ],
                        [
                            14.500877909043515,
                            42.273205969919921
                        ],
                        [
                            14.509599963123888,
                            42.251549766262691
                        ],
                        [
                            14.620787250019308,
                            42.199270721297836
                        ],
                        [
                            14.69891590572694,
                            42.174464808128462
                        ],
                        [
                            14.710529204147678,
                            42.172303315003077
                        ],
                        [
                            14.711700340508402,
                            42.177702237973243
                        ],
                        [
                            14.720252866037116,
                            42.155571073131057
                        ],
                        [
                            14.718351755367339,
                            42.105669512468367
                        ],
                        [
                            14.744309372810372,
                            42.084483525776491
                        ],
                        [
                            14.779549200142695,
                            42.069826081792947
                        ],
                        [
                            14.760802232577264,
                            42.04220495783543
                        ],
                        [
                            14.783013556714099,
                            42.033792700640035
                        ],
                        [
                            14.764313016418278,
                            42.01722800942828
                        ],
                        [
                            14.724130415710203,
                            42.000463189612155
                        ],
                        [
                            14.668636494345746,
                            41.946630587936156
                        ],
                        [
                            14.663763348735854,
                            41.916289054251699
                        ],
                        [
                            14.614244505898746,
                            41.88918843000998
                        ],
                        [
                            14.59770559600601,
                            41.851040228332074
                        ],
                        [
                            14.567979068531411,
                            41.81811950085703
                        ],
                        [
                            14.550771429146947,
                            41.816587365378588
                        ],
                        [
                            14.53095444452951,
                            41.80068808243395
                        ],
                        [
                            14.528864370128767,
                            41.786999080798637
                        ],
                        [
                            14.489545159963896,
                            41.760969850562688
                        ],
                        [
                            14.454787887021157,
                            41.7633550368516
                        ],
                        [
                            14.465140207706643,
                            41.777175302825093
                        ],
                        [
                            14.442328667177264,
                            41.841255617293477
                        ],
                        [
                            14.43236986232321,
                            41.841152334258936
                        ],
                        [
                            14.397448091146924,
                            41.869743438823868
                        ],
                        [
                            14.378869612898351,
                            41.865873356560542
                        ],
                        [
                            14.37667570204353,
                            41.879928722102242
                        ],
                        [
                            14.361376176410419,
                            41.874602428926437
                        ],
                        [
                            14.358137329816941,
                            41.859949412926625
                        ],
                        [
                            14.343005915201335,
                            41.862521430874324
                        ],
                        [
                            14.323887053864468,
                            41.896292193073648
                        ],
                        [
                            14.303981502829902,
                            41.893389873827182
                        ],
                        [
                            14.284195826352084,
                            41.910777905739877
                        ],
                        [
                            14.226873749492862,
                            41.874797778350732
                        ],
                        [
                            14.216626651330083,
                            41.853437889202112
                        ],
                        [
                            14.195454242419313,
                            41.848165833535809
                        ],
                        [
                            14.195017716896102,
                            41.841535592589388
                        ],
                        [
                            14.155623086755918,
                            41.839612345813876
                        ],
                        [
                            14.147163798458388,
                            41.82729576638453
                        ],
                        [
                            14.164451447900554,
                            41.809878981715649
                        ],
                        [
                            14.171454322221317,
                            41.778435845504305
                        ],
                        [
                            14.201918971667919,
                            41.766996103062269
                        ],
                        [
                            14.194177400749361,
                            41.748144377939454
                        ],
                        [
                            14.178707206187321,
                            41.749216723120846
                        ],
                        [
                            14.171834045407637,
                            41.765774246162586
                        ],
                        [
                            14.15867746998099,
                            41.747024737159272
                        ],
                        [
                            14.121930647670238,
                            41.746480924366665
                        ],
                        [
                            14.115265280727762,
                            41.736933959931015
                        ],
                        [
                            14.123277695731332,
                            41.726069638489605
                        ],
                        [
                            14.107194433811047,
                            41.707362168312265
                        ],
                        [
                            14.094401627753767,
                            41.737941360270369
                        ],
                        [
                            14.069570899720752,
                            41.737225372646051
                        ],
                        [
                            14.053076088825993,
                            41.719035498470383
                        ],
                        [
                            14.053246212650933,
                            41.701698676242685
                        ],
                        [
                            14.026922796275521,
                            41.702701594490286
                        ],
                        [
                            14.018726566991409,
                            41.682106072011855
                        ],
                        [
                            13.981923607080041,
                            41.695140878003564
                        ],
                        [
                            13.95513160182654,
                            41.695469318285326
                        ],
                        [
                            13.940482080721354,
                            41.688165282010544
                        ],
                        [
                            13.919307212552571,
                            41.717863707423632
                        ],
                        [
                            13.904455075864531,
                            41.718191288033594
                        ],
                        [
                            13.891707682230216,
                            41.735148637189752
                        ],
                        [
                            13.880585010312716,
                            41.728297095488479
                        ],
                        [
                            13.856449336020717,
                            41.731238381589023
                        ],
                        [
                            13.823484599731326,
                            41.740883287579074
                        ],
                        [
                            13.811618302192269,
                            41.754261316561987
                        ],
                        [
                            13.790157915095662,
                            41.742972522810625
                        ],
                        [
                            13.76591219856058,
                            41.7487024090847
                        ],
                        [
                            13.749457215702499,
                            41.760585646049925
                        ],
                        [
                            13.729562459142684,
                            41.79890021263374
                        ],
                        [
                            13.705550205497582,
                            41.787466697225199
                        ],
                        [
                            13.67996702478638,
                            41.804360319502678
                        ],
                        [
                            13.647731986049113,
                            41.811006578984035
                        ],
                        [
                            13.631268411565124,
                            41.782645330973104
                        ],
                        [
                            13.571815490711186,
                            41.754297630255884
                        ],
                        [
                            13.520435634984652,
                            41.772967874810213
                        ],
                        [
                            13.505081716576495,
                            41.801598021997052
                        ],
                        [
                            13.469706410294792,
                            41.80662928050203
                        ],
                        [
                            13.451558727739299,
                            41.822820525183573
                        ],
                        [
                            13.416902281353995,
                            41.834665593241738
                        ],
                        [
                            13.396303381693816,
                            41.834034801645565
                        ],
                        [
                            13.391514395271962,
                            41.819785071442411
                        ],
                        [
                            13.379521067187122,
                            41.8174571406987
                        ],
                        [
                            13.366831845477931,
                            41.833070825278845
                        ],
                        [
                            13.367279391384745,
                            41.863326524266149
                        ],
                        [
                            13.359835248988645,
                            41.869376925399301
                        ],
                        [
                            13.383996004322618,
                            41.904187344529717
                        ],
                        [
                            13.365247331489442,
                            41.924135315869201
                        ],
                        [
                            13.345495086072876,
                            41.922175805117448
                        ],
                        [
                            13.31030039471363,
                            41.951619720640402
                        ],
                        [
                            13.287218329393944,
                            41.949892448120671
                        ],
                        [
                            13.230563459906277,
                            41.98213889675678
                        ],
                        [
                            13.199082167563075,
                            41.986496254697819
                        ],
                        [
                            13.104972334622522,
                            42.025996173064669
                        ],
                        [
                            13.09661247847426,
                            42.021946351269555
                        ],
                        [
                            13.101024800057168,
                            42.007989661761059
                        ],
                        [
                            13.064832967309851,
                            42.01243513160486
                        ],
                        [
                            13.026621707390849,
                            42.050027638020175
                        ],
                        [
                            13.018487896923602,
                            42.07493818837407
                        ],
                        [
                            13.03077842134889,
                            42.122101418202632
                        ],
                        [
                            13.059821988176592,
                            42.12295452081792
                        ],
                        [
                            13.084839299011126,
                            42.142198256662319
                        ],
                        [
                            13.093482748460948,
                            42.160649626704924
                        ],
                        [
                            13.087058574016083,
                            42.177868298454882
                        ],
                        [
                            13.123417991026676,
                            42.17699405152878
                        ],
                        [
                            13.169710583034661,
                            42.150706975557604
                        ],
                        [
                            13.192711203022855,
                            42.158257547920478
                        ],
                        [
                            13.248778851570274,
                            42.127428251667148
                        ],
                        [
                            13.265001573921893,
                            42.136788063978784
                        ],
                        [
                            13.305290674482569,
                            42.138256326456791
                        ],
                        [
                            13.317483830193781,
                            42.153652979494574
                        ],
                        [
                            13.328753724276817,
                            42.154920229970514
                        ],
                        [
                            13.327270071666927,
                            42.163858539886327
                        ],
                        [
                            13.353959186401763,
                            42.166718453663407
                        ],
                        [
                            13.342366050985049,
                            42.176810705741779
                        ],
                        [
                            13.3798894133772,
                            42.180447482888617
                        ],
                        [
                            13.341473874852523,
                            42.198413012295909
                        ],
                        [
                            13.331890240372479,
                            42.208180424913309
                        ],
                        [
                            13.341069214022919,
                            42.217394715467854
                        ],
                        [
                            13.335622893319321,
                            42.222401478131864
                        ],
                        [
                            13.276660706788325,
                            42.241666453662113
                        ],
                        [
                            13.271242872839318,
                            42.25416338037067
                        ],
                        [
                            13.23461514583305,
                            42.277865645091055
                        ],
                        [
                            13.226462976043926,
                            42.31933055998249
                        ],
                        [
                            13.15334899638421,
                            42.356994098511329
                        ],
                        [
                            13.194158137142809,
                            42.389193545912491
                        ],
                        [
                            13.189201951994566,
                            42.400220117942609
                        ],
                        [
                            13.155165212768273,
                            42.414214911123949
                        ],
                        [
                            13.116170638833314,
                            42.443908153982207
                        ],
                        [
                            13.178421306111971,
                            42.479340010387304
                        ],
                        [
                            13.171404408008826,
                            42.485122843862726
                        ],
                        [
                            13.177772391476511,
                            42.512635398483944
                        ],
                        [
                            13.160542275544122,
                            42.522014930500823
                        ],
                        [
                            13.155803549623077,
                            42.540048295735637
                        ],
                        [
                            13.176812761445543,
                            42.547321101428437
                        ],
                        [
                            13.174274564719029,
                            42.567514433985394
                        ],
                        [
                            13.192271648898595,
                            42.577966702558619
                        ],
                        [
                            13.191364186797788,
                            42.587515304268621
                        ],
                        [
                            13.226788576140038,
                            42.582836764318749
                        ],
                        [
                            13.245935611881956,
                            42.572705298201342
                        ],
                        [
                            13.253804319595316,
                            42.581965695139218
                        ],
                        [
                            13.283619592040955,
                            42.582523003737087
                        ],
                        [
                            13.293284080917177,
                            42.569537653054716
                        ],
                        [
                            13.323091001950019,
                            42.579750244113995
                        ],
                        [
                            13.342825213995619,
                            42.574901460934207
                        ],
                        [
                            13.381779339088018,
                            42.58101445260467
                        ],
                        [
                            13.394013451958379,
                            42.591258603934051
                        ],
                        [
                            13.394681455362145,
                            42.621701454556188
                        ],
                        [
                            13.409745125566316,
                            42.639046738547648
                        ],
                        [
                            13.369918595005752,
                            42.648968148501126
                        ],
                        [
                            13.349682737927941,
                            42.668716734599101
                        ],
                        [
                            13.358862573843028,
                            42.695827103548773
                        ],
                        [
                            13.389981287881113,
                            42.687156064446306
                        ],
                        [
                            13.427396929779411,
                            42.706425287723974
                        ],
                        [
                            13.436999932821285,
                            42.698921202110704
                        ],
                        [
                            13.447987373116666,
                            42.73221715063795
                        ],
                        [
                            13.493443722009962,
                            42.736615385060709
                        ],
                        [
                            13.504615489128234,
                            42.747599508204857
                        ],
                        [
                            13.50420649207895,
                            42.774740124730982
                        ],
                        [
                            13.529733382633669,
                            42.79598926458074
                        ],
                        [
                            13.534499894745869,
                            42.816649938083188
                        ],
                        [
                            13.572247604869501,
                            42.800373199410785
                        ],
                        [
                            13.624398863148985,
                            42.816541728357372
                        ],
                        [
                            13.635516359759826,
                            42.80330238088154
                        ],
                        [
                            13.663599828555302,
                            42.807127373191335
                        ],
                        [
                            13.699303303375498,
                            42.822615594365509
                        ],
                        [
                            13.706602169718991,
                            42.849312057740306
                        ],
                        [
                            13.722478311414351,
                            42.855353554637809
                        ],
                        [
                            13.777964718765846,
                            42.860445481771023
                        ],
                        [
                            13.81931597997955,
                            42.878907331688978
                        ],
                        [
                            13.874872141756429,
                            42.888859818064788
                        ],
                        [
                            13.876852722538111,
                            42.894714849096133
                        ],
                        [
                            13.920265186431294,
                            42.890047291768866
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 15,
                "name": "Molise",
                "length": 433874.67797,
                "area": 4461149496.359999656677246
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            14.846753503472348,
                            42.039367294323
                        ],
                        [
                            14.900207962512184,
                            42.021371203821033
                        ],
                        [
                            14.993590831511503,
                            42.004786676863922
                        ],
                        [
                            15.079136205753377,
                            41.94264724227893
                        ],
                        [
                            15.138045716378885,
                            41.926645120756845
                        ],
                        [
                            15.131238081236829,
                            41.900848197875554
                        ],
                        [
                            15.138799086136043,
                            41.879280874243499
                        ],
                        [
                            15.100985806702472,
                            41.837481032709569
                        ],
                        [
                            15.116443102027457,
                            41.814535307415532
                        ],
                        [
                            15.115994532171628,
                            41.799063682280753
                        ],
                        [
                            15.097026000643053,
                            41.767401307476419
                        ],
                        [
                            15.116545693077578,
                            41.748962678392424
                        ],
                        [
                            15.103276241249715,
                            41.749038716239539
                        ],
                        [
                            15.101883369403334,
                            41.74276260763191
                        ],
                        [
                            15.120903801761342,
                            41.72039174836835
                        ],
                        [
                            15.161499251175616,
                            41.709388252437748
                        ],
                        [
                            15.117067669492435,
                            41.693750735844183
                        ],
                        [
                            15.102457167474158,
                            41.67205891174239
                        ],
                        [
                            15.08992901166668,
                            41.681821701304621
                        ],
                        [
                            15.089959130722361,
                            41.671995245194893
                        ],
                        [
                            15.050248232040683,
                            41.657313009891844
                        ],
                        [
                            15.045177537020539,
                            41.636949786053272
                        ],
                        [
                            15.025987635653786,
                            41.634567627326838
                        ],
                        [
                            15.025496771400739,
                            41.62232010937317
                        ],
                        [
                            15.008330918148987,
                            41.622294774152017
                        ],
                        [
                            14.990470049320642,
                            41.629670857829126
                        ],
                        [
                            14.988703293098499,
                            41.637806023758465
                        ],
                        [
                            14.959532594317533,
                            41.64603822386065
                        ],
                        [
                            14.934236210573776,
                            41.6201130995331
                        ],
                        [
                            14.947801240216897,
                            41.608639232958154
                        ],
                        [
                            14.95030992691369,
                            41.592661819350063
                        ],
                        [
                            14.937151484409215,
                            41.527475990662587
                        ],
                        [
                            14.966393579493774,
                            41.519003486364547
                        ],
                        [
                            15.007621762083044,
                            41.486387440373115
                        ],
                        [
                            14.946894506417022,
                            41.456084096368457
                        ],
                        [
                            14.884420392087334,
                            41.444779761714081
                        ],
                        [
                            14.856560413473847,
                            41.424751027587469
                        ],
                        [
                            14.784939316072949,
                            41.452093367280376
                        ],
                        [
                            14.77130311139943,
                            41.441852426936805
                        ],
                        [
                            14.764700378653206,
                            41.417368054233464
                        ],
                        [
                            14.716859746707131,
                            41.400776628732125
                        ],
                        [
                            14.685548524960566,
                            41.411335211773462
                        ],
                        [
                            14.660852803513425,
                            41.393153046758954
                        ],
                        [
                            14.643406851538959,
                            41.394021798215682
                        ],
                        [
                            14.603039215922035,
                            41.363962327282785
                        ],
                        [
                            14.566325770054886,
                            41.392130633618073
                        ],
                        [
                            14.55182053421276,
                            41.379429295360168
                        ],
                        [
                            14.505071938980855,
                            41.382496978763832
                        ],
                        [
                            14.488605932869863,
                            41.390708410511401
                        ],
                        [
                            14.477346172006412,
                            41.418978421790015
                        ],
                        [
                            14.427612935112982,
                            41.429107435859088
                        ],
                        [
                            14.412511455222152,
                            41.441225571862482
                        ],
                        [
                            14.400940640579091,
                            41.437199334192378
                        ],
                        [
                            14.327161977699934,
                            41.4534374127566
                        ],
                        [
                            14.284282299067248,
                            41.472104342639419
                        ],
                        [
                            14.292141459854649,
                            41.476336373638766
                        ],
                        [
                            14.27913070168249,
                            41.486378295796563
                        ],
                        [
                            14.249421803846463,
                            41.484551894047804
                        ],
                        [
                            14.240745763761698,
                            41.497196922007596
                        ],
                        [
                            14.173788336345295,
                            41.50070496372723
                        ],
                        [
                            14.164664027251884,
                            41.478887983226144
                        ],
                        [
                            14.122622930896092,
                            41.507291348236322
                        ],
                        [
                            14.082412515866116,
                            41.465451266309145
                        ],
                        [
                            14.078369426473735,
                            41.447083954668109
                        ],
                        [
                            14.105229948648788,
                            41.423253820871878
                        ],
                        [
                            14.103436450376826,
                            41.402279996068273
                        ],
                        [
                            14.113666186564261,
                            41.388677874353647
                        ],
                        [
                            14.096102435580304,
                            41.39019519731584
                        ],
                        [
                            14.083463024864963,
                            41.400145969289348
                        ],
                        [
                            14.040951468112995,
                            41.393764973810626
                        ],
                        [
                            14.026578770989291,
                            41.416687232982184
                        ],
                        [
                            14.00070447961447,
                            41.430932208175385
                        ],
                        [
                            14.007040431577279,
                            41.45187506514516
                        ],
                        [
                            13.977904751137292,
                            41.462486710550444
                        ],
                        [
                            13.992776628934616,
                            41.482081463058385
                        ],
                        [
                            13.972690566834673,
                            41.493406554875506
                        ],
                        [
                            13.994726106924254,
                            41.512922903368725
                        ],
                        [
                            14.027500409693411,
                            41.523208791858792
                        ],
                        [
                            14.005257068002045,
                            41.538753155703979
                        ],
                        [
                            14.020702036428212,
                            41.542363524591266
                        ],
                        [
                            14.026012493140737,
                            41.555325133923681
                        ],
                        [
                            13.998819952495763,
                            41.574879668802588
                        ],
                        [
                            14.010990417087932,
                            41.607538593519735
                        ],
                        [
                            13.988294014206573,
                            41.653832027437389
                        ],
                        [
                            13.941015150170369,
                            41.687972748704787
                        ],
                        [
                            13.95513160182654,
                            41.695469318285326
                        ],
                        [
                            13.981923607080041,
                            41.695140878003564
                        ],
                        [
                            14.018726566991409,
                            41.682106072011855
                        ],
                        [
                            14.026922796275521,
                            41.702701594490286
                        ],
                        [
                            14.053246212650933,
                            41.701698676242685
                        ],
                        [
                            14.053076088825993,
                            41.719035498470383
                        ],
                        [
                            14.069570899720752,
                            41.737225372646051
                        ],
                        [
                            14.094401627753767,
                            41.737941360270369
                        ],
                        [
                            14.107194433811047,
                            41.707362168312265
                        ],
                        [
                            14.123277695731332,
                            41.726069638489605
                        ],
                        [
                            14.115265280727762,
                            41.736933959931015
                        ],
                        [
                            14.121930647670238,
                            41.746480924366665
                        ],
                        [
                            14.15867746998099,
                            41.747024737159272
                        ],
                        [
                            14.171834045407637,
                            41.765774246162586
                        ],
                        [
                            14.178707206187321,
                            41.749216723120846
                        ],
                        [
                            14.194177400749361,
                            41.748144377939454
                        ],
                        [
                            14.201918971667919,
                            41.766996103062269
                        ],
                        [
                            14.171454322221317,
                            41.778435845504305
                        ],
                        [
                            14.164451447900554,
                            41.809878981715649
                        ],
                        [
                            14.147163798458388,
                            41.82729576638453
                        ],
                        [
                            14.155623086755918,
                            41.839612345813876
                        ],
                        [
                            14.195017716896102,
                            41.841535592589388
                        ],
                        [
                            14.195454242419313,
                            41.848165833535809
                        ],
                        [
                            14.216626651330083,
                            41.853437889202112
                        ],
                        [
                            14.226873749492862,
                            41.874797778350732
                        ],
                        [
                            14.284195826352084,
                            41.910777905739877
                        ],
                        [
                            14.303981502829902,
                            41.893389873827182
                        ],
                        [
                            14.323887053864468,
                            41.896292193073648
                        ],
                        [
                            14.343005915201335,
                            41.862521430874324
                        ],
                        [
                            14.358137329816941,
                            41.859949412926625
                        ],
                        [
                            14.361376176410419,
                            41.874602428926437
                        ],
                        [
                            14.37667570204353,
                            41.879928722102242
                        ],
                        [
                            14.378869612898351,
                            41.865873356560542
                        ],
                        [
                            14.397448091146924,
                            41.869743438823868
                        ],
                        [
                            14.43236986232321,
                            41.841152334258936
                        ],
                        [
                            14.442328667177264,
                            41.841255617293477
                        ],
                        [
                            14.465140207706643,
                            41.777175302825093
                        ],
                        [
                            14.454787887021157,
                            41.7633550368516
                        ],
                        [
                            14.488840475756152,
                            41.760690791251619
                        ],
                        [
                            14.528864370128767,
                            41.786999080798637
                        ],
                        [
                            14.53095444452951,
                            41.80068808243395
                        ],
                        [
                            14.550771429146947,
                            41.816587365378588
                        ],
                        [
                            14.567979068531411,
                            41.81811950085703
                        ],
                        [
                            14.59770559600601,
                            41.851040228332074
                        ],
                        [
                            14.614244505898746,
                            41.88918843000998
                        ],
                        [
                            14.663763348735854,
                            41.916289054251699
                        ],
                        [
                            14.668636494345746,
                            41.946630587936156
                        ],
                        [
                            14.724130415710203,
                            42.000463189612155
                        ],
                        [
                            14.780152905348922,
                            42.029670426761896
                        ],
                        [
                            14.78224695341186,
                            42.03510521186108
                        ],
                        [
                            14.760802232577264,
                            42.04220495783543
                        ],
                        [
                            14.779549200142695,
                            42.069826081792947
                        ],
                        [
                            14.846753503472348,
                            42.039367294323
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 16,
                "name": "Campania",
                "length": 892379.131913,
                "area": 13663989800.100000381469727
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                14.039589806510197,
                                40.798316916569469
                            ],
                            [
                                14.045627051528657,
                                40.860838039163696
                            ],
                            [
                                14.016949201519557,
                                40.926911968000127
                            ],
                            [
                                13.978038121658033,
                                40.976601308287563
                            ],
                            [
                                13.922475316665174,
                                41.026536032087478
                            ],
                            [
                                13.896325580892238,
                                41.087234234618585
                            ],
                            [
                                13.835732189984915,
                                41.162798869814672
                            ],
                            [
                                13.762112591802691,
                                41.222596721145614
                            ],
                            [
                                13.771971216977365,
                                41.242103814719464
                            ],
                            [
                                13.816865153340357,
                                41.243683754715001
                            ],
                            [
                                13.833525239128072,
                                41.252202790654636
                            ],
                            [
                                13.840121860004805,
                                41.262540209744252
                            ],
                            [
                                13.828429541214378,
                                41.281034477472936
                            ],
                            [
                                13.88973957527929,
                                41.297483276325821
                            ],
                            [
                                13.894814804093558,
                                41.311636548749597
                            ],
                            [
                                13.873679891043986,
                                41.335624624806862
                            ],
                            [
                                13.870811702157097,
                                41.357089044098373
                            ],
                            [
                                13.873857503279959,
                                41.375304309543516
                            ],
                            [
                                13.88631835771281,
                                41.38444426176266
                            ],
                            [
                                13.861798813208882,
                                41.418086874470809
                            ],
                            [
                                13.875139867062758,
                                41.426416370026928
                            ],
                            [
                                13.910859213106965,
                                41.428685360732395
                            ],
                            [
                                13.965650814857016,
                                41.464072457118895
                            ],
                            [
                                14.007040431577279,
                                41.45187506514516
                            ],
                            [
                                14.00070447961447,
                                41.430932208175385
                            ],
                            [
                                14.026578770989291,
                                41.416687232982184
                            ],
                            [
                                14.042388564707089,
                                41.392780427030424
                            ],
                            [
                                14.084769185707234,
                                41.400034091113874
                            ],
                            [
                                14.111440628153693,
                                41.386434031663249
                            ],
                            [
                                14.105229948648788,
                                41.423253820871878
                            ],
                            [
                                14.078369426473735,
                                41.447083954668109
                            ],
                            [
                                14.082412515866116,
                                41.465451266309145
                            ],
                            [
                                14.125269995765905,
                                41.507369659998552
                            ],
                            [
                                14.164664027251884,
                                41.478887983226144
                            ],
                            [
                                14.173788336345295,
                                41.50070496372723
                            ],
                            [
                                14.240745763761698,
                                41.497196922007596
                            ],
                            [
                                14.249421803846463,
                                41.484551894047804
                            ],
                            [
                                14.27913070168249,
                                41.486378295796563
                            ],
                            [
                                14.292141459854649,
                                41.476336373638766
                            ],
                            [
                                14.284282299067248,
                                41.472104342639419
                            ],
                            [
                                14.327161977699934,
                                41.4534374127566
                            ],
                            [
                                14.400940640579091,
                                41.437199334192378
                            ],
                            [
                                14.412511455222152,
                                41.441225571862482
                            ],
                            [
                                14.427612935112982,
                                41.429107435859088
                            ],
                            [
                                14.477346172006412,
                                41.418978421790015
                            ],
                            [
                                14.488605932869863,
                                41.390708410511401
                            ],
                            [
                                14.505071938980855,
                                41.382496978763832
                            ],
                            [
                                14.55182053421276,
                                41.379429295360168
                            ],
                            [
                                14.566325770054886,
                                41.392130633618073
                            ],
                            [
                                14.603039215922035,
                                41.363962327282785
                            ],
                            [
                                14.643406851538959,
                                41.394021798215682
                            ],
                            [
                                14.660852803513425,
                                41.393153046758954
                            ],
                            [
                                14.685548524960566,
                                41.411335211773462
                            ],
                            [
                                14.716859746707131,
                                41.400776628732125
                            ],
                            [
                                14.764700378653206,
                                41.417368054233464
                            ],
                            [
                                14.77130311139943,
                                41.441852426936805
                            ],
                            [
                                14.784939316072949,
                                41.452093367280376
                            ],
                            [
                                14.856560413473847,
                                41.424751027587469
                            ],
                            [
                                14.884420392087334,
                                41.444779761714081
                            ],
                            [
                                14.946894506417022,
                                41.456084096368457
                            ],
                            [
                                15.007621762083044,
                                41.486387440373115
                            ],
                            [
                                15.023890046825803,
                                41.476947772572373
                            ],
                            [
                                15.032443002959532,
                                41.452684896472419
                            ],
                            [
                                15.043124222019429,
                                41.456762357696149
                            ],
                            [
                                15.046791619419237,
                                41.443341539686898
                            ],
                            [
                                15.100831550275982,
                                41.429667237949339
                            ],
                            [
                                15.103294141443691,
                                41.420940021668507
                            ],
                            [
                                15.086640895855851,
                                41.40722566192872
                            ],
                            [
                                15.098316307347954,
                                41.390567893767319
                            ],
                            [
                                15.058471033353257,
                                41.372135360347556
                            ],
                            [
                                15.072191154003765,
                                41.332464038534042
                            ],
                            [
                                15.130560162671413,
                                41.317185576019753
                            ],
                            [
                                15.126770580733929,
                                41.302951894096047
                            ],
                            [
                                15.149155740828267,
                                41.28044522516381
                            ],
                            [
                                15.200695549968771,
                                41.286354349663959
                            ],
                            [
                                15.199744306547514,
                                41.279448071995446
                            ],
                            [
                                15.21574487781513,
                                41.27594010888123
                            ],
                            [
                                15.220439556725825,
                                41.265187525734916
                            ],
                            [
                                15.24900367768188,
                                41.27099117856833
                            ],
                            [
                                15.275658458242869,
                                41.249535798835574
                            ],
                            [
                                15.279843905763123,
                                41.24079495833476
                            ],
                            [
                                15.246175047091498,
                                41.23611111972798
                            ],
                            [
                                15.262415058774248,
                                41.197626241468193
                            ],
                            [
                                15.223535566596293,
                                41.181941610523921
                            ],
                            [
                                15.209345454240415,
                                41.167686580049967
                            ],
                            [
                                15.210788464044903,
                                41.148670643745234
                            ],
                            [
                                15.23566285713248,
                                41.139882308662692
                            ],
                            [
                                15.264310621901142,
                                41.105320590489612
                            ],
                            [
                                15.291909052070279,
                                41.092773274980374
                            ],
                            [
                                15.31435718684236,
                                41.103885670099736
                            ],
                            [
                                15.367059139829831,
                                41.084806112193313
                            ],
                            [
                                15.401278667945389,
                                41.105978995326559
                            ],
                            [
                                15.446097031861854,
                                41.078016753902197
                            ],
                            [
                                15.478351224186506,
                                41.078661716019205
                            ],
                            [
                                15.542871313000477,
                                41.05585415596363
                            ],
                            [
                                15.563153936389751,
                                41.03102433632418
                            ],
                            [
                                15.559551747019729,
                                41.016974294489785
                            ],
                            [
                                15.572297880695242,
                                40.997516070950184
                            ],
                            [
                                15.566861039414629,
                                40.969526893402836
                            ],
                            [
                                15.542285728477093,
                                40.946396204646938
                            ],
                            [
                                15.527246317655502,
                                40.907836623885828
                            ],
                            [
                                15.467631613016376,
                                40.889600520996531
                            ],
                            [
                                15.473019758037861,
                                40.874338691463073
                            ],
                            [
                                15.460815964010271,
                                40.867150702634042
                            ],
                            [
                                15.42992551896312,
                                40.879630469932373
                            ],
                            [
                                15.402734345552625,
                                40.881613027389903
                            ],
                            [
                                15.388111733413536,
                                40.875618466971055
                            ],
                            [
                                15.375232332913143,
                                40.885838456967491
                            ],
                            [
                                15.354173629776065,
                                40.882653793753484
                            ],
                            [
                                15.355245020461709,
                                40.870893814938803
                            ],
                            [
                                15.378357160509228,
                                40.86766869228844
                            ],
                            [
                                15.377683202954364,
                                40.83644780143598
                            ],
                            [
                                15.334971165727529,
                                40.83488002796274
                            ],
                            [
                                15.366457236744342,
                                40.812138731357948
                            ],
                            [
                                15.38050192482657,
                                40.810950165338554
                            ],
                            [
                                15.366643215110077,
                                40.798308330955223
                            ],
                            [
                                15.388285702758731,
                                40.79539259543143
                            ],
                            [
                                15.380401857805319,
                                40.780584034995357
                            ],
                            [
                                15.391107076196143,
                                40.767247804934293
                            ],
                            [
                                15.379057663921309,
                                40.750930531483895
                            ],
                            [
                                15.381476205035552,
                                40.724150816940124
                            ],
                            [
                                15.409088487439002,
                                40.713042499006363
                            ],
                            [
                                15.428942238887712,
                                40.692592425999791
                            ],
                            [
                                15.50363302670454,
                                40.663668137234382
                            ],
                            [
                                15.492097844158941,
                                40.647494582227317
                            ],
                            [
                                15.46746141038164,
                                40.638937912306979
                            ],
                            [
                                15.449472088404514,
                                40.609100107279822
                            ],
                            [
                                15.474018204851177,
                                40.592655326012327
                            ],
                            [
                                15.510128216091623,
                                40.585747447602721
                            ],
                            [
                                15.519888869473654,
                                40.570488710860673
                            ],
                            [
                                15.539340989902874,
                                40.568062205280278
                            ],
                            [
                                15.526577116070147,
                                40.557334644312917
                            ],
                            [
                                15.545304155079569,
                                40.531656072193691
                            ],
                            [
                                15.535307054021008,
                                40.522261425284
                            ],
                            [
                                15.550473995794279,
                                40.509245031840443
                            ],
                            [
                                15.535224981533046,
                                40.499640712173232
                            ],
                            [
                                15.538852936906936,
                                40.488050900396509
                            ],
                            [
                                15.578731899486291,
                                40.468893967992635
                            ],
                            [
                                15.586733895558332,
                                40.443603194760904
                            ],
                            [
                                15.647978660856406,
                                40.41400716181721
                            ],
                            [
                                15.662732981385146,
                                40.392493295740294
                            ],
                            [
                                15.671575220333398,
                                40.397911633444608
                            ],
                            [
                                15.710122267514906,
                                40.377299477996083
                            ],
                            [
                                15.704748008467071,
                                40.342241003112676
                            ],
                            [
                                15.730837384012412,
                                40.322166959019718
                            ],
                            [
                                15.726879567204927,
                                40.315446375349758
                            ],
                            [
                                15.747638097192251,
                                40.299221288880602
                            ],
                            [
                                15.792286320752897,
                                40.289779684951689
                            ],
                            [
                                15.805766212002213,
                                40.274527027845522
                            ],
                            [
                                15.799617280295903,
                                40.267785584936838
                            ],
                            [
                                15.805372390433364,
                                40.251409601527527
                            ],
                            [
                                15.78735450030001,
                                40.236634607683435
                            ],
                            [
                                15.796982292438756,
                                40.223666409346123
                            ],
                            [
                                15.751207126119805,
                                40.2017997010798
                            ],
                            [
                                15.734476620381898,
                                40.201676400153502
                            ],
                            [
                                15.729752918328442,
                                40.18632546391315
                            ],
                            [
                                15.712527198329401,
                                40.178444940395075
                            ],
                            [
                                15.716490853462842,
                                40.169586912386265
                            ],
                            [
                                15.700508051545988,
                                40.158278385702154
                            ],
                            [
                                15.709217473065234,
                                40.139867964006747
                            ],
                            [
                                15.705829910019814,
                                40.117732310187414
                            ],
                            [
                                15.6769828255233,
                                40.084468682301519
                            ],
                            [
                                15.651625700342331,
                                40.078581749246446
                            ],
                            [
                                15.675896315208574,
                                40.063576966562628
                            ],
                            [
                                15.676164236078439,
                                40.054899062405568
                            ],
                            [
                                15.657414815403254,
                                40.047245285422356
                            ],
                            [
                                15.645340843577166,
                                40.042963208034728
                            ],
                            [
                                15.626837860921533,
                                40.056250359928818
                            ],
                            [
                                15.63250996504579,
                                40.068218235805347
                            ],
                            [
                                15.625471016132298,
                                40.074076049608664
                            ],
                            [
                                15.617504390913323,
                                40.068660361285502
                            ],
                            [
                                15.573022590504474,
                                40.07831149218935
                            ],
                            [
                                15.530672032655817,
                                40.073834354418047
                            ],
                            [
                                15.503294956288686,
                                40.064051451566108
                            ],
                            [
                                15.48440753858311,
                                40.038364837695241
                            ],
                            [
                                15.460097002118619,
                                40.033698380086079
                            ],
                            [
                                15.419039484194165,
                                39.990560455525085
                            ],
                            [
                                15.381704995429793,
                                40.0007568156677
                            ],
                            [
                                15.356856287007647,
                                39.999116565815811
                            ],
                            [
                                15.314859874696699,
                                40.031881742685108
                            ],
                            [
                                15.270901888843243,
                                40.023003345926789
                            ],
                            [
                                15.267879215874512,
                                40.031459605517341
                            ],
                            [
                                15.28530392452816,
                                40.035087247873832
                            ],
                            [
                                15.271242679745614,
                                40.074234369974
                            ],
                            [
                                15.205678370573763,
                                40.123452717523953
                            ],
                            [
                                15.17884199811372,
                                40.127282091550128
                            ],
                            [
                                15.13205448214755,
                                40.171468048259115
                            ],
                            [
                                15.11277055560598,
                                40.177134782914472
                            ],
                            [
                                15.065846053015044,
                                40.164396008630661
                            ],
                            [
                                15.039955151107456,
                                40.17052594272878
                            ],
                            [
                                14.990894442007162,
                                40.218945940312217
                            ],
                            [
                                14.96869743120299,
                                40.222037079713949
                            ],
                            [
                                14.951525610620468,
                                40.233412748781298
                            ],
                            [
                                14.935258176104904,
                                40.228593283031636
                            ],
                            [
                                14.908904799299682,
                                40.24342341727764
                            ],
                            [
                                14.906478813151745,
                                40.253954943926722
                            ],
                            [
                                14.943455128931452,
                                40.275703113256299
                            ],
                            [
                                14.944802235253402,
                                40.335565923737583
                            ],
                            [
                                14.997292212164272,
                                40.356934801253693
                            ],
                            [
                                14.999050350616214,
                                40.389699890298104
                            ],
                            [
                                14.893377964191064,
                                40.566621882998298
                            ],
                            [
                                14.854432498072125,
                                40.611832708926521
                            ],
                            [
                                14.795910595984969,
                                40.661029688751569
                            ],
                            [
                                14.747630417320494,
                                40.677795677047207
                            ],
                            [
                                14.741789861188556,
                                40.669442535838371
                            ],
                            [
                                14.718738159281356,
                                40.666583456524265
                            ],
                            [
                                14.691665557254133,
                                40.634302732278137
                            ],
                            [
                                14.624899813165188,
                                40.647879737794788
                            ],
                            [
                                14.572107857199432,
                                40.611399603732004
                            ],
                            [
                                14.539270638185123,
                                40.613308742652293
                            ],
                            [
                                14.528648222147343,
                                40.607267535808759
                            ],
                            [
                                14.486280012294696,
                                40.627538481332309
                            ],
                            [
                                14.418907635260863,
                                40.610291520608271
                            ],
                            [
                                14.408032837016766,
                                40.599576481654665
                            ],
                            [
                                14.352310011187656,
                                40.582081062545718
                            ],
                            [
                                14.324520434106644,
                                40.569041064235613
                            ],
                            [
                                14.320442573353256,
                                40.587806838938789
                            ],
                            [
                                14.341790902867984,
                                40.618517531171968
                            ],
                            [
                                14.339389957178701,
                                40.628203340753103
                            ],
                            [
                                14.351282539268784,
                                40.634533893317318
                            ],
                            [
                                14.371011358097423,
                                40.627831070294462
                            ],
                            [
                                14.399704158178725,
                                40.637978936103856
                            ],
                            [
                                14.403604770367336,
                                40.65630805755287
                            ],
                            [
                                14.430017097640137,
                                40.665930316285596
                            ],
                            [
                                14.447976689246975,
                                40.687394000324915
                            ],
                            [
                                14.479245857534293,
                                40.695960114222039
                            ],
                            [
                                14.477968364016327,
                                40.714586540169762
                            ],
                            [
                                14.455860528182946,
                                40.747942264170767
                            ],
                            [
                                14.446393684770406,
                                40.754922081826059
                            ],
                            [
                                14.423230438862042,
                                40.751498227193181
                            ],
                            [
                                14.39550723411984,
                                40.759386725673046
                            ],
                            [
                                14.324410404550896,
                                40.819522208634474
                            ],
                            [
                                14.273932834682876,
                                40.844693320891146
                            ],
                            [
                                14.25205560890287,
                                40.836257758482049
                            ],
                            [
                                14.24999950488516,
                                40.826224903244707
                            ],
                            [
                                14.223245331589169,
                                40.82916828630291
                            ],
                            [
                                14.20565062994657,
                                40.808562775302121
                            ],
                            [
                                14.20520545661369,
                                40.80724285018777
                            ],
                            [
                                14.207612123312613,
                                40.801065898830132
                            ],
                            [
                                14.187286153241955,
                                40.792255820776184
                            ],
                            [
                                14.174487445516673,
                                40.799147309905671
                            ],
                            [
                                14.16142159632291,
                                40.792843099776313
                            ],
                            [
                                14.159826584789295,
                                40.797579915524096
                            ],
                            [
                                14.173398725432873,
                                40.802307627200044
                            ],
                            [
                                14.165675295552576,
                                40.811316108769354
                            ],
                            [
                                14.159183616512895,
                                40.808026979968325
                            ],
                            [
                                14.162193308894144,
                                40.815303170359499
                            ],
                            [
                                14.123230453932448,
                                40.820796940201845
                            ],
                            [
                                14.106750477891765,
                                40.831680658402853
                            ],
                            [
                                14.086586503756397,
                                40.830124949842798
                            ],
                            [
                                14.071572808083195,
                                40.818816297522019
                            ],
                            [
                                14.081814100069964,
                                40.81222384730863
                            ],
                            [
                                14.084763949409682,
                                40.793402035045325
                            ],
                            [
                                14.077997443039468,
                                40.790187221200476
                            ],
                            [
                                14.088711476198586,
                                40.78706626196734
                            ],
                            [
                                14.089457762259835,
                                40.777796595227869
                            ],
                            [
                                14.077769473419144,
                                40.787338425437532
                            ],
                            [
                                14.043866530476059,
                                40.79090158425781
                            ],
                            [
                                14.039589806510197,
                                40.798316916569469
                            ]
                        ],
                        [
                            [
                                14.168382479507308,
                                40.79840807346779
                            ],
                            [
                                14.16943355923501,
                                40.799048278661836
                            ],
                            [
                                14.168332513863891,
                                40.798453846761227
                            ],
                            [
                                14.168382479507308,
                                40.79840807346779
                            ]
                        ],
                        [
                            [
                                14.170315089179505,
                                40.799846600621514
                            ],
                            [
                                14.169567909020627,
                                40.799248851752388
                            ],
                            [
                                14.17037955636348,
                                40.799791990162234
                            ],
                            [
                                14.170315089179505,
                                40.799846600621514
                            ]
                        ],
                        [
                            [
                                14.168584459726144,
                                40.799648567051889
                            ],
                            [
                                14.168724960709696,
                                40.799794915541987
                            ],
                            [
                                14.167800721621781,
                                40.799072334468292
                            ],
                            [
                                14.168584459726144,
                                40.799648567051889
                            ]
                        ],
                        [
                            [
                                14.213882403321367,
                                40.819370167247641
                            ],
                            [
                                14.214163345160594,
                                40.819121788988355
                            ],
                            [
                                14.214193928088715,
                                40.818953992289046
                            ],
                            [
                                14.214292758851824,
                                40.819091496131882
                            ],
                            [
                                14.213882403321367,
                                40.819370167247641
                            ]
                        ],
                        [
                            [
                                14.072125541246709,
                                40.817293804889871
                            ],
                            [
                                14.072121294779892,
                                40.816954544347261
                            ],
                            [
                                14.072235608620225,
                                40.81739912937374
                            ],
                            [
                                14.072125541246709,
                                40.817293804889871
                            ]
                        ],
                        [
                            [
                                14.472651176760897,
                                40.691875160023713
                            ],
                            [
                                14.472671528713578,
                                40.691822107561833
                            ],
                            [
                                14.473250853813955,
                                40.691904472133885
                            ],
                            [
                                14.472651176760897,
                                40.691875160023713
                            ]
                        ],
                        [
                            [
                                14.465133611108977,
                                40.736359371512272
                            ],
                            [
                                14.465230692872359,
                                40.736325500805322
                            ],
                            [
                                14.465051998315717,
                                40.736387999024352
                            ],
                            [
                                14.465133611108977,
                                40.736359371512272
                            ]
                        ],
                        [
                            [
                                14.248352753115471,
                                40.829053916646309
                            ],
                            [
                                14.248382521377614,
                                40.828958560761407
                            ],
                            [
                                14.248415462584525,
                                40.829239690701115
                            ],
                            [
                                14.248352753115471,
                                40.829053916646309
                            ]
                        ],
                        [
                            [
                                14.216775278202167,
                                40.821827591712115
                            ],
                            [
                                14.216877507441103,
                                40.821814337751221
                            ],
                            [
                                14.216969961210125,
                                40.821859795289072
                            ],
                            [
                                14.216855592713408,
                                40.821862521574637
                            ],
                            [
                                14.216775278202167,
                                40.821827591712115
                            ]
                        ],
                        [
                            [
                                14.0845319462821,
                                40.78804468218847
                            ],
                            [
                                14.084455615848332,
                                40.788042651535086
                            ],
                            [
                                14.084536573298033,
                                40.787929770554015
                            ],
                            [
                                14.0845319462821,
                                40.78804468218847
                            ]
                        ],
                        [
                            [
                                14.086012046790033,
                                40.787182960469572
                            ],
                            [
                                14.086179182929632,
                                40.787216129495242
                            ],
                            [
                                14.086115158658124,
                                40.787241122320232
                            ],
                            [
                                14.086012046790033,
                                40.787182960469572
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                13.871883680070649,
                                40.760834765557398
                            ],
                            [
                                13.953973657352813,
                                40.742004940103939
                            ],
                            [
                                13.965289403289667,
                                40.712697060006377
                            ],
                            [
                                13.954524505403562,
                                40.709005066865373
                            ],
                            [
                                13.954062038714907,
                                40.700661385434778
                            ],
                            [
                                13.939718519176987,
                                40.706646166823226
                            ],
                            [
                                13.923236935471936,
                                40.697303949206926
                            ],
                            [
                                13.905205379375605,
                                40.701786421676218
                            ],
                            [
                                13.873661890340856,
                                40.696909572321118
                            ],
                            [
                                13.856263672844076,
                                40.706504234637599
                            ],
                            [
                                13.851037763774196,
                                40.711037301190991
                            ],
                            [
                                13.860759391995758,
                                40.715999336978179
                            ],
                            [
                                13.858568378022401,
                                40.738060683472071
                            ],
                            [
                                13.868469095543619,
                                40.75148014572018
                            ],
                            [
                                13.861892204836886,
                                40.757421837753071
                            ],
                            [
                                13.871883680070649,
                                40.760834765557398
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.260242771102249,
                                40.561456304465146
                            ],
                            [
                                14.266299293766822,
                                40.556007332007844
                            ],
                            [
                                14.252893511102535,
                                40.541615421698275
                            ],
                            [
                                14.244404719258041,
                                40.546670638000911
                            ],
                            [
                                14.197944354742194,
                                40.536806421918008
                            ],
                            [
                                14.199722369123084,
                                40.560971591178955
                            ],
                            [
                                14.241557038397652,
                                40.555731222256846
                            ],
                            [
                                14.260242771102249,
                                40.561456304465146
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.020837200734164,
                                40.757181431841744
                            ],
                            [
                                14.012826038190489,
                                40.748597001064987
                            ],
                            [
                                14.0174123444217,
                                40.739283396517912
                            ],
                            [
                                14.006594750453816,
                                40.748966892962187
                            ],
                            [
                                14.00420437928579,
                                40.745062279807605
                            ],
                            [
                                13.995786991204334,
                                40.747215054261652
                            ],
                            [
                                13.9977114708615,
                                40.740116216496084
                            ],
                            [
                                13.990168063517229,
                                40.743050746672047
                            ],
                            [
                                13.994664231119469,
                                40.749170358577814
                            ],
                            [
                                14.002012162777602,
                                40.747475934772964
                            ],
                            [
                                14.016253055096143,
                                40.770373252364557
                            ],
                            [
                                14.026903611011447,
                                40.760975428420927
                            ],
                            [
                                14.020837200734164,
                                40.757181431841744
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.434636799003894,
                                40.583459554075631
                            ],
                            [
                                14.436149584885317,
                                40.58224932319942
                            ],
                            [
                                14.436346761282735,
                                40.581105699048514
                            ],
                            [
                                14.432187736503506,
                                40.582436263163082
                            ],
                            [
                                14.434636799003894,
                                40.583459554075631
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.376851436331684,
                                40.587244396278798
                            ],
                            [
                                14.375293509453183,
                                40.587870780001275
                            ],
                            [
                                14.377824083175701,
                                40.58908955157888
                            ],
                            [
                                14.377575041458368,
                                40.587845306703493
                            ],
                            [
                                14.376851436331684,
                                40.587244396278798
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.900253747573304,
                                40.250399115492272
                            ],
                            [
                                14.899167904766609,
                                40.250245726882682
                            ],
                            [
                                14.899303063288013,
                                40.251946186436101
                            ],
                            [
                                14.900847917593666,
                                40.252029612091768
                            ],
                            [
                                14.900253747573304,
                                40.250399115492272
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.428767063286566,
                                40.582016892887715
                            ],
                            [
                                14.429036968877867,
                                40.582332759139426
                            ],
                            [
                                14.431035857854795,
                                40.581864918769078
                            ],
                            [
                                14.428909603769032,
                                40.580862340140122
                            ],
                            [
                                14.428767063286566,
                                40.582016892887715
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.039243175478834,
                                40.798367322238953
                            ],
                            [
                                14.035849277446871,
                                40.798395692795779
                            ],
                            [
                                14.035320487749214,
                                40.800316176096786
                            ],
                            [
                                14.035998252081077,
                                40.799229011690201
                            ],
                            [
                                14.039243175478834,
                                40.798367322238953
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.430965632380682,
                                40.579297978097784
                            ],
                            [
                                14.429700863292629,
                                40.579290095289657
                            ],
                            [
                                14.429067769540799,
                                40.580100917847986
                            ],
                            [
                                14.43065053755705,
                                40.580708245288001
                            ],
                            [
                                14.430965632380682,
                                40.579297978097784
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.253175020217531,
                                40.539833945382306
                            ],
                            [
                                14.252239968420801,
                                40.539351493377353
                            ],
                            [
                                14.251730641219041,
                                40.539416140335469
                            ],
                            [
                                14.25329402120229,
                                40.540592540874933
                            ],
                            [
                                14.253175020217531,
                                40.539833945382306
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.463587990218684,
                                40.728949439311855
                            ],
                            [
                                14.46258411289352,
                                40.729420211161298
                            ],
                            [
                                14.463787148465064,
                                40.730141824699373
                            ],
                            [
                                14.464058719291131,
                                40.729503248591328
                            ],
                            [
                                14.463587990218684,
                                40.728949439311855
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.252382079567713,
                                40.540450031386214
                            ],
                            [
                                14.252369562659648,
                                40.541019971424966
                            ],
                            [
                                14.253145004414886,
                                40.541227540942259
                            ],
                            [
                                14.253323953898247,
                                40.54067754002434
                            ],
                            [
                                14.252382079567713,
                                40.540450031386214
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.256589243077515,
                                40.542912678787637
                            ],
                            [
                                14.256045031554075,
                                40.543003404325738
                            ],
                            [
                                14.256549931234337,
                                40.543960420668952
                            ],
                            [
                                14.257076278795193,
                                40.543705103950693
                            ],
                            [
                                14.256589243077515,
                                40.542912678787637
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.186924281030638,
                                40.791264343299495
                            ],
                            [
                                14.186671133851867,
                                40.792027791013162
                            ],
                            [
                                14.187533717966287,
                                40.792045882848342
                            ],
                            [
                                14.187085481592369,
                                40.79132143375945
                            ],
                            [
                                14.186924281030638,
                                40.791264343299495
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                15.294678213124977,
                                40.023693628724097
                            ],
                            [
                                15.294327122005919,
                                40.023701514935624
                            ],
                            [
                                15.294008616469114,
                                40.024254095001645
                            ],
                            [
                                15.29457090924031,
                                40.024082714370707
                            ],
                            [
                                15.294678213124977,
                                40.023693628724097
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.20724711923414,
                                40.802160180718126
                            ],
                            [
                                14.207083298319434,
                                40.803093066779496
                            ],
                            [
                                14.207158071178275,
                                40.803121193604198
                            ],
                            [
                                14.207424207101639,
                                40.802501452413047
                            ],
                            [
                                14.20724711923414,
                                40.802160180718126
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.47727025704337,
                                40.696725701800766
                            ],
                            [
                                14.478180682220179,
                                40.696000937235596
                            ],
                            [
                                14.476573947129587,
                                40.696214427046179
                            ],
                            [
                                14.47727025704337,
                                40.696725701800766
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.477921346824212,
                                40.695719274519512
                            ],
                            [
                                14.477615769619945,
                                40.695589722889288
                            ],
                            [
                                14.478180682220179,
                                40.696000937235596
                            ],
                            [
                                14.477921346824212,
                                40.695719274519512
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.159071292707013,
                                40.808042060871216
                            ],
                            [
                                14.159096769699312,
                                40.807913462273085
                            ],
                            [
                                14.158931653067594,
                                40.807887710319939
                            ],
                            [
                                14.158935178635623,
                                40.807958133149761
                            ],
                            [
                                14.159071292707013,
                                40.808042060871216
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.221356285515247,
                                40.826137420054543
                            ],
                            [
                                14.221252636516841,
                                40.826128293580489
                            ],
                            [
                                14.221715142860937,
                                40.826287687668945
                            ],
                            [
                                14.221674372847069,
                                40.826235520137566
                            ],
                            [
                                14.221356285515247,
                                40.826137420054543
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.220687011727303,
                                40.826167050332671
                            ],
                            [
                                14.220731675488224,
                                40.826205654087389
                            ],
                            [
                                14.22096726326377,
                                40.826267610242475
                            ],
                            [
                                14.220918775589197,
                                40.826206789669179
                            ],
                            [
                                14.220687011727303,
                                40.826167050332671
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.22151771949359,
                                40.825948190742878
                            ],
                            [
                                14.221964550818207,
                                40.826091808966602
                            ],
                            [
                                14.221339795016695,
                                40.825839525716681
                            ],
                            [
                                14.22151771949359,
                                40.825948190742878
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.2219683322046,
                                40.825802993361428
                            ],
                            [
                                14.222222368613497,
                                40.825927855238049
                            ],
                            [
                                14.221644276303069,
                                40.825557188198367
                            ],
                            [
                                14.2219683322046,
                                40.825802993361428
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.207612123312613,
                                40.801065898830132
                            ],
                            [
                                14.207723556549251,
                                40.801148251528694
                            ],
                            [
                                14.207766795576395,
                                40.801090494717648
                            ],
                            [
                                14.207612123312613,
                                40.801065898830132
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.07506832181539,
                                40.820969959766487
                            ],
                            [
                                14.075113051074778,
                                40.821033269867243
                            ],
                            [
                                14.075190480763986,
                                40.820972795588879
                            ],
                            [
                                14.07506832181539,
                                40.820969959766487
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 17,
                "name": "Puglia",
                "length": 1176242.99348,
                "area": 19537077223.0
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                16.650491118433255,
                                41.191634608837262
                            ],
                            [
                                16.776843338368245,
                                41.160463563907484
                            ],
                            [
                                16.809634840354065,
                                41.140327277052755
                            ],
                            [
                                16.845408440158849,
                                41.139801982114797
                            ],
                            [
                                16.854347486340728,
                                41.128761748049662
                            ],
                            [
                                16.870939758996538,
                                41.136400646068317
                            ],
                            [
                                16.85538909589793,
                                41.143955516701368
                            ],
                            [
                                16.868220503466038,
                                41.143152949350416
                            ],
                            [
                                16.87905205177865,
                                41.12259719043842
                            ],
                            [
                                17.088029429688724,
                                41.064883844044445
                            ],
                            [
                                17.142406837051709,
                                41.036936637184318
                            ],
                            [
                                17.175409342270306,
                                41.029101454291514
                            ],
                            [
                                17.20283580900908,
                                41.0028647517153
                            ],
                            [
                                17.279118080613006,
                                40.971651018171045
                            ],
                            [
                                17.32826672577616,
                                40.935186389392243
                            ],
                            [
                                17.350114730998335,
                                40.905737589409021
                            ],
                            [
                                17.388075664200109,
                                40.893059625321577
                            ],
                            [
                                17.469872224876045,
                                40.841838307822798
                            ],
                            [
                                17.478478397745395,
                                40.829580657535729
                            ],
                            [
                                17.550546286991434,
                                40.801642385287721
                            ],
                            [
                                17.707228062754929,
                                40.758191734753247
                            ],
                            [
                                17.838543710548809,
                                40.691270366733363
                            ],
                            [
                                17.925820303875987,
                                40.679462983896236
                            ],
                            [
                                17.935627114438503,
                                40.686173330813808
                            ],
                            [
                                17.952989561190641,
                                40.664127576395806
                            ],
                            [
                                17.983992363980384,
                                40.663655449250342
                            ],
                            [
                                17.967376217119778,
                                40.654974566808313
                            ],
                            [
                                17.962268496037609,
                                40.662552037470441
                            ],
                            [
                                17.952283298703584,
                                40.648243665602635
                            ],
                            [
                                17.927257237649819,
                                40.639963579322746
                            ],
                            [
                                17.998416038721661,
                                40.649051717736675
                            ],
                            [
                                18.01501299619035,
                                40.637720762846698
                            ],
                            [
                                18.01814147706294,
                                40.621976432684711
                            ],
                            [
                                18.045144137075528,
                                40.597279241409915
                            ],
                            [
                                18.037437560700514,
                                40.563972032166291
                            ],
                            [
                                18.074734103375377,
                                40.539533323591002
                            ],
                            [
                                18.080781080317344,
                                40.525429490251533
                            ],
                            [
                                18.12667113904385,
                                40.493140726882011
                            ],
                            [
                                18.203013931569952,
                                40.467089715500208
                            ],
                            [
                                18.234250637032936,
                                40.448440058685151
                            ],
                            [
                                18.306434186989353,
                                40.391436878562985
                            ],
                            [
                                18.315973227084264,
                                40.372829310612914
                            ],
                            [
                                18.358687639347014,
                                40.34562655049632
                            ],
                            [
                                18.385980534334013,
                                40.314460459205016
                            ],
                            [
                                18.422677617940685,
                                40.294133351629007
                            ],
                            [
                                18.464464828879251,
                                40.225056212440855
                            ],
                            [
                                18.458644556000205,
                                40.20336838724122
                            ],
                            [
                                18.478939948690954,
                                40.178101577437204
                            ],
                            [
                                18.487213558425804,
                                40.148370111938078
                            ],
                            [
                                18.503518952250634,
                                40.14693070961048
                            ],
                            [
                                18.516877144534305,
                                40.135528697169036
                            ],
                            [
                                18.506564315490717,
                                40.126217074247492
                            ],
                            [
                                18.518859865506506,
                                40.104671428922735
                            ],
                            [
                                18.502514085680545,
                                40.093596675619317
                            ],
                            [
                                18.483066025155733,
                                40.077197355196567
                            ],
                            [
                                18.477718808272044,
                                40.05000317622919
                            ],
                            [
                                18.474443940593488,
                                40.043684610020961
                            ],
                            [
                                18.435606358611526,
                                40.024584248438188
                            ],
                            [
                                18.431663239642457,
                                40.000598876386718
                            ],
                            [
                                18.417055659052878,
                                39.99461087087915
                            ],
                            [
                                18.407162443116579,
                                39.975382772866546
                            ],
                            [
                                18.390217364754076,
                                39.907356085800956
                            ],
                            [
                                18.399034189817829,
                                39.889082290807799
                            ],
                            [
                                18.385341750291719,
                                39.841771661339074
                            ],
                            [
                                18.390811839727768,
                                39.817599250904323
                            ],
                            [
                                18.368992604165371,
                                39.793763505133143
                            ],
                            [
                                18.333989540941662,
                                39.79579848328062
                            ],
                            [
                                18.327074885414614,
                                39.807370889326542
                            ],
                            [
                                18.265630368481517,
                                39.83568495390594
                            ],
                            [
                                18.204743173135569,
                                39.838545165878507
                            ],
                            [
                                18.14925926892569,
                                39.861954358419794
                            ],
                            [
                                18.047563626743017,
                                39.928785172655182
                            ],
                            [
                                17.993189968906368,
                                40.000074547881788
                            ],
                            [
                                18.006259053638797,
                                39.995722396051761
                            ],
                            [
                                18.01764078022514,
                                40.007016901749523
                            ],
                            [
                                18.016131601141467,
                                40.034058162137839
                            ],
                            [
                                17.997661549391683,
                                40.050660020667991
                            ],
                            [
                                17.972082272603028,
                                40.054586499604547
                            ],
                            [
                                17.990283113029889,
                                40.058592162079535
                            ],
                            [
                                18.004601389037195,
                                40.07172152224166
                            ],
                            [
                                18.009918609044721,
                                40.109059907096338
                            ],
                            [
                                17.995253863937918,
                                40.132118323081286
                            ],
                            [
                                17.963585596534742,
                                40.147701269949003
                            ],
                            [
                                17.919810218420722,
                                40.192135440343179
                            ],
                            [
                                17.921586333225626,
                                40.226178909774184
                            ],
                            [
                                17.89522648728812,
                                40.250607058385462
                            ],
                            [
                                17.910596828601314,
                                40.241643876720644
                            ],
                            [
                                17.904517982065812,
                                40.256203360928055
                            ],
                            [
                                17.890453449590201,
                                40.25874798310592
                            ],
                            [
                                17.860093656720434,
                                40.284247378882611
                            ],
                            [
                                17.839771548560222,
                                40.28048653702551
                            ],
                            [
                                17.816364058206936,
                                40.289592927470864
                            ],
                            [
                                17.678494305088332,
                                40.304714437590967
                            ],
                            [
                                17.507629410603379,
                                40.294974363918556
                            ],
                            [
                                17.494765114611482,
                                40.309956287884383
                            ],
                            [
                                17.460238267123007,
                                40.316122778390522
                            ],
                            [
                                17.442842544457793,
                                40.329805175777118
                            ],
                            [
                                17.386010198818589,
                                40.337396156299647
                            ],
                            [
                                17.374587141210124,
                                40.348828986961216
                            ],
                            [
                                17.310613837341862,
                                40.366601118780267
                            ],
                            [
                                17.254909519519895,
                                40.396243733911817
                            ],
                            [
                                17.222771229894867,
                                40.408661692570199
                            ],
                            [
                                17.203304806310037,
                                40.408287737426797
                            ],
                            [
                                17.211421875859017,
                                40.422740846576531
                            ],
                            [
                                17.232152137824958,
                                40.424627078375231
                            ],
                            [
                                17.254734870998401,
                                40.441104040359974
                            ],
                            [
                                17.246732528150229,
                                40.462135568994476
                            ],
                            [
                                17.220167226974944,
                                40.479340879505649
                            ],
                            [
                                17.181832238550779,
                                40.481441193435906
                            ],
                            [
                                17.180635114326378,
                                40.49323322384538
                            ],
                            [
                                17.176832155440962,
                                40.489663426921901
                            ],
                            [
                                17.165827981623458,
                                40.501024741417751
                            ],
                            [
                                17.155073868168994,
                                40.496588038527236
                            ],
                            [
                                17.16263981133968,
                                40.506110995615771
                            ],
                            [
                                17.144748689114088,
                                40.494912764832208
                            ],
                            [
                                17.146028378742937,
                                40.509895194651961
                            ],
                            [
                                17.112955044609333,
                                40.519764313548016
                            ],
                            [
                                17.067856122907081,
                                40.51752581307602
                            ],
                            [
                                16.99526572884221,
                                40.494937013585812
                            ],
                            [
                                16.922184472283654,
                                40.45144654053346
                            ],
                            [
                                16.866520461662184,
                                40.398077491200802
                            ],
                            [
                                16.849842375786356,
                                40.401624490634909
                            ],
                            [
                                16.809382428858608,
                                40.433073936571851
                            ],
                            [
                                16.802817302287689,
                                40.457444785201098
                            ],
                            [
                                16.759824180314574,
                                40.462754452012014
                            ],
                            [
                                16.756625934462967,
                                40.468188207483109
                            ],
                            [
                                16.74381150729565,
                                40.464689592390584
                            ],
                            [
                                16.720219542416718,
                                40.479825818084869
                            ],
                            [
                                16.73704713456268,
                                40.507796515122131
                            ],
                            [
                                16.715820325809801,
                                40.524248350223154
                            ],
                            [
                                16.724378886454986,
                                40.535291800396337
                            ],
                            [
                                16.705362970162966,
                                40.555043398500906
                            ],
                            [
                                16.716590896807826,
                                40.58224126053107
                            ],
                            [
                                16.711771672804733,
                                40.592825506758999
                            ],
                            [
                                16.728263871685758,
                                40.601420621980573
                            ],
                            [
                                16.712620417599425,
                                40.615633003672521
                            ],
                            [
                                16.709758624943941,
                                40.632833123494102
                            ],
                            [
                                16.727202009280248,
                                40.688378514493543
                            ],
                            [
                                16.696486655017054,
                                40.702610726579223
                            ],
                            [
                                16.704483221587143,
                                40.711246124067252
                            ],
                            [
                                16.708713797247995,
                                40.705420055614653
                            ],
                            [
                                16.724908427954524,
                                40.71383274260161
                            ],
                            [
                                16.663357638507087,
                                40.748867224589262
                            ],
                            [
                                16.661517576018319,
                                40.736850646622301
                            ],
                            [
                                16.652860381615767,
                                40.736297639324732
                            ],
                            [
                                16.653166970744131,
                                40.74390648769625
                            ],
                            [
                                16.632819698649246,
                                40.753570608365457
                            ],
                            [
                                16.607937857696619,
                                40.751831451511308
                            ],
                            [
                                16.579679869123446,
                                40.763661503046166
                            ],
                            [
                                16.566965832067787,
                                40.754460001969605
                            ],
                            [
                                16.577983108287768,
                                40.741996221173132
                            ],
                            [
                                16.572439977445423,
                                40.736936951840576
                            ],
                            [
                                16.55447174545256,
                                40.757654053812026
                            ],
                            [
                                16.535800871987217,
                                40.751931521619269
                            ],
                            [
                                16.538614224204608,
                                40.724975692281397
                            ],
                            [
                                16.501051161864883,
                                40.762287967382377
                            ],
                            [
                                16.479679042024443,
                                40.73679905502317
                            ],
                            [
                                16.430509309191013,
                                40.704754563520112
                            ],
                            [
                                16.400152079808905,
                                40.707405390124855
                            ],
                            [
                                16.380389429305069,
                                40.736397768872202
                            ],
                            [
                                16.34881331465845,
                                40.749634889211762
                            ],
                            [
                                16.316225996214822,
                                40.783105595871135
                            ],
                            [
                                16.278230340692836,
                                40.801605339233788
                            ],
                            [
                                16.256145092350152,
                                40.823051511214025
                            ],
                            [
                                16.23162200968617,
                                40.854041450702802
                            ],
                            [
                                16.223804852545936,
                                40.886585413181841
                            ],
                            [
                                16.202464160114371,
                                40.917531525893118
                            ],
                            [
                                16.162970569801772,
                                40.928579956607898
                            ],
                            [
                                16.138067161135737,
                                40.918353349027839
                            ],
                            [
                                16.121069309142658,
                                40.897718860514324
                            ],
                            [
                                16.092773989333143,
                                40.920640700984919
                            ],
                            [
                                15.976628498627353,
                                40.958452898235208
                            ],
                            [
                                15.971811450532021,
                                40.972131657688266
                            ],
                            [
                                16.008352789909189,
                                40.972091707256638
                            ],
                            [
                                16.027038215556921,
                                40.991213864270975
                            ],
                            [
                                16.027934431317846,
                                41.024081153570627
                            ],
                            [
                                16.040467483344425,
                                41.028360711606346
                            ],
                            [
                                16.040736880378329,
                                41.035984162365942
                            ],
                            [
                                16.007250278869815,
                                41.059106285588008
                            ],
                            [
                                15.998858587384394,
                                41.05398997731546
                            ],
                            [
                                15.982599623937686,
                                41.089195379291624
                            ],
                            [
                                15.95413976149576,
                                41.09312091126818
                            ],
                            [
                                15.959956296517353,
                                41.100052708771315
                            ],
                            [
                                15.95338462517195,
                                41.11080942127662
                            ],
                            [
                                15.920968869071139,
                                41.111151053160199
                            ],
                            [
                                15.870254184085431,
                                41.139921284024815
                            ],
                            [
                                15.865019745963851,
                                41.130965546371591
                            ],
                            [
                                15.846603354088213,
                                41.125600781337141
                            ],
                            [
                                15.833614396617742,
                                41.130047448181905
                            ],
                            [
                                15.82506371860671,
                                41.117912589561818
                            ],
                            [
                                15.8120041199907,
                                41.116596834808867
                            ],
                            [
                                15.790552733681663,
                                41.087842422783886
                            ],
                            [
                                15.768008751033893,
                                41.083253378709081
                            ],
                            [
                                15.742750183585992,
                                41.099401500192613
                            ],
                            [
                                15.679414192590638,
                                41.086798650337229
                            ],
                            [
                                15.618533110696301,
                                41.09915362801334
                            ],
                            [
                                15.585739491636199,
                                41.098260160710588
                            ],
                            [
                                15.540235924598747,
                                41.072225301372725
                            ],
                            [
                                15.54174069566149,
                                41.055714735052419
                            ],
                            [
                                15.478351224186506,
                                41.078661716019205
                            ],
                            [
                                15.446097031861854,
                                41.078016753902197
                            ],
                            [
                                15.401278667945389,
                                41.105978995326559
                            ],
                            [
                                15.36659019601403,
                                41.08478187996581
                            ],
                            [
                                15.31435718684236,
                                41.103885670099736
                            ],
                            [
                                15.291909052070279,
                                41.092773274980374
                            ],
                            [
                                15.264310621901142,
                                41.105320590489612
                            ],
                            [
                                15.23566285713248,
                                41.139882308662692
                            ],
                            [
                                15.210562157578655,
                                41.148921420993183
                            ],
                            [
                                15.209345454240415,
                                41.167686580049967
                            ],
                            [
                                15.227500518898397,
                                41.184929228965913
                            ],
                            [
                                15.262415058774248,
                                41.197626241468193
                            ],
                            [
                                15.245739089507982,
                                41.235030746098829
                            ],
                            [
                                15.279843905763123,
                                41.24079495833476
                            ],
                            [
                                15.275658458242869,
                                41.249535798835574
                            ],
                            [
                                15.24900367768188,
                                41.27099117856833
                            ],
                            [
                                15.220439556725825,
                                41.265187525734916
                            ],
                            [
                                15.21574487781513,
                                41.27594010888123
                            ],
                            [
                                15.199744306547514,
                                41.279448071995446
                            ],
                            [
                                15.200695549968771,
                                41.286354349663959
                            ],
                            [
                                15.149155740828267,
                                41.28044522516381
                            ],
                            [
                                15.126770580733929,
                                41.302951894096047
                            ],
                            [
                                15.130560162671413,
                                41.317185576019753
                            ],
                            [
                                15.072191154003765,
                                41.332464038534042
                            ],
                            [
                                15.058471033353257,
                                41.372135360347556
                            ],
                            [
                                15.098316307347954,
                                41.390567893767319
                            ],
                            [
                                15.086640895855851,
                                41.40722566192872
                            ],
                            [
                                15.103294141443691,
                                41.420940021668507
                            ],
                            [
                                15.100831550275982,
                                41.429667237949339
                            ],
                            [
                                15.046791619419237,
                                41.443341539686898
                            ],
                            [
                                15.043124222019429,
                                41.456762357696149
                            ],
                            [
                                15.030299342889641,
                                41.455390085603042
                            ],
                            [
                                15.023890046825803,
                                41.476947772572373
                            ],
                            [
                                14.966393579493774,
                                41.519003486364547
                            ],
                            [
                                14.938568445947888,
                                41.525197195831261
                            ],
                            [
                                14.95030992691369,
                                41.592661819350063
                            ],
                            [
                                14.934539402701379,
                                41.620898527098568
                            ],
                            [
                                14.959532594317533,
                                41.64603822386065
                            ],
                            [
                                14.988703293098499,
                                41.637806023758465
                            ],
                            [
                                14.990470049320642,
                                41.629670857829126
                            ],
                            [
                                15.008330918148987,
                                41.622294774152017
                            ],
                            [
                                15.025496771400739,
                                41.62232010937317
                            ],
                            [
                                15.025987635653786,
                                41.634567627326838
                            ],
                            [
                                15.045177537020539,
                                41.636949786053272
                            ],
                            [
                                15.050248232040683,
                                41.657313009891844
                            ],
                            [
                                15.089959130722361,
                                41.671995245194893
                            ],
                            [
                                15.08992901166668,
                                41.681821701304621
                            ],
                            [
                                15.102457167474158,
                                41.67205891174239
                            ],
                            [
                                15.117067669492435,
                                41.693750735844183
                            ],
                            [
                                15.161499251175616,
                                41.709388252437748
                            ],
                            [
                                15.120903801761342,
                                41.72039174836835
                            ],
                            [
                                15.101883369403334,
                                41.74276260763191
                            ],
                            [
                                15.103276241249715,
                                41.749038716239539
                            ],
                            [
                                15.116545693077578,
                                41.748962678392424
                            ],
                            [
                                15.097026000643053,
                                41.767401307476419
                            ],
                            [
                                15.115994532171628,
                                41.799063682280753
                            ],
                            [
                                15.116443102027457,
                                41.814535307415532
                            ],
                            [
                                15.100985806702472,
                                41.837481032709569
                            ],
                            [
                                15.138799086136043,
                                41.879280874243499
                            ],
                            [
                                15.131238081236829,
                                41.900848197875554
                            ],
                            [
                                15.138045716378885,
                                41.926645120756845
                            ],
                            [
                                15.207805065632842,
                                41.919205513839415
                            ],
                            [
                                15.293569159487562,
                                41.921016855845764
                            ],
                            [
                                15.335921606549176,
                                41.916729510189654
                            ],
                            [
                                15.363393020382006,
                                41.903208312606147
                            ],
                            [
                                15.419247647461981,
                                41.900887631901469
                            ],
                            [
                                15.623048030775262,
                                41.927434384002034
                            ],
                            [
                                15.677772528278044,
                                41.915074699797103
                            ],
                            [
                                15.737697466181485,
                                41.915770057334697
                            ],
                            [
                                15.924564556273634,
                                41.933138444648229
                            ],
                            [
                                16.012148678168781,
                                41.950441811317638
                            ],
                            [
                                16.061058989329105,
                                41.949084904553239
                            ],
                            [
                                16.089751284023908,
                                41.9386704329156
                            ],
                            [
                                16.120920367328736,
                                41.915108346753058
                            ],
                            [
                                16.153004779814648,
                                41.908682855084194
                            ],
                            [
                                16.161982314476134,
                                41.890418777033481
                            ],
                            [
                                16.176461851068311,
                                41.884823717677456
                            ],
                            [
                                16.176685100233929,
                                41.85511455036233
                            ],
                            [
                                16.199739776285377,
                                41.826153637454922
                            ],
                            [
                                16.193102339463731,
                                41.7825480113477
                            ],
                            [
                                16.186602766798423,
                                41.772122012438452
                            ],
                            [
                                16.16759777957974,
                                41.766354699767582
                            ],
                            [
                                16.163633890033839,
                                41.754850349319142
                            ],
                            [
                                16.104912382945461,
                                41.729740524987136
                            ],
                            [
                                16.034874247000833,
                                41.677218397953105
                            ],
                            [
                                15.945333818504981,
                                41.643372688228219
                            ],
                            [
                                15.903291564514037,
                                41.618190023494236
                            ],
                            [
                                15.894549210776393,
                                41.585702252065069
                            ],
                            [
                                15.898625799012819,
                                41.549867794508025
                            ],
                            [
                                15.929309520609209,
                                41.489013447439014
                            ],
                            [
                                15.962240088310004,
                                41.457791885664946
                            ],
                            [
                                16.018460305728176,
                                41.428101025029861
                            ],
                            [
                                16.207033883268441,
                                41.359425133103414
                            ],
                            [
                                16.266533321860944,
                                41.326920005400403
                            ],
                            [
                                16.359056410357081,
                                41.304711258018934
                            ],
                            [
                                16.421768068711064,
                                41.280205295306665
                            ],
                            [
                                16.453176930159309,
                                41.259786238548458
                            ],
                            [
                                16.531833429990449,
                                41.23874577581919
                            ],
                            [
                                16.582202167989475,
                                41.208160189576063
                            ],
                            [
                                16.650491118433255,
                                41.191634608837262
                            ]
                        ],
                        [
                            [
                                16.63375700247963,
                                40.754178512665085
                            ],
                            [
                                16.642291569034111,
                                40.751604003215093
                            ],
                            [
                                16.646454514677043,
                                40.754151626497823
                            ],
                            [
                                16.642558757946087,
                                40.756125121859775
                            ],
                            [
                                16.63375700247963,
                                40.754178512665085
                            ]
                        ],
                        [
                            [
                                18.11888045202231,
                                39.882601117224176
                            ],
                            [
                                18.118901802538613,
                                39.882826422106483
                            ],
                            [
                                18.118054668051542,
                                39.88315655422052
                            ],
                            [
                                18.118193874908503,
                                39.882855587955468
                            ],
                            [
                                18.11888045202231,
                                39.882601117224176
                            ]
                        ],
                        [
                            [
                                18.122464839914755,
                                39.880040105150925
                            ],
                            [
                                18.122409891569486,
                                39.880130992877476
                            ],
                            [
                                18.122176564438753,
                                39.880087695996323
                            ],
                            [
                                18.122440193183852,
                                39.879899344162183
                            ],
                            [
                                18.122464839914755,
                                39.880040105150925
                            ]
                        ],
                        [
                            [
                                18.489580536467546,
                                40.147249596489509
                            ],
                            [
                                18.489592150303334,
                                40.147353134746197
                            ],
                            [
                                18.489459560846747,
                                40.147305672096401
                            ],
                            [
                                18.489512638419082,
                                40.147224874146296
                            ],
                            [
                                18.489580536467546,
                                40.147249596489509
                            ]
                        ],
                        [
                            [
                                17.967625879863547,
                                40.657053213474903
                            ],
                            [
                                17.967486701138363,
                                40.657026625282477
                            ],
                            [
                                17.967758651049603,
                                40.65698590540638
                            ],
                            [
                                17.967625879863547,
                                40.657053213474903
                            ]
                        ],
                        [
                            [
                                18.47903385567923,
                                40.061739779847606
                            ],
                            [
                                18.479133483467379,
                                40.061688855197986
                            ],
                            [
                                18.479125501408078,
                                40.061799067302424
                            ],
                            [
                                18.47903385567923,
                                40.061739779847606
                            ]
                        ],
                        [
                            [
                                18.418980126760882,
                                40.295772173773393
                            ],
                            [
                                18.418961769948172,
                                40.295704010667336
                            ],
                            [
                                18.419046546454684,
                                40.295638709750605
                            ],
                            [
                                18.418980126760882,
                                40.295772173773393
                            ]
                        ],
                        [
                            [
                                17.966939827440093,
                                40.655765898576469
                            ],
                            [
                                17.966916931682835,
                                40.655713063300688
                            ],
                            [
                                17.967018898661753,
                                40.655719783691161
                            ],
                            [
                                17.966939827440093,
                                40.655765898576469
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                15.482694723983217,
                                42.103685760344504
                            ],
                            [
                                15.476268882035033,
                                42.111619735613267
                            ],
                            [
                                15.491133037675716,
                                42.125791587954183
                            ],
                            [
                                15.496262568122283,
                                42.11548005553469
                            ],
                            [
                                15.482694723983217,
                                42.103685760344504
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                17.160656363269506,
                                40.453231979189198
                            ],
                            [
                                17.166992218783843,
                                40.448072685476959
                            ],
                            [
                                17.157211430955787,
                                40.444738348724279
                            ],
                            [
                                17.143293223185211,
                                40.450509349703488
                            ],
                            [
                                17.160966066257547,
                                40.45809413898764
                            ],
                            [
                                17.160656363269506,
                                40.453231979189198
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                15.504110576280102,
                                42.118593306033809
                            ],
                            [
                                15.504260173237521,
                                42.121933027668874
                            ],
                            [
                                15.517498775051152,
                                42.128187801151903
                            ],
                            [
                                15.51728194944298,
                                42.12578800423826
                            ],
                            [
                                15.504110576280102,
                                42.118593306033809
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                17.94871928676837,
                                40.053317637430325
                            ],
                            [
                                17.955852362288624,
                                40.050583834114747
                            ],
                            [
                                17.948280742568127,
                                40.045088960828977
                            ],
                            [
                                17.94468365566301,
                                40.046888498234942
                            ],
                            [
                                17.94871928676837,
                                40.053317637430325
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                15.508876985938818,
                                42.129415140268669
                            ],
                            [
                                15.509977633154795,
                                42.137795024566081
                            ],
                            [
                                15.515795069034894,
                                42.140003799203896
                            ],
                            [
                                15.517796496306431,
                                42.137684474316181
                            ],
                            [
                                15.508876985938818,
                                42.129415140268669
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                17.888298081042972,
                                40.254954011631348
                            ],
                            [
                                17.883875946395101,
                                40.256218001099889
                            ],
                            [
                                17.881444834415841,
                                40.26210357887296
                            ],
                            [
                                17.887270369727887,
                                40.258329082285677
                            ],
                            [
                                17.888298081042972,
                                40.254954011631348
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                15.744066645282992,
                                42.226510796382186
                            ],
                            [
                                15.7512851637221,
                                42.225955915812257
                            ],
                            [
                                15.751721161351917,
                                42.225673625110012
                            ],
                            [
                                15.748141957591058,
                                42.223232401084914
                            ],
                            [
                                15.744066645282992,
                                42.226510796382186
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                17.868856549868781,
                                40.268522609006183
                            ],
                            [
                                17.86672709967343,
                                40.268664642792366
                            ],
                            [
                                17.86441041202249,
                                40.271442242372217
                            ],
                            [
                                17.868926846315272,
                                40.269546750592269
                            ],
                            [
                                17.868856549868781,
                                40.268522609006183
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                17.175218605517813,
                                40.438996184583878
                            ],
                            [
                                17.175341782977579,
                                40.440633447846587
                            ],
                            [
                                17.179339985391824,
                                40.436955431141662
                            ],
                            [
                                17.174031096355087,
                                40.438718695717839
                            ],
                            [
                                17.173352326723126,
                                40.440030776591229
                            ],
                            [
                                17.174927449418448,
                                40.440928294241417
                            ],
                            [
                                17.175218605517813,
                                40.438996184583878
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                16.184765367914618,
                                41.887523492134967
                            ],
                            [
                                16.183028338694093,
                                41.888741882893356
                            ],
                            [
                                16.181638787117752,
                                41.890854073676039
                            ],
                            [
                                16.184770574111887,
                                41.889734720565983
                            ],
                            [
                                16.184765367914618,
                                41.887523492134967
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                15.500079743460601,
                                42.121606155792243
                            ],
                            [
                                15.498192988525616,
                                42.121540222556789
                            ],
                            [
                                15.496942068132155,
                                42.122486678196942
                            ],
                            [
                                15.500159435082319,
                                42.123766277704455
                            ],
                            [
                                15.500079743460601,
                                42.121606155792243
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                16.199783555847912,
                                41.814524019323393
                            ],
                            [
                                16.199600541507817,
                                41.815489457048415
                            ],
                            [
                                16.20086920591601,
                                41.81625992780792
                            ],
                            [
                                16.201393828403372,
                                41.81544394178043
                            ],
                            [
                                16.199783555847912,
                                41.814524019323393
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                16.188646069410716,
                                41.843824550820969
                            ],
                            [
                                16.187082923334856,
                                41.844264860620164
                            ],
                            [
                                16.186713726160065,
                                41.845021516698864
                            ],
                            [
                                16.188796411554954,
                                41.844706008283637
                            ],
                            [
                                16.188646069410716,
                                41.843824550820969
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                17.994347349672399,
                                40.655253026153879
                            ],
                            [
                                17.993078376135362,
                                40.655734868496261
                            ],
                            [
                                17.9937503826288,
                                40.657035445771477
                            ],
                            [
                                17.994551862582298,
                                40.655978856820866
                            ],
                            [
                                17.994347349672399,
                                40.655253026153879
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                17.9693064845689,
                                40.054421087019996
                            ],
                            [
                                17.970356244130162,
                                40.054186292709666
                            ],
                            [
                                17.968899083302738,
                                40.052567017720996
                            ],
                            [
                                17.968556831901793,
                                40.05314218415522
                            ],
                            [
                                17.9693064845689,
                                40.054421087019996
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                17.80599486392828,
                                40.713103706597309
                            ],
                            [
                                17.804919641588562,
                                40.71357308317242
                            ],
                            [
                                17.804714500477576,
                                40.714587089246884
                            ],
                            [
                                17.805969338239635,
                                40.714112895869945
                            ],
                            [
                                17.80599486392828,
                                40.713103706597309
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                16.111491651794502,
                                41.927977623812509
                            ],
                            [
                                16.109768249087576,
                                41.928192896326635
                            ],
                            [
                                16.109382278599728,
                                41.928378908076603
                            ],
                            [
                                16.11099950033692,
                                41.928885703159068
                            ],
                            [
                                16.111491651794502,
                                41.927977623812509
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                18.002549890132535,
                                40.653898055660385
                            ],
                            [
                                18.002413096795138,
                                40.654718125077721
                            ],
                            [
                                18.003366807795256,
                                40.655155721263242
                            ],
                            [
                                18.00338842139756,
                                40.654335768340609
                            ],
                            [
                                18.002549890132535,
                                40.653898055660385
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                17.890987610532228,
                                40.253190145051917
                            ],
                            [
                                17.890627955215166,
                                40.252932512307623
                            ],
                            [
                                17.889396287452318,
                                40.253670813466236
                            ],
                            [
                                17.890407476587232,
                                40.25395217300116
                            ],
                            [
                                17.890987610532228,
                                40.253190145051917
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                17.825263841119003,
                                40.702571177218246
                            ],
                            [
                                17.824413328462125,
                                40.70290652101211
                            ],
                            [
                                17.824748684736633,
                                40.703539406175729
                            ],
                            [
                                17.825859013701962,
                                40.703114349968786
                            ],
                            [
                                17.825263841119003,
                                40.702571177218246
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                17.810008909654591,
                                40.71202606980134
                            ],
                            [
                                17.809053417667368,
                                40.711906220107508
                            ],
                            [
                                17.809342533192527,
                                40.712814764412698
                            ],
                            [
                                17.809964723884775,
                                40.712627508630732
                            ],
                            [
                                17.810008909654591,
                                40.71202606980134
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                18.095792688948404,
                                39.895186298486145
                            ],
                            [
                                18.096645510108978,
                                39.895082875824777
                            ],
                            [
                                18.096617167474498,
                                39.894323203549035
                            ],
                            [
                                18.095903057588981,
                                39.894613436641208
                            ],
                            [
                                18.095792688948404,
                                39.895186298486145
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                17.824028957227451,
                                40.703214912800505
                            ],
                            [
                                17.823618759072446,
                                40.703817512217938
                            ],
                            [
                                17.823808507742719,
                                40.704355985243886
                            ],
                            [
                                17.824195797091022,
                                40.703624717365258
                            ],
                            [
                                17.824028957227451,
                                40.703214912800505
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                17.992635182228632,
                                40.656974597866395
                            ],
                            [
                                17.992209632967377,
                                40.656949614942341
                            ],
                            [
                                17.992103224048289,
                                40.657439020533253
                            ],
                            [
                                17.992776884597891,
                                40.657476028158776
                            ],
                            [
                                17.992635182228632,
                                40.656974597866395
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                17.990850699975219,
                                40.657374872306448
                            ],
                            [
                                17.990484617355168,
                                40.657606882804814
                            ],
                            [
                                17.990617634374882,
                                40.657968869727483
                            ],
                            [
                                17.99095369560321,
                                40.657780862016374
                            ],
                            [
                                17.990850699975219,
                                40.657374872306448
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                18.503095959135269,
                                40.09221813002511
                            ],
                            [
                                18.502890781211615,
                                40.091965451547196
                            ],
                            [
                                18.503238489872434,
                                40.092774878175717
                            ],
                            [
                                18.503383232065445,
                                40.092430301387907
                            ],
                            [
                                18.503095959135269,
                                40.09221813002511
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                18.027248804652064,
                                40.642876103847414
                            ],
                            [
                                18.027087284125525,
                                40.643077647683917
                            ],
                            [
                                18.027511202933951,
                                40.64315666632411
                            ],
                            [
                                18.027340716649871,
                                40.642922770962699
                            ],
                            [
                                18.027248804652064,
                                40.642876103847414
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                17.991527747904687,
                                40.657730857320821
                            ],
                            [
                                17.991349209709579,
                                40.657650882533929
                            ],
                            [
                                17.991409703599651,
                                40.657956888787012
                            ],
                            [
                                17.991591215945846,
                                40.657829620185964
                            ],
                            [
                                17.991527747904687,
                                40.657730857320821
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                18.380058942115525,
                                40.322305722472308
                            ],
                            [
                                18.380225966701492,
                                40.322334758649994
                            ],
                            [
                                18.380499469144649,
                                40.322379804510675
                            ],
                            [
                                18.380412686241741,
                                40.32221047575154
                            ],
                            [
                                18.380058942115525,
                                40.322305722472308
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                18.275856354454788,
                                39.830529984685775
                            ],
                            [
                                18.276081788676802,
                                39.830870245562501
                            ],
                            [
                                18.275927229189193,
                                39.830515278545647
                            ],
                            [
                                18.275856354454788,
                                39.830529984685775
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                17.088029429688724,
                                41.064883844044445
                            ],
                            [
                                17.088104294621068,
                                41.064924658601456
                            ],
                            [
                                17.088399858451901,
                                41.064875661324322
                            ],
                            [
                                17.088029429688724,
                                41.064883844044445
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                18.420140025226534,
                                40.295838691460474
                            ],
                            [
                                18.420243765527328,
                                40.295845899593921
                            ],
                            [
                                18.420257227177064,
                                40.295795349400102
                            ],
                            [
                                18.420140025226534,
                                40.295838691460474
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                18.427178113787289,
                                40.288322300454567
                            ],
                            [
                                18.427272661019195,
                                40.288295422884417
                            ],
                            [
                                18.427199027530047,
                                40.288262147199681
                            ],
                            [
                                18.427178113787289,
                                40.288322300454567
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 18,
                "name": "Basilicata",
                "length": 614219.205497,
                "area": 10073260222.600000381469727
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                15.723534944860088,
                                39.968289100174168
                            ],
                            [
                                15.681132526825747,
                                40.006164199060329
                            ],
                            [
                                15.665033709020152,
                                40.039071791491402
                            ],
                            [
                                15.644487431983398,
                                40.04157895796979
                            ],
                            [
                                15.67634488178534,
                                40.055654215768079
                            ],
                            [
                                15.671858893079371,
                                40.070348524900986
                            ],
                            [
                                15.651539754911731,
                                40.078271730409973
                            ],
                            [
                                15.6769828255233,
                                40.084468682301519
                            ],
                            [
                                15.705829910019814,
                                40.117732310187414
                            ],
                            [
                                15.709380647972813,
                                40.13861208744261
                            ],
                            [
                                15.701060148152965,
                                40.160617565572174
                            ],
                            [
                                15.716490853462842,
                                40.169586912386265
                            ],
                            [
                                15.712527198329401,
                                40.178444940395075
                            ],
                            [
                                15.729752918328442,
                                40.18632546391315
                            ],
                            [
                                15.731255160334394,
                                40.199328786354833
                            ],
                            [
                                15.795716491396208,
                                40.221918806513607
                            ],
                            [
                                15.78735450030001,
                                40.236634607683435
                            ],
                            [
                                15.805372390433364,
                                40.251409601527527
                            ],
                            [
                                15.799617280295903,
                                40.267785584936838
                            ],
                            [
                                15.806361233238331,
                                40.273232017989223
                            ],
                            [
                                15.792286320752897,
                                40.289779684951689
                            ],
                            [
                                15.747638097192251,
                                40.299221288880602
                            ],
                            [
                                15.726879567204927,
                                40.315446375349758
                            ],
                            [
                                15.730837384012412,
                                40.322166959019718
                            ],
                            [
                                15.704748008467071,
                                40.342241003112676
                            ],
                            [
                                15.710122267514906,
                                40.377299477996083
                            ],
                            [
                                15.671575220333398,
                                40.397911633444608
                            ],
                            [
                                15.662732981385146,
                                40.392493295740294
                            ],
                            [
                                15.647978660856406,
                                40.41400716181721
                            ],
                            [
                                15.586733895558332,
                                40.443603194760904
                            ],
                            [
                                15.578731899486291,
                                40.468893967992635
                            ],
                            [
                                15.538852936906936,
                                40.488050900396509
                            ],
                            [
                                15.535224981533046,
                                40.499640712173232
                            ],
                            [
                                15.550473995794279,
                                40.509245031840443
                            ],
                            [
                                15.535307054021008,
                                40.522261425284
                            ],
                            [
                                15.545304155079569,
                                40.531656072193691
                            ],
                            [
                                15.526577116070147,
                                40.557334644312917
                            ],
                            [
                                15.539340989902874,
                                40.568062205280278
                            ],
                            [
                                15.519888869473654,
                                40.570488710860673
                            ],
                            [
                                15.510128216091623,
                                40.585747447602721
                            ],
                            [
                                15.474018204851177,
                                40.592655326012327
                            ],
                            [
                                15.449472088404514,
                                40.609100107279822
                            ],
                            [
                                15.46746141038164,
                                40.638937912306979
                            ],
                            [
                                15.492097844158941,
                                40.647494582227317
                            ],
                            [
                                15.50363302670454,
                                40.663668137234382
                            ],
                            [
                                15.428942238887712,
                                40.692592425999791
                            ],
                            [
                                15.409088487439002,
                                40.713042499006363
                            ],
                            [
                                15.381476205035552,
                                40.724150816940124
                            ],
                            [
                                15.379057663921309,
                                40.750930531483895
                            ],
                            [
                                15.391107076196143,
                                40.767247804934293
                            ],
                            [
                                15.380401857805319,
                                40.780584034995357
                            ],
                            [
                                15.388285702758731,
                                40.79539259543143
                            ],
                            [
                                15.366643215110077,
                                40.798308330955223
                            ],
                            [
                                15.38050192482657,
                                40.810950165338554
                            ],
                            [
                                15.366457236744342,
                                40.812138731357948
                            ],
                            [
                                15.334971165727529,
                                40.83488002796274
                            ],
                            [
                                15.377683202954364,
                                40.83644780143598
                            ],
                            [
                                15.378357160509228,
                                40.86766869228844
                            ],
                            [
                                15.355245020461709,
                                40.870893814938803
                            ],
                            [
                                15.354173629776065,
                                40.882653793753484
                            ],
                            [
                                15.375232332913143,
                                40.885838456967491
                            ],
                            [
                                15.388111733413536,
                                40.875618466971055
                            ],
                            [
                                15.402734345552625,
                                40.881613027389903
                            ],
                            [
                                15.42992551896312,
                                40.879630469932373
                            ],
                            [
                                15.460815964010271,
                                40.867150702634042
                            ],
                            [
                                15.473019758037861,
                                40.874338691463073
                            ],
                            [
                                15.467631613016376,
                                40.889600520996531
                            ],
                            [
                                15.527246317655502,
                                40.907836623885828
                            ],
                            [
                                15.542285728477093,
                                40.946396204646938
                            ],
                            [
                                15.569458646114308,
                                40.979971201479913
                            ],
                            [
                                15.563247261122894,
                                41.030753501093443
                            ],
                            [
                                15.55103021194366,
                                41.039416656080817
                            ],
                            [
                                15.539302532838356,
                                41.070374989641024
                            ],
                            [
                                15.559724049871907,
                                41.088203761933066
                            ],
                            [
                                15.585739491636199,
                                41.098260160710588
                            ],
                            [
                                15.617415667757216,
                                41.099258600513288
                            ],
                            [
                                15.684553996773838,
                                41.086883212095231
                            ],
                            [
                                15.717089552127419,
                                41.089680238071033
                            ],
                            [
                                15.737881482544138,
                                41.099548156292698
                            ],
                            [
                                15.752597489344843,
                                41.097337173254701
                            ],
                            [
                                15.768400642953987,
                                41.083189753555665
                            ],
                            [
                                15.79775872921056,
                                41.091015296149394
                            ],
                            [
                                15.805371820128769,
                                41.110889026285705
                            ],
                            [
                                15.82506371860671,
                                41.117912589561818
                            ],
                            [
                                15.831744872307224,
                                41.129132929966893
                            ],
                            [
                                15.846603354088213,
                                41.125600781337141
                            ],
                            [
                                15.865019745963851,
                                41.130965546371591
                            ],
                            [
                                15.870254184085431,
                                41.139921284024815
                            ],
                            [
                                15.920968869071139,
                                41.111151053160199
                            ],
                            [
                                15.95338462517195,
                                41.11080942127662
                            ],
                            [
                                15.959956296517353,
                                41.100052708771315
                            ],
                            [
                                15.95413976149576,
                                41.09312091126818
                            ],
                            [
                                15.982599623937686,
                                41.089195379291624
                            ],
                            [
                                15.998858587384394,
                                41.05398997731546
                            ],
                            [
                                16.007250278869815,
                                41.059106285588008
                            ],
                            [
                                16.040622743495753,
                                41.036243137224858
                            ],
                            [
                                16.040467483344425,
                                41.028360711606346
                            ],
                            [
                                16.027934431317846,
                                41.024081153570627
                            ],
                            [
                                16.027038215556921,
                                40.991213864270975
                            ],
                            [
                                16.008352789909189,
                                40.972091707256638
                            ],
                            [
                                15.971811450532021,
                                40.972131657688266
                            ],
                            [
                                15.976628498627353,
                                40.958452898235208
                            ],
                            [
                                16.092773989333143,
                                40.920640700984919
                            ],
                            [
                                16.121069309142658,
                                40.897718860514324
                            ],
                            [
                                16.138067161135737,
                                40.918353349027839
                            ],
                            [
                                16.162970569801772,
                                40.928579956607898
                            ],
                            [
                                16.202464160114371,
                                40.917531525893118
                            ],
                            [
                                16.223804852545936,
                                40.886585413181841
                            ],
                            [
                                16.23162200968617,
                                40.854041450702802
                            ],
                            [
                                16.256145092350152,
                                40.823051511214025
                            ],
                            [
                                16.278230340692836,
                                40.801605339233788
                            ],
                            [
                                16.316225996214822,
                                40.783105595871135
                            ],
                            [
                                16.34881331465845,
                                40.749634889211762
                            ],
                            [
                                16.380389429305069,
                                40.736397768872202
                            ],
                            [
                                16.400152079808905,
                                40.707405390124855
                            ],
                            [
                                16.430509309191013,
                                40.704754563520112
                            ],
                            [
                                16.479679042024443,
                                40.73679905502317
                            ],
                            [
                                16.501051161864883,
                                40.762287967382377
                            ],
                            [
                                16.538614224204608,
                                40.724975692281397
                            ],
                            [
                                16.535800871987217,
                                40.751931521619269
                            ],
                            [
                                16.55447174545256,
                                40.757654053812026
                            ],
                            [
                                16.572439977445423,
                                40.736936951840576
                            ],
                            [
                                16.577983108287768,
                                40.741996221173132
                            ],
                            [
                                16.566965832067787,
                                40.754460001969605
                            ],
                            [
                                16.579679869123446,
                                40.763661503046166
                            ],
                            [
                                16.607937857696619,
                                40.751831451511308
                            ],
                            [
                                16.632819698649246,
                                40.753570608365457
                            ],
                            [
                                16.653166970744131,
                                40.74390648769625
                            ],
                            [
                                16.652860381615767,
                                40.736297639324732
                            ],
                            [
                                16.661517576018319,
                                40.736850646622301
                            ],
                            [
                                16.663357638507087,
                                40.748867224589262
                            ],
                            [
                                16.724908427954524,
                                40.71383274260161
                            ],
                            [
                                16.708713797247995,
                                40.705420055614653
                            ],
                            [
                                16.704483221587143,
                                40.711246124067252
                            ],
                            [
                                16.696486655017054,
                                40.702610726579223
                            ],
                            [
                                16.727202009280248,
                                40.688378514493543
                            ],
                            [
                                16.709758624943941,
                                40.632833123494102
                            ],
                            [
                                16.712620417599425,
                                40.615633003672521
                            ],
                            [
                                16.728263871685758,
                                40.601420621980573
                            ],
                            [
                                16.711771672804733,
                                40.592825506758999
                            ],
                            [
                                16.716590896807826,
                                40.58224126053107
                            ],
                            [
                                16.705362970162966,
                                40.555043398500906
                            ],
                            [
                                16.724378886454986,
                                40.535291800396337
                            ],
                            [
                                16.715820325809801,
                                40.524248350223154
                            ],
                            [
                                16.73704713456268,
                                40.507796515122131
                            ],
                            [
                                16.720219542416718,
                                40.479825818084869
                            ],
                            [
                                16.74381150729565,
                                40.464689592390584
                            ],
                            [
                                16.756625934462967,
                                40.468188207483109
                            ],
                            [
                                16.759824180314574,
                                40.462754452012014
                            ],
                            [
                                16.802817302287689,
                                40.457444785201098
                            ],
                            [
                                16.809382428858608,
                                40.433073936571851
                            ],
                            [
                                16.823681320873654,
                                40.419497863989903
                            ],
                            [
                                16.866885272166176,
                                40.397349725494387
                            ],
                            [
                                16.785041443180067,
                                40.300928392675665
                            ],
                            [
                                16.749481153374781,
                                40.245793839309066
                            ],
                            [
                                16.737294678506832,
                                40.210613783811127
                            ],
                            [
                                16.691814388468,
                                40.151678795516887
                            ],
                            [
                                16.645260737368137,
                                40.118128187669591
                            ],
                            [
                                16.620948161154839,
                                40.132100487856121
                            ],
                            [
                                16.56185858320109,
                                40.129879408018162
                            ],
                            [
                                16.530009930077849,
                                40.118094081465465
                            ],
                            [
                                16.517974179744186,
                                40.128776851234257
                            ],
                            [
                                16.493326100407021,
                                40.125205464414449
                            ],
                            [
                                16.470772863530275,
                                40.134079696193794
                            ],
                            [
                                16.434012435439474,
                                40.128010849134611
                            ],
                            [
                                16.421115818539871,
                                40.143925871446463
                            ],
                            [
                                16.419924800439304,
                                40.128523563340131
                            ],
                            [
                                16.408948686101297,
                                40.120957630780531
                            ],
                            [
                                16.414240123810295,
                                40.080684604042595
                            ],
                            [
                                16.392768330016064,
                                40.042438450691591
                            ],
                            [
                                16.398377853269633,
                                40.01694578546212
                            ],
                            [
                                16.360575221714555,
                                39.968587933196865
                            ],
                            [
                                16.358086752062491,
                                39.954099863781018
                            ],
                            [
                                16.337802461660154,
                                39.936175209789596
                            ],
                            [
                                16.359662842482447,
                                39.91960412769847
                            ],
                            [
                                16.3514085450878,
                                39.899015169391518
                            ],
                            [
                                16.309590279107244,
                                39.934044405170624
                            ],
                            [
                                16.268886609735784,
                                39.935983081262421
                            ],
                            [
                                16.237998563217253,
                                39.92546919344079
                            ],
                            [
                                16.214276366975593,
                                39.926595625938042
                            ],
                            [
                                16.214690806435197,
                                39.895978836100255
                            ],
                            [
                                16.158954937380248,
                                39.919403137667828
                            ],
                            [
                                16.137972008274627,
                                39.901412680581402
                            ],
                            [
                                16.103318526029238,
                                39.906921214934151
                            ],
                            [
                                16.082394575977009,
                                39.896249606379236
                            ],
                            [
                                16.049021339587227,
                                39.89480202731432
                            ],
                            [
                                16.037951221273801,
                                39.915993207015944
                            ],
                            [
                                16.016531041655313,
                                39.925751527950894
                            ],
                            [
                                16.021921518614853,
                                39.934129110372226
                            ],
                            [
                                16.006877319935953,
                                39.956936120613186
                            ],
                            [
                                16.03380950215962,
                                39.982763262818196
                            ],
                            [
                                16.023383270701331,
                                39.995946460087666
                            ],
                            [
                                16.008596370588315,
                                39.99648168957885
                            ],
                            [
                                16.005866874927612,
                                39.989512048481167
                            ],
                            [
                                15.979203204715272,
                                39.982400521474929
                            ],
                            [
                                15.968515571214612,
                                39.991734710589675
                            ],
                            [
                                15.928019413665899,
                                40.001071693771713
                            ],
                            [
                                15.897769777158945,
                                39.981670865457637
                            ],
                            [
                                15.890766483116382,
                                39.994318357117763
                            ],
                            [
                                15.876867586450707,
                                39.996524655132795
                            ],
                            [
                                15.867660729512684,
                                39.990126350583743
                            ],
                            [
                                15.851706914928725,
                                40.005895807726759
                            ],
                            [
                                15.820049759905803,
                                40.001869067603842
                            ],
                            [
                                15.794797795836766,
                                39.971368572685556
                            ],
                            [
                                15.773000877487329,
                                39.960515324952546
                            ],
                            [
                                15.765853398229911,
                                39.930604096554326
                            ],
                            [
                                15.755889718551181,
                                39.923545412810078
                            ],
                            [
                                15.734963079307775,
                                39.942490260127457
                            ],
                            [
                                15.731927687570472,
                                39.964080361377242
                            ],
                            [
                                15.723534944860088,
                                39.968289100174168
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                16.64585873536593,
                                40.752549409062794
                            ],
                            [
                                16.641185331705465,
                                40.751776654511673
                            ],
                            [
                                16.63376353501215,
                                40.754884333876802
                            ],
                            [
                                16.642558757946087,
                                40.756125121859775
                            ],
                            [
                                16.64585873536593,
                                40.752549409062794
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                15.715085265591956,
                                39.966605085547513
                            ],
                            [
                                15.715466754059609,
                                39.967541277817986
                            ],
                            [
                                15.717322275431963,
                                39.967410774070231
                            ],
                            [
                                15.716765677752758,
                                39.967087715106288
                            ],
                            [
                                15.715085265591956,
                                39.966605085547513
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                15.723493001540902,
                                39.968226864059162
                            ],
                            [
                                15.723451757750349,
                                39.968000918195472
                            ],
                            [
                                15.723312939764892,
                                39.967971886228796
                            ],
                            [
                                15.723425147309294,
                                39.968146452481406
                            ],
                            [
                                15.723493001540902,
                                39.968226864059162
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 19,
                "name": "Calabria",
                "length": 838194.35773,
                "area": 15216683867.799999237060547
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                15.816004200890625,
                                39.676966315913937
                            ],
                            [
                                15.815048152081264,
                                39.678133827201066
                            ],
                            [
                                15.813894211061275,
                                39.692350947367402
                            ],
                            [
                                15.809233428995535,
                                39.710031899998903
                            ],
                            [
                                15.808367843561467,
                                39.730569925052315
                            ],
                            [
                                15.78571299206371,
                                39.816393644663314
                            ],
                            [
                                15.769009633366348,
                                39.835674803765201
                            ],
                            [
                                15.789079185245404,
                                39.849623880605151
                            ],
                            [
                                15.791569415996864,
                                39.86314592261467
                            ],
                            [
                                15.755889718551181,
                                39.923545412810078
                            ],
                            [
                                15.765853398229911,
                                39.930604096554326
                            ],
                            [
                                15.773000877487329,
                                39.960515324952546
                            ],
                            [
                                15.794797795836766,
                                39.971368572685556
                            ],
                            [
                                15.820049759905803,
                                40.001869067603842
                            ],
                            [
                                15.851706914928725,
                                40.005895807726759
                            ],
                            [
                                15.867660729512684,
                                39.990126350583743
                            ],
                            [
                                15.876867586450707,
                                39.996524655132795
                            ],
                            [
                                15.890766483116382,
                                39.994318357117763
                            ],
                            [
                                15.897769777158945,
                                39.981670865457637
                            ],
                            [
                                15.928019413665899,
                                40.001071693771713
                            ],
                            [
                                15.968515571214612,
                                39.991734710589675
                            ],
                            [
                                15.979203204715272,
                                39.982400521474929
                            ],
                            [
                                16.005866874927612,
                                39.989512048481167
                            ],
                            [
                                16.008596370588315,
                                39.99648168957885
                            ],
                            [
                                16.030710750780809,
                                39.993358414503497
                            ],
                            [
                                16.033591374660492,
                                39.982349165507067
                            ],
                            [
                                16.006801182675662,
                                39.957305173480229
                            ],
                            [
                                16.021921518614853,
                                39.934129110372226
                            ],
                            [
                                16.016531041655313,
                                39.925751527950894
                            ],
                            [
                                16.037951221273801,
                                39.915993207015944
                            ],
                            [
                                16.049021339587227,
                                39.89480202731432
                            ],
                            [
                                16.082394575977009,
                                39.896249606379236
                            ],
                            [
                                16.103318526029238,
                                39.906921214934151
                            ],
                            [
                                16.137972008274627,
                                39.901412680581402
                            ],
                            [
                                16.158954937380248,
                                39.919403137667828
                            ],
                            [
                                16.214690806435197,
                                39.895978836100255
                            ],
                            [
                                16.214276366975593,
                                39.926595625938042
                            ],
                            [
                                16.237998563217253,
                                39.92546919344079
                            ],
                            [
                                16.268886609735784,
                                39.935983081262421
                            ],
                            [
                                16.309590279107244,
                                39.934044405170624
                            ],
                            [
                                16.350301390723022,
                                39.898685382393055
                            ],
                            [
                                16.359662842482447,
                                39.91960412769847
                            ],
                            [
                                16.337802461660154,
                                39.936175209789596
                            ],
                            [
                                16.358086752062491,
                                39.954099863781018
                            ],
                            [
                                16.360575221714555,
                                39.968587933196865
                            ],
                            [
                                16.398377853269633,
                                40.01694578546212
                            ],
                            [
                                16.392768330016064,
                                40.042438450691591
                            ],
                            [
                                16.414240123810295,
                                40.080684604042595
                            ],
                            [
                                16.408948686101297,
                                40.120957630780531
                            ],
                            [
                                16.419924800439304,
                                40.128523563340131
                            ],
                            [
                                16.421115818539871,
                                40.143925871446463
                            ],
                            [
                                16.434012435439474,
                                40.128010849134611
                            ],
                            [
                                16.470772863530275,
                                40.134079696193794
                            ],
                            [
                                16.493326100407021,
                                40.125205464414449
                            ],
                            [
                                16.517974179744186,
                                40.128776851234257
                            ],
                            [
                                16.530009930077849,
                                40.118094081465465
                            ],
                            [
                                16.587215634646935,
                                40.133118607795247
                            ],
                            [
                                16.627769224980174,
                                40.12972804683266
                            ],
                            [
                                16.645072663142233,
                                40.118033702290376
                            ],
                            [
                                16.606000187708439,
                                40.080608316012601
                            ],
                            [
                                16.598684255206759,
                                40.040890529334831
                            ],
                            [
                                16.62696808262838,
                                39.956914020363989
                            ],
                            [
                                16.538255653489315,
                                39.870754746403833
                            ],
                            [
                                16.489310781270905,
                                39.798092911368805
                            ],
                            [
                                16.493391591551422,
                                39.749438449403016
                            ],
                            [
                                16.529399736452511,
                                39.724435450563824
                            ],
                            [
                                16.517943163467287,
                                39.668399090425453
                            ],
                            [
                                16.523681158508115,
                                39.658896986109653
                            ],
                            [
                                16.529229948528208,
                                39.666488467146849
                            ],
                            [
                                16.564989283864151,
                                39.641808038458628
                            ],
                            [
                                16.621896233565238,
                                39.621333511541003
                            ],
                            [
                                16.732915607367811,
                                39.616291159919349
                            ],
                            [
                                16.755276597516964,
                                39.624483102869583
                            ],
                            [
                                16.770404566225242,
                                39.620792934007383
                            ],
                            [
                                16.81622891244643,
                                39.58938689378494
                            ],
                            [
                                16.833380090849335,
                                39.561365912731176
                            ],
                            [
                                16.866594945937067,
                                39.53861856294813
                            ],
                            [
                                16.956919323164936,
                                39.496838095148405
                            ],
                            [
                                17.02449566564313,
                                39.483847518894876
                            ],
                            [
                                17.052166558587604,
                                39.439464515131526
                            ],
                            [
                                17.115834824580482,
                                39.406387808079465
                            ],
                            [
                                17.156715884492566,
                                39.401130812458987
                            ],
                            [
                                17.13486783115335,
                                39.372367572882908
                            ],
                            [
                                17.109222294221993,
                                39.307527836250912
                            ],
                            [
                                17.106340672599192,
                                39.253259855421327
                            ],
                            [
                                17.148421412567284,
                                39.20609796638464
                            ],
                            [
                                17.117403508263472,
                                39.144948437167095
                            ],
                            [
                                17.108103499992062,
                                39.107343487356374
                            ],
                            [
                                17.118890841499891,
                                39.087373923752992
                            ],
                            [
                                17.135858746700542,
                                39.083533147417619
                            ],
                            [
                                17.125984390096374,
                                39.096298458578921
                            ],
                            [
                                17.135154397268611,
                                39.086979192285696
                            ],
                            [
                                17.138698691426473,
                                39.079873711231031
                            ],
                            [
                                17.131126591807675,
                                39.068228583693553
                            ],
                            [
                                17.1467498604292,
                                39.046479242285542
                            ],
                            [
                                17.173110608519423,
                                39.033071540150324
                            ],
                            [
                                17.206526444170159,
                                39.028457051568793
                            ],
                            [
                                17.205018980957032,
                                39.020667784787086
                            ],
                            [
                                17.181207973047663,
                                39.014290361479496
                            ],
                            [
                                17.163454814304508,
                                38.992507145688762
                            ],
                            [
                                17.160506389464025,
                                38.969190932561922
                            ],
                            [
                                17.170130460012221,
                                38.95680604456048
                            ],
                            [
                                17.094154681661461,
                                38.892618417003533
                            ],
                            [
                                17.08513601946839,
                                38.91218938330222
                            ],
                            [
                                17.042090070648992,
                                38.918911034419466
                            ],
                            [
                                17.021599667432838,
                                38.905834526170906
                            ],
                            [
                                16.980644827957981,
                                38.938153845864477
                            ],
                            [
                                16.890569685264989,
                                38.927989887686678
                            ],
                            [
                                16.775828201472972,
                                38.895413929562558
                            ],
                            [
                                16.60586766234783,
                                38.811959234161833
                            ],
                            [
                                16.534791482257049,
                                38.711362080618478
                            ],
                            [
                                16.558595148681626,
                                38.680598419088867
                            ],
                            [
                                16.582191607240166,
                                38.469146845129238
                            ],
                            [
                                16.570924192128931,
                                38.426931599160824
                            ],
                            [
                                16.465447342794118,
                                38.339405099992241
                            ],
                            [
                                16.336816259657819,
                                38.30101303721051
                            ],
                            [
                                16.318374349105216,
                                38.288479562141085
                            ],
                            [
                                16.163949246032214,
                                38.133988804084815
                            ],
                            [
                                16.144193732145002,
                                38.031248313202731
                            ],
                            [
                                16.106594022851482,
                                37.967522742516536
                            ],
                            [
                                16.06445525413298,
                                37.925634575851682
                            ],
                            [
                                15.997847648507674,
                                37.915754359776713
                            ],
                            [
                                15.921302919938052,
                                37.929706896280308
                            ],
                            [
                                15.761207577037567,
                                37.916646402758339
                            ],
                            [
                                15.678022696820678,
                                37.954062810458673
                            ],
                            [
                                15.633557791037603,
                                38.018403084697042
                            ],
                            [
                                15.657074787114558,
                                38.039674612774213
                            ],
                            [
                                15.647765081507128,
                                38.054409976724145
                            ],
                            [
                                15.651945919490871,
                                38.066192215801763
                            ],
                            [
                                15.634842554950181,
                                38.075539377163572
                            ],
                            [
                                15.630177515715467,
                                38.093155046986034
                            ],
                            [
                                15.655258138794132,
                                38.133840782095824
                            ],
                            [
                                15.65506243136408,
                                38.152486172703185
                            ],
                            [
                                15.634007126264247,
                                38.185840589613022
                            ],
                            [
                                15.636501767658189,
                                38.232184003166509
                            ],
                            [
                                15.691891724601502,
                                38.251078673660672
                            ],
                            [
                                15.749190107375799,
                                38.257112994540414
                            ],
                            [
                                15.817086215153399,
                                38.300719202698197
                            ],
                            [
                                15.833062264112401,
                                38.357534474058347
                            ],
                            [
                                15.858128632793095,
                                38.380210527162063
                            ],
                            [
                                15.898369009299145,
                                38.451502100487801
                            ],
                            [
                                15.92917951122514,
                                38.532322688962992
                            ],
                            [
                                15.928785841262943,
                                38.549972851674831
                            ],
                            [
                                15.901163607683584,
                                38.564431582488773
                            ],
                            [
                                15.845589112482013,
                                38.61289055482311
                            ],
                            [
                                15.826892260407032,
                                38.619200163376782
                            ],
                            [
                                15.836632059908053,
                                38.646187922021873
                            ],
                            [
                                15.872071226267476,
                                38.673228730879607
                            ],
                            [
                                15.948429613213094,
                                38.691336829517908
                            ],
                            [
                                15.986023517544773,
                                38.723020112367251
                            ],
                            [
                                16.042123727438725,
                                38.727683769440993
                            ],
                            [
                                16.104433349015899,
                                38.711806183626976
                            ],
                            [
                                16.137095830644125,
                                38.71879770792674
                            ],
                            [
                                16.188210084050773,
                                38.756060205191012
                            ],
                            [
                                16.220098537060906,
                                38.840471520589951
                            ],
                            [
                                16.216483162876081,
                                38.924390664277965
                            ],
                            [
                                16.156120275096601,
                                38.95148217032213
                            ],
                            [
                                16.131311306761269,
                                38.998866171378602
                            ],
                            [
                                16.097802642263588,
                                39.034018979947781
                            ],
                            [
                                16.06686646667427,
                                39.133468821671407
                            ],
                            [
                                16.050949628906718,
                                39.298675191182753
                            ],
                            [
                                15.996770072859519,
                                39.439406114276451
                            ],
                            [
                                15.925195464321211,
                                39.526531681990058
                            ],
                            [
                                15.875683508878353,
                                39.55153511495817
                            ],
                            [
                                15.831697034627735,
                                39.668310428353884
                            ],
                            [
                                15.816004200890625,
                                39.676966315913937
                            ]
                        ],
                        [
                            [
                                15.816004200890625,
                                39.676966315913937
                            ],
                            [
                                15.816270693616394,
                                39.676867706698062
                            ],
                            [
                                15.816285221060113,
                                39.676921343948955
                            ],
                            [
                                15.816004200890625,
                                39.676966315913937
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                15.779391545298497,
                                39.871824549003442
                            ],
                            [
                                15.769953758017298,
                                39.871337935906006
                            ],
                            [
                                15.768605111110261,
                                39.871927070531576
                            ],
                            [
                                15.774274665442718,
                                39.875868756738072
                            ],
                            [
                                15.779391545298497,
                                39.871824549003442
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                15.801239691968627,
                                39.697434055424345
                            ],
                            [
                                15.800008582037455,
                                39.698471598766531
                            ],
                            [
                                15.801301133837148,
                                39.700507944110434
                            ],
                            [
                                15.803215992781411,
                                39.698663024225276
                            ],
                            [
                                15.801239691968627,
                                39.697434055424345
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                15.788324145316839,
                                39.856241304194135
                            ],
                            [
                                15.788122475226972,
                                39.85662209866743
                            ],
                            [
                                15.789379791040851,
                                39.856791139474261
                            ],
                            [
                                15.789129966556317,
                                39.856567372984365
                            ],
                            [
                                15.788324145316839,
                                39.856241304194135
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                15.778685165527612,
                                39.847583945143207
                            ],
                            [
                                15.778168339722612,
                                39.847596281967135
                            ],
                            [
                                15.778856514239003,
                                39.848239776860311
                            ],
                            [
                                15.779267530390531,
                                39.848013179690454
                            ],
                            [
                                15.778685165527612,
                                39.847583945143207
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                15.727712421982636,
                                37.928635221233556
                            ],
                            [
                                15.727864120577179,
                                37.928563467856513
                            ],
                            [
                                15.727831783589385,
                                37.928480374664787
                            ],
                            [
                                15.727659152296804,
                                37.928560572602322
                            ],
                            [
                                15.727712421982636,
                                37.928635221233556
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 20,
                "name": "Sicilia",
                "length": 1339973.64188,
                "area": 25824775591.400001525878906
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                12.44315526850734,
                                37.788228725915545
                            ],
                            [
                                12.425329200489262,
                                37.803180264256731
                            ],
                            [
                                12.461548967498269,
                                37.817349979410487
                            ],
                            [
                                12.485949734446979,
                                37.874710620990385
                            ],
                            [
                                12.459035606814712,
                                37.908423235757191
                            ],
                            [
                                12.491505377204133,
                                37.951136152304542
                            ],
                            [
                                12.494204275218754,
                                37.984997005741448
                            ],
                            [
                                12.519745917127452,
                                38.009351071895608
                            ],
                            [
                                12.49144337944151,
                                38.017016972721798
                            ],
                            [
                                12.51835316624082,
                                38.021318873534895
                            ],
                            [
                                12.56924247908707,
                                38.068909404792834
                            ],
                            [
                                12.60407207239343,
                                38.064817499460005
                            ],
                            [
                                12.645565885051987,
                                38.078220504382017
                            ],
                            [
                                12.662733426761065,
                                38.094558449031275
                            ],
                            [
                                12.660228294142867,
                                38.11184588789736
                            ],
                            [
                                12.672153060684176,
                                38.114696284816283
                            ],
                            [
                                12.688900061934744,
                                38.105627038305578
                            ],
                            [
                                12.711051841301417,
                                38.109799943377119
                            ],
                            [
                                12.737432458176407,
                                38.13966193219084
                            ],
                            [
                                12.715789323571824,
                                38.172927178345823
                            ],
                            [
                                12.730995665806729,
                                38.189630787364457
                            ],
                            [
                                12.738447671398161,
                                38.175956772803957
                            ],
                            [
                                12.76801215380063,
                                38.179615598058831
                            ],
                            [
                                12.769650498249652,
                                38.151391131237318
                            ],
                            [
                                12.779324912524686,
                                38.15098934739207
                            ],
                            [
                                12.790790865687393,
                                38.135197704356742
                            ],
                            [
                                12.790054992714639,
                                38.112093768560953
                            ],
                            [
                                12.810825183130508,
                                38.081357112405854
                            ],
                            [
                                12.854684432577749,
                                38.049682084735316
                            ],
                            [
                                12.868504181234139,
                                38.051344927915828
                            ],
                            [
                                12.878757271622566,
                                38.029165022987939
                            ],
                            [
                                12.902381235013928,
                                38.024649353690464
                            ],
                            [
                                12.975977397319067,
                                38.039720688768035
                            ],
                            [
                                13.077667077407959,
                                38.087777982977364
                            ],
                            [
                                13.068122835134542,
                                38.120616271044995
                            ],
                            [
                                13.052291938945086,
                                38.138790721545135
                            ],
                            [
                                13.072077429622938,
                                38.141720859098257
                            ],
                            [
                                13.084760246921855,
                                38.161681935341512
                            ],
                            [
                                13.076969588049156,
                                38.172015266588737
                            ],
                            [
                                13.105491376709104,
                                38.190999781861819
                            ],
                            [
                                13.159902079630163,
                                38.185865851289911
                            ],
                            [
                                13.162920509041788,
                                38.171140507119262
                            ],
                            [
                                13.191250364953509,
                                38.169392467448041
                            ],
                            [
                                13.237828789103641,
                                38.186663389045982
                            ],
                            [
                                13.241301327763846,
                                38.204190861181708
                            ],
                            [
                                13.273869000418793,
                                38.198276910821043
                            ],
                            [
                                13.296124745962718,
                                38.217528596971029
                            ],
                            [
                                13.317481321080134,
                                38.224465482972029
                            ],
                            [
                                13.328738340926897,
                                38.1999070174206
                            ],
                            [
                                13.365580145150094,
                                38.18234246007416
                            ],
                            [
                                13.374807214214281,
                                38.154008508840413
                            ],
                            [
                                13.372402096809649,
                                38.133047786034254
                            ],
                            [
                                13.362529173498954,
                                38.129895533898981
                            ],
                            [
                                13.38412321713831,
                                38.10871657187699
                            ],
                            [
                                13.442582070894343,
                                38.094864918234265
                            ],
                            [
                                13.49165807074478,
                                38.10298187709283
                            ],
                            [
                                13.504942571083136,
                                38.108386269237343
                            ],
                            [
                                13.508452877012198,
                                38.119662685649452
                            ],
                            [
                                13.537651700530859,
                                38.112756897698141
                            ],
                            [
                                13.536927901657736,
                                38.08214368987089
                            ],
                            [
                                13.54395166426723,
                                38.075468926441033
                            ],
                            [
                                13.537813472591779,
                                38.064723633124132
                            ],
                            [
                                13.566282543839524,
                                38.038816811560864
                            ],
                            [
                                13.652042056981715,
                                37.997820711579955
                            ],
                            [
                                13.708500443481352,
                                37.991252814680152
                            ],
                            [
                                13.721378077300516,
                                37.9870963095251
                            ],
                            [
                                13.703503926355648,
                                37.989990595906981
                            ],
                            [
                                13.708763884436758,
                                37.978230153385127
                            ],
                            [
                                13.744819344786961,
                                37.970202004909112
                            ],
                            [
                                13.834790724240639,
                                37.982881214320514
                            ],
                            [
                                13.945683464786464,
                                38.028256955515033
                            ],
                            [
                                14.005940425824694,
                                38.032494394082171
                            ],
                            [
                                14.023280791293592,
                                38.041149112516045
                            ],
                            [
                                14.037178561580797,
                                38.041586991813105
                            ],
                            [
                                14.03253963374511,
                                38.036491312901262
                            ],
                            [
                                14.064983224480256,
                                38.018563964849477
                            ],
                            [
                                14.125913305691572,
                                38.016862387100538
                            ],
                            [
                                14.146336134349742,
                                38.029964992458083
                            ],
                            [
                                14.169395824164893,
                                38.018271810840901
                            ],
                            [
                                14.288319444566392,
                                38.007066559938096
                            ],
                            [
                                14.341455172115648,
                                38.019260722207008
                            ],
                            [
                                14.372689840133548,
                                38.015902776651536
                            ],
                            [
                                14.426815783533028,
                                38.040618256378323
                            ],
                            [
                                14.470849793212849,
                                38.032875040079581
                            ],
                            [
                                14.520993726221876,
                                38.04148948698176
                            ],
                            [
                                14.556282051353625,
                                38.060177306297113
                            ],
                            [
                                14.585521522527086,
                                38.059113783148646
                            ],
                            [
                                14.6362932159065,
                                38.073331181024862
                            ],
                            [
                                14.677726447570997,
                                38.099082672277916
                            ],
                            [
                                14.747703895178756,
                                38.165445905731616
                            ],
                            [
                                14.787360180339791,
                                38.151465770517945
                            ],
                            [
                                14.88832067396692,
                                38.171765723255476
                            ],
                            [
                                14.916149107364234,
                                38.192318683099188
                            ],
                            [
                                14.939623318355254,
                                38.179377156691579
                            ],
                            [
                                14.969622294755625,
                                38.152503623295182
                            ],
                            [
                                15.044682742583758,
                                38.151961108993831
                            ],
                            [
                                15.056046150050138,
                                38.131550364778747
                            ],
                            [
                                15.095893065155083,
                                38.120946752952733
                            ],
                            [
                                15.173626405677457,
                                38.153427645263264
                            ],
                            [
                                15.212008257776208,
                                38.186483621903612
                            ],
                            [
                                15.240832796830334,
                                38.242548362454322
                            ],
                            [
                                15.231055631526436,
                                38.271594840586026
                            ],
                            [
                                15.252796922316975,
                                38.246805617468937
                            ],
                            [
                                15.241147564404001,
                                38.21695179213512
                            ],
                            [
                                15.25906015846142,
                                38.208387332329984
                            ],
                            [
                                15.292689044057886,
                                38.206437911712968
                            ],
                            [
                                15.425986710933504,
                                38.241391979638344
                            ],
                            [
                                15.519312225871678,
                                38.297323841168364
                            ],
                            [
                                15.541272558146668,
                                38.301504668354397
                            ],
                            [
                                15.609187938995435,
                                38.274467934235702
                            ],
                            [
                                15.652794619949606,
                                38.267307491930069
                            ],
                            [
                                15.58203828744664,
                                38.245421784846748
                            ],
                            [
                                15.557453474726648,
                                38.190444400835581
                            ],
                            [
                                15.565490242431235,
                                38.192808528920175
                            ],
                            [
                                15.563094744477104,
                                38.19906462893497
                            ],
                            [
                                15.575903360449216,
                                38.194175335071506
                            ],
                            [
                                15.529934765513952,
                                38.14114727548224
                            ],
                            [
                                15.493461849907137,
                                38.074675058307456
                            ],
                            [
                                15.349213307874301,
                                37.923465652907005
                            ],
                            [
                                15.345822431694327,
                                37.910227041446724
                            ],
                            [
                                15.305822948320509,
                                37.877932996173072
                            ],
                            [
                                15.29645627751613,
                                37.862437063822597
                            ],
                            [
                                15.305248266887769,
                                37.851587984583844
                            ],
                            [
                                15.297983171287608,
                                37.844335433742273
                            ],
                            [
                                15.286016764342298,
                                37.847704039460226
                            ],
                            [
                                15.272946715761289,
                                37.835866003547665
                            ],
                            [
                                15.265396806785297,
                                37.81516661817831
                            ],
                            [
                                15.213682687621152,
                                37.756559956918395
                            ],
                            [
                                15.204771400365637,
                                37.736400235656149
                            ],
                            [
                                15.21820809452346,
                                37.708434127666145
                            ],
                            [
                                15.199039597111534,
                                37.676740129479171
                            ],
                            [
                                15.199022593764854,
                                37.654243381334986
                            ],
                            [
                                15.174207807612781,
                                37.632561331600428
                            ],
                            [
                                15.177002843139656,
                                37.576322945443849
                            ],
                            [
                                15.148415106031724,
                                37.556350569986265
                            ],
                            [
                                15.142855658871975,
                                37.543622173571052
                            ],
                            [
                                15.116015517272253,
                                37.531633554970576
                            ],
                            [
                                15.099239530109427,
                                37.499864786685748
                            ],
                            [
                                15.090132096416752,
                                37.499718853461793
                            ],
                            [
                                15.090424847274523,
                                37.362302690839108
                            ],
                            [
                                15.099267998228761,
                                37.318060916501921
                            ],
                            [
                                15.105200853226648,
                                37.310195330371748
                            ],
                            [
                                15.139144410326004,
                                37.306875998165829
                            ],
                            [
                                15.162094810230068,
                                37.289064548990964
                            ],
                            [
                                15.171775908348501,
                                37.293198883973702
                            ],
                            [
                                15.186512594748166,
                                37.279472956418026
                            ],
                            [
                                15.20425651679188,
                                37.294297615722613
                            ],
                            [
                                15.254847322119131,
                                37.243964987851818
                            ],
                            [
                                15.247022258930036,
                                37.232089147088828
                            ],
                            [
                                15.225227449448834,
                                37.240667061185889
                            ],
                            [
                                15.224330593645485,
                                37.216288879825257
                            ],
                            [
                                15.215974162525843,
                                37.223609688368541
                            ],
                            [
                                15.214351564820436,
                                37.24719652994326
                            ],
                            [
                                15.192698865238661,
                                37.235968608939423
                            ],
                            [
                                15.194670189429877,
                                37.224251956171948
                            ],
                            [
                                15.183074877514667,
                                37.215843627094905
                            ],
                            [
                                15.186340160352021,
                                37.191560223804821
                            ],
                            [
                                15.201180415673573,
                                37.178299792436881
                            ],
                            [
                                15.206343457039354,
                                37.153110607212852
                            ],
                            [
                                15.220915489530633,
                                37.150233698817694
                            ],
                            [
                                15.23347261266135,
                                37.159189416264091
                            ],
                            [
                                15.244615075369204,
                                37.145933901618974
                            ],
                            [
                                15.229098196511572,
                                37.152670501364561
                            ],
                            [
                                15.219979000479546,
                                37.143430605598368
                            ],
                            [
                                15.220597896322332,
                                37.129465793948626
                            ],
                            [
                                15.236811764947317,
                                37.115501995920191
                            ],
                            [
                                15.258765038987317,
                                37.109816558055577
                            ],
                            [
                                15.267954949879101,
                                37.116008875843363
                            ],
                            [
                                15.268706242740404,
                                37.115936021183039
                            ],
                            [
                                15.262550841666435,
                                37.106165421722771
                            ],
                            [
                                15.295610210633408,
                                37.106807405990573
                            ],
                            [
                                15.300136043378185,
                                37.085488107508127
                            ],
                            [
                                15.291128516469461,
                                37.067154214014359
                            ],
                            [
                                15.298497397352627,
                                37.059478460961408
                            ],
                            [
                                15.296157139234676,
                                37.052631399893578
                            ],
                            [
                                15.289219031631383,
                                37.06335603349045
                            ],
                            [
                                15.274382366633422,
                                37.062400255778485
                            ],
                            [
                                15.275416769976543,
                                37.039551567219121
                            ],
                            [
                                15.288107778978004,
                                37.032647533803548
                            ],
                            [
                                15.300685228604678,
                                37.042656297913297
                            ],
                            [
                                15.312278292349365,
                                37.038706051102416
                            ],
                            [
                                15.336604283571532,
                                37.007630736878269
                            ],
                            [
                                15.335333364003265,
                                37.001798475910839
                            ],
                            [
                                15.314850787633693,
                                37.003772404905632
                            ],
                            [
                                15.301584796519617,
                                37.015369892611346
                            ],
                            [
                                15.274977383202463,
                                37.006791301637342
                            ],
                            [
                                15.264727694096583,
                                36.9976855996306
                            ],
                            [
                                15.262482745199309,
                                36.975165305210908
                            ],
                            [
                                15.208395485938421,
                                36.963596871615678
                            ],
                            [
                                15.15329276112729,
                                36.914522080122879
                            ],
                            [
                                15.13670598256676,
                                36.866861186454443
                            ],
                            [
                                15.126675209071614,
                                36.865816061614559
                            ],
                            [
                                15.11064751000991,
                                36.848381633066317
                            ],
                            [
                                15.109710295365053,
                                36.8169892529083
                            ],
                            [
                                15.094036131673448,
                                36.799393305510243
                            ],
                            [
                                15.102929043252907,
                                36.757918282843015
                            ],
                            [
                                15.119364814070027,
                                36.744821779342196
                            ],
                            [
                                15.123465094582224,
                                36.701663060960506
                            ],
                            [
                                15.140112039626169,
                                36.685101753005171
                            ],
                            [
                                15.131827365281255,
                                36.66687256118496
                            ],
                            [
                                15.115947048666783,
                                36.67483013781834
                            ],
                            [
                                15.078368955504363,
                                36.646578093763665
                            ],
                            [
                                15.070735604769744,
                                36.658513922490492
                            ],
                            [
                                15.056466637119973,
                                36.661879674382277
                            ],
                            [
                                15.043740610170133,
                                36.687780799642518
                            ],
                            [
                                15.017822653064297,
                                36.70208038067851
                            ],
                            [
                                14.956478369440624,
                                36.694148587526456
                            ],
                            [
                                14.910132876755535,
                                36.724376575741417
                            ],
                            [
                                14.876708063958427,
                                36.731160873303082
                            ],
                            [
                                14.834370502888037,
                                36.722166492144567
                            ],
                            [
                                14.826850649795041,
                                36.715008128379871
                            ],
                            [
                                14.839703765677179,
                                36.707919531249047
                            ],
                            [
                                14.816531526671804,
                                36.716959257990339
                            ],
                            [
                                14.780912232206338,
                                36.703740506806795
                            ],
                            [
                                14.746438393926415,
                                36.720136659258969
                            ],
                            [
                                14.689700333590041,
                                36.721299160191577
                            ],
                            [
                                14.638987797732913,
                                36.761120402055845
                            ],
                            [
                                14.588149640550837,
                                36.777055992984835
                            ],
                            [
                                14.493206000453378,
                                36.786576230037639
                            ],
                            [
                                14.459899213372895,
                                36.814742818010004
                            ],
                            [
                                14.444019351130791,
                                36.870083749386737
                            ],
                            [
                                14.382905416814202,
                                36.956203946480692
                            ],
                            [
                                14.326150812935682,
                                37.012164155322679
                            ],
                            [
                                14.269217797479383,
                                37.053231790032619
                            ],
                            [
                                14.167109078420106,
                                37.092151647456419
                            ],
                            [
                                14.078773066043873,
                                37.109708765322701
                            ],
                            [
                                13.981244440357324,
                                37.109327066276855
                            ],
                            [
                                13.931541783130905,
                                37.09492158521077
                            ],
                            [
                                13.895499837555626,
                                37.097532185720418
                            ],
                            [
                                13.85832959226431,
                                37.112673914616195
                            ],
                            [
                                13.844569977111597,
                                37.133063600744713
                            ],
                            [
                                13.823945448926361,
                                37.1445498351979
                            ],
                            [
                                13.751255812803702,
                                37.14931838649575
                            ],
                            [
                                13.726018942340474,
                                37.170312088705437
                            ],
                            [
                                13.663302700742209,
                                37.193442724032494
                            ],
                            [
                                13.641688945603599,
                                37.227272584088361
                            ],
                            [
                                13.555384922621913,
                                37.285499851849565
                            ],
                            [
                                13.53747434328502,
                                37.282305744874563
                            ],
                            [
                                13.510063816403877,
                                37.291859789595634
                            ],
                            [
                                13.482226991389762,
                                37.288247432877661
                            ],
                            [
                                13.448349080158383,
                                37.296020719807245
                            ],
                            [
                                13.426208281530817,
                                37.306867216356146
                            ],
                            [
                                13.401717463396915,
                                37.333107357648977
                            ],
                            [
                                13.351061902980558,
                                37.358977623221918
                            ],
                            [
                                13.321598260036268,
                                37.363788753449633
                            ],
                            [
                                13.293756904681977,
                                37.389049436473705
                            ],
                            [
                                13.271480687777855,
                                37.391751553694128
                            ],
                            [
                                13.253714179311157,
                                37.424607257177691
                            ],
                            [
                                13.168775093481372,
                                37.49204910480131
                            ],
                            [
                                13.14835108831997,
                                37.497328552167829
                            ],
                            [
                                13.130485515632065,
                                37.492541731662385
                            ],
                            [
                                13.077952806239457,
                                37.505796359626466
                            ],
                            [
                                13.019900062967183,
                                37.495640541618464
                            ],
                            [
                                12.99276220489442,
                                37.536531489322293
                            ],
                            [
                                12.964012058925112,
                                37.561678558847213
                            ],
                            [
                                12.917583047950714,
                                37.577161917761394
                            ],
                            [
                                12.906534667715182,
                                37.572409490798933
                            ],
                            [
                                12.858107767576085,
                                37.582693698336854
                            ],
                            [
                                12.780851530851903,
                                37.580893769533418
                            ],
                            [
                                12.672707053041972,
                                37.560011711132759
                            ],
                            [
                                12.628664690663667,
                                37.602413763610471
                            ],
                            [
                                12.614631392323441,
                                37.635856438376159
                            ],
                            [
                                12.560786298352234,
                                37.662523324101087
                            ],
                            [
                                12.517569940637246,
                                37.660859921058176
                            ],
                            [
                                12.475956023530587,
                                37.699027320943472
                            ],
                            [
                                12.471032650848299,
                                37.744499336340759
                            ],
                            [
                                12.44315526850734,
                                37.788228725915545
                            ]
                        ],
                        [
                            [
                                15.300775346525795,
                                37.850782155532279
                            ],
                            [
                                15.299739246681456,
                                37.850295625496074
                            ],
                            [
                                15.300823444098866,
                                37.849482738226577
                            ],
                            [
                                15.301438030493802,
                                37.850115339442858
                            ],
                            [
                                15.300775346525795,
                                37.850782155532279
                            ]
                        ],
                        [
                            [
                                15.118668754344426,
                                36.737893875935058
                            ],
                            [
                                15.119002965100508,
                                36.738106126197621
                            ],
                            [
                                15.119098886278644,
                                36.738643431873356
                            ],
                            [
                                15.118280597433859,
                                36.738548419037031
                            ],
                            [
                                15.118668754344426,
                                36.737893875935058
                            ]
                        ],
                        [
                            [
                                15.146438094985442,
                                38.141576242596962
                            ],
                            [
                                15.147067600377733,
                                38.141850269401644
                            ],
                            [
                                15.147373137812471,
                                38.142147304319785
                            ],
                            [
                                15.147210983274727,
                                38.142068443259625
                            ],
                            [
                                15.146438094985442,
                                38.141576242596962
                            ]
                        ],
                        [
                            [
                                12.732931879796091,
                                38.180261674088641
                            ],
                            [
                                12.732772241233947,
                                38.180683006512602
                            ],
                            [
                                12.732309763964651,
                                38.180365407874298
                            ],
                            [
                                12.732709590372252,
                                38.180077320740168
                            ],
                            [
                                12.732931879796091,
                                38.180261674088641
                            ]
                        ],
                        [
                            [
                                12.731768958755245,
                                38.181917572126295
                            ],
                            [
                                12.732629200051404,
                                38.181619100951693
                            ],
                            [
                                12.732668305257125,
                                38.181671301430299
                            ],
                            [
                                12.731768958755245,
                                38.181917572126295
                            ]
                        ],
                        [
                            [
                                14.966714347301794,
                                38.154146633015728
                            ],
                            [
                                14.96730570805668,
                                38.154158951479914
                            ],
                            [
                                14.967468115853242,
                                38.154073974959303
                            ],
                            [
                                14.967319353542164,
                                38.154221042101888
                            ],
                            [
                                14.966714347301794,
                                38.154146633015728
                            ]
                        ],
                        [
                            [
                                13.537254701030628,
                                38.07075368776151
                            ],
                            [
                                13.537511926470236,
                                38.070517224705547
                            ],
                            [
                                13.537580973377505,
                                38.070561106723837
                            ],
                            [
                                13.537254701030628,
                                38.07075368776151
                            ]
                        ],
                        [
                            [
                                15.241582944419555,
                                37.234571716219619
                            ],
                            [
                                15.241466615100645,
                                37.234317230231532
                            ],
                            [
                                15.241677835260836,
                                37.234604691463907
                            ],
                            [
                                15.241582944419555,
                                37.234571716219619
                            ]
                        ],
                        [
                            [
                                15.612866546725717,
                                38.256829220848054
                            ],
                            [
                                15.613254180123832,
                                38.256781034289027
                            ],
                            [
                                15.613261010944177,
                                38.256838323095586
                            ],
                            [
                                15.613021973517718,
                                38.256839572396572
                            ],
                            [
                                15.612866546725717,
                                38.256829220848054
                            ]
                        ],
                        [
                            [
                                12.458970195867629,
                                37.815725252198938
                            ],
                            [
                                12.459069655508566,
                                37.815573636416012
                            ],
                            [
                                12.459079419812779,
                                37.815823186600738
                            ],
                            [
                                12.458970195867629,
                                37.815725252198938
                            ]
                        ],
                        [
                            [
                                13.539846804959275,
                                38.072466692616786
                            ],
                            [
                                13.539859932619123,
                                38.072393108860574
                            ],
                            [
                                13.539806707213684,
                                38.072334064136435
                            ],
                            [
                                13.53997668873382,
                                38.072382263633074
                            ],
                            [
                                13.539846804959275,
                                38.072466692616786
                            ]
                        ],
                        [
                            [
                                15.2392055721305,
                                37.235851320039977
                            ],
                            [
                                15.238962164747059,
                                37.235688314720349
                            ],
                            [
                                15.239306293844173,
                                37.235858239828502
                            ],
                            [
                                15.2392055721305,
                                37.235851320039977
                            ]
                        ],
                        [
                            [
                                12.732892814428547,
                                38.179945835452003
                            ],
                            [
                                12.732950570842638,
                                38.179921231766642
                            ],
                            [
                                12.733104915098236,
                                38.180108544135798
                            ],
                            [
                                12.732892814428547,
                                38.179945835452003
                            ]
                        ],
                        [
                            [
                                15.145761065327683,
                                38.141366264115256
                            ],
                            [
                                15.145827879161546,
                                38.141415112204839
                            ],
                            [
                                15.145808941721022,
                                38.141482907084047
                            ],
                            [
                                15.145761190812447,
                                38.141430264036288
                            ],
                            [
                                15.145761065327683,
                                38.141366264115256
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                11.972507979395882,
                                36.834765054453406
                            ],
                            [
                                12.001205393130972,
                                36.819721335026259
                            ],
                            [
                                12.013216546182305,
                                36.825225590035181
                            ],
                            [
                                12.05258777439977,
                                36.793615280842587
                            ],
                            [
                                12.054403744685859,
                                36.761564352086296
                            ],
                            [
                                12.028221921694968,
                                36.735881693851383
                            ],
                            [
                                11.992006653372501,
                                36.737944741084185
                            ],
                            [
                                11.926457590387894,
                                36.802330195331642
                            ],
                            [
                                11.934818154682185,
                                36.833814206769368
                            ],
                            [
                                11.942168136165519,
                                36.830813777386936
                            ],
                            [
                                11.954412889909475,
                                36.839472527753422
                            ],
                            [
                                11.972507979395882,
                                36.834765054453406
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.960346427552894,
                                38.523445448323997
                            ],
                            [
                                14.962474092676471,
                                38.490980264374834
                            ],
                            [
                                14.980550431523294,
                                38.483391995390171
                            ],
                            [
                                14.955157132107971,
                                38.474481082423424
                            ],
                            [
                                14.962508451160618,
                                38.452349924625096
                            ],
                            [
                                14.954101877894178,
                                38.439198230969886
                            ],
                            [
                                14.933422585262283,
                                38.460668709740496
                            ],
                            [
                                14.912037566414748,
                                38.465458058417518
                            ],
                            [
                                14.897524896407399,
                                38.486435413351948
                            ],
                            [
                                14.912357357762268,
                                38.518489779469625
                            ],
                            [
                                14.960346427552894,
                                38.523445448323997
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.864574221644347,
                                38.583087126174263
                            ],
                            [
                                14.872869735510312,
                                38.566881669992966
                            ],
                            [
                                14.871132411674921,
                                38.536755052004999
                            ],
                            [
                                14.849108919940454,
                                38.536449375782091
                            ],
                            [
                                14.795925124549271,
                                38.561701378335798
                            ],
                            [
                                14.807216596834554,
                                38.583132868768928
                            ],
                            [
                                14.864574221644347,
                                38.583087126174263
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.962350517926275,
                                38.419897124104281
                            ],
                            [
                                14.963588736886914,
                                38.412169566736942
                            ],
                            [
                                14.997101414955992,
                                38.396142481487338
                            ],
                            [
                                15.006381182550664,
                                38.375752187511438
                            ],
                            [
                                14.992188952028267,
                                38.36677138068746
                            ],
                            [
                                14.954673327997428,
                                38.381971048296471
                            ],
                            [
                                14.9391883640229,
                                38.402043261795093
                            ],
                            [
                                14.959408128057774,
                                38.43233743000512
                            ],
                            [
                                14.968917818313951,
                                38.425455057949847
                            ],
                            [
                                14.962350517926275,
                                38.419897124104281
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.530747426720746,
                                35.529210855975542
                            ],
                            [
                                12.627787260220131,
                                35.520468928256975
                            ],
                            [
                                12.632563155906958,
                                35.493755042585676
                            ],
                            [
                                12.607802708792237,
                                35.495312641187255
                            ],
                            [
                                12.604127566156942,
                                35.502892553275998
                            ],
                            [
                                12.599125174390245,
                                35.495599914461422
                            ],
                            [
                                12.568654190697936,
                                35.511502901106397
                            ],
                            [
                                12.518214632900067,
                                35.519489015392374
                            ],
                            [
                                12.530747426720746,
                                35.529210855975542
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.276658444018857,
                                37.934702598971157
                            ],
                            [
                                12.278183288936527,
                                37.945219266722958
                            ],
                            [
                                12.288316501208499,
                                37.941909369297555
                            ],
                            [
                                12.307889158558988,
                                37.953302931477921
                            ],
                            [
                                12.323794353748209,
                                37.929304062255312
                            ],
                            [
                                12.34423956837586,
                                37.936679662941778
                            ],
                            [
                                12.369043603534859,
                                37.922441269511928
                            ],
                            [
                                12.366902335221491,
                                37.907974122311359
                            ],
                            [
                                12.350575478998445,
                                37.907682845150021
                            ],
                            [
                                12.337132134043138,
                                37.919855726766507
                            ],
                            [
                                12.286312246771713,
                                37.915951712578511
                            ],
                            [
                                12.276658444018857,
                                37.934702598971157
                            ]
                        ],
                        [
                            [
                                12.282898661395043,
                                37.924589596593549
                            ],
                            [
                                12.282831135078519,
                                37.924558712939671
                            ],
                            [
                                12.282985190493877,
                                37.924607291454947
                            ],
                            [
                                12.282898661395043,
                                37.924589596593549
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                15.214945572885327,
                                38.771548301190414
                            ],
                            [
                                15.187207728349092,
                                38.790934940573912
                            ],
                            [
                                15.220472419000272,
                                38.812180263755565
                            ],
                            [
                                15.243063434305963,
                                38.802439016742788
                            ],
                            [
                                15.214945572885327,
                                38.771548301190414
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.063757328408563,
                                37.990103372336137
                            ],
                            [
                                12.064772868375545,
                                37.977411179124061
                            ],
                            [
                                12.091571386064304,
                                37.947407267206138
                            ],
                            [
                                12.044288292986097,
                                37.958589575677905
                            ],
                            [
                                12.027800653223592,
                                37.991618561186186
                            ],
                            [
                                12.063757328408563,
                                37.990103372336137
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.58584231311643,
                                38.558911688729978
                            ],
                            [
                                14.593116165022073,
                                38.555846105804854
                            ],
                            [
                                14.555629148228206,
                                38.557823107948764
                            ],
                            [
                                14.541411576981504,
                                38.58223551459524
                            ],
                            [
                                14.57555296538272,
                                38.581332447321458
                            ],
                            [
                                14.58584231311643,
                                38.558911688729978
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                13.181929817579009,
                                38.719447617601986
                            ],
                            [
                                13.200294110591319,
                                38.710784173344756
                            ],
                            [
                                13.185830783039222,
                                38.696287554878076
                            ],
                            [
                                13.152713185420811,
                                38.693507231084524
                            ],
                            [
                                13.159222821368225,
                                38.712036823480688
                            ],
                            [
                                13.181929817579009,
                                38.719447617601986
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.350486525314444,
                                37.988413798289677
                            ],
                            [
                                12.333187957634332,
                                37.986031255414865
                            ],
                            [
                                12.322554093170149,
                                37.995205388247477
                            ],
                            [
                                12.333218019309831,
                                38.020704095373304
                            ],
                            [
                                12.350486525314444,
                                37.988413798289677
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.449845858137493,
                                37.896264531565961
                            ],
                            [
                                12.451673197824636,
                                37.852970876215863
                            ],
                            [
                                12.446365848862255,
                                37.844105635337364
                            ],
                            [
                                12.428685269023426,
                                37.892401510795864
                            ],
                            [
                                12.454989250025797,
                                37.905010742765803
                            ],
                            [
                                12.449845858137493,
                                37.896264531565961
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.87530041237525,
                                35.875440555139249
                            ],
                            [
                                12.881368967886129,
                                35.855193990918202
                            ],
                            [
                                12.85838432690052,
                                35.85542635383878
                            ],
                            [
                                12.849124110634589,
                                35.871125553564809
                            ],
                            [
                                12.87530041237525,
                                35.875440555139249
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.351654367841245,
                                38.530696174600422
                            ],
                            [
                                14.341337663031696,
                                38.534766029551122
                            ],
                            [
                                14.34015269193811,
                                38.548304177478876
                            ],
                            [
                                14.362164275454404,
                                38.554310898449579
                            ],
                            [
                                14.36341364812526,
                                38.537893594713921
                            ],
                            [
                                14.351654367841245,
                                38.530696174600422
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                15.058383418561029,
                                38.625105778024874
                            ],
                            [
                                15.058913178692064,
                                38.640754584788162
                            ],
                            [
                                15.073572153307122,
                                38.646392196295395
                            ],
                            [
                                15.075562231715088,
                                38.631953957019398
                            ],
                            [
                                15.058383418561029,
                                38.625105778024874
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                15.144126042792141,
                                36.682338606827742
                            ],
                            [
                                15.146150797530014,
                                36.68852125890357
                            ],
                            [
                                15.154041846926328,
                                36.688992802842478
                            ],
                            [
                                15.15136100375603,
                                36.684938991117626
                            ],
                            [
                                15.144126042792141,
                                36.682338606827742
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.467770176784615,
                                37.863616124109633
                            ],
                            [
                                12.464128373345819,
                                37.868812968293454
                            ],
                            [
                                12.47031617296032,
                                37.870671931447234
                            ],
                            [
                                12.471646881520911,
                                37.866325480239858
                            ],
                            [
                                12.467770176784615,
                                37.863616124109633
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                15.11751891393885,
                                38.661014004602954
                            ],
                            [
                                15.110169747861148,
                                38.661697042319538
                            ],
                            [
                                15.108618237941327,
                                38.663712633004188
                            ],
                            [
                                15.11509053024753,
                                38.666180173927849
                            ],
                            [
                                15.11751891393885,
                                38.661014004602954
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.464700361554591,
                                37.878531326045987
                            ],
                            [
                                12.458263634275792,
                                37.881853007167138
                            ],
                            [
                                12.454889441801489,
                                37.887611678726266
                            ],
                            [
                                12.465051727972009,
                                37.879617526294268
                            ],
                            [
                                12.464700361554591,
                                37.878531326045987
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                13.23379931453454,
                                38.212131320363078
                            ],
                            [
                                13.23715433923376,
                                38.212058803378035
                            ],
                            [
                                13.237547394076929,
                                38.208267085015684
                            ],
                            [
                                13.234361594148886,
                                38.208715486816942
                            ],
                            [
                                13.23379931453454,
                                38.212131320363078
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.416566854699228,
                                37.987569529331047
                            ],
                            [
                                12.414469484683885,
                                37.988370401264653
                            ],
                            [
                                12.410834469423502,
                                37.992182954906838
                            ],
                            [
                                12.414029864271081,
                                37.990189884311192
                            ],
                            [
                                12.416566854699228,
                                37.987569529331047
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.302443540345127,
                                37.913899358453797
                            ],
                            [
                                12.300684498515269,
                                37.914183362875313
                            ],
                            [
                                12.299838964689899,
                                37.915533557319897
                            ],
                            [
                                12.302094767494403,
                                37.916207054796288
                            ],
                            [
                                12.302443540345127,
                                37.913899358453797
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.321310411134538,
                                35.550682400089435
                            ],
                            [
                                12.319814990593354,
                                35.55129134457875
                            ],
                            [
                                12.320532612005055,
                                35.553339802740453
                            ],
                            [
                                12.322577072796774,
                                35.552141398370324
                            ],
                            [
                                12.321310411134538,
                                35.550682400089435
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.425822821193787,
                                37.988040236185171
                            ],
                            [
                                12.423401429580224,
                                37.988424201326779
                            ],
                            [
                                12.423451979334271,
                                37.98990754746638
                            ],
                            [
                                12.426679696943062,
                                37.989257405628344
                            ],
                            [
                                12.425822821193787,
                                37.988040236185171
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.496487137717708,
                                38.011596739614596
                            ],
                            [
                                12.492028553306884,
                                38.011085269968397
                            ],
                            [
                                12.48885699006409,
                                38.011900234201924
                            ],
                            [
                                12.496000862336134,
                                38.012160744295109
                            ],
                            [
                                12.496487137717708,
                                38.011596739614596
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                15.106023102429361,
                                36.790764798365778
                            ],
                            [
                                15.105425862551334,
                                36.790098056667063
                            ],
                            [
                                15.10410460559727,
                                36.792371173422318
                            ],
                            [
                                15.106004245112512,
                                36.792442044168574
                            ],
                            [
                                15.106023102429361,
                                36.790764798365778
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                15.113940451906846,
                                38.638578130348272
                            ],
                            [
                                15.111936668499883,
                                38.639386620355864
                            ],
                            [
                                15.113713543385447,
                                38.640412255370769
                            ],
                            [
                                15.115366100229227,
                                38.639126443594307
                            ],
                            [
                                15.113940451906846,
                                38.638578130348272
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.559455083183792,
                                35.509658510758264
                            ],
                            [
                                12.558214787413368,
                                35.509570303899835
                            ],
                            [
                                12.557208672606226,
                                35.510667632445887
                            ],
                            [
                                12.558492972659243,
                                35.511486871788705
                            ],
                            [
                                12.559455083183792,
                                35.509658510758264
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                15.166699056076956,
                                37.56043456984257
                            ],
                            [
                                15.165756067104937,
                                37.561309773047796
                            ],
                            [
                                15.166472353125402,
                                37.562246484808007
                            ],
                            [
                                15.167843891958338,
                                37.561495059765576
                            ],
                            [
                                15.166699056076956,
                                37.56043456984257
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                15.096984067214981,
                                38.638706055516266
                            ],
                            [
                                15.095683828152183,
                                38.639464116371599
                            ],
                            [
                                15.0974718432138,
                                38.640408890070567
                            ],
                            [
                                15.098101954435087,
                                38.639043072352138
                            ],
                            [
                                15.096984067214981,
                                38.638706055516266
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                15.205485710262696,
                                37.235741389948146
                            ],
                            [
                                15.203452424940826,
                                37.235296459615491
                            ],
                            [
                                15.203191051751116,
                                37.235576339816134
                            ],
                            [
                                15.204326858419071,
                                37.236608733164132
                            ],
                            [
                                15.205485710262696,
                                37.235741389948146
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                15.26439528776061,
                                36.978745795967001
                            ],
                            [
                                15.262980472508252,
                                36.979003577556782
                            ],
                            [
                                15.263106790233886,
                                36.97979656769909
                            ],
                            [
                                15.264064138309193,
                                36.979647968479817
                            ],
                            [
                                15.26439528776061,
                                36.978745795967001
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.32723402387065,
                                37.987436792178428
                            ],
                            [
                                12.328974057888486,
                                37.987016825510196
                            ],
                            [
                                12.329365861398822,
                                37.986494105103787
                            ],
                            [
                                12.327631820652272,
                                37.986670947843912
                            ],
                            [
                                12.32723402387065,
                                37.987436792178428
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.289161542722972,
                                37.913765144751608
                            ],
                            [
                                12.288868394497486,
                                37.914082768968221
                            ],
                            [
                                12.289868761891467,
                                37.915412348051532
                            ],
                            [
                                12.290407516818364,
                                37.914523707149193
                            ],
                            [
                                12.289161542722972,
                                37.913765144751608
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.298780288333207,
                                37.911751872393893
                            ],
                            [
                                12.297783955349791,
                                37.912017325287621
                            ],
                            [
                                12.29790618613143,
                                37.912795037377968
                            ],
                            [
                                12.298856778721378,
                                37.912303273060516
                            ],
                            [
                                12.298780288333207,
                                37.911751872393893
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                15.110890717033547,
                                38.6373013666147
                            ],
                            [
                                15.109835175291972,
                                38.638302676398986
                            ],
                            [
                                15.109864628870071,
                                38.638784780228228
                            ],
                            [
                                15.110920474376602,
                                38.637963711490009
                            ],
                            [
                                15.110890717033547,
                                38.6373013666147
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.528897828950917,
                                38.063769153974015
                            ],
                            [
                                12.528848915106316,
                                38.064277369930636
                            ],
                            [
                                12.529674547352073,
                                38.065074578323831
                            ],
                            [
                                12.529579791811997,
                                38.064163047174127
                            ],
                            [
                                12.528897828950917,
                                38.063769153974015
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                15.108702426016775,
                                38.664275793591266
                            ],
                            [
                                15.107651159792489,
                                38.664583159587309
                            ],
                            [
                                15.107404694110739,
                                38.665020464481628
                            ],
                            [
                                15.108358574378235,
                                38.664924952163872
                            ],
                            [
                                15.108702426016775,
                                38.664275793591266
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.931946307971412,
                                36.685803012357411
                            ],
                            [
                                14.931357006712558,
                                36.686095767282112
                            ],
                            [
                                14.932038111508687,
                                36.686559008241161
                            ],
                            [
                                14.932502973435691,
                                36.686074472687487
                            ],
                            [
                                14.931946307971412,
                                36.685803012357411
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                15.062851466738259,
                                38.624233808550166
                            ],
                            [
                                15.061987117436644,
                                38.624351427057668
                            ],
                            [
                                15.063676117415213,
                                38.624665942944297
                            ],
                            [
                                15.063664541402343,
                                38.624566801946443
                            ],
                            [
                                15.062851466738259,
                                38.624233808550166
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                15.166061219487268,
                                37.559327266175153
                            ],
                            [
                                15.165282228340134,
                                37.559408601938564
                            ],
                            [
                                15.165363966866934,
                                37.560191830735874
                            ],
                            [
                                15.166123682509776,
                                37.559578244168918
                            ],
                            [
                                15.166061219487268,
                                37.559327266175153
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.938620753299988,
                                38.399510528995535
                            ],
                            [
                                14.938005156943783,
                                38.399555268191094
                            ],
                            [
                                14.937898920390799,
                                38.399902183493388
                            ],
                            [
                                14.938826366100944,
                                38.400127983812197
                            ],
                            [
                                14.938620753299988,
                                38.399510528995535
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                13.856563728259964,
                                37.112260150978734
                            ],
                            [
                                13.855976843601704,
                                37.112336016065811
                            ],
                            [
                                13.855614319410533,
                                37.112886721520255
                            ],
                            [
                                13.856588783173244,
                                37.11268461844606
                            ],
                            [
                                13.856563728259964,
                                37.112260150978734
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                15.064319470839614,
                                38.647204203971903
                            ],
                            [
                                15.064683906104003,
                                38.64675339948225
                            ],
                            [
                                15.064629128249971,
                                38.646537150150493
                            ],
                            [
                                15.063560880333133,
                                38.647033386272007
                            ],
                            [
                                15.064319470839614,
                                38.647204203971903
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.488803482750319,
                                38.012466556552944
                            ],
                            [
                                12.4883020749672,
                                38.012370953592054
                            ],
                            [
                                12.487833545089691,
                                38.01279037864515
                            ],
                            [
                                12.488619696169303,
                                38.012853189642954
                            ],
                            [
                                12.488803482750319,
                                38.012466556552944
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.456763099600868,
                                37.862609567359669
                            ],
                            [
                                12.456165366456547,
                                37.862720917893803
                            ],
                            [
                                12.456279115716315,
                                37.862959680467604
                            ],
                            [
                                12.457085769551528,
                                37.862950379950853
                            ],
                            [
                                12.456763099600868,
                                37.862609567359669
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.469199192581263,
                                37.730836420416964
                            ],
                            [
                                12.469443251633336,
                                37.730600644974331
                            ],
                            [
                                12.46969354001067,
                                37.730379390938168
                            ],
                            [
                                12.468846288185311,
                                37.730947724284178
                            ],
                            [
                                12.469199192581263,
                                37.730836420416964
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                15.106454746697153,
                                38.634777676754176
                            ],
                            [
                                15.106449869593318,
                                38.635358945269523
                            ],
                            [
                                15.106780334774056,
                                38.635451003328257
                            ],
                            [
                                15.106785717848242,
                                38.635205440811681
                            ],
                            [
                                15.106454746697153,
                                38.634777676754176
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.528586429865577,
                                35.528844319327554
                            ],
                            [
                                12.528388425109409,
                                35.528828988666362
                            ],
                            [
                                12.528183868192336,
                                35.529161689246351
                            ],
                            [
                                12.528597211854624,
                                35.5291217062193
                            ],
                            [
                                12.528586429865577,
                                35.528844319327554
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.49301929643519,
                                36.786631692057732
                            ],
                            [
                                14.493206000453378,
                                36.786576230037639
                            ],
                            [
                                14.492817327075336,
                                36.786643334280818
                            ],
                            [
                                14.491881520835657,
                                36.787251967113399
                            ],
                            [
                                14.49301929643519,
                                36.786631692057732
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                15.091939235500886,
                                37.494961660923337
                            ],
                            [
                                15.091948696595441,
                                37.493443987535429
                            ],
                            [
                                15.091827056507656,
                                37.493423814790873
                            ],
                            [
                                15.091868137942638,
                                37.493484618041009
                            ],
                            [
                                15.091939235500886,
                                37.494961660923337
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                13.069910974819114,
                                38.148447684812105
                            ],
                            [
                                13.070115398161407,
                                38.148305089976212
                            ],
                            [
                                13.070126951402882,
                                38.148229786273312
                            ],
                            [
                                13.069881851239046,
                                38.148223231915217
                            ],
                            [
                                13.069910974819114,
                                38.148447684812105
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.498138530229379,
                                38.014272118590782
                            ],
                            [
                                12.498217042322089,
                                38.013610057229478
                            ],
                            [
                                12.498146940847786,
                                38.013608565217638
                            ],
                            [
                                12.498138530229379,
                                38.014272118590782
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                15.125963635968732,
                                38.134339906185062
                            ],
                            [
                                15.125900729766039,
                                38.134590198383833
                            ],
                            [
                                15.125900912426866,
                                38.134696951257894
                            ],
                            [
                                15.125968468422338,
                                38.134696879837144
                            ],
                            [
                                15.125963635968732,
                                38.134339906185062
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                15.203366786505422,
                                37.293984016889212
                            ],
                            [
                                15.203389624177895,
                                37.29413019207086
                            ],
                            [
                                15.203453023708168,
                                37.29412586961832
                            ],
                            [
                                15.203452630959132,
                                37.293986510662172
                            ],
                            [
                                15.203366786505422,
                                37.293984016889212
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                14.034337368296816,
                                38.037382367867146
                            ],
                            [
                                14.034392439569466,
                                38.037297424611552
                            ],
                            [
                                14.034257552123073,
                                38.037253628680013
                            ],
                            [
                                14.034220802055053,
                                38.037327568084109
                            ],
                            [
                                14.034337368296816,
                                38.037382367867146
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.425709017176391,
                                37.987632262668122
                            ],
                            [
                                12.425793377014589,
                                37.987580041974923
                            ],
                            [
                                12.425408159417845,
                                37.987667344276325
                            ],
                            [
                                12.425709017176391,
                                37.987632262668122
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                13.181994111345059,
                                38.719520699639176
                            ],
                            [
                                13.181947727822829,
                                38.7195920752172
                            ],
                            [
                                13.181934066778178,
                                38.719677458650992
                            ],
                            [
                                13.18202747032014,
                                38.71967891672729
                            ],
                            [
                                13.181994111345059,
                                38.719520699639176
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.44285887633615,
                                37.788121057419559
                            ],
                            [
                                12.44315526850734,
                                37.788228725915545
                            ],
                            [
                                12.442907507547718,
                                37.788075390276418
                            ],
                            [
                                12.44285887633615,
                                37.788121057419559
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                15.116429160568257,
                                37.310591308733223
                            ],
                            [
                                15.116652648283051,
                                37.310412282632591
                            ],
                            [
                                15.116315755300407,
                                37.310586530053996
                            ],
                            [
                                15.116429160568257,
                                37.310591308733223
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                12.276588602945877,
                                37.934805648095399
                            ],
                            [
                                12.276658444018857,
                                37.934702598971157
                            ],
                            [
                                12.276548053264449,
                                37.934758658050946
                            ],
                            [
                                12.276588602945877,
                                37.934805648095399
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                15.185228921695684,
                                37.287147451041477
                            ],
                            [
                                15.185301521709851,
                                37.287127994205726
                            ],
                            [
                                15.185301350263005,
                                37.287062183188091
                            ],
                            [
                                15.185228921695684,
                                37.287147451041477
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 21,
                "name": "Sardegna",
                "length": 1460657.08082,
                "area": 24094165311.900001525878906
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                8.203561822289023,
                                40.581142275114573
                            ],
                            [
                                8.205723731037743,
                                40.592470363199673
                            ],
                            [
                                8.219405747189947,
                                40.601727699302906
                            ],
                            [
                                8.196040000311228,
                                40.61841806365112
                            ],
                            [
                                8.181530494410449,
                                40.59776971020316
                            ],
                            [
                                8.168423785277795,
                                40.593592918928614
                            ],
                            [
                                8.163948345849686,
                                40.559976280880875
                            ],
                            [
                                8.15092436170309,
                                40.579362556370128
                            ],
                            [
                                8.144677653610874,
                                40.623239159925504
                            ],
                            [
                                8.186772952835254,
                                40.639123633849721
                            ],
                            [
                                8.20494472131357,
                                40.684835723134306
                            ],
                            [
                                8.174796648214581,
                                40.694643870823278
                            ],
                            [
                                8.169533143419525,
                                40.708668367658696
                            ],
                            [
                                8.133867106846743,
                                40.731332746208352
                            ],
                            [
                                8.166626378287834,
                                40.766121185160486
                            ],
                            [
                                8.160917722137309,
                                40.79360598888416
                            ],
                            [
                                8.19174921186079,
                                40.821467012264499
                            ],
                            [
                                8.223839902089049,
                                40.886312685314238
                            ],
                            [
                                8.219358199070848,
                                40.900019950620823
                            ],
                            [
                                8.192374815779617,
                                40.912775508435871
                            ],
                            [
                                8.190817716782673,
                                40.924343453439093
                            ],
                            [
                                8.175852933901796,
                                40.934885082165614
                            ],
                            [
                                8.202567396254558,
                                40.971429661860732
                            ],
                            [
                                8.226519122809046,
                                40.953067692885583
                            ],
                            [
                                8.238424285651186,
                                40.952836168523874
                            ],
                            [
                                8.228117152947346,
                                40.930115542770913
                            ],
                            [
                                8.238171854834302,
                                40.903325101458108
                            ],
                            [
                                8.302154451401263,
                                40.850635941674597
                            ],
                            [
                                8.343381995144828,
                                40.840653552952567
                            ],
                            [
                                8.350188458573271,
                                40.850282573870487
                            ],
                            [
                                8.362555184003012,
                                40.852845752190426
                            ],
                            [
                                8.384765586809076,
                                40.851101630293648
                            ],
                            [
                                8.351366294572808,
                                40.850241909319237
                            ],
                            [
                                8.34795347459397,
                                40.839715592642001
                            ],
                            [
                                8.413696782657684,
                                40.838932285884859
                            ],
                            [
                                8.44935356123915,
                                40.821190360088558
                            ],
                            [
                                8.496002979906194,
                                40.82051625340754
                            ],
                            [
                                8.590922136233948,
                                40.842571673371125
                            ],
                            [
                                8.624505601362227,
                                40.863763188792298
                            ],
                            [
                                8.632409375803622,
                                40.881262560064847
                            ],
                            [
                                8.698959537958736,
                                40.914477642035138
                            ],
                            [
                                8.789941922065323,
                                40.922099829384486
                            ],
                            [
                                8.873042590873515,
                                40.99539504315117
                            ],
                            [
                                8.879922801543691,
                                41.028591775130899
                            ],
                            [
                                8.915983633091216,
                                41.035727722195212
                            ],
                            [
                                8.948123699748656,
                                41.05705079533508
                            ],
                            [
                                9.013292987894994,
                                41.125351482677523
                            ],
                            [
                                9.046276630436155,
                                41.137845994636464
                            ],
                            [
                                9.058290258509286,
                                41.127958819650722
                            ],
                            [
                                9.08625979049307,
                                41.1279232565021
                            ],
                            [
                                9.110218718902082,
                                41.134861468495721
                            ],
                            [
                                9.123235122168502,
                                41.156183560019372
                            ],
                            [
                                9.152528768045174,
                                41.155351294890998
                            ],
                            [
                                9.171145708678118,
                                41.17388590981497
                            ],
                            [
                                9.154152254999744,
                                41.197141191018822
                            ],
                            [
                                9.167303548656539,
                                41.22933930839082
                            ],
                            [
                                9.1600095140726,
                                41.235755340486442
                            ],
                            [
                                9.141347953479153,
                                41.232295997992168
                            ],
                            [
                                9.14427955933478,
                                41.246877085398189
                            ],
                            [
                                9.162780384336633,
                                41.235535269829697
                            ],
                            [
                                9.181184042889106,
                                41.248031967875349
                            ],
                            [
                                9.198624189905605,
                                41.244562236237627
                            ],
                            [
                                9.235110750306973,
                                41.259075944699283
                            ],
                            [
                                9.237052422256488,
                                41.245978066510602
                            ],
                            [
                                9.260576153919258,
                                41.241556214311473
                            ],
                            [
                                9.280566236548056,
                                41.227772378489838
                            ],
                            [
                                9.269688015891269,
                                41.19661331667254
                            ],
                            [
                                9.276757135838309,
                                41.19310150355723
                            ],
                            [
                                9.286709038985848,
                                41.219145795516404
                            ],
                            [
                                9.300946313332355,
                                41.202003629683482
                            ],
                            [
                                9.28949700449372,
                                41.193292002184357
                            ],
                            [
                                9.315567959006431,
                                41.191956789282415
                            ],
                            [
                                9.320379830503544,
                                41.202996113583708
                            ],
                            [
                                9.318999374742894,
                                41.193802950749237
                            ],
                            [
                                9.331907029584155,
                                41.185254063302928
                            ],
                            [
                                9.341338274156559,
                                41.192063450620601
                            ],
                            [
                                9.330357857862495,
                                41.194923931965064
                            ],
                            [
                                9.338242805851856,
                                41.204620488235228
                            ],
                            [
                                9.363353646269637,
                                41.20750756753246
                            ],
                            [
                                9.370277712685651,
                                41.183173382563822
                            ],
                            [
                                9.380894423662168,
                                41.187629170327945
                            ],
                            [
                                9.384113467294762,
                                41.178366295278252
                            ],
                            [
                                9.423318893950082,
                                41.176739197523638
                            ],
                            [
                                9.421796419712832,
                                41.166142533779897
                            ],
                            [
                                9.405164374062327,
                                41.157860947089965
                            ],
                            [
                                9.43220014969325,
                                41.151454905889246
                            ],
                            [
                                9.442546343811282,
                                41.101736914862641
                            ],
                            [
                                9.471749758863362,
                                41.125638462366553
                            ],
                            [
                                9.466967809968443,
                                41.143430548427581
                            ],
                            [
                                9.510195824409259,
                                41.140661935131178
                            ],
                            [
                                9.519528193488533,
                                41.156825393885484
                            ],
                            [
                                9.536460068535217,
                                41.137835745298752
                            ],
                            [
                                9.526663796342467,
                                41.133665254782855
                            ],
                            [
                                9.545830550294625,
                                41.133616568183221
                            ],
                            [
                                9.540454182049979,
                                41.114373995825687
                            ],
                            [
                                9.566932267029987,
                                41.115796102395727
                            ],
                            [
                                9.570692623768201,
                                41.100429150753541
                            ],
                            [
                                9.560744801057838,
                                41.084334613340829
                            ],
                            [
                                9.548635529762812,
                                41.079861896979402
                            ],
                            [
                                9.540932658412768,
                                41.089951212111032
                            ],
                            [
                                9.529547300094592,
                                41.073285292421147
                            ],
                            [
                                9.526508525608069,
                                41.042451265240587
                            ],
                            [
                                9.5059588878367,
                                41.009356459219482
                            ],
                            [
                                9.523771882565503,
                                41.010159684851054
                            ],
                            [
                                9.528139069890303,
                                41.026517567911
                            ],
                            [
                                9.561254015564282,
                                41.037643647650995
                            ],
                            [
                                9.555518440229028,
                                41.003702012300359
                            ],
                            [
                                9.574028382484357,
                                41.008191931404447
                            ],
                            [
                                9.576878347327213,
                                41.002786363025884
                            ],
                            [
                                9.595119178127579,
                                41.022664524647382
                            ],
                            [
                                9.630950308464545,
                                41.002061669916344
                            ],
                            [
                                9.656030295074951,
                                41.004443918052658
                            ],
                            [
                                9.664916838958176,
                                40.9953759153709
                            ],
                            [
                                9.651474667845473,
                                40.984075448422402
                            ],
                            [
                                9.611008013597781,
                                41.003150986269858
                            ],
                            [
                                9.582579039233421,
                                40.982933104225253
                            ],
                            [
                                9.593918323289452,
                                40.968405933777824
                            ],
                            [
                                9.568190806329371,
                                40.942365753689764
                            ],
                            [
                                9.574872686036739,
                                40.92791614023772
                            ],
                            [
                                9.539148055756806,
                                40.925813573069739
                            ],
                            [
                                9.527692737223944,
                                40.93364572126444
                            ],
                            [
                                9.502783654903114,
                                40.929302462060427
                            ],
                            [
                                9.52475396453247,
                                40.923089115480522
                            ],
                            [
                                9.507823744050508,
                                40.92439679238629
                            ],
                            [
                                9.503850676419598,
                                40.912624690503748
                            ],
                            [
                                9.563403625171278,
                                40.918992682461372
                            ],
                            [
                                9.569486652608017,
                                40.911867695818685
                            ],
                            [
                                9.579481508450854,
                                40.915389666783774
                            ],
                            [
                                9.572043871498172,
                                40.910807831723424
                            ],
                            [
                                9.571584453945603,
                                40.908132411366843
                            ],
                            [
                                9.588699966810623,
                                40.89954478011321
                            ],
                            [
                                9.618462506620553,
                                40.923008571345406
                            ],
                            [
                                9.630305482410193,
                                40.918086769319025
                            ],
                            [
                                9.644326202316741,
                                40.919943791568762
                            ],
                            [
                                9.616018934616525,
                                40.889502585505916
                            ],
                            [
                                9.635731882890241,
                                40.884381949234296
                            ],
                            [
                                9.640434185151372,
                                40.873660868139069
                            ],
                            [
                                9.647835819933945,
                                40.88073606403568
                            ],
                            [
                                9.656668349492836,
                                40.874947848630107
                            ],
                            [
                                9.65248387970969,
                                40.860784679473248
                            ],
                            [
                                9.665215201802189,
                                40.853215931478239
                            ],
                            [
                                9.677776937760852,
                                40.861592581799549
                            ],
                            [
                                9.693563029644269,
                                40.846301752756283
                            ],
                            [
                                9.727949917991106,
                                40.844410955077826
                            ],
                            [
                                9.713941090573693,
                                40.832992644657239
                            ],
                            [
                                9.686340982225675,
                                40.835170135415524
                            ],
                            [
                                9.680668895432134,
                                40.82301997098461
                            ],
                            [
                                9.691958714743505,
                                40.811232383252083
                            ],
                            [
                                9.673731450605786,
                                40.804391994772253
                            ],
                            [
                                9.67142842632799,
                                40.784596534218529
                            ],
                            [
                                9.686730699946521,
                                40.766429405694559
                            ],
                            [
                                9.714998466976459,
                                40.753060374329067
                            ],
                            [
                                9.715388265002828,
                                40.709006516715071
                            ],
                            [
                                9.749723805434817,
                                40.67986225822218
                            ],
                            [
                                9.741539680683324,
                                40.636457730440135
                            ],
                            [
                                9.75179447374696,
                                40.600798300678349
                            ],
                            [
                                9.788399305646164,
                                40.572717432237958
                            ],
                            [
                                9.794006855067243,
                                40.546373581737711
                            ],
                            [
                                9.82458581851316,
                                40.532267907788857
                            ],
                            [
                                9.827041703935,
                                40.522426311593428
                            ],
                            [
                                9.763907824152254,
                                40.390655632668462
                            ],
                            [
                                9.754771248676153,
                                40.381208893398281
                            ],
                            [
                                9.730533229010113,
                                40.375406222729907
                            ],
                            [
                                9.684009840121874,
                                40.338583576838445
                            ],
                            [
                                9.631663802304004,
                                40.276456884369132
                            ],
                            [
                                9.62396025780528,
                                40.252714343549115
                            ],
                            [
                                9.628992717398093,
                                40.191703259936617
                            ],
                            [
                                9.657254504456334,
                                40.142186217990343
                            ],
                            [
                                9.685987066315837,
                                40.110732126813538
                            ],
                            [
                                9.728955919025044,
                                40.09076150135455
                            ],
                            [
                                9.735721497473325,
                                40.07742076034144
                            ],
                            [
                                9.705525872920408,
                                40.033498017428514
                            ],
                            [
                                9.700020037364709,
                                40.000664477073443
                            ],
                            [
                                9.686676267587043,
                                39.984103543188013
                            ],
                            [
                                9.686886393228392,
                                39.948351972139214
                            ],
                            [
                                9.699776087716151,
                                39.935843761582369
                            ],
                            [
                                9.712746843262435,
                                39.938794256929611
                            ],
                            [
                                9.716119750829185,
                                39.930146686627189
                            ],
                            [
                                9.713603917169889,
                                39.921440797697286
                            ],
                            [
                                9.692868088433197,
                                39.918746517944754
                            ],
                            [
                                9.682024646079233,
                                39.900214688100796
                            ],
                            [
                                9.682614855445152,
                                39.869942843867364
                            ],
                            [
                                9.696769282159512,
                                39.853366208401496
                            ],
                            [
                                9.682915519654077,
                                39.836726323865037
                            ],
                            [
                                9.668472811247028,
                                39.776678309260149
                            ],
                            [
                                9.675991069759919,
                                39.710816684200431
                            ],
                            [
                                9.660020733076269,
                                39.697366436860214
                            ],
                            [
                                9.663909555394076,
                                39.68295965798881
                            ],
                            [
                                9.647230365566285,
                                39.651630990682733
                            ],
                            [
                                9.655549655106958,
                                39.570415821195191
                            ],
                            [
                                9.63149494128432,
                                39.503278989597547
                            ],
                            [
                                9.644757448776859,
                                39.490241365671999
                            ],
                            [
                                9.645361232006406,
                                39.460888809533444
                            ],
                            [
                                9.607928688294326,
                                39.388136876593421
                            ],
                            [
                                9.597446687441714,
                                39.347176019697756
                            ],
                            [
                                9.604930770580594,
                                39.317916923633263
                            ],
                            [
                                9.628486839519944,
                                39.306273096658259
                            ],
                            [
                                9.633278909900243,
                                39.295710244304082
                            ],
                            [
                                9.606895858991649,
                                39.294115074424319
                            ],
                            [
                                9.581583012938447,
                                39.264041374017083
                            ],
                            [
                                9.562777344800843,
                                39.196409519607158
                            ],
                            [
                                9.57893705183338,
                                39.175518561393851
                            ],
                            [
                                9.570051884939449,
                                39.170152440806881
                            ],
                            [
                                9.560423730566903,
                                39.137166142002812
                            ],
                            [
                                9.538254815217458,
                                39.132653625426308
                            ],
                            [
                                9.52098706584732,
                                39.117576707946839
                            ],
                            [
                                9.523823077218292,
                                39.094603893453346
                            ],
                            [
                                9.50532022883815,
                                39.110662130993866
                            ],
                            [
                                9.502936798326786,
                                39.131092521210462
                            ],
                            [
                                9.484451962625407,
                                39.135603099435635
                            ],
                            [
                                9.437692529436893,
                                39.121947143701291
                            ],
                            [
                                9.430907459133435,
                                39.133281255773205
                            ],
                            [
                                9.392305741263595,
                                39.144520265206253
                            ],
                            [
                                9.391713091162408,
                                39.15737982273091
                            ],
                            [
                                9.371094500204672,
                                39.173707610450101
                            ],
                            [
                                9.350043549863909,
                                39.17832441243138
                            ],
                            [
                                9.322754591724744,
                                39.203419838495243
                            ],
                            [
                                9.302120728675598,
                                39.20546884289223
                            ],
                            [
                                9.297523426369578,
                                39.213183887655696
                            ],
                            [
                                9.209883703460733,
                                39.22675033364996
                            ],
                            [
                                9.164869805350133,
                                39.20433320902778
                            ],
                            [
                                9.159903622424231,
                                39.193601516583776
                            ],
                            [
                                9.1689632339253,
                                39.188096649649296
                            ],
                            [
                                9.158711683915753,
                                39.181248304589026
                            ],
                            [
                                9.146047154979904,
                                39.18388231570917
                            ],
                            [
                                9.123482130874139,
                                39.20595674295997
                            ],
                            [
                                9.114503066863117,
                                39.211830607588901
                            ],
                            [
                                9.095963104367147,
                                39.214047254375643
                            ],
                            [
                                9.030244718460182,
                                39.163471933182187
                            ],
                            [
                                9.008959199281557,
                                39.121210725848584
                            ],
                            [
                                9.016555679158545,
                                39.086594836392422
                            ],
                            [
                                9.045829380135078,
                                39.056070707534246
                            ],
                            [
                                9.024412579909347,
                                39.020103267856868
                            ],
                            [
                                9.024225042293629,
                                39.003690434894594
                            ],
                            [
                                9.011867793858595,
                                38.987077800133704
                            ],
                            [
                                8.996035123991092,
                                38.98519047028843
                            ],
                            [
                                8.903193705498444,
                                38.905037188474864
                            ],
                            [
                                8.879932313387796,
                                38.89530802979052
                            ],
                            [
                                8.854637983138241,
                                38.878484207303323
                            ],
                            [
                                8.832713363805491,
                                38.877273231386972
                            ],
                            [
                                8.821897452948887,
                                38.893178198712775
                            ],
                            [
                                8.806021997173229,
                                38.899590438721141
                            ],
                            [
                                8.798962445899205,
                                38.894656009185084
                            ],
                            [
                                8.783587340250964,
                                38.898336723637065
                            ],
                            [
                                8.780256524239825,
                                38.913157640904529
                            ],
                            [
                                8.722197277960435,
                                38.937632698608809
                            ],
                            [
                                8.714683417405579,
                                38.924938977484082
                            ],
                            [
                                8.681747030699279,
                                38.909291194423439
                            ],
                            [
                                8.664156454559413,
                                38.912439831144503
                            ],
                            [
                                8.670297256294573,
                                38.897094045411734
                            ],
                            [
                                8.649708623637983,
                                38.894826301064121
                            ],
                            [
                                8.65666336274831,
                                38.870579207637533
                            ],
                            [
                                8.639971742584924,
                                38.864878770811316
                            ],
                            [
                                8.646426984619326,
                                38.894156325022834
                            ],
                            [
                                8.606698390011728,
                                38.892768795122613
                            ],
                            [
                                8.62363028354725,
                                38.937495046785216
                            ],
                            [
                                8.607338272000181,
                                38.961578159347518
                            ],
                            [
                                8.585435786199564,
                                38.958117547981367
                            ],
                            [
                                8.588851798661945,
                                38.964403737947293
                            ],
                            [
                                8.565048830561812,
                                38.999696726565041
                            ],
                            [
                                8.576426384650917,
                                39.021777738931796
                            ],
                            [
                                8.571454069736884,
                                39.037916611963347
                            ],
                            [
                                8.511675791210587,
                                39.062250498432071
                            ],
                            [
                                8.467195942816375,
                                39.056912677198646
                            ],
                            [
                                8.45271795049827,
                                39.024440507595465
                            ],
                            [
                                8.451456676983685,
                                38.989383366346296
                            ],
                            [
                                8.440578792305464,
                                38.978152190865686
                            ],
                            [
                                8.444795343933752,
                                38.969853844128856
                            ],
                            [
                                8.414130045703409,
                                38.955196963850703
                            ],
                            [
                                8.403248422873018,
                                38.962244935338134
                            ],
                            [
                                8.360461895831154,
                                39.037617383939086
                            ],
                            [
                                8.349898121679837,
                                39.079549399876903
                            ],
                            [
                                8.35859080904882,
                                39.086554053638899
                            ],
                            [
                                8.350786163555966,
                                39.097442339686111
                            ],
                            [
                                8.361392238704022,
                                39.098521413546329
                            ],
                            [
                                8.36037023582773,
                                39.109879801982608
                            ],
                            [
                                8.373182700341561,
                                39.112151457562767
                            ],
                            [
                                8.385627744272268,
                                39.099218213512337
                            ],
                            [
                                8.4257820140569,
                                39.108856308409749
                            ],
                            [
                                8.431584999457531,
                                39.095835097499716
                            ],
                            [
                                8.456529740841725,
                                39.083675925795866
                            ],
                            [
                                8.466063520550685,
                                39.05708014269959
                            ],
                            [
                                8.478053909081884,
                                39.060878228446157
                            ],
                            [
                                8.488498335674434,
                                39.084670967993944
                            ],
                            [
                                8.466872292653996,
                                39.118544565961351
                            ],
                            [
                                8.437411945796706,
                                39.120084406708081
                            ],
                            [
                                8.437440287892205,
                                39.155778120232824
                            ],
                            [
                                8.412948736380615,
                                39.173914572001927
                            ],
                            [
                                8.412633207679333,
                                39.151132240097745
                            ],
                            [
                                8.401488231382938,
                                39.193671211886333
                            ],
                            [
                                8.368300726598877,
                                39.215455425176629
                            ],
                            [
                                8.36668554987077,
                                39.228106853726096
                            ],
                            [
                                8.423844355738609,
                                39.268078145551634
                            ],
                            [
                                8.437030728622121,
                                39.291931026295863
                            ],
                            [
                                8.431750116819318,
                                39.311661368943895
                            ],
                            [
                                8.417891295729664,
                                39.323628920304408
                            ],
                            [
                                8.420415103315005,
                                39.332523784626439
                            ],
                            [
                                8.396735180687392,
                                39.337612747075639
                            ],
                            [
                                8.385560623370493,
                                39.365477093415699
                            ],
                            [
                                8.373023960019168,
                                39.374709154618337
                            ],
                            [
                                8.379815454647074,
                                39.374236452146576
                            ],
                            [
                                8.412756534636276,
                                39.426835296261963
                            ],
                            [
                                8.410939992820797,
                                39.441116775644595
                            ],
                            [
                                8.384613716418786,
                                39.454928682371175
                            ],
                            [
                                8.385662817450811,
                                39.471110247353948
                            ],
                            [
                                8.451157775713508,
                                39.545578804039053
                            ],
                            [
                                8.470613096154025,
                                39.598869308640126
                            ],
                            [
                                8.449138023338966,
                                39.634242785028114
                            ],
                            [
                                8.459169977794554,
                                39.668061235587544
                            ],
                            [
                                8.44441428369646,
                                39.678273289706524
                            ],
                            [
                                8.455384259761743,
                                39.711047757049009
                            ],
                            [
                                8.446520960324936,
                                39.717997670198137
                            ],
                            [
                                8.444011752578259,
                                39.758035352288864
                            ],
                            [
                                8.451339306452327,
                                39.769521946714363
                            ],
                            [
                                8.459894947801178,
                                39.768372756284087
                            ],
                            [
                                8.49843457202593,
                                39.71826959324062
                            ],
                            [
                                8.492526226203339,
                                39.716135555605128
                            ],
                            [
                                8.502258675193545,
                                39.712966713296261
                            ],
                            [
                                8.504417471514941,
                                39.729190735064961
                            ],
                            [
                                8.521119435498161,
                                39.745946357789819
                            ],
                            [
                                8.512460499808347,
                                39.752764708320726
                            ],
                            [
                                8.545406112665916,
                                39.795120494351636
                            ],
                            [
                                8.553945505924942,
                                39.857496795885559
                            ],
                            [
                                8.570498344121454,
                                39.863781723436858
                            ],
                            [
                                8.544282807111225,
                                39.865943169099111
                            ],
                            [
                                8.54458195524181,
                                39.884576742004604
                            ],
                            [
                                8.531770541244562,
                                39.897355734012429
                            ],
                            [
                                8.491895949315113,
                                39.909553843526616
                            ],
                            [
                                8.466498986729388,
                                39.903551877259105
                            ],
                            [
                                8.441974454434844,
                                39.879947874726803
                            ],
                            [
                                8.440433114483344,
                                39.864731835205149
                            ],
                            [
                                8.435611647847539,
                                39.857956713055849
                            ],
                            [
                                8.434211245712929,
                                39.884694479997016
                            ],
                            [
                                8.399824802229226,
                                39.901392476139726
                            ],
                            [
                                8.401404571178499,
                                39.9569209326528
                            ],
                            [
                                8.39144522841927,
                                39.97547632690749
                            ],
                            [
                                8.411147618131503,
                                39.999282499666094
                            ],
                            [
                                8.414124608337353,
                                40.016930550565654
                            ],
                            [
                                8.40192110976286,
                                40.032462695249144
                            ],
                            [
                                8.378296015478842,
                                40.028866277011737
                            ],
                            [
                                8.376305840358771,
                                40.035701734461057
                            ],
                            [
                                8.399164909754342,
                                40.051206359444151
                            ],
                            [
                                8.411964696352134,
                                40.041090658329338
                            ],
                            [
                                8.453740933229405,
                                40.050737747793335
                            ],
                            [
                                8.493034456725281,
                                40.08687347054078
                            ],
                            [
                                8.484941496335873,
                                40.117713320631445
                            ],
                            [
                                8.459559907536713,
                                40.151608305702759
                            ],
                            [
                                8.455802795349078,
                                40.176609801846347
                            ],
                            [
                                8.467698607706557,
                                40.199422755997979
                            ],
                            [
                                8.462143728900761,
                                40.213974178363031
                            ],
                            [
                                8.483008580709786,
                                40.285287535665731
                            ],
                            [
                                8.464532445942938,
                                40.300095710348856
                            ],
                            [
                                8.458788488420542,
                                40.319492756898697
                            ],
                            [
                                8.443022890228946,
                                40.31874223563733
                            ],
                            [
                                8.42596342878873,
                                40.336001426758848
                            ],
                            [
                                8.382579781863335,
                                40.338669909951001
                            ],
                            [
                                8.387661091574262,
                                40.348309633312333
                            ],
                            [
                                8.379036678390509,
                                40.359781763369519
                            ],
                            [
                                8.389210118995512,
                                40.365858504190605
                            ],
                            [
                                8.401567555233441,
                                40.409026847713321
                            ],
                            [
                                8.398442760818078,
                                40.429555627563708
                            ],
                            [
                                8.373978322533578,
                                40.490758451064636
                            ],
                            [
                                8.339255879476042,
                                40.509101974795485
                            ],
                            [
                                8.326430484318886,
                                40.530324760734565
                            ],
                            [
                                8.30915825105191,
                                40.560609352846541
                            ],
                            [
                                8.318007863387448,
                                40.570630105166423
                            ],
                            [
                                8.306745321513137,
                                40.585607621451636
                            ],
                            [
                                8.286825210041885,
                                40.595112135167945
                            ],
                            [
                                8.247229522450466,
                                40.582387215532599
                            ],
                            [
                                8.243460332365714,
                                40.570450837195587
                            ],
                            [
                                8.220615401279037,
                                40.56943975746654
                            ],
                            [
                                8.198190853338772,
                                40.571125183452196
                            ],
                            [
                                8.203561822289023,
                                40.581142275114573
                            ]
                        ],
                        [
                            [
                                8.21277110317769,
                                40.594516281964275
                            ],
                            [
                                8.212383785551012,
                                40.593910624130757
                            ],
                            [
                                8.213277315608151,
                                40.593927411520198
                            ],
                            [
                                8.21277110317769,
                                40.594516281964275
                            ]
                        ],
                        [
                            [
                                8.21277110317769,
                                40.594516281964275
                            ],
                            [
                                8.213042985886181,
                                40.594636373416243
                            ],
                            [
                                8.213586457640456,
                                40.594858699935791
                            ],
                            [
                                8.213168712402529,
                                40.594748712161589
                            ],
                            [
                                8.21277110317769,
                                40.594516281964275
                            ]
                        ],
                        [
                            [
                                8.213277315608151,
                                40.593927411520198
                            ],
                            [
                                8.213360244426511,
                                40.593552990742246
                            ],
                            [
                                8.213445414597597,
                                40.59426863339479
                            ],
                            [
                                8.213277315608151,
                                40.593927411520198
                            ]
                        ],
                        [
                            [
                                9.604317598689928,
                                40.91044278698908
                            ],
                            [
                                9.604232825269557,
                                40.910424088722372
                            ],
                            [
                                9.60444379207075,
                                40.909875733270141
                            ],
                            [
                                9.604317598689928,
                                40.91044278698908
                            ]
                        ],
                        [
                            [
                                9.550785566071706,
                                40.927825395572469
                            ],
                            [
                                9.551061970442969,
                                40.92740969716052
                            ],
                            [
                                9.551106854260397,
                                40.927451145640937
                            ],
                            [
                                9.550785566071706,
                                40.927825395572469
                            ]
                        ],
                        [
                            [
                                8.466420416159728,
                                39.055821040768102
                            ],
                            [
                                8.466618745661538,
                                39.055862497974893
                            ],
                            [
                                8.466582096371145,
                                39.05593329279894
                            ],
                            [
                                8.466420416159728,
                                39.055821040768102
                            ]
                        ],
                        [
                            [
                                9.550506894801654,
                                40.927700048335332
                            ],
                            [
                                9.550574961175176,
                                40.927583179594741
                            ],
                            [
                                9.550675498393083,
                                40.927622110443956
                            ],
                            [
                                9.550506894801654,
                                40.927700048335332
                            ]
                        ],
                        [
                            [
                                9.551708501228788,
                                40.928208899551009
                            ],
                            [
                                9.55174934433321,
                                40.928121437069301
                            ],
                            [
                                9.551820605371567,
                                40.928121096066626
                            ],
                            [
                                9.551708501228788,
                                40.928208899551009
                            ]
                        ],
                        [
                            [
                                9.3091614989987,
                                39.205238614588332
                            ],
                            [
                                9.309180391273234,
                                39.205089884138332
                            ],
                            [
                                9.309208868543372,
                                39.205146126860676
                            ],
                            [
                                9.3091614989987,
                                39.205238614588332
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.22436154690546,
                                41.035948668181284
                            ],
                            [
                                8.221508558184174,
                                41.042198987218931
                            ],
                            [
                                8.257756192162431,
                                41.056915092354387
                            ],
                            [
                                8.266887555975854,
                                41.073052184635735
                            ],
                            [
                                8.28533271534871,
                                41.076670464681087
                            ],
                            [
                                8.275230234001194,
                                41.104205373864282
                            ],
                            [
                                8.301728086709845,
                                41.105004078021629
                            ],
                            [
                                8.320139522755065,
                                41.120013257009667
                            ],
                            [
                                8.326290986014946,
                                41.102051610124533
                            ],
                            [
                                8.344772638305079,
                                41.097302930014692
                            ],
                            [
                                8.349965738808317,
                                41.088711753074463
                            ],
                            [
                                8.336214975581989,
                                41.080346046187728
                            ],
                            [
                                8.333236077173289,
                                41.051161032611347
                            ],
                            [
                                8.2834143129305,
                                41.064372829878486
                            ],
                            [
                                8.257365401705716,
                                41.051189135715575
                            ],
                            [
                                8.267272196171669,
                                41.046042561615138
                            ],
                            [
                                8.234623077541229,
                                41.024074918067164
                            ],
                            [
                                8.248940235593695,
                                41.026894030399859
                            ],
                            [
                                8.263627523898013,
                                41.002601812471951
                            ],
                            [
                                8.254758819945277,
                                40.98529662735249
                            ],
                            [
                                8.209043420203969,
                                40.989322638706618
                            ],
                            [
                                8.21265088743578,
                                41.007232803782642
                            ],
                            [
                                8.229326138724462,
                                41.023134315237527
                            ],
                            [
                                8.217404289379218,
                                41.025336382628716
                            ],
                            [
                                8.22436154690546,
                                41.035948668181284
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.308250122194471,
                                39.180117354590259
                            ],
                            [
                                8.307857014640788,
                                39.104737574509365
                            ],
                            [
                                8.290212072579925,
                                39.095441412259596
                            ],
                            [
                                8.254841888803355,
                                39.103792387930653
                            ],
                            [
                                8.2472970820697,
                                39.110729654267274
                            ],
                            [
                                8.250361112838236,
                                39.133335280231258
                            ],
                            [
                                8.220487446291651,
                                39.145686972732079
                            ],
                            [
                                8.226678673896032,
                                39.160860843034854
                            ],
                            [
                                8.271725437632943,
                                39.179731465031558
                            ],
                            [
                                8.296519866722576,
                                39.178883596130611
                            ],
                            [
                                8.309143999727652,
                                39.187855097041066
                            ],
                            [
                                8.308250122194471,
                                39.180117354590259
                            ]
                        ],
                        [
                            [
                                8.262968998915992,
                                39.175111285368722
                            ],
                            [
                                8.26272501011657,
                                39.175610970253338
                            ],
                            [
                                8.262243874409846,
                                39.175677758973038
                            ],
                            [
                                8.263182364545594,
                                39.174911017028684
                            ],
                            [
                                8.262968998915992,
                                39.175111285368722
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.403674189147102,
                                41.211197663921851
                            ],
                            [
                                9.381400623808087,
                                41.210256268971115
                            ],
                            [
                                9.373868861315357,
                                41.227307945886444
                            ],
                            [
                                9.400583959919539,
                                41.242837568180249
                            ],
                            [
                                9.404770518064167,
                                41.255029540829746
                            ],
                            [
                                9.413368498120516,
                                41.250660643159087
                            ],
                            [
                                9.417660037126193,
                                41.269038922586091
                            ],
                            [
                                9.430918762783646,
                                41.260270593948214
                            ],
                            [
                                9.43514051545389,
                                41.236273868229112
                            ],
                            [
                                9.447748497249661,
                                41.232896039405823
                            ],
                            [
                                9.436192703774978,
                                41.228958963157957
                            ],
                            [
                                9.437223796844453,
                                41.213584404759558
                            ],
                            [
                                9.416629685320736,
                                41.216799970042693
                            ],
                            [
                                9.403674189147102,
                                41.211197663921851
                            ]
                        ],
                        [
                            [
                                9.427393986277805,
                                41.258167481207863
                            ],
                            [
                                9.427481846564019,
                                41.258140694836662
                            ],
                            [
                                9.427464484845954,
                                41.258224080730997
                            ],
                            [
                                9.427393986277805,
                                41.258167481207863
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.469111126855097,
                                41.24322506991647
                            ],
                            [
                                9.488739810721803,
                                41.220180408789574
                            ],
                            [
                                9.463833176410946,
                                41.184324274677081
                            ],
                            [
                                9.481711071857347,
                                41.182708295777033
                            ],
                            [
                                9.469120410959379,
                                41.180238074797714
                            ],
                            [
                                9.4531882690716,
                                41.192294667236766
                            ],
                            [
                                9.437104367419874,
                                41.180624133165558
                            ],
                            [
                                9.433618714039403,
                                41.189931142942037
                            ],
                            [
                                9.443543191372919,
                                41.190414676735081
                            ],
                            [
                                9.443579536600987,
                                41.202864464088613
                            ],
                            [
                                9.456496780020979,
                                41.20013754055595
                            ],
                            [
                                9.448136700484891,
                                41.212420983782984
                            ],
                            [
                                9.451825407481206,
                                41.217806737415081
                            ],
                            [
                                9.451807482940437,
                                41.221702671900537
                            ],
                            [
                                9.448898670637051,
                                41.224202445679182
                            ],
                            [
                                9.458642395985684,
                                41.228154489675873
                            ],
                            [
                                9.459499245136627,
                                41.242534202961522
                            ],
                            [
                                9.469111126855097,
                                41.24322506991647
                            ]
                        ],
                        [
                            [
                                9.455421534179134,
                                41.226526734144031
                            ],
                            [
                                9.454446243875937,
                                41.226323408692096
                            ],
                            [
                                9.455764266543682,
                                41.22498167179706
                            ],
                            [
                                9.455836840627267,
                                41.226412493741819
                            ],
                            [
                                9.455421534179134,
                                41.226526734144031
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.734165765777732,
                                40.922546149782697
                            ],
                            [
                                9.741670275668096,
                                40.911010441724883
                            ],
                            [
                                9.692820781027237,
                                40.887776918729671
                            ],
                            [
                                9.673128698977914,
                                40.888981278969837
                            ],
                            [
                                9.737433091509011,
                                40.927609286582843
                            ],
                            [
                                9.734165765777732,
                                40.922546149782697
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.343757018103844,
                                41.25091316588189
                            ],
                            [
                                9.360669381251462,
                                41.242424545960645
                            ],
                            [
                                9.345707129796891,
                                41.228857450454562
                            ],
                            [
                                9.332902718309343,
                                41.235563186931095
                            ],
                            [
                                9.333250736070639,
                                41.247989512615277
                            ],
                            [
                                9.343757018103844,
                                41.25091316588189
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.410076748095587,
                                41.186356815605798
                            ],
                            [
                                9.396888877716522,
                                41.190298906374579
                            ],
                            [
                                9.398122870810871,
                                41.197646160009931
                            ],
                            [
                                9.41727066101878,
                                41.2080814812767
                            ],
                            [
                                9.424213828719274,
                                41.194410405155011
                            ],
                            [
                                9.410076748095587,
                                41.186356815605798
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.729943589225645,
                                40.875690841757731
                            ],
                            [
                                9.742195396355791,
                                40.870617577653896
                            ],
                            [
                                9.73648344330533,
                                40.859417510693206
                            ],
                            [
                                9.710114527902064,
                                40.86922959480048
                            ],
                            [
                                9.715852103765533,
                                40.876254348734683
                            ],
                            [
                                9.729943589225645,
                                40.875690841757731
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.380610440459042,
                                41.307804695733971
                            ],
                            [
                                9.384716025180252,
                                41.298259818239806
                            ],
                            [
                                9.365052475509115,
                                41.287492123943096
                            ],
                            [
                                9.360693231704696,
                                41.296380681039977
                            ],
                            [
                                9.380610440459042,
                                41.307804695733971
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.355152799411396,
                                41.276569733443587
                            ],
                            [
                                9.349018935145493,
                                41.275817207942922
                            ],
                            [
                                9.334888755303632,
                                41.283315303879647
                            ],
                            [
                                9.355882580891382,
                                41.28864567215453
                            ],
                            [
                                9.355152799411396,
                                41.276569733443587
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.342264505450059,
                                41.307945368421137
                            ],
                            [
                                9.353309509876793,
                                41.303409293700064
                            ],
                            [
                                9.359244737104918,
                                41.294150181387664
                            ],
                            [
                                9.333372777764867,
                                41.30132043067843
                            ],
                            [
                                9.342264505450059,
                                41.307945368421137
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.221474025153695,
                                40.968726976102133
                            ],
                            [
                                8.214706901322691,
                                40.969134860354195
                            ],
                            [
                                8.214257099322225,
                                40.982629273307282
                            ],
                            [
                                8.226952177692722,
                                40.975524410060565
                            ],
                            [
                                8.221474025153695,
                                40.968726976102133
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.610061236169235,
                                41.079652138506042
                            ],
                            [
                                9.60609397056726,
                                41.07089593207958
                            ],
                            [
                                9.597387487532265,
                                41.074899278430401
                            ],
                            [
                                9.606864243063134,
                                41.081848947891849
                            ],
                            [
                                9.610061236169235,
                                41.079652138506042
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.312365561436403,
                                39.996670789519762
                            ],
                            [
                                8.312391959875812,
                                39.990242584590817
                            ],
                            [
                                8.302259727677741,
                                39.985668208727589
                            ],
                            [
                                8.301050446595559,
                                39.990836949711607
                            ],
                            [
                                8.312365561436403,
                                39.996670789519762
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.57507429987208,
                                41.069637284309493
                            ],
                            [
                                9.579198487837559,
                                41.065725176501488
                            ],
                            [
                                9.575255819385825,
                                41.06093127745887
                            ],
                            [
                                9.569223720146946,
                                41.064072369893651
                            ],
                            [
                                9.57507429987208,
                                41.069637284309493
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.530416072326252,
                                39.089816251601626
                            ],
                            [
                                9.535039109473686,
                                39.088389404424511
                            ],
                            [
                                9.535061576291593,
                                39.082180681808978
                            ],
                            [
                                9.526909172382371,
                                39.08509233608109
                            ],
                            [
                                9.530416072326252,
                                39.089816251601626
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.605410216743364,
                                39.133456165335751
                            ],
                            [
                                9.603643006884839,
                                39.139565749704403
                            ],
                            [
                                9.60592058046258,
                                39.144910940507664
                            ],
                            [
                                9.608095395039909,
                                39.139114584770887
                            ],
                            [
                                9.605410216743364,
                                39.133456165335751
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.523086763713597,
                                41.16180977641914
                            ],
                            [
                                9.519901648719392,
                                41.162985084576732
                            ],
                            [
                                9.516747400693989,
                                41.166586656055564
                            ],
                            [
                                9.525484141953376,
                                41.16611024714804
                            ],
                            [
                                9.523086763713597,
                                41.16180977641914
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.376744910615002,
                                41.307890599563144
                            ],
                            [
                                9.37075563566412,
                                41.308709475595244
                            ],
                            [
                                9.370468796011794,
                                41.311060269830925
                            ],
                            [
                                9.379290410523325,
                                41.311669956486142
                            ],
                            [
                                9.376744910615002,
                                41.307890599563144
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.324158636793085,
                                39.189239595795456
                            ],
                            [
                                8.317173107256799,
                                39.190333105832131
                            ],
                            [
                                8.319728888204853,
                                39.195322042676899
                            ],
                            [
                                8.324973254161311,
                                39.191687385041881
                            ],
                            [
                                8.324158636793085,
                                39.189239595795456
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.644580809632572,
                                40.978051745141173
                            ],
                            [
                                9.640425693598042,
                                40.979804461001898
                            ],
                            [
                                9.639930835733223,
                                40.982716828463374
                            ],
                            [
                                9.645010943293157,
                                40.981940842882004
                            ],
                            [
                                9.644580809632572,
                                40.978051745141173
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.401397443391989,
                                41.292621482483909
                            ],
                            [
                                9.396350824823973,
                                41.294494549364934
                            ],
                            [
                                9.399290145797123,
                                41.298608776935787
                            ],
                            [
                                9.402395634139582,
                                41.29447357780024
                            ],
                            [
                                9.401397443391989,
                                41.292621482483909
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.650372679894705,
                                40.890121900571557
                            ],
                            [
                                9.655225287844249,
                                40.888673382289291
                            ],
                            [
                                9.655390807129208,
                                40.888305355663952
                            ],
                            [
                                9.648239928398896,
                                40.886724285065995
                            ],
                            [
                                9.650372679894705,
                                40.890121900571557
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.400924689219629,
                                41.280265715714727
                            ],
                            [
                                9.399902706241333,
                                41.284987047180358
                            ],
                            [
                                9.402103511030358,
                                41.286530954420833
                            ],
                            [
                                9.403074702328233,
                                41.28158233851012
                            ],
                            [
                                9.400924689219629,
                                41.280265715714727
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.14424367292083,
                                40.60385842739479
                            ],
                            [
                                8.140366757763925,
                                40.601674323024582
                            ],
                            [
                                8.137667613964371,
                                40.602818566364881
                            ],
                            [
                                8.140318277392453,
                                40.605342723751043
                            ],
                            [
                                8.14424367292083,
                                40.60385842739479
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.41051431205744,
                                38.859566467941704
                            ],
                            [
                                8.408214856196022,
                                38.859581873293969
                            ],
                            [
                                8.40837144639325,
                                38.863286345036336
                            ],
                            [
                                8.412220035827858,
                                38.862021655978658
                            ],
                            [
                                8.41051431205744,
                                38.859566467941704
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.566618751948543,
                                41.124699713119234
                            ],
                            [
                                9.563560535957695,
                                41.125438724708111
                            ],
                            [
                                9.568618262291146,
                                41.128628565835299
                            ],
                            [
                                9.56936672921808,
                                41.127182479202382
                            ],
                            [
                                9.566618751948543,
                                41.124699713119234
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.716901103579232,
                                38.912634839422722
                            ],
                            [
                                8.714281809104218,
                                38.913974533817488
                            ],
                            [
                                8.718325885541425,
                                38.916202286909588
                            ],
                            [
                                8.719160434706241,
                                38.915174747372312
                            ],
                            [
                                8.716901103579232,
                                38.912634839422722
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.325283246242938,
                                41.249030173420913
                            ],
                            [
                                9.321195627794186,
                                41.250293726252103
                            ],
                            [
                                9.323705487757023,
                                41.252493595310263
                            ],
                            [
                                9.325373808500585,
                                41.250444134219876
                            ],
                            [
                                9.325283246242938,
                                41.249030173420913
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.450189595838639,
                                38.934671272227398
                            ],
                            [
                                8.448138645951493,
                                38.935247327173542
                            ],
                            [
                                8.449614011334241,
                                38.93935442588208
                            ],
                            [
                                8.451649108649967,
                                38.936543473558274
                            ],
                            [
                                8.450189595838639,
                                38.934671272227398
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.48652824370043,
                                41.180317861201438
                            ],
                            [
                                9.483626338160391,
                                41.183127015113662
                            ],
                            [
                                9.484767809432658,
                                41.184718853801343
                            ],
                            [
                                9.487580278096386,
                                41.182105970858743
                            ],
                            [
                                9.48652824370043,
                                41.180317861201438
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.585711736407399,
                                41.071074527222827
                            ],
                            [
                                9.587767561963572,
                                41.070693605845506
                            ],
                            [
                                9.588358457302117,
                                41.068547815847666
                            ],
                            [
                                9.584455957837825,
                                41.069393032307467
                            ],
                            [
                                9.585711736407399,
                                41.071074527222827
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.863622272216844,
                                41.012414191264412
                            ],
                            [
                                8.862179867469802,
                                41.012624166857208
                            ],
                            [
                                8.861210173849141,
                                41.015672256726397
                            ],
                            [
                                8.864061759476792,
                                41.015567557475947
                            ],
                            [
                                8.863622272216844,
                                41.012414191264412
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.461576642468003,
                                41.172647918692213
                            ],
                            [
                                9.459018877958918,
                                41.1727718647358
                            ],
                            [
                                9.461184285904329,
                                41.175984645960675
                            ],
                            [
                                9.461895202414922,
                                41.174933509084049
                            ],
                            [
                                9.461576642468003,
                                41.172647918692213
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.406079939086901,
                                41.293585207047933
                            ],
                            [
                                9.404188807605436,
                                41.294013534240399
                            ],
                            [
                                9.403692327352493,
                                41.296058891206322
                            ],
                            [
                                9.40565533893526,
                                41.296258040762027
                            ],
                            [
                                9.406079939086901,
                                41.293585207047933
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.418913128018135,
                                41.21359842407076
                            ],
                            [
                                9.41889821669011,
                                41.21126095549424
                            ],
                            [
                                9.417237283180715,
                                41.209985626068836
                            ],
                            [
                                9.415192903003836,
                                41.213375442756849
                            ],
                            [
                                9.418913128018135,
                                41.21359842407076
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.702514425951065,
                                39.975422447279584
                            ],
                            [
                                9.705563382011166,
                                39.974548012133923
                            ],
                            [
                                9.706546653015778,
                                39.973370769413677
                            ],
                            [
                                9.702743489471954,
                                39.973204687038816
                            ],
                            [
                                9.702514425951065,
                                39.975422447279584
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.583277625919019,
                                41.067376709518214
                            ],
                            [
                                9.580636732595636,
                                41.06720031605451
                            ],
                            [
                                9.580075107436592,
                                41.067963756785026
                            ],
                            [
                                9.582400808153418,
                                41.06917373412707
                            ],
                            [
                                9.583277625919019,
                                41.067376709518214
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.151777871794732,
                                40.568732963957167
                            ],
                            [
                                8.150642627678392,
                                40.570693018546443
                            ],
                            [
                                8.152922754113902,
                                40.572209705947444
                            ],
                            [
                                8.153267767782721,
                                40.571198759416404
                            ],
                            [
                                8.151777871794732,
                                40.568732963957167
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.185163349278827,
                                41.249241685469222
                            ],
                            [
                                9.182594614947487,
                                41.249903354472828
                            ],
                            [
                                9.183727404923893,
                                41.252180515901976
                            ],
                            [
                                9.184961740395721,
                                41.251286771443866
                            ],
                            [
                                9.185163349278827,
                                41.249241685469222
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.813344405849014,
                                38.889845254109169
                            ],
                            [
                                8.811802747776271,
                                38.889640022350768
                            ],
                            [
                                8.813647406410976,
                                38.893030152049299
                            ],
                            [
                                8.814446208365242,
                                38.892367957790839
                            ],
                            [
                                8.813344405849014,
                                38.889845254109169
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.723776187473268,
                                40.847574357048963
                            ],
                            [
                                9.724624988607721,
                                40.846677207087069
                            ],
                            [
                                9.722153901489852,
                                40.844975497043706
                            ],
                            [
                                9.721909951347881,
                                40.846680718028949
                            ],
                            [
                                9.723776187473268,
                                40.847574357048963
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.817261564595071,
                                40.537837802565612
                            ],
                            [
                                9.817004365222704,
                                40.538839591493591
                            ],
                            [
                                9.821191192569824,
                                40.540841378013468
                            ],
                            [
                                9.821350042007971,
                                40.540070002179391
                            ],
                            [
                                9.817261564595071,
                                40.537837802565612
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.238788389350981,
                                41.252795604932977
                            ],
                            [
                                9.236534563886593,
                                41.252957892876012
                            ],
                            [
                                9.237902397048963,
                                41.254922142553013
                            ],
                            [
                                9.239439074246432,
                                41.254068850608597
                            ],
                            [
                                9.238788389350981,
                                41.252795604932977
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.334326202083911,
                                41.189678926325485
                            ],
                            [
                                9.331549467693296,
                                41.190011235781512
                            ],
                            [
                                9.331721728944109,
                                41.191064657175232
                            ],
                            [
                                9.335379542602933,
                                41.190459545972736
                            ],
                            [
                                9.334326202083911,
                                41.189678926325485
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.399291022112926,
                                39.334374246548364
                            ],
                            [
                                8.401134989773606,
                                39.33456621449848
                            ],
                            [
                                8.401802857309155,
                                39.333889344266311
                            ],
                            [
                                8.398548751175108,
                                39.333151721962942
                            ],
                            [
                                8.399291022112926,
                                39.334374246548364
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.213557456701121,
                                40.879567935760626
                            ],
                            [
                                8.211771334826791,
                                40.880060203117978
                            ],
                            [
                                8.214483328379757,
                                40.881565062888953
                            ],
                            [
                                8.214816324606979,
                                40.880504360096069
                            ],
                            [
                                8.213557456701121,
                                40.879567935760626
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.716179455331201,
                                40.735333421832983
                            ],
                            [
                                9.715236813597036,
                                40.735780682093036
                            ],
                            [
                                9.718783431033895,
                                40.737398190104116
                            ],
                            [
                                9.718911285218924,
                                40.736073149433487
                            ],
                            [
                                9.716179455331201,
                                40.735333421832983
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.571063816797713,
                                41.125918602836755
                            ],
                            [
                                9.569108712340949,
                                41.126447358269324
                            ],
                            [
                                9.57013336170891,
                                41.128010792314626
                            ],
                            [
                                9.571691722524356,
                                41.127919746238476
                            ],
                            [
                                9.571063816797713,
                                41.125918602836755
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.501924995031333,
                                41.153759699395913
                            ],
                            [
                                9.503908605679436,
                                41.153664337981681
                            ],
                            [
                                9.503649918753412,
                                41.152760178161124
                            ],
                            [
                                9.500062251812823,
                                41.153293761908877
                            ],
                            [
                                9.501924995031333,
                                41.153759699395913
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.50903123911546,
                                40.916339233788932
                            ],
                            [
                                9.507609293280291,
                                40.916741864332643
                            ],
                            [
                                9.5120613432147,
                                40.918127465972937
                            ],
                            [
                                9.510422947865212,
                                40.91663936222124
                            ],
                            [
                                9.50903123911546,
                                40.916339233788932
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.672083775896978,
                                40.876921944145508
                            ],
                            [
                                9.670123110880766,
                                40.878005335753109
                            ],
                            [
                                9.67134088832894,
                                40.878718914633964
                            ],
                            [
                                9.673475299656864,
                                40.877798888794295
                            ],
                            [
                                9.672083775896978,
                                40.876921944145508
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.603807574639426,
                                39.146808573033262
                            ],
                            [
                                9.60259549469766,
                                39.147329596410962
                            ],
                            [
                                9.603251407064143,
                                39.14858998764511
                            ],
                            [
                                9.605167379936191,
                                39.147831020187994
                            ],
                            [
                                9.603807574639426,
                                39.146808573033262
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.253196809529854,
                                41.028240238022256
                            ],
                            [
                                8.252348427513519,
                                41.027526482857994
                            ],
                            [
                                8.2506941648878,
                                41.028781364624365
                            ],
                            [
                                8.252708793386708,
                                41.0297143879014
                            ],
                            [
                                8.253196809529854,
                                41.028240238022256
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.567244967672028,
                                41.129979764815943
                            ],
                            [
                                9.566125800790312,
                                41.131275651231846
                            ],
                            [
                                9.567553380124028,
                                41.132416007104773
                            ],
                            [
                                9.56798094601052,
                                41.13087917995464
                            ],
                            [
                                9.567244967672028,
                                41.129979764815943
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.708570884988349,
                                40.827239032220788
                            ],
                            [
                                9.706693230480267,
                                40.827151457912457
                            ],
                            [
                                9.707578093984193,
                                40.828812574733348
                            ],
                            [
                                9.708678324105648,
                                40.828697721347879
                            ],
                            [
                                9.708570884988349,
                                40.827239032220788
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.39924812623649,
                                41.252525531670209
                            ],
                            [
                                9.398038089876874,
                                41.253749143341842
                            ],
                            [
                                9.400170261086856,
                                41.254006354579566
                            ],
                            [
                                9.400560617347823,
                                41.252938706683402
                            ],
                            [
                                9.39924812623649,
                                41.252525531670209
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.640741213701478,
                                40.886425001435285
                            ],
                            [
                                9.641256164404505,
                                40.885359165132812
                            ],
                            [
                                9.63959782894228,
                                40.884326793790045
                            ],
                            [
                                9.639149838594271,
                                40.885260506076243
                            ],
                            [
                                9.640741213701478,
                                40.886425001435285
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.031916055157735,
                                39.002404478892799
                            ],
                            [
                                9.031249721377138,
                                39.003780003912006
                            ],
                            [
                                9.032536291938952,
                                39.004448738680395
                            ],
                            [
                                9.033107490894459,
                                39.00342016728225
                            ],
                            [
                                9.031916055157735,
                                39.002404478892799
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.569853889938033,
                                41.117567507336013
                            ],
                            [
                                9.569935295628273,
                                41.115618016760877
                            ],
                            [
                                9.56883538066821,
                                41.115660610551728
                            ],
                            [
                                9.568091816984545,
                                41.117143829888079
                            ],
                            [
                                9.569853889938033,
                                41.117567507336013
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.777621181788319,
                                40.873529176662437
                            ],
                            [
                                9.776969819974559,
                                40.874659595961774
                            ],
                            [
                                9.778153935065459,
                                40.875953302825181
                            ],
                            [
                                9.77895103664687,
                                40.874601191153538
                            ],
                            [
                                9.777621181788319,
                                40.873529176662437
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.512546252965898,
                                40.920944888911968
                            ],
                            [
                                9.511568075426725,
                                40.920381713923661
                            ],
                            [
                                9.510501911235616,
                                40.920728751663006
                            ],
                            [
                                9.512686560540136,
                                40.922196409258888
                            ],
                            [
                                9.512546252965898,
                                40.920944888911968
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.765910949423048,
                                40.684084606508307
                            ],
                            [
                                9.765021625659157,
                                40.684833706920926
                            ],
                            [
                                9.767714546245074,
                                40.685410393543783
                            ],
                            [
                                9.767063266538964,
                                40.684342707628751
                            ],
                            [
                                9.765910949423048,
                                40.684084606508307
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.584118648658597,
                                40.904926855241804
                            ],
                            [
                                9.582307839111971,
                                40.904063339527873
                            ],
                            [
                                9.581646113618778,
                                40.904593661125418
                            ],
                            [
                                9.583454208864749,
                                40.905654256128962
                            ],
                            [
                                9.584118648658597,
                                40.904926855241804
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.207516829921442,
                                40.969995474695352
                            ],
                            [
                                8.206315275246068,
                                40.970095305592992
                            ],
                            [
                                8.205849542776129,
                                40.97127215704473
                            ],
                            [
                                8.207130748595779,
                                40.971470145625148
                            ],
                            [
                                8.207516829921442,
                                40.969995474695352
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.397159000802263,
                                41.195779238848445
                            ],
                            [
                                9.395914169394683,
                                41.195763257426826
                            ],
                            [
                                9.395798182803833,
                                41.197048396932338
                            ],
                            [
                                9.397120405161335,
                                41.197039341227708
                            ],
                            [
                                9.397159000802263,
                                41.195779238848445
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.587579027745129,
                                40.959151015854303
                            ],
                            [
                                9.589227394786821,
                                40.959358798956508
                            ],
                            [
                                9.589557642357001,
                                40.958663482649378
                            ],
                            [
                                9.58789921780688,
                                40.957906257883586
                            ],
                            [
                                9.587579027745129,
                                40.959151015854303
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.369968852795269,
                                41.308475556223144
                            ],
                            [
                                9.3679782272403,
                                41.308722891793117
                            ],
                            [
                                9.368087421644139,
                                41.309552372561328
                            ],
                            [
                                9.369024751611196,
                                41.309736280123026
                            ],
                            [
                                9.369968852795269,
                                41.308475556223144
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.566585131536417,
                                41.122522217180659
                            ],
                            [
                                9.564497406634556,
                                41.122511072261574
                            ],
                            [
                                9.563912013863391,
                                41.123009374162862
                            ],
                            [
                                9.564861535882843,
                                41.123473133529885
                            ],
                            [
                                9.566585131536417,
                                41.122522217180659
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.319557923604048,
                                39.185282959290326
                            ],
                            [
                                8.318356120048565,
                                39.185189205024415
                            ],
                            [
                                8.318176130441035,
                                39.186591592471345
                            ],
                            [
                                8.319211102629462,
                                39.186127953712202
                            ],
                            [
                                8.319557923604048,
                                39.185282959290326
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.366391185367108,
                                41.285833834486247
                            ],
                            [
                                9.365296131514977,
                                41.286213385484047
                            ],
                            [
                                9.366497668832231,
                                41.287256710072981
                            ],
                            [
                                9.367022599637231,
                                41.286363276716997
                            ],
                            [
                                9.366391185367108,
                                41.285833834486247
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.241875657484337,
                                41.256118650617175
                            ],
                            [
                                9.240771791112307,
                                41.256191900335764
                            ],
                            [
                                9.240349970175059,
                                41.257125083544935
                            ],
                            [
                                9.242112173837162,
                                41.257134902992249
                            ],
                            [
                                9.241875657484337,
                                41.256118650617175
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.890778260067803,
                                38.896728967583719
                            ],
                            [
                                8.890078304303724,
                                38.89728251354488
                            ],
                            [
                                8.89012414698708,
                                38.898402226435948
                            ],
                            [
                                8.89135797179393,
                                38.897511249769245
                            ],
                            [
                                8.890778260067803,
                                38.896728967583719
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.447347591030168,
                                41.222877583420193
                            ],
                            [
                                9.449975841324511,
                                41.222088170505693
                            ],
                            [
                                9.450031394321426,
                                41.221272749708298
                            ],
                            [
                                9.447915664102416,
                                41.221548980224924
                            ],
                            [
                                9.447347591030168,
                                41.222877583420193
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.526298169104665,
                                40.917883203388655
                            ],
                            [
                                9.526470676209454,
                                40.91708068309174
                            ],
                            [
                                9.525077147543071,
                                40.916654641479646
                            ],
                            [
                                9.525346595434659,
                                40.917689361287394
                            ],
                            [
                                9.526298169104665,
                                40.917883203388655
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.455112733276929,
                                40.210373602048016
                            ],
                            [
                                8.455905332831705,
                                40.210264713865669
                            ],
                            [
                                8.456317460021383,
                                40.209424278415526
                            ],
                            [
                                8.453997363090066,
                                40.210251224953126
                            ],
                            [
                                8.455112733276929,
                                40.210373602048016
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.540237546914495,
                                39.08322012053209
                            ],
                            [
                                9.540087679451227,
                                39.081761022838016
                            ],
                            [
                                9.539695012667154,
                                39.081816907353058
                            ],
                            [
                                9.539047959397228,
                                39.08338782521178
                            ],
                            [
                                9.540237546914495,
                                39.08322012053209
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.605833836769914,
                                39.148459449815512
                            ],
                            [
                                9.604917206518719,
                                39.148347068907711
                            ],
                            [
                                9.605758000723144,
                                39.150075054638314
                            ],
                            [
                                9.606038241534092,
                                39.149522804166089
                            ],
                            [
                                9.605833836769914,
                                39.148459449815512
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.569853889938033,
                                41.117567507336013
                            ],
                            [
                                9.569877824731909,
                                41.118441156606984
                            ],
                            [
                                9.570811948964479,
                                41.119020920366587
                            ],
                            [
                                9.571078572642511,
                                41.117658278099242
                            ],
                            [
                                9.569853889938033,
                                41.117567507336013
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.526503694173833,
                                40.930313614265373
                            ],
                            [
                                9.525959053589821,
                                40.930532296977461
                            ],
                            [
                                9.52633668673864,
                                40.931719657978505
                            ],
                            [
                                9.527425479739929,
                                40.931219231218819
                            ],
                            [
                                9.526503694173833,
                                40.930313614265373
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.605480680098166,
                                39.150968578415345
                            ],
                            [
                                9.604438168950004,
                                39.150856847800192
                            ],
                            [
                                9.603942800577121,
                                39.151967760969114
                            ],
                            [
                                9.604558378344541,
                                39.152225886387122
                            ],
                            [
                                9.605480680098166,
                                39.150968578415345
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.677362830905842,
                                40.863892126477701
                            ],
                            [
                                9.676560363217115,
                                40.863887827937461
                            ],
                            [
                                9.676269974008402,
                                40.865231764631787
                            ],
                            [
                                9.677619787873768,
                                40.864800453498695
                            ],
                            [
                                9.677362830905842,
                                40.863892126477701
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.647256044024783,
                                40.917151730385228
                            ],
                            [
                                9.646384685492823,
                                40.917608154367954
                            ],
                            [
                                9.647224167927485,
                                40.918297077467471
                            ],
                            [
                                9.648053187287042,
                                40.917912950781769
                            ],
                            [
                                9.647256044024783,
                                40.917151730385228
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.276191857143257,
                                39.881275169641761
                            ],
                            [
                                8.275113137469049,
                                39.881403578971671
                            ],
                            [
                                8.275757378515136,
                                39.88241669868907
                            ],
                            [
                                8.276346668449776,
                                39.882123054618717
                            ],
                            [
                                8.276191857143257,
                                39.881275169641761
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.225305328996638,
                                40.966564945226757
                            ],
                            [
                                8.224772755970703,
                                40.966502812561451
                            ],
                            [
                                8.223811303386812,
                                40.967544660199863
                            ],
                            [
                                8.225604107616505,
                                40.967184007070806
                            ],
                            [
                                8.225305328996638,
                                40.966564945226757
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.403834125468942,
                                40.053194562536319
                            ],
                            [
                                8.402914232327609,
                                40.053563721825775
                            ],
                            [
                                8.403145804458633,
                                40.05431721261035
                            ],
                            [
                                8.404275592549743,
                                40.05382750204511
                            ],
                            [
                                8.403834125468942,
                                40.053194562536319
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.537005447463207,
                                39.080856130181438
                            ],
                            [
                                9.535925376113898,
                                39.080922816180752
                            ],
                            [
                                9.535972866770763,
                                39.081906164592148
                            ],
                            [
                                9.536832375081925,
                                39.081474185053203
                            ],
                            [
                                9.537005447463207,
                                39.080856130181438
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.633787355619171,
                                40.920819691936671
                            ],
                            [
                                9.633190178327318,
                                40.920776805590094
                            ],
                            [
                                9.633204592031868,
                                40.92197594356518
                            ],
                            [
                                9.63415127911577,
                                40.921619421273476
                            ],
                            [
                                9.633787355619171,
                                40.920819691936671
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.450265494940501,
                                38.940718198825508
                            ],
                            [
                                8.449878279146029,
                                38.941365186278347
                            ],
                            [
                                8.450718313450803,
                                38.942035976766078
                            ],
                            [
                                8.451009031164347,
                                38.94137051020477
                            ],
                            [
                                8.450265494940501,
                                38.940718198825508
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.529292659914489,
                                41.041713364897412
                            ],
                            [
                                9.528773875592437,
                                41.041373440780539
                            ],
                            [
                                9.527331931678738,
                                41.042199779415157
                            ],
                            [
                                9.528657505944356,
                                41.042256762652571
                            ],
                            [
                                9.529292659914489,
                                41.041713364897412
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.334633215585878,
                                41.294360597698763
                            ],
                            [
                                9.333496780592212,
                                41.294300841884031
                            ],
                            [
                                9.33350949063186,
                                41.294744433236168
                            ],
                            [
                                9.335227894537017,
                                41.295038947170447
                            ],
                            [
                                9.334633215585878,
                                41.294360597698763
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.377470567171457,
                                40.35991748908954
                            ],
                            [
                                8.376639676860675,
                                40.360223826595131
                            ],
                            [
                                8.376685401522549,
                                40.360773626434039
                            ],
                            [
                                8.378093668574182,
                                40.360515440247738
                            ],
                            [
                                8.377470567171457,
                                40.35991748908954
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.400725673175064,
                                41.300921009535124
                            ],
                            [
                                9.399966069379317,
                                41.301471992632635
                            ],
                            [
                                9.400491731108973,
                                41.301974593845522
                            ],
                            [
                                9.401174356317183,
                                41.301775174318919
                            ],
                            [
                                9.400725673175064,
                                41.300921009535124
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.443310012459408,
                                41.201365702018499
                            ],
                            [
                                9.441905982178756,
                                41.202079337097651
                            ],
                            [
                                9.442052599884589,
                                41.202598975255491
                            ],
                            [
                                9.442670760936952,
                                41.202297091182857
                            ],
                            [
                                9.443310012459408,
                                41.201365702018499
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.300390481868344,
                                40.571766830511741
                            ],
                            [
                                8.299442883764886,
                                40.57200432319722
                            ],
                            [
                                8.300039816710552,
                                40.573107006022362
                            ],
                            [
                                8.300563928863523,
                                40.572128229809366
                            ],
                            [
                                8.300390481868344,
                                40.571766830511741
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.8275487986469,
                                38.881374940095661
                            ],
                            [
                                8.826994063895702,
                                38.88133244162055
                            ],
                            [
                                8.826239411318625,
                                38.881717686911152
                            ],
                            [
                                8.827452079285242,
                                38.882038264950467
                            ],
                            [
                                8.8275487986469,
                                38.881374940095661
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.397336815543314,
                                41.249066416121039
                            ],
                            [
                                9.397356812142347,
                                41.250150653853616
                            ],
                            [
                                9.397902197667539,
                                41.250287264344834
                            ],
                            [
                                9.398292060898626,
                                41.249627225397802
                            ],
                            [
                                9.397336815543314,
                                41.249066416121039
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.581159535284062,
                                41.093450846179863
                            ],
                            [
                                9.580272199022332,
                                41.093759336791436
                            ],
                            [
                                9.5803949476899,
                                41.094515386223776
                            ],
                            [
                                9.581365808049549,
                                41.094056716129593
                            ],
                            [
                                9.581159535284062,
                                41.093450846179863
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.541496509908209,
                                39.083620904712916
                            ],
                            [
                                9.541411335127886,
                                39.083065993676357
                            ],
                            [
                                9.540060473194742,
                                39.083689515948748
                            ],
                            [
                                9.540694579935073,
                                39.084022239160099
                            ],
                            [
                                9.541496509908209,
                                39.083620904712916
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.356726346277505,
                                39.225889684681725
                            ],
                            [
                                8.356165005217079,
                                39.226147896684786
                            ],
                            [
                                8.356231002880785,
                                39.227166482574262
                            ],
                            [
                                8.357156143916143,
                                39.22608128444412
                            ],
                            [
                                8.356726346277505,
                                39.225889684681725
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.337521666140317,
                                41.227915649861664
                            ],
                            [
                                9.337265250689288,
                                41.228517670603942
                            ],
                            [
                                9.337897041160511,
                                41.229273597937222
                            ],
                            [
                                9.338044651071042,
                                41.228106657060302
                            ],
                            [
                                9.337521666140317,
                                41.227915649861664
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.174164048385903,
                                40.938872605275471
                            ],
                            [
                                8.173653403222934,
                                40.938859938490133
                            ],
                            [
                                8.173440583568707,
                                40.939732200706658
                            ],
                            [
                                8.174366525019099,
                                40.939783875550411
                            ],
                            [
                                8.174164048385903,
                                40.938872605275471
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.765955429412159,
                                38.914063652676603
                            ],
                            [
                                8.765036014811379,
                                38.913926635059411
                            ],
                            [
                                8.764930641972233,
                                38.914400647268032
                            ],
                            [
                                8.765760998333763,
                                38.914876540530173
                            ],
                            [
                                8.765955429412159,
                                38.914063652676603
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.213242557796358,
                                40.971974809050138
                            ],
                            [
                                8.212210330957499,
                                40.971325933873182
                            ],
                            [
                                8.21184821149021,
                                40.971669143912592
                            ],
                            [
                                8.211836748674582,
                                40.972132981800975
                            ],
                            [
                                8.213242557796358,
                                40.971974809050138
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.487937523233814,
                                41.183451128443984
                            ],
                            [
                                9.487255465912895,
                                41.183928053016245
                            ],
                            [
                                9.488375090596533,
                                41.184571874327176
                            ],
                            [
                                9.488535593216898,
                                41.184509264802628
                            ],
                            [
                                9.487937523233814,
                                41.183451128443984
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.437447645778635,
                                39.104866111919939
                            ],
                            [
                                8.437533710571175,
                                39.105678645327956
                            ],
                            [
                                8.438393904655502,
                                39.105494687286502
                            ],
                            [
                                8.437881852518458,
                                39.104984223214764
                            ],
                            [
                                8.437447645778635,
                                39.104866111919939
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.658512663989637,
                                39.524732222199901
                            ],
                            [
                                9.659046363396074,
                                39.52501787100293
                            ],
                            [
                                9.659791263803623,
                                39.52427930225322
                            ],
                            [
                                9.659221636925109,
                                39.524097821949766
                            ],
                            [
                                9.658512663989637,
                                39.524732222199901
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.632816774059723,
                                40.919915193686961
                            ],
                            [
                                9.632304852891762,
                                40.919782878791914
                            ],
                            [
                                9.63180986976422,
                                40.920181952987811
                            ],
                            [
                                9.632646032819425,
                                40.920690836235678
                            ],
                            [
                                9.632816774059723,
                                40.919915193686961
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.865183960764448,
                                38.881450361892476
                            ],
                            [
                                8.864689010163007,
                                38.881787718794918
                            ],
                            [
                                8.864707853198162,
                                38.88249063364286
                            ],
                            [
                                8.865503035056053,
                                38.881905808032528
                            ],
                            [
                                8.865183960764448,
                                38.881450361892476
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.455516029424501,
                                41.228108349275701
                            ],
                            [
                                9.45461578647765,
                                41.22862309767298
                            ],
                            [
                                9.454864778092015,
                                41.229257161692892
                            ],
                            [
                                9.455268499046161,
                                41.228975199545523
                            ],
                            [
                                9.455516029424501,
                                41.228108349275701
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.519158200183266,
                                41.163745097659941
                            ],
                            [
                                9.519082626403673,
                                41.163420029555589
                            ],
                            [
                                9.517656608006781,
                                41.164161713352954
                            ],
                            [
                                9.518239772973256,
                                41.164235657714684
                            ],
                            [
                                9.519158200183266,
                                41.163745097659941
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.318432928897142,
                                41.2024160048162
                            ],
                            [
                                9.317395091405075,
                                41.202373830706748
                            ],
                            [
                                9.317314215480577,
                                41.202914523022173
                            ],
                            [
                                9.317541738253535,
                                41.203103060184112
                            ],
                            [
                                9.318432928897142,
                                41.2024160048162
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.337014974414565,
                                41.285902751852454
                            ],
                            [
                                9.336395881839241,
                                41.286125814019137
                            ],
                            [
                                9.336975605112011,
                                41.286809828988652
                            ],
                            [
                                9.337428648824565,
                                41.286372754919832
                            ],
                            [
                                9.337014974414565,
                                41.285902751852454
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.707738083278652,
                                40.874928413362412
                            ],
                            [
                                9.707251384172428,
                                40.875056388392942
                            ],
                            [
                                9.707974731746676,
                                40.875836794716228
                            ],
                            [
                                9.708116219817338,
                                40.875192961960458
                            ],
                            [
                                9.707738083278652,
                                40.874928413362412
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.239363293892668,
                                41.255789488486457
                            ],
                            [
                                9.238651120039057,
                                41.255663732413353
                            ],
                            [
                                9.239555779881551,
                                41.256608793249541
                            ],
                            [
                                9.239745974935309,
                                41.256392211416134
                            ],
                            [
                                9.239363293892668,
                                41.255789488486457
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.33559987307488,
                                41.294210282884997
                            ],
                            [
                                9.335132658371926,
                                41.294516779141048
                            ],
                            [
                                9.335806140627179,
                                41.295130716453706
                            ],
                            [
                                9.336156579835393,
                                41.294469881232722
                            ],
                            [
                                9.33559987307488,
                                41.294210282884997
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.587300933926775,
                                41.074267649475864
                            ],
                            [
                                9.586632853398978,
                                41.074603221833463
                            ],
                            [
                                9.587195835631375,
                                41.074997831276015
                            ],
                            [
                                9.587779167811233,
                                41.074669443991539
                            ],
                            [
                                9.587300933926775,
                                41.074267649475864
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.825409299394337,
                                38.881134084038017
                            ],
                            [
                                8.82466480149335,
                                38.880903176674963
                            ],
                            [
                                8.824474340563887,
                                38.880997510743839
                            ],
                            [
                                8.825252115358863,
                                38.881763523743949
                            ],
                            [
                                8.825409299394337,
                                38.881134084038017
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.355824507327176,
                                39.227276870275247
                            ],
                            [
                                8.35535967447731,
                                39.227431987729943
                            ],
                            [
                                8.355326777166498,
                                39.228495080528347
                            ],
                            [
                                8.355640559815988,
                                39.228388687159537
                            ],
                            [
                                8.355824507327176,
                                39.227276870275247
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.400475088118382,
                                41.287293276160007
                            ],
                            [
                                9.400987894685798,
                                41.286933435727654
                            ],
                            [
                                9.400836856438817,
                                41.286645715915341
                            ],
                            [
                                9.399749173202274,
                                41.286979404381768
                            ],
                            [
                                9.400475088118382,
                                41.287293276160007
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.508933692699125,
                                40.917555776556952
                            ],
                            [
                                9.508315846021482,
                                40.917513460512318
                            ],
                            [
                                9.508177553988586,
                                40.918063572513027
                            ],
                            [
                                9.508997490210181,
                                40.918132022160073
                            ],
                            [
                                9.508933692699125,
                                40.917555776556952
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.365195699850185,
                                41.285335454516115
                            ],
                            [
                                9.364435940953152,
                                41.285343492008515
                            ],
                            [
                                9.36436845377626,
                                41.285555386324468
                            ],
                            [
                                9.365150845669053,
                                41.285858042739449
                            ],
                            [
                                9.365195699850185,
                                41.285335454516115
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.707451532133529,
                                39.975951016468656
                            ],
                            [
                                9.706670938660521,
                                39.975631431238476
                            ],
                            [
                                9.706783542522524,
                                39.976473145723446
                            ],
                            [
                                9.707278296605311,
                                39.9761863242367
                            ],
                            [
                                9.707451532133529,
                                39.975951016468656
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.517702511068448,
                                41.217483248022894
                            ],
                            [
                                9.517906440595723,
                                41.217248128991173
                            ],
                            [
                                9.516673778299547,
                                41.216749231161799
                            ],
                            [
                                9.516761818383703,
                                41.217325333456685
                            ],
                            [
                                9.517702511068448,
                                41.217483248022894
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.213883326179163,
                                40.985325766378409
                            ],
                            [
                                8.2128967444956,
                                40.985319034093344
                            ],
                            [
                                8.21263081582299,
                                40.985501883265826
                            ],
                            [
                                8.214640323657321,
                                40.985646208483274
                            ],
                            [
                                8.213883326179163,
                                40.985325766378409
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.641586984528535,
                                40.920060407112622
                            ],
                            [
                                9.640990648095457,
                                40.920411665386062
                            ],
                            [
                                9.641299555516531,
                                40.920886256562738
                            ],
                            [
                                9.641739370280558,
                                40.920314040900323
                            ],
                            [
                                9.641586984528535,
                                40.920060407112622
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.668534342428959,
                                40.893495232818282
                            ],
                            [
                                9.667764194372396,
                                40.893494064531588
                            ],
                            [
                                9.667587382585671,
                                40.893766461328092
                            ],
                            [
                                9.668003459304471,
                                40.89411987742276
                            ],
                            [
                                9.668534342428959,
                                40.893495232818282
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.579516493621645,
                                41.091941282195933
                            ],
                            [
                                9.578801441417967,
                                41.092037207993606
                            ],
                            [
                                9.578568993033425,
                                41.092515796924225
                            ],
                            [
                                9.579358277348275,
                                41.092398105442157
                            ],
                            [
                                9.579516493621645,
                                41.091941282195933
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.362273276314832,
                                41.287289222888077
                            ],
                            [
                                9.361756353249653,
                                41.287483387755159
                            ],
                            [
                                9.361856032846369,
                                41.287962733737977
                            ],
                            [
                                9.362512596955966,
                                41.287914503674415
                            ],
                            [
                                9.362273276314832,
                                41.287289222888077
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.48779269418576,
                                40.092741509891233
                            ],
                            [
                                8.487315671859688,
                                40.0928024661048
                            ],
                            [
                                8.486821243770068,
                                40.09342362235391
                            ],
                            [
                                8.487657041699057,
                                40.093427885374275
                            ],
                            [
                                8.48779269418576,
                                40.092741509891233
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.211943838837508,
                                40.985479172738017
                            ],
                            [
                                8.211767846686483,
                                40.985284296118472
                            ],
                            [
                                8.211076281825186,
                                40.985459726412003
                            ],
                            [
                                8.211474308202218,
                                40.985975909285642
                            ],
                            [
                                8.211943838837508,
                                40.985479172738017
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.459644910694673,
                                41.173860443841932
                            ],
                            [
                                9.459056713878828,
                                41.173922466704141
                            ],
                            [
                                9.459049477400116,
                                41.174593580222329
                            ],
                            [
                                9.459569937672191,
                                41.17443386735323
                            ],
                            [
                                9.459644910694673,
                                41.173860443841932
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.119300932588313,
                                41.158043331591401
                            ],
                            [
                                9.119639774859847,
                                41.158398792577039
                            ],
                            [
                                9.120033071929464,
                                41.158384871541003
                            ],
                            [
                                9.119113674323653,
                                41.157476027035997
                            ],
                            [
                                9.119300932588313,
                                41.158043331591401
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.463092958549931,
                                39.081333043594874
                            ],
                            [
                                8.463144341767013,
                                39.081989961459271
                            ],
                            [
                                8.463773432634868,
                                39.082315001735779
                            ],
                            [
                                8.463905124827004,
                                39.082100468155829
                            ],
                            [
                                8.463092958549931,
                                39.081333043594874
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.278974143065769,
                                41.233212444778125
                            ],
                            [
                                9.279734116955089,
                                41.233043957092903
                            ],
                            [
                                9.2789504662301,
                                41.232554934122987
                            ],
                            [
                                9.278744656305106,
                                41.233086891612388
                            ],
                            [
                                9.278974143065769,
                                41.233212444778125
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.446666336072211,
                                41.207903094748161
                            ],
                            [
                                9.446036748512983,
                                41.207954514907286
                            ],
                            [
                                9.445959754908401,
                                41.208253196387844
                            ],
                            [
                                9.446983501988605,
                                41.208280754596842
                            ],
                            [
                                9.446666336072211,
                                41.207903094748161
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.642212296479839,
                                40.92101629984127
                            ],
                            [
                                9.641425727167602,
                                40.921038694238746
                            ],
                            [
                                9.641127044356686,
                                40.921315105444776
                            ],
                            [
                                9.642000365014495,
                                40.921512931059247
                            ],
                            [
                                9.642212296479839,
                                40.92101629984127
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.357648248531403,
                                41.245376127579569
                            ],
                            [
                                9.3575228274767,
                                41.244809028664434
                            ],
                            [
                                9.356930387776423,
                                41.245048446214732
                            ],
                            [
                                9.356917179223609,
                                41.245362632537066
                            ],
                            [
                                9.357648248531403,
                                41.245376127579569
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.658440699000574,
                                39.524793792079215
                            ],
                            [
                                9.658698931344242,
                                39.524418399748569
                            ],
                            [
                                9.658596333170857,
                                39.524180206922473
                            ],
                            [
                                9.658015781800975,
                                39.524381722295779
                            ],
                            [
                                9.658440699000574,
                                39.524793792079215
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.370001991818187,
                                41.312620094223043
                            ],
                            [
                                9.36919419686693,
                                41.312772440118806
                            ],
                            [
                                9.369290920509917,
                                41.313240527398868
                            ],
                            [
                                9.36988230910759,
                                41.312978532785756
                            ],
                            [
                                9.370001991818187,
                                41.312620094223043
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.363590665747958,
                                41.28366060071248
                            ],
                            [
                                9.364206851948371,
                                41.283606858704985
                            ],
                            [
                                9.364287746646674,
                                41.283390418141593
                            ],
                            [
                                9.363327961491898,
                                41.283124346470252
                            ],
                            [
                                9.363590665747958,
                                41.28366060071248
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.356898530211039,
                                41.245773669038115
                            ],
                            [
                                9.356642595637846,
                                41.246169677172716
                            ],
                            [
                                9.356795535853196,
                                41.246585811823635
                            ],
                            [
                                9.35733872286079,
                                41.246339792071559
                            ],
                            [
                                9.356898530211039,
                                41.245773669038115
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.70833341126294,
                                39.976297006389423
                            ],
                            [
                                9.707933595216131,
                                39.976137275566956
                            ],
                            [
                                9.707787405947682,
                                39.976723794691488
                            ],
                            [
                                9.708662224045577,
                                39.976385092869862
                            ],
                            [
                                9.70833341126294,
                                39.976297006389423
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.601434676266425,
                                41.078810204342503
                            ],
                            [
                                9.601404014462579,
                                41.079364354376217
                            ],
                            [
                                9.602079120027128,
                                41.079312410944404
                            ],
                            [
                                9.602020028472493,
                                41.079033472716063
                            ],
                            [
                                9.601434676266425,
                                41.078810204342503
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.674870676892587,
                                40.896429919059187
                            ],
                            [
                                9.674478474247371,
                                40.896678813849924
                            ],
                            [
                                9.675052274306953,
                                40.897068440624452
                            ],
                            [
                                9.675231729373543,
                                40.896620356599293
                            ],
                            [
                                9.674870676892587,
                                40.896429919059187
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.56630635026486,
                                40.920281277910149
                            ],
                            [
                                9.565739151787936,
                                40.920092637327492
                            ],
                            [
                                9.566561750645169,
                                40.920636974107573
                            ],
                            [
                                9.567050699518269,
                                40.92052759812784
                            ],
                            [
                                9.56630635026486,
                                40.920281277910149
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.536792588490538,
                                39.08490082435614
                            ],
                            [
                                9.537217828713906,
                                39.084468587806434
                            ],
                            [
                                9.53607575508885,
                                39.084807253395184
                            ],
                            [
                                9.536489698130499,
                                39.084886449043886
                            ],
                            [
                                9.536792588490538,
                                39.08490082435614
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.518957257939606,
                                41.218698152827244
                            ],
                            [
                                9.518312472574411,
                                41.218813653977385
                            ],
                            [
                                9.518422824015742,
                                41.219191483465387
                            ],
                            [
                                9.518982722827941,
                                41.219089875960115
                            ],
                            [
                                9.518957257939606,
                                41.218698152827244
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.627659929555573,
                                39.308486302927733
                            ],
                            [
                                9.628141092146381,
                                39.308141301581514
                            ],
                            [
                                9.627546932464275,
                                39.30784715331373
                            ],
                            [
                                9.627482272823025,
                                39.308399406454448
                            ],
                            [
                                9.627659929555573,
                                39.308486302927733
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.023551866636389,
                                38.984913316304493
                            ],
                            [
                                9.023470938335818,
                                38.984588925969561
                            ],
                            [
                                9.022696049656334,
                                38.984981070617572
                            ],
                            [
                                9.023159344792505,
                                38.985030541708589
                            ],
                            [
                                9.023551866636389,
                                38.984913316304493
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.710709352362997,
                                40.919001718731515
                            ],
                            [
                                8.71040381594891,
                                40.918941272051491
                            ],
                            [
                                8.70994752672102,
                                40.919408555296158
                            ],
                            [
                                8.710327174861538,
                                40.919495088146753
                            ],
                            [
                                8.710709352362997,
                                40.919001718731515
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.337171375922578,
                                40.499489992607394
                            ],
                            [
                                8.337009980042899,
                                40.499101686362756
                            ],
                            [
                                8.336777872723108,
                                40.499902141852594
                            ],
                            [
                                8.337171375922578,
                                40.499489992607394
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.724157715777636,
                                40.845843496063132
                            ],
                            [
                                9.724538018620006,
                                40.846316295566389
                            ],
                            [
                                9.724959389415842,
                                40.846338983978065
                            ],
                            [
                                9.724543823231169,
                                40.845896247348549
                            ],
                            [
                                9.724157715777636,
                                40.845843496063132
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.518975706603607,
                                41.219711443503833
                            ],
                            [
                                9.519248945197361,
                                41.219566087460862
                            ],
                            [
                                9.519257027480391,
                                41.219079631594418
                            ],
                            [
                                9.518556964550255,
                                41.219560197928864
                            ],
                            [
                                9.518975706603607,
                                41.219711443503833
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.364745130295473,
                                41.283233587197024
                            ],
                            [
                                9.364707304644813,
                                41.283678461830434
                            ],
                            [
                                9.36517301887255,
                                41.283676985483289
                            ],
                            [
                                9.364991764868847,
                                41.283294733387635
                            ],
                            [
                                9.364745130295473,
                                41.283233587197024
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.40343598592092,
                                41.276017696018052
                            ],
                            [
                                9.403221191716968,
                                41.276038715854618
                            ],
                            [
                                9.403046577201692,
                                41.276525742995219
                            ],
                            [
                                9.403642829691092,
                                41.276402050064235
                            ],
                            [
                                9.40343598592092,
                                41.276017696018052
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.338169972058871,
                                41.294644137729591
                            ],
                            [
                                9.337678107109417,
                                41.294800964057423
                            ],
                            [
                                9.338336277015257,
                                41.295046742632792
                            ],
                            [
                                9.338292956438671,
                                41.294752994470265
                            ],
                            [
                                9.338169972058871,
                                41.294644137729591
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.487183176650616,
                                40.09228608488516
                            ],
                            [
                                8.486595446217825,
                                40.092249695671399
                            ],
                            [
                                8.486384396464139,
                                40.09262603344942
                            ],
                            [
                                8.486753318134024,
                                40.092510545040192
                            ],
                            [
                                8.487183176650616,
                                40.09228608488516
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.635346707776129,
                                40.923210670636678
                            ],
                            [
                                9.634940479540136,
                                40.923266957384321
                            ],
                            [
                                9.635295052978282,
                                40.9237075322607
                            ],
                            [
                                9.635410903602031,
                                40.923558258637073
                            ],
                            [
                                9.635346707776129,
                                40.923210670636678
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.638267419371347,
                                40.92018692749587
                            ],
                            [
                                9.637912904096087,
                                40.920524444835657
                            ],
                            [
                                9.638153129013705,
                                40.920651482553616
                            ],
                            [
                                9.638439111782301,
                                40.920442710847681
                            ],
                            [
                                9.638267419371347,
                                40.92018692749587
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.399445031311064,
                                41.287042387924828
                            ],
                            [
                                9.399180187461498,
                                41.287185177576134
                            ],
                            [
                                9.399519128172098,
                                41.287442972614222
                            ],
                            [
                                9.399723547627636,
                                41.287183292158787
                            ],
                            [
                                9.399445031311064,
                                41.287042387924828
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.332608784015491,
                                41.294948586025058
                            ],
                            [
                                9.332219767594811,
                                41.295075816869264
                            ],
                            [
                                9.332682384325333,
                                41.295330073690877
                            ],
                            [
                                9.332826204068208,
                                41.295133740972467
                            ],
                            [
                                9.332608784015491,
                                41.294948586025058
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.518622886177575,
                                41.216767492665404
                            ],
                            [
                                9.518734998174466,
                                41.216424692372726
                            ],
                            [
                                9.51821133498267,
                                41.216580182257502
                            ],
                            [
                                9.518428118348712,
                                41.216840431856589
                            ],
                            [
                                9.518622886177575,
                                41.216767492665404
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.119269972387663,
                                41.158223521847347
                            ],
                            [
                                9.119350260941635,
                                41.158133359588575
                            ],
                            [
                                9.118876326192408,
                                41.158043770579347
                            ],
                            [
                                9.118841041711109,
                                41.158305036368802
                            ],
                            [
                                9.119269972387663,
                                41.158223521847347
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.485940975191232,
                                40.094262671522017
                            ],
                            [
                                8.485582739511557,
                                40.094320769113317
                            ],
                            [
                                8.485620244855651,
                                40.094597978139987
                            ],
                            [
                                8.485821006832039,
                                40.094420931671593
                            ],
                            [
                                8.485940975191232,
                                40.094262671522017
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.486557332094494,
                                40.094589747713357
                            ],
                            [
                                8.486586402839841,
                                40.094428831559007
                            ],
                            [
                                8.48655960028,
                                40.094287939137246
                            ],
                            [
                                8.486253952548207,
                                40.094762961788661
                            ],
                            [
                                8.486557332094494,
                                40.094589747713357
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.524246414525617,
                                40.916534557879146
                            ],
                            [
                                9.524125021795466,
                                40.916482186298971
                            ],
                            [
                                9.523877451010208,
                                40.916805355710025
                            ],
                            [
                                9.524072097623206,
                                40.916829243919793
                            ],
                            [
                                9.524246414525617,
                                40.916534557879146
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.123071700315428,
                                39.204179575302163
                            ],
                            [
                                9.124295466728542,
                                39.204847760968939
                            ],
                            [
                                9.123088907736781,
                                39.204128768693906
                            ],
                            [
                                9.123071700315428,
                                39.204179575302163
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.372501507056466,
                                40.847582004091386
                            ],
                            [
                                8.372482687371471,
                                40.847926469914384
                            ],
                            [
                                8.372691761258608,
                                40.847927607073487
                            ],
                            [
                                8.372553270848385,
                                40.847832266515454
                            ],
                            [
                                8.372501507056466,
                                40.847582004091386
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.30915825105191,
                                40.560609352846541
                            ],
                            [
                                8.309350308259615,
                                40.561388631449979
                            ],
                            [
                                8.309419839499121,
                                40.561375534002607
                            ],
                            [
                                8.30915825105191,
                                40.560609352846541
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.26342007718584,
                                41.068577330924199
                            ],
                            [
                                8.263579409820666,
                                41.068498403768949
                            ],
                            [
                                8.263486071428769,
                                41.068396467780673
                            ],
                            [
                                8.263341029202092,
                                41.068461411247164
                            ],
                            [
                                8.26342007718584,
                                41.068577330924199
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.526686632763836,
                                41.02356168620922
                            ],
                            [
                                9.526386821948574,
                                41.023347425189925
                            ],
                            [
                                9.526902044370493,
                                41.023726224919663
                            ],
                            [
                                9.526686632763836,
                                41.02356168620922
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.372501507056466,
                                40.847582004091386
                            ],
                            [
                                8.372680320797325,
                                40.84756833813848
                            ],
                            [
                                8.372681372070042,
                                40.847456865903489
                            ],
                            [
                                8.372504238442351,
                                40.84746813938029
                            ],
                            [
                                8.372501507056466,
                                40.847582004091386
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.403674189147102,
                                41.211197663921851
                            ],
                            [
                                9.404402315703082,
                                41.211277868393708
                            ],
                            [
                                9.404409451844842,
                                41.211226048488463
                            ],
                            [
                                9.403674189147102,
                                41.211197663921851
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.403451820113567,
                                40.839892074110033
                            ],
                            [
                                8.403766269588571,
                                40.840297757086127
                            ],
                            [
                                8.403504952905694,
                                40.839836609763978
                            ],
                            [
                                8.403451820113567,
                                40.839892074110033
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.574740811411736,
                                40.910809060274474
                            ],
                            [
                                9.574971083711375,
                                40.910833248040888
                            ],
                            [
                                9.575139366168392,
                                40.910812140347034
                            ],
                            [
                                9.574768543382891,
                                40.910754872652277
                            ],
                            [
                                9.574740811411736,
                                40.910809060274474
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.574891849617341,
                                40.911281802692898
                            ],
                            [
                                9.574976329850799,
                                40.911096149706857
                            ],
                            [
                                9.574971083711375,
                                40.910833248040888
                            ],
                            [
                                9.574936550185162,
                                40.910958972477168
                            ],
                            [
                                9.574891849617341,
                                40.911281802692898
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.287172755923228,
                                40.592432789125539
                            ],
                            [
                                8.287164907232986,
                                40.592615447703686
                            ],
                            [
                                8.287331754666139,
                                40.592483599128954
                            ],
                            [
                                8.287172755923228,
                                40.592432789125539
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.287120781822152,
                                40.592249760435593
                            ],
                            [
                                8.287172755923228,
                                40.592432789125539
                            ],
                            [
                                8.287202755168963,
                                40.59225082938066
                            ],
                            [
                                8.287120781822152,
                                40.592249760435593
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.724038479482795,
                                40.845787379668145
                            ],
                            [
                                9.724157715777636,
                                40.845843496063132
                            ],
                            [
                                9.724198986454116,
                                40.845752590994472
                            ],
                            [
                                9.724038479482795,
                                40.845787379668145
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.55962488686664,
                                41.020962461245524
                            ],
                            [
                                9.559804450059273,
                                41.020966938239432
                            ],
                            [
                                9.559784903365816,
                                41.020857636510478
                            ],
                            [
                                9.55975324208849,
                                41.020933124741795
                            ],
                            [
                                9.55962488686664,
                                41.020962461245524
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.355701984579152,
                                40.847983726552002
                            ],
                            [
                                8.355764665257581,
                                40.847942413179183
                            ],
                            [
                                8.35570571906179,
                                40.847904361640396
                            ],
                            [
                                8.355654938871321,
                                40.847941800318623
                            ],
                            [
                                8.355701984579152,
                                40.847983726552002
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.520690072680882,
                                40.931419872719061
                            ],
                            [
                                9.52080909477319,
                                40.931356277698285
                            ],
                            [
                                9.520759808409716,
                                40.93131934141627
                            ],
                            [
                                9.520690072680882,
                                40.931419872719061
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                8.203498355700706,
                                40.581200956951129
                            ],
                            [
                                8.203561822289023,
                                40.581142275114573
                            ],
                            [
                                8.203439683092622,
                                40.581166769809144
                            ],
                            [
                                8.203498355700706,
                                40.581200956951129
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                9.52642217585694,
                                40.932763094210728
                            ],
                            [
                                9.526472284766754,
                                40.932809595524716
                            ],
                            [
                                9.526521598128236,
                                40.932755884107792
                            ],
                            [
                                9.52642217585694,
                                40.932763094210728
                            ]
                        ]
                    ]
                ]
            }
        }
    ]
}